import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/zod/v4/core/core.cjs
var require_core = __commonJS({
  "../../node_modules/zod/v4/core/core.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.globalConfig = exports.$ZodAsyncError = exports.$brand = exports.NEVER = void 0;
    exports.$constructor = $constructor;
    exports.config = config;
    exports.NEVER = Object.freeze({
      status: "aborted"
    });
    function $constructor(name, initializer, params) {
      function init(inst, def) {
        var _a;
        Object.defineProperty(inst, "_zod", {
          value: inst._zod ?? {},
          enumerable: false
        });
        (_a = inst._zod).traits ?? (_a.traits = /* @__PURE__ */ new Set());
        inst._zod.traits.add(name);
        initializer(inst, def);
        for (const k in _.prototype) {
          if (!(k in inst))
            Object.defineProperty(inst, k, { value: _.prototype[k].bind(inst) });
        }
        inst._zod.constr = _;
        inst._zod.def = def;
      }
      const Parent = params?.Parent ?? Object;
      class Definition extends Parent {
      }
      Object.defineProperty(Definition, "name", { value: name });
      function _(def) {
        var _a;
        const inst = params?.Parent ? new Definition() : this;
        init(inst, def);
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        for (const fn of inst._zod.deferred) {
          fn();
        }
        return inst;
      }
      Object.defineProperty(_, "init", { value: init });
      Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst) => {
          if (params?.Parent && inst instanceof params.Parent)
            return true;
          return inst?._zod?.traits?.has(name);
        }
      });
      Object.defineProperty(_, "name", { value: name });
      return _;
    }
    exports.$brand = Symbol("zod_brand");
    var $ZodAsyncError = class extends Error {
      constructor() {
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
      }
    };
    exports.$ZodAsyncError = $ZodAsyncError;
    exports.globalConfig = {};
    function config(newConfig) {
      if (newConfig)
        Object.assign(exports.globalConfig, newConfig);
      return exports.globalConfig;
    }
  }
});

// ../../node_modules/zod/v4/core/util.cjs
var require_util = __commonJS({
  "../../node_modules/zod/v4/core/util.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Class = exports.BIGINT_FORMAT_RANGES = exports.NUMBER_FORMAT_RANGES = exports.primitiveTypes = exports.propertyKeyTypes = exports.getParsedType = exports.allowsEval = exports.captureStackTrace = void 0;
    exports.assertEqual = assertEqual;
    exports.assertNotEqual = assertNotEqual;
    exports.assertIs = assertIs;
    exports.assertNever = assertNever;
    exports.assert = assert;
    exports.getEnumValues = getEnumValues;
    exports.joinValues = joinValues;
    exports.jsonStringifyReplacer = jsonStringifyReplacer;
    exports.cached = cached;
    exports.nullish = nullish;
    exports.cleanRegex = cleanRegex;
    exports.floatSafeRemainder = floatSafeRemainder;
    exports.defineLazy = defineLazy;
    exports.assignProp = assignProp;
    exports.getElementAtPath = getElementAtPath;
    exports.promiseAllObject = promiseAllObject;
    exports.randomString = randomString;
    exports.esc = esc;
    exports.isObject = isObject;
    exports.isPlainObject = isPlainObject;
    exports.numKeys = numKeys;
    exports.escapeRegex = escapeRegex;
    exports.clone = clone2;
    exports.normalizeParams = normalizeParams;
    exports.createTransparentProxy = createTransparentProxy;
    exports.stringifyPrimitive = stringifyPrimitive;
    exports.optionalKeys = optionalKeys;
    exports.pick = pick2;
    exports.omit = omit;
    exports.extend = extend;
    exports.merge = merge;
    exports.partial = partial;
    exports.required = required;
    exports.aborted = aborted;
    exports.prefixIssues = prefixIssues;
    exports.unwrapMessage = unwrapMessage;
    exports.finalizeIssue = finalizeIssue;
    exports.getSizableOrigin = getSizableOrigin;
    exports.getLengthableOrigin = getLengthableOrigin;
    exports.issue = issue;
    exports.cleanEnum = cleanEnum;
    function assertEqual(val) {
      return val;
    }
    function assertNotEqual(val) {
      return val;
    }
    function assertIs(_arg) {
    }
    function assertNever(_x) {
      throw new Error();
    }
    function assert(_) {
    }
    function getEnumValues(entries) {
      const numericValues = Object.values(entries).filter((v) => typeof v === "number");
      const values = Object.entries(entries).filter(([k, _]) => numericValues.indexOf(+k) === -1).map(([_, v]) => v);
      return values;
    }
    function joinValues(array, separator = "|") {
      return array.map((val) => stringifyPrimitive(val)).join(separator);
    }
    function jsonStringifyReplacer(_, value) {
      if (typeof value === "bigint")
        return value.toString();
      return value;
    }
    function cached(getter) {
      const set = false;
      return {
        get value() {
          if (!set) {
            const value = getter();
            Object.defineProperty(this, "value", { value });
            return value;
          }
          throw new Error("cached value already set");
        }
      };
    }
    function nullish(input) {
      return input === null || input === void 0;
    }
    function cleanRegex(source) {
      const start = source.startsWith("^") ? 1 : 0;
      const end = source.endsWith("$") ? source.length - 1 : source.length;
      return source.slice(start, end);
    }
    function floatSafeRemainder(val, step) {
      const valDecCount = (val.toString().split(".")[1] || "").length;
      const stepDecCount = (step.toString().split(".")[1] || "").length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
      const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
      return valInt % stepInt / 10 ** decCount;
    }
    function defineLazy(object, key, getter) {
      const set = false;
      Object.defineProperty(object, key, {
        get() {
          if (!set) {
            const value = getter();
            object[key] = value;
            return value;
          }
          throw new Error("cached value already set");
        },
        set(v) {
          Object.defineProperty(object, key, {
            value: v
            // configurable: true,
          });
        },
        configurable: true
      });
    }
    function assignProp(target, prop, value) {
      Object.defineProperty(target, prop, {
        value,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
    function getElementAtPath(obj, path) {
      if (!path)
        return obj;
      return path.reduce((acc, key) => acc?.[key], obj);
    }
    function promiseAllObject(promisesObj) {
      const keys = Object.keys(promisesObj);
      const promises = keys.map((key) => promisesObj[key]);
      return Promise.all(promises).then((results) => {
        const resolvedObj = {};
        for (let i = 0; i < keys.length; i++) {
          resolvedObj[keys[i]] = results[i];
        }
        return resolvedObj;
      });
    }
    function randomString(length = 10) {
      const chars = "abcdefghijklmnopqrstuvwxyz";
      let str = "";
      for (let i = 0; i < length; i++) {
        str += chars[Math.floor(Math.random() * chars.length)];
      }
      return str;
    }
    function esc(str) {
      return JSON.stringify(str);
    }
    exports.captureStackTrace = Error.captureStackTrace ? Error.captureStackTrace : (..._args) => {
    };
    function isObject(data) {
      return typeof data === "object" && data !== null && !Array.isArray(data);
    }
    exports.allowsEval = cached(() => {
      if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) {
        return false;
      }
      try {
        const F = Function;
        new F("");
        return true;
      } catch (_) {
        return false;
      }
    });
    function isPlainObject(o) {
      if (isObject(o) === false)
        return false;
      const ctor = o.constructor;
      if (ctor === void 0)
        return true;
      const prot = ctor.prototype;
      if (isObject(prot) === false)
        return false;
      if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) {
        return false;
      }
      return true;
    }
    function numKeys(data) {
      let keyCount = 0;
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          keyCount++;
        }
      }
      return keyCount;
    }
    var getParsedType = (data) => {
      const t = typeof data;
      switch (t) {
        case "undefined":
          return "undefined";
        case "string":
          return "string";
        case "number":
          return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
          return "boolean";
        case "function":
          return "function";
        case "bigint":
          return "bigint";
        case "symbol":
          return "symbol";
        case "object":
          if (Array.isArray(data)) {
            return "array";
          }
          if (data === null) {
            return "null";
          }
          if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
            return "promise";
          }
          if (typeof Map !== "undefined" && data instanceof Map) {
            return "map";
          }
          if (typeof Set !== "undefined" && data instanceof Set) {
            return "set";
          }
          if (typeof Date !== "undefined" && data instanceof Date) {
            return "date";
          }
          if (typeof File !== "undefined" && data instanceof File) {
            return "file";
          }
          return "object";
        default:
          throw new Error(`Unknown data type: ${t}`);
      }
    };
    exports.getParsedType = getParsedType;
    exports.propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
    exports.primitiveTypes = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
    function escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function clone2(inst, def, params) {
      const cl = new inst._zod.constr(def ?? inst._zod.def);
      if (!def || params?.parent)
        cl._zod.parent = inst;
      return cl;
    }
    function normalizeParams(_params) {
      const params = _params;
      if (!params)
        return {};
      if (typeof params === "string")
        return { error: () => params };
      if (params?.message !== void 0) {
        if (params?.error !== void 0)
          throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
      }
      delete params.message;
      if (typeof params.error === "string")
        return { ...params, error: () => params.error };
      return params;
    }
    function createTransparentProxy(getter) {
      let target;
      return new Proxy({}, {
        get(_, prop, receiver) {
          target ?? (target = getter());
          return Reflect.get(target, prop, receiver);
        },
        set(_, prop, value, receiver) {
          target ?? (target = getter());
          return Reflect.set(target, prop, value, receiver);
        },
        has(_, prop) {
          target ?? (target = getter());
          return Reflect.has(target, prop);
        },
        deleteProperty(_, prop) {
          target ?? (target = getter());
          return Reflect.deleteProperty(target, prop);
        },
        ownKeys(_) {
          target ?? (target = getter());
          return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor(_, prop) {
          target ?? (target = getter());
          return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty(_, prop, descriptor) {
          target ?? (target = getter());
          return Reflect.defineProperty(target, prop, descriptor);
        }
      });
    }
    function stringifyPrimitive(value) {
      if (typeof value === "bigint")
        return value.toString() + "n";
      if (typeof value === "string")
        return `"${value}"`;
      return `${value}`;
    }
    function optionalKeys(shape) {
      return Object.keys(shape).filter((k) => {
        return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
      });
    }
    exports.NUMBER_FORMAT_RANGES = {
      safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
      int32: [-2147483648, 2147483647],
      uint32: [0, 4294967295],
      float32: [-34028234663852886e22, 34028234663852886e22],
      float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
    };
    exports.BIGINT_FORMAT_RANGES = {
      int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
      uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
    };
    function pick2(schema, mask) {
      const newShape = {};
      const currDef = schema._zod.def;
      for (const key in mask) {
        if (!(key in currDef.shape)) {
          throw new Error(`Unrecognized key: "${key}"`);
        }
        if (!mask[key])
          continue;
        newShape[key] = currDef.shape[key];
      }
      return clone2(schema, {
        ...schema._zod.def,
        shape: newShape,
        checks: []
      });
    }
    function omit(schema, mask) {
      const newShape = { ...schema._zod.def.shape };
      const currDef = schema._zod.def;
      for (const key in mask) {
        if (!(key in currDef.shape)) {
          throw new Error(`Unrecognized key: "${key}"`);
        }
        if (!mask[key])
          continue;
        delete newShape[key];
      }
      return clone2(schema, {
        ...schema._zod.def,
        shape: newShape,
        checks: []
      });
    }
    function extend(schema, shape) {
      if (!isPlainObject(shape)) {
        throw new Error("Invalid input to extend: expected a plain object");
      }
      const def = {
        ...schema._zod.def,
        get shape() {
          const _shape = { ...schema._zod.def.shape, ...shape };
          assignProp(this, "shape", _shape);
          return _shape;
        },
        checks: []
        // delete existing checks
      };
      return clone2(schema, def);
    }
    function merge(a, b) {
      return clone2(a, {
        ...a._zod.def,
        get shape() {
          const _shape = { ...a._zod.def.shape, ...b._zod.def.shape };
          assignProp(this, "shape", _shape);
          return _shape;
        },
        catchall: b._zod.def.catchall,
        checks: []
        // delete existing checks
      });
    }
    function partial(Class2, schema, mask) {
      const oldShape = schema._zod.def.shape;
      const shape = { ...oldShape };
      if (mask) {
        for (const key in mask) {
          if (!(key in oldShape)) {
            throw new Error(`Unrecognized key: "${key}"`);
          }
          if (!mask[key])
            continue;
          shape[key] = Class2 ? new Class2({
            type: "optional",
            innerType: oldShape[key]
          }) : oldShape[key];
        }
      } else {
        for (const key in oldShape) {
          shape[key] = Class2 ? new Class2({
            type: "optional",
            innerType: oldShape[key]
          }) : oldShape[key];
        }
      }
      return clone2(schema, {
        ...schema._zod.def,
        shape,
        checks: []
      });
    }
    function required(Class2, schema, mask) {
      const oldShape = schema._zod.def.shape;
      const shape = { ...oldShape };
      if (mask) {
        for (const key in mask) {
          if (!(key in shape)) {
            throw new Error(`Unrecognized key: "${key}"`);
          }
          if (!mask[key])
            continue;
          shape[key] = new Class2({
            type: "nonoptional",
            innerType: oldShape[key]
          });
        }
      } else {
        for (const key in oldShape) {
          shape[key] = new Class2({
            type: "nonoptional",
            innerType: oldShape[key]
          });
        }
      }
      return clone2(schema, {
        ...schema._zod.def,
        shape,
        // optional: [],
        checks: []
      });
    }
    function aborted(x, startIndex = 0) {
      for (let i = startIndex; i < x.issues.length; i++) {
        if (x.issues[i]?.continue !== true)
          return true;
      }
      return false;
    }
    function prefixIssues(path, issues) {
      return issues.map((iss) => {
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
      });
    }
    function unwrapMessage(message) {
      return typeof message === "string" ? message : message?.message;
    }
    function finalizeIssue(iss, ctx, config) {
      const full = { ...iss, path: iss.path ?? [] };
      if (!iss.message) {
        const message = unwrapMessage(iss.inst?._zod.def?.error?.(iss)) ?? unwrapMessage(ctx?.error?.(iss)) ?? unwrapMessage(config.customError?.(iss)) ?? unwrapMessage(config.localeError?.(iss)) ?? "Invalid input";
        full.message = message;
      }
      delete full.inst;
      delete full.continue;
      if (!ctx?.reportInput) {
        delete full.input;
      }
      return full;
    }
    function getSizableOrigin(input) {
      if (input instanceof Set)
        return "set";
      if (input instanceof Map)
        return "map";
      if (input instanceof File)
        return "file";
      return "unknown";
    }
    function getLengthableOrigin(input) {
      if (Array.isArray(input))
        return "array";
      if (typeof input === "string")
        return "string";
      return "unknown";
    }
    function issue(...args) {
      const [iss, input, inst] = args;
      if (typeof iss === "string") {
        return {
          message: iss,
          code: "custom",
          input,
          inst
        };
      }
      return { ...iss };
    }
    function cleanEnum(obj) {
      return Object.entries(obj).filter(([k, _]) => {
        return Number.isNaN(Number.parseInt(k, 10));
      }).map((el) => el[1]);
    }
    var Class = class {
      constructor(..._args) {
      }
    };
    exports.Class = Class;
  }
});

// ../../node_modules/zod/v4/core/errors.cjs
var require_errors = __commonJS({
  "../../node_modules/zod/v4/core/errors.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.$ZodRealError = exports.$ZodError = void 0;
    exports.flattenError = flattenError;
    exports.formatError = formatError;
    exports.treeifyError = treeifyError;
    exports.toDotPath = toDotPath;
    exports.prettifyError = prettifyError;
    var core_js_1 = require_core();
    var util = __importStar(require_util());
    var initializer = (inst, def) => {
      inst.name = "$ZodError";
      Object.defineProperty(inst, "_zod", {
        value: inst._zod,
        enumerable: false
      });
      Object.defineProperty(inst, "issues", {
        value: def,
        enumerable: false
      });
      Object.defineProperty(inst, "message", {
        get() {
          return JSON.stringify(def, util.jsonStringifyReplacer, 2);
        },
        enumerable: true
        // configurable: false,
      });
      Object.defineProperty(inst, "toString", {
        value: () => inst.message,
        enumerable: false
      });
    };
    exports.$ZodError = (0, core_js_1.$constructor)("$ZodError", initializer);
    exports.$ZodRealError = (0, core_js_1.$constructor)("$ZodError", initializer, { Parent: Error });
    function flattenError(error, mapper = (issue) => issue.message) {
      const fieldErrors = {};
      const formErrors = [];
      for (const sub of error.issues) {
        if (sub.path.length > 0) {
          fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
          fieldErrors[sub.path[0]].push(mapper(sub));
        } else {
          formErrors.push(mapper(sub));
        }
      }
      return { formErrors, fieldErrors };
    }
    function formatError(error, _mapper) {
      const mapper = _mapper || function(issue) {
        return issue.message;
      };
      const fieldErrors = { _errors: [] };
      const processError = (error2) => {
        for (const issue of error2.issues) {
          if (issue.code === "invalid_union" && issue.errors.length) {
            issue.errors.map((issues) => processError({ issues }));
          } else if (issue.code === "invalid_key") {
            processError({ issues: issue.issues });
          } else if (issue.code === "invalid_element") {
            processError({ issues: issue.issues });
          } else if (issue.path.length === 0) {
            fieldErrors._errors.push(mapper(issue));
          } else {
            let curr = fieldErrors;
            let i = 0;
            while (i < issue.path.length) {
              const el = issue.path[i];
              const terminal = i === issue.path.length - 1;
              if (!terminal) {
                curr[el] = curr[el] || { _errors: [] };
              } else {
                curr[el] = curr[el] || { _errors: [] };
                curr[el]._errors.push(mapper(issue));
              }
              curr = curr[el];
              i++;
            }
          }
        }
      };
      processError(error);
      return fieldErrors;
    }
    function treeifyError(error, _mapper) {
      const mapper = _mapper || function(issue) {
        return issue.message;
      };
      const result = { errors: [] };
      const processError = (error2, path = []) => {
        var _a, _b;
        for (const issue of error2.issues) {
          if (issue.code === "invalid_union" && issue.errors.length) {
            issue.errors.map((issues) => processError({ issues }, issue.path));
          } else if (issue.code === "invalid_key") {
            processError({ issues: issue.issues }, issue.path);
          } else if (issue.code === "invalid_element") {
            processError({ issues: issue.issues }, issue.path);
          } else {
            const fullpath = [...path, ...issue.path];
            if (fullpath.length === 0) {
              result.errors.push(mapper(issue));
              continue;
            }
            let curr = result;
            let i = 0;
            while (i < fullpath.length) {
              const el = fullpath[i];
              const terminal = i === fullpath.length - 1;
              if (typeof el === "string") {
                curr.properties ?? (curr.properties = {});
                (_a = curr.properties)[el] ?? (_a[el] = { errors: [] });
                curr = curr.properties[el];
              } else {
                curr.items ?? (curr.items = []);
                (_b = curr.items)[el] ?? (_b[el] = { errors: [] });
                curr = curr.items[el];
              }
              if (terminal) {
                curr.errors.push(mapper(issue));
              }
              i++;
            }
          }
        }
      };
      processError(error);
      return result;
    }
    function toDotPath(path) {
      const segs = [];
      for (const seg of path) {
        if (typeof seg === "number")
          segs.push(`[${seg}]`);
        else if (typeof seg === "symbol")
          segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg))
          segs.push(`[${JSON.stringify(seg)}]`);
        else {
          if (segs.length)
            segs.push(".");
          segs.push(seg);
        }
      }
      return segs.join("");
    }
    function prettifyError(error) {
      const lines = [];
      const issues = [...error.issues].sort((a, b) => a.path.length - b.path.length);
      for (const issue of issues) {
        lines.push(`\u2716 ${issue.message}`);
        if (issue.path?.length)
          lines.push(`  \u2192 at ${toDotPath(issue.path)}`);
      }
      return lines.join("\n");
    }
  }
});

// ../../node_modules/zod/v4/core/parse.cjs
var require_parse = __commonJS({
  "../../node_modules/zod/v4/core/parse.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.safeParseAsync = exports._safeParseAsync = exports.safeParse = exports._safeParse = exports.parseAsync = exports._parseAsync = exports.parse = exports._parse = void 0;
    var core = __importStar(require_core());
    var errors = __importStar(require_errors());
    var util = __importStar(require_util());
    var _parse = (_Err) => (schema, value, _ctx, _params) => {
      const ctx = _ctx ? Object.assign(_ctx, { async: false }) : { async: false };
      const result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise) {
        throw new core.$ZodAsyncError();
      }
      if (result.issues.length) {
        const e = new (_params?.Err ?? _Err)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())));
        util.captureStackTrace(e, _params?.callee);
        throw e;
      }
      return result.value;
    };
    exports._parse = _parse;
    exports.parse = (0, exports._parse)(errors.$ZodRealError);
    var _parseAsync = (_Err) => async (schema, value, _ctx, params) => {
      const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
      let result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise)
        result = await result;
      if (result.issues.length) {
        const e = new (params?.Err ?? _Err)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())));
        util.captureStackTrace(e, params?.callee);
        throw e;
      }
      return result.value;
    };
    exports._parseAsync = _parseAsync;
    exports.parseAsync = (0, exports._parseAsync)(errors.$ZodRealError);
    var _safeParse = (_Err) => (schema, value, _ctx) => {
      const ctx = _ctx ? { ..._ctx, async: false } : { async: false };
      const result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise) {
        throw new core.$ZodAsyncError();
      }
      return result.issues.length ? {
        success: false,
        error: new (_Err ?? errors.$ZodError)(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
      } : { success: true, data: result.value };
    };
    exports._safeParse = _safeParse;
    exports.safeParse = (0, exports._safeParse)(errors.$ZodRealError);
    var _safeParseAsync = (_Err) => async (schema, value, _ctx) => {
      const ctx = _ctx ? Object.assign(_ctx, { async: true }) : { async: true };
      let result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise)
        result = await result;
      return result.issues.length ? {
        success: false,
        error: new _Err(result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
      } : { success: true, data: result.value };
    };
    exports._safeParseAsync = _safeParseAsync;
    exports.safeParseAsync = (0, exports._safeParseAsync)(errors.$ZodRealError);
  }
});

// ../../node_modules/zod/v4/core/regexes.cjs
var require_regexes = __commonJS({
  "../../node_modules/zod/v4/core/regexes.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uppercase = exports.lowercase = exports.undefined = exports.null = exports.boolean = exports.number = exports.integer = exports.bigint = exports.string = exports.date = exports.e164 = exports.domain = exports.hostname = exports.base64url = exports.base64 = exports.cidrv6 = exports.cidrv4 = exports.ipv6 = exports.ipv4 = exports._emoji = exports.browserEmail = exports.unicodeEmail = exports.rfc5322Email = exports.html5Email = exports.email = exports.uuid7 = exports.uuid6 = exports.uuid4 = exports.uuid = exports.guid = exports.extendedDuration = exports.duration = exports.nanoid = exports.ksuid = exports.xid = exports.ulid = exports.cuid2 = exports.cuid = void 0;
    exports.emoji = emoji;
    exports.time = time;
    exports.datetime = datetime;
    exports.cuid = /^[cC][^\s-]{8,}$/;
    exports.cuid2 = /^[0-9a-z]+$/;
    exports.ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
    exports.xid = /^[0-9a-vA-V]{20}$/;
    exports.ksuid = /^[A-Za-z0-9]{27}$/;
    exports.nanoid = /^[a-zA-Z0-9_-]{21}$/;
    exports.duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
    exports.extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
    exports.guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
    var uuid = (version) => {
      if (!version)
        return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/;
      return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
    };
    exports.uuid = uuid;
    exports.uuid4 = (0, exports.uuid)(4);
    exports.uuid6 = (0, exports.uuid)(6);
    exports.uuid7 = (0, exports.uuid)(7);
    exports.email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
    exports.html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    exports.rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    exports.unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
    exports.browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    exports._emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
    function emoji() {
      return new RegExp(exports._emoji, "u");
    }
    exports.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
    exports.ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/;
    exports.cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
    exports.cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
    exports.base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
    exports.base64url = /^[A-Za-z0-9_-]*$/;
    exports.hostname = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/;
    exports.domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    exports.e164 = /^\+(?:[0-9]){6,14}[0-9]$/;
    var dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
    exports.date = new RegExp(`^${dateSource}$`);
    function timeSource(args) {
      const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
      const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
      return regex;
    }
    function time(args) {
      return new RegExp(`^${timeSource(args)}$`);
    }
    function datetime(args) {
      const time2 = timeSource({ precision: args.precision });
      const opts = ["Z"];
      if (args.local)
        opts.push("");
      if (args.offset)
        opts.push(`([+-]\\d{2}:\\d{2})`);
      const timeRegex = `${time2}(?:${opts.join("|")})`;
      return new RegExp(`^${dateSource}T(?:${timeRegex})$`);
    }
    var string = (params) => {
      const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
      return new RegExp(`^${regex}$`);
    };
    exports.string = string;
    exports.bigint = /^\d+n?$/;
    exports.integer = /^\d+$/;
    exports.number = /^-?\d+(?:\.\d+)?/i;
    exports.boolean = /true|false/i;
    var _null = /null/i;
    exports.null = _null;
    var _undefined = /undefined/i;
    exports.undefined = _undefined;
    exports.lowercase = /^[^A-Z]*$/;
    exports.uppercase = /^[^a-z]*$/;
  }
});

// ../../node_modules/zod/v4/core/checks.cjs
var require_checks = __commonJS({
  "../../node_modules/zod/v4/core/checks.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.$ZodCheckOverwrite = exports.$ZodCheckMimeType = exports.$ZodCheckProperty = exports.$ZodCheckEndsWith = exports.$ZodCheckStartsWith = exports.$ZodCheckIncludes = exports.$ZodCheckUpperCase = exports.$ZodCheckLowerCase = exports.$ZodCheckRegex = exports.$ZodCheckStringFormat = exports.$ZodCheckLengthEquals = exports.$ZodCheckMinLength = exports.$ZodCheckMaxLength = exports.$ZodCheckSizeEquals = exports.$ZodCheckMinSize = exports.$ZodCheckMaxSize = exports.$ZodCheckBigIntFormat = exports.$ZodCheckNumberFormat = exports.$ZodCheckMultipleOf = exports.$ZodCheckGreaterThan = exports.$ZodCheckLessThan = exports.$ZodCheck = void 0;
    var core = __importStar(require_core());
    var regexes = __importStar(require_regexes());
    var util = __importStar(require_util());
    exports.$ZodCheck = core.$constructor("$ZodCheck", (inst, def) => {
      var _a;
      inst._zod ?? (inst._zod = {});
      inst._zod.def = def;
      (_a = inst._zod).onattach ?? (_a.onattach = []);
    });
    var numericOriginMap = {
      number: "number",
      bigint: "bigint",
      object: "date"
    };
    exports.$ZodCheckLessThan = core.$constructor("$ZodCheckLessThan", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const origin = numericOriginMap[typeof def.value];
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
          if (def.inclusive)
            bag.maximum = def.value;
          else
            bag.exclusiveMaximum = def.value;
        }
      });
      inst._zod.check = (payload) => {
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) {
          return;
        }
        payload.issues.push({
          origin,
          code: "too_big",
          maximum: def.value,
          input: payload.value,
          inclusive: def.inclusive,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckGreaterThan = core.$constructor("$ZodCheckGreaterThan", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const origin = numericOriginMap[typeof def.value];
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
          if (def.inclusive)
            bag.minimum = def.value;
          else
            bag.exclusiveMinimum = def.value;
        }
      });
      inst._zod.check = (payload) => {
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) {
          return;
        }
        payload.issues.push({
          origin,
          code: "too_small",
          minimum: def.value,
          input: payload.value,
          inclusive: def.inclusive,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckMultipleOf = /* @__PURE__ */ core.$constructor("$ZodCheckMultipleOf", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        var _a;
        (_a = inst2._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
      });
      inst._zod.check = (payload) => {
        if (typeof payload.value !== typeof def.value)
          throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : util.floatSafeRemainder(payload.value, def.value) === 0;
        if (isMultiple)
          return;
        payload.issues.push({
          origin: typeof payload.value,
          code: "not_multiple_of",
          divisor: def.value,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckNumberFormat = core.$constructor("$ZodCheckNumberFormat", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      def.format = def.format || "float64";
      const isInt = def.format?.includes("int");
      const origin = isInt ? "int" : "number";
      const [minimum, maximum] = util.NUMBER_FORMAT_RANGES[def.format];
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt)
          bag.pattern = regexes.integer;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        if (isInt) {
          if (!Number.isInteger(input)) {
            payload.issues.push({
              expected: origin,
              format: def.format,
              code: "invalid_type",
              input,
              inst
            });
            return;
          }
          if (!Number.isSafeInteger(input)) {
            if (input > 0) {
              payload.issues.push({
                input,
                code: "too_big",
                maximum: Number.MAX_SAFE_INTEGER,
                note: "Integers must be within the safe integer range.",
                inst,
                origin,
                continue: !def.abort
              });
            } else {
              payload.issues.push({
                input,
                code: "too_small",
                minimum: Number.MIN_SAFE_INTEGER,
                note: "Integers must be within the safe integer range.",
                inst,
                origin,
                continue: !def.abort
              });
            }
            return;
          }
        }
        if (input < minimum) {
          payload.issues.push({
            origin: "number",
            input,
            code: "too_small",
            minimum,
            inclusive: true,
            inst,
            continue: !def.abort
          });
        }
        if (input > maximum) {
          payload.issues.push({
            origin: "number",
            input,
            code: "too_big",
            maximum,
            inst
          });
        }
      };
    });
    exports.$ZodCheckBigIntFormat = core.$constructor("$ZodCheckBigIntFormat", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const [minimum, maximum] = util.BIGINT_FORMAT_RANGES[def.format];
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        if (input < minimum) {
          payload.issues.push({
            origin: "bigint",
            input,
            code: "too_small",
            minimum,
            inclusive: true,
            inst,
            continue: !def.abort
          });
        }
        if (input > maximum) {
          payload.issues.push({
            origin: "bigint",
            input,
            code: "too_big",
            maximum,
            inst
          });
        }
      };
    });
    exports.$ZodCheckMaxSize = core.$constructor("$ZodCheckMaxSize", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.size !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const curr = inst2._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr)
          inst2._zod.bag.maximum = def.maximum;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum)
          return;
        payload.issues.push({
          origin: util.getSizableOrigin(input),
          code: "too_big",
          maximum: def.maximum,
          input,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckMinSize = core.$constructor("$ZodCheckMinSize", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.size !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const curr = inst2._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr)
          inst2._zod.bag.minimum = def.minimum;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum)
          return;
        payload.issues.push({
          origin: util.getSizableOrigin(input),
          code: "too_small",
          minimum: def.minimum,
          input,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckSizeEquals = core.$constructor("$ZodCheckSizeEquals", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.size !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const size = input.size;
        if (size === def.size)
          return;
        const tooBig = size > def.size;
        payload.issues.push({
          origin: util.getSizableOrigin(input),
          ...tooBig ? { code: "too_big", maximum: def.size } : { code: "too_small", minimum: def.size },
          inclusive: true,
          exact: true,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckMaxLength = core.$constructor("$ZodCheckMaxLength", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.length !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const curr = inst2._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr)
          inst2._zod.bag.maximum = def.maximum;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const length = input.length;
        if (length <= def.maximum)
          return;
        const origin = util.getLengthableOrigin(input);
        payload.issues.push({
          origin,
          code: "too_big",
          maximum: def.maximum,
          inclusive: true,
          input,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckMinLength = core.$constructor("$ZodCheckMinLength", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.length !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const curr = inst2._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr)
          inst2._zod.bag.minimum = def.minimum;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const length = input.length;
        if (length >= def.minimum)
          return;
        const origin = util.getLengthableOrigin(input);
        payload.issues.push({
          origin,
          code: "too_small",
          minimum: def.minimum,
          inclusive: true,
          input,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckLengthEquals = core.$constructor("$ZodCheckLengthEquals", (inst, def) => {
      var _a;
      exports.$ZodCheck.init(inst, def);
      (_a = inst._zod.def).when ?? (_a.when = (payload) => {
        const val = payload.value;
        return !util.nullish(val) && val.length !== void 0;
      });
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
      });
      inst._zod.check = (payload) => {
        const input = payload.value;
        const length = input.length;
        if (length === def.length)
          return;
        const origin = util.getLengthableOrigin(input);
        const tooBig = length > def.length;
        payload.issues.push({
          origin,
          ...tooBig ? { code: "too_big", maximum: def.length } : { code: "too_small", minimum: def.length },
          inclusive: true,
          exact: true,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckStringFormat = core.$constructor("$ZodCheckStringFormat", (inst, def) => {
      var _a, _b;
      exports.$ZodCheck.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
          bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
          bag.patterns.add(def.pattern);
        }
      });
      if (def.pattern)
        (_a = inst._zod).check ?? (_a.check = (payload) => {
          def.pattern.lastIndex = 0;
          if (def.pattern.test(payload.value))
            return;
          payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? { pattern: def.pattern.toString() } : {},
            inst,
            continue: !def.abort
          });
        });
      else
        (_b = inst._zod).check ?? (_b.check = () => {
        });
    });
    exports.$ZodCheckRegex = core.$constructor("$ZodCheckRegex", (inst, def) => {
      exports.$ZodCheckStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value))
          return;
        payload.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "regex",
          input: payload.value,
          pattern: def.pattern.toString(),
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckLowerCase = core.$constructor("$ZodCheckLowerCase", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.lowercase);
      exports.$ZodCheckStringFormat.init(inst, def);
    });
    exports.$ZodCheckUpperCase = core.$constructor("$ZodCheckUpperCase", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.uppercase);
      exports.$ZodCheckStringFormat.init(inst, def);
    });
    exports.$ZodCheckIncludes = core.$constructor("$ZodCheckIncludes", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const escapedRegex = util.escapeRegex(def.includes);
      const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
      def.pattern = pattern;
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
        bag.patterns.add(pattern);
      });
      inst._zod.check = (payload) => {
        if (payload.value.includes(def.includes, def.position))
          return;
        payload.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "includes",
          includes: def.includes,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckStartsWith = core.$constructor("$ZodCheckStartsWith", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const pattern = new RegExp(`^${util.escapeRegex(def.prefix)}.*`);
      def.pattern ?? (def.pattern = pattern);
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
        bag.patterns.add(pattern);
      });
      inst._zod.check = (payload) => {
        if (payload.value.startsWith(def.prefix))
          return;
        payload.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "starts_with",
          prefix: def.prefix,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCheckEndsWith = core.$constructor("$ZodCheckEndsWith", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const pattern = new RegExp(`.*${util.escapeRegex(def.suffix)}$`);
      def.pattern ?? (def.pattern = pattern);
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.patterns ?? (bag.patterns = /* @__PURE__ */ new Set());
        bag.patterns.add(pattern);
      });
      inst._zod.check = (payload) => {
        if (payload.value.endsWith(def.suffix))
          return;
        payload.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "ends_with",
          suffix: def.suffix,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    function handleCheckPropertyResult(result, payload, property) {
      if (result.issues.length) {
        payload.issues.push(...util.prefixIssues(property, result.issues));
      }
    }
    exports.$ZodCheckProperty = core.$constructor("$ZodCheckProperty", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      inst._zod.check = (payload) => {
        const result = def.schema._zod.run({
          value: payload.value[def.property],
          issues: []
        }, {});
        if (result instanceof Promise) {
          return result.then((result2) => handleCheckPropertyResult(result2, payload, def.property));
        }
        handleCheckPropertyResult(result, payload, def.property);
        return;
      };
    });
    exports.$ZodCheckMimeType = core.$constructor("$ZodCheckMimeType", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      const mimeSet = new Set(def.mime);
      inst._zod.onattach.push((inst2) => {
        inst2._zod.bag.mime = def.mime;
      });
      inst._zod.check = (payload) => {
        if (mimeSet.has(payload.value.type))
          return;
        payload.issues.push({
          code: "invalid_value",
          values: def.mime,
          input: payload.value.type,
          inst
        });
      };
    });
    exports.$ZodCheckOverwrite = core.$constructor("$ZodCheckOverwrite", (inst, def) => {
      exports.$ZodCheck.init(inst, def);
      inst._zod.check = (payload) => {
        payload.value = def.tx(payload.value);
      };
    });
  }
});

// ../../node_modules/zod/v4/core/doc.cjs
var require_doc = __commonJS({
  "../../node_modules/zod/v4/core/doc.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Doc = void 0;
    var Doc = class {
      constructor(args = []) {
        this.content = [];
        this.indent = 0;
        if (this)
          this.args = args;
      }
      indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
      }
      write(arg) {
        if (typeof arg === "function") {
          arg(this, { execution: "sync" });
          arg(this, { execution: "async" });
          return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x) => x);
        const minIndent = Math.min(...lines.map((x) => x.length - x.trimStart().length));
        const dedented = lines.map((x) => x.slice(minIndent)).map((x) => " ".repeat(this.indent * 2) + x);
        for (const line of dedented) {
          this.content.push(line);
        }
      }
      compile() {
        const F = Function;
        const args = this?.args;
        const content = this?.content ?? [``];
        const lines = [...content.map((x) => `  ${x}`)];
        return new F(...args, lines.join("\n"));
      }
    };
    exports.Doc = Doc;
  }
});

// ../../node_modules/zod/v4/core/versions.cjs
var require_versions = __commonJS({
  "../../node_modules/zod/v4/core/versions.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.version = void 0;
    exports.version = {
      major: 4,
      minor: 0,
      patch: 0
    };
  }
});

// ../../node_modules/zod/v4/core/schemas.cjs
var require_schemas = __commonJS({
  "../../node_modules/zod/v4/core/schemas.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.$ZodSet = exports.$ZodMap = exports.$ZodRecord = exports.$ZodTuple = exports.$ZodIntersection = exports.$ZodDiscriminatedUnion = exports.$ZodUnion = exports.$ZodObject = exports.$ZodArray = exports.$ZodDate = exports.$ZodVoid = exports.$ZodNever = exports.$ZodUnknown = exports.$ZodAny = exports.$ZodNull = exports.$ZodUndefined = exports.$ZodSymbol = exports.$ZodBigIntFormat = exports.$ZodBigInt = exports.$ZodBoolean = exports.$ZodNumberFormat = exports.$ZodNumber = exports.$ZodCustomStringFormat = exports.$ZodJWT = exports.$ZodE164 = exports.$ZodBase64URL = exports.$ZodBase64 = exports.$ZodCIDRv6 = exports.$ZodCIDRv4 = exports.$ZodIPv6 = exports.$ZodIPv4 = exports.$ZodISODuration = exports.$ZodISOTime = exports.$ZodISODate = exports.$ZodISODateTime = exports.$ZodKSUID = exports.$ZodXID = exports.$ZodULID = exports.$ZodCUID2 = exports.$ZodCUID = exports.$ZodNanoID = exports.$ZodEmoji = exports.$ZodURL = exports.$ZodEmail = exports.$ZodUUID = exports.$ZodGUID = exports.$ZodStringFormat = exports.$ZodString = exports.clone = exports.$ZodType = void 0;
    exports.$ZodCustom = exports.$ZodLazy = exports.$ZodPromise = exports.$ZodTemplateLiteral = exports.$ZodReadonly = exports.$ZodPipe = exports.$ZodNaN = exports.$ZodCatch = exports.$ZodSuccess = exports.$ZodNonOptional = exports.$ZodPrefault = exports.$ZodDefault = exports.$ZodNullable = exports.$ZodOptional = exports.$ZodTransform = exports.$ZodFile = exports.$ZodLiteral = exports.$ZodEnum = void 0;
    exports.isValidBase64 = isValidBase64;
    exports.isValidBase64URL = isValidBase64URL;
    exports.isValidJWT = isValidJWT;
    var checks = __importStar(require_checks());
    var core = __importStar(require_core());
    var doc_js_1 = require_doc();
    var parse_js_1 = require_parse();
    var regexes = __importStar(require_regexes());
    var util = __importStar(require_util());
    var versions_js_1 = require_versions();
    exports.$ZodType = core.$constructor("$ZodType", (inst, def) => {
      var _a;
      inst ?? (inst = {});
      inst._zod.def = def;
      inst._zod.bag = inst._zod.bag || {};
      inst._zod.version = versions_js_1.version;
      const checks2 = [...inst._zod.def.checks ?? []];
      if (inst._zod.traits.has("$ZodCheck")) {
        checks2.unshift(inst);
      }
      for (const ch of checks2) {
        for (const fn of ch._zod.onattach) {
          fn(inst);
        }
      }
      if (checks2.length === 0) {
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(() => {
          inst._zod.run = inst._zod.parse;
        });
      } else {
        const runChecks = (payload, checks3, ctx) => {
          let isAborted = util.aborted(payload);
          let asyncResult;
          for (const ch of checks3) {
            if (ch._zod.def.when) {
              const shouldRun = ch._zod.def.when(payload);
              if (!shouldRun)
                continue;
            } else if (isAborted) {
              continue;
            }
            const currLen = payload.issues.length;
            const _ = ch._zod.check(payload);
            if (_ instanceof Promise && ctx?.async === false) {
              throw new core.$ZodAsyncError();
            }
            if (asyncResult || _ instanceof Promise) {
              asyncResult = (asyncResult ?? Promise.resolve()).then(async () => {
                await _;
                const nextLen = payload.issues.length;
                if (nextLen === currLen)
                  return;
                if (!isAborted)
                  isAborted = util.aborted(payload, currLen);
              });
            } else {
              const nextLen = payload.issues.length;
              if (nextLen === currLen)
                continue;
              if (!isAborted)
                isAborted = util.aborted(payload, currLen);
            }
          }
          if (asyncResult) {
            return asyncResult.then(() => {
              return payload;
            });
          }
          return payload;
        };
        inst._zod.run = (payload, ctx) => {
          const result = inst._zod.parse(payload, ctx);
          if (result instanceof Promise) {
            if (ctx.async === false)
              throw new core.$ZodAsyncError();
            return result.then((result2) => runChecks(result2, checks2, ctx));
          }
          return runChecks(result, checks2, ctx);
        };
      }
      inst["~standard"] = {
        validate: (value) => {
          try {
            const r2 = (0, parse_js_1.safeParse)(inst, value);
            return r2.success ? { value: r2.data } : { issues: r2.error?.issues };
          } catch (_) {
            return (0, parse_js_1.safeParseAsync)(inst, value).then((r2) => r2.success ? { value: r2.data } : { issues: r2.error?.issues });
          }
        },
        vendor: "zod",
        version: 1
      };
    });
    var util_js_1 = require_util();
    Object.defineProperty(exports, "clone", { enumerable: true, get: function() {
      return util_js_1.clone;
    } });
    exports.$ZodString = core.$constructor("$ZodString", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = [...inst?._zod.bag?.patterns ?? []].pop() ?? regexes.string(inst._zod.bag);
      inst._zod.parse = (payload, _) => {
        if (def.coerce)
          try {
            payload.value = String(payload.value);
          } catch (_2) {
          }
        if (typeof payload.value === "string")
          return payload;
        payload.issues.push({
          expected: "string",
          code: "invalid_type",
          input: payload.value,
          inst
        });
        return payload;
      };
    });
    exports.$ZodStringFormat = core.$constructor("$ZodStringFormat", (inst, def) => {
      checks.$ZodCheckStringFormat.init(inst, def);
      exports.$ZodString.init(inst, def);
    });
    exports.$ZodGUID = core.$constructor("$ZodGUID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.guid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodUUID = core.$constructor("$ZodUUID", (inst, def) => {
      if (def.version) {
        const versionMap = {
          v1: 1,
          v2: 2,
          v3: 3,
          v4: 4,
          v5: 5,
          v6: 6,
          v7: 7,
          v8: 8
        };
        const v = versionMap[def.version];
        if (v === void 0)
          throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = regexes.uuid(v));
      } else
        def.pattern ?? (def.pattern = regexes.uuid());
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodEmail = core.$constructor("$ZodEmail", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.email);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodURL = core.$constructor("$ZodURL", (inst, def) => {
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        try {
          const orig = payload.value;
          const url = new URL(orig);
          const href = url.href;
          if (def.hostname) {
            def.hostname.lastIndex = 0;
            if (!def.hostname.test(url.hostname)) {
              payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid hostname",
                pattern: regexes.hostname.source,
                input: payload.value,
                inst,
                continue: !def.abort
              });
            }
          }
          if (def.protocol) {
            def.protocol.lastIndex = 0;
            if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) {
              payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid protocol",
                pattern: def.protocol.source,
                input: payload.value,
                inst,
                continue: !def.abort
              });
            }
          }
          if (!orig.endsWith("/") && href.endsWith("/")) {
            payload.value = href.slice(0, -1);
          } else {
            payload.value = href;
          }
          return;
        } catch (_) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      };
    });
    exports.$ZodEmoji = core.$constructor("$ZodEmoji", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.emoji());
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodNanoID = core.$constructor("$ZodNanoID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.nanoid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodCUID = core.$constructor("$ZodCUID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.cuid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodCUID2 = core.$constructor("$ZodCUID2", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.cuid2);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodULID = core.$constructor("$ZodULID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.ulid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodXID = core.$constructor("$ZodXID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.xid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodKSUID = core.$constructor("$ZodKSUID", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.ksuid);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodISODateTime = core.$constructor("$ZodISODateTime", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.datetime(def));
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodISODate = core.$constructor("$ZodISODate", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.date);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodISOTime = core.$constructor("$ZodISOTime", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.time(def));
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodISODuration = core.$constructor("$ZodISODuration", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.duration);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodIPv4 = core.$constructor("$ZodIPv4", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.ipv4);
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.format = `ipv4`;
      });
    });
    exports.$ZodIPv6 = core.$constructor("$ZodIPv6", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.ipv6);
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        const bag = inst2._zod.bag;
        bag.format = `ipv6`;
      });
      inst._zod.check = (payload) => {
        try {
          new URL(`http://[${payload.value}]`);
        } catch {
          payload.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      };
    });
    exports.$ZodCIDRv4 = core.$constructor("$ZodCIDRv4", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.cidrv4);
      exports.$ZodStringFormat.init(inst, def);
    });
    exports.$ZodCIDRv6 = core.$constructor("$ZodCIDRv6", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.cidrv6);
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        const [address, prefix] = payload.value.split("/");
        try {
          if (!prefix)
            throw new Error();
          const prefixNum = Number(prefix);
          if (`${prefixNum}` !== prefix)
            throw new Error();
          if (prefixNum < 0 || prefixNum > 128)
            throw new Error();
          new URL(`http://[${address}]`);
        } catch {
          payload.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      };
    });
    function isValidBase64(data) {
      if (data === "")
        return true;
      if (data.length % 4 !== 0)
        return false;
      try {
        atob(data);
        return true;
      } catch {
        return false;
      }
    }
    exports.$ZodBase64 = core.$constructor("$ZodBase64", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.base64);
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        inst2._zod.bag.contentEncoding = "base64";
      });
      inst._zod.check = (payload) => {
        if (isValidBase64(payload.value))
          return;
        payload.issues.push({
          code: "invalid_format",
          format: "base64",
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    function isValidBase64URL(data) {
      if (!regexes.base64url.test(data))
        return false;
      const base64 = data.replace(/[-_]/g, (c) => c === "-" ? "+" : "/");
      const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
      return isValidBase64(padded);
    }
    exports.$ZodBase64URL = core.$constructor("$ZodBase64URL", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.base64url);
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.onattach.push((inst2) => {
        inst2._zod.bag.contentEncoding = "base64url";
      });
      inst._zod.check = (payload) => {
        if (isValidBase64URL(payload.value))
          return;
        payload.issues.push({
          code: "invalid_format",
          format: "base64url",
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodE164 = core.$constructor("$ZodE164", (inst, def) => {
      def.pattern ?? (def.pattern = regexes.e164);
      exports.$ZodStringFormat.init(inst, def);
    });
    function isValidJWT(token, algorithm = null) {
      try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3)
          return false;
        const [header] = tokensParts;
        if (!header)
          return false;
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT")
          return false;
        if (!parsedHeader.alg)
          return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm))
          return false;
        return true;
      } catch {
        return false;
      }
    }
    exports.$ZodJWT = core.$constructor("$ZodJWT", (inst, def) => {
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        if (isValidJWT(payload.value, def.alg))
          return;
        payload.issues.push({
          code: "invalid_format",
          format: "jwt",
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodCustomStringFormat = core.$constructor("$ZodCustomStringFormat", (inst, def) => {
      exports.$ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        if (def.fn(payload.value))
          return;
        payload.issues.push({
          code: "invalid_format",
          format: def.format,
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    exports.$ZodNumber = core.$constructor("$ZodNumber", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = inst._zod.bag.pattern ?? regexes.number;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = Number(payload.value);
          } catch (_) {
          }
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) {
          return payload;
        }
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : void 0 : void 0;
        payload.issues.push({
          expected: "number",
          code: "invalid_type",
          input,
          inst,
          ...received ? { received } : {}
        });
        return payload;
      };
    });
    exports.$ZodNumberFormat = core.$constructor("$ZodNumber", (inst, def) => {
      checks.$ZodCheckNumberFormat.init(inst, def);
      exports.$ZodNumber.init(inst, def);
    });
    exports.$ZodBoolean = core.$constructor("$ZodBoolean", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = regexes.boolean;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = Boolean(payload.value);
          } catch (_) {
          }
        const input = payload.value;
        if (typeof input === "boolean")
          return payload;
        payload.issues.push({
          expected: "boolean",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodBigInt = core.$constructor("$ZodBigInt", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = regexes.bigint;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = BigInt(payload.value);
          } catch (_) {
          }
        if (typeof payload.value === "bigint")
          return payload;
        payload.issues.push({
          expected: "bigint",
          code: "invalid_type",
          input: payload.value,
          inst
        });
        return payload;
      };
    });
    exports.$ZodBigIntFormat = core.$constructor("$ZodBigInt", (inst, def) => {
      checks.$ZodCheckBigIntFormat.init(inst, def);
      exports.$ZodBigInt.init(inst, def);
    });
    exports.$ZodSymbol = core.$constructor("$ZodSymbol", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (typeof input === "symbol")
          return payload;
        payload.issues.push({
          expected: "symbol",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodUndefined = core.$constructor("$ZodUndefined", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = regexes.undefined;
      inst._zod.values = /* @__PURE__ */ new Set([void 0]);
      inst._zod.optin = "optional";
      inst._zod.optout = "optional";
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (typeof input === "undefined")
          return payload;
        payload.issues.push({
          expected: "undefined",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodNull = core.$constructor("$ZodNull", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.pattern = regexes.null;
      inst._zod.values = /* @__PURE__ */ new Set([null]);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (input === null)
          return payload;
        payload.issues.push({
          expected: "null",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodAny = core.$constructor("$ZodAny", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload) => payload;
    });
    exports.$ZodUnknown = core.$constructor("$ZodUnknown", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload) => payload;
    });
    exports.$ZodNever = core.$constructor("$ZodNever", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        payload.issues.push({
          expected: "never",
          code: "invalid_type",
          input: payload.value,
          inst
        });
        return payload;
      };
    });
    exports.$ZodVoid = core.$constructor("$ZodVoid", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (typeof input === "undefined")
          return payload;
        payload.issues.push({
          expected: "void",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodDate = core.$constructor("$ZodDate", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce) {
          try {
            payload.value = new Date(payload.value);
          } catch (_err) {
          }
        }
        const input = payload.value;
        const isDate2 = input instanceof Date;
        const isValidDate = isDate2 && !Number.isNaN(input.getTime());
        if (isValidDate)
          return payload;
        payload.issues.push({
          expected: "date",
          code: "invalid_type",
          input,
          ...isDate2 ? { received: "Invalid Date" } : {},
          inst
        });
        return payload;
      };
    });
    function handleArrayResult(result, final, index) {
      if (result.issues.length) {
        final.issues.push(...util.prefixIssues(index, result.issues));
      }
      final.value[index] = result.value;
    }
    exports.$ZodArray = core.$constructor("$ZodArray", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!Array.isArray(input)) {
          payload.issues.push({
            expected: "array",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        payload.value = Array(input.length);
        const proms = [];
        for (let i = 0; i < input.length; i++) {
          const item = input[i];
          const result = def.element._zod.run({
            value: item,
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then((result2) => handleArrayResult(result2, payload, i)));
          } else {
            handleArrayResult(result, payload, i);
          }
        }
        if (proms.length) {
          return Promise.all(proms).then(() => payload);
        }
        return payload;
      };
    });
    function handleObjectResult(result, final, key) {
      if (result.issues.length) {
        final.issues.push(...util.prefixIssues(key, result.issues));
      }
      final.value[key] = result.value;
    }
    function handleOptionalObjectResult(result, final, key, input) {
      if (result.issues.length) {
        if (input[key] === void 0) {
          if (key in input) {
            final.value[key] = void 0;
          } else {
            final.value[key] = result.value;
          }
        } else {
          final.issues.push(...util.prefixIssues(key, result.issues));
        }
      } else if (result.value === void 0) {
        if (key in input)
          final.value[key] = void 0;
      } else {
        final.value[key] = result.value;
      }
    }
    exports.$ZodObject = core.$constructor("$ZodObject", (inst, def) => {
      exports.$ZodType.init(inst, def);
      const _normalized = util.cached(() => {
        const keys = Object.keys(def.shape);
        for (const k of keys) {
          if (!(def.shape[k] instanceof exports.$ZodType)) {
            throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
          }
        }
        const okeys = util.optionalKeys(def.shape);
        return {
          shape: def.shape,
          keys,
          keySet: new Set(keys),
          numKeys: keys.length,
          optionalKeys: new Set(okeys)
        };
      });
      util.defineLazy(inst._zod, "propValues", () => {
        const shape = def.shape;
        const propValues = {};
        for (const key in shape) {
          const field = shape[key]._zod;
          if (field.values) {
            propValues[key] ?? (propValues[key] = /* @__PURE__ */ new Set());
            for (const v of field.values)
              propValues[key].add(v);
          }
        }
        return propValues;
      });
      const generateFastpass = (shape) => {
        const doc = new doc_js_1.Doc(["shape", "payload", "ctx"]);
        const normalized = _normalized.value;
        const parseStr = (key) => {
          const k = util.esc(key);
          return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        };
        doc.write(`const input = payload.value;`);
        const ids = /* @__PURE__ */ Object.create(null);
        let counter = 0;
        for (const key of normalized.keys) {
          ids[key] = `key_${counter++}`;
        }
        doc.write(`const newResult = {}`);
        for (const key of normalized.keys) {
          if (normalized.optionalKeys.has(key)) {
            const id = ids[key];
            doc.write(`const ${id} = ${parseStr(key)};`);
            const k = util.esc(key);
            doc.write(`
        if (${id}.issues.length) {
          if (input[${k}] === undefined) {
            if (${k} in input) {
              newResult[${k}] = undefined;
            }
          } else {
            payload.issues = payload.issues.concat(
              ${id}.issues.map((iss) => ({
                ...iss,
                path: iss.path ? [${k}, ...iss.path] : [${k}],
              }))
            );
          }
        } else if (${id}.value === undefined) {
          if (${k} in input) newResult[${k}] = undefined;
        } else {
          newResult[${k}] = ${id}.value;
        }
        `);
          } else {
            const id = ids[key];
            doc.write(`const ${id} = ${parseStr(key)};`);
            doc.write(`
          if (${id}.issues.length) payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${util.esc(key)}, ...iss.path] : [${util.esc(key)}]
          })));`);
            doc.write(`newResult[${util.esc(key)}] = ${id}.value`);
          }
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        const fn = doc.compile();
        return (payload, ctx) => fn(shape, payload, ctx);
      };
      let fastpass;
      const isObject = util.isObject;
      const jit = !core.globalConfig.jitless;
      const allowsEval = util.allowsEval;
      const fastEnabled = jit && allowsEval.value;
      const catchall = def.catchall;
      let value;
      inst._zod.parse = (payload, ctx) => {
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
          payload.issues.push({
            expected: "object",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        const proms = [];
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
          if (!fastpass)
            fastpass = generateFastpass(def.shape);
          payload = fastpass(payload, ctx);
        } else {
          payload.value = {};
          const shape = value.shape;
          for (const key of value.keys) {
            const el = shape[key];
            const r2 = el._zod.run({ value: input[key], issues: [] }, ctx);
            const isOptional = el._zod.optin === "optional" && el._zod.optout === "optional";
            if (r2 instanceof Promise) {
              proms.push(r2.then((r3) => isOptional ? handleOptionalObjectResult(r3, payload, key, input) : handleObjectResult(r3, payload, key)));
            } else if (isOptional) {
              handleOptionalObjectResult(r2, payload, key, input);
            } else {
              handleObjectResult(r2, payload, key);
            }
          }
        }
        if (!catchall) {
          return proms.length ? Promise.all(proms).then(() => payload) : payload;
        }
        const unrecognized = [];
        const keySet = value.keySet;
        const _catchall = catchall._zod;
        const t = _catchall.def.type;
        for (const key of Object.keys(input)) {
          if (keySet.has(key))
            continue;
          if (t === "never") {
            unrecognized.push(key);
            continue;
          }
          const r2 = _catchall.run({ value: input[key], issues: [] }, ctx);
          if (r2 instanceof Promise) {
            proms.push(r2.then((r3) => handleObjectResult(r3, payload, key)));
          } else {
            handleObjectResult(r2, payload, key);
          }
        }
        if (unrecognized.length) {
          payload.issues.push({
            code: "unrecognized_keys",
            keys: unrecognized,
            input,
            inst
          });
        }
        if (!proms.length)
          return payload;
        return Promise.all(proms).then(() => {
          return payload;
        });
      };
    });
    function handleUnionResults(results, final, inst, ctx) {
      for (const result of results) {
        if (result.issues.length === 0) {
          final.value = result.value;
          return final;
        }
      }
      final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst,
        errors: results.map((result) => result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())))
      });
      return final;
    }
    exports.$ZodUnion = core.$constructor("$ZodUnion", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "optin", () => def.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0);
      util.defineLazy(inst._zod, "optout", () => def.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0);
      util.defineLazy(inst._zod, "values", () => {
        if (def.options.every((o) => o._zod.values)) {
          return new Set(def.options.flatMap((option) => Array.from(option._zod.values)));
        }
        return void 0;
      });
      util.defineLazy(inst._zod, "pattern", () => {
        if (def.options.every((o) => o._zod.pattern)) {
          const patterns = def.options.map((o) => o._zod.pattern);
          return new RegExp(`^(${patterns.map((p) => util.cleanRegex(p.source)).join("|")})$`);
        }
        return void 0;
      });
      inst._zod.parse = (payload, ctx) => {
        let async = false;
        const results = [];
        for (const option of def.options) {
          const result = option._zod.run({
            value: payload.value,
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            results.push(result);
            async = true;
          } else {
            if (result.issues.length === 0)
              return result;
            results.push(result);
          }
        }
        if (!async)
          return handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results2) => {
          return handleUnionResults(results2, payload, inst, ctx);
        });
      };
    });
    exports.$ZodDiscriminatedUnion = /* @__PURE__ */ core.$constructor("$ZodDiscriminatedUnion", (inst, def) => {
      exports.$ZodUnion.init(inst, def);
      const _super = inst._zod.parse;
      util.defineLazy(inst._zod, "propValues", () => {
        const propValues = {};
        for (const option of def.options) {
          const pv = option._zod.propValues;
          if (!pv || Object.keys(pv).length === 0)
            throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
          for (const [k, v] of Object.entries(pv)) {
            if (!propValues[k])
              propValues[k] = /* @__PURE__ */ new Set();
            for (const val of v) {
              propValues[k].add(val);
            }
          }
        }
        return propValues;
      });
      const disc = util.cached(() => {
        const opts = def.options;
        const map = /* @__PURE__ */ new Map();
        for (const o of opts) {
          const values = o._zod.propValues[def.discriminator];
          if (!values || values.size === 0)
            throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
          for (const v of values) {
            if (map.has(v)) {
              throw new Error(`Duplicate discriminator value "${String(v)}"`);
            }
            map.set(v, o);
          }
        }
        return map;
      });
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!util.isObject(input)) {
          payload.issues.push({
            code: "invalid_type",
            expected: "object",
            input,
            inst
          });
          return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) {
          return opt._zod.run(payload, ctx);
        }
        if (def.unionFallback) {
          return _super(payload, ctx);
        }
        payload.issues.push({
          code: "invalid_union",
          errors: [],
          note: "No matching discriminator",
          input,
          path: [def.discriminator],
          inst
        });
        return payload;
      };
    });
    exports.$ZodIntersection = core.$constructor("$ZodIntersection", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        const left = def.left._zod.run({ value: input, issues: [] }, ctx);
        const right = def.right._zod.run({ value: input, issues: [] }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) {
          return Promise.all([left, right]).then(([left2, right2]) => {
            return handleIntersectionResults(payload, left2, right2);
          });
        }
        return handleIntersectionResults(payload, left, right);
      };
    });
    function mergeValues(a, b) {
      if (a === b) {
        return { valid: true, data: a };
      }
      if (a instanceof Date && b instanceof Date && +a === +b) {
        return { valid: true, data: a };
      }
      if (util.isPlainObject(a) && util.isPlainObject(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
          const sharedValue = mergeValues(a[key], b[key]);
          if (!sharedValue.valid) {
            return {
              valid: false,
              mergeErrorPath: [key, ...sharedValue.mergeErrorPath]
            };
          }
          newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
      }
      if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
          return { valid: false, mergeErrorPath: [] };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
          const itemA = a[index];
          const itemB = b[index];
          const sharedValue = mergeValues(itemA, itemB);
          if (!sharedValue.valid) {
            return {
              valid: false,
              mergeErrorPath: [index, ...sharedValue.mergeErrorPath]
            };
          }
          newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
      }
      return { valid: false, mergeErrorPath: [] };
    }
    function handleIntersectionResults(result, left, right) {
      if (left.issues.length) {
        result.issues.push(...left.issues);
      }
      if (right.issues.length) {
        result.issues.push(...right.issues);
      }
      if (util.aborted(result))
        return result;
      const merged = mergeValues(left.value, right.value);
      if (!merged.valid) {
        throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(merged.mergeErrorPath)}`);
      }
      result.value = merged.data;
      return result;
    }
    exports.$ZodTuple = core.$constructor("$ZodTuple", (inst, def) => {
      exports.$ZodType.init(inst, def);
      const items = def.items;
      const optStart = items.length - [...items].reverse().findIndex((item) => item._zod.optin !== "optional");
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!Array.isArray(input)) {
          payload.issues.push({
            input,
            inst,
            expected: "tuple",
            code: "invalid_type"
          });
          return payload;
        }
        payload.value = [];
        const proms = [];
        if (!def.rest) {
          const tooBig = input.length > items.length;
          const tooSmall = input.length < optStart - 1;
          if (tooBig || tooSmall) {
            payload.issues.push({
              input,
              inst,
              origin: "array",
              ...tooBig ? { code: "too_big", maximum: items.length } : { code: "too_small", minimum: items.length }
            });
            return payload;
          }
        }
        let i = -1;
        for (const item of items) {
          i++;
          if (i >= input.length) {
            if (i >= optStart)
              continue;
          }
          const result = item._zod.run({
            value: input[i],
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then((result2) => handleTupleResult(result2, payload, i)));
          } else {
            handleTupleResult(result, payload, i);
          }
        }
        if (def.rest) {
          const rest = input.slice(items.length);
          for (const el of rest) {
            i++;
            const result = def.rest._zod.run({
              value: el,
              issues: []
            }, ctx);
            if (result instanceof Promise) {
              proms.push(result.then((result2) => handleTupleResult(result2, payload, i)));
            } else {
              handleTupleResult(result, payload, i);
            }
          }
        }
        if (proms.length)
          return Promise.all(proms).then(() => payload);
        return payload;
      };
    });
    function handleTupleResult(result, final, index) {
      if (result.issues.length) {
        final.issues.push(...util.prefixIssues(index, result.issues));
      }
      final.value[index] = result.value;
    }
    exports.$ZodRecord = core.$constructor("$ZodRecord", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!util.isPlainObject(input)) {
          payload.issues.push({
            expected: "record",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        const proms = [];
        if (def.keyType._zod.values) {
          const values = def.keyType._zod.values;
          payload.value = {};
          for (const key of values) {
            if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
              const result = def.valueType._zod.run({ value: input[key], issues: [] }, ctx);
              if (result instanceof Promise) {
                proms.push(result.then((result2) => {
                  if (result2.issues.length) {
                    payload.issues.push(...util.prefixIssues(key, result2.issues));
                  }
                  payload.value[key] = result2.value;
                }));
              } else {
                if (result.issues.length) {
                  payload.issues.push(...util.prefixIssues(key, result.issues));
                }
                payload.value[key] = result.value;
              }
            }
          }
          let unrecognized;
          for (const key in input) {
            if (!values.has(key)) {
              unrecognized = unrecognized ?? [];
              unrecognized.push(key);
            }
          }
          if (unrecognized && unrecognized.length > 0) {
            payload.issues.push({
              code: "unrecognized_keys",
              input,
              inst,
              keys: unrecognized
            });
          }
        } else {
          payload.value = {};
          for (const key of Reflect.ownKeys(input)) {
            if (key === "__proto__")
              continue;
            const keyResult = def.keyType._zod.run({ value: key, issues: [] }, ctx);
            if (keyResult instanceof Promise) {
              throw new Error("Async schemas not supported in object keys currently");
            }
            if (keyResult.issues.length) {
              payload.issues.push({
                origin: "record",
                code: "invalid_key",
                issues: keyResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config())),
                input: key,
                path: [key],
                inst
              });
              payload.value[keyResult.value] = keyResult.value;
              continue;
            }
            const result = def.valueType._zod.run({ value: input[key], issues: [] }, ctx);
            if (result instanceof Promise) {
              proms.push(result.then((result2) => {
                if (result2.issues.length) {
                  payload.issues.push(...util.prefixIssues(key, result2.issues));
                }
                payload.value[keyResult.value] = result2.value;
              }));
            } else {
              if (result.issues.length) {
                payload.issues.push(...util.prefixIssues(key, result.issues));
              }
              payload.value[keyResult.value] = result.value;
            }
          }
        }
        if (proms.length) {
          return Promise.all(proms).then(() => payload);
        }
        return payload;
      };
    });
    exports.$ZodMap = core.$constructor("$ZodMap", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!(input instanceof Map)) {
          payload.issues.push({
            expected: "map",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        const proms = [];
        payload.value = /* @__PURE__ */ new Map();
        for (const [key, value] of input) {
          const keyResult = def.keyType._zod.run({ value: key, issues: [] }, ctx);
          const valueResult = def.valueType._zod.run({ value, issues: [] }, ctx);
          if (keyResult instanceof Promise || valueResult instanceof Promise) {
            proms.push(Promise.all([keyResult, valueResult]).then(([keyResult2, valueResult2]) => {
              handleMapResult(keyResult2, valueResult2, payload, key, input, inst, ctx);
            }));
          } else {
            handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
          }
        }
        if (proms.length)
          return Promise.all(proms).then(() => payload);
        return payload;
      };
    });
    function handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
      if (keyResult.issues.length) {
        if (util.propertyKeyTypes.has(typeof key)) {
          final.issues.push(...util.prefixIssues(key, keyResult.issues));
        } else {
          final.issues.push({
            origin: "map",
            code: "invalid_key",
            input,
            inst,
            issues: keyResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
          });
        }
      }
      if (valueResult.issues.length) {
        if (util.propertyKeyTypes.has(typeof key)) {
          final.issues.push(...util.prefixIssues(key, valueResult.issues));
        } else {
          final.issues.push({
            origin: "map",
            code: "invalid_element",
            input,
            inst,
            key,
            issues: valueResult.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
          });
        }
      }
      final.value.set(keyResult.value, valueResult.value);
    }
    exports.$ZodSet = core.$constructor("$ZodSet", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!(input instanceof Set)) {
          payload.issues.push({
            input,
            inst,
            expected: "set",
            code: "invalid_type"
          });
          return payload;
        }
        const proms = [];
        payload.value = /* @__PURE__ */ new Set();
        for (const item of input) {
          const result = def.valueType._zod.run({ value: item, issues: [] }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then((result2) => handleSetResult(result2, payload)));
          } else
            handleSetResult(result, payload);
        }
        if (proms.length)
          return Promise.all(proms).then(() => payload);
        return payload;
      };
    });
    function handleSetResult(result, final) {
      if (result.issues.length) {
        final.issues.push(...result.issues);
      }
      final.value.add(result.value);
    }
    exports.$ZodEnum = core.$constructor("$ZodEnum", (inst, def) => {
      exports.$ZodType.init(inst, def);
      const values = util.getEnumValues(def.entries);
      inst._zod.values = new Set(values);
      inst._zod.pattern = new RegExp(`^(${values.filter((k) => util.propertyKeyTypes.has(typeof k)).map((o) => typeof o === "string" ? util.escapeRegex(o) : o.toString()).join("|")})$`);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (inst._zod.values.has(input)) {
          return payload;
        }
        payload.issues.push({
          code: "invalid_value",
          values,
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodLiteral = core.$constructor("$ZodLiteral", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.values = new Set(def.values);
      inst._zod.pattern = new RegExp(`^(${def.values.map((o) => typeof o === "string" ? util.escapeRegex(o) : o ? o.toString() : String(o)).join("|")})$`);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (inst._zod.values.has(input)) {
          return payload;
        }
        payload.issues.push({
          code: "invalid_value",
          values: def.values,
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodFile = core.$constructor("$ZodFile", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (input instanceof File)
          return payload;
        payload.issues.push({
          expected: "file",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    exports.$ZodTransform = core.$constructor("$ZodTransform", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        const _out = def.transform(payload.value, payload);
        if (_ctx.async) {
          const output = _out instanceof Promise ? _out : Promise.resolve(_out);
          return output.then((output2) => {
            payload.value = output2;
            return payload;
          });
        }
        if (_out instanceof Promise) {
          throw new core.$ZodAsyncError();
        }
        payload.value = _out;
        return payload;
      };
    });
    exports.$ZodOptional = core.$constructor("$ZodOptional", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.optin = "optional";
      inst._zod.optout = "optional";
      util.defineLazy(inst._zod, "values", () => {
        return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, void 0]) : void 0;
      });
      util.defineLazy(inst._zod, "pattern", () => {
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${util.cleanRegex(pattern.source)})?$`) : void 0;
      });
      inst._zod.parse = (payload, ctx) => {
        if (def.innerType._zod.optin === "optional") {
          return def.innerType._zod.run(payload, ctx);
        }
        if (payload.value === void 0) {
          return payload;
        }
        return def.innerType._zod.run(payload, ctx);
      };
    });
    exports.$ZodNullable = core.$constructor("$ZodNullable", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
      util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
      util.defineLazy(inst._zod, "pattern", () => {
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${util.cleanRegex(pattern.source)}|null)$`) : void 0;
      });
      util.defineLazy(inst._zod, "values", () => {
        return def.innerType._zod.values ? /* @__PURE__ */ new Set([...def.innerType._zod.values, null]) : void 0;
      });
      inst._zod.parse = (payload, ctx) => {
        if (payload.value === null)
          return payload;
        return def.innerType._zod.run(payload, ctx);
      };
    });
    exports.$ZodDefault = core.$constructor("$ZodDefault", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.optin = "optional";
      util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
      inst._zod.parse = (payload, ctx) => {
        if (payload.value === void 0) {
          payload.value = def.defaultValue;
          return payload;
        }
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => handleDefaultResult(result2, def));
        }
        return handleDefaultResult(result, def);
      };
    });
    function handleDefaultResult(payload, def) {
      if (payload.value === void 0) {
        payload.value = def.defaultValue;
      }
      return payload;
    }
    exports.$ZodPrefault = core.$constructor("$ZodPrefault", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.optin = "optional";
      util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
      inst._zod.parse = (payload, ctx) => {
        if (payload.value === void 0) {
          payload.value = def.defaultValue;
        }
        return def.innerType._zod.run(payload, ctx);
      };
    });
    exports.$ZodNonOptional = core.$constructor("$ZodNonOptional", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "values", () => {
        const v = def.innerType._zod.values;
        return v ? new Set([...v].filter((x) => x !== void 0)) : void 0;
      });
      inst._zod.parse = (payload, ctx) => {
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => handleNonOptionalResult(result2, inst));
        }
        return handleNonOptionalResult(result, inst);
      };
    });
    function handleNonOptionalResult(payload, inst) {
      if (!payload.issues.length && payload.value === void 0) {
        payload.issues.push({
          code: "invalid_type",
          expected: "nonoptional",
          input: payload.value,
          inst
        });
      }
      return payload;
    }
    exports.$ZodSuccess = core.$constructor("$ZodSuccess", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => {
            payload.value = result2.issues.length === 0;
            return payload;
          });
        }
        payload.value = result.issues.length === 0;
        return payload;
      };
    });
    exports.$ZodCatch = core.$constructor("$ZodCatch", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.optin = "optional";
      util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
      util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
      inst._zod.parse = (payload, ctx) => {
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => {
            payload.value = result2.value;
            if (result2.issues.length) {
              payload.value = def.catchValue({
                ...payload,
                error: {
                  issues: result2.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
                },
                input: payload.value
              });
              payload.issues = [];
            }
            return payload;
          });
        }
        payload.value = result.value;
        if (result.issues.length) {
          payload.value = def.catchValue({
            ...payload,
            error: {
              issues: result.issues.map((iss) => util.finalizeIssue(iss, ctx, core.config()))
            },
            input: payload.value
          });
          payload.issues = [];
        }
        return payload;
      };
    });
    exports.$ZodNaN = core.$constructor("$ZodNaN", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
          payload.issues.push({
            input: payload.value,
            inst,
            expected: "nan",
            code: "invalid_type"
          });
          return payload;
        }
        return payload;
      };
    });
    exports.$ZodPipe = core.$constructor("$ZodPipe", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "values", () => def.in._zod.values);
      util.defineLazy(inst._zod, "optin", () => def.in._zod.optin);
      util.defineLazy(inst._zod, "optout", () => def.out._zod.optout);
      inst._zod.parse = (payload, ctx) => {
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) {
          return left.then((left2) => handlePipeResult(left2, def, ctx));
        }
        return handlePipeResult(left, def, ctx);
      };
    });
    function handlePipeResult(left, def, ctx) {
      if (util.aborted(left)) {
        return left;
      }
      return def.out._zod.run({ value: left.value, issues: left.issues }, ctx);
    }
    exports.$ZodReadonly = core.$constructor("$ZodReadonly", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "propValues", () => def.innerType._zod.propValues);
      util.defineLazy(inst._zod, "values", () => def.innerType._zod.values);
      util.defineLazy(inst._zod, "optin", () => def.innerType._zod.optin);
      util.defineLazy(inst._zod, "optout", () => def.innerType._zod.optout);
      inst._zod.parse = (payload, ctx) => {
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then(handleReadonlyResult);
        }
        return handleReadonlyResult(result);
      };
    });
    function handleReadonlyResult(payload) {
      payload.value = Object.freeze(payload.value);
      return payload;
    }
    exports.$ZodTemplateLiteral = core.$constructor("$ZodTemplateLiteral", (inst, def) => {
      exports.$ZodType.init(inst, def);
      const regexParts = [];
      for (const part of def.parts) {
        if (part instanceof exports.$ZodType) {
          if (!part._zod.pattern) {
            throw new Error(`Invalid template literal part, no pattern found: ${[...part._zod.traits].shift()}`);
          }
          const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
          if (!source)
            throw new Error(`Invalid template literal part: ${part._zod.traits}`);
          const start = source.startsWith("^") ? 1 : 0;
          const end = source.endsWith("$") ? source.length - 1 : source.length;
          regexParts.push(source.slice(start, end));
        } else if (part === null || util.primitiveTypes.has(typeof part)) {
          regexParts.push(util.escapeRegex(`${part}`));
        } else {
          throw new Error(`Invalid template literal part: ${part}`);
        }
      }
      inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
      inst._zod.parse = (payload, _ctx) => {
        if (typeof payload.value !== "string") {
          payload.issues.push({
            input: payload.value,
            inst,
            expected: "template_literal",
            code: "invalid_type"
          });
          return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
          payload.issues.push({
            input: payload.value,
            inst,
            code: "invalid_format",
            format: "template_literal",
            pattern: inst._zod.pattern.source
          });
          return payload;
        }
        return payload;
      };
    });
    exports.$ZodPromise = core.$constructor("$ZodPromise", (inst, def) => {
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, ctx) => {
        return Promise.resolve(payload.value).then((inner) => def.innerType._zod.run({ value: inner, issues: [] }, ctx));
      };
    });
    exports.$ZodLazy = core.$constructor("$ZodLazy", (inst, def) => {
      exports.$ZodType.init(inst, def);
      util.defineLazy(inst._zod, "innerType", () => def.getter());
      util.defineLazy(inst._zod, "pattern", () => inst._zod.innerType._zod.pattern);
      util.defineLazy(inst._zod, "propValues", () => inst._zod.innerType._zod.propValues);
      util.defineLazy(inst._zod, "optin", () => inst._zod.innerType._zod.optin);
      util.defineLazy(inst._zod, "optout", () => inst._zod.innerType._zod.optout);
      inst._zod.parse = (payload, ctx) => {
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
      };
    });
    exports.$ZodCustom = core.$constructor("$ZodCustom", (inst, def) => {
      checks.$ZodCheck.init(inst, def);
      exports.$ZodType.init(inst, def);
      inst._zod.parse = (payload, _) => {
        return payload;
      };
      inst._zod.check = (payload) => {
        const input = payload.value;
        const r2 = def.fn(input);
        if (r2 instanceof Promise) {
          return r2.then((r3) => handleRefineResult(r3, payload, input, inst));
        }
        handleRefineResult(r2, payload, input, inst);
        return;
      };
    });
    function handleRefineResult(result, payload, input, inst) {
      if (!result) {
        const _iss = {
          code: "custom",
          input,
          inst,
          // incorporates params.error into issue reporting
          path: [...inst._zod.def.path ?? []],
          // incorporates params.error into issue reporting
          continue: !inst._zod.def.abort
          // params: inst._zod.def.params,
        };
        if (inst._zod.def.params)
          _iss.params = inst._zod.def.params;
        payload.issues.push(util.issue(_iss));
      }
    }
  }
});

// ../../node_modules/zod/v4/locales/ar.cjs
var require_ar = __commonJS({
  "../../node_modules/zod/v4/locales/ar.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u062D\u0631\u0641", verb: "\u0623\u0646 \u064A\u062D\u0648\u064A" },
        file: { unit: "\u0628\u0627\u064A\u062A", verb: "\u0623\u0646 \u064A\u062D\u0648\u064A" },
        array: { unit: "\u0639\u0646\u0635\u0631", verb: "\u0623\u0646 \u064A\u062D\u0648\u064A" },
        set: { unit: "\u0639\u0646\u0635\u0631", verb: "\u0623\u0646 \u064A\u062D\u0648\u064A" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0645\u062F\u062E\u0644",
        email: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        url: "\u0631\u0627\u0628\u0637",
        emoji: "\u0625\u064A\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        date: "\u062A\u0627\u0631\u064A\u062E \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        time: "\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        duration: "\u0645\u062F\u0629 \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        ipv4: "\u0639\u0646\u0648\u0627\u0646 IPv4",
        ipv6: "\u0639\u0646\u0648\u0627\u0646 IPv6",
        cidrv4: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv4",
        cidrv6: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv6",
        base64: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64-encoded",
        base64url: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64url-encoded",
        json_string: "\u0646\u064E\u0635 \u0639\u0644\u0649 \u0647\u064A\u0626\u0629 JSON",
        e164: "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0628\u0645\u0639\u064A\u0627\u0631 E.164",
        jwt: "JWT",
        template_literal: "\u0645\u062F\u062E\u0644"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0645\u062F\u062E\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629: \u064A\u0641\u062A\u0631\u0636 \u0625\u062F\u062E\u0627\u0644 ${issue.expected}\u060C \u0648\u0644\u0643\u0646 \u062A\u0645 \u0625\u062F\u062E\u0627\u0644 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u0645\u062F\u062E\u0644\u0627\u062A \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644\u0629: \u064A\u0641\u062A\u0631\u0636 \u0625\u062F\u062E\u0627\u0644 ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u0627\u062E\u062A\u064A\u0627\u0631 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062A\u0648\u0642\u0639 \u0627\u0646\u062A\u0642\u0627\u0621 \u0623\u062D\u062F \u0647\u0630\u0647 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A: ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return ` \u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0644\u0627\u0632\u0645: \u064A\u0641\u062A\u0631\u0636 \u0623\u0646 \u062A\u0643\u0648\u0646 ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"}`;
            return `\u0623\u0643\u0628\u0631 \u0645\u0646 \u0627\u0644\u0644\u0627\u0632\u0645: \u064A\u0641\u062A\u0631\u0636 \u0623\u0646 \u062A\u0643\u0648\u0646 ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0623\u0635\u063A\u0631 \u0645\u0646 \u0627\u0644\u0644\u0627\u0632\u0645: \u064A\u0641\u062A\u0631\u0636 \u0644\u0640 ${issue.origin} \u0623\u0646 \u064A\u0643\u0648\u0646 ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u0623\u0635\u063A\u0631 \u0645\u0646 \u0627\u0644\u0644\u0627\u0632\u0645: \u064A\u0641\u062A\u0631\u0636 \u0644\u0640 ${issue.origin} \u0623\u0646 \u064A\u0643\u0648\u0646 ${adj} ${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u0646\u064E\u0635 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u062F\u0623 \u0628\u0640 "${issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `\u0646\u064E\u0635 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0646\u062A\u0647\u064A \u0628\u0640 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u0646\u064E\u0635 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0636\u0645\u0651\u064E\u0646 "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u0646\u064E\u0635 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0637\u0627\u0628\u0642 \u0627\u0644\u0646\u0645\u0637 ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644`;
          }
          case "not_multiple_of":
            return `\u0631\u0642\u0645 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644: \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0645\u0646 \u0645\u0636\u0627\u0639\u0641\u0627\u062A ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u0645\u0639\u0631\u0641${issue.keys.length > 1 ? "\u0627\u062A" : ""} \u063A\u0631\u064A\u0628${issue.keys.length > 1 ? "\u0629" : ""}: ${util.joinValues(issue.keys, "\u060C ")}`;
          case "invalid_key":
            return `\u0645\u0639\u0631\u0641 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644 \u0641\u064A ${issue.origin}`;
          case "invalid_union":
            return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
          case "invalid_element":
            return `\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644 \u0641\u064A ${issue.origin}`;
          default:
            return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/az.cjs
var require_az = __commonJS({
  "../../node_modules/zod/v4/locales/az.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "simvol", verb: "olmal\u0131d\u0131r" },
        file: { unit: "bayt", verb: "olmal\u0131d\u0131r" },
        array: { unit: "element", verb: "olmal\u0131d\u0131r" },
        set: { unit: "element", verb: "olmal\u0131d\u0131r" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Yanl\u0131\u015F d\u0259y\u0259r: g\xF6zl\u0259nil\u0259n ${issue.expected}, daxil olan ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Yanl\u0131\u015F d\u0259y\u0259r: g\xF6zl\u0259nil\u0259n ${util.stringifyPrimitive(issue.values[0])}`;
            return `Yanl\u0131\u015F se\xE7im: a\u015Fa\u011F\u0131dak\u0131lardan biri olmal\u0131d\u0131r: ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\xC7ox b\xF6y\xFCk: g\xF6zl\u0259nil\u0259n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
            return `\xC7ox b\xF6y\xFCk: g\xF6zl\u0259nil\u0259n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\xC7ox ki\xE7ik: g\xF6zl\u0259nil\u0259n ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            return `\xC7ox ki\xE7ik: g\xF6zl\u0259nil\u0259n ${issue.origin} ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Yanl\u0131\u015F m\u0259tn: "${_issue.prefix}" il\u0259 ba\u015Flamal\u0131d\u0131r`;
            if (_issue.format === "ends_with")
              return `Yanl\u0131\u015F m\u0259tn: "${_issue.suffix}" il\u0259 bitm\u0259lidir`;
            if (_issue.format === "includes")
              return `Yanl\u0131\u015F m\u0259tn: "${_issue.includes}" daxil olmal\u0131d\u0131r`;
            if (_issue.format === "regex")
              return `Yanl\u0131\u015F m\u0259tn: ${_issue.pattern} \u015Fablonuna uy\u011Fun olmal\u0131d\u0131r`;
            return `Yanl\u0131\u015F ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Yanl\u0131\u015F \u0259d\u0259d: ${issue.divisor} il\u0259 b\xF6l\xFCn\u0259 bil\u0259n olmal\u0131d\u0131r`;
          case "unrecognized_keys":
            return `Tan\u0131nmayan a\xE7ar${issue.keys.length > 1 ? "lar" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `${issue.origin} daxilind\u0259 yanl\u0131\u015F a\xE7ar`;
          case "invalid_union":
            return "Yanl\u0131\u015F d\u0259y\u0259r";
          case "invalid_element":
            return `${issue.origin} daxilind\u0259 yanl\u0131\u015F d\u0259y\u0259r`;
          default:
            return `Yanl\u0131\u015F d\u0259y\u0259r`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/be.cjs
var require_be = __commonJS({
  "../../node_modules/zod/v4/locales/be.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    function getBelarusianPlural(count, one, few, many) {
      const absCount = Math.abs(count);
      const lastDigit = absCount % 10;
      const lastTwoDigits = absCount % 100;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return many;
      }
      if (lastDigit === 1) {
        return one;
      }
      if (lastDigit >= 2 && lastDigit <= 4) {
        return few;
      }
      return many;
    }
    var error = () => {
      const Sizable = {
        string: {
          unit: {
            one: "\u0441\u0456\u043C\u0432\u0430\u043B",
            few: "\u0441\u0456\u043C\u0432\u0430\u043B\u044B",
            many: "\u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E"
          },
          verb: "\u043C\u0435\u0446\u044C"
        },
        array: {
          unit: {
            one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
            few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
            many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
          },
          verb: "\u043C\u0435\u0446\u044C"
        },
        set: {
          unit: {
            one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
            few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
            many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
          },
          verb: "\u043C\u0435\u0446\u044C"
        },
        file: {
          unit: {
            one: "\u0431\u0430\u0439\u0442",
            few: "\u0431\u0430\u0439\u0442\u044B",
            many: "\u0431\u0430\u0439\u0442\u0430\u045E"
          },
          verb: "\u043C\u0435\u0446\u044C"
        }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u043B\u0456\u043A";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u043C\u0430\u0441\u0456\u045E";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0443\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0430\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0456 \u0447\u0430\u0441",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0447\u0430\u0441",
        duration: "ISO \u043F\u0440\u0430\u0446\u044F\u0433\u043B\u0430\u0441\u0446\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0430\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0430\u0441",
        cidrv4: "IPv4 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64",
        base64url: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64url",
        json_string: "JSON \u0440\u0430\u0434\u043E\u043A",
        e164: "\u043D\u0443\u043C\u0430\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0443\u0432\u043E\u0434"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434: \u0447\u0430\u043A\u0430\u045E\u0441\u044F ${issue.expected}, \u0430\u0442\u0440\u044B\u043C\u0430\u043D\u0430 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434: \u0447\u0430\u043A\u0430\u043B\u0430\u0441\u044F ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0432\u0430\u0440\u044B\u044F\u043D\u0442: \u0447\u0430\u043A\u0430\u045E\u0441\u044F \u0430\u0434\u0437\u0456\u043D \u0437 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              const maxValue = Number(issue.maximum);
              const unit = getBelarusianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
              return `\u0417\u0430\u043D\u0430\u0434\u0442\u0430 \u0432\u044F\u043B\u0456\u043A\u0456: \u0447\u0430\u043A\u0430\u043B\u0430\u0441\u044F, \u0448\u0442\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u043F\u0430\u0432\u0456\u043D\u043D\u0430 ${sizing.verb} ${adj}${issue.maximum.toString()} ${unit}`;
            }
            return `\u0417\u0430\u043D\u0430\u0434\u0442\u0430 \u0432\u044F\u043B\u0456\u043A\u0456: \u0447\u0430\u043A\u0430\u043B\u0430\u0441\u044F, \u0448\u0442\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u0431\u044B\u0446\u044C ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              const minValue = Number(issue.minimum);
              const unit = getBelarusianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
              return `\u0417\u0430\u043D\u0430\u0434\u0442\u0430 \u043C\u0430\u043B\u044B: \u0447\u0430\u043A\u0430\u043B\u0430\u0441\u044F, \u0448\u0442\u043E ${issue.origin} \u043F\u0430\u0432\u0456\u043D\u043D\u0430 ${sizing.verb} ${adj}${issue.minimum.toString()} ${unit}`;
            }
            return `\u0417\u0430\u043D\u0430\u0434\u0442\u0430 \u043C\u0430\u043B\u044B: \u0447\u0430\u043A\u0430\u043B\u0430\u0441\u044F, \u0448\u0442\u043E ${issue.origin} \u043F\u0430\u0432\u0456\u043D\u043D\u0430 \u0431\u044B\u0446\u044C ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0440\u0430\u0434\u043E\u043A: \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u043F\u0430\u0447\u044B\u043D\u0430\u0446\u0446\u0430 \u0437 "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0440\u0430\u0434\u043E\u043A: \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0437\u0430\u043A\u0430\u043D\u0447\u0432\u0430\u0446\u0446\u0430 \u043D\u0430 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0440\u0430\u0434\u043E\u043A: \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0437\u043C\u044F\u0448\u0447\u0430\u0446\u044C "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u0440\u0430\u0434\u043E\u043A: \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0430\u0434\u043F\u0430\u0432\u044F\u0434\u0430\u0446\u044C \u0448\u0430\u0431\u043B\u043E\u043D\u0443 ${_issue.pattern}`;
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u043B\u0456\u043A: \u043F\u0430\u0432\u0456\u043D\u0435\u043D \u0431\u044B\u0446\u044C \u043A\u0440\u0430\u0442\u043D\u044B\u043C ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u041D\u0435\u0440\u0430\u0441\u043F\u0430\u0437\u043D\u0430\u043D\u044B ${issue.keys.length > 1 ? "\u043A\u043B\u044E\u0447\u044B" : "\u043A\u043B\u044E\u0447"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u043A\u043B\u044E\u0447 \u0443 ${issue.origin}`;
          case "invalid_union":
            return "\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434";
          case "invalid_element":
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u0430\u0435 \u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435 \u045E ${issue.origin}`;
          default:
            return `\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ca.cjs
var require_ca = __commonJS({
  "../../node_modules/zod/v4/locales/ca.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "car\xE0cters", verb: "contenir" },
        file: { unit: "bytes", verb: "contenir" },
        array: { unit: "elements", verb: "contenir" },
        set: { unit: "elements", verb: "contenir" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "entrada",
        email: "adre\xE7a electr\xF2nica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adre\xE7a IPv4",
        ipv6: "adre\xE7a IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "n\xFAmero E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Tipus inv\xE0lid: s'esperava ${issue.expected}, s'ha rebut ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Valor inv\xE0lid: s'esperava ${util.stringifyPrimitive(issue.values[0])}`;
            return `Opci\xF3 inv\xE0lida: s'esperava una de ${util.joinValues(issue.values, " o ")}`;
          case "too_big": {
            const adj = issue.inclusive ? "com a m\xE0xim" : "menys de";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} contingu\xE9s ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
            return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} fos ${adj} ${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? "com a m\xEDnim" : "m\xE9s de";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Massa petit: s'esperava que ${issue.origin} contingu\xE9s ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Massa petit: s'esperava que ${issue.origin} fos ${adj} ${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Format inv\xE0lid: ha de comen\xE7ar amb "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `Format inv\xE0lid: ha d'acabar amb "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Format inv\xE0lid: ha d'incloure "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Format inv\xE0lid: ha de coincidir amb el patr\xF3 ${_issue.pattern}`;
            return `Format inv\xE0lid per a ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `N\xFAmero inv\xE0lid: ha de ser m\xFAltiple de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Clau${issue.keys.length > 1 ? "s" : ""} no reconeguda${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Clau inv\xE0lida a ${issue.origin}`;
          case "invalid_union":
            return "Entrada inv\xE0lida";
          case "invalid_element":
            return `Element inv\xE0lid a ${issue.origin}`;
          default:
            return `Entrada inv\xE0lida`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/cs.cjs
var require_cs = __commonJS({
  "../../node_modules/zod/v4/locales/cs.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "znak\u016F", verb: "m\xEDt" },
        file: { unit: "bajt\u016F", verb: "m\xEDt" },
        array: { unit: "prvk\u016F", verb: "m\xEDt" },
        set: { unit: "prvk\u016F", verb: "m\xEDt" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u010D\xEDslo";
          }
          case "string": {
            return "\u0159et\u011Bzec";
          }
          case "boolean": {
            return "boolean";
          }
          case "bigint": {
            return "bigint";
          }
          case "function": {
            return "funkce";
          }
          case "symbol": {
            return "symbol";
          }
          case "undefined": {
            return "undefined";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "pole";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "regul\xE1rn\xED v\xFDraz",
        email: "e-mailov\xE1 adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a \u010Das ve form\xE1tu ISO",
        date: "datum ve form\xE1tu ISO",
        time: "\u010Das ve form\xE1tu ISO",
        duration: "doba trv\xE1n\xED ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "\u0159et\u011Bzec zak\xF3dovan\xFD ve form\xE1tu base64",
        base64url: "\u0159et\u011Bzec zak\xF3dovan\xFD ve form\xE1tu base64url",
        json_string: "\u0159et\u011Bzec ve form\xE1tu JSON",
        e164: "\u010D\xEDslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Neplatn\xFD vstup: o\u010Dek\xE1v\xE1no ${issue.expected}, obdr\u017Eeno ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Neplatn\xFD vstup: o\u010Dek\xE1v\xE1no ${util.stringifyPrimitive(issue.values[0])}`;
            return `Neplatn\xE1 mo\u017Enost: o\u010Dek\xE1v\xE1na jedna z hodnot ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Hodnota je p\u0159\xEDli\u0161 velk\xE1: ${issue.origin ?? "hodnota"} mus\xED m\xEDt ${adj}${issue.maximum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
            }
            return `Hodnota je p\u0159\xEDli\u0161 velk\xE1: ${issue.origin ?? "hodnota"} mus\xED b\xFDt ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Hodnota je p\u0159\xEDli\u0161 mal\xE1: ${issue.origin ?? "hodnota"} mus\xED m\xEDt ${adj}${issue.minimum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
            }
            return `Hodnota je p\u0159\xEDli\u0161 mal\xE1: ${issue.origin ?? "hodnota"} mus\xED b\xFDt ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Neplatn\xFD \u0159et\u011Bzec: mus\xED za\u010D\xEDnat na "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Neplatn\xFD \u0159et\u011Bzec: mus\xED kon\u010Dit na "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Neplatn\xFD \u0159et\u011Bzec: mus\xED obsahovat "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Neplatn\xFD \u0159et\u011Bzec: mus\xED odpov\xEDdat vzoru ${_issue.pattern}`;
            return `Neplatn\xFD form\xE1t ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Neplatn\xE9 \u010D\xEDslo: mus\xED b\xFDt n\xE1sobkem ${issue.divisor}`;
          case "unrecognized_keys":
            return `Nezn\xE1m\xE9 kl\xED\u010De: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Neplatn\xFD kl\xED\u010D v ${issue.origin}`;
          case "invalid_union":
            return "Neplatn\xFD vstup";
          case "invalid_element":
            return `Neplatn\xE1 hodnota v ${issue.origin}`;
          default:
            return `Neplatn\xFD vstup`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/de.cjs
var require_de = __commonJS({
  "../../node_modules/zod/v4/locales/de.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "Zeichen", verb: "zu haben" },
        file: { unit: "Bytes", verb: "zu haben" },
        array: { unit: "Elemente", verb: "zu haben" },
        set: { unit: "Elemente", verb: "zu haben" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "Zahl";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "Array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Ung\xFCltige Eingabe: erwartet ${issue.expected}, erhalten ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Ung\xFCltige Eingabe: erwartet ${util.stringifyPrimitive(issue.values[0])}`;
            return `Ung\xFCltige Option: erwartet eine von ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Zu gro\xDF: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "Elemente"} hat`;
            return `Zu gro\xDF: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ist`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} hat`;
            }
            return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ist`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Ung\xFCltiger String: muss mit "${_issue.prefix}" beginnen`;
            if (_issue.format === "ends_with")
              return `Ung\xFCltiger String: muss mit "${_issue.suffix}" enden`;
            if (_issue.format === "includes")
              return `Ung\xFCltiger String: muss "${_issue.includes}" enthalten`;
            if (_issue.format === "regex")
              return `Ung\xFCltiger String: muss dem Muster ${_issue.pattern} entsprechen`;
            return `Ung\xFCltig: ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Ung\xFCltige Zahl: muss ein Vielfaches von ${issue.divisor} sein`;
          case "unrecognized_keys":
            return `${issue.keys.length > 1 ? "Unbekannte Schl\xFCssel" : "Unbekannter Schl\xFCssel"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Ung\xFCltiger Schl\xFCssel in ${issue.origin}`;
          case "invalid_union":
            return "Ung\xFCltige Eingabe";
          case "invalid_element":
            return `Ung\xFCltiger Wert in ${issue.origin}`;
          default:
            return `Ung\xFCltige Eingabe`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/en.cjs
var require_en = __commonJS({
  "../../node_modules/zod/v4/locales/en.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parsedType = void 0;
    exports.default = default_1;
    var util = __importStar(require_util());
    var parsedType = (data) => {
      const t = typeof data;
      switch (t) {
        case "number": {
          return Number.isNaN(data) ? "NaN" : "number";
        }
        case "object": {
          if (Array.isArray(data)) {
            return "array";
          }
          if (data === null) {
            return "null";
          }
          if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
            return data.constructor.name;
          }
        }
      }
      return t;
    };
    exports.parsedType = parsedType;
    var error = () => {
      const Sizable = {
        string: { unit: "characters", verb: "to have" },
        file: { unit: "bytes", verb: "to have" },
        array: { unit: "items", verb: "to have" },
        set: { unit: "items", verb: "to have" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const Nouns = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Invalid input: expected ${issue.expected}, received ${(0, exports.parsedType)(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Invalid input: expected ${util.stringifyPrimitive(issue.values[0])}`;
            return `Invalid option: expected one of ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
            return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Invalid string: must start with "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `Invalid string: must end with "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Invalid string: must include "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Invalid string: must match pattern ${_issue.pattern}`;
            return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Invalid number: must be a multiple of ${issue.divisor}`;
          case "unrecognized_keys":
            return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Invalid key in ${issue.origin}`;
          case "invalid_union":
            return "Invalid input";
          case "invalid_element":
            return `Invalid value in ${issue.origin}`;
          default:
            return `Invalid input`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/eo.cjs
var require_eo = __commonJS({
  "../../node_modules/zod/v4/locales/eo.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parsedType = void 0;
    exports.default = default_1;
    var util = __importStar(require_util());
    var parsedType = (data) => {
      const t = typeof data;
      switch (t) {
        case "number": {
          return Number.isNaN(data) ? "NaN" : "nombro";
        }
        case "object": {
          if (Array.isArray(data)) {
            return "tabelo";
          }
          if (data === null) {
            return "senvalora";
          }
          if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
            return data.constructor.name;
          }
        }
      }
      return t;
    };
    exports.parsedType = parsedType;
    var error = () => {
      const Sizable = {
        string: { unit: "karaktrojn", verb: "havi" },
        file: { unit: "bajtojn", verb: "havi" },
        array: { unit: "elementojn", verb: "havi" },
        set: { unit: "elementojn", verb: "havi" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const Nouns = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emo\u011Dio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-da\u016Dro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Nevalida enigo: atendi\u011Dis ${issue.expected}, ricevi\u011Dis ${(0, exports.parsedType)(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Nevalida enigo: atendi\u011Dis ${util.stringifyPrimitive(issue.values[0])}`;
            return `Nevalida opcio: atendi\u011Dis unu el ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Tro granda: atendi\u011Dis ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementojn"}`;
            return `Tro granda: atendi\u011Dis ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Tro malgranda: atendi\u011Dis ke ${issue.origin} havu ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Tro malgranda: atendi\u011Dis ke ${issue.origin} estu ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Nevalida karaktraro: devas komenci\u011Di per "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Nevalida karaktraro: devas fini\u011Di per "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Nevalida karaktraro: devas inkluzivi "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Nevalida karaktraro: devas kongrui kun la modelo ${_issue.pattern}`;
            return `Nevalida ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Nevalida nombro: devas esti oblo de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Nekonata${issue.keys.length > 1 ? "j" : ""} \u015Dlosilo${issue.keys.length > 1 ? "j" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Nevalida \u015Dlosilo en ${issue.origin}`;
          case "invalid_union":
            return "Nevalida enigo";
          case "invalid_element":
            return `Nevalida valoro en ${issue.origin}`;
          default:
            return `Nevalida enigo`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/es.cjs
var require_es = __commonJS({
  "../../node_modules/zod/v4/locales/es.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "caracteres", verb: "tener" },
        file: { unit: "bytes", verb: "tener" },
        array: { unit: "elementos", verb: "tener" },
        set: { unit: "elementos", verb: "tener" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "n\xFAmero";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "arreglo";
            }
            if (data === null) {
              return "nulo";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "entrada",
        email: "direcci\xF3n de correo electr\xF3nico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duraci\xF3n ISO",
        ipv4: "direcci\xF3n IPv4",
        ipv6: "direcci\xF3n IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "n\xFAmero E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Entrada inv\xE1lida: se esperaba ${issue.expected}, recibido ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Entrada inv\xE1lida: se esperaba ${util.stringifyPrimitive(issue.values[0])}`;
            return `Opci\xF3n inv\xE1lida: se esperaba una de ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Demasiado grande: se esperaba que ${issue.origin ?? "valor"} tuviera ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
            return `Demasiado grande: se esperaba que ${issue.origin ?? "valor"} fuera ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Demasiado peque\xF1o: se esperaba que ${issue.origin} tuviera ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Demasiado peque\xF1o: se esperaba que ${issue.origin} fuera ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Cadena inv\xE1lida: debe comenzar con "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Cadena inv\xE1lida: debe terminar en "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Cadena inv\xE1lida: debe incluir "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Cadena inv\xE1lida: debe coincidir con el patr\xF3n ${_issue.pattern}`;
            return `Inv\xE1lido ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `N\xFAmero inv\xE1lido: debe ser m\xFAltiplo de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Llave${issue.keys.length > 1 ? "s" : ""} desconocida${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Llave inv\xE1lida en ${issue.origin}`;
          case "invalid_union":
            return "Entrada inv\xE1lida";
          case "invalid_element":
            return `Valor inv\xE1lido en ${issue.origin}`;
          default:
            return `Entrada inv\xE1lida`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/fa.cjs
var require_fa = __commonJS({
  "../../node_modules/zod/v4/locales/fa.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u06A9\u0627\u0631\u0627\u06A9\u062A\u0631", verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F" },
        file: { unit: "\u0628\u0627\u06CC\u062A", verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F" },
        array: { unit: "\u0622\u06CC\u062A\u0645", verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F" },
        set: { unit: "\u0622\u06CC\u062A\u0645", verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0639\u062F\u062F";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u0622\u0631\u0627\u06CC\u0647";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0648\u0631\u0648\u062F\u06CC",
        email: "\u0622\u062F\u0631\u0633 \u0627\u06CC\u0645\u06CC\u0644",
        url: "URL",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        date: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u0632\u0648",
        time: "\u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        duration: "\u0645\u062F\u062A \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        ipv4: "IPv4 \u0622\u062F\u0631\u0633",
        ipv6: "IPv6 \u0622\u062F\u0631\u0633",
        cidrv4: "IPv4 \u062F\u0627\u0645\u0646\u0647",
        cidrv6: "IPv6 \u062F\u0627\u0645\u0646\u0647",
        base64: "base64-encoded \u0631\u0634\u062A\u0647",
        base64url: "base64url-encoded \u0631\u0634\u062A\u0647",
        json_string: "JSON \u0631\u0634\u062A\u0647",
        e164: "E.164 \u0639\u062F\u062F",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u06CC"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0648\u0631\u0648\u062F\u06CC \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0645\u06CC\u200C\u0628\u0627\u06CC\u0633\u062A ${issue.expected} \u0645\u06CC\u200C\u0628\u0648\u062F\u060C ${parsedType(issue.input)} \u062F\u0631\u06CC\u0627\u0641\u062A \u0634\u062F`;
          case "invalid_value":
            if (issue.values.length === 1) {
              return `\u0648\u0631\u0648\u062F\u06CC \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0645\u06CC\u200C\u0628\u0627\u06CC\u0633\u062A ${util.stringifyPrimitive(issue.values[0])} \u0645\u06CC\u200C\u0628\u0648\u062F`;
            }
            return `\u06AF\u0632\u06CC\u0646\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0645\u06CC\u200C\u0628\u0627\u06CC\u0633\u062A \u06CC\u06A9\u06CC \u0627\u0632 ${util.joinValues(issue.values, "|")} \u0645\u06CC\u200C\u0628\u0648\u062F`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u062E\u06CC\u0644\u06CC \u0628\u0632\u0631\u06AF: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u0628\u0627\u06CC\u062F ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"} \u0628\u0627\u0634\u062F`;
            }
            return `\u062E\u06CC\u0644\u06CC \u0628\u0632\u0631\u06AF: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u0628\u0627\u06CC\u062F ${adj}${issue.maximum.toString()} \u0628\u0627\u0634\u062F`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u062E\u06CC\u0644\u06CC \u06A9\u0648\u0686\u06A9: ${issue.origin} \u0628\u0627\u06CC\u062F ${adj}${issue.minimum.toString()} ${sizing.unit} \u0628\u0627\u0634\u062F`;
            }
            return `\u062E\u06CC\u0644\u06CC \u06A9\u0648\u0686\u06A9: ${issue.origin} \u0628\u0627\u06CC\u062F ${adj}${issue.minimum.toString()} \u0628\u0627\u0634\u062F`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u0631\u0634\u062A\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0628\u0627\u06CC\u062F \u0628\u0627 "${_issue.prefix}" \u0634\u0631\u0648\u0639 \u0634\u0648\u062F`;
            }
            if (_issue.format === "ends_with") {
              return `\u0631\u0634\u062A\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0628\u0627\u06CC\u062F \u0628\u0627 "${_issue.suffix}" \u062A\u0645\u0627\u0645 \u0634\u0648\u062F`;
            }
            if (_issue.format === "includes") {
              return `\u0631\u0634\u062A\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0628\u0627\u06CC\u062F \u0634\u0627\u0645\u0644 "${_issue.includes}" \u0628\u0627\u0634\u062F`;
            }
            if (_issue.format === "regex") {
              return `\u0631\u0634\u062A\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0628\u0627\u06CC\u062F \u0628\u0627 \u0627\u0644\u06AF\u0648\u06CC ${_issue.pattern} \u0645\u0637\u0627\u0628\u0642\u062A \u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F`;
            }
            return `${Nouns[_issue.format] ?? issue.format} \u0646\u0627\u0645\u0639\u062A\u0628\u0631`;
          }
          case "not_multiple_of":
            return `\u0639\u062F\u062F \u0646\u0627\u0645\u0639\u062A\u0628\u0631: \u0628\u0627\u06CC\u062F \u0645\u0636\u0631\u0628 ${issue.divisor} \u0628\u0627\u0634\u062F`;
          case "unrecognized_keys":
            return `\u06A9\u0644\u06CC\u062F${issue.keys.length > 1 ? "\u0647\u0627\u06CC" : ""} \u0646\u0627\u0634\u0646\u0627\u0633: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u06A9\u0644\u06CC\u062F \u0646\u0627\u0634\u0646\u0627\u0633 \u062F\u0631 ${issue.origin}`;
          case "invalid_union":
            return `\u0648\u0631\u0648\u062F\u06CC \u0646\u0627\u0645\u0639\u062A\u0628\u0631`;
          case "invalid_element":
            return `\u0645\u0642\u062F\u0627\u0631 \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u062F\u0631 ${issue.origin}`;
          default:
            return `\u0648\u0631\u0648\u062F\u06CC \u0646\u0627\u0645\u0639\u062A\u0628\u0631`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/fi.cjs
var require_fi = __commonJS({
  "../../node_modules/zod/v4/locales/fi.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "merkki\xE4", subject: "merkkijonon" },
        file: { unit: "tavua", subject: "tiedoston" },
        array: { unit: "alkiota", subject: "listan" },
        set: { unit: "alkiota", subject: "joukon" },
        number: { unit: "", subject: "luvun" },
        bigint: { unit: "", subject: "suuren kokonaisluvun" },
        int: { unit: "", subject: "kokonaisluvun" },
        date: { unit: "", subject: "p\xE4iv\xE4m\xE4\xE4r\xE4n" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "s\xE4\xE4nn\xF6llinen lauseke",
        email: "s\xE4hk\xF6postiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-p\xE4iv\xE4m\xE4\xE4r\xE4",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Virheellinen tyyppi: odotettiin ${issue.expected}, oli ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Virheellinen sy\xF6te: t\xE4ytyy olla ${util.stringifyPrimitive(issue.values[0])}`;
            return `Virheellinen valinta: t\xE4ytyy olla yksi seuraavista: ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Liian suuri: ${sizing.subject} t\xE4ytyy olla ${adj}${issue.maximum.toString()} ${sizing.unit}`.trim();
            }
            return `Liian suuri: arvon t\xE4ytyy olla ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Liian pieni: ${sizing.subject} t\xE4ytyy olla ${adj}${issue.minimum.toString()} ${sizing.unit}`.trim();
            }
            return `Liian pieni: arvon t\xE4ytyy olla ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Virheellinen sy\xF6te: t\xE4ytyy alkaa "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Virheellinen sy\xF6te: t\xE4ytyy loppua "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Virheellinen sy\xF6te: t\xE4ytyy sis\xE4lt\xE4\xE4 "${_issue.includes}"`;
            if (_issue.format === "regex") {
              return `Virheellinen sy\xF6te: t\xE4ytyy vastata s\xE4\xE4nn\xF6llist\xE4 lauseketta ${_issue.pattern}`;
            }
            return `Virheellinen ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Virheellinen luku: t\xE4ytyy olla luvun ${issue.divisor} monikerta`;
          case "unrecognized_keys":
            return `${issue.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return "Virheellinen avain tietueessa";
          case "invalid_union":
            return "Virheellinen unioni";
          case "invalid_element":
            return "Virheellinen arvo joukossa";
          default:
            return `Virheellinen sy\xF6te`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/fr.cjs
var require_fr = __commonJS({
  "../../node_modules/zod/v4/locales/fr.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "caract\xE8res", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "\xE9l\xE9ments", verb: "avoir" },
        set: { unit: "\xE9l\xE9ments", verb: "avoir" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "nombre";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "tableau";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "entr\xE9e",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xE9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xEEne encod\xE9e en base64",
        base64url: "cha\xEEne encod\xE9e en base64url",
        json_string: "cha\xEEne JSON",
        e164: "num\xE9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xE9e"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Entr\xE9e invalide : ${issue.expected} attendu, ${parsedType(issue.input)} re\xE7u`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Entr\xE9e invalide : ${util.stringifyPrimitive(issue.values[0])} attendu`;
            return `Option invalide : une valeur parmi ${util.joinValues(issue.values, "|")} attendue`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Trop grand : ${issue.origin ?? "valeur"} doit ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xE9l\xE9ment(s)"}`;
            return `Trop grand : ${issue.origin ?? "valeur"} doit \xEAtre ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Trop petit : ${issue.origin} doit ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Trop petit : ${issue.origin} doit \xEAtre ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Cha\xEEne invalide : doit commencer par "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Cha\xEEne invalide : doit se terminer par "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Cha\xEEne invalide : doit inclure "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Cha\xEEne invalide : doit correspondre au mod\xE8le ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit \xEAtre un multiple de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Cl\xE9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Cl\xE9 invalide dans ${issue.origin}`;
          case "invalid_union":
            return "Entr\xE9e invalide";
          case "invalid_element":
            return `Valeur invalide dans ${issue.origin}`;
          default:
            return `Entr\xE9e invalide`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/fr-CA.cjs
var require_fr_CA = __commonJS({
  "../../node_modules/zod/v4/locales/fr-CA.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "caract\xE8res", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "\xE9l\xE9ments", verb: "avoir" },
        set: { unit: "\xE9l\xE9ments", verb: "avoir" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "entr\xE9e",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xE9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xEEne encod\xE9e en base64",
        base64url: "cha\xEEne encod\xE9e en base64url",
        json_string: "cha\xEEne JSON",
        e164: "num\xE9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xE9e"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Entr\xE9e invalide : attendu ${issue.expected}, re\xE7u ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Entr\xE9e invalide : attendu ${util.stringifyPrimitive(issue.values[0])}`;
            return `Option invalide : attendu l'une des valeurs suivantes ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "\u2264" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Trop grand : attendu que ${issue.origin ?? "la valeur"} ait ${adj}${issue.maximum.toString()} ${sizing.unit}`;
            return `Trop grand : attendu que ${issue.origin ?? "la valeur"} soit ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? "\u2265" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Trop petit : attendu que ${issue.origin} ait ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Trop petit : attendu que ${issue.origin} soit ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Cha\xEEne invalide : doit commencer par "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `Cha\xEEne invalide : doit se terminer par "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Cha\xEEne invalide : doit inclure "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Cha\xEEne invalide : doit correspondre au motif ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit \xEAtre un multiple de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Cl\xE9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Cl\xE9 invalide dans ${issue.origin}`;
          case "invalid_union":
            return "Entr\xE9e invalide";
          case "invalid_element":
            return `Valeur invalide dans ${issue.origin}`;
          default:
            return `Entr\xE9e invalide`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/he.cjs
var require_he = __commonJS({
  "../../node_modules/zod/v4/locales/he.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u05D0\u05D5\u05EA\u05D9\u05D5\u05EA", verb: "\u05DC\u05DB\u05DC\u05D5\u05DC" },
        file: { unit: "\u05D1\u05D9\u05D9\u05D8\u05D9\u05DD", verb: "\u05DC\u05DB\u05DC\u05D5\u05DC" },
        array: { unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD", verb: "\u05DC\u05DB\u05DC\u05D5\u05DC" },
        set: { unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD", verb: "\u05DC\u05DB\u05DC\u05D5\u05DC" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u05E7\u05DC\u05D8",
        email: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
        url: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05E8\u05E9\u05EA",
        emoji: "\u05D0\u05D9\u05DE\u05D5\u05D2'\u05D9",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05D6\u05DE\u05DF ISO",
        date: "\u05EA\u05D0\u05E8\u05D9\u05DA ISO",
        time: "\u05D6\u05DE\u05DF ISO",
        duration: "\u05DE\u05E9\u05DA \u05D6\u05DE\u05DF ISO",
        ipv4: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv4",
        ipv6: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv6",
        cidrv4: "\u05D8\u05D5\u05D5\u05D7 IPv4",
        cidrv6: "\u05D8\u05D5\u05D5\u05D7 IPv6",
        base64: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64",
        base64url: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64 \u05DC\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E8\u05E9\u05EA",
        json_string: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA JSON",
        e164: "\u05DE\u05E1\u05E4\u05E8 E.164",
        jwt: "JWT",
        template_literal: "\u05E7\u05DC\u05D8"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF: \u05E6\u05E8\u05D9\u05DA ${issue.expected}, \u05D4\u05EA\u05E7\u05D1\u05DC ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF: \u05E6\u05E8\u05D9\u05DA ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF: \u05E6\u05E8\u05D9\u05DA \u05D0\u05D7\u05EA \u05DE\u05D4\u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA  ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u05D2\u05D3\u05D5\u05DC \u05DE\u05D3\u05D9: ${issue.origin ?? "value"} \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
            return `\u05D2\u05D3\u05D5\u05DC \u05DE\u05D3\u05D9: ${issue.origin ?? "value"} \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u05E7\u05D8\u05DF \u05DE\u05D3\u05D9: ${issue.origin} \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u05E7\u05D8\u05DF \u05DE\u05D3\u05D9: ${issue.origin} \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05E0\u05D4: \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1"${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05E0\u05D4: \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05E1\u05EA\u05D9\u05D9\u05DD \u05D1 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05E0\u05D4: \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05DB\u05DC\u05D5\u05DC "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05E0\u05D4: \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05EA\u05D0\u05D9\u05DD \u05DC\u05EA\u05D1\u05E0\u05D9\u05EA ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF`;
          }
          case "not_multiple_of":
            return `\u05DE\u05E1\u05E4\u05E8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF: \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05DB\u05E4\u05DC\u05D4 \u05E9\u05DC ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u05DE\u05E4\u05EA\u05D7${issue.keys.length > 1 ? "\u05D5\u05EA" : ""} \u05DC\u05D0 \u05DE\u05D6\u05D5\u05D4${issue.keys.length > 1 ? "\u05D9\u05DD" : "\u05D4"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u05DE\u05E4\u05EA\u05D7 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF \u05D1${issue.origin}`;
          case "invalid_union":
            return "\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF";
          case "invalid_element":
            return `\u05E2\u05E8\u05DA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF \u05D1${issue.origin}`;
          default:
            return `\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/hu.cjs
var require_hu = __commonJS({
  "../../node_modules/zod/v4/locales/hu.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "karakter", verb: "legyen" },
        file: { unit: "byte", verb: "legyen" },
        array: { unit: "elem", verb: "legyen" },
        set: { unit: "elem", verb: "legyen" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "sz\xE1m";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "t\xF6mb";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "bemenet",
        email: "email c\xEDm",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO id\u0151b\xE9lyeg",
        date: "ISO d\xE1tum",
        time: "ISO id\u0151",
        duration: "ISO id\u0151intervallum",
        ipv4: "IPv4 c\xEDm",
        ipv6: "IPv6 c\xEDm",
        cidrv4: "IPv4 tartom\xE1ny",
        cidrv6: "IPv6 tartom\xE1ny",
        base64: "base64-k\xF3dolt string",
        base64url: "base64url-k\xF3dolt string",
        json_string: "JSON string",
        e164: "E.164 sz\xE1m",
        jwt: "JWT",
        template_literal: "bemenet"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\xC9rv\xE9nytelen bemenet: a v\xE1rt \xE9rt\xE9k ${issue.expected}, a kapott \xE9rt\xE9k ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\xC9rv\xE9nytelen bemenet: a v\xE1rt \xE9rt\xE9k ${util.stringifyPrimitive(issue.values[0])}`;
            return `\xC9rv\xE9nytelen opci\xF3: valamelyik \xE9rt\xE9k v\xE1rt ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `T\xFAl nagy: ${issue.origin ?? "\xE9rt\xE9k"} m\xE9rete t\xFAl nagy ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elem"}`;
            return `T\xFAl nagy: a bemeneti \xE9rt\xE9k ${issue.origin ?? "\xE9rt\xE9k"} t\xFAl nagy: ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `T\xFAl kicsi: a bemeneti \xE9rt\xE9k ${issue.origin} m\xE9rete t\xFAl kicsi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `T\xFAl kicsi: a bemeneti \xE9rt\xE9k ${issue.origin} t\xFAl kicsi ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\xC9rv\xE9nytelen string: "${_issue.prefix}" \xE9rt\xE9kkel kell kezd\u0151dnie`;
            if (_issue.format === "ends_with")
              return `\xC9rv\xE9nytelen string: "${_issue.suffix}" \xE9rt\xE9kkel kell v\xE9gz\u0151dnie`;
            if (_issue.format === "includes")
              return `\xC9rv\xE9nytelen string: "${_issue.includes}" \xE9rt\xE9ket kell tartalmaznia`;
            if (_issue.format === "regex")
              return `\xC9rv\xE9nytelen string: ${_issue.pattern} mint\xE1nak kell megfelelnie`;
            return `\xC9rv\xE9nytelen ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\xC9rv\xE9nytelen sz\xE1m: ${issue.divisor} t\xF6bbsz\xF6r\xF6s\xE9nek kell lennie`;
          case "unrecognized_keys":
            return `Ismeretlen kulcs${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\xC9rv\xE9nytelen kulcs ${issue.origin}`;
          case "invalid_union":
            return "\xC9rv\xE9nytelen bemenet";
          case "invalid_element":
            return `\xC9rv\xE9nytelen \xE9rt\xE9k: ${issue.origin}`;
          default:
            return `\xC9rv\xE9nytelen bemenet`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/id.cjs
var require_id = __commonJS({
  "../../node_modules/zod/v4/locales/id.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "karakter", verb: "memiliki" },
        file: { unit: "byte", verb: "memiliki" },
        array: { unit: "item", verb: "memiliki" },
        set: { unit: "item", verb: "memiliki" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Input tidak valid: diharapkan ${issue.expected}, diterima ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Input tidak valid: diharapkan ${util.stringifyPrimitive(issue.values[0])}`;
            return `Pilihan tidak valid: diharapkan salah satu dari ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Terlalu besar: diharapkan ${issue.origin ?? "value"} memiliki ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
            return `Terlalu besar: diharapkan ${issue.origin ?? "value"} menjadi ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Terlalu kecil: diharapkan ${issue.origin} memiliki ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Terlalu kecil: diharapkan ${issue.origin} menjadi ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `String tidak valid: harus dimulai dengan "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `String tidak valid: harus berakhir dengan "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `String tidak valid: harus menyertakan "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `String tidak valid: harus sesuai pola ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} tidak valid`;
          }
          case "not_multiple_of":
            return `Angka tidak valid: harus kelipatan dari ${issue.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali ${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak valid di ${issue.origin}`;
          case "invalid_union":
            return "Input tidak valid";
          case "invalid_element":
            return `Nilai tidak valid di ${issue.origin}`;
          default:
            return `Input tidak valid`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/it.cjs
var require_it = __commonJS({
  "../../node_modules/zod/v4/locales/it.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "caratteri", verb: "avere" },
        file: { unit: "byte", verb: "avere" },
        array: { unit: "elementi", verb: "avere" },
        set: { unit: "elementi", verb: "avere" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "numero";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "vettore";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Input non valido: atteso ${issue.expected}, ricevuto ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Input non valido: atteso ${util.stringifyPrimitive(issue.values[0])}`;
            return `Opzione non valida: atteso uno tra ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Troppo grande: ${issue.origin ?? "valore"} deve avere ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementi"}`;
            return `Troppo grande: ${issue.origin ?? "valore"} deve essere ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Troppo piccolo: ${issue.origin} deve avere ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Troppo piccolo: ${issue.origin} deve essere ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Stringa non valida: deve iniziare con "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Stringa non valida: deve terminare con "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Stringa non valida: deve includere "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Stringa non valida: deve corrispondere al pattern ${_issue.pattern}`;
            return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Numero non valido: deve essere un multiplo di ${issue.divisor}`;
          case "unrecognized_keys":
            return `Chiav${issue.keys.length > 1 ? "i" : "e"} non riconosciut${issue.keys.length > 1 ? "e" : "a"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Chiave non valida in ${issue.origin}`;
          case "invalid_union":
            return "Input non valido";
          case "invalid_element":
            return `Valore non valido in ${issue.origin}`;
          default:
            return `Input non valido`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ja.cjs
var require_ja = __commonJS({
  "../../node_modules/zod/v4/locales/ja.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u6587\u5B57", verb: "\u3067\u3042\u308B" },
        file: { unit: "\u30D0\u30A4\u30C8", verb: "\u3067\u3042\u308B" },
        array: { unit: "\u8981\u7D20", verb: "\u3067\u3042\u308B" },
        set: { unit: "\u8981\u7D20", verb: "\u3067\u3042\u308B" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u6570\u5024";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u914D\u5217";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u5165\u529B\u5024",
        email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        url: "URL",
        emoji: "\u7D75\u6587\u5B57",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u6642",
        date: "ISO\u65E5\u4ED8",
        time: "ISO\u6642\u523B",
        duration: "ISO\u671F\u9593",
        ipv4: "IPv4\u30A2\u30C9\u30EC\u30B9",
        ipv6: "IPv6\u30A2\u30C9\u30EC\u30B9",
        cidrv4: "IPv4\u7BC4\u56F2",
        cidrv6: "IPv6\u7BC4\u56F2",
        base64: "base64\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        base64url: "base64url\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        json_string: "JSON\u6587\u5B57\u5217",
        e164: "E.164\u756A\u53F7",
        jwt: "JWT",
        template_literal: "\u5165\u529B\u5024"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u7121\u52B9\u306A\u5165\u529B: ${issue.expected}\u304C\u671F\u5F85\u3055\u308C\u307E\u3057\u305F\u304C\u3001${parsedType(issue.input)}\u304C\u5165\u529B\u3055\u308C\u307E\u3057\u305F`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u7121\u52B9\u306A\u5165\u529B: ${util.stringifyPrimitive(issue.values[0])}\u304C\u671F\u5F85\u3055\u308C\u307E\u3057\u305F`;
            return `\u7121\u52B9\u306A\u9078\u629E: ${util.joinValues(issue.values, "\u3001")}\u306E\u3044\u305A\u308C\u304B\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
          case "too_big": {
            const adj = issue.inclusive ? "\u4EE5\u4E0B\u3067\u3042\u308B" : "\u3088\u308A\u5C0F\u3055\u3044";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u5927\u304D\u3059\u304E\u308B\u5024: ${issue.origin ?? "\u5024"}\u306F${issue.maximum.toString()}${sizing.unit ?? "\u8981\u7D20"}${adj}\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            return `\u5927\u304D\u3059\u304E\u308B\u5024: ${issue.origin ?? "\u5024"}\u306F${issue.maximum.toString()}${adj}\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
          }
          case "too_small": {
            const adj = issue.inclusive ? "\u4EE5\u4E0A\u3067\u3042\u308B" : "\u3088\u308A\u5927\u304D\u3044";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u5C0F\u3055\u3059\u304E\u308B\u5024: ${issue.origin}\u306F${issue.minimum.toString()}${sizing.unit}${adj}\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            return `\u5C0F\u3055\u3059\u304E\u308B\u5024: ${issue.origin}\u306F${issue.minimum.toString()}${adj}\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u7121\u52B9\u306A\u6587\u5B57\u5217: "${_issue.prefix}"\u3067\u59CB\u307E\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            if (_issue.format === "ends_with")
              return `\u7121\u52B9\u306A\u6587\u5B57\u5217: "${_issue.suffix}"\u3067\u7D42\u308F\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            if (_issue.format === "includes")
              return `\u7121\u52B9\u306A\u6587\u5B57\u5217: "${_issue.includes}"\u3092\u542B\u3080\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            if (_issue.format === "regex")
              return `\u7121\u52B9\u306A\u6587\u5B57\u5217: \u30D1\u30BF\u30FC\u30F3${_issue.pattern}\u306B\u4E00\u81F4\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
            return `\u7121\u52B9\u306A${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u7121\u52B9\u306A\u6570\u5024: ${issue.divisor}\u306E\u500D\u6570\u3067\u3042\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059`;
          case "unrecognized_keys":
            return `\u8A8D\u8B58\u3055\u308C\u3066\u3044\u306A\u3044\u30AD\u30FC${issue.keys.length > 1 ? "\u7FA4" : ""}: ${util.joinValues(issue.keys, "\u3001")}`;
          case "invalid_key":
            return `${issue.origin}\u5185\u306E\u7121\u52B9\u306A\u30AD\u30FC`;
          case "invalid_union":
            return "\u7121\u52B9\u306A\u5165\u529B";
          case "invalid_element":
            return `${issue.origin}\u5185\u306E\u7121\u52B9\u306A\u5024`;
          default:
            return `\u7121\u52B9\u306A\u5165\u529B`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/kh.cjs
var require_kh = __commonJS({
  "../../node_modules/zod/v4/locales/kh.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A", verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793" },
        file: { unit: "\u1794\u17C3", verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793" },
        array: { unit: "\u1792\u17B6\u178F\u17BB", verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793" },
        set: { unit: "\u1792\u17B6\u178F\u17BB", verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "\u1798\u17B7\u1793\u1798\u17C2\u1793\u1787\u17B6\u179B\u17C1\u1781 (NaN)" : "\u179B\u17C1\u1781";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u17A2\u17B6\u179A\u17C1 (Array)";
            }
            if (data === null) {
              return "\u1782\u17D2\u1798\u17B6\u1793\u178F\u1798\u17D2\u179B\u17C3 (null)";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B",
        email: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u17A2\u17CA\u17B8\u1798\u17C2\u179B",
        url: "URL",
        emoji: "\u179F\u1789\u17D2\u1789\u17B6\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 \u1793\u17B7\u1784\u1798\u17C9\u17C4\u1784 ISO",
        date: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 ISO",
        time: "\u1798\u17C9\u17C4\u1784 ISO",
        duration: "\u179A\u1799\u17C8\u1796\u17C1\u179B ISO",
        ipv4: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        ipv6: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        cidrv4: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        cidrv6: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        base64: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64",
        base64url: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64url",
        json_string: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A JSON",
        e164: "\u179B\u17C1\u1781 E.164",
        jwt: "JWT",
        template_literal: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${issue.expected} \u1794\u17C9\u17BB\u1793\u17D2\u178F\u17C2\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u1787\u1798\u17D2\u179A\u17BE\u179F\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1787\u17B6\u1798\u17BD\u1799\u1780\u17D2\u1793\u17BB\u1784\u1785\u17C6\u178E\u17C4\u1798 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u1792\u17C6\u1796\u17C1\u1780\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u1792\u17B6\u178F\u17BB"}`;
            return `\u1792\u17C6\u1796\u17C1\u1780\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u178F\u17BC\u1785\u1796\u17C1\u1780\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${issue.origin} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u178F\u17BC\u1785\u1796\u17C1\u1780\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A ${issue.origin} ${adj} ${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1785\u17B6\u1794\u17CB\u1795\u17D2\u178F\u17BE\u1798\u178A\u17C4\u1799 "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1794\u1789\u17D2\u1785\u1794\u17CB\u178A\u17C4\u1799 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u1798\u17B6\u1793 "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u178F\u17C2\u1795\u17D2\u1782\u17BC\u1795\u17D2\u1782\u1784\u1793\u17B9\u1784\u1791\u1798\u17D2\u179A\u1784\u17CB\u178A\u17C2\u179B\u1794\u17B6\u1793\u1780\u17C6\u178E\u178F\u17CB ${_issue.pattern}`;
            return `\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u179B\u17C1\u1781\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u17D6 \u178F\u17D2\u179A\u17BC\u179C\u178F\u17C2\u1787\u17B6\u1796\u17A0\u17BB\u1782\u17BB\u178E\u1793\u17C3 ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u179A\u1780\u1783\u17BE\u1789\u179F\u17C4\u1798\u17B7\u1793\u179F\u17D2\u1782\u17B6\u179B\u17CB\u17D6 ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u179F\u17C4\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u1793\u17C5\u1780\u17D2\u1793\u17BB\u1784 ${issue.origin}`;
          case "invalid_union":
            return `\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C`;
          case "invalid_element":
            return `\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C\u1793\u17C5\u1780\u17D2\u1793\u17BB\u1784 ${issue.origin}`;
          default:
            return `\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u178F\u17D2\u179A\u17BC\u179C`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ko.cjs
var require_ko = __commonJS({
  "../../node_modules/zod/v4/locales/ko.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\uBB38\uC790", verb: "to have" },
        file: { unit: "\uBC14\uC774\uD2B8", verb: "to have" },
        array: { unit: "\uAC1C", verb: "to have" },
        set: { unit: "\uAC1C", verb: "to have" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\uC785\uB825",
        email: "\uC774\uBA54\uC77C \uC8FC\uC18C",
        url: "URL",
        emoji: "\uC774\uBAA8\uC9C0",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \uB0A0\uC9DC\uC2DC\uAC04",
        date: "ISO \uB0A0\uC9DC",
        time: "ISO \uC2DC\uAC04",
        duration: "ISO \uAE30\uAC04",
        ipv4: "IPv4 \uC8FC\uC18C",
        ipv6: "IPv6 \uC8FC\uC18C",
        cidrv4: "IPv4 \uBC94\uC704",
        cidrv6: "IPv6 \uBC94\uC704",
        base64: "base64 \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        base64url: "base64url \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        json_string: "JSON \uBB38\uC790\uC5F4",
        e164: "E.164 \uBC88\uD638",
        jwt: "JWT",
        template_literal: "\uC785\uB825"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\uC798\uBABB\uB41C \uC785\uB825: \uC608\uC0C1 \uD0C0\uC785\uC740 ${issue.expected}, \uBC1B\uC740 \uD0C0\uC785\uC740 ${parsedType(issue.input)}\uC785\uB2C8\uB2E4`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\uC798\uBABB\uB41C \uC785\uB825: \uAC12\uC740 ${util.stringifyPrimitive(issue.values[0])} \uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4`;
            return `\uC798\uBABB\uB41C \uC635\uC158: ${util.joinValues(issue.values, "\uB610\uB294 ")} \uC911 \uD558\uB098\uC5EC\uC57C \uD569\uB2C8\uB2E4`;
          case "too_big": {
            const adj = issue.inclusive ? "\uC774\uD558" : "\uBBF8\uB9CC";
            const suffix = adj === "\uBBF8\uB9CC" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
            const sizing = getSizing(issue.origin);
            const unit = sizing?.unit ?? "\uC694\uC18C";
            if (sizing)
              return `${issue.origin ?? "\uAC12"}\uC774 \uB108\uBB34 \uD07D\uB2C8\uB2E4: ${issue.maximum.toString()}${unit} ${adj}${suffix}`;
            return `${issue.origin ?? "\uAC12"}\uC774 \uB108\uBB34 \uD07D\uB2C8\uB2E4: ${issue.maximum.toString()} ${adj}${suffix}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? "\uC774\uC0C1" : "\uCD08\uACFC";
            const suffix = adj === "\uC774\uC0C1" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
            const sizing = getSizing(issue.origin);
            const unit = sizing?.unit ?? "\uC694\uC18C";
            if (sizing) {
              return `${issue.origin ?? "\uAC12"}\uC774 \uB108\uBB34 \uC791\uC2B5\uB2C8\uB2E4: ${issue.minimum.toString()}${unit} ${adj}${suffix}`;
            }
            return `${issue.origin ?? "\uAC12"}\uC774 \uB108\uBB34 \uC791\uC2B5\uB2C8\uB2E4: ${issue.minimum.toString()} ${adj}${suffix}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\uC798\uBABB\uB41C \uBB38\uC790\uC5F4: "${_issue.prefix}"(\uC73C)\uB85C \uC2DC\uC791\uD574\uC57C \uD569\uB2C8\uB2E4`;
            }
            if (_issue.format === "ends_with")
              return `\uC798\uBABB\uB41C \uBB38\uC790\uC5F4: "${_issue.suffix}"(\uC73C)\uB85C \uB05D\uB098\uC57C \uD569\uB2C8\uB2E4`;
            if (_issue.format === "includes")
              return `\uC798\uBABB\uB41C \uBB38\uC790\uC5F4: "${_issue.includes}"\uC744(\uB97C) \uD3EC\uD568\uD574\uC57C \uD569\uB2C8\uB2E4`;
            if (_issue.format === "regex")
              return `\uC798\uBABB\uB41C \uBB38\uC790\uC5F4: \uC815\uADDC\uC2DD ${_issue.pattern} \uD328\uD134\uACFC \uC77C\uCE58\uD574\uC57C \uD569\uB2C8\uB2E4`;
            return `\uC798\uBABB\uB41C ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\uC798\uBABB\uB41C \uC22B\uC790: ${issue.divisor}\uC758 \uBC30\uC218\uC5EC\uC57C \uD569\uB2C8\uB2E4`;
          case "unrecognized_keys":
            return `\uC778\uC2DD\uD560 \uC218 \uC5C6\uB294 \uD0A4: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\uC798\uBABB\uB41C \uD0A4: ${issue.origin}`;
          case "invalid_union":
            return `\uC798\uBABB\uB41C \uC785\uB825`;
          case "invalid_element":
            return `\uC798\uBABB\uB41C \uAC12: ${issue.origin}`;
          default:
            return `\uC798\uBABB\uB41C \uC785\uB825`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/mk.cjs
var require_mk = __commonJS({
  "../../node_modules/zod/v4/locales/mk.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u0437\u043D\u0430\u0446\u0438", verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442" },
        file: { unit: "\u0431\u0430\u0458\u0442\u0438", verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442" },
        array: { unit: "\u0441\u0442\u0430\u0432\u043A\u0438", verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442" },
        set: { unit: "\u0441\u0442\u0430\u0432\u043A\u0438", verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0431\u0440\u043E\u0458";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u043D\u0438\u0437\u0430";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0432\u043D\u0435\u0441",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0430 \u0435-\u043F\u043E\u0448\u0442\u0430",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u045F\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0443\u043C \u0438 \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0443\u043C",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u0432\u0440\u0435\u043C\u0435\u0442\u0440\u0430\u0435\u045A\u0435",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441\u0430",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441\u0430",
        cidrv4: "IPv4 \u043E\u043F\u0441\u0435\u0433",
        cidrv6: "IPv6 \u043E\u043F\u0441\u0435\u0433",
        base64: "base64-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        base64url: "base64url-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        json_string: "JSON \u043D\u0438\u0437\u0430",
        e164: "E.164 \u0431\u0440\u043E\u0458",
        jwt: "JWT",
        template_literal: "\u0432\u043D\u0435\u0441"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 ${issue.expected}, \u043F\u0440\u0438\u043C\u0435\u043D\u043E ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Invalid input: expected ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u0413\u0440\u0435\u0448\u0430\u043D\u0430 \u043E\u043F\u0446\u0438\u0458\u0430: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 \u0435\u0434\u043D\u0430 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u041F\u0440\u0435\u043C\u043D\u043E\u0433\u0443 \u0433\u043E\u043B\u0435\u043C: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u0434\u0430 \u0438\u043C\u0430 ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438"}`;
            return `\u041F\u0440\u0435\u043C\u043D\u043E\u0433\u0443 \u0433\u043E\u043B\u0435\u043C: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u0434\u0430 \u0431\u0438\u0434\u0435 ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u041F\u0440\u0435\u043C\u043D\u043E\u0433\u0443 \u043C\u0430\u043B: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 ${issue.origin} \u0434\u0430 \u0438\u043C\u0430 ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u041F\u0440\u0435\u043C\u043D\u043E\u0433\u0443 \u043C\u0430\u043B: \u0441\u0435 \u043E\u0447\u0435\u043A\u0443\u0432\u0430 ${issue.origin} \u0434\u0430 \u0431\u0438\u0434\u0435 ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u041D\u0435\u0432\u0430\u0436\u0435\u0447\u043A\u0430 \u043D\u0438\u0437\u0430: \u043C\u043E\u0440\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0443\u0432\u0430 \u0441\u043E "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `\u041D\u0435\u0432\u0430\u0436\u0435\u0447\u043A\u0430 \u043D\u0438\u0437\u0430: \u043C\u043E\u0440\u0430 \u0434\u0430 \u0437\u0430\u0432\u0440\u0448\u0443\u0432\u0430 \u0441\u043E "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u041D\u0435\u0432\u0430\u0436\u0435\u0447\u043A\u0430 \u043D\u0438\u0437\u0430: \u043C\u043E\u0440\u0430 \u0434\u0430 \u0432\u043A\u043B\u0443\u0447\u0443\u0432\u0430 "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u041D\u0435\u0432\u0430\u0436\u0435\u0447\u043A\u0430 \u043D\u0438\u0437\u0430: \u043C\u043E\u0440\u0430 \u0434\u0430 \u043E\u0434\u0433\u043E\u0430\u0440\u0430 \u043D\u0430 \u043F\u0430\u0442\u0435\u0440\u043D\u043E\u0442 ${_issue.pattern}`;
            return `Invalid ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u0413\u0440\u0435\u0448\u0435\u043D \u0431\u0440\u043E\u0458: \u043C\u043E\u0440\u0430 \u0434\u0430 \u0431\u0438\u0434\u0435 \u0434\u0435\u043B\u0438\u0432 \u0441\u043E ${issue.divisor}`;
          case "unrecognized_keys":
            return `${issue.keys.length > 1 ? "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D\u0438 \u043A\u043B\u0443\u0447\u0435\u0432\u0438" : "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D \u043A\u043B\u0443\u0447"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u0413\u0440\u0435\u0448\u0435\u043D \u043A\u043B\u0443\u0447 \u0432\u043E ${issue.origin}`;
          case "invalid_union":
            return "\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441";
          case "invalid_element":
            return `\u0413\u0440\u0435\u0448\u043D\u0430 \u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442 \u0432\u043E ${issue.origin}`;
          default:
            return `\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ms.cjs
var require_ms = __commonJS({
  "../../node_modules/zod/v4/locales/ms.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "aksara", verb: "mempunyai" },
        file: { unit: "bait", verb: "mempunyai" },
        array: { unit: "elemen", verb: "mempunyai" },
        set: { unit: "elemen", verb: "mempunyai" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "nombor";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Input tidak sah: dijangka ${issue.expected}, diterima ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Input tidak sah: dijangka ${util.stringifyPrimitive(issue.values[0])}`;
            return `Pilihan tidak sah: dijangka salah satu daripada ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
            return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} adalah ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Terlalu kecil: dijangka ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Terlalu kecil: dijangka ${issue.origin} adalah ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `String tidak sah: mesti bermula dengan "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `String tidak sah: mesti berakhir dengan "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `String tidak sah: mesti mengandungi "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `String tidak sah: mesti sepadan dengan corak ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} tidak sah`;
          }
          case "not_multiple_of":
            return `Nombor tidak sah: perlu gandaan ${issue.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak sah dalam ${issue.origin}`;
          case "invalid_union":
            return "Input tidak sah";
          case "invalid_element":
            return `Nilai tidak sah dalam ${issue.origin}`;
          default:
            return `Input tidak sah`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/nl.cjs
var require_nl = __commonJS({
  "../../node_modules/zod/v4/locales/nl.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "tekens" },
        file: { unit: "bytes" },
        array: { unit: "elementen" },
        set: { unit: "elementen" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "getal";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Ongeldige invoer: verwacht ${issue.expected}, ontving ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Ongeldige invoer: verwacht ${util.stringifyPrimitive(issue.values[0])}`;
            return `Ongeldige optie: verwacht \xE9\xE9n van ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Te lang: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementen"} bevat`;
            return `Te lang: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} is`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Te kort: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} bevat`;
            }
            return `Te kort: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} is`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Ongeldige tekst: moet met "${_issue.prefix}" beginnen`;
            }
            if (_issue.format === "ends_with")
              return `Ongeldige tekst: moet op "${_issue.suffix}" eindigen`;
            if (_issue.format === "includes")
              return `Ongeldige tekst: moet "${_issue.includes}" bevatten`;
            if (_issue.format === "regex")
              return `Ongeldige tekst: moet overeenkomen met patroon ${_issue.pattern}`;
            return `Ongeldig: ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Ongeldig getal: moet een veelvoud van ${issue.divisor} zijn`;
          case "unrecognized_keys":
            return `Onbekende key${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Ongeldige key in ${issue.origin}`;
          case "invalid_union":
            return "Ongeldige invoer";
          case "invalid_element":
            return `Ongeldige waarde in ${issue.origin}`;
          default:
            return `Ongeldige invoer`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/no.cjs
var require_no = __commonJS({
  "../../node_modules/zod/v4/locales/no.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "tegn", verb: "\xE5 ha" },
        file: { unit: "bytes", verb: "\xE5 ha" },
        array: { unit: "elementer", verb: "\xE5 inneholde" },
        set: { unit: "elementer", verb: "\xE5 inneholde" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "tall";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "liste";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-omr\xE5de",
        ipv6: "IPv6-omr\xE5de",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Ugyldig input: forventet ${issue.expected}, fikk ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Ugyldig verdi: forventet ${util.stringifyPrimitive(issue.values[0])}`;
            return `Ugyldig valg: forventet en av ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `For stor(t): forventet ${issue.origin ?? "value"} til \xE5 ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
            return `For stor(t): forventet ${issue.origin ?? "value"} til \xE5 ha ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `For lite(n): forventet ${issue.origin} til \xE5 ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `For lite(n): forventet ${issue.origin} til \xE5 ha ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Ugyldig streng: m\xE5 starte med "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Ugyldig streng: m\xE5 ende med "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Ugyldig streng: m\xE5 inneholde "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Ugyldig streng: m\xE5 matche m\xF8nsteret ${_issue.pattern}`;
            return `Ugyldig ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Ugyldig tall: m\xE5 v\xE6re et multiplum av ${issue.divisor}`;
          case "unrecognized_keys":
            return `${issue.keys.length > 1 ? "Ukjente n\xF8kler" : "Ukjent n\xF8kkel"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig n\xF8kkel i ${issue.origin}`;
          case "invalid_union":
            return "Ugyldig input";
          case "invalid_element":
            return `Ugyldig verdi i ${issue.origin}`;
          default:
            return `Ugyldig input`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ota.cjs
var require_ota = __commonJS({
  "../../node_modules/zod/v4/locales/ota.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "harf", verb: "olmal\u0131d\u0131r" },
        file: { unit: "bayt", verb: "olmal\u0131d\u0131r" },
        array: { unit: "unsur", verb: "olmal\u0131d\u0131r" },
        set: { unit: "unsur", verb: "olmal\u0131d\u0131r" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "numara";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "saf";
            }
            if (data === null) {
              return "gayb";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "giren",
        email: "epostag\xE2h",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO heng\xE2m\u0131",
        date: "ISO tarihi",
        time: "ISO zaman\u0131",
        duration: "ISO m\xFCddeti",
        ipv4: "IPv4 ni\u015F\xE2n\u0131",
        ipv6: "IPv6 ni\u015F\xE2n\u0131",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-\u015Fifreli metin",
        base64url: "base64url-\u015Fifreli metin",
        json_string: "JSON metin",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "giren"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `F\xE2sit giren: umulan ${issue.expected}, al\u0131nan ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `F\xE2sit giren: umulan ${util.stringifyPrimitive(issue.values[0])}`;
            return `F\xE2sit tercih: m\xFBteberler ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Fazla b\xFCy\xFCk: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"} sahip olmal\u0131yd\u0131.`;
            return `Fazla b\xFCy\xFCk: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} olmal\u0131yd\u0131.`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Fazla k\xFC\xE7\xFCk: ${issue.origin}, ${adj}${issue.minimum.toString()} ${sizing.unit} sahip olmal\u0131yd\u0131.`;
            }
            return `Fazla k\xFC\xE7\xFCk: ${issue.origin}, ${adj}${issue.minimum.toString()} olmal\u0131yd\u0131.`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `F\xE2sit metin: "${_issue.prefix}" ile ba\u015Flamal\u0131.`;
            if (_issue.format === "ends_with")
              return `F\xE2sit metin: "${_issue.suffix}" ile bitmeli.`;
            if (_issue.format === "includes")
              return `F\xE2sit metin: "${_issue.includes}" ihtiv\xE2 etmeli.`;
            if (_issue.format === "regex")
              return `F\xE2sit metin: ${_issue.pattern} nak\u015F\u0131na uymal\u0131.`;
            return `F\xE2sit ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `F\xE2sit say\u0131: ${issue.divisor} kat\u0131 olmal\u0131yd\u0131.`;
          case "unrecognized_keys":
            return `Tan\u0131nmayan anahtar ${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `${issue.origin} i\xE7in tan\u0131nmayan anahtar var.`;
          case "invalid_union":
            return "Giren tan\u0131namad\u0131.";
          case "invalid_element":
            return `${issue.origin} i\xE7in tan\u0131nmayan k\u0131ymet var.`;
          default:
            return `K\u0131ymet tan\u0131namad\u0131.`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ps.cjs
var require_ps = __commonJS({
  "../../node_modules/zod/v4/locales/ps.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u062A\u0648\u06A9\u064A", verb: "\u0648\u0644\u0631\u064A" },
        file: { unit: "\u0628\u0627\u06CC\u067C\u0633", verb: "\u0648\u0644\u0631\u064A" },
        array: { unit: "\u062A\u0648\u06A9\u064A", verb: "\u0648\u0644\u0631\u064A" },
        set: { unit: "\u062A\u0648\u06A9\u064A", verb: "\u0648\u0644\u0631\u064A" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0639\u062F\u062F";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u0627\u0631\u06D0";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0648\u0631\u0648\u062F\u064A",
        email: "\u0628\u0631\u06CC\u069A\u0646\u0627\u0644\u06CC\u06A9",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0646\u06CC\u067C\u0647 \u0627\u0648 \u0648\u062E\u062A",
        date: "\u0646\u06D0\u067C\u0647",
        time: "\u0648\u062E\u062A",
        duration: "\u0645\u0648\u062F\u0647",
        ipv4: "\u062F IPv4 \u067E\u062A\u0647",
        ipv6: "\u062F IPv6 \u067E\u062A\u0647",
        cidrv4: "\u062F IPv4 \u0633\u0627\u062D\u0647",
        cidrv6: "\u062F IPv6 \u0633\u0627\u062D\u0647",
        base64: "base64-encoded \u0645\u062A\u0646",
        base64url: "base64url-encoded \u0645\u062A\u0646",
        json_string: "JSON \u0645\u062A\u0646",
        e164: "\u062F E.164 \u0634\u0645\u06D0\u0631\u0647",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u064A"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0646\u0627\u0633\u0645 \u0648\u0631\u0648\u062F\u064A: \u0628\u0627\u06CC\u062F ${issue.expected} \u0648\u0627\u06CC, \u0645\u06AB\u0631 ${parsedType(issue.input)} \u062A\u0631\u0644\u0627\u0633\u0647 \u0634\u0648`;
          case "invalid_value":
            if (issue.values.length === 1) {
              return `\u0646\u0627\u0633\u0645 \u0648\u0631\u0648\u062F\u064A: \u0628\u0627\u06CC\u062F ${util.stringifyPrimitive(issue.values[0])} \u0648\u0627\u06CC`;
            }
            return `\u0646\u0627\u0633\u0645 \u0627\u0646\u062A\u062E\u0627\u0628: \u0628\u0627\u06CC\u062F \u06CC\u0648 \u0644\u0647 ${util.joinValues(issue.values, "|")} \u0685\u062E\u0647 \u0648\u0627\u06CC`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0689\u06CC\u0631 \u0644\u0648\u06CC: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u0628\u0627\u06CC\u062F ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631\u0648\u0646\u0647"} \u0648\u0644\u0631\u064A`;
            }
            return `\u0689\u06CC\u0631 \u0644\u0648\u06CC: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u0628\u0627\u06CC\u062F ${adj}${issue.maximum.toString()} \u0648\u064A`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0689\u06CC\u0631 \u06A9\u0648\u0686\u0646\u06CC: ${issue.origin} \u0628\u0627\u06CC\u062F ${adj}${issue.minimum.toString()} ${sizing.unit} \u0648\u0644\u0631\u064A`;
            }
            return `\u0689\u06CC\u0631 \u06A9\u0648\u0686\u0646\u06CC: ${issue.origin} \u0628\u0627\u06CC\u062F ${adj}${issue.minimum.toString()} \u0648\u064A`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u0646\u0627\u0633\u0645 \u0645\u062A\u0646: \u0628\u0627\u06CC\u062F \u062F "${_issue.prefix}" \u0633\u0631\u0647 \u067E\u06CC\u0644 \u0634\u064A`;
            }
            if (_issue.format === "ends_with") {
              return `\u0646\u0627\u0633\u0645 \u0645\u062A\u0646: \u0628\u0627\u06CC\u062F \u062F "${_issue.suffix}" \u0633\u0631\u0647 \u067E\u0627\u06CC \u062A\u0647 \u0648\u0631\u0633\u064A\u0696\u064A`;
            }
            if (_issue.format === "includes") {
              return `\u0646\u0627\u0633\u0645 \u0645\u062A\u0646: \u0628\u0627\u06CC\u062F "${_issue.includes}" \u0648\u0644\u0631\u064A`;
            }
            if (_issue.format === "regex") {
              return `\u0646\u0627\u0633\u0645 \u0645\u062A\u0646: \u0628\u0627\u06CC\u062F \u062F ${_issue.pattern} \u0633\u0631\u0647 \u0645\u0637\u0627\u0628\u0642\u062A \u0648\u0644\u0631\u064A`;
            }
            return `${Nouns[_issue.format] ?? issue.format} \u0646\u0627\u0633\u0645 \u062F\u06CC`;
          }
          case "not_multiple_of":
            return `\u0646\u0627\u0633\u0645 \u0639\u062F\u062F: \u0628\u0627\u06CC\u062F \u062F ${issue.divisor} \u0645\u0636\u0631\u0628 \u0648\u064A`;
          case "unrecognized_keys":
            return `\u0646\u0627\u0633\u0645 ${issue.keys.length > 1 ? "\u06A9\u0644\u06CC\u0689\u0648\u0646\u0647" : "\u06A9\u0644\u06CC\u0689"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u0646\u0627\u0633\u0645 \u06A9\u0644\u06CC\u0689 \u067E\u0647 ${issue.origin} \u06A9\u06D0`;
          case "invalid_union":
            return `\u0646\u0627\u0633\u0645\u0647 \u0648\u0631\u0648\u062F\u064A`;
          case "invalid_element":
            return `\u0646\u0627\u0633\u0645 \u0639\u0646\u0635\u0631 \u067E\u0647 ${issue.origin} \u06A9\u06D0`;
          default:
            return `\u0646\u0627\u0633\u0645\u0647 \u0648\u0631\u0648\u062F\u064A`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/pl.cjs
var require_pl = __commonJS({
  "../../node_modules/zod/v4/locales/pl.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "znak\xF3w", verb: "mie\u0107" },
        file: { unit: "bajt\xF3w", verb: "mie\u0107" },
        array: { unit: "element\xF3w", verb: "mie\u0107" },
        set: { unit: "element\xF3w", verb: "mie\u0107" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "liczba";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "tablica";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "wyra\u017Cenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ci\u0105g znak\xF3w zakodowany w formacie base64",
        base64url: "ci\u0105g znak\xF3w zakodowany w formacie base64url",
        json_string: "ci\u0105g znak\xF3w w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wej\u015Bcie"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Nieprawid\u0142owe dane wej\u015Bciowe: oczekiwano ${issue.expected}, otrzymano ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Nieprawid\u0142owe dane wej\u015Bciowe: oczekiwano ${util.stringifyPrimitive(issue.values[0])}`;
            return `Nieprawid\u0142owa opcja: oczekiwano jednej z warto\u015Bci ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Za du\u017Ca warto\u015B\u0107: oczekiwano, \u017Ce ${issue.origin ?? "warto\u015B\u0107"} b\u0119dzie mie\u0107 ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element\xF3w"}`;
            }
            return `Zbyt du\u017C(y/a/e): oczekiwano, \u017Ce ${issue.origin ?? "warto\u015B\u0107"} b\u0119dzie wynosi\u0107 ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Za ma\u0142a warto\u015B\u0107: oczekiwano, \u017Ce ${issue.origin ?? "warto\u015B\u0107"} b\u0119dzie mie\u0107 ${adj}${issue.minimum.toString()} ${sizing.unit ?? "element\xF3w"}`;
            }
            return `Zbyt ma\u0142(y/a/e): oczekiwano, \u017Ce ${issue.origin ?? "warto\u015B\u0107"} b\u0119dzie wynosi\u0107 ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Nieprawid\u0142owy ci\u0105g znak\xF3w: musi zaczyna\u0107 si\u0119 od "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Nieprawid\u0142owy ci\u0105g znak\xF3w: musi ko\u0144czy\u0107 si\u0119 na "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Nieprawid\u0142owy ci\u0105g znak\xF3w: musi zawiera\u0107 "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Nieprawid\u0142owy ci\u0105g znak\xF3w: musi odpowiada\u0107 wzorcowi ${_issue.pattern}`;
            return `Nieprawid\u0142ow(y/a/e) ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Nieprawid\u0142owa liczba: musi by\u0107 wielokrotno\u015Bci\u0105 ${issue.divisor}`;
          case "unrecognized_keys":
            return `Nierozpoznane klucze${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Nieprawid\u0142owy klucz w ${issue.origin}`;
          case "invalid_union":
            return "Nieprawid\u0142owe dane wej\u015Bciowe";
          case "invalid_element":
            return `Nieprawid\u0142owa warto\u015B\u0107 w ${issue.origin}`;
          default:
            return `Nieprawid\u0142owe dane wej\u015Bciowe`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/pt.cjs
var require_pt = __commonJS({
  "../../node_modules/zod/v4/locales/pt.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "caracteres", verb: "ter" },
        file: { unit: "bytes", verb: "ter" },
        array: { unit: "itens", verb: "ter" },
        set: { unit: "itens", verb: "ter" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "n\xFAmero";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "nulo";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "padr\xE3o",
        email: "endere\xE7o de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "dura\xE7\xE3o ISO",
        ipv4: "endere\xE7o IPv4",
        ipv6: "endere\xE7o IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "n\xFAmero E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Tipo inv\xE1lido: esperado ${issue.expected}, recebido ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Entrada inv\xE1lida: esperado ${util.stringifyPrimitive(issue.values[0])}`;
            return `Op\xE7\xE3o inv\xE1lida: esperada uma das ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Muito grande: esperado que ${issue.origin ?? "valor"} tivesse ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
            return `Muito grande: esperado que ${issue.origin ?? "valor"} fosse ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Muito pequeno: esperado que ${issue.origin} tivesse ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Muito pequeno: esperado que ${issue.origin} fosse ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Texto inv\xE1lido: deve come\xE7ar com "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Texto inv\xE1lido: deve terminar com "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Texto inv\xE1lido: deve incluir "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Texto inv\xE1lido: deve corresponder ao padr\xE3o ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} inv\xE1lido`;
          }
          case "not_multiple_of":
            return `N\xFAmero inv\xE1lido: deve ser m\xFAltiplo de ${issue.divisor}`;
          case "unrecognized_keys":
            return `Chave${issue.keys.length > 1 ? "s" : ""} desconhecida${issue.keys.length > 1 ? "s" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Chave inv\xE1lida em ${issue.origin}`;
          case "invalid_union":
            return "Entrada inv\xE1lida";
          case "invalid_element":
            return `Valor inv\xE1lido em ${issue.origin}`;
          default:
            return `Campo inv\xE1lido`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ru.cjs
var require_ru = __commonJS({
  "../../node_modules/zod/v4/locales/ru.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    function getRussianPlural(count, one, few, many) {
      const absCount = Math.abs(count);
      const lastDigit = absCount % 10;
      const lastTwoDigits = absCount % 100;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return many;
      }
      if (lastDigit === 1) {
        return one;
      }
      if (lastDigit >= 2 && lastDigit <= 4) {
        return few;
      }
      return many;
    }
    var error = () => {
      const Sizable = {
        string: {
          unit: {
            one: "\u0441\u0438\u043C\u0432\u043E\u043B",
            few: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
            many: "\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
          },
          verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        file: {
          unit: {
            one: "\u0431\u0430\u0439\u0442",
            few: "\u0431\u0430\u0439\u0442\u0430",
            many: "\u0431\u0430\u0439\u0442"
          },
          verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        array: {
          unit: {
            one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
            few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
          },
          verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        set: {
          unit: {
            one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
            few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
          },
          verb: "\u0438\u043C\u0435\u0442\u044C"
        }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0447\u0438\u0441\u043B\u043E";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u043C\u0430\u0441\u0441\u0438\u0432";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0432\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u044F",
        duration: "ISO \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64",
        base64url: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64url",
        json_string: "JSON \u0441\u0442\u0440\u043E\u043A\u0430",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0432\u043E\u0434"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0432\u0432\u043E\u0434: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C ${issue.expected}, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0432\u0432\u043E\u0434: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0434\u043D\u043E \u0438\u0437 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              const maxValue = Number(issue.maximum);
              const unit = getRussianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
              return `\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C, \u0447\u0442\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C ${adj}${issue.maximum.toString()} ${unit}`;
            }
            return `\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C, \u0447\u0442\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u0431\u0443\u0434\u0435\u0442 ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              const minValue = Number(issue.minimum);
              const unit = getRussianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
              return `\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u0430\u043B\u0435\u043D\u044C\u043A\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C, \u0447\u0442\u043E ${issue.origin} \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C ${adj}${issue.minimum.toString()} ${unit}`;
            }
            return `\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u0430\u043B\u0435\u043D\u044C\u043A\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: \u043E\u0436\u0438\u0434\u0430\u043B\u043E\u0441\u044C, \u0447\u0442\u043E ${issue.origin} \u0431\u0443\u0434\u0435\u0442 ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430: \u0434\u043E\u043B\u0436\u043D\u0430 \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C\u0441\u044F \u0441 "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430: \u0434\u043E\u043B\u0436\u043D\u0430 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0430 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430: \u0434\u043E\u043B\u0436\u043D\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430: \u0434\u043E\u043B\u0436\u043D\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D\u0443 ${_issue.pattern}`;
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u043E\u0435 \u0447\u0438\u0441\u043B\u043E: \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043A\u0440\u0430\u0442\u043D\u044B\u043C ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u041D\u0435\u0440\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u043D\u043D${issue.keys.length > 1 ? "\u044B\u0435" : "\u044B\u0439"} \u043A\u043B\u044E\u0447${issue.keys.length > 1 ? "\u0438" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043B\u044E\u0447 \u0432 ${issue.origin}`;
          case "invalid_union":
            return "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0432\u0445\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435";
          case "invalid_element":
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 ${issue.origin}`;
          default:
            return `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0432\u0445\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/sl.cjs
var require_sl = __commonJS({
  "../../node_modules/zod/v4/locales/sl.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "znakov", verb: "imeti" },
        file: { unit: "bajtov", verb: "imeti" },
        array: { unit: "elementov", verb: "imeti" },
        set: { unit: "elementov", verb: "imeti" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0161tevilo";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "tabela";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "vnos",
        email: "e-po\u0161tni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in \u010Das",
        date: "ISO datum",
        time: "ISO \u010Das",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 \u0161tevilka",
        jwt: "JWT",
        template_literal: "vnos"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Neveljaven vnos: pri\u010Dakovano ${issue.expected}, prejeto ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Neveljaven vnos: pri\u010Dakovano ${util.stringifyPrimitive(issue.values[0])}`;
            return `Neveljavna mo\u017Enost: pri\u010Dakovano eno izmed ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Preveliko: pri\u010Dakovano, da bo ${issue.origin ?? "vrednost"} imelo ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementov"}`;
            return `Preveliko: pri\u010Dakovano, da bo ${issue.origin ?? "vrednost"} ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Premajhno: pri\u010Dakovano, da bo ${issue.origin} imelo ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Premajhno: pri\u010Dakovano, da bo ${issue.origin} ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Neveljaven niz: mora se za\u010Deti z "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `Neveljaven niz: mora se kon\u010Dati z "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Neveljaven niz: mora vsebovati "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Neveljaven niz: mora ustrezati vzorcu ${_issue.pattern}`;
            return `Neveljaven ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Neveljavno \u0161tevilo: mora biti ve\u010Dkratnik ${issue.divisor}`;
          case "unrecognized_keys":
            return `Neprepoznan${issue.keys.length > 1 ? "i klju\u010Di" : " klju\u010D"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Neveljaven klju\u010D v ${issue.origin}`;
          case "invalid_union":
            return "Neveljaven vnos";
          case "invalid_element":
            return `Neveljavna vrednost v ${issue.origin}`;
          default:
            return "Neveljaven vnos";
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/sv.cjs
var require_sv = __commonJS({
  "../../node_modules/zod/v4/locales/sv.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "tecken", verb: "att ha" },
        file: { unit: "bytes", verb: "att ha" },
        array: { unit: "objekt", verb: "att inneh\xE5lla" },
        set: { unit: "objekt", verb: "att inneh\xE5lla" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "antal";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "lista";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "regulj\xE4rt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad str\xE4ng",
        base64url: "base64url-kodad str\xE4ng",
        json_string: "JSON-str\xE4ng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Ogiltig inmatning: f\xF6rv\xE4ntat ${issue.expected}, fick ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Ogiltig inmatning: f\xF6rv\xE4ntat ${util.stringifyPrimitive(issue.values[0])}`;
            return `Ogiltigt val: f\xF6rv\xE4ntade en av ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `F\xF6r stor(t): f\xF6rv\xE4ntade ${issue.origin ?? "v\xE4rdet"} att ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
            }
            return `F\xF6r stor(t): f\xF6rv\xE4ntat ${issue.origin ?? "v\xE4rdet"} att ha ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `F\xF6r lite(t): f\xF6rv\xE4ntade ${issue.origin ?? "v\xE4rdet"} att ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `F\xF6r lite(t): f\xF6rv\xE4ntade ${issue.origin ?? "v\xE4rdet"} att ha ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `Ogiltig str\xE4ng: m\xE5ste b\xF6rja med "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `Ogiltig str\xE4ng: m\xE5ste sluta med "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Ogiltig str\xE4ng: m\xE5ste inneh\xE5lla "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Ogiltig str\xE4ng: m\xE5ste matcha m\xF6nstret "${_issue.pattern}"`;
            return `Ogiltig(t) ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Ogiltigt tal: m\xE5ste vara en multipel av ${issue.divisor}`;
          case "unrecognized_keys":
            return `${issue.keys.length > 1 ? "Ok\xE4nda nycklar" : "Ok\xE4nd nyckel"}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Ogiltig nyckel i ${issue.origin ?? "v\xE4rdet"}`;
          case "invalid_union":
            return "Ogiltig input";
          case "invalid_element":
            return `Ogiltigt v\xE4rde i ${issue.origin ?? "v\xE4rdet"}`;
          default:
            return `Ogiltig input`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ta.cjs
var require_ta = __commonJS({
  "../../node_modules/zod/v4/locales/ta.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u0B8E\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD", verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD" },
        file: { unit: "\u0BAA\u0BC8\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD", verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD" },
        array: { unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD", verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD" },
        set: { unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD", verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "\u0B8E\u0BA3\u0BCD \u0B85\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4\u0BA4\u0BC1" : "\u0B8E\u0BA3\u0BCD";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u0B85\u0BA3\u0BBF";
            }
            if (data === null) {
              return "\u0BB5\u0BC6\u0BB1\u0BC1\u0BAE\u0BC8";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1",
        email: "\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0BA4\u0BC7\u0BA4\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        date: "ISO \u0BA4\u0BC7\u0BA4\u0BBF",
        time: "ISO \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        duration: "ISO \u0B95\u0BBE\u0BB2 \u0B85\u0BB3\u0BB5\u0BC1",
        ipv4: "IPv4 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        ipv6: "IPv6 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        cidrv4: "IPv4 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        cidrv6: "IPv6 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        base64: "base64-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        base64url: "base64url-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        json_string: "JSON \u0B9A\u0BB0\u0BAE\u0BCD",
        e164: "E.164 \u0B8E\u0BA3\u0BCD",
        jwt: "JWT",
        template_literal: "input"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${issue.expected}, \u0BAA\u0BC6\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BB5\u0BBF\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0BAE\u0BCD: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${util.joinValues(issue.values, "|")} \u0B87\u0BB2\u0BCD \u0B92\u0BA9\u0BCD\u0BB1\u0BC1`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0BAE\u0BBF\u0B95 \u0BAA\u0BC6\u0BB0\u0BBF\u0BAF\u0BA4\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD"} \u0B86\u0B95 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            }
            return `\u0BAE\u0BBF\u0B95 \u0BAA\u0BC6\u0BB0\u0BBF\u0BAF\u0BA4\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} \u0B86\u0B95 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0BAE\u0BBF\u0B95\u0B9A\u0BCD \u0B9A\u0BBF\u0BB1\u0BBF\u0BAF\u0BA4\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} \u0B86\u0B95 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            }
            return `\u0BAE\u0BBF\u0B95\u0B9A\u0BCD \u0B9A\u0BBF\u0BB1\u0BBF\u0BAF\u0BA4\u0BC1: \u0B8E\u0BA4\u0BBF\u0BB0\u0BCD\u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1 ${issue.origin} ${adj}${issue.minimum.toString()} \u0B86\u0B95 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B9A\u0BB0\u0BAE\u0BCD: "${_issue.prefix}" \u0B87\u0BB2\u0BCD \u0BA4\u0BCA\u0B9F\u0B99\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            if (_issue.format === "ends_with")
              return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B9A\u0BB0\u0BAE\u0BCD: "${_issue.suffix}" \u0B87\u0BB2\u0BCD \u0BAE\u0BC1\u0B9F\u0BBF\u0BB5\u0B9F\u0BC8\u0BAF \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            if (_issue.format === "includes")
              return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B9A\u0BB0\u0BAE\u0BCD: "${_issue.includes}" \u0B90 \u0B89\u0BB3\u0BCD\u0BB3\u0B9F\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            if (_issue.format === "regex")
              return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B9A\u0BB0\u0BAE\u0BCD: ${_issue.pattern} \u0BAE\u0BC1\u0BB1\u0BC8\u0BAA\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1\u0B9F\u0BA9\u0BCD \u0BAA\u0BCA\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
            return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B8E\u0BA3\u0BCD: ${issue.divisor} \u0B87\u0BA9\u0BCD \u0BAA\u0BB2\u0BAE\u0BBE\u0B95 \u0B87\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD`;
          case "unrecognized_keys":
            return `\u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BCD \u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0BB5\u0BBF\u0B9A\u0BC8${issue.keys.length > 1 ? "\u0B95\u0BB3\u0BCD" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `${issue.origin} \u0B87\u0BB2\u0BCD \u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BB5\u0BBF\u0B9A\u0BC8`;
          case "invalid_union":
            return "\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1";
          case "invalid_element":
            return `${issue.origin} \u0B87\u0BB2\u0BCD \u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1`;
          default:
            return `\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/th.cjs
var require_th = __commonJS({
  "../../node_modules/zod/v4/locales/th.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23", verb: "\u0E04\u0E27\u0E23\u0E21\u0E35" },
        file: { unit: "\u0E44\u0E1A\u0E15\u0E4C", verb: "\u0E04\u0E27\u0E23\u0E21\u0E35" },
        array: { unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23", verb: "\u0E04\u0E27\u0E23\u0E21\u0E35" },
        set: { unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23", verb: "\u0E04\u0E27\u0E23\u0E21\u0E35" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 (NaN)" : "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u0E2D\u0E32\u0E23\u0E4C\u0E40\u0E23\u0E22\u0E4C (Array)";
            }
            if (data === null) {
              return "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32 (null)";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19",
        email: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
        url: "URL",
        emoji: "\u0E2D\u0E34\u0E42\u0E21\u0E08\u0E34",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        date: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E41\u0E1A\u0E1A ISO",
        time: "\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        duration: "\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        ipv4: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv4",
        ipv6: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv6",
        cidrv4: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv4",
        cidrv6: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv6",
        base64: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64",
        base64url: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL",
        json_string: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A JSON",
        e164: "\u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28 (E.164)",
        jwt: "\u0E42\u0E17\u0E40\u0E04\u0E19 JWT",
        template_literal: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E19 ${issue.expected} \u0E41\u0E15\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u0E04\u0E48\u0E32\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E19 ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E04\u0E27\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19" : "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u0E40\u0E01\u0E34\u0E19\u0E01\u0E33\u0E2B\u0E19\u0E14: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u0E04\u0E27\u0E23\u0E21\u0E35${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"}`;
            return `\u0E40\u0E01\u0E34\u0E19\u0E01\u0E33\u0E2B\u0E19\u0E14: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u0E04\u0E27\u0E23\u0E21\u0E35${adj} ${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22" : "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E01\u0E33\u0E2B\u0E19\u0E14: ${issue.origin} \u0E04\u0E27\u0E23\u0E21\u0E35${adj} ${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E01\u0E33\u0E2B\u0E19\u0E14: ${issue.origin} \u0E04\u0E27\u0E23\u0E21\u0E35${adj} ${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E02\u0E36\u0E49\u0E19\u0E15\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22 "${_issue.prefix}"`;
            }
            if (_issue.format === "ends_with")
              return `\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E25\u0E07\u0E17\u0E49\u0E32\u0E22\u0E14\u0E49\u0E27\u0E22 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35 "${_issue.includes}" \u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21`;
            if (_issue.format === "regex")
              return `\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E15\u0E49\u0E2D\u0E07\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14 ${_issue.pattern}`;
            return `\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E32\u0E23\u0E14\u0E49\u0E27\u0E22 ${issue.divisor} \u0E44\u0E14\u0E49\u0E25\u0E07\u0E15\u0E31\u0E27`;
          case "unrecognized_keys":
            return `\u0E1E\u0E1A\u0E04\u0E35\u0E22\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u0E04\u0E35\u0E22\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E19 ${issue.origin}`;
          case "invalid_union":
            return "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E22\u0E39\u0E40\u0E19\u0E35\u0E22\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49";
          case "invalid_element":
            return `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E19 ${issue.origin}`;
          default:
            return `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/tr.cjs
var require_tr = __commonJS({
  "../../node_modules/zod/v4/locales/tr.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parsedType = void 0;
    exports.default = default_1;
    var util = __importStar(require_util());
    var parsedType = (data) => {
      const t = typeof data;
      switch (t) {
        case "number": {
          return Number.isNaN(data) ? "NaN" : "number";
        }
        case "object": {
          if (Array.isArray(data)) {
            return "array";
          }
          if (data === null) {
            return "null";
          }
          if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
            return data.constructor.name;
          }
        }
      }
      return t;
    };
    exports.parsedType = parsedType;
    var error = () => {
      const Sizable = {
        string: { unit: "karakter", verb: "olmal\u0131" },
        file: { unit: "bayt", verb: "olmal\u0131" },
        array: { unit: "\xF6\u011Fe", verb: "olmal\u0131" },
        set: { unit: "\xF6\u011Fe", verb: "olmal\u0131" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const Nouns = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO s\xFCre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aral\u0131\u011F\u0131",
        cidrv6: "IPv6 aral\u0131\u011F\u0131",
        base64: "base64 ile \u015Fifrelenmi\u015F metin",
        base64url: "base64url ile \u015Fifrelenmi\u015F metin",
        json_string: "JSON dizesi",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "\u015Eablon dizesi"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `Ge\xE7ersiz de\u011Fer: beklenen ${issue.expected}, al\u0131nan ${(0, exports.parsedType)(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `Ge\xE7ersiz de\u011Fer: beklenen ${util.stringifyPrimitive(issue.values[0])}`;
            return `Ge\xE7ersiz se\xE7enek: a\u015Fa\u011F\u0131dakilerden biri olmal\u0131: ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\xC7ok b\xFCy\xFCk: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xF6\u011Fe"}`;
            return `\xC7ok b\xFCy\xFCk: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\xC7ok k\xFC\xE7\xFCk: beklenen ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            return `\xC7ok k\xFC\xE7\xFCk: beklenen ${issue.origin} ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Ge\xE7ersiz metin: "${_issue.prefix}" ile ba\u015Flamal\u0131`;
            if (_issue.format === "ends_with")
              return `Ge\xE7ersiz metin: "${_issue.suffix}" ile bitmeli`;
            if (_issue.format === "includes")
              return `Ge\xE7ersiz metin: "${_issue.includes}" i\xE7ermeli`;
            if (_issue.format === "regex")
              return `Ge\xE7ersiz metin: ${_issue.pattern} desenine uymal\u0131`;
            return `Ge\xE7ersiz ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `Ge\xE7ersiz say\u0131: ${issue.divisor} ile tam b\xF6l\xFCnebilmeli`;
          case "unrecognized_keys":
            return `Tan\u0131nmayan anahtar${issue.keys.length > 1 ? "lar" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `${issue.origin} i\xE7inde ge\xE7ersiz anahtar`;
          case "invalid_union":
            return "Ge\xE7ersiz de\u011Fer";
          case "invalid_element":
            return `${issue.origin} i\xE7inde ge\xE7ersiz de\u011Fer`;
          default:
            return `Ge\xE7ersiz de\u011Fer`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ua.cjs
var require_ua = __commonJS({
  "../../node_modules/zod/v4/locales/ua.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432", verb: "\u043C\u0430\u0442\u0438\u043C\u0435" },
        file: { unit: "\u0431\u0430\u0439\u0442\u0456\u0432", verb: "\u043C\u0430\u0442\u0438\u043C\u0435" },
        array: { unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432", verb: "\u043C\u0430\u0442\u0438\u043C\u0435" },
        set: { unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432", verb: "\u043C\u0430\u0442\u0438\u043C\u0435" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0447\u0438\u0441\u043B\u043E";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u043C\u0430\u0441\u0438\u0432";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0434\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 ISO",
        date: "\u0434\u0430\u0442\u0430 ISO",
        time: "\u0447\u0430\u0441 ISO",
        duration: "\u0442\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C ISO",
        ipv4: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv4",
        ipv6: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv6",
        cidrv4: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv4",
        cidrv6: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv6",
        base64: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64",
        base64url: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64url",
        json_string: "\u0440\u044F\u0434\u043E\u043A JSON",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F ${issue.expected}, \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430 \u043E\u043F\u0446\u0456\u044F: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F \u043E\u0434\u043D\u0435 \u0437 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0435\u043B\u0438\u043A\u0435: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F, \u0449\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432"}`;
            return `\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0435\u043B\u0438\u043A\u0435: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F, \u0449\u043E ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} \u0431\u0443\u0434\u0435 ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0435: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F, \u0449\u043E ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0435: \u043E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F, \u0449\u043E ${issue.origin} \u0431\u0443\u0434\u0435 ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A: \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u043F\u043E\u0447\u0438\u043D\u0430\u0442\u0438\u0441\u044F \u0437 "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A: \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u043D\u0430 "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A: \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u043C\u0456\u0441\u0442\u0438\u0442\u0438 "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A: \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 ${_issue.pattern}`;
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0447\u0438\u0441\u043B\u043E: \u043F\u043E\u0432\u0438\u043D\u043D\u043E \u0431\u0443\u0442\u0438 \u043A\u0440\u0430\u0442\u043D\u0438\u043C ${issue.divisor}`;
          case "unrecognized_keys":
            return `\u041D\u0435\u0440\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u043D\u0438\u0439 \u043A\u043B\u044E\u0447${issue.keys.length > 1 ? "\u0456" : ""}: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u043A\u043B\u044E\u0447 \u0443 ${issue.origin}`;
          case "invalid_union":
            return "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456";
          case "invalid_element":
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0443 ${issue.origin}`;
          default:
            return `\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/ur.cjs
var require_ur = __commonJS({
  "../../node_modules/zod/v4/locales/ur.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u062D\u0631\u0648\u0641", verb: "\u06C1\u0648\u0646\u0627" },
        file: { unit: "\u0628\u0627\u0626\u0679\u0633", verb: "\u06C1\u0648\u0646\u0627" },
        array: { unit: "\u0622\u0626\u0679\u0645\u0632", verb: "\u06C1\u0648\u0646\u0627" },
        set: { unit: "\u0622\u0626\u0679\u0645\u0632", verb: "\u06C1\u0648\u0646\u0627" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "\u0646\u0645\u0628\u0631";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u0622\u0631\u06D2";
            }
            if (data === null) {
              return "\u0646\u0644";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0627\u0646 \u067E\u0679",
        email: "\u0627\u06CC \u0645\u06CC\u0644 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        uuidv4: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 4",
        uuidv6: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 6",
        nanoid: "\u0646\u06CC\u0646\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        guid: "\u062C\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid2: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC 2",
        ulid: "\u06CC\u0648 \u0627\u06CC\u0644 \u0622\u0626\u06CC \u0688\u06CC",
        xid: "\u0627\u06CC\u06A9\u0633 \u0622\u0626\u06CC \u0688\u06CC",
        ksuid: "\u06A9\u06D2 \u0627\u06CC\u0633 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        datetime: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0688\u06CC\u0679 \u0679\u0627\u0626\u0645",
        date: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u062A\u0627\u0631\u06CC\u062E",
        time: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0648\u0642\u062A",
        duration: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0645\u062F\u062A",
        ipv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        ipv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        cidrv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0631\u06CC\u0646\u062C",
        cidrv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0631\u06CC\u0646\u062C",
        base64: "\u0628\u06CC\u0633 64 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        base64url: "\u0628\u06CC\u0633 64 \u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        json_string: "\u062C\u06D2 \u0627\u06CC\u0633 \u0627\u0648 \u0627\u06CC\u0646 \u0633\u0679\u0631\u0646\u06AF",
        e164: "\u0627\u06CC 164 \u0646\u0645\u0628\u0631",
        jwt: "\u062C\u06D2 \u0688\u0628\u0644\u06CC\u0648 \u0679\u06CC",
        template_literal: "\u0627\u0646 \u067E\u0679"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679: ${issue.expected} \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u0627\u060C ${parsedType(issue.input)} \u0645\u0648\u0635\u0648\u0644 \u06C1\u0648\u0627`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679: ${util.stringifyPrimitive(issue.values[0])} \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u0627`;
            return `\u063A\u0644\u0637 \u0622\u067E\u0634\u0646: ${util.joinValues(issue.values, "|")} \u0645\u06CC\u06BA \u0633\u06D2 \u0627\u06CC\u06A9 \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u0627`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u0628\u06C1\u062A \u0628\u0691\u0627: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u06A9\u06D2 ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0627\u0635\u0631"} \u06C1\u0648\u0646\u06D2 \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u06D2`;
            return `\u0628\u06C1\u062A \u0628\u0691\u0627: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u06A9\u0627 ${adj}${issue.maximum.toString()} \u06C1\u0648\u0646\u0627 \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u0627`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u0628\u06C1\u062A \u0686\u06BE\u0648\u0679\u0627: ${issue.origin} \u06A9\u06D2 ${adj}${issue.minimum.toString()} ${sizing.unit} \u06C1\u0648\u0646\u06D2 \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u06D2`;
            }
            return `\u0628\u06C1\u062A \u0686\u06BE\u0648\u0679\u0627: ${issue.origin} \u06A9\u0627 ${adj}${issue.minimum.toString()} \u06C1\u0648\u0646\u0627 \u0645\u062A\u0648\u0642\u0639 \u062A\u06BE\u0627`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u063A\u0644\u0637 \u0633\u0679\u0631\u0646\u06AF: "${_issue.prefix}" \u0633\u06D2 \u0634\u0631\u0648\u0639 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2`;
            }
            if (_issue.format === "ends_with")
              return `\u063A\u0644\u0637 \u0633\u0679\u0631\u0646\u06AF: "${_issue.suffix}" \u067E\u0631 \u062E\u062A\u0645 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2`;
            if (_issue.format === "includes")
              return `\u063A\u0644\u0637 \u0633\u0679\u0631\u0646\u06AF: "${_issue.includes}" \u0634\u0627\u0645\u0644 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2`;
            if (_issue.format === "regex")
              return `\u063A\u0644\u0637 \u0633\u0679\u0631\u0646\u06AF: \u067E\u06CC\u0679\u0631\u0646 ${_issue.pattern} \u0633\u06D2 \u0645\u06CC\u0686 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2`;
            return `\u063A\u0644\u0637 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u063A\u0644\u0637 \u0646\u0645\u0628\u0631: ${issue.divisor} \u06A9\u0627 \u0645\u0636\u0627\u0639\u0641 \u06C1\u0648\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06D2`;
          case "unrecognized_keys":
            return `\u063A\u06CC\u0631 \u062A\u0633\u0644\u06CC\u0645 \u0634\u062F\u06C1 \u06A9\u06CC${issue.keys.length > 1 ? "\u0632" : ""}: ${util.joinValues(issue.keys, "\u060C ")}`;
          case "invalid_key":
            return `${issue.origin} \u0645\u06CC\u06BA \u063A\u0644\u0637 \u06A9\u06CC`;
          case "invalid_union":
            return "\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679";
          case "invalid_element":
            return `${issue.origin} \u0645\u06CC\u06BA \u063A\u0644\u0637 \u0648\u06CC\u0644\u06CC\u0648`;
          default:
            return `\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/vi.cjs
var require_vi = __commonJS({
  "../../node_modules/zod/v4/locales/vi.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "k\xFD t\u1EF1", verb: "c\xF3" },
        file: { unit: "byte", verb: "c\xF3" },
        array: { unit: "ph\u1EA7n t\u1EED", verb: "c\xF3" },
        set: { unit: "ph\u1EA7n t\u1EED", verb: "c\xF3" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "s\u1ED1";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "m\u1EA3ng";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u0111\u1EA7u v\xE0o",
        email: "\u0111\u1ECBa ch\u1EC9 email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ng\xE0y gi\u1EDD ISO",
        date: "ng\xE0y ISO",
        time: "gi\u1EDD ISO",
        duration: "kho\u1EA3ng th\u1EDDi gian ISO",
        ipv4: "\u0111\u1ECBa ch\u1EC9 IPv4",
        ipv6: "\u0111\u1ECBa ch\u1EC9 IPv6",
        cidrv4: "d\u1EA3i IPv4",
        cidrv6: "d\u1EA3i IPv6",
        base64: "chu\u1ED7i m\xE3 h\xF3a base64",
        base64url: "chu\u1ED7i m\xE3 h\xF3a base64url",
        json_string: "chu\u1ED7i JSON",
        e164: "s\u1ED1 E.164",
        jwt: "JWT",
        template_literal: "\u0111\u1EA7u v\xE0o"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u0110\u1EA7u v\xE0o kh\xF4ng h\u1EE3p l\u1EC7: mong \u0111\u1EE3i ${issue.expected}, nh\u1EADn \u0111\u01B0\u1EE3c ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u0110\u1EA7u v\xE0o kh\xF4ng h\u1EE3p l\u1EC7: mong \u0111\u1EE3i ${util.stringifyPrimitive(issue.values[0])}`;
            return `T\xF9y ch\u1ECDn kh\xF4ng h\u1EE3p l\u1EC7: mong \u0111\u1EE3i m\u1ED9t trong c\xE1c gi\xE1 tr\u1ECB ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `Qu\xE1 l\u1EDBn: mong \u0111\u1EE3i ${issue.origin ?? "gi\xE1 tr\u1ECB"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "ph\u1EA7n t\u1EED"}`;
            return `Qu\xE1 l\u1EDBn: mong \u0111\u1EE3i ${issue.origin ?? "gi\xE1 tr\u1ECB"} ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `Qu\xE1 nh\u1ECF: mong \u0111\u1EE3i ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `Qu\xE1 nh\u1ECF: mong \u0111\u1EE3i ${issue.origin} ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `Chu\u1ED7i kh\xF4ng h\u1EE3p l\u1EC7: ph\u1EA3i b\u1EAFt \u0111\u1EA7u b\u1EB1ng "${_issue.prefix}"`;
            if (_issue.format === "ends_with")
              return `Chu\u1ED7i kh\xF4ng h\u1EE3p l\u1EC7: ph\u1EA3i k\u1EBFt th\xFAc b\u1EB1ng "${_issue.suffix}"`;
            if (_issue.format === "includes")
              return `Chu\u1ED7i kh\xF4ng h\u1EE3p l\u1EC7: ph\u1EA3i bao g\u1ED3m "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `Chu\u1ED7i kh\xF4ng h\u1EE3p l\u1EC7: ph\u1EA3i kh\u1EDBp v\u1EDBi m\u1EABu ${_issue.pattern}`;
            return `${Nouns[_issue.format] ?? issue.format} kh\xF4ng h\u1EE3p l\u1EC7`;
          }
          case "not_multiple_of":
            return `S\u1ED1 kh\xF4ng h\u1EE3p l\u1EC7: ph\u1EA3i l\xE0 b\u1ED9i s\u1ED1 c\u1EE7a ${issue.divisor}`;
          case "unrecognized_keys":
            return `Kh\xF3a kh\xF4ng \u0111\u01B0\u1EE3c nh\u1EADn d\u1EA1ng: ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `Kh\xF3a kh\xF4ng h\u1EE3p l\u1EC7 trong ${issue.origin}`;
          case "invalid_union":
            return "\u0110\u1EA7u v\xE0o kh\xF4ng h\u1EE3p l\u1EC7";
          case "invalid_element":
            return `Gi\xE1 tr\u1ECB kh\xF4ng h\u1EE3p l\u1EC7 trong ${issue.origin}`;
          default:
            return `\u0110\u1EA7u v\xE0o kh\xF4ng h\u1EE3p l\u1EC7`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/zh-CN.cjs
var require_zh_CN = __commonJS({
  "../../node_modules/zod/v4/locales/zh-CN.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u5B57\u7B26", verb: "\u5305\u542B" },
        file: { unit: "\u5B57\u8282", verb: "\u5305\u542B" },
        array: { unit: "\u9879", verb: "\u5305\u542B" },
        set: { unit: "\u9879", verb: "\u5305\u542B" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "\u975E\u6570\u5B57(NaN)" : "\u6570\u5B57";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "\u6570\u7EC4";
            }
            if (data === null) {
              return "\u7A7A\u503C(null)";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u8F93\u5165",
        email: "\u7535\u5B50\u90AE\u4EF6",
        url: "URL",
        emoji: "\u8868\u60C5\u7B26\u53F7",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u671F\u65F6\u95F4",
        date: "ISO\u65E5\u671F",
        time: "ISO\u65F6\u95F4",
        duration: "ISO\u65F6\u957F",
        ipv4: "IPv4\u5730\u5740",
        ipv6: "IPv6\u5730\u5740",
        cidrv4: "IPv4\u7F51\u6BB5",
        cidrv6: "IPv6\u7F51\u6BB5",
        base64: "base64\u7F16\u7801\u5B57\u7B26\u4E32",
        base64url: "base64url\u7F16\u7801\u5B57\u7B26\u4E32",
        json_string: "JSON\u5B57\u7B26\u4E32",
        e164: "E.164\u53F7\u7801",
        jwt: "JWT",
        template_literal: "\u8F93\u5165"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u65E0\u6548\u8F93\u5165\uFF1A\u671F\u671B ${issue.expected}\uFF0C\u5B9E\u9645\u63A5\u6536 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u65E0\u6548\u8F93\u5165\uFF1A\u671F\u671B ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u65E0\u6548\u9009\u9879\uFF1A\u671F\u671B\u4EE5\u4E0B\u4E4B\u4E00 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u6570\u503C\u8FC7\u5927\uFF1A\u671F\u671B ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u4E2A\u5143\u7D20"}`;
            return `\u6570\u503C\u8FC7\u5927\uFF1A\u671F\u671B ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u6570\u503C\u8FC7\u5C0F\uFF1A\u671F\u671B ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u6570\u503C\u8FC7\u5C0F\uFF1A\u671F\u671B ${issue.origin} ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with")
              return `\u65E0\u6548\u5B57\u7B26\u4E32\uFF1A\u5FC5\u987B\u4EE5 "${_issue.prefix}" \u5F00\u5934`;
            if (_issue.format === "ends_with")
              return `\u65E0\u6548\u5B57\u7B26\u4E32\uFF1A\u5FC5\u987B\u4EE5 "${_issue.suffix}" \u7ED3\u5C3E`;
            if (_issue.format === "includes")
              return `\u65E0\u6548\u5B57\u7B26\u4E32\uFF1A\u5FC5\u987B\u5305\u542B "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u65E0\u6548\u5B57\u7B26\u4E32\uFF1A\u5FC5\u987B\u6EE1\u8DB3\u6B63\u5219\u8868\u8FBE\u5F0F ${_issue.pattern}`;
            return `\u65E0\u6548${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u65E0\u6548\u6570\u5B57\uFF1A\u5FC5\u987B\u662F ${issue.divisor} \u7684\u500D\u6570`;
          case "unrecognized_keys":
            return `\u51FA\u73B0\u672A\u77E5\u7684\u952E(key): ${util.joinValues(issue.keys, ", ")}`;
          case "invalid_key":
            return `${issue.origin} \u4E2D\u7684\u952E(key)\u65E0\u6548`;
          case "invalid_union":
            return "\u65E0\u6548\u8F93\u5165";
          case "invalid_element":
            return `${issue.origin} \u4E2D\u5305\u542B\u65E0\u6548\u503C(value)`;
          default:
            return `\u65E0\u6548\u8F93\u5165`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/zh-TW.cjs
var require_zh_TW = __commonJS({
  "../../node_modules/zod/v4/locales/zh-TW.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = default_1;
    var util = __importStar(require_util());
    var error = () => {
      const Sizable = {
        string: { unit: "\u5B57\u5143", verb: "\u64C1\u6709" },
        file: { unit: "\u4F4D\u5143\u7D44", verb: "\u64C1\u6709" },
        array: { unit: "\u9805\u76EE", verb: "\u64C1\u6709" },
        set: { unit: "\u9805\u76EE", verb: "\u64C1\u6709" }
      };
      function getSizing(origin) {
        return Sizable[origin] ?? null;
      }
      const parsedType = (data) => {
        const t = typeof data;
        switch (t) {
          case "number": {
            return Number.isNaN(data) ? "NaN" : "number";
          }
          case "object": {
            if (Array.isArray(data)) {
              return "array";
            }
            if (data === null) {
              return "null";
            }
            if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
              return data.constructor.name;
            }
          }
        }
        return t;
      };
      const Nouns = {
        regex: "\u8F38\u5165",
        email: "\u90F5\u4EF6\u5730\u5740",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u65E5\u671F\u6642\u9593",
        date: "ISO \u65E5\u671F",
        time: "ISO \u6642\u9593",
        duration: "ISO \u671F\u9593",
        ipv4: "IPv4 \u4F4D\u5740",
        ipv6: "IPv6 \u4F4D\u5740",
        cidrv4: "IPv4 \u7BC4\u570D",
        cidrv6: "IPv6 \u7BC4\u570D",
        base64: "base64 \u7DE8\u78BC\u5B57\u4E32",
        base64url: "base64url \u7DE8\u78BC\u5B57\u4E32",
        json_string: "JSON \u5B57\u4E32",
        e164: "E.164 \u6578\u503C",
        jwt: "JWT",
        template_literal: "\u8F38\u5165"
      };
      return (issue) => {
        switch (issue.code) {
          case "invalid_type":
            return `\u7121\u6548\u7684\u8F38\u5165\u503C\uFF1A\u9810\u671F\u70BA ${issue.expected}\uFF0C\u4F46\u6536\u5230 ${parsedType(issue.input)}`;
          case "invalid_value":
            if (issue.values.length === 1)
              return `\u7121\u6548\u7684\u8F38\u5165\u503C\uFF1A\u9810\u671F\u70BA ${util.stringifyPrimitive(issue.values[0])}`;
            return `\u7121\u6548\u7684\u9078\u9805\uFF1A\u9810\u671F\u70BA\u4EE5\u4E0B\u5176\u4E2D\u4E4B\u4E00 ${util.joinValues(issue.values, "|")}`;
          case "too_big": {
            const adj = issue.inclusive ? "<=" : "<";
            const sizing = getSizing(issue.origin);
            if (sizing)
              return `\u6578\u503C\u904E\u5927\uFF1A\u9810\u671F ${issue.origin ?? "\u503C"} \u61C9\u70BA ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u500B\u5143\u7D20"}`;
            return `\u6578\u503C\u904E\u5927\uFF1A\u9810\u671F ${issue.origin ?? "\u503C"} \u61C9\u70BA ${adj}${issue.maximum.toString()}`;
          }
          case "too_small": {
            const adj = issue.inclusive ? ">=" : ">";
            const sizing = getSizing(issue.origin);
            if (sizing) {
              return `\u6578\u503C\u904E\u5C0F\uFF1A\u9810\u671F ${issue.origin} \u61C9\u70BA ${adj}${issue.minimum.toString()} ${sizing.unit}`;
            }
            return `\u6578\u503C\u904E\u5C0F\uFF1A\u9810\u671F ${issue.origin} \u61C9\u70BA ${adj}${issue.minimum.toString()}`;
          }
          case "invalid_format": {
            const _issue = issue;
            if (_issue.format === "starts_with") {
              return `\u7121\u6548\u7684\u5B57\u4E32\uFF1A\u5FC5\u9808\u4EE5 "${_issue.prefix}" \u958B\u982D`;
            }
            if (_issue.format === "ends_with")
              return `\u7121\u6548\u7684\u5B57\u4E32\uFF1A\u5FC5\u9808\u4EE5 "${_issue.suffix}" \u7D50\u5C3E`;
            if (_issue.format === "includes")
              return `\u7121\u6548\u7684\u5B57\u4E32\uFF1A\u5FC5\u9808\u5305\u542B "${_issue.includes}"`;
            if (_issue.format === "regex")
              return `\u7121\u6548\u7684\u5B57\u4E32\uFF1A\u5FC5\u9808\u7B26\u5408\u683C\u5F0F ${_issue.pattern}`;
            return `\u7121\u6548\u7684 ${Nouns[_issue.format] ?? issue.format}`;
          }
          case "not_multiple_of":
            return `\u7121\u6548\u7684\u6578\u5B57\uFF1A\u5FC5\u9808\u70BA ${issue.divisor} \u7684\u500D\u6578`;
          case "unrecognized_keys":
            return `\u7121\u6CD5\u8B58\u5225\u7684\u9375\u503C${issue.keys.length > 1 ? "\u5011" : ""}\uFF1A${util.joinValues(issue.keys, "\u3001")}`;
          case "invalid_key":
            return `${issue.origin} \u4E2D\u6709\u7121\u6548\u7684\u9375\u503C`;
          case "invalid_union":
            return "\u7121\u6548\u7684\u8F38\u5165\u503C";
          case "invalid_element":
            return `${issue.origin} \u4E2D\u6709\u7121\u6548\u7684\u503C`;
          default:
            return `\u7121\u6548\u7684\u8F38\u5165\u503C`;
        }
      };
    };
    function default_1() {
      return {
        localeError: error()
      };
    }
  }
});

// ../../node_modules/zod/v4/locales/index.cjs
var require_locales = __commonJS({
  "../../node_modules/zod/v4/locales/index.cjs"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.zhTW = exports.zhCN = exports.vi = exports.ur = exports.ua = exports.tr = exports.th = exports.ta = exports.sv = exports.sl = exports.ru = exports.pt = exports.pl = exports.ps = exports.ota = exports.no = exports.nl = exports.ms = exports.mk = exports.ko = exports.kh = exports.ja = exports.it = exports.id = exports.hu = exports.he = exports.frCA = exports.fr = exports.fi = exports.fa = exports.es = exports.eo = exports.en = exports.de = exports.cs = exports.ca = exports.be = exports.az = exports.ar = void 0;
    var ar_js_1 = require_ar();
    Object.defineProperty(exports, "ar", { enumerable: true, get: function() {
      return __importDefault(ar_js_1).default;
    } });
    var az_js_1 = require_az();
    Object.defineProperty(exports, "az", { enumerable: true, get: function() {
      return __importDefault(az_js_1).default;
    } });
    var be_js_1 = require_be();
    Object.defineProperty(exports, "be", { enumerable: true, get: function() {
      return __importDefault(be_js_1).default;
    } });
    var ca_js_1 = require_ca();
    Object.defineProperty(exports, "ca", { enumerable: true, get: function() {
      return __importDefault(ca_js_1).default;
    } });
    var cs_js_1 = require_cs();
    Object.defineProperty(exports, "cs", { enumerable: true, get: function() {
      return __importDefault(cs_js_1).default;
    } });
    var de_js_1 = require_de();
    Object.defineProperty(exports, "de", { enumerable: true, get: function() {
      return __importDefault(de_js_1).default;
    } });
    var en_js_1 = require_en();
    Object.defineProperty(exports, "en", { enumerable: true, get: function() {
      return __importDefault(en_js_1).default;
    } });
    var eo_js_1 = require_eo();
    Object.defineProperty(exports, "eo", { enumerable: true, get: function() {
      return __importDefault(eo_js_1).default;
    } });
    var es_js_1 = require_es();
    Object.defineProperty(exports, "es", { enumerable: true, get: function() {
      return __importDefault(es_js_1).default;
    } });
    var fa_js_1 = require_fa();
    Object.defineProperty(exports, "fa", { enumerable: true, get: function() {
      return __importDefault(fa_js_1).default;
    } });
    var fi_js_1 = require_fi();
    Object.defineProperty(exports, "fi", { enumerable: true, get: function() {
      return __importDefault(fi_js_1).default;
    } });
    var fr_js_1 = require_fr();
    Object.defineProperty(exports, "fr", { enumerable: true, get: function() {
      return __importDefault(fr_js_1).default;
    } });
    var fr_CA_js_1 = require_fr_CA();
    Object.defineProperty(exports, "frCA", { enumerable: true, get: function() {
      return __importDefault(fr_CA_js_1).default;
    } });
    var he_js_1 = require_he();
    Object.defineProperty(exports, "he", { enumerable: true, get: function() {
      return __importDefault(he_js_1).default;
    } });
    var hu_js_1 = require_hu();
    Object.defineProperty(exports, "hu", { enumerable: true, get: function() {
      return __importDefault(hu_js_1).default;
    } });
    var id_js_1 = require_id();
    Object.defineProperty(exports, "id", { enumerable: true, get: function() {
      return __importDefault(id_js_1).default;
    } });
    var it_js_1 = require_it();
    Object.defineProperty(exports, "it", { enumerable: true, get: function() {
      return __importDefault(it_js_1).default;
    } });
    var ja_js_1 = require_ja();
    Object.defineProperty(exports, "ja", { enumerable: true, get: function() {
      return __importDefault(ja_js_1).default;
    } });
    var kh_js_1 = require_kh();
    Object.defineProperty(exports, "kh", { enumerable: true, get: function() {
      return __importDefault(kh_js_1).default;
    } });
    var ko_js_1 = require_ko();
    Object.defineProperty(exports, "ko", { enumerable: true, get: function() {
      return __importDefault(ko_js_1).default;
    } });
    var mk_js_1 = require_mk();
    Object.defineProperty(exports, "mk", { enumerable: true, get: function() {
      return __importDefault(mk_js_1).default;
    } });
    var ms_js_1 = require_ms();
    Object.defineProperty(exports, "ms", { enumerable: true, get: function() {
      return __importDefault(ms_js_1).default;
    } });
    var nl_js_1 = require_nl();
    Object.defineProperty(exports, "nl", { enumerable: true, get: function() {
      return __importDefault(nl_js_1).default;
    } });
    var no_js_1 = require_no();
    Object.defineProperty(exports, "no", { enumerable: true, get: function() {
      return __importDefault(no_js_1).default;
    } });
    var ota_js_1 = require_ota();
    Object.defineProperty(exports, "ota", { enumerable: true, get: function() {
      return __importDefault(ota_js_1).default;
    } });
    var ps_js_1 = require_ps();
    Object.defineProperty(exports, "ps", { enumerable: true, get: function() {
      return __importDefault(ps_js_1).default;
    } });
    var pl_js_1 = require_pl();
    Object.defineProperty(exports, "pl", { enumerable: true, get: function() {
      return __importDefault(pl_js_1).default;
    } });
    var pt_js_1 = require_pt();
    Object.defineProperty(exports, "pt", { enumerable: true, get: function() {
      return __importDefault(pt_js_1).default;
    } });
    var ru_js_1 = require_ru();
    Object.defineProperty(exports, "ru", { enumerable: true, get: function() {
      return __importDefault(ru_js_1).default;
    } });
    var sl_js_1 = require_sl();
    Object.defineProperty(exports, "sl", { enumerable: true, get: function() {
      return __importDefault(sl_js_1).default;
    } });
    var sv_js_1 = require_sv();
    Object.defineProperty(exports, "sv", { enumerable: true, get: function() {
      return __importDefault(sv_js_1).default;
    } });
    var ta_js_1 = require_ta();
    Object.defineProperty(exports, "ta", { enumerable: true, get: function() {
      return __importDefault(ta_js_1).default;
    } });
    var th_js_1 = require_th();
    Object.defineProperty(exports, "th", { enumerable: true, get: function() {
      return __importDefault(th_js_1).default;
    } });
    var tr_js_1 = require_tr();
    Object.defineProperty(exports, "tr", { enumerable: true, get: function() {
      return __importDefault(tr_js_1).default;
    } });
    var ua_js_1 = require_ua();
    Object.defineProperty(exports, "ua", { enumerable: true, get: function() {
      return __importDefault(ua_js_1).default;
    } });
    var ur_js_1 = require_ur();
    Object.defineProperty(exports, "ur", { enumerable: true, get: function() {
      return __importDefault(ur_js_1).default;
    } });
    var vi_js_1 = require_vi();
    Object.defineProperty(exports, "vi", { enumerable: true, get: function() {
      return __importDefault(vi_js_1).default;
    } });
    var zh_CN_js_1 = require_zh_CN();
    Object.defineProperty(exports, "zhCN", { enumerable: true, get: function() {
      return __importDefault(zh_CN_js_1).default;
    } });
    var zh_TW_js_1 = require_zh_TW();
    Object.defineProperty(exports, "zhTW", { enumerable: true, get: function() {
      return __importDefault(zh_TW_js_1).default;
    } });
  }
});

// ../../node_modules/zod/v4/core/registries.cjs
var require_registries = __commonJS({
  "../../node_modules/zod/v4/core/registries.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.globalRegistry = exports.$ZodRegistry = exports.$input = exports.$output = void 0;
    exports.registry = registry;
    exports.$output = Symbol("ZodOutput");
    exports.$input = Symbol("ZodInput");
    var $ZodRegistry = class {
      constructor() {
        this._map = /* @__PURE__ */ new Map();
        this._idmap = /* @__PURE__ */ new Map();
      }
      add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) {
          if (this._idmap.has(meta.id)) {
            throw new Error(`ID ${meta.id} already exists in the registry`);
          }
          this._idmap.set(meta.id, schema);
        }
        return this;
      }
      clear() {
        this._map = /* @__PURE__ */ new Map();
        this._idmap = /* @__PURE__ */ new Map();
        return this;
      }
      remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) {
          this._idmap.delete(meta.id);
        }
        this._map.delete(schema);
        return this;
      }
      get(schema) {
        const p = schema._zod.parent;
        if (p) {
          const pm = { ...this.get(p) ?? {} };
          delete pm.id;
          return { ...pm, ...this._map.get(schema) };
        }
        return this._map.get(schema);
      }
      has(schema) {
        return this._map.has(schema);
      }
    };
    exports.$ZodRegistry = $ZodRegistry;
    function registry() {
      return new $ZodRegistry();
    }
    exports.globalRegistry = registry();
  }
});

// ../../node_modules/zod/v4/core/api.cjs
var require_api = __commonJS({
  "../../node_modules/zod/v4/core/api.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TimePrecision = void 0;
    exports._string = _string;
    exports._coercedString = _coercedString;
    exports._email = _email;
    exports._guid = _guid;
    exports._uuid = _uuid;
    exports._uuidv4 = _uuidv4;
    exports._uuidv6 = _uuidv6;
    exports._uuidv7 = _uuidv7;
    exports._url = _url;
    exports._emoji = _emoji;
    exports._nanoid = _nanoid;
    exports._cuid = _cuid;
    exports._cuid2 = _cuid2;
    exports._ulid = _ulid;
    exports._xid = _xid;
    exports._ksuid = _ksuid;
    exports._ipv4 = _ipv4;
    exports._ipv6 = _ipv6;
    exports._cidrv4 = _cidrv4;
    exports._cidrv6 = _cidrv6;
    exports._base64 = _base64;
    exports._base64url = _base64url;
    exports._e164 = _e164;
    exports._jwt = _jwt;
    exports._isoDateTime = _isoDateTime;
    exports._isoDate = _isoDate;
    exports._isoTime = _isoTime;
    exports._isoDuration = _isoDuration;
    exports._number = _number;
    exports._coercedNumber = _coercedNumber;
    exports._int = _int;
    exports._float32 = _float32;
    exports._float64 = _float64;
    exports._int32 = _int32;
    exports._uint32 = _uint32;
    exports._boolean = _boolean;
    exports._coercedBoolean = _coercedBoolean;
    exports._bigint = _bigint;
    exports._coercedBigint = _coercedBigint;
    exports._int64 = _int64;
    exports._uint64 = _uint64;
    exports._symbol = _symbol;
    exports._undefined = _undefined;
    exports._null = _null;
    exports._any = _any;
    exports._unknown = _unknown;
    exports._never = _never;
    exports._void = _void;
    exports._date = _date;
    exports._coercedDate = _coercedDate;
    exports._nan = _nan;
    exports._lt = _lt;
    exports._lte = _lte;
    exports._max = _lte;
    exports._lte = _lte;
    exports._max = _lte;
    exports._gt = _gt;
    exports._gte = _gte;
    exports._min = _gte;
    exports._gte = _gte;
    exports._min = _gte;
    exports._positive = _positive;
    exports._negative = _negative;
    exports._nonpositive = _nonpositive;
    exports._nonnegative = _nonnegative;
    exports._multipleOf = _multipleOf;
    exports._maxSize = _maxSize;
    exports._minSize = _minSize;
    exports._size = _size;
    exports._maxLength = _maxLength;
    exports._minLength = _minLength;
    exports._length = _length;
    exports._regex = _regex;
    exports._lowercase = _lowercase;
    exports._uppercase = _uppercase;
    exports._includes = _includes;
    exports._startsWith = _startsWith;
    exports._endsWith = _endsWith;
    exports._property = _property;
    exports._mime = _mime;
    exports._overwrite = _overwrite;
    exports._normalize = _normalize;
    exports._trim = _trim;
    exports._toLowerCase = _toLowerCase;
    exports._toUpperCase = _toUpperCase;
    exports._array = _array;
    exports._union = _union;
    exports._discriminatedUnion = _discriminatedUnion;
    exports._intersection = _intersection;
    exports._tuple = _tuple;
    exports._record = _record;
    exports._map = _map;
    exports._set = _set;
    exports._enum = _enum;
    exports._nativeEnum = _nativeEnum;
    exports._literal = _literal;
    exports._file = _file;
    exports._transform = _transform;
    exports._optional = _optional;
    exports._nullable = _nullable;
    exports._default = _default;
    exports._nonoptional = _nonoptional;
    exports._success = _success;
    exports._catch = _catch;
    exports._pipe = _pipe;
    exports._readonly = _readonly;
    exports._templateLiteral = _templateLiteral;
    exports._lazy = _lazy;
    exports._promise = _promise;
    exports._custom = _custom;
    exports._refine = _refine;
    exports._stringbool = _stringbool;
    exports._stringFormat = _stringFormat;
    var checks = __importStar(require_checks());
    var schemas = __importStar(require_schemas());
    var util = __importStar(require_util());
    function _string(Class, params) {
      return new Class({
        type: "string",
        ...util.normalizeParams(params)
      });
    }
    function _coercedString(Class, params) {
      return new Class({
        type: "string",
        coerce: true,
        ...util.normalizeParams(params)
      });
    }
    function _email(Class, params) {
      return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _guid(Class, params) {
      return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _uuid(Class, params) {
      return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _uuidv4(Class, params) {
      return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...util.normalizeParams(params)
      });
    }
    function _uuidv6(Class, params) {
      return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...util.normalizeParams(params)
      });
    }
    function _uuidv7(Class, params) {
      return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...util.normalizeParams(params)
      });
    }
    function _url(Class, params) {
      return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _emoji(Class, params) {
      return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _nanoid(Class, params) {
      return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _cuid(Class, params) {
      return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _cuid2(Class, params) {
      return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _ulid(Class, params) {
      return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _xid(Class, params) {
      return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _ksuid(Class, params) {
      return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _ipv4(Class, params) {
      return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _ipv6(Class, params) {
      return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _cidrv4(Class, params) {
      return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _cidrv6(Class, params) {
      return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _base64(Class, params) {
      return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _base64url(Class, params) {
      return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _e164(Class, params) {
      return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    function _jwt(Class, params) {
      return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...util.normalizeParams(params)
      });
    }
    exports.TimePrecision = {
      Any: null,
      Minute: -1,
      Second: 0,
      Millisecond: 3,
      Microsecond: 6
    };
    function _isoDateTime(Class, params) {
      return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...util.normalizeParams(params)
      });
    }
    function _isoDate(Class, params) {
      return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...util.normalizeParams(params)
      });
    }
    function _isoTime(Class, params) {
      return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...util.normalizeParams(params)
      });
    }
    function _isoDuration(Class, params) {
      return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...util.normalizeParams(params)
      });
    }
    function _number(Class, params) {
      return new Class({
        type: "number",
        checks: [],
        ...util.normalizeParams(params)
      });
    }
    function _coercedNumber(Class, params) {
      return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...util.normalizeParams(params)
      });
    }
    function _int(Class, params) {
      return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...util.normalizeParams(params)
      });
    }
    function _float32(Class, params) {
      return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...util.normalizeParams(params)
      });
    }
    function _float64(Class, params) {
      return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...util.normalizeParams(params)
      });
    }
    function _int32(Class, params) {
      return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...util.normalizeParams(params)
      });
    }
    function _uint32(Class, params) {
      return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...util.normalizeParams(params)
      });
    }
    function _boolean(Class, params) {
      return new Class({
        type: "boolean",
        ...util.normalizeParams(params)
      });
    }
    function _coercedBoolean(Class, params) {
      return new Class({
        type: "boolean",
        coerce: true,
        ...util.normalizeParams(params)
      });
    }
    function _bigint(Class, params) {
      return new Class({
        type: "bigint",
        ...util.normalizeParams(params)
      });
    }
    function _coercedBigint(Class, params) {
      return new Class({
        type: "bigint",
        coerce: true,
        ...util.normalizeParams(params)
      });
    }
    function _int64(Class, params) {
      return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...util.normalizeParams(params)
      });
    }
    function _uint64(Class, params) {
      return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...util.normalizeParams(params)
      });
    }
    function _symbol(Class, params) {
      return new Class({
        type: "symbol",
        ...util.normalizeParams(params)
      });
    }
    function _undefined(Class, params) {
      return new Class({
        type: "undefined",
        ...util.normalizeParams(params)
      });
    }
    function _null(Class, params) {
      return new Class({
        type: "null",
        ...util.normalizeParams(params)
      });
    }
    function _any(Class) {
      return new Class({
        type: "any"
      });
    }
    function _unknown(Class) {
      return new Class({
        type: "unknown"
      });
    }
    function _never(Class, params) {
      return new Class({
        type: "never",
        ...util.normalizeParams(params)
      });
    }
    function _void(Class, params) {
      return new Class({
        type: "void",
        ...util.normalizeParams(params)
      });
    }
    function _date(Class, params) {
      return new Class({
        type: "date",
        ...util.normalizeParams(params)
      });
    }
    function _coercedDate(Class, params) {
      return new Class({
        type: "date",
        coerce: true,
        ...util.normalizeParams(params)
      });
    }
    function _nan(Class, params) {
      return new Class({
        type: "nan",
        ...util.normalizeParams(params)
      });
    }
    function _lt(value, params) {
      return new checks.$ZodCheckLessThan({
        check: "less_than",
        ...util.normalizeParams(params),
        value,
        inclusive: false
      });
    }
    function _lte(value, params) {
      return new checks.$ZodCheckLessThan({
        check: "less_than",
        ...util.normalizeParams(params),
        value,
        inclusive: true
      });
    }
    function _gt(value, params) {
      return new checks.$ZodCheckGreaterThan({
        check: "greater_than",
        ...util.normalizeParams(params),
        value,
        inclusive: false
      });
    }
    function _gte(value, params) {
      return new checks.$ZodCheckGreaterThan({
        check: "greater_than",
        ...util.normalizeParams(params),
        value,
        inclusive: true
      });
    }
    function _positive(params) {
      return _gt(0, params);
    }
    function _negative(params) {
      return _lt(0, params);
    }
    function _nonpositive(params) {
      return _lte(0, params);
    }
    function _nonnegative(params) {
      return _gte(0, params);
    }
    function _multipleOf(value, params) {
      return new checks.$ZodCheckMultipleOf({
        check: "multiple_of",
        ...util.normalizeParams(params),
        value
      });
    }
    function _maxSize(maximum, params) {
      return new checks.$ZodCheckMaxSize({
        check: "max_size",
        ...util.normalizeParams(params),
        maximum
      });
    }
    function _minSize(minimum, params) {
      return new checks.$ZodCheckMinSize({
        check: "min_size",
        ...util.normalizeParams(params),
        minimum
      });
    }
    function _size(size, params) {
      return new checks.$ZodCheckSizeEquals({
        check: "size_equals",
        ...util.normalizeParams(params),
        size
      });
    }
    function _maxLength(maximum, params) {
      const ch = new checks.$ZodCheckMaxLength({
        check: "max_length",
        ...util.normalizeParams(params),
        maximum
      });
      return ch;
    }
    function _minLength(minimum, params) {
      return new checks.$ZodCheckMinLength({
        check: "min_length",
        ...util.normalizeParams(params),
        minimum
      });
    }
    function _length(length, params) {
      return new checks.$ZodCheckLengthEquals({
        check: "length_equals",
        ...util.normalizeParams(params),
        length
      });
    }
    function _regex(pattern, params) {
      return new checks.$ZodCheckRegex({
        check: "string_format",
        format: "regex",
        ...util.normalizeParams(params),
        pattern
      });
    }
    function _lowercase(params) {
      return new checks.$ZodCheckLowerCase({
        check: "string_format",
        format: "lowercase",
        ...util.normalizeParams(params)
      });
    }
    function _uppercase(params) {
      return new checks.$ZodCheckUpperCase({
        check: "string_format",
        format: "uppercase",
        ...util.normalizeParams(params)
      });
    }
    function _includes(includes, params) {
      return new checks.$ZodCheckIncludes({
        check: "string_format",
        format: "includes",
        ...util.normalizeParams(params),
        includes
      });
    }
    function _startsWith(prefix, params) {
      return new checks.$ZodCheckStartsWith({
        check: "string_format",
        format: "starts_with",
        ...util.normalizeParams(params),
        prefix
      });
    }
    function _endsWith(suffix, params) {
      return new checks.$ZodCheckEndsWith({
        check: "string_format",
        format: "ends_with",
        ...util.normalizeParams(params),
        suffix
      });
    }
    function _property(property, schema, params) {
      return new checks.$ZodCheckProperty({
        check: "property",
        property,
        schema,
        ...util.normalizeParams(params)
      });
    }
    function _mime(types, params) {
      return new checks.$ZodCheckMimeType({
        check: "mime_type",
        mime: types,
        ...util.normalizeParams(params)
      });
    }
    function _overwrite(tx) {
      return new checks.$ZodCheckOverwrite({
        check: "overwrite",
        tx
      });
    }
    function _normalize(form) {
      return _overwrite((input) => input.normalize(form));
    }
    function _trim() {
      return _overwrite((input) => input.trim());
    }
    function _toLowerCase() {
      return _overwrite((input) => input.toLowerCase());
    }
    function _toUpperCase() {
      return _overwrite((input) => input.toUpperCase());
    }
    function _array(Class, element, params) {
      return new Class({
        type: "array",
        element,
        // get element() {
        //   return element;
        // },
        ...util.normalizeParams(params)
      });
    }
    function _union(Class, options, params) {
      return new Class({
        type: "union",
        options,
        ...util.normalizeParams(params)
      });
    }
    function _discriminatedUnion(Class, discriminator, options, params) {
      return new Class({
        type: "union",
        options,
        discriminator,
        ...util.normalizeParams(params)
      });
    }
    function _intersection(Class, left, right) {
      return new Class({
        type: "intersection",
        left,
        right
      });
    }
    function _tuple(Class, items, _paramsOrRest, _params) {
      const hasRest = _paramsOrRest instanceof schemas.$ZodType;
      const params = hasRest ? _params : _paramsOrRest;
      const rest = hasRest ? _paramsOrRest : null;
      return new Class({
        type: "tuple",
        items,
        rest,
        ...util.normalizeParams(params)
      });
    }
    function _record(Class, keyType, valueType, params) {
      return new Class({
        type: "record",
        keyType,
        valueType,
        ...util.normalizeParams(params)
      });
    }
    function _map(Class, keyType, valueType, params) {
      return new Class({
        type: "map",
        keyType,
        valueType,
        ...util.normalizeParams(params)
      });
    }
    function _set(Class, valueType, params) {
      return new Class({
        type: "set",
        valueType,
        ...util.normalizeParams(params)
      });
    }
    function _enum(Class, values, params) {
      const entries = Array.isArray(values) ? Object.fromEntries(values.map((v) => [v, v])) : values;
      return new Class({
        type: "enum",
        entries,
        ...util.normalizeParams(params)
      });
    }
    function _nativeEnum(Class, entries, params) {
      return new Class({
        type: "enum",
        entries,
        ...util.normalizeParams(params)
      });
    }
    function _literal(Class, value, params) {
      return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [value],
        ...util.normalizeParams(params)
      });
    }
    function _file(Class, params) {
      return new Class({
        type: "file",
        ...util.normalizeParams(params)
      });
    }
    function _transform(Class, fn) {
      return new Class({
        type: "transform",
        transform: fn
      });
    }
    function _optional(Class, innerType) {
      return new Class({
        type: "optional",
        innerType
      });
    }
    function _nullable(Class, innerType) {
      return new Class({
        type: "nullable",
        innerType
      });
    }
    function _default(Class, innerType, defaultValue) {
      return new Class({
        type: "default",
        innerType,
        get defaultValue() {
          return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        }
      });
    }
    function _nonoptional(Class, innerType, params) {
      return new Class({
        type: "nonoptional",
        innerType,
        ...util.normalizeParams(params)
      });
    }
    function _success(Class, innerType) {
      return new Class({
        type: "success",
        innerType
      });
    }
    function _catch(Class, innerType, catchValue) {
      return new Class({
        type: "catch",
        innerType,
        catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
      });
    }
    function _pipe(Class, in_, out) {
      return new Class({
        type: "pipe",
        in: in_,
        out
      });
    }
    function _readonly(Class, innerType) {
      return new Class({
        type: "readonly",
        innerType
      });
    }
    function _templateLiteral(Class, parts, params) {
      return new Class({
        type: "template_literal",
        parts,
        ...util.normalizeParams(params)
      });
    }
    function _lazy(Class, getter) {
      return new Class({
        type: "lazy",
        getter
      });
    }
    function _promise(Class, innerType) {
      return new Class({
        type: "promise",
        innerType
      });
    }
    function _custom(Class, fn, _params) {
      const norm = util.normalizeParams(_params);
      norm.abort ?? (norm.abort = true);
      const schema = new Class({
        type: "custom",
        check: "custom",
        fn,
        ...norm
      });
      return schema;
    }
    function _refine(Class, fn, _params) {
      const schema = new Class({
        type: "custom",
        check: "custom",
        fn,
        ...util.normalizeParams(_params)
      });
      return schema;
    }
    function _stringbool(Classes, _params) {
      const params = util.normalizeParams(_params);
      let truthyArray = params.truthy ?? ["true", "1", "yes", "on", "y", "enabled"];
      let falsyArray = params.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
      if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v) => typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v) => typeof v === "string" ? v.toLowerCase() : v);
      }
      const truthySet = new Set(truthyArray);
      const falsySet = new Set(falsyArray);
      const _Pipe = Classes.Pipe ?? schemas.$ZodPipe;
      const _Boolean = Classes.Boolean ?? schemas.$ZodBoolean;
      const _String = Classes.String ?? schemas.$ZodString;
      const _Transform = Classes.Transform ?? schemas.$ZodTransform;
      const tx = new _Transform({
        type: "transform",
        transform: (input, payload) => {
          let data = input;
          if (params.case !== "sensitive")
            data = data.toLowerCase();
          if (truthySet.has(data)) {
            return true;
          } else if (falsySet.has(data)) {
            return false;
          } else {
            payload.issues.push({
              code: "invalid_value",
              expected: "stringbool",
              values: [...truthySet, ...falsySet],
              input: payload.value,
              inst: tx
            });
            return {};
          }
        },
        error: params.error
      });
      const innerPipe = new _Pipe({
        type: "pipe",
        in: new _String({ type: "string", error: params.error }),
        out: tx,
        error: params.error
      });
      const outerPipe = new _Pipe({
        type: "pipe",
        in: innerPipe,
        out: new _Boolean({
          type: "boolean",
          error: params.error
        }),
        error: params.error
      });
      return outerPipe;
    }
    function _stringFormat(Class, format, fnOrRegex, _params = {}) {
      const params = util.normalizeParams(_params);
      const def = {
        ...util.normalizeParams(_params),
        check: "string_format",
        type: "string",
        format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val) => fnOrRegex.test(val),
        ...params
      };
      if (fnOrRegex instanceof RegExp) {
        def.pattern = fnOrRegex;
      }
      const inst = new Class(def);
      return inst;
    }
  }
});

// ../../node_modules/zod/v4/core/function.cjs
var require_function = __commonJS({
  "../../node_modules/zod/v4/core/function.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.$ZodFunction = void 0;
    exports.function = _function;
    var api_js_1 = require_api();
    var parse_js_1 = require_parse();
    var schemas = __importStar(require_schemas());
    var schemas_js_1 = require_schemas();
    var $ZodFunction = class {
      constructor(def) {
        this._def = def;
        this.def = def;
      }
      implement(func) {
        if (typeof func !== "function") {
          throw new Error("implement() must be called with a function");
        }
        const impl = (...args) => {
          const parsedArgs = this._def.input ? (0, parse_js_1.parse)(this._def.input, args, void 0, { callee: impl }) : args;
          if (!Array.isArray(parsedArgs)) {
            throw new Error("Invalid arguments schema: not an array or tuple schema.");
          }
          const output = func(...parsedArgs);
          return this._def.output ? (0, parse_js_1.parse)(this._def.output, output, void 0, { callee: impl }) : output;
        };
        return impl;
      }
      implementAsync(func) {
        if (typeof func !== "function") {
          throw new Error("implement() must be called with a function");
        }
        const impl = async (...args) => {
          const parsedArgs = this._def.input ? await (0, parse_js_1.parseAsync)(this._def.input, args, void 0, { callee: impl }) : args;
          if (!Array.isArray(parsedArgs)) {
            throw new Error("Invalid arguments schema: not an array or tuple schema.");
          }
          const output = await func(...parsedArgs);
          return this._def.output ? (0, parse_js_1.parseAsync)(this._def.output, output, void 0, { callee: impl }) : output;
        };
        return impl;
      }
      input(...args) {
        const F = this.constructor;
        if (Array.isArray(args[0])) {
          return new F({
            type: "function",
            input: new schemas_js_1.$ZodTuple({
              type: "tuple",
              items: args[0],
              rest: args[1]
            }),
            output: this._def.output
          });
        }
        return new F({
          type: "function",
          input: args[0],
          output: this._def.output
        });
      }
      output(output) {
        const F = this.constructor;
        return new F({
          type: "function",
          input: this._def.input,
          output
        });
      }
    };
    exports.$ZodFunction = $ZodFunction;
    function _function(params) {
      return new $ZodFunction({
        type: "function",
        input: Array.isArray(params?.input) ? (0, api_js_1._tuple)(schemas.$ZodTuple, params?.input) : params?.input ?? (0, api_js_1._array)(schemas.$ZodArray, (0, api_js_1._unknown)(schemas.$ZodUnknown)),
        output: params?.output ?? (0, api_js_1._unknown)(schemas.$ZodUnknown)
      });
    }
  }
});

// ../../node_modules/zod/v4/core/to-json-schema.cjs
var require_to_json_schema = __commonJS({
  "../../node_modules/zod/v4/core/to-json-schema.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.JSONSchemaGenerator = void 0;
    exports.toJSONSchema = toJSONSchema;
    var registries_js_1 = require_registries();
    var util_js_1 = require_util();
    var JSONSchemaGenerator = class {
      constructor(params) {
        this.counter = 0;
        this.metadataRegistry = params?.metadata ?? registries_js_1.globalRegistry;
        this.target = params?.target ?? "draft-2020-12";
        this.unrepresentable = params?.unrepresentable ?? "throw";
        this.override = params?.override ?? (() => {
        });
        this.io = params?.io ?? "output";
        this.seen = /* @__PURE__ */ new Map();
      }
      process(schema, _params = { path: [], schemaPath: [] }) {
        var _a;
        const def = schema._zod.def;
        const formatMap = {
          guid: "uuid",
          url: "uri",
          datetime: "date-time",
          json_string: "json-string",
          regex: ""
          // do not set
        };
        const seen = this.seen.get(schema);
        if (seen) {
          seen.count++;
          const isCycle = _params.schemaPath.includes(schema);
          if (isCycle) {
            seen.cycle = _params.path;
          }
          return seen.schema;
        }
        const result = { schema: {}, count: 1, cycle: void 0, path: _params.path };
        this.seen.set(schema, result);
        const overrideSchema = schema._zod.toJSONSchema?.();
        if (overrideSchema) {
          result.schema = overrideSchema;
        } else {
          const params = {
            ..._params,
            schemaPath: [..._params.schemaPath, schema],
            path: _params.path
          };
          const parent = schema._zod.parent;
          if (parent) {
            result.ref = parent;
            this.process(parent, params);
            this.seen.get(parent).isParent = true;
          } else {
            const _json = result.schema;
            switch (def.type) {
              case "string": {
                const json = _json;
                json.type = "string";
                const { minimum, maximum, format, patterns, contentEncoding } = schema._zod.bag;
                if (typeof minimum === "number")
                  json.minLength = minimum;
                if (typeof maximum === "number")
                  json.maxLength = maximum;
                if (format) {
                  json.format = formatMap[format] ?? format;
                  if (json.format === "")
                    delete json.format;
                }
                if (contentEncoding)
                  json.contentEncoding = contentEncoding;
                if (patterns && patterns.size > 0) {
                  const regexes = [...patterns];
                  if (regexes.length === 1)
                    json.pattern = regexes[0].source;
                  else if (regexes.length > 1) {
                    result.schema.allOf = [
                      ...regexes.map((regex) => ({
                        ...this.target === "draft-7" ? { type: "string" } : {},
                        pattern: regex.source
                      }))
                    ];
                  }
                }
                break;
              }
              case "number": {
                const json = _json;
                const { minimum, maximum, format, multipleOf, exclusiveMaximum, exclusiveMinimum } = schema._zod.bag;
                if (typeof format === "string" && format.includes("int"))
                  json.type = "integer";
                else
                  json.type = "number";
                if (typeof exclusiveMinimum === "number")
                  json.exclusiveMinimum = exclusiveMinimum;
                if (typeof minimum === "number") {
                  json.minimum = minimum;
                  if (typeof exclusiveMinimum === "number") {
                    if (exclusiveMinimum >= minimum)
                      delete json.minimum;
                    else
                      delete json.exclusiveMinimum;
                  }
                }
                if (typeof exclusiveMaximum === "number")
                  json.exclusiveMaximum = exclusiveMaximum;
                if (typeof maximum === "number") {
                  json.maximum = maximum;
                  if (typeof exclusiveMaximum === "number") {
                    if (exclusiveMaximum <= maximum)
                      delete json.maximum;
                    else
                      delete json.exclusiveMaximum;
                  }
                }
                if (typeof multipleOf === "number")
                  json.multipleOf = multipleOf;
                break;
              }
              case "boolean": {
                const json = _json;
                json.type = "boolean";
                break;
              }
              case "bigint": {
                if (this.unrepresentable === "throw") {
                  throw new Error("BigInt cannot be represented in JSON Schema");
                }
                break;
              }
              case "symbol": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Symbols cannot be represented in JSON Schema");
                }
                break;
              }
              case "null": {
                _json.type = "null";
                break;
              }
              case "any": {
                break;
              }
              case "unknown": {
                break;
              }
              case "undefined": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Undefined cannot be represented in JSON Schema");
                }
                break;
              }
              case "void": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Void cannot be represented in JSON Schema");
                }
                break;
              }
              case "never": {
                _json.not = {};
                break;
              }
              case "date": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Date cannot be represented in JSON Schema");
                }
                break;
              }
              case "array": {
                const json = _json;
                const { minimum, maximum } = schema._zod.bag;
                if (typeof minimum === "number")
                  json.minItems = minimum;
                if (typeof maximum === "number")
                  json.maxItems = maximum;
                json.type = "array";
                json.items = this.process(def.element, { ...params, path: [...params.path, "items"] });
                break;
              }
              case "object": {
                const json = _json;
                json.type = "object";
                json.properties = {};
                const shape = def.shape;
                for (const key in shape) {
                  json.properties[key] = this.process(shape[key], {
                    ...params,
                    path: [...params.path, "properties", key]
                  });
                }
                const allKeys = new Set(Object.keys(shape));
                const requiredKeys = new Set([...allKeys].filter((key) => {
                  const v = def.shape[key]._zod;
                  if (this.io === "input") {
                    return v.optin === void 0;
                  } else {
                    return v.optout === void 0;
                  }
                }));
                if (requiredKeys.size > 0) {
                  json.required = Array.from(requiredKeys);
                }
                if (def.catchall?._zod.def.type === "never") {
                  json.additionalProperties = false;
                } else if (!def.catchall) {
                  if (this.io === "output")
                    json.additionalProperties = false;
                } else if (def.catchall) {
                  json.additionalProperties = this.process(def.catchall, {
                    ...params,
                    path: [...params.path, "additionalProperties"]
                  });
                }
                break;
              }
              case "union": {
                const json = _json;
                json.anyOf = def.options.map((x, i) => this.process(x, {
                  ...params,
                  path: [...params.path, "anyOf", i]
                }));
                break;
              }
              case "intersection": {
                const json = _json;
                const a = this.process(def.left, {
                  ...params,
                  path: [...params.path, "allOf", 0]
                });
                const b = this.process(def.right, {
                  ...params,
                  path: [...params.path, "allOf", 1]
                });
                const isSimpleIntersection = (val) => "allOf" in val && Object.keys(val).length === 1;
                const allOf = [
                  ...isSimpleIntersection(a) ? a.allOf : [a],
                  ...isSimpleIntersection(b) ? b.allOf : [b]
                ];
                json.allOf = allOf;
                break;
              }
              case "tuple": {
                const json = _json;
                json.type = "array";
                const prefixItems = def.items.map((x, i) => this.process(x, { ...params, path: [...params.path, "prefixItems", i] }));
                if (this.target === "draft-2020-12") {
                  json.prefixItems = prefixItems;
                } else {
                  json.items = prefixItems;
                }
                if (def.rest) {
                  const rest = this.process(def.rest, {
                    ...params,
                    path: [...params.path, "items"]
                  });
                  if (this.target === "draft-2020-12") {
                    json.items = rest;
                  } else {
                    json.additionalItems = rest;
                  }
                }
                if (def.rest) {
                  json.items = this.process(def.rest, {
                    ...params,
                    path: [...params.path, "items"]
                  });
                }
                const { minimum, maximum } = schema._zod.bag;
                if (typeof minimum === "number")
                  json.minItems = minimum;
                if (typeof maximum === "number")
                  json.maxItems = maximum;
                break;
              }
              case "record": {
                const json = _json;
                json.type = "object";
                json.propertyNames = this.process(def.keyType, { ...params, path: [...params.path, "propertyNames"] });
                json.additionalProperties = this.process(def.valueType, {
                  ...params,
                  path: [...params.path, "additionalProperties"]
                });
                break;
              }
              case "map": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Map cannot be represented in JSON Schema");
                }
                break;
              }
              case "set": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Set cannot be represented in JSON Schema");
                }
                break;
              }
              case "enum": {
                const json = _json;
                const values = (0, util_js_1.getEnumValues)(def.entries);
                if (values.every((v) => typeof v === "number"))
                  json.type = "number";
                if (values.every((v) => typeof v === "string"))
                  json.type = "string";
                json.enum = values;
                break;
              }
              case "literal": {
                const json = _json;
                const vals = [];
                for (const val of def.values) {
                  if (val === void 0) {
                    if (this.unrepresentable === "throw") {
                      throw new Error("Literal `undefined` cannot be represented in JSON Schema");
                    } else {
                    }
                  } else if (typeof val === "bigint") {
                    if (this.unrepresentable === "throw") {
                      throw new Error("BigInt literals cannot be represented in JSON Schema");
                    } else {
                      vals.push(Number(val));
                    }
                  } else {
                    vals.push(val);
                  }
                }
                if (vals.length === 0) {
                } else if (vals.length === 1) {
                  const val = vals[0];
                  json.type = val === null ? "null" : typeof val;
                  json.const = val;
                } else {
                  if (vals.every((v) => typeof v === "number"))
                    json.type = "number";
                  if (vals.every((v) => typeof v === "string"))
                    json.type = "string";
                  if (vals.every((v) => typeof v === "boolean"))
                    json.type = "string";
                  if (vals.every((v) => v === null))
                    json.type = "null";
                  json.enum = vals;
                }
                break;
              }
              case "file": {
                const json = _json;
                const file = {
                  type: "string",
                  format: "binary",
                  contentEncoding: "binary"
                };
                const { minimum, maximum, mime } = schema._zod.bag;
                if (minimum !== void 0)
                  file.minLength = minimum;
                if (maximum !== void 0)
                  file.maxLength = maximum;
                if (mime) {
                  if (mime.length === 1) {
                    file.contentMediaType = mime[0];
                    Object.assign(json, file);
                  } else {
                    json.anyOf = mime.map((m) => {
                      const mFile = { ...file, contentMediaType: m };
                      return mFile;
                    });
                  }
                } else {
                  Object.assign(json, file);
                }
                break;
              }
              case "transform": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Transforms cannot be represented in JSON Schema");
                }
                break;
              }
              case "nullable": {
                const inner = this.process(def.innerType, params);
                _json.anyOf = [inner, { type: "null" }];
                break;
              }
              case "nonoptional": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                break;
              }
              case "success": {
                const json = _json;
                json.type = "boolean";
                break;
              }
              case "default": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                _json.default = JSON.parse(JSON.stringify(def.defaultValue));
                break;
              }
              case "prefault": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                if (this.io === "input")
                  _json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
                break;
              }
              case "catch": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                let catchValue;
                try {
                  catchValue = def.catchValue(void 0);
                } catch {
                  throw new Error("Dynamic catch values are not supported in JSON Schema");
                }
                _json.default = catchValue;
                break;
              }
              case "nan": {
                if (this.unrepresentable === "throw") {
                  throw new Error("NaN cannot be represented in JSON Schema");
                }
                break;
              }
              case "template_literal": {
                const json = _json;
                const pattern = schema._zod.pattern;
                if (!pattern)
                  throw new Error("Pattern not found in template literal");
                json.type = "string";
                json.pattern = pattern.source;
                break;
              }
              case "pipe": {
                const innerType = this.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
                this.process(innerType, params);
                result.ref = innerType;
                break;
              }
              case "readonly": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                _json.readOnly = true;
                break;
              }
              case "promise": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                break;
              }
              case "optional": {
                this.process(def.innerType, params);
                result.ref = def.innerType;
                break;
              }
              case "lazy": {
                const innerType = schema._zod.innerType;
                this.process(innerType, params);
                result.ref = innerType;
                break;
              }
              case "custom": {
                if (this.unrepresentable === "throw") {
                  throw new Error("Custom types cannot be represented in JSON Schema");
                }
                break;
              }
              default: {
                def;
              }
            }
          }
        }
        const meta = this.metadataRegistry.get(schema);
        if (meta)
          Object.assign(result.schema, meta);
        if (this.io === "input" && isTransforming(schema)) {
          delete result.schema.examples;
          delete result.schema.default;
        }
        if (this.io === "input" && result.schema._prefault)
          (_a = result.schema).default ?? (_a.default = result.schema._prefault);
        delete result.schema._prefault;
        const _result = this.seen.get(schema);
        return _result.schema;
      }
      emit(schema, _params) {
        const params = {
          cycles: _params?.cycles ?? "ref",
          reused: _params?.reused ?? "inline",
          // unrepresentable: _params?.unrepresentable ?? "throw",
          // uri: _params?.uri ?? ((id) => `${id}`),
          external: _params?.external ?? void 0
        };
        const root = this.seen.get(schema);
        if (!root)
          throw new Error("Unprocessed schema. This is a bug in Zod.");
        const makeURI = (entry) => {
          const defsSegment = this.target === "draft-2020-12" ? "$defs" : "definitions";
          if (params.external) {
            const externalId = params.external.registry.get(entry[0])?.id;
            const uriGenerator = params.external.uri ?? ((id2) => id2);
            if (externalId) {
              return { ref: uriGenerator(externalId) };
            }
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${this.counter++}`;
            entry[1].defId = id;
            return { defId: id, ref: `${uriGenerator("__shared")}#/${defsSegment}/${id}` };
          }
          if (entry[1] === root) {
            return { ref: "#" };
          }
          const uriPrefix = `#`;
          const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
          const defId = entry[1].schema.id ?? `__schema${this.counter++}`;
          return { defId, ref: defUriPrefix + defId };
        };
        const extractToDef = (entry) => {
          if (entry[1].schema.$ref) {
            return;
          }
          const seen = entry[1];
          const { ref, defId } = makeURI(entry);
          seen.def = { ...seen.schema };
          if (defId)
            seen.defId = defId;
          const schema2 = seen.schema;
          for (const key in schema2) {
            delete schema2[key];
          }
          schema2.$ref = ref;
        };
        if (params.cycles === "throw") {
          for (const entry of this.seen.entries()) {
            const seen = entry[1];
            if (seen.cycle) {
              throw new Error(`Cycle detected: #/${seen.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
            }
          }
        }
        for (const entry of this.seen.entries()) {
          const seen = entry[1];
          if (schema === entry[0]) {
            extractToDef(entry);
            continue;
          }
          if (params.external) {
            const ext = params.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
              extractToDef(entry);
              continue;
            }
          }
          const id = this.metadataRegistry.get(entry[0])?.id;
          if (id) {
            extractToDef(entry);
            continue;
          }
          if (seen.cycle) {
            extractToDef(entry);
            continue;
          }
          if (seen.count > 1) {
            if (params.reused === "ref") {
              extractToDef(entry);
              continue;
            }
          }
        }
        const flattenRef = (zodSchema, params2) => {
          const seen = this.seen.get(zodSchema);
          const schema2 = seen.def ?? seen.schema;
          const _cached = { ...schema2 };
          if (seen.ref === null) {
            return;
          }
          const ref = seen.ref;
          seen.ref = null;
          if (ref) {
            flattenRef(ref, params2);
            const refSchema = this.seen.get(ref).schema;
            if (refSchema.$ref && params2.target === "draft-7") {
              schema2.allOf = schema2.allOf ?? [];
              schema2.allOf.push(refSchema);
            } else {
              Object.assign(schema2, refSchema);
              Object.assign(schema2, _cached);
            }
          }
          if (!seen.isParent)
            this.override({
              zodSchema,
              jsonSchema: schema2,
              path: seen.path ?? []
            });
        };
        for (const entry of [...this.seen.entries()].reverse()) {
          flattenRef(entry[0], { target: this.target });
        }
        const result = {};
        if (this.target === "draft-2020-12") {
          result.$schema = "https://json-schema.org/draft/2020-12/schema";
        } else if (this.target === "draft-7") {
          result.$schema = "http://json-schema.org/draft-07/schema#";
        } else {
          console.warn(`Invalid target: ${this.target}`);
        }
        if (params.external?.uri) {
          const id = params.external.registry.get(schema)?.id;
          if (!id)
            throw new Error("Schema is missing an `id` property");
          result.$id = params.external.uri(id);
        }
        Object.assign(result, root.def);
        const defs = params.external?.defs ?? {};
        for (const entry of this.seen.entries()) {
          const seen = entry[1];
          if (seen.def && seen.defId) {
            defs[seen.defId] = seen.def;
          }
        }
        if (params.external) {
        } else {
          if (Object.keys(defs).length > 0) {
            if (this.target === "draft-2020-12") {
              result.$defs = defs;
            } else {
              result.definitions = defs;
            }
          }
        }
        try {
          return JSON.parse(JSON.stringify(result));
        } catch (_err) {
          throw new Error("Error converting schema to JSON.");
        }
      }
    };
    exports.JSONSchemaGenerator = JSONSchemaGenerator;
    function toJSONSchema(input, _params) {
      if (input instanceof registries_js_1.$ZodRegistry) {
        const gen2 = new JSONSchemaGenerator(_params);
        const defs = {};
        for (const entry of input._idmap.entries()) {
          const [_, schema] = entry;
          gen2.process(schema);
        }
        const schemas = {};
        const external = {
          registry: input,
          uri: _params?.uri,
          defs
        };
        for (const entry of input._idmap.entries()) {
          const [key, schema] = entry;
          schemas[key] = gen2.emit(schema, {
            ..._params,
            external
          });
        }
        if (Object.keys(defs).length > 0) {
          const defsSegment = gen2.target === "draft-2020-12" ? "$defs" : "definitions";
          schemas.__shared = {
            [defsSegment]: defs
          };
        }
        return { schemas };
      }
      const gen = new JSONSchemaGenerator(_params);
      gen.process(input);
      return gen.emit(input, _params);
    }
    function isTransforming(_schema, _ctx) {
      const ctx = _ctx ?? { seen: /* @__PURE__ */ new Set() };
      if (ctx.seen.has(_schema))
        return false;
      ctx.seen.add(_schema);
      const schema = _schema;
      const def = schema._zod.def;
      switch (def.type) {
        case "string":
        case "number":
        case "bigint":
        case "boolean":
        case "date":
        case "symbol":
        case "undefined":
        case "null":
        case "any":
        case "unknown":
        case "never":
        case "void":
        case "literal":
        case "enum":
        case "nan":
        case "file":
        case "template_literal":
          return false;
        case "array": {
          return isTransforming(def.element, ctx);
        }
        case "object": {
          for (const key in def.shape) {
            if (isTransforming(def.shape[key], ctx))
              return true;
          }
          return false;
        }
        case "union": {
          for (const option of def.options) {
            if (isTransforming(option, ctx))
              return true;
          }
          return false;
        }
        case "intersection": {
          return isTransforming(def.left, ctx) || isTransforming(def.right, ctx);
        }
        case "tuple": {
          for (const item of def.items) {
            if (isTransforming(item, ctx))
              return true;
          }
          if (def.rest && isTransforming(def.rest, ctx))
            return true;
          return false;
        }
        case "record": {
          return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
        }
        case "map": {
          return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
        }
        case "set": {
          return isTransforming(def.valueType, ctx);
        }
        case "promise":
        case "optional":
        case "nonoptional":
        case "nullable":
        case "readonly":
          return isTransforming(def.innerType, ctx);
        case "lazy":
          return isTransforming(def.getter(), ctx);
        case "default": {
          return isTransforming(def.innerType, ctx);
        }
        case "prefault": {
          return isTransforming(def.innerType, ctx);
        }
        case "custom": {
          return false;
        }
        case "transform": {
          return true;
        }
        case "pipe": {
          return isTransforming(def.in, ctx) || isTransforming(def.out, ctx);
        }
        case "success": {
          return false;
        }
        case "catch": {
          return false;
        }
        default:
          def;
      }
      throw new Error(`Unknown schema type: ${def.type}`);
    }
  }
});

// ../../node_modules/zod/v4/core/json-schema.cjs
var require_json_schema = __commonJS({
  "../../node_modules/zod/v4/core/json-schema.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// ../../node_modules/zod/v4/core/index.cjs
var require_core2 = __commonJS({
  "../../node_modules/zod/v4/core/index.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.JSONSchema = exports.locales = exports.regexes = exports.util = void 0;
    __exportStar(require_core(), exports);
    __exportStar(require_parse(), exports);
    __exportStar(require_errors(), exports);
    __exportStar(require_schemas(), exports);
    __exportStar(require_checks(), exports);
    __exportStar(require_versions(), exports);
    exports.util = __importStar(require_util());
    exports.regexes = __importStar(require_regexes());
    exports.locales = __importStar(require_locales());
    __exportStar(require_registries(), exports);
    __exportStar(require_doc(), exports);
    __exportStar(require_function(), exports);
    __exportStar(require_api(), exports);
    __exportStar(require_to_json_schema(), exports);
    exports.JSONSchema = __importStar(require_json_schema());
  }
});

// ../../node_modules/zod/v4/classic/checks.cjs
var require_checks2 = __commonJS({
  "../../node_modules/zod/v4/classic/checks.cjs"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toUpperCase = exports.toLowerCase = exports.trim = exports.normalize = exports.overwrite = exports.mime = exports.property = exports.endsWith = exports.startsWith = exports.includes = exports.uppercase = exports.lowercase = exports.regex = exports.length = exports.minLength = exports.maxLength = exports.size = exports.minSize = exports.maxSize = exports.multipleOf = exports.nonnegative = exports.nonpositive = exports.negative = exports.positive = exports.gte = exports.gt = exports.lte = exports.lt = void 0;
    var index_js_1 = require_core2();
    Object.defineProperty(exports, "lt", { enumerable: true, get: function() {
      return index_js_1._lt;
    } });
    Object.defineProperty(exports, "lte", { enumerable: true, get: function() {
      return index_js_1._lte;
    } });
    Object.defineProperty(exports, "gt", { enumerable: true, get: function() {
      return index_js_1._gt;
    } });
    Object.defineProperty(exports, "gte", { enumerable: true, get: function() {
      return index_js_1._gte;
    } });
    Object.defineProperty(exports, "positive", { enumerable: true, get: function() {
      return index_js_1._positive;
    } });
    Object.defineProperty(exports, "negative", { enumerable: true, get: function() {
      return index_js_1._negative;
    } });
    Object.defineProperty(exports, "nonpositive", { enumerable: true, get: function() {
      return index_js_1._nonpositive;
    } });
    Object.defineProperty(exports, "nonnegative", { enumerable: true, get: function() {
      return index_js_1._nonnegative;
    } });
    Object.defineProperty(exports, "multipleOf", { enumerable: true, get: function() {
      return index_js_1._multipleOf;
    } });
    Object.defineProperty(exports, "maxSize", { enumerable: true, get: function() {
      return index_js_1._maxSize;
    } });
    Object.defineProperty(exports, "minSize", { enumerable: true, get: function() {
      return index_js_1._minSize;
    } });
    Object.defineProperty(exports, "size", { enumerable: true, get: function() {
      return index_js_1._size;
    } });
    Object.defineProperty(exports, "maxLength", { enumerable: true, get: function() {
      return index_js_1._maxLength;
    } });
    Object.defineProperty(exports, "minLength", { enumerable: true, get: function() {
      return index_js_1._minLength;
    } });
    Object.defineProperty(exports, "length", { enumerable: true, get: function() {
      return index_js_1._length;
    } });
    Object.defineProperty(exports, "regex", { enumerable: true, get: function() {
      return index_js_1._regex;
    } });
    Object.defineProperty(exports, "lowercase", { enumerable: true, get: function() {
      return index_js_1._lowercase;
    } });
    Object.defineProperty(exports, "uppercase", { enumerable: true, get: function() {
      return index_js_1._uppercase;
    } });
    Object.defineProperty(exports, "includes", { enumerable: true, get: function() {
      return index_js_1._includes;
    } });
    Object.defineProperty(exports, "startsWith", { enumerable: true, get: function() {
      return index_js_1._startsWith;
    } });
    Object.defineProperty(exports, "endsWith", { enumerable: true, get: function() {
      return index_js_1._endsWith;
    } });
    Object.defineProperty(exports, "property", { enumerable: true, get: function() {
      return index_js_1._property;
    } });
    Object.defineProperty(exports, "mime", { enumerable: true, get: function() {
      return index_js_1._mime;
    } });
    Object.defineProperty(exports, "overwrite", { enumerable: true, get: function() {
      return index_js_1._overwrite;
    } });
    Object.defineProperty(exports, "normalize", { enumerable: true, get: function() {
      return index_js_1._normalize;
    } });
    Object.defineProperty(exports, "trim", { enumerable: true, get: function() {
      return index_js_1._trim;
    } });
    Object.defineProperty(exports, "toLowerCase", { enumerable: true, get: function() {
      return index_js_1._toLowerCase;
    } });
    Object.defineProperty(exports, "toUpperCase", { enumerable: true, get: function() {
      return index_js_1._toUpperCase;
    } });
  }
});

// ../../node_modules/zod/v4/classic/iso.cjs
var require_iso = __commonJS({
  "../../node_modules/zod/v4/classic/iso.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ZodISODuration = exports.ZodISOTime = exports.ZodISODate = exports.ZodISODateTime = void 0;
    exports.datetime = datetime;
    exports.date = date;
    exports.time = time;
    exports.duration = duration;
    var core = __importStar(require_core2());
    var schemas = __importStar(require_schemas2());
    exports.ZodISODateTime = core.$constructor("ZodISODateTime", (inst, def) => {
      core.$ZodISODateTime.init(inst, def);
      schemas.ZodStringFormat.init(inst, def);
    });
    function datetime(params) {
      return core._isoDateTime(exports.ZodISODateTime, params);
    }
    exports.ZodISODate = core.$constructor("ZodISODate", (inst, def) => {
      core.$ZodISODate.init(inst, def);
      schemas.ZodStringFormat.init(inst, def);
    });
    function date(params) {
      return core._isoDate(exports.ZodISODate, params);
    }
    exports.ZodISOTime = core.$constructor("ZodISOTime", (inst, def) => {
      core.$ZodISOTime.init(inst, def);
      schemas.ZodStringFormat.init(inst, def);
    });
    function time(params) {
      return core._isoTime(exports.ZodISOTime, params);
    }
    exports.ZodISODuration = core.$constructor("ZodISODuration", (inst, def) => {
      core.$ZodISODuration.init(inst, def);
      schemas.ZodStringFormat.init(inst, def);
    });
    function duration(params) {
      return core._isoDuration(exports.ZodISODuration, params);
    }
  }
});

// ../../node_modules/zod/v4/classic/errors.cjs
var require_errors2 = __commonJS({
  "../../node_modules/zod/v4/classic/errors.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ZodRealError = exports.ZodError = void 0;
    var core = __importStar(require_core2());
    var index_js_1 = require_core2();
    var initializer = (inst, issues) => {
      index_js_1.$ZodError.init(inst, issues);
      inst.name = "ZodError";
      Object.defineProperties(inst, {
        format: {
          value: (mapper) => core.formatError(inst, mapper)
          // enumerable: false,
        },
        flatten: {
          value: (mapper) => core.flattenError(inst, mapper)
          // enumerable: false,
        },
        addIssue: {
          value: (issue) => inst.issues.push(issue)
          // enumerable: false,
        },
        addIssues: {
          value: (issues2) => inst.issues.push(...issues2)
          // enumerable: false,
        },
        isEmpty: {
          get() {
            return inst.issues.length === 0;
          }
          // enumerable: false,
        }
      });
    };
    exports.ZodError = core.$constructor("ZodError", initializer);
    exports.ZodRealError = core.$constructor("ZodError", initializer, {
      Parent: Error
    });
  }
});

// ../../node_modules/zod/v4/classic/parse.cjs
var require_parse2 = __commonJS({
  "../../node_modules/zod/v4/classic/parse.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.safeParseAsync = exports.safeParse = exports.parseAsync = exports.parse = void 0;
    var core = __importStar(require_core2());
    var errors_js_1 = require_errors2();
    exports.parse = core._parse(errors_js_1.ZodRealError);
    exports.parseAsync = core._parseAsync(errors_js_1.ZodRealError);
    exports.safeParse = core._safeParse(errors_js_1.ZodRealError);
    exports.safeParseAsync = core._safeParseAsync(errors_js_1.ZodRealError);
  }
});

// ../../node_modules/zod/v4/classic/schemas.cjs
var require_schemas2 = __commonJS({
  "../../node_modules/zod/v4/classic/schemas.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ZodTransform = exports.ZodFile = exports.ZodLiteral = exports.ZodEnum = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodDate = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodBigIntFormat = exports.ZodBigInt = exports.ZodBoolean = exports.ZodNumberFormat = exports.ZodNumber = exports.ZodCustomStringFormat = exports.ZodJWT = exports.ZodE164 = exports.ZodBase64URL = exports.ZodBase64 = exports.ZodCIDRv6 = exports.ZodCIDRv4 = exports.ZodIPv6 = exports.ZodIPv4 = exports.ZodKSUID = exports.ZodXID = exports.ZodULID = exports.ZodCUID2 = exports.ZodCUID = exports.ZodNanoID = exports.ZodEmoji = exports.ZodURL = exports.ZodUUID = exports.ZodGUID = exports.ZodEmail = exports.ZodStringFormat = exports.ZodString = exports._ZodString = exports.ZodType = void 0;
    exports.stringbool = exports.ZodCustom = exports.ZodPromise = exports.ZodLazy = exports.ZodTemplateLiteral = exports.ZodReadonly = exports.ZodPipe = exports.ZodNaN = exports.ZodCatch = exports.ZodSuccess = exports.ZodNonOptional = exports.ZodPrefault = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = void 0;
    exports.string = string;
    exports.email = email;
    exports.guid = guid;
    exports.uuid = uuid;
    exports.uuidv4 = uuidv4;
    exports.uuidv6 = uuidv6;
    exports.uuidv7 = uuidv7;
    exports.url = url;
    exports.emoji = emoji;
    exports.nanoid = nanoid;
    exports.cuid = cuid;
    exports.cuid2 = cuid2;
    exports.ulid = ulid;
    exports.xid = xid;
    exports.ksuid = ksuid;
    exports.ipv4 = ipv4;
    exports.ipv6 = ipv6;
    exports.cidrv4 = cidrv4;
    exports.cidrv6 = cidrv6;
    exports.base64 = base64;
    exports.base64url = base64url;
    exports.e164 = e164;
    exports.jwt = jwt;
    exports.stringFormat = stringFormat;
    exports.number = number;
    exports.int = int2;
    exports.float32 = float32;
    exports.float64 = float64;
    exports.int32 = int32;
    exports.uint32 = uint32;
    exports.boolean = boolean;
    exports.bigint = bigint;
    exports.int64 = int64;
    exports.uint64 = uint64;
    exports.symbol = symbol;
    exports.undefined = _undefined;
    exports.null = _null;
    exports.any = any;
    exports.unknown = unknown;
    exports.never = never;
    exports.void = _void;
    exports.date = date;
    exports.array = array;
    exports.keyof = keyof;
    exports.object = object;
    exports.strictObject = strictObject;
    exports.looseObject = looseObject;
    exports.union = union;
    exports.discriminatedUnion = discriminatedUnion;
    exports.intersection = intersection;
    exports.tuple = tuple;
    exports.record = record;
    exports.partialRecord = partialRecord;
    exports.map = map;
    exports.set = set;
    exports.enum = _enum;
    exports.nativeEnum = nativeEnum;
    exports.literal = literal;
    exports.file = file;
    exports.transform = transform;
    exports.optional = optional;
    exports.nullable = nullable;
    exports.nullish = nullish;
    exports._default = _default;
    exports.prefault = prefault;
    exports.nonoptional = nonoptional;
    exports.success = success;
    exports.catch = _catch;
    exports.nan = nan;
    exports.pipe = pipe;
    exports.readonly = readonly;
    exports.templateLiteral = templateLiteral;
    exports.lazy = lazy;
    exports.promise = promise;
    exports.check = check;
    exports.custom = custom;
    exports.refine = refine;
    exports.superRefine = superRefine;
    exports.instanceof = _instanceof;
    exports.json = json;
    exports.preprocess = preprocess;
    var core = __importStar(require_core2());
    var index_js_1 = require_core2();
    var checks = __importStar(require_checks2());
    var iso = __importStar(require_iso());
    var parse2 = __importStar(require_parse2());
    exports.ZodType = core.$constructor("ZodType", (inst, def) => {
      core.$ZodType.init(inst, def);
      inst.def = def;
      Object.defineProperty(inst, "_def", { value: def });
      inst.check = (...checks2) => {
        return inst.clone(
          {
            ...def,
            checks: [
              ...def.checks ?? [],
              ...checks2.map((ch) => typeof ch === "function" ? { _zod: { check: ch, def: { check: "custom" }, onattach: [] } } : ch)
            ]
          }
          // { parent: true }
        );
      };
      inst.clone = (def2, params) => core.clone(inst, def2, params);
      inst.brand = () => inst;
      inst.register = (reg, meta) => {
        reg.add(inst, meta);
        return inst;
      };
      inst.parse = (data, params) => parse2.parse(inst, data, params, { callee: inst.parse });
      inst.safeParse = (data, params) => parse2.safeParse(inst, data, params);
      inst.parseAsync = async (data, params) => parse2.parseAsync(inst, data, params, { callee: inst.parseAsync });
      inst.safeParseAsync = async (data, params) => parse2.safeParseAsync(inst, data, params);
      inst.spa = inst.safeParseAsync;
      inst.refine = (check2, params) => inst.check(refine(check2, params));
      inst.superRefine = (refinement) => inst.check(superRefine(refinement));
      inst.overwrite = (fn) => inst.check(checks.overwrite(fn));
      inst.optional = () => optional(inst);
      inst.nullable = () => nullable(inst);
      inst.nullish = () => optional(nullable(inst));
      inst.nonoptional = (params) => nonoptional(inst, params);
      inst.array = () => array(inst);
      inst.or = (arg) => union([inst, arg]);
      inst.and = (arg) => intersection(inst, arg);
      inst.transform = (tx) => pipe(inst, transform(tx));
      inst.default = (def2) => _default(inst, def2);
      inst.prefault = (def2) => prefault(inst, def2);
      inst.catch = (params) => _catch(inst, params);
      inst.pipe = (target) => pipe(inst, target);
      inst.readonly = () => readonly(inst);
      inst.describe = (description) => {
        const cl = inst.clone();
        core.globalRegistry.add(cl, { description });
        return cl;
      };
      Object.defineProperty(inst, "description", {
        get() {
          return core.globalRegistry.get(inst)?.description;
        },
        configurable: true
      });
      inst.meta = (...args) => {
        if (args.length === 0) {
          return core.globalRegistry.get(inst);
        }
        const cl = inst.clone();
        core.globalRegistry.add(cl, args[0]);
        return cl;
      };
      inst.isOptional = () => inst.safeParse(void 0).success;
      inst.isNullable = () => inst.safeParse(null).success;
      return inst;
    });
    exports._ZodString = core.$constructor("_ZodString", (inst, def) => {
      core.$ZodString.init(inst, def);
      exports.ZodType.init(inst, def);
      const bag = inst._zod.bag;
      inst.format = bag.format ?? null;
      inst.minLength = bag.minimum ?? null;
      inst.maxLength = bag.maximum ?? null;
      inst.regex = (...args) => inst.check(checks.regex(...args));
      inst.includes = (...args) => inst.check(checks.includes(...args));
      inst.startsWith = (...args) => inst.check(checks.startsWith(...args));
      inst.endsWith = (...args) => inst.check(checks.endsWith(...args));
      inst.min = (...args) => inst.check(checks.minLength(...args));
      inst.max = (...args) => inst.check(checks.maxLength(...args));
      inst.length = (...args) => inst.check(checks.length(...args));
      inst.nonempty = (...args) => inst.check(checks.minLength(1, ...args));
      inst.lowercase = (params) => inst.check(checks.lowercase(params));
      inst.uppercase = (params) => inst.check(checks.uppercase(params));
      inst.trim = () => inst.check(checks.trim());
      inst.normalize = (...args) => inst.check(checks.normalize(...args));
      inst.toLowerCase = () => inst.check(checks.toLowerCase());
      inst.toUpperCase = () => inst.check(checks.toUpperCase());
    });
    exports.ZodString = core.$constructor("ZodString", (inst, def) => {
      core.$ZodString.init(inst, def);
      exports._ZodString.init(inst, def);
      inst.email = (params) => inst.check(core._email(exports.ZodEmail, params));
      inst.url = (params) => inst.check(core._url(exports.ZodURL, params));
      inst.jwt = (params) => inst.check(core._jwt(exports.ZodJWT, params));
      inst.emoji = (params) => inst.check(core._emoji(exports.ZodEmoji, params));
      inst.guid = (params) => inst.check(core._guid(exports.ZodGUID, params));
      inst.uuid = (params) => inst.check(core._uuid(exports.ZodUUID, params));
      inst.uuidv4 = (params) => inst.check(core._uuidv4(exports.ZodUUID, params));
      inst.uuidv6 = (params) => inst.check(core._uuidv6(exports.ZodUUID, params));
      inst.uuidv7 = (params) => inst.check(core._uuidv7(exports.ZodUUID, params));
      inst.nanoid = (params) => inst.check(core._nanoid(exports.ZodNanoID, params));
      inst.guid = (params) => inst.check(core._guid(exports.ZodGUID, params));
      inst.cuid = (params) => inst.check(core._cuid(exports.ZodCUID, params));
      inst.cuid2 = (params) => inst.check(core._cuid2(exports.ZodCUID2, params));
      inst.ulid = (params) => inst.check(core._ulid(exports.ZodULID, params));
      inst.base64 = (params) => inst.check(core._base64(exports.ZodBase64, params));
      inst.base64url = (params) => inst.check(core._base64url(exports.ZodBase64URL, params));
      inst.xid = (params) => inst.check(core._xid(exports.ZodXID, params));
      inst.ksuid = (params) => inst.check(core._ksuid(exports.ZodKSUID, params));
      inst.ipv4 = (params) => inst.check(core._ipv4(exports.ZodIPv4, params));
      inst.ipv6 = (params) => inst.check(core._ipv6(exports.ZodIPv6, params));
      inst.cidrv4 = (params) => inst.check(core._cidrv4(exports.ZodCIDRv4, params));
      inst.cidrv6 = (params) => inst.check(core._cidrv6(exports.ZodCIDRv6, params));
      inst.e164 = (params) => inst.check(core._e164(exports.ZodE164, params));
      inst.datetime = (params) => inst.check(iso.datetime(params));
      inst.date = (params) => inst.check(iso.date(params));
      inst.time = (params) => inst.check(iso.time(params));
      inst.duration = (params) => inst.check(iso.duration(params));
    });
    function string(params) {
      return core._string(exports.ZodString, params);
    }
    exports.ZodStringFormat = core.$constructor("ZodStringFormat", (inst, def) => {
      core.$ZodStringFormat.init(inst, def);
      exports._ZodString.init(inst, def);
    });
    exports.ZodEmail = core.$constructor("ZodEmail", (inst, def) => {
      core.$ZodEmail.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function email(params) {
      return core._email(exports.ZodEmail, params);
    }
    exports.ZodGUID = core.$constructor("ZodGUID", (inst, def) => {
      core.$ZodGUID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function guid(params) {
      return core._guid(exports.ZodGUID, params);
    }
    exports.ZodUUID = core.$constructor("ZodUUID", (inst, def) => {
      core.$ZodUUID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function uuid(params) {
      return core._uuid(exports.ZodUUID, params);
    }
    function uuidv4(params) {
      return core._uuidv4(exports.ZodUUID, params);
    }
    function uuidv6(params) {
      return core._uuidv6(exports.ZodUUID, params);
    }
    function uuidv7(params) {
      return core._uuidv7(exports.ZodUUID, params);
    }
    exports.ZodURL = core.$constructor("ZodURL", (inst, def) => {
      core.$ZodURL.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function url(params) {
      return core._url(exports.ZodURL, params);
    }
    exports.ZodEmoji = core.$constructor("ZodEmoji", (inst, def) => {
      core.$ZodEmoji.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function emoji(params) {
      return core._emoji(exports.ZodEmoji, params);
    }
    exports.ZodNanoID = core.$constructor("ZodNanoID", (inst, def) => {
      core.$ZodNanoID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function nanoid(params) {
      return core._nanoid(exports.ZodNanoID, params);
    }
    exports.ZodCUID = core.$constructor("ZodCUID", (inst, def) => {
      core.$ZodCUID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function cuid(params) {
      return core._cuid(exports.ZodCUID, params);
    }
    exports.ZodCUID2 = core.$constructor("ZodCUID2", (inst, def) => {
      core.$ZodCUID2.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function cuid2(params) {
      return core._cuid2(exports.ZodCUID2, params);
    }
    exports.ZodULID = core.$constructor("ZodULID", (inst, def) => {
      core.$ZodULID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function ulid(params) {
      return core._ulid(exports.ZodULID, params);
    }
    exports.ZodXID = core.$constructor("ZodXID", (inst, def) => {
      core.$ZodXID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function xid(params) {
      return core._xid(exports.ZodXID, params);
    }
    exports.ZodKSUID = core.$constructor("ZodKSUID", (inst, def) => {
      core.$ZodKSUID.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function ksuid(params) {
      return core._ksuid(exports.ZodKSUID, params);
    }
    exports.ZodIPv4 = core.$constructor("ZodIPv4", (inst, def) => {
      core.$ZodIPv4.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function ipv4(params) {
      return core._ipv4(exports.ZodIPv4, params);
    }
    exports.ZodIPv6 = core.$constructor("ZodIPv6", (inst, def) => {
      core.$ZodIPv6.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function ipv6(params) {
      return core._ipv6(exports.ZodIPv6, params);
    }
    exports.ZodCIDRv4 = core.$constructor("ZodCIDRv4", (inst, def) => {
      core.$ZodCIDRv4.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function cidrv4(params) {
      return core._cidrv4(exports.ZodCIDRv4, params);
    }
    exports.ZodCIDRv6 = core.$constructor("ZodCIDRv6", (inst, def) => {
      core.$ZodCIDRv6.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function cidrv6(params) {
      return core._cidrv6(exports.ZodCIDRv6, params);
    }
    exports.ZodBase64 = core.$constructor("ZodBase64", (inst, def) => {
      core.$ZodBase64.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function base64(params) {
      return core._base64(exports.ZodBase64, params);
    }
    exports.ZodBase64URL = core.$constructor("ZodBase64URL", (inst, def) => {
      core.$ZodBase64URL.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function base64url(params) {
      return core._base64url(exports.ZodBase64URL, params);
    }
    exports.ZodE164 = core.$constructor("ZodE164", (inst, def) => {
      core.$ZodE164.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function e164(params) {
      return core._e164(exports.ZodE164, params);
    }
    exports.ZodJWT = core.$constructor("ZodJWT", (inst, def) => {
      core.$ZodJWT.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function jwt(params) {
      return core._jwt(exports.ZodJWT, params);
    }
    exports.ZodCustomStringFormat = core.$constructor("ZodCustomStringFormat", (inst, def) => {
      core.$ZodCustomStringFormat.init(inst, def);
      exports.ZodStringFormat.init(inst, def);
    });
    function stringFormat(format, fnOrRegex, _params = {}) {
      return core._stringFormat(exports.ZodCustomStringFormat, format, fnOrRegex, _params);
    }
    exports.ZodNumber = core.$constructor("ZodNumber", (inst, def) => {
      core.$ZodNumber.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.gt = (value, params) => inst.check(checks.gt(value, params));
      inst.gte = (value, params) => inst.check(checks.gte(value, params));
      inst.min = (value, params) => inst.check(checks.gte(value, params));
      inst.lt = (value, params) => inst.check(checks.lt(value, params));
      inst.lte = (value, params) => inst.check(checks.lte(value, params));
      inst.max = (value, params) => inst.check(checks.lte(value, params));
      inst.int = (params) => inst.check(int2(params));
      inst.safe = (params) => inst.check(int2(params));
      inst.positive = (params) => inst.check(checks.gt(0, params));
      inst.nonnegative = (params) => inst.check(checks.gte(0, params));
      inst.negative = (params) => inst.check(checks.lt(0, params));
      inst.nonpositive = (params) => inst.check(checks.lte(0, params));
      inst.multipleOf = (value, params) => inst.check(checks.multipleOf(value, params));
      inst.step = (value, params) => inst.check(checks.multipleOf(value, params));
      inst.finite = () => inst;
      const bag = inst._zod.bag;
      inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
      inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
      inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
      inst.isFinite = true;
      inst.format = bag.format ?? null;
    });
    function number(params) {
      return core._number(exports.ZodNumber, params);
    }
    exports.ZodNumberFormat = core.$constructor("ZodNumberFormat", (inst, def) => {
      core.$ZodNumberFormat.init(inst, def);
      exports.ZodNumber.init(inst, def);
    });
    function int2(params) {
      return core._int(exports.ZodNumberFormat, params);
    }
    function float32(params) {
      return core._float32(exports.ZodNumberFormat, params);
    }
    function float64(params) {
      return core._float64(exports.ZodNumberFormat, params);
    }
    function int32(params) {
      return core._int32(exports.ZodNumberFormat, params);
    }
    function uint32(params) {
      return core._uint32(exports.ZodNumberFormat, params);
    }
    exports.ZodBoolean = core.$constructor("ZodBoolean", (inst, def) => {
      core.$ZodBoolean.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function boolean(params) {
      return core._boolean(exports.ZodBoolean, params);
    }
    exports.ZodBigInt = core.$constructor("ZodBigInt", (inst, def) => {
      core.$ZodBigInt.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.gte = (value, params) => inst.check(checks.gte(value, params));
      inst.min = (value, params) => inst.check(checks.gte(value, params));
      inst.gt = (value, params) => inst.check(checks.gt(value, params));
      inst.gte = (value, params) => inst.check(checks.gte(value, params));
      inst.min = (value, params) => inst.check(checks.gte(value, params));
      inst.lt = (value, params) => inst.check(checks.lt(value, params));
      inst.lte = (value, params) => inst.check(checks.lte(value, params));
      inst.max = (value, params) => inst.check(checks.lte(value, params));
      inst.positive = (params) => inst.check(checks.gt(BigInt(0), params));
      inst.negative = (params) => inst.check(checks.lt(BigInt(0), params));
      inst.nonpositive = (params) => inst.check(checks.lte(BigInt(0), params));
      inst.nonnegative = (params) => inst.check(checks.gte(BigInt(0), params));
      inst.multipleOf = (value, params) => inst.check(checks.multipleOf(value, params));
      const bag = inst._zod.bag;
      inst.minValue = bag.minimum ?? null;
      inst.maxValue = bag.maximum ?? null;
      inst.format = bag.format ?? null;
    });
    function bigint(params) {
      return core._bigint(exports.ZodBigInt, params);
    }
    exports.ZodBigIntFormat = core.$constructor("ZodBigIntFormat", (inst, def) => {
      core.$ZodBigIntFormat.init(inst, def);
      exports.ZodBigInt.init(inst, def);
    });
    function int64(params) {
      return core._int64(exports.ZodBigIntFormat, params);
    }
    function uint64(params) {
      return core._uint64(exports.ZodBigIntFormat, params);
    }
    exports.ZodSymbol = core.$constructor("ZodSymbol", (inst, def) => {
      core.$ZodSymbol.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function symbol(params) {
      return core._symbol(exports.ZodSymbol, params);
    }
    exports.ZodUndefined = core.$constructor("ZodUndefined", (inst, def) => {
      core.$ZodUndefined.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function _undefined(params) {
      return core._undefined(exports.ZodUndefined, params);
    }
    exports.ZodNull = core.$constructor("ZodNull", (inst, def) => {
      core.$ZodNull.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function _null(params) {
      return core._null(exports.ZodNull, params);
    }
    exports.ZodAny = core.$constructor("ZodAny", (inst, def) => {
      core.$ZodAny.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function any() {
      return core._any(exports.ZodAny);
    }
    exports.ZodUnknown = core.$constructor("ZodUnknown", (inst, def) => {
      core.$ZodUnknown.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function unknown() {
      return core._unknown(exports.ZodUnknown);
    }
    exports.ZodNever = core.$constructor("ZodNever", (inst, def) => {
      core.$ZodNever.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function never(params) {
      return core._never(exports.ZodNever, params);
    }
    exports.ZodVoid = core.$constructor("ZodVoid", (inst, def) => {
      core.$ZodVoid.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function _void(params) {
      return core._void(exports.ZodVoid, params);
    }
    exports.ZodDate = core.$constructor("ZodDate", (inst, def) => {
      core.$ZodDate.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.min = (value, params) => inst.check(checks.gte(value, params));
      inst.max = (value, params) => inst.check(checks.lte(value, params));
      const c = inst._zod.bag;
      inst.minDate = c.minimum ? new Date(c.minimum) : null;
      inst.maxDate = c.maximum ? new Date(c.maximum) : null;
    });
    function date(params) {
      return core._date(exports.ZodDate, params);
    }
    exports.ZodArray = core.$constructor("ZodArray", (inst, def) => {
      core.$ZodArray.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.element = def.element;
      inst.min = (minLength, params) => inst.check(checks.minLength(minLength, params));
      inst.nonempty = (params) => inst.check(checks.minLength(1, params));
      inst.max = (maxLength, params) => inst.check(checks.maxLength(maxLength, params));
      inst.length = (len, params) => inst.check(checks.length(len, params));
      inst.unwrap = () => inst.element;
    });
    function array(element, params) {
      return core._array(exports.ZodArray, element, params);
    }
    function keyof(schema) {
      const shape = schema._zod.def.shape;
      return literal(Object.keys(shape));
    }
    exports.ZodObject = core.$constructor("ZodObject", (inst, def) => {
      core.$ZodObject.init(inst, def);
      exports.ZodType.init(inst, def);
      index_js_1.util.defineLazy(inst, "shape", () => def.shape);
      inst.keyof = () => _enum(Object.keys(inst._zod.def.shape));
      inst.catchall = (catchall) => inst.clone({ ...inst._zod.def, catchall });
      inst.passthrough = () => inst.clone({ ...inst._zod.def, catchall: unknown() });
      inst.loose = () => inst.clone({ ...inst._zod.def, catchall: unknown() });
      inst.strict = () => inst.clone({ ...inst._zod.def, catchall: never() });
      inst.strip = () => inst.clone({ ...inst._zod.def, catchall: void 0 });
      inst.extend = (incoming) => {
        return index_js_1.util.extend(inst, incoming);
      };
      inst.merge = (other) => index_js_1.util.merge(inst, other);
      inst.pick = (mask) => index_js_1.util.pick(inst, mask);
      inst.omit = (mask) => index_js_1.util.omit(inst, mask);
      inst.partial = (...args) => index_js_1.util.partial(exports.ZodOptional, inst, args[0]);
      inst.required = (...args) => index_js_1.util.required(exports.ZodNonOptional, inst, args[0]);
    });
    function object(shape, params) {
      const def = {
        type: "object",
        get shape() {
          index_js_1.util.assignProp(this, "shape", { ...shape });
          return this.shape;
        },
        ...index_js_1.util.normalizeParams(params)
      };
      return new exports.ZodObject(def);
    }
    function strictObject(shape, params) {
      return new exports.ZodObject({
        type: "object",
        get shape() {
          index_js_1.util.assignProp(this, "shape", { ...shape });
          return this.shape;
        },
        catchall: never(),
        ...index_js_1.util.normalizeParams(params)
      });
    }
    function looseObject(shape, params) {
      return new exports.ZodObject({
        type: "object",
        get shape() {
          index_js_1.util.assignProp(this, "shape", { ...shape });
          return this.shape;
        },
        catchall: unknown(),
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodUnion = core.$constructor("ZodUnion", (inst, def) => {
      core.$ZodUnion.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.options = def.options;
    });
    function union(options, params) {
      return new exports.ZodUnion({
        type: "union",
        options,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodDiscriminatedUnion = core.$constructor("ZodDiscriminatedUnion", (inst, def) => {
      exports.ZodUnion.init(inst, def);
      core.$ZodDiscriminatedUnion.init(inst, def);
    });
    function discriminatedUnion(discriminator, options, params) {
      return new exports.ZodDiscriminatedUnion({
        type: "union",
        options,
        discriminator,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodIntersection = core.$constructor("ZodIntersection", (inst, def) => {
      core.$ZodIntersection.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function intersection(left, right) {
      return new exports.ZodIntersection({
        type: "intersection",
        left,
        right
      });
    }
    exports.ZodTuple = core.$constructor("ZodTuple", (inst, def) => {
      core.$ZodTuple.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.rest = (rest) => inst.clone({
        ...inst._zod.def,
        rest
      });
    });
    function tuple(items, _paramsOrRest, _params) {
      const hasRest = _paramsOrRest instanceof core.$ZodType;
      const params = hasRest ? _params : _paramsOrRest;
      const rest = hasRest ? _paramsOrRest : null;
      return new exports.ZodTuple({
        type: "tuple",
        items,
        rest,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodRecord = core.$constructor("ZodRecord", (inst, def) => {
      core.$ZodRecord.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.keyType = def.keyType;
      inst.valueType = def.valueType;
    });
    function record(keyType, valueType, params) {
      return new exports.ZodRecord({
        type: "record",
        keyType,
        valueType,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    function partialRecord(keyType, valueType, params) {
      return new exports.ZodRecord({
        type: "record",
        keyType: union([keyType, never()]),
        valueType,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodMap = core.$constructor("ZodMap", (inst, def) => {
      core.$ZodMap.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.keyType = def.keyType;
      inst.valueType = def.valueType;
    });
    function map(keyType, valueType, params) {
      return new exports.ZodMap({
        type: "map",
        keyType,
        valueType,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodSet = core.$constructor("ZodSet", (inst, def) => {
      core.$ZodSet.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.min = (...args) => inst.check(core._minSize(...args));
      inst.nonempty = (params) => inst.check(core._minSize(1, params));
      inst.max = (...args) => inst.check(core._maxSize(...args));
      inst.size = (...args) => inst.check(core._size(...args));
    });
    function set(valueType, params) {
      return new exports.ZodSet({
        type: "set",
        valueType,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodEnum = core.$constructor("ZodEnum", (inst, def) => {
      core.$ZodEnum.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.enum = def.entries;
      inst.options = Object.values(def.entries);
      const keys = new Set(Object.keys(def.entries));
      inst.extract = (values, params) => {
        const newEntries = {};
        for (const value of values) {
          if (keys.has(value)) {
            newEntries[value] = def.entries[value];
          } else
            throw new Error(`Key ${value} not found in enum`);
        }
        return new exports.ZodEnum({
          ...def,
          checks: [],
          ...index_js_1.util.normalizeParams(params),
          entries: newEntries
        });
      };
      inst.exclude = (values, params) => {
        const newEntries = { ...def.entries };
        for (const value of values) {
          if (keys.has(value)) {
            delete newEntries[value];
          } else
            throw new Error(`Key ${value} not found in enum`);
        }
        return new exports.ZodEnum({
          ...def,
          checks: [],
          ...index_js_1.util.normalizeParams(params),
          entries: newEntries
        });
      };
    });
    function _enum(values, params) {
      const entries = Array.isArray(values) ? Object.fromEntries(values.map((v) => [v, v])) : values;
      return new exports.ZodEnum({
        type: "enum",
        entries,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    function nativeEnum(entries, params) {
      return new exports.ZodEnum({
        type: "enum",
        entries,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodLiteral = core.$constructor("ZodLiteral", (inst, def) => {
      core.$ZodLiteral.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.values = new Set(def.values);
      Object.defineProperty(inst, "value", {
        get() {
          if (def.values.length > 1) {
            throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
          }
          return def.values[0];
        }
      });
    });
    function literal(value, params) {
      return new exports.ZodLiteral({
        type: "literal",
        values: Array.isArray(value) ? value : [value],
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodFile = core.$constructor("ZodFile", (inst, def) => {
      core.$ZodFile.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.min = (size, params) => inst.check(core._minSize(size, params));
      inst.max = (size, params) => inst.check(core._maxSize(size, params));
      inst.mime = (types, params) => inst.check(core._mime(Array.isArray(types) ? types : [types], params));
    });
    function file(params) {
      return core._file(exports.ZodFile, params);
    }
    exports.ZodTransform = core.$constructor("ZodTransform", (inst, def) => {
      core.$ZodTransform.init(inst, def);
      exports.ZodType.init(inst, def);
      inst._zod.parse = (payload, _ctx) => {
        payload.addIssue = (issue) => {
          if (typeof issue === "string") {
            payload.issues.push(index_js_1.util.issue(issue, payload.value, def));
          } else {
            const _issue = issue;
            if (_issue.fatal)
              _issue.continue = false;
            _issue.code ?? (_issue.code = "custom");
            _issue.input ?? (_issue.input = payload.value);
            _issue.inst ?? (_issue.inst = inst);
            _issue.continue ?? (_issue.continue = true);
            payload.issues.push(index_js_1.util.issue(_issue));
          }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) {
          return output.then((output2) => {
            payload.value = output2;
            return payload;
          });
        }
        payload.value = output;
        return payload;
      };
    });
    function transform(fn) {
      return new exports.ZodTransform({
        type: "transform",
        transform: fn
      });
    }
    exports.ZodOptional = core.$constructor("ZodOptional", (inst, def) => {
      core.$ZodOptional.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function optional(innerType) {
      return new exports.ZodOptional({
        type: "optional",
        innerType
      });
    }
    exports.ZodNullable = core.$constructor("ZodNullable", (inst, def) => {
      core.$ZodNullable.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function nullable(innerType) {
      return new exports.ZodNullable({
        type: "nullable",
        innerType
      });
    }
    function nullish(innerType) {
      return optional(nullable(innerType));
    }
    exports.ZodDefault = core.$constructor("ZodDefault", (inst, def) => {
      core.$ZodDefault.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
      inst.removeDefault = inst.unwrap;
    });
    function _default(innerType, defaultValue) {
      return new exports.ZodDefault({
        type: "default",
        innerType,
        get defaultValue() {
          return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        }
      });
    }
    exports.ZodPrefault = core.$constructor("ZodPrefault", (inst, def) => {
      core.$ZodPrefault.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function prefault(innerType, defaultValue) {
      return new exports.ZodPrefault({
        type: "prefault",
        innerType,
        get defaultValue() {
          return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        }
      });
    }
    exports.ZodNonOptional = core.$constructor("ZodNonOptional", (inst, def) => {
      core.$ZodNonOptional.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function nonoptional(innerType, params) {
      return new exports.ZodNonOptional({
        type: "nonoptional",
        innerType,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodSuccess = core.$constructor("ZodSuccess", (inst, def) => {
      core.$ZodSuccess.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function success(innerType) {
      return new exports.ZodSuccess({
        type: "success",
        innerType
      });
    }
    exports.ZodCatch = core.$constructor("ZodCatch", (inst, def) => {
      core.$ZodCatch.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
      inst.removeCatch = inst.unwrap;
    });
    function _catch(innerType, catchValue) {
      return new exports.ZodCatch({
        type: "catch",
        innerType,
        catchValue: typeof catchValue === "function" ? catchValue : () => catchValue
      });
    }
    exports.ZodNaN = core.$constructor("ZodNaN", (inst, def) => {
      core.$ZodNaN.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function nan(params) {
      return core._nan(exports.ZodNaN, params);
    }
    exports.ZodPipe = core.$constructor("ZodPipe", (inst, def) => {
      core.$ZodPipe.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.in = def.in;
      inst.out = def.out;
    });
    function pipe(in_, out) {
      return new exports.ZodPipe({
        type: "pipe",
        in: in_,
        out
        // ...util.normalizeParams(params),
      });
    }
    exports.ZodReadonly = core.$constructor("ZodReadonly", (inst, def) => {
      core.$ZodReadonly.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function readonly(innerType) {
      return new exports.ZodReadonly({
        type: "readonly",
        innerType
      });
    }
    exports.ZodTemplateLiteral = core.$constructor("ZodTemplateLiteral", (inst, def) => {
      core.$ZodTemplateLiteral.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function templateLiteral(parts, params) {
      return new exports.ZodTemplateLiteral({
        type: "template_literal",
        parts,
        ...index_js_1.util.normalizeParams(params)
      });
    }
    exports.ZodLazy = core.$constructor("ZodLazy", (inst, def) => {
      core.$ZodLazy.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.getter();
    });
    function lazy(getter) {
      return new exports.ZodLazy({
        type: "lazy",
        getter
      });
    }
    exports.ZodPromise = core.$constructor("ZodPromise", (inst, def) => {
      core.$ZodPromise.init(inst, def);
      exports.ZodType.init(inst, def);
      inst.unwrap = () => inst._zod.def.innerType;
    });
    function promise(innerType) {
      return new exports.ZodPromise({
        type: "promise",
        innerType
      });
    }
    exports.ZodCustom = core.$constructor("ZodCustom", (inst, def) => {
      core.$ZodCustom.init(inst, def);
      exports.ZodType.init(inst, def);
    });
    function check(fn) {
      const ch = new core.$ZodCheck({
        check: "custom"
        // ...util.normalizeParams(params),
      });
      ch._zod.check = fn;
      return ch;
    }
    function custom(fn, _params) {
      return core._custom(exports.ZodCustom, fn ?? (() => true), _params);
    }
    function refine(fn, _params = {}) {
      return core._refine(exports.ZodCustom, fn, _params);
    }
    function superRefine(fn) {
      const ch = check((payload) => {
        payload.addIssue = (issue) => {
          if (typeof issue === "string") {
            payload.issues.push(index_js_1.util.issue(issue, payload.value, ch._zod.def));
          } else {
            const _issue = issue;
            if (_issue.fatal)
              _issue.continue = false;
            _issue.code ?? (_issue.code = "custom");
            _issue.input ?? (_issue.input = payload.value);
            _issue.inst ?? (_issue.inst = ch);
            _issue.continue ?? (_issue.continue = !ch._zod.def.abort);
            payload.issues.push(index_js_1.util.issue(_issue));
          }
        };
        return fn(payload.value, payload);
      });
      return ch;
    }
    function _instanceof(cls, params = {
      error: `Input not instance of ${cls.name}`
    }) {
      const inst = new exports.ZodCustom({
        type: "custom",
        check: "custom",
        fn: (data) => data instanceof cls,
        abort: true,
        ...index_js_1.util.normalizeParams(params)
      });
      inst._zod.bag.Class = cls;
      return inst;
    }
    var stringbool = (...args) => core._stringbool({
      Pipe: exports.ZodPipe,
      Boolean: exports.ZodBoolean,
      String: exports.ZodString,
      Transform: exports.ZodTransform
    }, ...args);
    exports.stringbool = stringbool;
    function json(params) {
      const jsonSchema = lazy(() => {
        return union([string(params), number(), boolean(), _null(), array(jsonSchema), record(string(), jsonSchema)]);
      });
      return jsonSchema;
    }
    function preprocess(fn, schema) {
      return pipe(transform(fn), schema);
    }
  }
});

// ../../node_modules/zod/v4/classic/compat.cjs
var require_compat = __commonJS({
  "../../node_modules/zod/v4/classic/compat.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.config = exports.$brand = exports.ZodIssueCode = void 0;
    exports.setErrorMap = setErrorMap;
    exports.getErrorMap = getErrorMap;
    var core = __importStar(require_core2());
    exports.ZodIssueCode = {
      invalid_type: "invalid_type",
      too_big: "too_big",
      too_small: "too_small",
      invalid_format: "invalid_format",
      not_multiple_of: "not_multiple_of",
      unrecognized_keys: "unrecognized_keys",
      invalid_union: "invalid_union",
      invalid_key: "invalid_key",
      invalid_element: "invalid_element",
      invalid_value: "invalid_value",
      custom: "custom"
    };
    var index_js_1 = require_core2();
    Object.defineProperty(exports, "$brand", { enumerable: true, get: function() {
      return index_js_1.$brand;
    } });
    Object.defineProperty(exports, "config", { enumerable: true, get: function() {
      return index_js_1.config;
    } });
    function setErrorMap(map) {
      core.config({
        customError: map
      });
    }
    function getErrorMap() {
      return core.config().customError;
    }
  }
});

// ../../node_modules/zod/v4/classic/coerce.cjs
var require_coerce = __commonJS({
  "../../node_modules/zod/v4/classic/coerce.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.string = string;
    exports.number = number;
    exports.boolean = boolean;
    exports.bigint = bigint;
    exports.date = date;
    var core = __importStar(require_core2());
    var schemas = __importStar(require_schemas2());
    function string(params) {
      return core._coercedString(schemas.ZodString, params);
    }
    function number(params) {
      return core._coercedNumber(schemas.ZodNumber, params);
    }
    function boolean(params) {
      return core._coercedBoolean(schemas.ZodBoolean, params);
    }
    function bigint(params) {
      return core._coercedBigint(schemas.ZodBigInt, params);
    }
    function date(params) {
      return core._coercedDate(schemas.ZodDate, params);
    }
  }
});

// ../../node_modules/zod/v4/classic/external.cjs
var require_external = __commonJS({
  "../../node_modules/zod/v4/classic/external.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.coerce = exports.iso = exports.ZodISODuration = exports.ZodISOTime = exports.ZodISODate = exports.ZodISODateTime = exports.locales = exports.NEVER = exports.TimePrecision = exports.toJSONSchema = exports.flattenError = exports.formatError = exports.prettifyError = exports.treeifyError = exports.regexes = exports.clone = exports.$brand = exports.$input = exports.$output = exports.function = exports.config = exports.registry = exports.globalRegistry = exports.core = void 0;
    exports.core = __importStar(require_core2());
    __exportStar(require_schemas2(), exports);
    __exportStar(require_checks2(), exports);
    __exportStar(require_errors2(), exports);
    __exportStar(require_parse2(), exports);
    __exportStar(require_compat(), exports);
    var index_js_1 = require_core2();
    var en_js_1 = __importDefault(require_en());
    (0, index_js_1.config)((0, en_js_1.default)());
    var index_js_2 = require_core2();
    Object.defineProperty(exports, "globalRegistry", { enumerable: true, get: function() {
      return index_js_2.globalRegistry;
    } });
    Object.defineProperty(exports, "registry", { enumerable: true, get: function() {
      return index_js_2.registry;
    } });
    Object.defineProperty(exports, "config", { enumerable: true, get: function() {
      return index_js_2.config;
    } });
    Object.defineProperty(exports, "function", { enumerable: true, get: function() {
      return index_js_2.function;
    } });
    Object.defineProperty(exports, "$output", { enumerable: true, get: function() {
      return index_js_2.$output;
    } });
    Object.defineProperty(exports, "$input", { enumerable: true, get: function() {
      return index_js_2.$input;
    } });
    Object.defineProperty(exports, "$brand", { enumerable: true, get: function() {
      return index_js_2.$brand;
    } });
    Object.defineProperty(exports, "clone", { enumerable: true, get: function() {
      return index_js_2.clone;
    } });
    Object.defineProperty(exports, "regexes", { enumerable: true, get: function() {
      return index_js_2.regexes;
    } });
    Object.defineProperty(exports, "treeifyError", { enumerable: true, get: function() {
      return index_js_2.treeifyError;
    } });
    Object.defineProperty(exports, "prettifyError", { enumerable: true, get: function() {
      return index_js_2.prettifyError;
    } });
    Object.defineProperty(exports, "formatError", { enumerable: true, get: function() {
      return index_js_2.formatError;
    } });
    Object.defineProperty(exports, "flattenError", { enumerable: true, get: function() {
      return index_js_2.flattenError;
    } });
    Object.defineProperty(exports, "toJSONSchema", { enumerable: true, get: function() {
      return index_js_2.toJSONSchema;
    } });
    Object.defineProperty(exports, "TimePrecision", { enumerable: true, get: function() {
      return index_js_2.TimePrecision;
    } });
    Object.defineProperty(exports, "NEVER", { enumerable: true, get: function() {
      return index_js_2.NEVER;
    } });
    exports.locales = __importStar(require_locales());
    var iso_js_1 = require_iso();
    Object.defineProperty(exports, "ZodISODateTime", { enumerable: true, get: function() {
      return iso_js_1.ZodISODateTime;
    } });
    Object.defineProperty(exports, "ZodISODate", { enumerable: true, get: function() {
      return iso_js_1.ZodISODate;
    } });
    Object.defineProperty(exports, "ZodISOTime", { enumerable: true, get: function() {
      return iso_js_1.ZodISOTime;
    } });
    Object.defineProperty(exports, "ZodISODuration", { enumerable: true, get: function() {
      return iso_js_1.ZodISODuration;
    } });
    exports.iso = __importStar(require_iso());
    exports.coerce = __importStar(require_coerce());
  }
});

// ../../node_modules/zod/v4/classic/index.cjs
var require_classic = __commonJS({
  "../../node_modules/zod/v4/classic/index.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.z = void 0;
    var z = __importStar(require_external());
    exports.z = z;
    __exportStar(require_external(), exports);
    exports.default = z;
  }
});

// ../../node_modules/zod/v4/index.cjs
var require_v4 = __commonJS({
  "../../node_modules/zod/v4/index.cjs"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var index_js_1 = __importDefault(require_classic());
    __exportStar(require_classic(), exports);
    exports.default = index_js_1.default;
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/aipo/aipoConfigRecord.js
var require_aipoConfigRecord = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/aipo/aipoConfigRecord.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AipoMinimalRecordSchema = exports.AipoConfigRecordSchema = exports.AipoRenewalSettingsSchema = exports.AipoRenewalPriceIncreaseSchema = exports.AipoConfigurableUpfrontDimensionRatesSchema = exports.AipoDimensionRateSchema = exports.PAYMENT_SCHEDULE_FREQUENCY_MONTHS = exports.AipoPaymentScheduleFrequencySchema = void 0;
    var v4_1 = require_v4();
    exports.AipoPaymentScheduleFrequencySchema = v4_1.z.enum(["MONTHLY", "QUARTERLY", "ANNUALLY"]);
    exports.PAYMENT_SCHEDULE_FREQUENCY_MONTHS = {
      MONTHLY: 1,
      QUARTERLY: 3,
      ANNUALLY: 12
    };
    exports.AipoDimensionRateSchema = v4_1.z.object({
      dimensionKey: v4_1.z.string(),
      price: v4_1.z.number().min(0)
    });
    exports.AipoConfigurableUpfrontDimensionRatesSchema = v4_1.z.object({
      duration: v4_1.z.string(),
      dimensionRates: v4_1.z.array(exports.AipoDimensionRateSchema)
    });
    exports.AipoRenewalPriceIncreaseSchema = v4_1.z.discriminatedUnion("type", [
      v4_1.z.object({ type: v4_1.z.literal("FixedPercentage"), value: v4_1.z.string() }),
      v4_1.z.object({
        type: v4_1.z.literal("PercentageRange"),
        rangeConfiguration: v4_1.z.object({
          minValue: v4_1.z.string(),
          maxValue: v4_1.z.string(),
          defaultValue: v4_1.z.string()
        }),
        adjustmentDeadline: v4_1.z.string().optional()
      })
    ]);
    exports.AipoRenewalSettingsSchema = v4_1.z.object({
      maxRenewals: v4_1.z.number().int().min(1).optional(),
      lockoutPeriod: v4_1.z.string().optional(),
      priceIncrease: exports.AipoRenewalPriceIncreaseSchema
    });
    exports.AipoConfigRecordSchema = v4_1.z.object({
      productId: v4_1.z.string(),
      sellerAwsAccountId: v4_1.z.string().regex(/^\d{12}$/),
      eulaType: v4_1.z.enum(["PUBLIC_OFFER_EULA", "STANDARD_CONTRACT_MARKETPLACE"]),
      eulaOfferId: v4_1.z.string().optional(),
      maxDiscountPercentage: v4_1.z.number().int().min(0).max(100),
      minTotalContractValue: v4_1.z.number().min(0).optional(),
      maxTotalContractValue: v4_1.z.number().min(0),
      minOfferDuration: v4_1.z.string(),
      maxOfferDuration: v4_1.z.string(),
      expiration: v4_1.z.string(),
      maxFutureStartDuration: v4_1.z.string(),
      currencyCode: v4_1.z.literal("USD"),
      configurableUpfrontDimensionRates: exports.AipoConfigurableUpfrontDimensionRatesSchema,
      usageDimensionOfferId: v4_1.z.string().optional(),
      sellerInstructions: v4_1.z.string(),
      createdAt: v4_1.z.string(),
      statusUpdatedAt: v4_1.z.string(),
      status: v4_1.z.enum(["PENDING", "ACTIVE", "FAILED"]),
      capiEntityId: v4_1.z.string().optional(),
      capiEntityRevision: v4_1.z.string().optional(),
      trackerRequestId: v4_1.z.string().optional(),
      allowedFrequencies: v4_1.z.array(exports.AipoPaymentScheduleFrequencySchema).optional(),
      initialPaymentAllowed: v4_1.z.boolean().optional(),
      renewalSettings: exports.AipoRenewalSettingsSchema.optional(),
      version: v4_1.z.number().int().min(1)
    });
    exports.AipoMinimalRecordSchema = v4_1.z.object({
      productId: v4_1.z.string(),
      capiEntityId: v4_1.z.string(),
      version: v4_1.z.number().int().min(1)
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/aipo/aipoRequestTracker.js
var require_aipoRequestTracker = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/aipo/aipoRequestTracker.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AipoRequestTrackerRecordSchema = exports.TrackerSource = exports.TrackerOfferStatusReason = exports.TrackerOfferStatus = exports.TrackerOfferType = void 0;
    var v4_1 = require_v4();
    exports.TrackerOfferType = {
      SELLER_CONFIGURATION_OFFER: "SELLER_CONFIGURATION_OFFER",
      BUYER_OFFER: "BUYER_OFFER"
    };
    exports.TrackerOfferStatus = {
      PENDING: "PENDING",
      SUCCEEDED: "SUCCEEDED",
      FAILED: "FAILED"
    };
    exports.TrackerOfferStatusReason = {
      SELLER_CONFIGURATION_OFFER_FAILED: "SELLER_CONFIGURATION_OFFER_FAILED",
      SELLER_CONFIGURATION_OFFER_TIMEOUT: "SELLER_CONFIGURATION_OFFER_TIMEOUT",
      BUYER_OFFER_FAILED: "BUYER_OFFER_FAILED",
      BUYER_OFFER_TIMEOUT: "BUYER_OFFER_TIMEOUT",
      OTHER: "OTHER"
    };
    exports.TrackerSource = {
      EPOW: "EPOW"
    };
    exports.AipoRequestTrackerRecordSchema = v4_1.z.object({
      requestId: v4_1.z.string(),
      buyerIdProductIdSellerId: v4_1.z.string(),
      buyerId: v4_1.z.string(),
      productId: v4_1.z.string(),
      sellerId: v4_1.z.string(),
      createdAt: v4_1.z.string(),
      listPrice: v4_1.z.number(),
      discountedPrice: v4_1.z.number(),
      requestedDiscountPercentage: v4_1.z.number(),
      appliedDiscountPercentage: v4_1.z.number(),
      requestedDuration: v4_1.z.string(),
      currencyCode: v4_1.z.string(),
      offerStatus: v4_1.z.enum([exports.TrackerOfferStatus.PENDING, exports.TrackerOfferStatus.SUCCEEDED, exports.TrackerOfferStatus.FAILED]),
      changesetId: v4_1.z.string(),
      offerType: v4_1.z.enum([exports.TrackerOfferType.SELLER_CONFIGURATION_OFFER, exports.TrackerOfferType.BUYER_OFFER]),
      offerStatusReason: v4_1.z.enum([
        exports.TrackerOfferStatusReason.SELLER_CONFIGURATION_OFFER_FAILED,
        exports.TrackerOfferStatusReason.SELLER_CONFIGURATION_OFFER_TIMEOUT,
        exports.TrackerOfferStatusReason.BUYER_OFFER_FAILED,
        exports.TrackerOfferStatusReason.BUYER_OFFER_TIMEOUT,
        exports.TrackerOfferStatusReason.OTHER
      ]).optional(),
      dlqSentAt: v4_1.z.string().optional(),
      offerId: v4_1.z.string().optional(),
      futureStartDate: v4_1.z.string().optional(),
      source: v4_1.z.enum([exports.TrackerSource.EPOW]).optional(),
      capiEntityId: v4_1.z.string().optional(),
      version: v4_1.z.number().int().min(1)
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/capiEpocChangeTypes.js
var require_capiEpocChangeTypes = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/capiEpocChangeTypes.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaystoneTokenChangeType = exports.CapiTokenChangeType = exports.EpocChangeType = void 0;
    exports.EpocChangeType = {
      CreateExpressPrivateOfferConfiguration: "CreateExpressPrivateOfferConfiguration",
      DeleteExpressPrivateOfferConfiguration: "DeleteExpressPrivateOfferConfiguration",
      DeprecateExpressPrivateOfferConfiguration: "DeprecateExpressPrivateOfferConfiguration",
      BackfillCreateInternal: "BackfillCreateInternal",
      BackfillDeprecateInternal: "BackfillDeprecateInternal",
      UpdatePricing: "UpdatePricing",
      UpdateOfferSettings: "UpdateOfferSettings",
      UpdatePaymentSchedule: "UpdatePaymentSchedule",
      UpdateRenewal: "UpdateRenewal"
    };
    exports.CapiTokenChangeType = {
      CreateAgentTokenContainer: "CreateAgentTokenContainer",
      RequestExpressPrivateOffer: "RequestExpressPrivateOffer"
    };
    exports.WaystoneTokenChangeType = {
      CreateMaxAccessTokens: "CreateMaxAccessTokens",
      DecrementTokenInternal: "DecrementTokenInternal"
    };
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/stages.js
var require_stages = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/stages.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Stage = void 0;
    exports.Stage = {
      LOCAL: "local",
      ALPHA: "alpha",
      GAMMA: "gamma",
      PRE_PROD: "pre-prod",
      PROD: "prod"
    };
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/accounts.js
var require_accounts = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/accounts.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AIPO_REQUEST_TRACKER_TABLE_NAME = exports.ALL_TEST_SELLER_ACCOUNT_IDS = exports.OTHER_TEST_SELLER_ACCOUNT_IDS = exports.BUG_BASH_ACCOUNTS = exports.EPOW_TEST_SELLER_ACCOUNT_IDS = exports.MAX_SELLER_TEST_ACCOUNTS = exports.TEST_SELLER_ACCOUNT_IDS = exports.AIPO_INTEG_TEST_ACCOUNTS = exports.AIPO_CANARY_TEST_ACCOUNTS = exports.EPOW_CANARY_SELLER_ACCOUNTS = exports.EPOW_INTEG_TEST_ACCOUNTS = exports.AIPO_SERVICE_ACCOUNTS = void 0;
    exports.isKnownTestSellerAccount = isKnownTestSellerAccount;
    exports.AIPO_SERVICE_ACCOUNTS = {
      local: ["668227158085"],
      alpha: ["668227158085"],
      gamma: ["363155825176"],
      "pre-prod": ["039814968972"],
      prod: ["039814968972", "298249408882"]
    };
    exports.EPOW_INTEG_TEST_ACCOUNTS = {
      alpha: "430602287244",
      gamma: "606103597368"
    };
    exports.EPOW_CANARY_SELLER_ACCOUNTS = {
      alpha: "326269142588",
      gamma: "946952788114",
      prod: "937554352335"
    };
    exports.AIPO_CANARY_TEST_ACCOUNTS = {
      alpha: "577165020473",
      gamma: "927374823955",
      "pre-prod": "784059519111",
      prod: "882872689044"
    };
    exports.AIPO_INTEG_TEST_ACCOUNTS = {
      alpha: "458950492854",
      gamma: "341319229250",
      "pre-prod": "471372921774",
      prod: "816892137641"
    };
    exports.TEST_SELLER_ACCOUNT_IDS = /* @__PURE__ */ new Set([
      "030886884671",
      // aws-mp-legoland+aipo-test-seller-integ-test@amazon.com
      "014869289566"
      // aws-mp-legoland+aipo-test-seller-canary@amazon.com
    ]);
    exports.MAX_SELLER_TEST_ACCOUNTS = /* @__PURE__ */ new Set([
      "424522917739",
      // amps-catalog-epo-eng+epo-max-canary-seller-alpha@amazon.com
      "093359840243",
      // amps-catalog-epo-eng+epo-max-canary-seller-gamma@amazon.com
      "217508296284",
      // amps-catalog-epo-eng+epo-max-canary-seller-pre-pro@amazon.com
      "808765743577",
      // amps-catalog-epo-eng+epo-max-canary-seller-prod@amazon.com
      "251200161960",
      // amps-catalog-epo-eng+epo-max-integ-seller-alpha@amazon.com
      "944765968889",
      // amps-catalog-epo-eng+epo-max-integ-seller-gamma@amazon.com
      "877231425747",
      // amps-catalog-epo-eng+epo-max-integ-seller-pre-prod@amazon.com
      "844347864690",
      // amps-catalog-epo-eng+epo-max-integ-seller-prod@amazon.com
      "377876718136"
      // amps-catalog-epo-eng+epo-max-seller-local-dev-1@amazon.com
    ]);
    exports.EPOW_TEST_SELLER_ACCOUNT_IDS = new Set([...Object.values(exports.EPOW_CANARY_SELLER_ACCOUNTS), ...Object.values(exports.EPOW_INTEG_TEST_ACCOUNTS)].filter((accountId) => accountId !== void 0));
    exports.BUG_BASH_ACCOUNTS = /* @__PURE__ */ new Set([
      "088594415230",
      // aws-mp-legoland+aipo-test-seller-1@amazon.com
      "854698772211",
      // aws-mp-legoland+aipo-test-seller-2@amazon.com
      "137452617528",
      // aws-mp-legoland+aipo-test-seller-3@amazon.com
      "271297707035",
      // aws-mp-legoland+aipo-test-seller-4@amazon.com
      "913378705422",
      // aws-mp-legoland+aipo-test-seller-max@amazon.com
      "598821842563",
      // aws-mp-legoland+aipo-mcm-test-seller-1@amazon.com
      "954894834308",
      // aws-mp-legoland+aipo-mcm-test-seller-2@amazon.com
      "139775101108",
      // amps-catalog-epo-eng+aipo-test-seller-5@amazon.com
      "768396678421",
      // amps-catalog-epo-eng+aipo-test-seller-6@amazon.com
      "074926209215",
      // amps-catalog-epo-eng+aipo-test-seller-7@amazon.com
      "821014378930",
      // amps-catalog-epo-eng+aipo-test-seller-8@amazon.com
      "210855481904"
      // amps-catalog-epo-eng+aipo-test-seller-9@amazon.com
    ]);
    exports.OTHER_TEST_SELLER_ACCOUNT_IDS = /* @__PURE__ */ new Set([
      "058264409059"
      // borrowed ACE test seller (leads-capture campaign registry)
    ]);
    exports.ALL_TEST_SELLER_ACCOUNT_IDS = /* @__PURE__ */ new Set([
      ...exports.TEST_SELLER_ACCOUNT_IDS,
      ...exports.MAX_SELLER_TEST_ACCOUNTS,
      ...exports.EPOW_TEST_SELLER_ACCOUNT_IDS,
      ...exports.BUG_BASH_ACCOUNTS,
      ...exports.OTHER_TEST_SELLER_ACCOUNT_IDS
    ]);
    function isKnownTestSellerAccount(accountId) {
      return exports.ALL_TEST_SELLER_ACCOUNT_IDS.has(accountId);
    }
    exports.AIPO_REQUEST_TRACKER_TABLE_NAME = "AIPORequestTrackerTable";
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/servicePrincipals.js
var require_servicePrincipals = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/servicePrincipals.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AIPO_SERVICE_PRINCIPAL_NAMES = exports.EPOW_SERVICE_PRINCIPAL_NAMES = exports.CAPI_SERVICE_PRINCIPALS = void 0;
    exports.CAPI_SERVICE_PRINCIPALS = {
      local: ["catalog.marketplace.aws.internal"],
      alpha: ["catalog.marketplace.aws.internal"],
      gamma: ["catalog.marketplace.aws.internal", "marketplacecatalog.amazonaws.com"],
      "pre-prod": ["marketplacecatalog.amazonaws.com"],
      prod: ["marketplacecatalog.amazonaws.com"]
    };
    exports.EPOW_SERVICE_PRINCIPAL_NAMES = {
      local: ["developer.legoland.aws.internal", "developer.epo.marketplace.aws.internal"],
      alpha: ["alpha.waystone.epo.marketplace.aws.internal"],
      gamma: ["gamma.waystone.epo.marketplace.aws.internal"],
      "pre-prod": ["prod.waystone.epo.marketplace.aws.internal"],
      prod: ["prod.waystone.epo.marketplace.aws.internal"]
    };
    exports.AIPO_SERVICE_PRINCIPAL_NAMES = {
      local: ["developer.legoland.aws.internal", "developer.epo.marketplace.aws.internal"],
      alpha: ["aws-mp-aipo-service-alpha.aws.internal"],
      gamma: ["aws-mp-aipo-service-gamma.aws.internal"],
      "pre-prod": ["aws-mp-aipo-service-pre-prod.aws.internal"],
      prod: ["aws-mp-aipo-service-prod.aws.internal"]
    };
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/waystoneDomains.js
var require_waystoneDomains = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/waystoneDomains.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EPOC_WAYSTONE_DOMAINS = void 0;
    exports.EPOC_WAYSTONE_DOMAINS = {
      local: "aws.marketplace.sandbox",
      alpha: "aws.marketplace.changetype.beta.iad",
      gamma: "aws.marketplace.changetype.gamma.iad",
      "pre-prod": "aws.marketplace.commercial.prod.iad",
      prod: "aws.marketplace.commercial.prod.iad"
    };
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/capiEndpoints.js
var require_capiEndpoints = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/capiEndpoints.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getCapiEndpoint = getCapiEndpoint;
    function getCapiEndpoint(stage) {
      switch (stage) {
        case "local":
        case "alpha":
          return "https://catalog-beta.marketplace.us-east-1.amazonaws.com";
        case "gamma":
          return "https://catalog-gamma.marketplace.us-east-1.amazonaws.com";
        case "pre-prod":
        case "prod":
          return "https://catalog.marketplace.us-east-1.amazonaws.com";
      }
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/capiCatalog.js
var require_capiCatalog = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/capiCatalog.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CAPI_CATALOG = void 0;
    exports.CAPI_CATALOG = "AWSMarketplace";
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/epocEntity.js
var require_epocEntity = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/epocEntity.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EPOC_ENTITY_TYPE_MINOR_VERSION = exports.EPOC_ENTITY_TYPE_MAJOR_VERSION = exports.EPOC_ENTITY_TYPE_NAME = void 0;
    exports.EPOC_ENTITY_TYPE_NAME = "com.amazonaws.marketplace.entities.configurations.ExpressPrivateOfferConfiguration";
    exports.EPOC_ENTITY_TYPE_MAJOR_VERSION = "1";
    exports.EPOC_ENTITY_TYPE_MINOR_VERSION = "0";
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/validation.js
var require_validation = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/validation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EpocValidation = void 0;
    exports.calculateMaxFutureStartDays = calculateMaxFutureStartDays;
    exports.EpocValidation = {
      // Offer duration
      MIN_OFFER_DURATION_MONTHS: 1,
      MAX_OFFER_DURATION_MONTHS: 60,
      // Expiration
      MIN_EXPIRATION_DAYS: 1,
      MAX_EXPIRATION_DAYS: 365,
      // Future start duration
      MAX_FUTURE_START_DURATION_YEARS: 3,
      MAX_FUTURE_START_BUFFER_DAYS: 1,
      // Contract value
      MAX_TOTAL_CONTRACT_VALUE: 1e6,
      // Discount percentage
      MIN_DISCOUNT_PERCENTAGE: 0,
      MAX_DISCOUNT_PERCENTAGE: 100,
      // Price validation
      MAX_DIMENSION_PRICE: 1e6,
      MAX_PRICE_DECIMAL_PLACES: 8,
      MAX_PRICE_SIGNIFICANT_DIGITS: 15,
      // Configurable upfront rate
      CONFIGURABLE_UPFRONT_RATE_DURATION: "P1M",
      // Tier limits
      MAX_TCV_DISCOUNT_TIERS: 10,
      MAX_DISCOUNT_TIERS_PER_DIMENSION: 5,
      MAX_TOTAL_DIMENSION_TIERS: 25,
      // Dimension limits
      MAX_DIMENSIONS: 25,
      // Qualification limits
      MAX_QUALIFICATIONS: 5,
      // String length limits
      MAX_ID_LENGTH: 100,
      MAX_NAME_LENGTH: 256,
      MAX_DESCRIPTION_LENGTH: 1e3,
      MAX_QUALIFICATION_DETAIL_LENGTH: 1e3,
      MAX_QUESTION_LENGTH: 1e3,
      MAX_EXAMPLE_RESPONSE_LENGTH: 1e3
    };
    function calculateMaxFutureStartDays(expirationDays) {
      const maxTotalDays = exports.EpocValidation.MAX_FUTURE_START_DURATION_YEARS * 365;
      return maxTotalDays - expirationDays - exports.EpocValidation.MAX_FUTURE_START_BUFFER_DAYS;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/constants/index.js
var require_constants = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/constants/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.calculateMaxFutureStartDays = exports.EpocValidation = exports.EPOC_ENTITY_TYPE_MINOR_VERSION = exports.EPOC_ENTITY_TYPE_MAJOR_VERSION = exports.EPOC_ENTITY_TYPE_NAME = exports.CAPI_CATALOG = exports.getCapiEndpoint = exports.EPOC_WAYSTONE_DOMAINS = exports.EPOW_SERVICE_PRINCIPAL_NAMES = exports.CAPI_SERVICE_PRINCIPALS = exports.AIPO_SERVICE_PRINCIPAL_NAMES = exports.isKnownTestSellerAccount = exports.TEST_SELLER_ACCOUNT_IDS = exports.OTHER_TEST_SELLER_ACCOUNT_IDS = exports.MAX_SELLER_TEST_ACCOUNTS = exports.EPOW_INTEG_TEST_ACCOUNTS = exports.EPOW_CANARY_SELLER_ACCOUNTS = exports.BUG_BASH_ACCOUNTS = exports.ALL_TEST_SELLER_ACCOUNT_IDS = exports.AIPO_SERVICE_ACCOUNTS = exports.AIPO_REQUEST_TRACKER_TABLE_NAME = exports.AIPO_INTEG_TEST_ACCOUNTS = exports.AIPO_CANARY_TEST_ACCOUNTS = exports.Stage = void 0;
    var stages_1 = require_stages();
    Object.defineProperty(exports, "Stage", { enumerable: true, get: function() {
      return stages_1.Stage;
    } });
    var accounts_1 = require_accounts();
    Object.defineProperty(exports, "AIPO_CANARY_TEST_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.AIPO_CANARY_TEST_ACCOUNTS;
    } });
    Object.defineProperty(exports, "AIPO_INTEG_TEST_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.AIPO_INTEG_TEST_ACCOUNTS;
    } });
    Object.defineProperty(exports, "AIPO_REQUEST_TRACKER_TABLE_NAME", { enumerable: true, get: function() {
      return accounts_1.AIPO_REQUEST_TRACKER_TABLE_NAME;
    } });
    Object.defineProperty(exports, "AIPO_SERVICE_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.AIPO_SERVICE_ACCOUNTS;
    } });
    Object.defineProperty(exports, "ALL_TEST_SELLER_ACCOUNT_IDS", { enumerable: true, get: function() {
      return accounts_1.ALL_TEST_SELLER_ACCOUNT_IDS;
    } });
    Object.defineProperty(exports, "BUG_BASH_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.BUG_BASH_ACCOUNTS;
    } });
    Object.defineProperty(exports, "EPOW_CANARY_SELLER_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.EPOW_CANARY_SELLER_ACCOUNTS;
    } });
    Object.defineProperty(exports, "EPOW_INTEG_TEST_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.EPOW_INTEG_TEST_ACCOUNTS;
    } });
    Object.defineProperty(exports, "MAX_SELLER_TEST_ACCOUNTS", { enumerable: true, get: function() {
      return accounts_1.MAX_SELLER_TEST_ACCOUNTS;
    } });
    Object.defineProperty(exports, "OTHER_TEST_SELLER_ACCOUNT_IDS", { enumerable: true, get: function() {
      return accounts_1.OTHER_TEST_SELLER_ACCOUNT_IDS;
    } });
    Object.defineProperty(exports, "TEST_SELLER_ACCOUNT_IDS", { enumerable: true, get: function() {
      return accounts_1.TEST_SELLER_ACCOUNT_IDS;
    } });
    Object.defineProperty(exports, "isKnownTestSellerAccount", { enumerable: true, get: function() {
      return accounts_1.isKnownTestSellerAccount;
    } });
    var servicePrincipals_1 = require_servicePrincipals();
    Object.defineProperty(exports, "AIPO_SERVICE_PRINCIPAL_NAMES", { enumerable: true, get: function() {
      return servicePrincipals_1.AIPO_SERVICE_PRINCIPAL_NAMES;
    } });
    Object.defineProperty(exports, "CAPI_SERVICE_PRINCIPALS", { enumerable: true, get: function() {
      return servicePrincipals_1.CAPI_SERVICE_PRINCIPALS;
    } });
    Object.defineProperty(exports, "EPOW_SERVICE_PRINCIPAL_NAMES", { enumerable: true, get: function() {
      return servicePrincipals_1.EPOW_SERVICE_PRINCIPAL_NAMES;
    } });
    var waystoneDomains_1 = require_waystoneDomains();
    Object.defineProperty(exports, "EPOC_WAYSTONE_DOMAINS", { enumerable: true, get: function() {
      return waystoneDomains_1.EPOC_WAYSTONE_DOMAINS;
    } });
    var capiEndpoints_1 = require_capiEndpoints();
    Object.defineProperty(exports, "getCapiEndpoint", { enumerable: true, get: function() {
      return capiEndpoints_1.getCapiEndpoint;
    } });
    var capiCatalog_1 = require_capiCatalog();
    Object.defineProperty(exports, "CAPI_CATALOG", { enumerable: true, get: function() {
      return capiCatalog_1.CAPI_CATALOG;
    } });
    var epocEntity_1 = require_epocEntity();
    Object.defineProperty(exports, "EPOC_ENTITY_TYPE_NAME", { enumerable: true, get: function() {
      return epocEntity_1.EPOC_ENTITY_TYPE_NAME;
    } });
    Object.defineProperty(exports, "EPOC_ENTITY_TYPE_MAJOR_VERSION", { enumerable: true, get: function() {
      return epocEntity_1.EPOC_ENTITY_TYPE_MAJOR_VERSION;
    } });
    Object.defineProperty(exports, "EPOC_ENTITY_TYPE_MINOR_VERSION", { enumerable: true, get: function() {
      return epocEntity_1.EPOC_ENTITY_TYPE_MINOR_VERSION;
    } });
    var validation_1 = require_validation();
    Object.defineProperty(exports, "EpocValidation", { enumerable: true, get: function() {
      return validation_1.EpocValidation;
    } });
    Object.defineProperty(exports, "calculateMaxFutureStartDays", { enumerable: true, get: function() {
      return validation_1.calculateMaxFutureStartDays;
    } });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/duration-validator.js
var require_duration_validator = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/duration-validator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DurationValidator = void 0;
    var DurationValidator2 = class {
      /**
       * The subset of ISO-8601 durations this domain supports: years, months, and/or
       * days only (`P[nY][nM][nD]`), with at least one component present.
       *
       * The Zod schema boundary validates durations with `z.iso.duration()`, which accepts
       * the FULL ISO-8601 grammar — including week (`P1W`) and time (`PT720H`, `PT30M`, `PT0S`)
       * forms this validator cannot represent. Those wider forms used to pass the schema and
       * then throw here downstream, surfacing as an opaque SERVER_FAULT (BUG-2). The schema now
       * gates on `isSupported` so unsupported-but-valid durations are rejected cleanly at the
       * boundary. This pattern is the single source of truth for which durations are REPRESENTABLE
       * (parseable) — magnitude/bounds checks live separately in validateOfferSettingsBounds.
       */
      static SUPPORTED_DURATION_PATTERN = /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?$/;
      /**
       * True when `duration` is a representable year/month/day duration (see
       * SUPPORTED_DURATION_PATTERN) with at least one component present. This is a GRAMMAR check
       * used by the schema boundary (SupportedIsoDuration) to reject week/time-component forms this
       * validator cannot represent (`P1W`, `PT720H`).
       *
       * It intentionally accepts an all-zero duration like `P0M`/`P0D`: those are representable and
       * parse fine, but carry no usable magnitude. Non-zero VALUE is a separate, bounds-layer concern
       * — validateOfferSettingsBounds rejects `P0M`/`P0D` with a specific "at least N month/day"
       * message. `tryToMonths` differs deliberately for a different reason: it returns null for an
       * all-zero duration because its callers need a usable positive month count, not a grammar verdict.
       */
      static isSupported(duration) {
        const match2 = duration.match(this.SUPPORTED_DURATION_PATTERN);
        return match2 !== null && (match2[1] !== void 0 || match2[2] !== void 0 || match2[3] !== void 0);
      }
      static parse(duration) {
        const match2 = duration.match(this.SUPPORTED_DURATION_PATTERN);
        if (!match2)
          throw new Error(`Invalid duration format: ${duration}`);
        return {
          years: parseInt(match2[1] || "0", 10),
          months: parseInt(match2[2] || "0", 10),
          days: parseInt(match2[3] || "0", 10)
        };
      }
      static toMonths(duration) {
        const { years, months: months2 } = this.parse(duration);
        return years * 12 + months2;
      }
      static tryToMonths(duration) {
        let parsed;
        try {
          parsed = this.parse(duration);
        } catch {
          return null;
        }
        if (!parsed.years && !parsed.months && !parsed.days)
          return null;
        return parsed.years * 12 + parsed.months;
      }
      static toDays(duration) {
        const { years, months: months2, days } = this.parse(duration);
        return years * 365 + months2 * 30 + days;
      }
      /**
       * Canonical month-notation ISO duration (`P<months>M`) — the one offer-duration format every
       * offer-creation path emits. Months-only matters because CAPI ReleaseOffer reads AgreementDuration
       * on its months component only and the FPS generator is month-granular. Callers derive `months`
       * via {@link toMonths}/{@link tryToMonths} first (P1Y → 12, P1M15D → 1).
       */
      static monthsToIso(months2) {
        return `P${months2}M`;
      }
      // Shortest-possible calendar day counts for a run of N consecutive months (index = month count).
      // MIN[1]=28 (Feb), MIN[12]=365 (non-leap year). This mirrors the server's PeriodUtil
      // MIN_DAYS_BY_MONTH_COUNT table verbatim (AWSMPOfferValidations
      // rules/util/PeriodUtil.java) so the client and server agree on month→day conversion.
      static MIN_DAYS_BY_MONTH_COUNT = [0, 28, 59, 89, 120, 150, 181, 212, 242, 273, 303, 334, 365];
      /**
       * The MINIMUM number of days a Y/M/D duration can span on a real calendar (shortest February, a
       * 365-day year). This is a faithful port of the server's `PeriodUtil.minPossibleDays`
       * (AWSMPOfferValidations): fold years+months into a total month count, look the shortest day-run up
       * in MIN_DAYS_BY_MONTH_COUNT, then add the standalone day component. A flat 30-day-month / 365-day-year
       * approximation (see `toDays`) diverges from the server near month boundaries (e.g. P1M is 28 days
       * here, not 30; P12M is 365), so use THIS method — not `toDays` — for any comparison that must agree
       * with the server's INVALID_LOCKOUT_PERIOD verdict.
       */
      static minPossibleCalendarDays(duration) {
        const { years, months: months2, days } = this.parse(duration);
        const totalMonths = years * 12 + months2;
        const fullYears = Math.floor(totalMonths / 12);
        const remainingMonths = totalMonths % 12;
        return fullYears * this.MIN_DAYS_BY_MONTH_COUNT[12] + this.MIN_DAYS_BY_MONTH_COUNT[remainingMonths] + days;
      }
      /**
       * The shortest calendar-day span of the offer duration offer creation ACTUALLY EMITS for a given
       * MaxOfferDuration. Every offer-creation path emits `monthsToIso(toMonths(MaxOfferDuration))` — whole
       * months, dropping any day remainder (see {@link monthsToIso}). Renewal LockoutPeriod /
       * AdjustmentDeadline must be validated against THIS floored span, not the raw day-inclusive
       * {@link minPossibleCalendarDays} of MaxOfferDuration: a day-bearing duration (e.g. `P1M15D`, ~43 days)
       * otherwise passes config validation but emits a shorter whole-month offer (`P1M`, ~28 days), so a
       * lockout/deadline in that gap slips through and trips CAPI INVALID_LOCKOUT_PERIOD /
       * INVALID_ADJUSTMENT_DEADLINE at offer time. Assumes a representable (isSupported) duration, as the
       * callers already ensure. Returns 0 when MaxOfferDuration floors to 0 months (a bad Max that
       * validateOfferSettingsBounds rejects).
       */
      static emittedOfferMinPossibleCalendarDays(maxOfferDuration) {
        return this.minPossibleCalendarDays(this.monthsToIso(this.toMonths(maxOfferDuration)));
      }
      static validateMinMonths(duration, minMonths) {
        const months2 = this.toMonths(duration);
        if (months2 < minMonths) {
          throw new Error(`Duration must be at least ${minMonths} month(s)`);
        }
      }
      static validateMaxMonths(duration, maxMonths) {
        const months2 = this.toMonths(duration);
        if (months2 > maxMonths) {
          throw new Error(`Duration cannot exceed ${maxMonths} months`);
        }
      }
      static validateMinDays(duration, minDays) {
        const days = this.toDays(duration);
        if (days < minDays) {
          throw new Error(`Duration must be at least ${minDays} day(s)`);
        }
      }
      static validateMaxDays(duration, maxDays) {
        const days = this.toDays(duration);
        if (days > maxDays) {
          throw new Error(`Duration cannot exceed ${maxDays} days`);
        }
      }
    };
    exports.DurationValidator = DurationValidator2;
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/epo-config.schema.js
var require_epo_config_schema = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/epo-config.schema.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EpoConfigSchema = exports.DiscountRulesSchema = exports.RenewalTermSchema = exports.PaymentScheduleSchema = exports.OfferSettingsSchema = exports.GuardrailsSchema = exports.OfferRatesSchema = exports.IdentifiersSchema = exports.DiscountRulesDetailShape = exports.RenewalTermDetailShape = exports.RenewalTermDetailBase = exports.RENEWAL_DAYS_DURATION_REGEX = exports.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT = exports.LOCKOUT_PERIOD_MIN_DAYS = exports.PERCENTAGE_MAX = exports.PERCENTAGE_MIN = exports.PaymentScheduleDetailShape = exports.OfferSettingsInputDetailShape = exports.OfferSettingsDetailShape = exports.EulaSchema = exports.GuardrailsDetailShape = exports.OfferRatesDetailShape = exports.UsageDimensionWithPriceSchema = exports.IdentifiersDetailShape = exports.ResponseTypeEnum = exports.QualifyingThemeEnum = exports.CURRENCY_MINOR_UNIT_SCALE = exports.CurrencyCodeEnum = exports.StateEnum = exports.Price = exports.TierQuantityBound = exports.Quantity = exports.DiscountPercentage = exports.Percentage = exports.AwsAccountId = exports.OfferId = exports.ProductId = exports.ConfigEntityId = exports.MAX_PAYMENT_SCHEDULE_FREQUENCIES = exports.SupportedIsoDuration = void 0;
    var v4_1 = require_v4();
    var constants_1 = require_constants();
    var duration_validator_1 = require_duration_validator();
    var aipoConfigRecord_1 = require_aipoConfigRecord();
    exports.SupportedIsoDuration = v4_1.z.iso.duration().refine((value) => duration_validator_1.DurationValidator.isSupported(value), {
      message: "Duration must use only year, month, and/or day components (e.g. P1Y2M, P30D); week and time components are not supported"
    });
    var { MAX_ID_LENGTH, MAX_NAME_LENGTH, MAX_DESCRIPTION_LENGTH: MAX_DESCRIPTION_LENGTH2, MAX_QUALIFICATION_DETAIL_LENGTH: MAX_QUALIFICATION_DETAIL_LENGTH2, MAX_QUESTION_LENGTH, MAX_EXAMPLE_RESPONSE_LENGTH, MAX_QUALIFICATIONS: MAX_QUALIFICATIONS2, MAX_TCV_DISCOUNT_TIERS, MAX_DIMENSIONS, MAX_TOTAL_DIMENSION_TIERS } = constants_1.EpocValidation;
    exports.MAX_PAYMENT_SCHEDULE_FREQUENCIES = 3;
    exports.ConfigEntityId = v4_1.z.string().startsWith("epoconfig-").max(MAX_ID_LENGTH);
    exports.ProductId = v4_1.z.union([v4_1.z.string().startsWith("prod-").max(MAX_ID_LENGTH), v4_1.z.uuid()]);
    exports.OfferId = v4_1.z.string().max(MAX_ID_LENGTH);
    exports.AwsAccountId = v4_1.z.string().regex(/^\d{12}$/);
    exports.Percentage = v4_1.z.number().min(0).max(100).refine((val) => Number.isFinite(val) && Math.abs(Math.round(val * 100) - val * 100) < 1e-8, {
      message: "Percentage must have at most 2 decimal places"
    });
    exports.DiscountPercentage = exports.Percentage.min(0).max(99);
    exports.Quantity = v4_1.z.number().int().min(1);
    exports.TierQuantityBound = v4_1.z.number().int().min(0);
    exports.Price = v4_1.z.number().min(0);
    exports.StateEnum = v4_1.z.enum(["ACTIVE", "INACTIVE"]);
    exports.CurrencyCodeEnum = v4_1.z.enum(["USD"]);
    exports.CURRENCY_MINOR_UNIT_SCALE = { USD: 2 };
    exports.QualifyingThemeEnum = v4_1.z.enum(["COMPANY_SIZE", "INDUSTRY", "USE_CASE", "OTHER"]);
    exports.ResponseTypeEnum = v4_1.z.enum(["FREE_TEXT"]);
    var HeaderSchema = v4_1.z.strictObject({
      Name: v4_1.z.string(),
      Version: v4_1.z.string()
    });
    var TypeSchema = v4_1.z.strictObject({
      Name: v4_1.z.string(),
      Version: v4_1.z.string()
    });
    function createFacetSchema(detailSchema) {
      return v4_1.z.strictObject({
        $Header: HeaderSchema,
        Type: TypeSchema,
        Id: v4_1.z.string(),
        Detail: detailSchema
      });
    }
    var TieredQuantityDiscountSchema = v4_1.z.strictObject({
      MinValue: exports.TierQuantityBound,
      MaxValue: exports.Quantity,
      UpfrontDiscountPercentage: exports.DiscountPercentage
    }).refine((data) => data.MinValue <= data.MaxValue, {
      message: "MinValue must be less than or equal to MaxValue"
    });
    var TieredPriceDiscountSchema = v4_1.z.strictObject({
      MinValue: exports.Price,
      MaxValue: exports.Price,
      UpfrontDiscountPercentage: exports.DiscountPercentage
    }).refine((data) => data.MinValue <= data.MaxValue, {
      message: "MinValue must be less than or equal to MaxValue"
    });
    exports.IdentifiersDetailShape = v4_1.z.strictObject({
      EntityId: exports.ConfigEntityId,
      ProductId: exports.ProductId,
      OwnerAccountId: exports.AwsAccountId,
      Name: v4_1.z.string().max(MAX_NAME_LENGTH)
    });
    exports.UsageDimensionWithPriceSchema = v4_1.z.strictObject({
      Dimension: v4_1.z.string(),
      Price: exports.Price
    });
    exports.OfferRatesDetailShape = v4_1.z.strictObject({
      ConfigurableUpfrontDimensionRates: v4_1.z.strictObject({
        Duration: v4_1.z.literal(constants_1.EpocValidation.CONFIGURABLE_UPFRONT_RATE_DURATION),
        DimensionRates: v4_1.z.array(v4_1.z.strictObject({
          DimensionKey: v4_1.z.string(),
          Price: exports.Price
        })).min(1)
      }),
      UsageBasedDimensionRates: v4_1.z.strictObject({
        OfferId: exports.OfferId
      }).optional()
    });
    exports.GuardrailsDetailShape = v4_1.z.strictObject({
      MaxTotalContractValue: exports.Price,
      MinTotalContractValue: exports.Price,
      MaxDiscountPercentage: exports.Percentage.max(99)
    }).refine((data) => data.MinTotalContractValue <= data.MaxTotalContractValue, {
      message: "MinTotalContractValue must not exceed MaxTotalContractValue"
    });
    var OfferEulaSchema = v4_1.z.strictObject({
      Type: v4_1.z.literal("OFFER_EULA"),
      OfferId: exports.OfferId
    });
    var StandardContractEulaSchema = v4_1.z.strictObject({
      Type: v4_1.z.literal("STANDARD_CONTRACT_MARKETPLACE")
    });
    exports.EulaSchema = v4_1.z.discriminatedUnion("Type", [OfferEulaSchema, StandardContractEulaSchema]);
    exports.OfferSettingsDetailShape = v4_1.z.strictObject({
      Eula: exports.EulaSchema,
      MinOfferDuration: v4_1.z.iso.duration(),
      MaxOfferDuration: v4_1.z.iso.duration(),
      MaxFutureStartDuration: v4_1.z.iso.duration(),
      Expiration: v4_1.z.iso.duration()
    });
    exports.OfferSettingsInputDetailShape = exports.OfferSettingsDetailShape.extend({
      MinOfferDuration: exports.SupportedIsoDuration,
      MaxOfferDuration: exports.SupportedIsoDuration,
      MaxFutureStartDuration: exports.SupportedIsoDuration,
      Expiration: exports.SupportedIsoDuration
    });
    exports.PaymentScheduleDetailShape = v4_1.z.strictObject({
      AllowedFrequencies: v4_1.z.array(aipoConfigRecord_1.AipoPaymentScheduleFrequencySchema).min(1).max(exports.MAX_PAYMENT_SCHEDULE_FREQUENCIES).refine((arr) => new Set(arr).size === arr.length, {
        message: "AllowedFrequencies must not contain duplicates"
      }),
      InitialPaymentAllowed: v4_1.z.boolean()
    });
    exports.PERCENTAGE_MIN = 0;
    exports.PERCENTAGE_MAX = 100;
    exports.LOCKOUT_PERIOD_MIN_DAYS = 1;
    exports.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT = 1;
    var PERCENTAGE_REGEX2 = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
    exports.RENEWAL_DAYS_DURATION_REGEX = /^P([1-9]\d{0,6}D)$/;
    var PriceIncreaseShape = v4_1.z.discriminatedUnion("Type", [
      v4_1.z.strictObject({
        Type: v4_1.z.literal("FixedPercentage"),
        Value: v4_1.z.string().regex(PERCENTAGE_REGEX2)
      }),
      v4_1.z.strictObject({
        Type: v4_1.z.literal("PercentageRange"),
        // `Range` matches the CAPI contract's struct name (PercentageRange@1.0 -> Range in the SDL).
        Range: v4_1.z.strictObject({
          MinValue: v4_1.z.string().regex(PERCENTAGE_REGEX2),
          MaxValue: v4_1.z.string().regex(PERCENTAGE_REGEX2),
          DefaultValue: v4_1.z.string().regex(PERCENTAGE_REGEX2)
        })
      })
    ]);
    exports.RenewalTermDetailBase = v4_1.z.strictObject({
      MaxRenewals: v4_1.z.number().int().min(1).optional(),
      LockoutPeriod: v4_1.z.string().regex(exports.RENEWAL_DAYS_DURATION_REGEX).optional(),
      PriceIncrease: PriceIncreaseShape,
      AdjustmentDeadline: v4_1.z.string().regex(exports.RENEWAL_DAYS_DURATION_REGEX).optional()
    });
    function renewalTermIntraFacetRefinement(renewalTerm, ctx) {
      const inBounds = (value) => !PERCENTAGE_REGEX2.test(value) || Number(value) >= exports.PERCENTAGE_MIN && Number(value) <= exports.PERCENTAGE_MAX;
      const renewalDurationToDays = (value) => exports.RENEWAL_DAYS_DURATION_REGEX.test(value) ? duration_validator_1.DurationValidator.toDays(value) : null;
      const lockoutDays = renewalTerm.LockoutPeriod ? renewalDurationToDays(renewalTerm.LockoutPeriod) : null;
      if (lockoutDays !== null && lockoutDays < exports.LOCKOUT_PERIOD_MIN_DAYS) {
        ctx.addIssue({
          code: "custom",
          path: ["LockoutPeriod"],
          message: `LockoutPeriod must be at least P${exports.LOCKOUT_PERIOD_MIN_DAYS}D`
        });
      }
      const priceIncrease = renewalTerm.PriceIncrease;
      if (priceIncrease.Type === "FixedPercentage" && !inBounds(priceIncrease.Value)) {
        ctx.addIssue({
          code: "custom",
          path: ["PriceIncrease", "Value"],
          message: `FixedPercentage Value must be within [${exports.PERCENTAGE_MIN}, ${exports.PERCENTAGE_MAX}]`
        });
      }
      if (priceIncrease.Type === "PercentageRange") {
        const { MinValue, MaxValue, DefaultValue } = priceIncrease.Range;
        const min = Number(MinValue);
        const max = Number(MaxValue);
        const def = Number(DefaultValue);
        if (![MinValue, DefaultValue, MaxValue].every(inBounds)) {
          ctx.addIssue({
            code: "custom",
            path: ["PriceIncrease", "Range"],
            message: `Each Range value must be within [${exports.PERCENTAGE_MIN}, ${exports.PERCENTAGE_MAX}]`
          });
        }
        const rangeValuesWellFormed = [MinValue, MaxValue, DefaultValue].every((value) => PERCENTAGE_REGEX2.test(value));
        if (rangeValuesWellFormed && !(min <= def && def <= max)) {
          ctx.addIssue({
            code: "custom",
            path: ["PriceIncrease", "Range"],
            message: `Range must satisfy MinValue (${MinValue}) <= DefaultValue (${DefaultValue}) <= MaxValue (${MaxValue})`
          });
        }
        if (!renewalTerm.AdjustmentDeadline) {
          ctx.addIssue({
            code: "custom",
            path: ["AdjustmentDeadline"],
            message: "AdjustmentDeadline is required when PriceIncrease.Type is PercentageRange"
          });
        } else {
          const adjustmentDeadlineDays = renewalDurationToDays(renewalTerm.AdjustmentDeadline);
          if (adjustmentDeadlineDays !== null && adjustmentDeadlineDays < (lockoutDays ?? 0) + exports.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT) {
            ctx.addIssue({
              code: "custom",
              path: ["AdjustmentDeadline"],
              message: `AdjustmentDeadline (${renewalTerm.AdjustmentDeadline}) must be >= LockoutPeriod + ${exports.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT} days`
            });
          }
        }
      } else if (renewalTerm.AdjustmentDeadline) {
        ctx.addIssue({
          code: "custom",
          path: ["AdjustmentDeadline"],
          message: "AdjustmentDeadline is only valid when PriceIncrease.Type is PercentageRange"
        });
      }
    }
    exports.RenewalTermDetailShape = exports.RenewalTermDetailBase.superRefine(renewalTermIntraFacetRefinement);
    exports.DiscountRulesDetailShape = v4_1.z.strictObject({
      TotalContractValue: v4_1.z.strictObject({
        Tiers: v4_1.z.array(TieredPriceDiscountSchema).min(1).max(MAX_TCV_DISCOUNT_TIERS)
      }).optional(),
      DimensionQuantity: v4_1.z.strictObject({
        PerDimensionTiers: v4_1.z.record(v4_1.z.string(), v4_1.z.array(TieredQuantityDiscountSchema).min(1)).refine((data) => Object.keys(data).length > 0, {
          message: "PerDimensionTiers must contain at least one dimension"
        }).refine((data) => Object.keys(data).length <= MAX_DIMENSIONS, {
          message: `PerDimensionTiers cannot exceed ${MAX_DIMENSIONS} dimensions`
        }).refine((data) => {
          const totalTiers = Object.values(data).reduce((sum, tiers) => sum + tiers.length, 0);
          return totalTiers <= MAX_TOTAL_DIMENSION_TIERS;
        }, {
          message: `Total tiers across all dimensions cannot exceed ${MAX_TOTAL_DIMENSION_TIERS}`
        })
      }).optional(),
      Qualification: v4_1.z.strictObject({
        Questions: v4_1.z.array(v4_1.z.strictObject({
          QualifyingTheme: exports.QualifyingThemeEnum,
          Instructions: v4_1.z.string().min(1).max(MAX_QUALIFICATION_DETAIL_LENGTH2),
          BuyerQuestions: v4_1.z.array(v4_1.z.strictObject({
            Question: v4_1.z.string().min(1).max(MAX_QUESTION_LENGTH),
            ResponseType: exports.ResponseTypeEnum,
            ExampleResponse: v4_1.z.string().min(1).max(MAX_EXAMPLE_RESPONSE_LENGTH)
          }))
        })).min(1).max(MAX_QUALIFICATIONS2)
      }).optional()
    }).refine((data) => {
      return data.TotalContractValue || data.DimensionQuantity || data.Qualification;
    }, {
      message: "At least one discount rule is required when DiscountRules is specified"
    }).refine((data) => {
      return !(data.TotalContractValue && data.DimensionQuantity);
    }, {
      message: "Cannot specify both TotalContractValue and DimensionQuantity"
    });
    exports.IdentifiersSchema = createFacetSchema(exports.IdentifiersDetailShape);
    exports.OfferRatesSchema = createFacetSchema(exports.OfferRatesDetailShape);
    exports.GuardrailsSchema = createFacetSchema(exports.GuardrailsDetailShape);
    exports.OfferSettingsSchema = createFacetSchema(exports.OfferSettingsDetailShape);
    exports.PaymentScheduleSchema = createFacetSchema(exports.PaymentScheduleDetailShape);
    exports.RenewalTermSchema = createFacetSchema(exports.RenewalTermDetailShape);
    exports.DiscountRulesSchema = createFacetSchema(exports.DiscountRulesDetailShape).optional();
    exports.EpoConfigSchema = v4_1.z.strictObject({
      $Header: HeaderSchema,
      Type: TypeSchema.extend({
        Name: v4_1.z.literal(constants_1.EPOC_ENTITY_TYPE_NAME)
      }),
      Id: exports.ConfigEntityId,
      Detail: v4_1.z.strictObject({
        Identifiers: exports.IdentifiersSchema,
        State: exports.StateEnum,
        CurrencyCode: exports.CurrencyCodeEnum,
        Description: v4_1.z.string().max(MAX_DESCRIPTION_LENGTH2).optional(),
        OfferRates: exports.OfferRatesSchema,
        // No cross-field validation against OfferSettings.MaxOfferDuration — a duration shorter than a
        // frequency interval is valid (single upfront payment); feasibility is enforced at offer-time
        // generation.
        PaymentSchedule: exports.PaymentScheduleSchema.optional(),
        // Optional renewal terms (EPO Renewals). Absent = a non-renewing config; existing configs
        // stay valid. Cross-field validation against OfferSettings.MaxOfferDuration is enforced on the
        // *input* schema (CreateEpoConfigInputSchema), not here.
        RenewalTerm: exports.RenewalTermSchema.optional(),
        Guardrails: exports.GuardrailsSchema,
        OfferSettings: exports.OfferSettingsSchema,
        DiscountRules: exports.DiscountRulesSchema.optional()
      })
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/renewal-duration.js
var require_renewal_duration = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/renewal-duration.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.checkRenewalDurationShorterThanMaxOffer = checkRenewalDurationShorterThanMaxOffer2;
    var epo_config_schema_1 = require_epo_config_schema();
    var duration_validator_1 = require_duration_validator();
    function checkRenewalDurationShorterThanMaxOffer2(fieldValue, fieldName, maxOfferDuration, maxOfferDurationMinDays) {
      if (!fieldValue || !epo_config_schema_1.RENEWAL_DAYS_DURATION_REGEX.test(fieldValue))
        return void 0;
      if (duration_validator_1.DurationValidator.minPossibleCalendarDays(fieldValue) >= maxOfferDurationMinDays) {
        const emittedOfferDuration = duration_validator_1.DurationValidator.monthsToIso(duration_validator_1.DurationValidator.toMonths(maxOfferDuration));
        const offerDurationDesc = emittedOfferDuration === maxOfferDuration ? maxOfferDuration : `${maxOfferDuration} \u2192 ${emittedOfferDuration}`;
        return `${fieldName} (${fieldValue}) must be strictly shorter than the offer duration derived from MaxOfferDuration (${offerDurationDesc})`;
      }
      return void 0;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/epo-config-operations.schema.js
var require_epo_config_operations_schema = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/epoc/epo-config-operations.schema.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UpdateOfferSettingsInputSchema = exports.UpdateRenewalInputSchema = exports.UpdatePaymentScheduleInputSchema = exports.UpdatePricingInputSchema = exports.DescribeEntityPayloadSchema = exports.BackfillDeprecateInternalInputSchema = exports.BackfillCreateInternalInputSchema = exports.DeprecateEpoConfigInputSchema = exports.CreateEpoConfigInputSchema = void 0;
    var v4_1 = require_v4();
    var duration_validator_1 = require_duration_validator();
    var renewal_duration_1 = require_renewal_duration();
    var epo_config_schema_1 = require_epo_config_schema();
    var DetailShape = epo_config_schema_1.EpoConfigSchema.shape.Detail.shape;
    var CreateEpoConfigInputBaseSchema = v4_1.z.strictObject({
      Name: epo_config_schema_1.IdentifiersDetailShape.shape.Name,
      Description: DetailShape.Description,
      ProductId: epo_config_schema_1.IdentifiersDetailShape.shape.ProductId,
      CurrencyCode: DetailShape.CurrencyCode,
      OfferRates: epo_config_schema_1.OfferRatesDetailShape,
      Guardrails: epo_config_schema_1.GuardrailsDetailShape,
      OfferSettings: epo_config_schema_1.OfferSettingsDetailShape,
      DiscountRules: epo_config_schema_1.DiscountRulesDetailShape.optional(),
      PaymentSchedule: epo_config_schema_1.PaymentScheduleDetailShape.optional(),
      RenewalTerm: epo_config_schema_1.RenewalTermDetailShape.optional()
    });
    function addRenewalDurationIssue(fieldValue, fieldName, maxOfferDuration, maxOfferDurationMinDays, ctx) {
      const message = (0, renewal_duration_1.checkRenewalDurationShorterThanMaxOffer)(fieldValue, fieldName, maxOfferDuration, maxOfferDurationMinDays);
      if (message) {
        ctx.addIssue({ code: "custom", path: ["RenewalTerm", fieldName], message });
      }
    }
    function renewalTermRefinement(data, ctx) {
      const renewalTerm = data.RenewalTerm;
      if (!renewalTerm)
        return;
      const { LockoutPeriod, AdjustmentDeadline } = renewalTerm;
      if (!LockoutPeriod && !AdjustmentDeadline)
        return;
      if (!data.OfferSettings)
        return;
      const maxOfferDuration = data.OfferSettings.MaxOfferDuration;
      if (!duration_validator_1.DurationValidator.isSupported(maxOfferDuration))
        return;
      const maxOfferDurationMinDays = duration_validator_1.DurationValidator.emittedOfferMinPossibleCalendarDays(maxOfferDuration);
      if (maxOfferDurationMinDays === 0)
        return;
      addRenewalDurationIssue(LockoutPeriod, "LockoutPeriod", maxOfferDuration, maxOfferDurationMinDays, ctx);
      addRenewalDurationIssue(AdjustmentDeadline, "AdjustmentDeadline", maxOfferDuration, maxOfferDurationMinDays, ctx);
    }
    exports.CreateEpoConfigInputSchema = CreateEpoConfigInputBaseSchema.extend({
      OfferSettings: epo_config_schema_1.OfferSettingsInputDetailShape
    }).superRefine(renewalTermRefinement);
    exports.DeprecateEpoConfigInputSchema = v4_1.z.strictObject({});
    exports.BackfillCreateInternalInputSchema = CreateEpoConfigInputBaseSchema.extend({
      OwnerAwsAccountId: epo_config_schema_1.IdentifiersDetailShape.shape.OwnerAccountId
    });
    exports.BackfillDeprecateInternalInputSchema = exports.DeprecateEpoConfigInputSchema;
    exports.DescribeEntityPayloadSchema = v4_1.z.strictObject({
      Name: epo_config_schema_1.IdentifiersDetailShape.shape.Name,
      Description: DetailShape.Description,
      OwnerAccountId: epo_config_schema_1.IdentifiersDetailShape.shape.OwnerAccountId,
      ProductId: epo_config_schema_1.IdentifiersDetailShape.shape.ProductId,
      State: DetailShape.State,
      CurrencyCode: DetailShape.CurrencyCode,
      OfferRates: epo_config_schema_1.OfferRatesDetailShape,
      Guardrails: epo_config_schema_1.GuardrailsDetailShape,
      OfferSettings: epo_config_schema_1.OfferSettingsDetailShape,
      DiscountRules: epo_config_schema_1.DiscountRulesDetailShape.optional(),
      PaymentSchedule: epo_config_schema_1.PaymentScheduleDetailShape.optional(),
      RenewalTerm: epo_config_schema_1.RenewalTermDetailShape.optional()
    });
    exports.UpdatePricingInputSchema = v4_1.z.strictObject({
      OfferRates: epo_config_schema_1.OfferRatesDetailShape.optional(),
      Guardrails: epo_config_schema_1.GuardrailsDetailShape.optional(),
      DiscountRules: epo_config_schema_1.DiscountRulesDetailShape.nullable().optional()
    }).refine((data) => data.OfferRates !== void 0 || data.Guardrails !== void 0 || data.DiscountRules !== void 0, { message: "At least one of OfferRates, Guardrails, or DiscountRules is required" });
    exports.UpdatePaymentScheduleInputSchema = v4_1.z.strictObject({
      PaymentSchedule: epo_config_schema_1.PaymentScheduleDetailShape.nullable()
    });
    exports.UpdateRenewalInputSchema = v4_1.z.strictObject({
      RenewalTerm: epo_config_schema_1.RenewalTermDetailShape.nullable()
    });
    exports.UpdateOfferSettingsInputSchema = v4_1.z.strictObject({
      OfferSettings: epo_config_schema_1.OfferSettingsInputDetailShape
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/cas/saasProduct.js
var require_saasProduct = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/cas/saasProduct.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SaasProductDocumentSchema = void 0;
    var v4_1 = require_v4();
    var ProductDimensionSchema = v4_1.z.looseObject({
      Key: v4_1.z.string(),
      Tags: v4_1.z.array(v4_1.z.string()).optional(),
      DisplayName: v4_1.z.string().optional(),
      Description: v4_1.z.string().optional(),
      ProductCode: v4_1.z.string().optional(),
      Unit: v4_1.z.string().optional()
    });
    var DimensionsDetailSchema = v4_1.z.looseObject({
      Available: v4_1.z.array(ProductDimensionSchema)
    });
    var DimensionsFacetSchema = v4_1.z.looseObject({
      Detail: DimensionsDetailSchema
    });
    var EngagementOptionSchema = v4_1.z.looseObject({
      EngagementOption: v4_1.z.string()
    });
    var BuyerEngagementDetailSchema = v4_1.z.looseObject({
      EnabledEngagementOptions: v4_1.z.array(EngagementOptionSchema)
    });
    var BuyerEngagementFacetSchema = v4_1.z.looseObject({
      Detail: BuyerEngagementDetailSchema
    });
    var IdentifiersDetailSchema = v4_1.z.looseObject({
      OwnerAccountId: v4_1.z.string(),
      ProductCode: v4_1.z.string().optional()
    });
    var IdentifiersFacetSchema = v4_1.z.looseObject({
      Detail: IdentifiersDetailSchema
    });
    var LifecycleStateDetailSchema = v4_1.z.looseObject({
      AllowedAccounts: v4_1.z.array(v4_1.z.string().regex(/^\d{12}$/)).optional(),
      LimitedAllowedAccounts: v4_1.z.array(v4_1.z.string().regex(/^\d{12}$/)).optional(),
      Message: v4_1.z.string().optional(),
      ReplacementProductId: v4_1.z.string().optional(),
      DraftTitle: v4_1.z.string().optional()
    });
    var LifecycleDetailSchema = v4_1.z.looseObject({
      State: v4_1.z.enum(["Limited", "Public", "Restricted", "Unavailable", "Draft"]),
      Detail: LifecycleStateDetailSchema.optional()
    });
    var LifecycleFacetSchema = v4_1.z.looseObject({
      Detail: LifecycleDetailSchema
    });
    var ProductTypeSchema = v4_1.z.looseObject({
      Name: v4_1.z.string(),
      Version: v4_1.z.literal("2.0")
    });
    exports.SaasProductDocumentSchema = v4_1.z.looseObject({
      Type: ProductTypeSchema,
      Id: v4_1.z.string().optional(),
      Detail: v4_1.z.looseObject({
        Identifiers: IdentifiersFacetSchema,
        Lifecycle: LifecycleFacetSchema,
        Dimensions: DimensionsFacetSchema.optional(),
        BuyerEngagement: BuyerEngagementFacetSchema.optional()
      })
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/cas/offer.js
var require_offer = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/cas/offer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OfferDocumentSchema = void 0;
    var v4_1 = require_v4();
    var AgreementSchema = v4_1.z.looseObject({
      Type: v4_1.z.string(),
      Url: v4_1.z.string().optional()
    });
    var LegalTermDetailsSchema = v4_1.z.looseObject({
      IsMandatory: v4_1.z.boolean().optional(),
      Agreements: v4_1.z.array(AgreementSchema).optional()
    });
    var RateCardEntrySchema = v4_1.z.looseObject({
      Dimension: v4_1.z.string(),
      Price: v4_1.z.number()
    });
    var UsageRateCardSchema = v4_1.z.looseObject({
      RateCard: v4_1.z.array(RateCardEntrySchema).optional()
    });
    var UsageBasedPricingTermDetailsSchema = v4_1.z.looseObject({
      IsMandatory: v4_1.z.boolean().optional(),
      CurrencyCode: v4_1.z.string().optional(),
      RateCards: v4_1.z.array(UsageRateCardSchema).optional()
    });
    var ConfigurableUpfrontRateCardEntrySchema = v4_1.z.looseObject({
      Dimension: v4_1.z.string(),
      Price: v4_1.z.number().optional()
    });
    var ConfigurableUpfrontRateCardSchema = v4_1.z.looseObject({
      RateCard: v4_1.z.array(ConfigurableUpfrontRateCardEntrySchema).optional()
    });
    var ConfigurableUpfrontPricingTermDetailsSchema = v4_1.z.looseObject({
      IsMandatory: v4_1.z.boolean().optional(),
      CurrencyCode: v4_1.z.string().optional(),
      RateCards: v4_1.z.array(ConfigurableUpfrontRateCardSchema).optional()
    });
    var PositiveTargetingSchema = v4_1.z.looseObject({
      AwsAccounts: v4_1.z.array(v4_1.z.string()).optional(),
      ParticipatingPrograms: v4_1.z.array(v4_1.z.string()).optional(),
      CountryCodes: v4_1.z.array(v4_1.z.string()).optional()
    });
    var TargetingRuleDetailsSchema = v4_1.z.looseObject({
      PositiveTargeting: PositiveTargetingSchema.optional()
    });
    var TermValueSchema = v4_1.z.looseObject({
      Type: v4_1.z.string(),
      Id: v4_1.z.string().optional(),
      Details: v4_1.z.union([
        LegalTermDetailsSchema,
        UsageBasedPricingTermDetailsSchema,
        ConfigurableUpfrontPricingTermDetailsSchema,
        v4_1.z.looseObject({})
      ]).optional()
    });
    var RuleValueSchema = v4_1.z.looseObject({
      Type: v4_1.z.string(),
      Id: v4_1.z.string().optional(),
      Details: v4_1.z.union([TargetingRuleDetailsSchema, v4_1.z.looseObject({})]).optional()
    });
    var TermsFacetSchema = v4_1.z.looseObject({
      Detail: v4_1.z.looseObject({
        Values: v4_1.z.array(TermValueSchema)
      })
    });
    var RulesFacetSchema = v4_1.z.looseObject({
      Detail: v4_1.z.looseObject({
        Values: v4_1.z.array(RuleValueSchema)
      })
    });
    var TrackingReferenceValueSchema = v4_1.z.looseObject({
      Type: v4_1.z.string(),
      Id: v4_1.z.string().optional()
    });
    var TrackingReferencesFacetSchema = v4_1.z.looseObject({
      Detail: v4_1.z.looseObject({
        Values: v4_1.z.array(TrackingReferenceValueSchema).optional()
      })
    });
    var ValidityDetailSchema = v4_1.z.looseObject({
      AgreementStartDate: v4_1.z.string().optional(),
      ExpirationDate: v4_1.z.string().optional()
    });
    var ValidityFacetSchema = v4_1.z.looseObject({
      Detail: ValidityDetailSchema
    });
    var MetadataDetailSchema = v4_1.z.looseObject({
      ProductId: v4_1.z.string()
    });
    var MetadataFacetSchema = v4_1.z.looseObject({
      Detail: MetadataDetailSchema
    });
    exports.OfferDocumentSchema = v4_1.z.looseObject({
      Detail: v4_1.z.looseObject({
        Metadata: MetadataFacetSchema,
        Terms: TermsFacetSchema,
        Rules: RulesFacetSchema,
        TrackingReferences: TrackingReferencesFacetSchema.optional(),
        Validity: ValidityFacetSchema.optional()
      })
    });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/index.js
var require_schemas3 = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/schemas/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OfferSettingsSchema = exports.GuardrailsSchema = exports.OfferRatesSchema = exports.IdentifiersSchema = exports.DiscountRulesDetailShape = exports.RenewalTermDetailShape = exports.RenewalTermDetailBase = exports.RENEWAL_DAYS_DURATION_REGEX = exports.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT = exports.LOCKOUT_PERIOD_MIN_DAYS = exports.PERCENTAGE_MAX = exports.PERCENTAGE_MIN = exports.PaymentScheduleDetailShape = exports.OfferSettingsInputDetailShape = exports.OfferSettingsDetailShape = exports.EulaSchema = exports.GuardrailsDetailShape = exports.OfferRatesDetailShape = exports.UsageDimensionWithPriceSchema = exports.IdentifiersDetailShape = exports.ResponseTypeEnum = exports.QualifyingThemeEnum = exports.CURRENCY_MINOR_UNIT_SCALE = exports.CurrencyCodeEnum = exports.StateEnum = exports.Price = exports.TierQuantityBound = exports.Quantity = exports.DiscountPercentage = exports.Percentage = exports.AwsAccountId = exports.OfferId = exports.ProductId = exports.ConfigEntityId = exports.MAX_PAYMENT_SCHEDULE_FREQUENCIES = exports.SupportedIsoDuration = exports.WaystoneTokenChangeType = exports.CapiTokenChangeType = exports.EpocChangeType = exports.TrackerSource = exports.TrackerOfferStatusReason = exports.TrackerOfferStatus = exports.TrackerOfferType = exports.AipoRequestTrackerRecordSchema = exports.PAYMENT_SCHEDULE_FREQUENCY_MONTHS = exports.AipoMinimalRecordSchema = exports.AipoPaymentScheduleFrequencySchema = exports.AipoDimensionRateSchema = exports.AipoConfigurableUpfrontDimensionRatesSchema = exports.AipoConfigRecordSchema = void 0;
    exports.OfferDocumentSchema = exports.SaasProductDocumentSchema = exports.UpdateOfferSettingsInputSchema = exports.UpdateRenewalInputSchema = exports.UpdatePaymentScheduleInputSchema = exports.UpdatePricingInputSchema = exports.DescribeEntityPayloadSchema = exports.BackfillDeprecateInternalInputSchema = exports.BackfillCreateInternalInputSchema = exports.DeprecateEpoConfigInputSchema = exports.CreateEpoConfigInputSchema = exports.EpoConfigSchema = exports.DiscountRulesSchema = exports.RenewalTermSchema = exports.PaymentScheduleSchema = void 0;
    var aipoConfigRecord_1 = require_aipoConfigRecord();
    Object.defineProperty(exports, "AipoConfigRecordSchema", { enumerable: true, get: function() {
      return aipoConfigRecord_1.AipoConfigRecordSchema;
    } });
    Object.defineProperty(exports, "AipoConfigurableUpfrontDimensionRatesSchema", { enumerable: true, get: function() {
      return aipoConfigRecord_1.AipoConfigurableUpfrontDimensionRatesSchema;
    } });
    Object.defineProperty(exports, "AipoDimensionRateSchema", { enumerable: true, get: function() {
      return aipoConfigRecord_1.AipoDimensionRateSchema;
    } });
    Object.defineProperty(exports, "AipoPaymentScheduleFrequencySchema", { enumerable: true, get: function() {
      return aipoConfigRecord_1.AipoPaymentScheduleFrequencySchema;
    } });
    Object.defineProperty(exports, "AipoMinimalRecordSchema", { enumerable: true, get: function() {
      return aipoConfigRecord_1.AipoMinimalRecordSchema;
    } });
    Object.defineProperty(exports, "PAYMENT_SCHEDULE_FREQUENCY_MONTHS", { enumerable: true, get: function() {
      return aipoConfigRecord_1.PAYMENT_SCHEDULE_FREQUENCY_MONTHS;
    } });
    var aipoRequestTracker_1 = require_aipoRequestTracker();
    Object.defineProperty(exports, "AipoRequestTrackerRecordSchema", { enumerable: true, get: function() {
      return aipoRequestTracker_1.AipoRequestTrackerRecordSchema;
    } });
    Object.defineProperty(exports, "TrackerOfferType", { enumerable: true, get: function() {
      return aipoRequestTracker_1.TrackerOfferType;
    } });
    Object.defineProperty(exports, "TrackerOfferStatus", { enumerable: true, get: function() {
      return aipoRequestTracker_1.TrackerOfferStatus;
    } });
    Object.defineProperty(exports, "TrackerOfferStatusReason", { enumerable: true, get: function() {
      return aipoRequestTracker_1.TrackerOfferStatusReason;
    } });
    Object.defineProperty(exports, "TrackerSource", { enumerable: true, get: function() {
      return aipoRequestTracker_1.TrackerSource;
    } });
    var capiEpocChangeTypes_1 = require_capiEpocChangeTypes();
    Object.defineProperty(exports, "EpocChangeType", { enumerable: true, get: function() {
      return capiEpocChangeTypes_1.EpocChangeType;
    } });
    Object.defineProperty(exports, "CapiTokenChangeType", { enumerable: true, get: function() {
      return capiEpocChangeTypes_1.CapiTokenChangeType;
    } });
    Object.defineProperty(exports, "WaystoneTokenChangeType", { enumerable: true, get: function() {
      return capiEpocChangeTypes_1.WaystoneTokenChangeType;
    } });
    var epo_config_schema_1 = require_epo_config_schema();
    Object.defineProperty(exports, "SupportedIsoDuration", { enumerable: true, get: function() {
      return epo_config_schema_1.SupportedIsoDuration;
    } });
    Object.defineProperty(exports, "MAX_PAYMENT_SCHEDULE_FREQUENCIES", { enumerable: true, get: function() {
      return epo_config_schema_1.MAX_PAYMENT_SCHEDULE_FREQUENCIES;
    } });
    Object.defineProperty(exports, "ConfigEntityId", { enumerable: true, get: function() {
      return epo_config_schema_1.ConfigEntityId;
    } });
    Object.defineProperty(exports, "ProductId", { enumerable: true, get: function() {
      return epo_config_schema_1.ProductId;
    } });
    Object.defineProperty(exports, "OfferId", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferId;
    } });
    Object.defineProperty(exports, "AwsAccountId", { enumerable: true, get: function() {
      return epo_config_schema_1.AwsAccountId;
    } });
    Object.defineProperty(exports, "Percentage", { enumerable: true, get: function() {
      return epo_config_schema_1.Percentage;
    } });
    Object.defineProperty(exports, "DiscountPercentage", { enumerable: true, get: function() {
      return epo_config_schema_1.DiscountPercentage;
    } });
    Object.defineProperty(exports, "Quantity", { enumerable: true, get: function() {
      return epo_config_schema_1.Quantity;
    } });
    Object.defineProperty(exports, "TierQuantityBound", { enumerable: true, get: function() {
      return epo_config_schema_1.TierQuantityBound;
    } });
    Object.defineProperty(exports, "Price", { enumerable: true, get: function() {
      return epo_config_schema_1.Price;
    } });
    Object.defineProperty(exports, "StateEnum", { enumerable: true, get: function() {
      return epo_config_schema_1.StateEnum;
    } });
    Object.defineProperty(exports, "CurrencyCodeEnum", { enumerable: true, get: function() {
      return epo_config_schema_1.CurrencyCodeEnum;
    } });
    Object.defineProperty(exports, "CURRENCY_MINOR_UNIT_SCALE", { enumerable: true, get: function() {
      return epo_config_schema_1.CURRENCY_MINOR_UNIT_SCALE;
    } });
    Object.defineProperty(exports, "QualifyingThemeEnum", { enumerable: true, get: function() {
      return epo_config_schema_1.QualifyingThemeEnum;
    } });
    Object.defineProperty(exports, "ResponseTypeEnum", { enumerable: true, get: function() {
      return epo_config_schema_1.ResponseTypeEnum;
    } });
    Object.defineProperty(exports, "IdentifiersDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.IdentifiersDetailShape;
    } });
    Object.defineProperty(exports, "UsageDimensionWithPriceSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.UsageDimensionWithPriceSchema;
    } });
    Object.defineProperty(exports, "OfferRatesDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferRatesDetailShape;
    } });
    Object.defineProperty(exports, "GuardrailsDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.GuardrailsDetailShape;
    } });
    Object.defineProperty(exports, "EulaSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.EulaSchema;
    } });
    Object.defineProperty(exports, "OfferSettingsDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferSettingsDetailShape;
    } });
    Object.defineProperty(exports, "OfferSettingsInputDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferSettingsInputDetailShape;
    } });
    Object.defineProperty(exports, "PaymentScheduleDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.PaymentScheduleDetailShape;
    } });
    Object.defineProperty(exports, "PERCENTAGE_MIN", { enumerable: true, get: function() {
      return epo_config_schema_1.PERCENTAGE_MIN;
    } });
    Object.defineProperty(exports, "PERCENTAGE_MAX", { enumerable: true, get: function() {
      return epo_config_schema_1.PERCENTAGE_MAX;
    } });
    Object.defineProperty(exports, "LOCKOUT_PERIOD_MIN_DAYS", { enumerable: true, get: function() {
      return epo_config_schema_1.LOCKOUT_PERIOD_MIN_DAYS;
    } });
    Object.defineProperty(exports, "ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT", { enumerable: true, get: function() {
      return epo_config_schema_1.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT;
    } });
    Object.defineProperty(exports, "RENEWAL_DAYS_DURATION_REGEX", { enumerable: true, get: function() {
      return epo_config_schema_1.RENEWAL_DAYS_DURATION_REGEX;
    } });
    Object.defineProperty(exports, "RenewalTermDetailBase", { enumerable: true, get: function() {
      return epo_config_schema_1.RenewalTermDetailBase;
    } });
    Object.defineProperty(exports, "RenewalTermDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.RenewalTermDetailShape;
    } });
    Object.defineProperty(exports, "DiscountRulesDetailShape", { enumerable: true, get: function() {
      return epo_config_schema_1.DiscountRulesDetailShape;
    } });
    Object.defineProperty(exports, "IdentifiersSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.IdentifiersSchema;
    } });
    Object.defineProperty(exports, "OfferRatesSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferRatesSchema;
    } });
    Object.defineProperty(exports, "GuardrailsSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.GuardrailsSchema;
    } });
    Object.defineProperty(exports, "OfferSettingsSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.OfferSettingsSchema;
    } });
    Object.defineProperty(exports, "PaymentScheduleSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.PaymentScheduleSchema;
    } });
    Object.defineProperty(exports, "RenewalTermSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.RenewalTermSchema;
    } });
    Object.defineProperty(exports, "DiscountRulesSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.DiscountRulesSchema;
    } });
    Object.defineProperty(exports, "EpoConfigSchema", { enumerable: true, get: function() {
      return epo_config_schema_1.EpoConfigSchema;
    } });
    var epo_config_operations_schema_1 = require_epo_config_operations_schema();
    Object.defineProperty(exports, "CreateEpoConfigInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.CreateEpoConfigInputSchema;
    } });
    Object.defineProperty(exports, "DeprecateEpoConfigInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.DeprecateEpoConfigInputSchema;
    } });
    Object.defineProperty(exports, "BackfillCreateInternalInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.BackfillCreateInternalInputSchema;
    } });
    Object.defineProperty(exports, "BackfillDeprecateInternalInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.BackfillDeprecateInternalInputSchema;
    } });
    Object.defineProperty(exports, "DescribeEntityPayloadSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.DescribeEntityPayloadSchema;
    } });
    Object.defineProperty(exports, "UpdatePricingInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.UpdatePricingInputSchema;
    } });
    Object.defineProperty(exports, "UpdatePaymentScheduleInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.UpdatePaymentScheduleInputSchema;
    } });
    Object.defineProperty(exports, "UpdateRenewalInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.UpdateRenewalInputSchema;
    } });
    Object.defineProperty(exports, "UpdateOfferSettingsInputSchema", { enumerable: true, get: function() {
      return epo_config_operations_schema_1.UpdateOfferSettingsInputSchema;
    } });
    var saasProduct_1 = require_saasProduct();
    Object.defineProperty(exports, "SaasProductDocumentSchema", { enumerable: true, get: function() {
      return saasProduct_1.SaasProductDocumentSchema;
    } });
    var offer_1 = require_offer();
    Object.defineProperty(exports, "OfferDocumentSchema", { enumerable: true, get: function() {
      return offer_1.OfferDocumentSchema;
    } });
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/dateArithmeticUtils.js
var require_dateArithmeticUtils = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/dateArithmeticUtils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MS_PER_DAY = void 0;
    exports.addMonthsAnchored = addMonthsAnchored;
    exports.MS_PER_DAY = 24 * 60 * 60 * 1e3;
    function addMonthsAnchored(base, months2, anchorDay) {
      const targetYear = base.getUTCFullYear();
      const targetMonth = base.getUTCMonth() + months2;
      const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
      const clampedDay = Math.min(anchorDay, lastDayOfTargetMonth);
      return new Date(Date.UTC(targetYear, targetMonth, clampedDay));
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/generateInstallmentDates.js
var require_generateInstallmentDates = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/generateInstallmentDates.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MAX_INSTALLMENT_COUNT = exports.MAX_DAY_OF_MONTH = exports.MIN_DAY_OF_MONTH = exports.InstallmentScheduleError = exports.INSTALLMENT_SCHEDULE_ERROR_CODE = void 0;
    exports.assertValidDayOfMonth = assertValidDayOfMonth;
    exports.generateInstallmentDates = generateInstallmentDates;
    var schemas_1 = require_schemas3();
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    exports.INSTALLMENT_SCHEDULE_ERROR_CODE = {
      EMPTY: "EMPTY",
      DATE_FORMAT: "DATE_FORMAT",
      CADENCE_SPACING: "CADENCE_SPACING",
      CADENCE_INCOMPLETE: "CADENCE_INCOMPLETE",
      CADENCE_OUT_OF_BOUNDS: "CADENCE_OUT_OF_BOUNDS",
      CADENCE_OVER_CAP: "CADENCE_OVER_CAP",
      INVALID_DAY_OF_MONTH: "INVALID_DAY_OF_MONTH",
      AMOUNT_NOT_POSITIVE: "AMOUNT_NOT_POSITIVE",
      AMOUNT_SUM_MISMATCH: "AMOUNT_SUM_MISMATCH",
      GENERATION_FAILED: "GENERATION_FAILED",
      INVALID_INITIAL_PAYMENT: "INVALID_INITIAL_PAYMENT",
      INVALID_DURATION: "INVALID_DURATION",
      INVALID_OFFER_EXPIRY: "INVALID_OFFER_EXPIRY"
    };
    var InstallmentScheduleError = class extends Error {
      code;
      reason;
      field;
      index;
      constructor(detail) {
        super(`Failed payment schedule (${detail.code}): ${detail.reason}`);
        this.code = detail.code;
        this.reason = detail.reason;
        this.field = detail.field;
        this.index = detail.index;
        this.name = "InstallmentScheduleError";
      }
    };
    exports.InstallmentScheduleError = InstallmentScheduleError;
    exports.MIN_DAY_OF_MONTH = 1;
    exports.MAX_DAY_OF_MONTH = 31;
    function assertValidDayOfMonth(dayOfMonth) {
      if (dayOfMonth < exports.MIN_DAY_OF_MONTH || dayOfMonth > exports.MAX_DAY_OF_MONTH || !Number.isInteger(dayOfMonth)) {
        throw new InstallmentScheduleError({
          code: exports.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_DAY_OF_MONTH,
          reason: `dayOfMonth must be an integer in [${exports.MIN_DAY_OF_MONTH}, ${exports.MAX_DAY_OF_MONTH}] (got ${dayOfMonth})`
        });
      }
    }
    exports.MAX_INSTALLMENT_COUNT = 60;
    function generateInstallmentDates({ firstPaymentDate, endDate, frequency, dayOfMonth }) {
      if (dayOfMonth !== void 0) {
        assertValidDayOfMonth(dayOfMonth);
      }
      if (firstPaymentDate >= endDate) {
        throw new InstallmentScheduleError({
          code: exports.INSTALLMENT_SCHEDULE_ERROR_CODE.GENERATION_FAILED,
          reason: `firstPaymentDate (${firstPaymentDate.toISOString()}) is on or after the contract end (${endDate.toISOString()})`
        });
      }
      const monthStep = schemas_1.PAYMENT_SCHEDULE_FREQUENCY_MONTHS[frequency];
      const anchorDay = dayOfMonth ?? firstPaymentDate.getUTCDate();
      const dates = [firstPaymentDate];
      for (let i = 1; dates.length < exports.MAX_INSTALLMENT_COUNT; i++) {
        const next = (0, dateArithmeticUtils_1.addMonthsAnchored)(firstPaymentDate, monthStep * i, anchorDay);
        if (next >= endDate) {
          return dates;
        }
        dates.push(next);
      }
      return dates;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/isoDurationUtils.js
var require_isoDurationUtils = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/isoDurationUtils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.tokenizeIsoDuration = tokenizeIsoDuration;
    var ISO_DATE_DURATION = /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?$/;
    function tokenizeIsoDuration(durationISO) {
      const match2 = ISO_DATE_DURATION.exec(durationISO);
      if (!match2 || match2[1] === void 0 && match2[2] === void 0 && match2[3] === void 0) {
        return null;
      }
      return {
        years: Number(match2[1] ?? 0),
        months: Number(match2[2] ?? 0),
        days: Number(match2[3] ?? 0)
      };
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/windowValidation.js
var require_windowValidation = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/windowValidation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseDurationMonths = parseDurationMonths;
    exports.addContractDuration = addContractDuration;
    exports.isBeforeContractEnd = isBeforeContractEnd;
    exports.isWithinContractEnd = isWithinContractEnd;
    exports.isFirstPaymentDateWithinLimit = isFirstPaymentDateWithinLimit;
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var isoDurationUtils_1 = require_isoDurationUtils();
    var MONTHS_PER_YEAR = 12;
    var DEFAULT_MAX_FIRST_PAYMENT_DAYS = 30;
    function parseDurationMonths(durationISO) {
      const components = (0, isoDurationUtils_1.tokenizeIsoDuration)(durationISO);
      if (!components || components.days > 0) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_DURATION,
          reason: `contract duration "${durationISO}" must be a P<n>M or P<n>Y ISO duration (no day component)`
        });
      }
      return components.years * MONTHS_PER_YEAR + components.months;
    }
    function addContractDuration(contractStart, durationISO) {
      const totalMonths = parseDurationMonths(durationISO);
      return (0, dateArithmeticUtils_1.addMonthsAnchored)(contractStart, totalMonths, contractStart.getUTCDate());
    }
    function isBeforeContractEnd(date, endDate) {
      return date < endDate;
    }
    function isWithinContractEnd(chargeDate, contractStart, durationISO) {
      return isBeforeContractEnd(chargeDate, addContractDuration(contractStart, durationISO));
    }
    function isFirstPaymentDateWithinLimit(firstPaymentDate, offerCreation, maxDays = DEFAULT_MAX_FIRST_PAYMENT_DAYS, anchor = offerCreation) {
      if (firstPaymentDate < offerCreation) {
        return false;
      }
      const dayDelta = (firstPaymentDate.getTime() - anchor.getTime()) / dateArithmeticUtils_1.MS_PER_DAY;
      return dayDelta <= maxDays;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertScheduleCadence.js
var require_assertScheduleCadence = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertScheduleCadence.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.assertScheduleCadence = assertScheduleCadence;
    var schemas_1 = require_schemas3();
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var windowValidation_1 = require_windowValidation();
    function assertScheduleCadence({ dates, frequency, endDate, dayOfMonth, skipCompletenessCheck }) {
      const fail = (code, reason, index) => {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code,
          reason,
          ...index !== void 0 ? { field: "chargeDate", index } : {}
        });
      };
      if (dayOfMonth !== void 0 && (dayOfMonth < generateInstallmentDates_1.MIN_DAY_OF_MONTH || dayOfMonth > generateInstallmentDates_1.MAX_DAY_OF_MONTH || !Number.isInteger(dayOfMonth))) {
        fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_DAY_OF_MONTH, `dayOfMonth must be an integer in [${generateInstallmentDates_1.MIN_DAY_OF_MONTH}, ${generateInstallmentDates_1.MAX_DAY_OF_MONTH}]`);
      }
      if (dates.length < 1) {
        fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.EMPTY, "schedule must contain at least one charge date");
      }
      if (dates.length > generateInstallmentDates_1.MAX_INSTALLMENT_COUNT) {
        fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.CADENCE_OVER_CAP, `schedule exceeds the ${generateInstallmentDates_1.MAX_INSTALLMENT_COUNT}-installment cap`);
      }
      const monthStep = schemas_1.PAYMENT_SCHEDULE_FREQUENCY_MONTHS[frequency];
      const anchorDay = dayOfMonth ?? dates[0].getUTCDate();
      for (let i = 1; i < dates.length; i++) {
        const expected = (0, dateArithmeticUtils_1.addMonthsAnchored)(dates[0], monthStep * i, anchorDay);
        if (dates[i].getTime() !== expected.getTime()) {
          fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.CADENCE_SPACING, `date at index ${i} (${dates[i].toISOString()}) does not match the ${frequency} cadence (expected ${expected.toISOString()})`, i);
        }
      }
      if (!(0, windowValidation_1.isBeforeContractEnd)(dates[dates.length - 1], endDate)) {
        fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.CADENCE_OUT_OF_BOUNDS, `last charge date (${dates[dates.length - 1].toISOString()}) is on or after the contract end`);
      }
      if (dates.length < generateInstallmentDates_1.MAX_INSTALLMENT_COUNT && !skipCompletenessCheck) {
        const nextAfterLast = (0, dateArithmeticUtils_1.addMonthsAnchored)(dates[0], monthStep * dates.length, anchorDay);
        if (nextAfterLast < endDate) {
          fail(generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.CADENCE_INCOMPLETE, `schedule is incomplete \u2014 next cadence date (${nextAfterLast.toISOString()}) falls before the contract end, so the generator would have emitted it`);
        }
      }
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertScheduleAmounts.js
var require_assertScheduleAmounts = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertScheduleAmounts.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.assertScheduleAmounts = assertScheduleAmounts;
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var CHARGE_AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;
    function toCents(value) {
      return Math.round(value * 100);
    }
    function assertScheduleAmounts({ amounts, total }) {
      if (Math.abs(Math.round(total * 100) - total * 100) > 1e-6) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.AMOUNT_SUM_MISMATCH,
          reason: `expected total (${total}) must be a 2-decimal amount`
        });
      }
      if (amounts.length < 1) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.EMPTY,
          reason: "schedule must contain at least one installment amount"
        });
      }
      if (amounts.length > generateInstallmentDates_1.MAX_INSTALLMENT_COUNT) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.CADENCE_OVER_CAP,
          reason: `schedule exceeds the ${generateInstallmentDates_1.MAX_INSTALLMENT_COUNT}-installment cap`
        });
      }
      let sumCents = 0;
      for (let i = 0; i < amounts.length; i++) {
        const raw = amounts[i];
        if (!CHARGE_AMOUNT_PATTERN.test(raw)) {
          throw new generateInstallmentDates_1.InstallmentScheduleError({
            code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.AMOUNT_NOT_POSITIVE,
            reason: `amount at index ${i} ('${raw}') is not a valid 2-decimal charge amount`,
            field: "chargeAmount",
            index: i
          });
        }
        const value = Number(raw);
        if (value <= 0) {
          throw new generateInstallmentDates_1.InstallmentScheduleError({
            code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.AMOUNT_NOT_POSITIVE,
            reason: `amount at index ${i} ('${raw}') must be strictly positive`,
            field: "chargeAmount",
            index: i
          });
        }
        sumCents += toCents(value);
      }
      const totalCents = toCents(total);
      if (sumCents !== totalCents) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.AMOUNT_SUM_MISMATCH,
          reason: `installment amounts sum to ${(sumCents / 100).toFixed(2)} but the expected total is ${(totalCents / 100).toFixed(2)}`
        });
      }
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/roundingUtils.js
var require_roundingUtils = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/roundingUtils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toDecimalPrecision = toDecimalPrecision;
    var DEFAULT_PRECISION = 2;
    function toDecimalPrecision(value, precision = DEFAULT_PRECISION) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        useGrouping: false
      }).format(value);
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/splitAmountUtils.js
var require_splitAmountUtils = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/splitAmountUtils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initialPaymentStarvesSchedule = initialPaymentStarvesSchedule;
    exports.splitEvenly = splitEvenly;
    exports.splitAmount = splitAmount;
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var roundingUtils_1 = require_roundingUtils();
    function floorToCents(value) {
      return Math.floor(value * 100) / 100;
    }
    function initialPaymentStarvesSchedule({ total, initialPayment, fullCount }) {
      if (fullCount < 2) {
        return false;
      }
      const roundedInitial = Number((0, roundingUtils_1.toDecimalPrecision)(initialPayment));
      if (roundedInitial <= 0) {
        return false;
      }
      const remainderCents = Math.round((total - roundedInitial) * 100);
      return remainderCents > 0 && remainderCents < fullCount - 1;
    }
    function splitEvenly(total, n2) {
      let per = (0, roundingUtils_1.toDecimalPrecision)(total / n2);
      let last = total - Number(per) * (n2 - 1);
      if (Number((0, roundingUtils_1.toDecimalPrecision)(last)) <= 0) {
        per = (0, roundingUtils_1.toDecimalPrecision)(floorToCents(total / n2));
        last = total - Number(per) * (n2 - 1);
      }
      const body = Array.from({ length: n2 - 1 }, () => per);
      return [...body, (0, roundingUtils_1.toDecimalPrecision)(last)];
    }
    function splitAmount({ total, count, initialPayment }) {
      if (count === 1) {
        return [(0, roundingUtils_1.toDecimalPrecision)(total)];
      }
      if (initialPayment !== void 0) {
        const roundedInitialStr = (0, roundingUtils_1.toDecimalPrecision)(initialPayment);
        const roundedInitial = Number(roundedInitialStr);
        if (roundedInitial <= 0 || roundedInitial >= total) {
          throw new generateInstallmentDates_1.InstallmentScheduleError({
            code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_INITIAL_PAYMENT,
            reason: `initialPayment (${initialPayment}) must round to > 0 and < total (${total}) for a ${count}-installment schedule`
          });
        }
        return [roundedInitialStr, ...splitEvenly(total - roundedInitial, count - 1)];
      }
      return splitEvenly(total, count);
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertSchedule.js
var require_assertSchedule = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/assertSchedule.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.assertSchedule = assertSchedule;
    var assertScheduleAmounts_1 = require_assertScheduleAmounts();
    var assertScheduleCadence_1 = require_assertScheduleCadence();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var splitAmountUtils_1 = require_splitAmountUtils();
    var ISO_UTC_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
    function parseIsoUtcDate(raw, index) {
      if (!ISO_UTC_DATE_PATTERN.test(raw)) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.DATE_FORMAT,
          field: "chargeDate",
          index,
          reason: `chargeDate at index ${index} ('${raw}') is not an ISO-8601 UTC date (YYYY-MM-DD)`
        });
      }
      const parsed = /* @__PURE__ */ new Date(`${raw}T00:00:00.000Z`);
      if (Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== raw) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.DATE_FORMAT,
          field: "chargeDate",
          index,
          reason: `chargeDate at index ${index} ('${raw}') is not a valid calendar date`
        });
      }
      return parsed;
    }
    function assertSchedule({ terms, frequency, endDate, total, dayOfMonth }) {
      if (terms.length < 1) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.EMPTY,
          reason: "schedule must contain at least one installment"
        });
      }
      const dates = terms.map((term, index) => parseIsoUtcDate(term.chargeDate, index));
      const amounts = terms.map((term) => term.chargeAmount);
      const skipCompletenessCheck = isInitialPaymentCollapse({ dates, amounts, frequency, endDate, total, dayOfMonth });
      (0, assertScheduleCadence_1.assertScheduleCadence)({ dates, frequency, endDate, dayOfMonth, skipCompletenessCheck });
      (0, assertScheduleAmounts_1.assertScheduleAmounts)({ amounts, total });
    }
    function isInitialPaymentCollapse({ dates, amounts, frequency, endDate, total, dayOfMonth }) {
      if (dates.length !== 2) {
        return false;
      }
      const initialPayment = Number(amounts[0]);
      if (!Number.isFinite(initialPayment) || initialPayment <= 0) {
        return false;
      }
      let fullCount;
      try {
        fullCount = (0, generateInstallmentDates_1.generateInstallmentDates)({ firstPaymentDate: dates[0], endDate, frequency, dayOfMonth }).length;
      } catch {
        return false;
      }
      if (fullCount <= 2) {
        return false;
      }
      return (0, splitAmountUtils_1.initialPaymentStarvesSchedule)({ total, initialPayment, fullCount });
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/buildInstallmentSchedule.js
var require_buildInstallmentSchedule = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/buildInstallmentSchedule.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.buildInstallmentSchedule = buildInstallmentSchedule;
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var roundingUtils_1 = require_roundingUtils();
    var splitAmountUtils_1 = require_splitAmountUtils();
    var windowValidation_1 = require_windowValidation();
    function buildInstallmentSchedule(input) {
      const endDate = (0, windowValidation_1.addContractDuration)(input.contractWindowAnchor, input.durationISO);
      const dates = (0, generateInstallmentDates_1.generateInstallmentDates)({
        firstPaymentDate: input.firstPaymentDate,
        endDate,
        frequency: input.frequency,
        dayOfMonth: input.dayOfMonth
      });
      if (input.initialPayment !== void 0 && (0, splitAmountUtils_1.initialPaymentStarvesSchedule)({ total: input.total, initialPayment: input.initialPayment, fullCount: dates.length })) {
        if (dates.length < 2) {
          throw new generateInstallmentDates_1.InstallmentScheduleError({
            code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.GENERATION_FAILED,
            reason: `initial-payment collapse requires a second installment date but the window yielded ${dates.length}`
          });
        }
        const roundedInitialStr = (0, roundingUtils_1.toDecimalPrecision)(input.initialPayment);
        const remainderStr = (0, roundingUtils_1.toDecimalPrecision)(input.total - Number(roundedInitialStr));
        return [
          { date: dates[0], amount: roundedInitialStr },
          { date: dates[1], amount: remainderStr }
        ];
      }
      const amounts = (0, splitAmountUtils_1.splitAmount)({ total: input.total, count: dates.length, initialPayment: input.initialPayment });
      return dates.map((date, i) => ({ date, amount: amounts[i] }));
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/computeInstallmentCount.js
var require_computeInstallmentCount = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/computeInstallmentCount.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.computeInstallmentCount = computeInstallmentCount;
    var schemas_1 = require_schemas3();
    function computeInstallmentCount(durationMonths, frequency) {
      return Math.floor(durationMonths / schemas_1.PAYMENT_SCHEDULE_FREQUENCY_MONTHS[frequency]);
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/addCalendarDuration.js
var require_addCalendarDuration = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/addCalendarDuration.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.addCalendarDuration = addCalendarDuration;
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var isoDurationUtils_1 = require_isoDurationUtils();
    function addCalendarDuration(base, durationISO) {
      const components = (0, isoDurationUtils_1.tokenizeIsoDuration)(durationISO);
      if (!components) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_DURATION,
          reason: `duration "${durationISO}" is malformed or empty`
        });
      }
      const yearMonth = (0, dateArithmeticUtils_1.addMonthsAnchored)(base, components.years * 12 + components.months, base.getUTCDate());
      return new Date(yearMonth.getTime() + components.days * dateArithmeticUtils_1.MS_PER_DAY);
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/computeOfferExpiry.js
var require_computeOfferExpiry = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/computeOfferExpiry.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.computeOfferExpiry = computeOfferExpiry;
    var addCalendarDuration_1 = require_addCalendarDuration();
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    function dayBefore(date) {
      return new Date(date.getTime() - dateArithmeticUtils_1.MS_PER_DAY);
    }
    function computeOfferExpiry({ chargeDates, sellerExpirationISO, offerCreationDate, agreementStartDate }) {
      if (chargeDates.length < 1) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.INVALID_OFFER_EXPIRY,
          reason: "schedule must contain at least one charge date"
        });
      }
      const candidates = [(0, addCalendarDuration_1.addCalendarDuration)(offerCreationDate, sellerExpirationISO)];
      if (chargeDates.length >= 2) {
        candidates.push(dayBefore(chargeDates[1]));
      }
      if (agreementStartDate !== void 0) {
        candidates.push(dayBefore(agreementStartDate));
      }
      return candidates.reduce((earliest, candidate) => candidate < earliest ? candidate : earliest);
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/firstInvoiceDateRange.js
var require_firstInvoiceDateRange = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/firstInvoiceDateRange.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resolveFirstInvoiceDateRange = resolveFirstInvoiceDateRange;
    var dateArithmeticUtils_1 = require_dateArithmeticUtils();
    function startOfUtcDay(date) {
      return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }
    function resolveFirstInvoiceDateRange(referenceTime) {
      const creationDay = startOfUtcDay(referenceTime);
      const earliest = new Date(creationDay.getTime() + dateArithmeticUtils_1.MS_PER_DAY);
      const oneMonthOut = (0, dateArithmeticUtils_1.addMonthsAnchored)(creationDay, 1, creationDay.getUTCDate());
      const latest = new Date(oneMonthOut.getTime() - dateArithmeticUtils_1.MS_PER_DAY);
      return { earliest, latest };
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/deriveRenewalTermTemplate.js
var require_deriveRenewalTermTemplate = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/deriveRenewalTermTemplate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RENEWAL_TEMPLATE_DAY_ONE_OFFSET = exports.RENEWAL_TEMPLATE_TOTAL_PERCENTAGE = void 0;
    exports.deriveRenewalTermTemplate = deriveRenewalTermTemplate2;
    var schemas_1 = require_schemas3();
    var computeInstallmentCount_1 = require_computeInstallmentCount();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    var splitAmountUtils_1 = require_splitAmountUtils();
    var windowValidation_1 = require_windowValidation();
    exports.RENEWAL_TEMPLATE_TOTAL_PERCENTAGE = 100;
    exports.RENEWAL_TEMPLATE_DAY_ONE_OFFSET = "P0M";
    function deriveRenewalTermTemplate2({ frequency, durationISO, dayOfMonth }) {
      if (dayOfMonth !== void 0) {
        (0, generateInstallmentDates_1.assertValidDayOfMonth)(dayOfMonth);
      }
      const durationMonths = (0, windowValidation_1.parseDurationMonths)(durationISO);
      const count = Math.min(generateInstallmentDates_1.MAX_INSTALLMENT_COUNT, Math.max(1, (0, computeInstallmentCount_1.computeInstallmentCount)(durationMonths, frequency)));
      const monthStep = schemas_1.PAYMENT_SCHEDULE_FREQUENCY_MONTHS[frequency];
      const percentages = (0, splitAmountUtils_1.splitEvenly)(exports.RENEWAL_TEMPLATE_TOTAL_PERCENTAGE, count);
      return percentages.map((chargePercentage, index) => {
        const pinDayOfMonth = dayOfMonth !== void 0;
        return {
          chargeDateOffset: `P${monthStep * index}M`,
          chargePercentage,
          ...pinDayOfMonth ? { dayOfMonth } : {}
        };
      });
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/chargeDistribution.js
var require_chargeDistribution = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/chargeDistribution.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.scaleForCurrency = scaleForCurrency;
    exports.totalToMinorUnits = totalToMinorUnits;
    exports.distributeChargeMinorUnits = distributeChargeMinorUnits;
    exports.minorUnitsToAmount = minorUnitsToAmount;
    exports.distributeCharges = distributeCharges2;
    var schemas_1 = require_schemas3();
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    function scaleForCurrency(currencyCode) {
      return schemas_1.CURRENCY_MINOR_UNIT_SCALE[currencyCode];
    }
    function parseNonNegativeDecimal(decimal) {
      const trimmed = decimal.trim();
      if (!/^\d+(\.\d+)?$/.test(trimmed)) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.GENERATION_FAILED,
          reason: `Unexpected non-negative decimal value: ${decimal}`
        });
      }
      const [intPart, fracPart = ""] = trimmed.split(".");
      return { scaled: BigInt(intPart + fracPart), pow: 10n ** BigInt(fracPart.length) };
    }
    function totalToMinorUnits(total, scale) {
      if (!Number.isFinite(total) || total < 0) {
        throw new generateInstallmentDates_1.InstallmentScheduleError({
          code: generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE.AMOUNT_NOT_POSITIVE,
          reason: `Unexpected charge total: ${total}`,
          field: "chargeAmount"
        });
      }
      return Math.round(total * 10 ** scale);
    }
    function distributeChargeMinorUnits(totalMinorUnits, percentages) {
      const total = BigInt(totalMinorUnits);
      const parsed = percentages.map(parseNonNegativeDecimal);
      const commonPow = parsed.reduce((max, entry) => entry.pow > max ? entry.pow : max, 1n);
      const denom = commonPow * 100n;
      const numerators = parsed.map((entry) => total * entry.scaled * (commonPow / entry.pow));
      const order = numerators.map((numerator, index) => ({ remainder: numerator % denom, index })).sort((a, b) => b.remainder > a.remainder ? 1 : b.remainder < a.remainder ? -1 : a.index - b.index).map((entry) => entry.index);
      const units = numerators.map((numerator) => Number(numerator / denom));
      let deficit = totalMinorUnits - units.reduce((sum, unit) => sum + unit, 0);
      for (let k = 0; deficit > 0; k = (k + 1) % order.length, deficit -= 1) {
        units[order[k]] += 1;
      }
      return units;
    }
    function minorUnitsToAmount(minorUnits, scale) {
      return minorUnits / 10 ** scale;
    }
    function distributeCharges2(input) {
      const scale = scaleForCurrency(input.currencyCode);
      const totalMinorUnits = totalToMinorUnits(input.total, scale);
      const chargeMinorUnits = input.percentages.length === 0 ? [] : distributeChargeMinorUnits(totalMinorUnits, input.percentages);
      return {
        totalAmount: minorUnitsToAmount(totalMinorUnits, scale),
        chargeAmounts: chargeMinorUnits.map((minorUnits) => minorUnitsToAmount(minorUnits, scale))
      };
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/index.js
var require_payment_schedule = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/payment-schedule/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.distributeCharges = exports.deriveRenewalTermTemplate = exports.resolveFirstInvoiceDateRange = exports.computeOfferExpiry = exports.computeInstallmentCount = exports.isWithinContractEnd = exports.isFirstPaymentDateWithinLimit = exports.isBeforeContractEnd = exports.addContractDuration = exports.buildInstallmentSchedule = exports.splitAmount = exports.assertSchedule = exports.assertScheduleAmounts = exports.assertScheduleCadence = exports.MIN_DAY_OF_MONTH = exports.MAX_DAY_OF_MONTH = exports.MAX_INSTALLMENT_COUNT = exports.InstallmentScheduleError = exports.INSTALLMENT_SCHEDULE_ERROR_CODE = exports.generateInstallmentDates = void 0;
    var generateInstallmentDates_1 = require_generateInstallmentDates();
    Object.defineProperty(exports, "generateInstallmentDates", { enumerable: true, get: function() {
      return generateInstallmentDates_1.generateInstallmentDates;
    } });
    Object.defineProperty(exports, "INSTALLMENT_SCHEDULE_ERROR_CODE", { enumerable: true, get: function() {
      return generateInstallmentDates_1.INSTALLMENT_SCHEDULE_ERROR_CODE;
    } });
    Object.defineProperty(exports, "InstallmentScheduleError", { enumerable: true, get: function() {
      return generateInstallmentDates_1.InstallmentScheduleError;
    } });
    Object.defineProperty(exports, "MAX_INSTALLMENT_COUNT", { enumerable: true, get: function() {
      return generateInstallmentDates_1.MAX_INSTALLMENT_COUNT;
    } });
    Object.defineProperty(exports, "MAX_DAY_OF_MONTH", { enumerable: true, get: function() {
      return generateInstallmentDates_1.MAX_DAY_OF_MONTH;
    } });
    Object.defineProperty(exports, "MIN_DAY_OF_MONTH", { enumerable: true, get: function() {
      return generateInstallmentDates_1.MIN_DAY_OF_MONTH;
    } });
    var assertScheduleCadence_1 = require_assertScheduleCadence();
    Object.defineProperty(exports, "assertScheduleCadence", { enumerable: true, get: function() {
      return assertScheduleCadence_1.assertScheduleCadence;
    } });
    var assertScheduleAmounts_1 = require_assertScheduleAmounts();
    Object.defineProperty(exports, "assertScheduleAmounts", { enumerable: true, get: function() {
      return assertScheduleAmounts_1.assertScheduleAmounts;
    } });
    var assertSchedule_1 = require_assertSchedule();
    Object.defineProperty(exports, "assertSchedule", { enumerable: true, get: function() {
      return assertSchedule_1.assertSchedule;
    } });
    var splitAmountUtils_1 = require_splitAmountUtils();
    Object.defineProperty(exports, "splitAmount", { enumerable: true, get: function() {
      return splitAmountUtils_1.splitAmount;
    } });
    var buildInstallmentSchedule_1 = require_buildInstallmentSchedule();
    Object.defineProperty(exports, "buildInstallmentSchedule", { enumerable: true, get: function() {
      return buildInstallmentSchedule_1.buildInstallmentSchedule;
    } });
    var windowValidation_1 = require_windowValidation();
    Object.defineProperty(exports, "addContractDuration", { enumerable: true, get: function() {
      return windowValidation_1.addContractDuration;
    } });
    Object.defineProperty(exports, "isBeforeContractEnd", { enumerable: true, get: function() {
      return windowValidation_1.isBeforeContractEnd;
    } });
    Object.defineProperty(exports, "isFirstPaymentDateWithinLimit", { enumerable: true, get: function() {
      return windowValidation_1.isFirstPaymentDateWithinLimit;
    } });
    Object.defineProperty(exports, "isWithinContractEnd", { enumerable: true, get: function() {
      return windowValidation_1.isWithinContractEnd;
    } });
    var computeInstallmentCount_1 = require_computeInstallmentCount();
    Object.defineProperty(exports, "computeInstallmentCount", { enumerable: true, get: function() {
      return computeInstallmentCount_1.computeInstallmentCount;
    } });
    var computeOfferExpiry_1 = require_computeOfferExpiry();
    Object.defineProperty(exports, "computeOfferExpiry", { enumerable: true, get: function() {
      return computeOfferExpiry_1.computeOfferExpiry;
    } });
    var firstInvoiceDateRange_1 = require_firstInvoiceDateRange();
    Object.defineProperty(exports, "resolveFirstInvoiceDateRange", { enumerable: true, get: function() {
      return firstInvoiceDateRange_1.resolveFirstInvoiceDateRange;
    } });
    var deriveRenewalTermTemplate_1 = require_deriveRenewalTermTemplate();
    Object.defineProperty(exports, "deriveRenewalTermTemplate", { enumerable: true, get: function() {
      return deriveRenewalTermTemplate_1.deriveRenewalTermTemplate;
    } });
    var chargeDistribution_1 = require_chargeDistribution();
    Object.defineProperty(exports, "distributeCharges", { enumerable: true, get: function() {
      return chargeDistribution_1.distributeCharges;
    } });
  }
});

// ../../node_modules/validator/lib/util/assertString.js
var require_assertString = __commonJS({
  "../../node_modules/validator/lib/util/assertString.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = assertString;
    function assertString(input) {
      if (input === void 0 || input === null)
        throw new TypeError("Expected a string but received a ".concat(input));
      if (input.constructor.name !== "String")
        throw new TypeError("Expected a string but received a ".concat(input.constructor.name));
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/util/checkHost.js
var require_checkHost = __commonJS({
  "../../node_modules/validator/lib/util/checkHost.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = checkHost;
    function isRegExp(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    }
    function checkHost(host, matches) {
      for (var i = 0; i < matches.length; i++) {
        var match2 = matches[i];
        if (host === match2 || isRegExp(match2) && match2.test(host)) {
          return true;
        }
      }
      return false;
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/isByteLength.js
var require_isByteLength = __commonJS({
  "../../node_modules/validator/lib/isByteLength.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isByteLength;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isByteLength(str, options) {
      (0, _assertString.default)(str);
      var min;
      var max;
      if (_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
      } else {
        min = arguments[1];
        max = arguments[2];
      }
      var len = encodeURI(str).split(/%..|./).length - 1;
      return len >= min && (typeof max === "undefined" || len <= max);
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/util/merge.js
var require_merge = __commonJS({
  "../../node_modules/validator/lib/util/merge.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = merge;
    function merge() {
      var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var defaults = arguments.length > 1 ? arguments[1] : void 0;
      for (var key in defaults) {
        if (typeof obj[key] === "undefined") {
          obj[key] = defaults[key];
        }
      }
      return obj;
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/isFQDN.js
var require_isFQDN = __commonJS({
  "../../node_modules/validator/lib/isFQDN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isFQDN;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_fqdn_options = {
      require_tld: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_numeric_tld: false,
      allow_wildcard: false,
      ignore_max_length: false
    };
    function isFQDN(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_fqdn_options);
      if (options.allow_trailing_dot && str[str.length - 1] === ".") {
        str = str.substring(0, str.length - 1);
      }
      if (options.allow_wildcard === true && str.indexOf("*.") === 0) {
        str = str.substring(2);
      }
      var parts = str.split(".");
      var tld = parts[parts.length - 1];
      if (options.require_tld) {
        if (parts.length < 2) {
          return false;
        }
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
          return false;
        }
        if (/\s/.test(tld)) {
          return false;
        }
      }
      if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
        return false;
      }
      return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) {
          return false;
        }
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
          return false;
        }
        if (/[\uff01-\uff5e]/.test(part)) {
          return false;
        }
        if (/^-|-$/.test(part)) {
          return false;
        }
        if (!options.allow_underscores && /_/.test(part)) {
          return false;
        }
        return true;
      });
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/isIP.js
var require_isIP = __commonJS({
  "../../node_modules/validator/lib/isIP.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIP;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    var IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
    var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
    var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
    var IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
    var IPv6AddressRegExp = new RegExp("^(" + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z.]{1,})?$");
    function isIP(ipAddress) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(ipAddress);
      var version = (_typeof(options) === "object" ? options.version : arguments[1]) || "";
      if (!version) {
        return isIP(ipAddress, {
          version: 4
        }) || isIP(ipAddress, {
          version: 6
        });
      }
      if (version.toString() === "4") {
        return IPv4AddressRegExp.test(ipAddress);
      }
      if (version.toString() === "6") {
        return IPv6AddressRegExp.test(ipAddress);
      }
      return false;
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/validator/lib/isEmail.js
var require_isEmail = __commonJS({
  "../../node_modules/validator/lib/isEmail.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isEmail2;
    var _assertString = _interopRequireDefault(require_assertString());
    var _checkHost = _interopRequireDefault(require_checkHost());
    var _isByteLength = _interopRequireDefault(require_isByteLength());
    var _isFQDN = _interopRequireDefault(require_isFQDN());
    var _isIP = _interopRequireDefault(require_isIP());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_email_options = {
      allow_display_name: false,
      allow_underscores: false,
      require_display_name: false,
      allow_utf8_local_part: true,
      require_tld: true,
      blacklisted_chars: "",
      ignore_max_length: false,
      host_blacklist: [],
      host_whitelist: []
    };
    var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
    var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
    var gmailUserPart = /^[a-z\d]+$/;
    var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
    var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
    var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
    var defaultMaxEmailLength = 254;
    function validateDisplayName(display_name) {
      var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1");
      if (!display_name_without_quotes.trim()) {
        return false;
      }
      var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
      if (contains_illegal) {
        if (display_name_without_quotes === display_name) {
          return false;
        }
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) {
          return false;
        }
      }
      return true;
    }
    function isEmail2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_email_options);
      if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match(splitNameAddress);
        if (display_email) {
          var display_name = display_email[1];
          str = str.replace(display_name, "").replace(/(^<|>$)/g, "");
          if (display_name.endsWith(" ")) {
            display_name = display_name.slice(0, -1);
          }
          if (!validateDisplayName(display_name)) {
            return false;
          }
        } else if (options.require_display_name) {
          return false;
        }
      }
      if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
        return false;
      }
      var parts = str.split("@");
      var domain = parts.pop();
      var lower_domain = domain.toLowerCase();
      if (options.host_blacklist.length > 0 && (0, _checkHost.default)(lower_domain, options.host_blacklist)) {
        return false;
      }
      if (options.host_whitelist.length > 0 && !(0, _checkHost.default)(lower_domain, options.host_whitelist)) {
        return false;
      }
      var user = parts.join("@");
      if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        user = user.toLowerCase();
        var username = user.split("+")[0];
        if (!(0, _isByteLength.default)(username.replace(/\./g, ""), {
          min: 6,
          max: 30
        })) {
          return false;
        }
        var _user_parts = username.split(".");
        for (var i = 0; i < _user_parts.length; i++) {
          if (!gmailUserPart.test(_user_parts[i])) {
            return false;
          }
        }
      }
      if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
        max: 64
      }) || !(0, _isByteLength.default)(domain, {
        max: 254
      }))) {
        return false;
      }
      if (!(0, _isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
      })) {
        if (!options.allow_ip_domain) {
          return false;
        }
        if (!(0, _isIP.default)(domain)) {
          if (!domain.startsWith("[") || !domain.endsWith("]")) {
            return false;
          }
          var noBracketdomain = domain.slice(1, -1);
          if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
            return false;
          }
        }
      }
      if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1)
          return false;
      }
      if (user[0] === '"' && user[user.length - 1] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
      }
      var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
      var user_parts = user.split(".");
      for (var _i = 0; _i < user_parts.length; _i++) {
        if (!pattern.test(user_parts[_i])) {
          return false;
        }
      }
      return true;
    }
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/validation-types.js
var require_validation_types = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/validation-types.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatValidationErrors = formatValidationErrors;
    function formatValidationErrors(errors) {
      if (errors.length === 1) {
        return errors[0].message;
      }
      return `Multiple validation errors: ${errors.map((e) => e.message).join("; ")}`;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/price-validator.js
var require_price_validator = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/price-validator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PriceValidator = void 0;
    var constants_1 = require_constants();
    var { MAX_DIMENSION_PRICE, MAX_PRICE_DECIMAL_PLACES, MAX_PRICE_SIGNIFICANT_DIGITS } = constants_1.EpocValidation;
    function toPlainDecimalString(value) {
      const str = value.toString();
      const match2 = /^(-?)(\d+)(?:\.(\d+))?[eE]([+-]?\d+)$/.exec(str);
      if (!match2) {
        return str;
      }
      const [, sign, intPart, fracPart = "", expStr] = match2;
      const digits = intPart + fracPart;
      const pointFromLeft = intPart.length + Number(expStr);
      if (pointFromLeft <= 0) {
        return `${sign}0.${"0".repeat(-pointFromLeft)}${digits}`;
      }
      if (pointFromLeft >= digits.length) {
        return `${sign}${digits}${"0".repeat(pointFromLeft - digits.length)}`;
      }
      return `${sign}${digits.slice(0, pointFromLeft)}.${digits.slice(pointFromLeft)}`;
    }
    var PriceValidator = class {
      // Re-export constants as static properties for backwards compatibility
      static MAX_DECIMAL_PLACES = MAX_PRICE_DECIMAL_PLACES;
      static MAX_SIGNIFICANT_DIGITS = MAX_PRICE_SIGNIFICANT_DIGITS;
      static MAX_PRICE = MAX_DIMENSION_PRICE;
      static validate(price) {
        if (price <= 0) {
          throw new Error("Price must be greater than 0");
        }
        if (price > MAX_DIMENSION_PRICE) {
          throw new Error(`Price cannot exceed ${MAX_DIMENSION_PRICE}`);
        }
        const str = toPlainDecimalString(price);
        const parts = str.split(".");
        if (parts.length > 1 && parts[1].length > MAX_PRICE_DECIMAL_PLACES) {
          throw new Error(`Price must have at most ${MAX_PRICE_DECIMAL_PLACES} decimal places`);
        }
        const significantDigits = str.replace(".", "").replace(/^0+/, "").length;
        if (significantDigits > MAX_PRICE_SIGNIFICANT_DIGITS) {
          throw new Error(`Price has too many significant digits (max ${MAX_PRICE_SIGNIFICANT_DIGITS})`);
        }
      }
    };
    exports.PriceValidator = PriceValidator;
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/tier-validator.js
var require_tier_validator = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/tier-validator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TierValidator = void 0;
    exports.validateTcvTierOverlap = validateTcvTierOverlap;
    exports.validateQuantityTierOverlap = validateQuantityTierOverlap;
    function validateTcvTierOverlap(tiers) {
      if (tiers.length <= 1) {
        return [];
      }
      const errors = [];
      const sortedTiers = [...tiers].sort((a, b) => a.MinValue - b.MinValue);
      for (let i = 0; i < sortedTiers.length - 1; i++) {
        const currentTier = sortedTiers[i];
        const nextTier = sortedTiers[i + 1];
        if (currentTier.MaxValue > nextTier.MinValue) {
          errors.push({
            tierIndex: i,
            message: `Overlap between tier ${i + 1} [${currentTier.MinValue}, ${currentTier.MaxValue}) and tier ${i + 2} [${nextTier.MinValue}, ${nextTier.MaxValue}): values in range [${nextTier.MinValue}, ${currentTier.MaxValue}) would match multiple tiers`
          });
        }
      }
      return errors;
    }
    function validateQuantityTierOverlap(tiers) {
      if (tiers.length <= 1) {
        return [];
      }
      const errors = [];
      const sortedTiers = [...tiers].sort((a, b) => a.MinValue - b.MinValue);
      for (let i = 0; i < sortedTiers.length - 1; i++) {
        const currentTier = sortedTiers[i];
        const nextTier = sortedTiers[i + 1];
        if (currentTier.MaxValue >= nextTier.MinValue) {
          errors.push({
            tierIndex: i,
            message: `Overlap between tier ${i + 1} [${currentTier.MinValue}, ${currentTier.MaxValue}] and tier ${i + 2} [${nextTier.MinValue}, ${nextTier.MaxValue}]: quantity ${nextTier.MinValue} to ${currentTier.MaxValue} would match multiple tiers`
          });
        }
      }
      return errors;
    }
    var TierValidator = class {
      /**
       * Validates that TCV (Total Contract Value) tiers do not overlap.
       *
       * Uses [min, max) half-open interval semantics. Gaps are allowed.
       *
       * @param tiers - Array of TCV discount tiers
       * @throws Error if tiers overlap
       */
      static validateTcvTiers(tiers) {
        const errors = validateTcvTierOverlap(tiers);
        if (errors.length > 0) {
          throw new Error(`TotalContractValue discount tiers overlap: ${errors[0].message}`);
        }
      }
      /**
       * Validates that per-dimension quantity tiers do not overlap.
       *
       * Uses [min, max] closed interval semantics. Gaps are allowed.
       *
       * @param perDimensionTiers - Record of dimension key to array of tiers
       * @throws Error if any dimension's tiers overlap
       */
      static validatePerDimensionTiers(perDimensionTiers) {
        for (const [dimensionKey, tiers] of Object.entries(perDimensionTiers)) {
          const errors = validateQuantityTierOverlap(tiers);
          if (errors.length > 0) {
            throw new Error(`DimensionQuantity discount tiers for dimension '${dimensionKey}' overlap: ${errors[0].message}`);
          }
        }
      }
      /**
       * Validates all discount rule tiers for overlaps.
       *
       * - TCV tiers use [min, max) semantics (for decimal prices)
       * - Quantity tiers use [min, max] semantics (for integer quantities)
       * - Gaps between tiers are allowed
       *
       * @param discountRules - The discount rules object (optional)
       * @throws Error if any tiers overlap
       */
      static validateDiscountRules(discountRules) {
        if (!discountRules) {
          return;
        }
        if (discountRules.TotalContractValue) {
          this.validateTcvTiers(discountRules.TotalContractValue.Tiers);
        }
        if (discountRules.DimensionQuantity) {
          this.validatePerDimensionTiers(discountRules.DimensionQuantity.PerDimensionTiers);
        }
      }
    };
    exports.TierValidator = TierValidator;
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/offer-settings-validator.js
var require_offer_settings_validator = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/offer-settings-validator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.validateOfferSettingsBounds = validateOfferSettingsBounds;
    var constants_1 = require_constants();
    var duration_validator_1 = require_duration_validator();
    var { MIN_OFFER_DURATION_MONTHS, MAX_OFFER_DURATION_MONTHS: MAX_OFFER_DURATION_MONTHS2, MIN_EXPIRATION_DAYS: MIN_EXPIRATION_DAYS2, MAX_EXPIRATION_DAYS: MAX_EXPIRATION_DAYS2 } = constants_1.EpocValidation;
    function validateOfferSettingsBounds(offerSettings) {
      const errors = [];
      try {
        duration_validator_1.DurationValidator.validateMinMonths(offerSettings.MinOfferDuration, MIN_OFFER_DURATION_MONTHS);
      } catch {
        errors.push({
          field: "OfferSettings.MinOfferDuration",
          message: `Minimum offer duration cannot be less than ${MIN_OFFER_DURATION_MONTHS} month(s).`
        });
      }
      try {
        duration_validator_1.DurationValidator.validateMaxMonths(offerSettings.MaxOfferDuration, MAX_OFFER_DURATION_MONTHS2);
      } catch {
        errors.push({
          field: "OfferSettings.MaxOfferDuration",
          message: `Maximum offer duration cannot exceed ${MAX_OFFER_DURATION_MONTHS2} months.`
        });
      }
      try {
        const minMonths = duration_validator_1.DurationValidator.toMonths(offerSettings.MinOfferDuration);
        const maxMonths = duration_validator_1.DurationValidator.toMonths(offerSettings.MaxOfferDuration);
        if (minMonths > maxMonths) {
          errors.push({
            field: "OfferSettings.MinOfferDuration",
            message: "Minimum offer duration must be less than or equal to maximum offer duration."
          });
        }
      } catch {
      }
      try {
        duration_validator_1.DurationValidator.validateMinDays(offerSettings.Expiration, MIN_EXPIRATION_DAYS2);
      } catch {
        errors.push({
          field: "OfferSettings.Expiration",
          message: `Expiration duration must be at least ${MIN_EXPIRATION_DAYS2} day(s).`
        });
      }
      try {
        duration_validator_1.DurationValidator.validateMaxDays(offerSettings.Expiration, MAX_EXPIRATION_DAYS2);
      } catch {
        errors.push({
          field: "OfferSettings.Expiration",
          message: `Expiration duration cannot exceed ${MAX_EXPIRATION_DAYS2} days.`
        });
      }
      try {
        const expirationDays = duration_validator_1.DurationValidator.toDays(offerSettings.Expiration);
        const maxFutureStartDays = (0, constants_1.calculateMaxFutureStartDays)(expirationDays);
        try {
          duration_validator_1.DurationValidator.validateMaxDays(offerSettings.MaxFutureStartDuration, maxFutureStartDays);
        } catch {
          errors.push({
            field: "OfferSettings.MaxFutureStartDuration",
            message: `Maximum future start duration cannot exceed ${maxFutureStartDays} days (calculated as 3 years minus expiration of ${expirationDays} days minus 1 day buffer).`
          });
        }
      } catch {
      }
      return errors;
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/create-input-validator.js
var require_create_input_validator = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/create-input-validator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.validateCreateEpoConfigInput = validateCreateEpoConfigInput2;
    exports.formatZodError = formatZodError;
    var constants_1 = require_constants();
    var offer_settings_validator_1 = require_offer_settings_validator();
    var price_validator_1 = require_price_validator();
    var tier_validator_1 = require_tier_validator();
    var { MAX_TOTAL_CONTRACT_VALUE, MAX_DIMENSIONS, CONFIGURABLE_UPFRONT_RATE_DURATION } = constants_1.EpocValidation;
    function validateCreateEpoConfigInput2(input) {
      const errors = [];
      if (input.OfferRates.ConfigurableUpfrontDimensionRates.Duration !== CONFIGURABLE_UPFRONT_RATE_DURATION) {
        errors.push({
          field: "OfferRates.ConfigurableUpfrontDimensionRates.Duration",
          message: `Configurable upfront dimension rates duration must be ${CONFIGURABLE_UPFRONT_RATE_DURATION}.`
        });
      }
      const dimensionRates = input.OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates;
      if (dimensionRates.length > MAX_DIMENSIONS) {
        errors.push({
          field: "OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates",
          message: `Cannot exceed ${MAX_DIMENSIONS} dimension rates (got ${dimensionRates.length}).`
        });
      }
      const dimensionKeys = dimensionRates.map((dr) => dr.DimensionKey);
      const uniqueKeys = new Set(dimensionKeys);
      if (uniqueKeys.size !== dimensionKeys.length) {
        const duplicates = dimensionKeys.filter((key, idx) => dimensionKeys.indexOf(key) !== idx);
        errors.push({
          field: "OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates",
          message: `Duplicate dimension key found: ${duplicates[0]}. All dimension keys must be unique.`
        });
      }
      errors.push(...(0, offer_settings_validator_1.validateOfferSettingsBounds)(input.OfferSettings));
      if (input.Guardrails.MaxTotalContractValue <= 0) {
        errors.push({
          field: "Guardrails.MaxTotalContractValue",
          message: "Maximum total contract value must be greater than 0."
        });
      }
      if (input.Guardrails.MaxTotalContractValue >= MAX_TOTAL_CONTRACT_VALUE) {
        errors.push({
          field: "Guardrails.MaxTotalContractValue",
          message: `Maximum total contract value must be less than ${MAX_TOTAL_CONTRACT_VALUE}.`
        });
      }
      for (const dimensionRate of input.OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates) {
        try {
          price_validator_1.PriceValidator.validate(dimensionRate.Price);
        } catch {
          errors.push({
            field: `OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates[${dimensionRate.DimensionKey}].Price`,
            message: `Invalid price for dimension ${dimensionRate.DimensionKey}. Price must be a positive number with at most 8 decimal places.`
          });
        }
      }
      const maxDiscount = input.Guardrails.MaxDiscountPercentage;
      const hasDiscountRules = input.DiscountRules !== void 0;
      if (maxDiscount > 0 && !hasDiscountRules) {
        errors.push({
          field: "DiscountRules",
          message: "DiscountRules is required when MaxDiscountPercentage is greater than 0."
        });
      }
      if (maxDiscount === 0 && hasDiscountRules) {
        errors.push({
          field: "Guardrails.MaxDiscountPercentage",
          message: "MaxDiscountPercentage must be greater than 0 when DiscountRules is specified."
        });
      }
      if (input.DiscountRules) {
        try {
          tier_validator_1.TierValidator.validateDiscountRules(input.DiscountRules);
        } catch (error) {
          errors.push({
            field: "DiscountRules",
            message: error instanceof Error ? error.message : "Invalid discount tier configuration."
          });
        }
      }
      return errors;
    }
    function formatZodError(error) {
      return error.issues.map((issue) => {
        const path = issue.path.join(".");
        if (path) {
          return `Invalid value for '${path}': ${issue.message}`;
        }
        return issue.message;
      }).join(". ") + ".";
    }
  }
});

// ../../node_modules/@amzn/awsmp-epo-utils/dist/validation/index.js
var require_validation2 = __commonJS({
  "../../node_modules/@amzn/awsmp-epo-utils/dist/validation/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatZodError = exports.validateCreateEpoConfigInput = exports.checkRenewalDurationShorterThanMaxOffer = exports.validateOfferSettingsBounds = exports.validateQuantityTierOverlap = exports.validateTcvTierOverlap = exports.TierValidator = exports.PriceValidator = exports.formatValidationErrors = exports.DurationValidator = void 0;
    var duration_validator_1 = require_duration_validator();
    Object.defineProperty(exports, "DurationValidator", { enumerable: true, get: function() {
      return duration_validator_1.DurationValidator;
    } });
    var validation_types_1 = require_validation_types();
    Object.defineProperty(exports, "formatValidationErrors", { enumerable: true, get: function() {
      return validation_types_1.formatValidationErrors;
    } });
    var price_validator_1 = require_price_validator();
    Object.defineProperty(exports, "PriceValidator", { enumerable: true, get: function() {
      return price_validator_1.PriceValidator;
    } });
    var tier_validator_1 = require_tier_validator();
    Object.defineProperty(exports, "TierValidator", { enumerable: true, get: function() {
      return tier_validator_1.TierValidator;
    } });
    Object.defineProperty(exports, "validateTcvTierOverlap", { enumerable: true, get: function() {
      return tier_validator_1.validateTcvTierOverlap;
    } });
    Object.defineProperty(exports, "validateQuantityTierOverlap", { enumerable: true, get: function() {
      return tier_validator_1.validateQuantityTierOverlap;
    } });
    var offer_settings_validator_1 = require_offer_settings_validator();
    Object.defineProperty(exports, "validateOfferSettingsBounds", { enumerable: true, get: function() {
      return offer_settings_validator_1.validateOfferSettingsBounds;
    } });
    var renewal_duration_1 = require_renewal_duration();
    Object.defineProperty(exports, "checkRenewalDurationShorterThanMaxOffer", { enumerable: true, get: function() {
      return renewal_duration_1.checkRenewalDurationShorterThanMaxOffer;
    } });
    var create_input_validator_1 = require_create_input_validator();
    Object.defineProperty(exports, "validateCreateEpoConfigInput", { enumerable: true, get: function() {
      return create_input_validator_1.validateCreateEpoConfigInput;
    } });
    Object.defineProperty(exports, "formatZodError", { enumerable: true, get: function() {
      return create_input_validator_1.formatZodError;
    } });
  }
});

// src/aipo/GetOffer/GetOffer.tsx
import React4, { useState as useState10, useEffect as useEffect6, useRef as useRef8, useCallback as useCallback10 } from "react";
import Wizard from "@amzn/awsui-components-react/polaris/wizard";
import Link10 from "@amzn/awsui-components-react/polaris/link";
import SpaceBetween16 from "@amzn/awsui-components-react/polaris/space-between";

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.tsx
import { useMemo, useCallback as useCallback3, useState as useState2 } from "react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button2 from "@amzn/awsui-components-react/polaris/button";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import TextContent from "@amzn/awsui-components-react/polaris/text-content";
import Header from "@amzn/awsui-components-react/polaris/header";
import Container from "@amzn/awsui-components-react/polaris/container";
import Input from "@amzn/awsui-components-react/polaris/input";
import Link from "@amzn/awsui-components-react/polaris/link";
import Popover from "@amzn/awsui-components-react/polaris/popover";
import { ManagedTable } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { marketplaceLinks } from "@amzn/awsmp-max-link-catalog/browser";
import {
  HELP_PANEL_PATHSLUG
} from "@amzn/awsmp-max-agentic-renderer-interface";

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.module.scss
var UnitsStep_module_default = {};

// src/aipo/GetOffer/config/constants.ts
var PAGE_CONTEXT = {
  // Bound to the canonical EPO page-type set (@amzn/awsmp-max-model); see CreateConfig constants.
  PAGE_TYPE: "AWSMP-EPO-Request",
  // Not a canonical PageType — a client-only sub-variant appended when a lead referral is present;
  // it is not a distinct monitored page, so it is intentionally NOT bound to EpoPageType.
  REQUEST_WITH_LEAD_REFERRAL_PAGE_TYPE: "AWSMP-EPO-Request-LeadReferralPresent",
  SUB_PAGE_TYPES: {
    ASSESSMENT: "AWSMP-Assessment",
    CONTRACT_NEEDS: "AWSMP-Contract-Needs",
    ENTER_CONTACT_INFORMATION: "AWSMP-Enter-Contact-Information",
    ENTER_UNITS: "AWSMP-Enter-Units",
    REVIEW: "AWSMP-Review",
    SUCCESS: "AWSMP-Success",
    INELIGIBLE: "AWSMP-Ineligible",
    UNONBOARDED: "AWSMP-Unonboarded",
    EDIT_PAYMENT_SCHEDULE: "AWSMP-Configure-Payment-Schedule"
  }
};

// src/aipo/shared/usePageHit.ts
import { useRef } from "react";
function usePageHit(logger, pageType) {
  const emittedRef = useRef(false);
  if (!emittedRef.current) {
    emittedRef.current = true;
    logger.pageHit({ pageType });
  }
}
function useSubPageHit(logger, subPageType) {
  const emittedRef = useRef(false);
  if (!emittedRef.current) {
    emittedRef.current = true;
    logger.subPageHit({ subPageType });
  }
}

// src/aipo/config/epoConstants.ts
import { AgentId } from "@amzn/awsmp-max-model";
var EPO_ROUTES = {
  LIST: "/epo",
  CREATE: "/epo/create",
  VIEW: (id) => `/epo/${id}`,
  EDIT: (id) => `/epo/${id}/edit`
};
var EPO_AGENT_ID = AgentId.EpoSellerQualification;
var EPO_CONFIG_ENTITY_ID_PATTERN = /^epoconfig-[a-z0-9]+$/;
var QUERY_PARAMS = {
  CREATED: "created",
  DELETED: "deleted",
  PRODUCT_ID: "productId",
  PRODUCT_NAME: "productName"
};

// src/aipo/utils/inputUtils.ts
var parseIntegerValue = (value) => {
  if (!value || value === "")
    return void 0;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? void 0 : parsed;
};
var parseThousandsSeparated = (display) => {
  const beforeDecimal = display.split(".")[0];
  const digits = beforeDecimal.replace(/[^\d]/g, "");
  return digits === "" ? void 0 : Number(digits);
};
var CENTS_PRECISION = 2;
var IN_PROGRESS_DECIMAL = /^\d*\.?\d*$/;
var restrictDecimalInput = (next, previous, maxDecimalPlaces) => {
  const stripped = next.replace(/,/g, "");
  if (stripped === "")
    return stripped;
  if (!IN_PROGRESS_DECIMAL.test(stripped))
    return previous;
  const value = stripped.replace(/^0+(?=\d)/, "");
  const decimals = value.split(".")[1];
  if (decimals !== void 0 && decimals.length > maxDecimalPlaces)
    return previous;
  return value;
};
var parseCurrencyValue = (display) => {
  const cleaned = display.replace(/,/g, "").trim();
  if (cleaned === "")
    return void 0;
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) || parsed < 0 ? void 0 : parsed;
};

// src/aipo/GetOffer/components/BuyerChatPanel/BuyerChatPanel.tsx
import { useCallback as useCallback2, useRef as useRef4, useState } from "react";
import Box from "@amzn/awsui-components-react/polaris/box";
import Button from "@amzn/awsui-components-react/polaris/button";
import { PromptInput } from "@amzn/awsmp-max-ux-patterns/PromptInput";

// src/aipo/GetOffer/components/BuyerChatPanel/ContainerAutoScroll.tsx
import { useRef as useRef3, forwardRef, useImperativeHandle } from "react";

// src/aipo/GetOffer/components/BuyerChatPanel/useContainerAutoScroll.ts
import { useRef as useRef2, useEffect, useCallback } from "react";
var BOTTOM_THRESHOLD_PX = 30;
var MOUNT_CHECK_DELAY_MS = 100;
var MUTATION_DEBOUNCE_MS = 50;
var SCROLL_STOP_DETECT_MS = 500;
var NAVIGATION_KEYS = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "]);
var useContainerAutoScroll = ({
  containerRef,
  isActive,
  onScrolledAwayFromBottom
}) => {
  const shouldAutoScroll = useRef2(false);
  const scrollStopTimer = useRef2(null);
  const isAtBottom = useCallback((el) => {
    return el.scrollHeight - el.scrollTop - el.clientHeight < BOTTOM_THRESHOLD_PX;
  }, []);
  const scrollToBottom = useCallback(() => {
    const container = containerRef.current;
    if (!container)
      return;
    container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
    shouldAutoScroll.current = true;
    onScrolledAwayFromBottom?.(false);
  }, [containerRef, onScrolledAwayFromBottom]);
  useEffect(() => {
    if (isActive) {
      shouldAutoScroll.current = true;
      onScrolledAwayFromBottom?.(false);
    }
  }, [isActive, onScrolledAwayFromBottom]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container)
      return;
    const timer = setTimeout(() => {
      if (!isAtBottom(container)) {
        onScrolledAwayFromBottom?.(true);
      }
    }, MOUNT_CHECK_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const container = containerRef.current;
    if (!container)
      return;
    const handleUserGesture = () => {
      if (shouldAutoScroll.current) {
        shouldAutoScroll.current = false;
      }
      if (scrollStopTimer.current)
        clearTimeout(scrollStopTimer.current);
      scrollStopTimer.current = setTimeout(() => {
        const atBottom = isAtBottom(container);
        if (atBottom) {
          shouldAutoScroll.current = true;
        }
        onScrolledAwayFromBottom?.(!atBottom);
      }, SCROLL_STOP_DETECT_MS);
    };
    const handleKeyDown = (e) => {
      if (NAVIGATION_KEYS.has(e.key)) {
        handleUserGesture();
      }
    };
    container.addEventListener("wheel", handleUserGesture, { passive: true });
    container.addEventListener("touchmove", handleUserGesture, { passive: true });
    container.addEventListener("keydown", handleKeyDown);
    return () => {
      container.removeEventListener("wheel", handleUserGesture);
      container.removeEventListener("touchmove", handleUserGesture);
      container.removeEventListener("keydown", handleKeyDown);
      if (scrollStopTimer.current)
        clearTimeout(scrollStopTimer.current);
    };
  }, [isAtBottom, onScrolledAwayFromBottom, containerRef]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container)
      return;
    let debounceTimer = null;
    const observer = new MutationObserver(() => {
      if (debounceTimer)
        clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (shouldAutoScroll.current) {
          container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
        } else {
          onScrolledAwayFromBottom?.(!isAtBottom(container));
        }
      }, MUTATION_DEBOUNCE_MS);
    });
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return () => {
      if (debounceTimer)
        clearTimeout(debounceTimer);
      observer.disconnect();
    };
  }, [isAtBottom, onScrolledAwayFromBottom, containerRef]);
  return { scrollToBottom };
};

// src/aipo/GetOffer/components/BuyerChatPanel/ContainerAutoScroll.tsx
import { jsx } from "react/jsx-runtime";
var ContainerAutoScroll = forwardRef(
  ({ children, isActive, onScrolledAwayFromBottom, style, className, "data-testid": dataTestId }, ref) => {
    const containerRef = useRef3(null);
    const { scrollToBottom } = useContainerAutoScroll({ containerRef, isActive, onScrolledAwayFromBottom });
    useImperativeHandle(ref, () => ({ scrollToBottom }), [scrollToBottom]);
    return /* @__PURE__ */ jsx("div", { ref: containerRef, style, className, "data-testid": dataTestId, children });
  }
);

// src/aipo/GetOffer/components/BuyerChatPanel/BuyerChatPanel.tsx
import { AgentId as AgentId2 } from "@amzn/awsmp-max-model";

// src/aipo/GetOffer/components/BuyerChatPanel/BuyerChatPanel.module.scss
var BuyerChatPanel_module_default = {
  chatContainer: "BuyerChatPanel_module_chatContainer",
  messagesWrapper: "BuyerChatPanel_module_messagesWrapper",
  messagesArea: "BuyerChatPanel_module_messagesArea",
  scrollButtonContainer: "BuyerChatPanel_module_scrollButtonContainer",
  fadeInButton: "BuyerChatPanel_module_fadeInButton"
};

// src/aipo/GetOffer/components/BuyerChatPanel/BuyerChatPanel.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var EPO_BUYER_UNIT_GUIDANCE_AGENT = { agentId: AgentId2.EpoBuyerUnitGuidance };
var BI_CLICK_FEAT = "chat-section";
var BI_CLICK_ACT_SEND = "send-message";
var BuyerChatPanel = ({ renderMessages, sendMessage, isArtifactLocked, logger, t }) => {
  const scrollRef = useRef4(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const handleSubmit = useCallback2(
    (data) => {
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: BI_CLICK_FEAT,
          ClickAct: BI_CLICK_ACT_SEND
        }
      });
      sendMessage(data.contentBlocks, EPO_BUYER_UNIT_GUIDANCE_AGENT);
    },
    [sendMessage, logger]
  );
  return /* @__PURE__ */ jsxs("div", { className: BuyerChatPanel_module_default.chatContainer, "data-testid": "get-offer-ai-chat-panel", children: [
    /* @__PURE__ */ jsxs("div", { className: BuyerChatPanel_module_default.messagesWrapper, children: [
      /* @__PURE__ */ jsx2(
        ContainerAutoScroll,
        {
          ref: scrollRef,
          isActive: isArtifactLocked,
          onScrolledAwayFromBottom: setShowScrollButton,
          className: BuyerChatPanel_module_default.messagesArea,
          "data-testid": "get-offer-ai-chat-messages",
          children: renderMessages()
        }
      ),
      showScrollButton && /* @__PURE__ */ jsx2("div", { className: BuyerChatPanel_module_default.scrollButtonContainer, children: /* @__PURE__ */ jsx2(Button, { iconName: "angle-down", onClick: () => scrollRef.current?.scrollToBottom(), ariaLabel: t("scrollToBottom"), children: t("scrollToBottom") }) })
    ] }),
    /* @__PURE__ */ jsx2(Box, { padding: { top: "l" }, children: /* @__PURE__ */ jsx2(PromptInput, { lines: 2, placeholderText: t("chatPlaceholder"), onSubmit: handleSubmit, isDisabled: isArtifactLocked, logger }) })
  ] });
};

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var BI_CLICK_FEAT_UNITS = "units-table";
var BI_CLICK_OBJ_HEADER = "table-header";
var BI_CLICK_ACT_OPEN_CHAT = "open-chat";
var UnitsStep = ({
  buyerData,
  errors,
  clearFieldError,
  writeableArtifact,
  isArtifactLocked,
  renderMessages,
  layoutComponents,
  openHelpPanel,
  logger,
  t,
  onShowChat
}) => {
  const { configurableUpfrontPricingTerms, usageBasedPricingTerms } = buyerData;
  const { artifact, setArtifact, sendMessage } = writeableArtifact;
  const [showSplitPanel, setShowSplitPanel] = useState2(false);
  const [splitPanelView, setSplitPanelView] = useState2("guidance" /* Guidance */);
  const [selectedGuidance, setSelectedGuidance] = useState2("");
  const [panelSize, setPanelSize] = useState2(680);
  const { LayoutSplitPanel } = layoutComponents;
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.ENTER_UNITS);
  const formatCurrency2 = useCallback3(
    (amount) => {
      return `${new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: buyerData.currencyCode,
        maximumFractionDigits: 10
      }).format(amount)}`;
    },
    [buyerData.currencyCode]
  );
  const dimensionSelections = useMemo(() => {
    return artifact.offerRequest?.configurableUpfrontDimensionSelections || [];
  }, [artifact.offerRequest?.configurableUpfrontDimensionSelections]);
  const unitsMap = useMemo(() => {
    const map = {};
    dimensionSelections.forEach((selection) => {
      map[selection.dimensionKey] = selection.quantity;
    });
    return map;
  }, [dimensionSelections]);
  const tableData = useMemo(
    () => configurableUpfrontPricingTerms.rateCards.map((rateCard) => ({
      ...rateCard,
      numberOfUnits: unitsMap[rateCard.dimensionKey] || 0
    })),
    [configurableUpfrontPricingTerms.rateCards, unitsMap]
  );
  const updateUnits = useCallback3(
    (dimensionKey, value) => {
      if (value !== "" && !/^\d*$/.test(value.replace(/,/g, ""))) {
        return;
      }
      const numValue = Math.max(0, parseThousandsSeparated(value) ?? 0);
      const updatedSelections = [...dimensionSelections];
      const existingIndex = updatedSelections.findIndex((s2) => s2.dimensionKey === dimensionKey);
      if (existingIndex >= 0) {
        updatedSelections[existingIndex] = { dimensionKey, quantity: numValue };
      } else {
        updatedSelections.push({ dimensionKey, quantity: numValue });
      }
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          configurableUpfrontDimensionSelections: updatedSelections
        }
      }));
    },
    [dimensionSelections, setArtifact]
  );
  const handleGuidanceClick = useCallback3((supplementaryDescription) => {
    setSelectedGuidance(supplementaryDescription);
    setSplitPanelView("guidance" /* Guidance */);
    setShowSplitPanel(true);
  }, []);
  const handleChatClick = useCallback3(() => {
    setSplitPanelView("chat" /* Chat */);
    setShowSplitPanel(true);
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: BI_CLICK_FEAT_UNITS,
        ClickObj: BI_CLICK_OBJ_HEADER,
        ClickAct: BI_CLICK_ACT_OPEN_CHAT
      }
    });
    onShowChat?.();
  }, [onShowChat, logger]);
  const columnDefinitions = useMemo(
    () => [
      {
        id: "dimension",
        header: t("dimension"),
        cell: (item) => item.displayName,
        sortingField: "displayName",
        width: 200,
        minWidth: 150
      },
      {
        id: "description",
        header: t("description"),
        cell: (item) => item.description,
        width: 300,
        minWidth: 200
      },
      {
        id: "numberOfUnits",
        header: t("numberOfUnits"),
        cell: (item) => /* @__PURE__ */ jsx3(
          Input,
          {
            type: "text",
            inputMode: "numeric",
            value: item.numberOfUnits.toString(),
            onChange: ({ detail }) => {
              updateUnits(item.dimensionKey, detail.value);
              if (errors?.unitsTableError) {
                clearFieldError("unitsTableError");
              }
            },
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: "units-table",
                  ClickObj: "number-of-units-editable-column",
                  ClickAct: item.dimensionKey
                }
              });
            },
            placeholder: "0",
            disabled: isArtifactLocked
          }
        ),
        width: 200,
        minWidth: 150
      },
      {
        id: "guidance",
        header: t("guidance"),
        cell: (item) => item.supplementaryDescription ? /* @__PURE__ */ jsx3(
          Link,
          {
            variant: "primary",
            href: "_",
            onFollow: (e) => {
              handleGuidanceClick(item.supplementaryDescription);
              e.preventDefault();
            },
            children: t("view")
          }
        ) : /* @__PURE__ */ jsx3(Popover, { size: "small", position: "left", triggerType: "custom", dismissButton: false, content: t("noGuidanceAvailable"), children: /* @__PURE__ */ jsx3("div", { style: { fontWeight: "bold", color: "#B4B4BB" }, children: t("view") }) }),
        width: 120,
        minWidth: 100
      }
    ],
    [isArtifactLocked, handleGuidanceClick, updateUnits, errors?.unitsTableError, clearFieldError, logger, t]
  );
  const usageColumnDefinitions = [
    {
      id: "dimension",
      header: t("dimension"),
      cell: (item) => item.displayName,
      width: 500,
      minWidth: 350
    },
    {
      id: "cost",
      header: `${t("costPerUnit")} (${buyerData.currencyCode})`,
      cell: (item) => formatCurrency2(item.price),
      width: 320,
      minWidth: 250
    }
  ];
  return /* @__PURE__ */ jsxs2(SpaceBetween, { size: "l", children: [
    /* @__PURE__ */ jsx3(
      Alert,
      {
        action: /* @__PURE__ */ jsx3(
          Button2,
          {
            href: marketplaceLinks.get("RequestPrivateOffer", { listingId: buyerData.listingId }),
            external: true,
            onClick: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: "custom-offer-alert",
                  ClickAct: "request-custom-offer"
                }
              });
            },
            children: t("connectWithRepresentative")
          }
        ),
        children: t("complexBusinessNeedsMessage")
      }
    ),
    /* @__PURE__ */ jsx3(
      Container,
      {
        header: /* @__PURE__ */ jsx3(
          Header,
          {
            info: openHelpPanel ? /* @__PURE__ */ jsx3(Link, { variant: "info", onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG.EPO_ENTER_UNITS), children: t("info") }) : void 0,
            description: /* @__PURE__ */ jsxs2(Fragment, { children: [
              t("enterUnitsGuidanceDescriptionPrefix"),
              /* @__PURE__ */ jsx3("strong", { children: t("helpMeEstimateUnits") }),
              t("enterUnitsGuidanceDescriptionSuffix")
            ] }),
            actions: renderMessages ? /* @__PURE__ */ jsx3(
              Button2,
              {
                iconName: "gen-ai",
                className: UnitsStep_module_default.genAiButton,
                onClick: handleChatClick,
                disabled: isArtifactLocked,
                "data-testid": "get-offer-ai-chat-button",
                children: t("helpMeEstimateUnits")
              }
            ) : void 0,
            children: t("enterUnitsHeader")
          }
        ),
        children: /* @__PURE__ */ jsxs2(SpaceBetween, { size: "l", children: [
          errors?.unitsTableError && /* @__PURE__ */ jsx3(Alert, { type: "error", "data-testid": "units-validation-alert", children: errors.unitsTableError }),
          /* @__PURE__ */ jsx3(
            ManagedTable,
            {
              "data-testid": "enter-units-table",
              defaultPreferences: {
                contentDensity: "compact",
                ...usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && { pageSize: 5 }
              },
              columnDefinitions,
              items: tableData,
              variant: "embedded",
              stickyHeader: true,
              pagination: {},
              filtering: {
                filteringPlaceholder: t("findDimension")
              }
            }
          ),
          usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && /* @__PURE__ */ jsxs2(Fragment, { children: [
            /* @__PURE__ */ jsx3(
              Header,
              {
                counter: `(${usageBasedPricingTerms.length})`,
                description: t("additionalUsageCostsDescription"),
                "data-testid": "usage-costs-header",
                children: t("additionalUsageCosts")
              }
            ),
            /* @__PURE__ */ jsx3(
              ManagedTable,
              {
                "data-testid": "usage-costs-table",
                columnDefinitions: usageColumnDefinitions,
                defaultPreferences: {
                  contentDensity: "compact",
                  ...usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && { pageSize: 5 }
                },
                items: usageBasedPricingTerms,
                variant: "embedded",
                stickyHeader: true,
                pagination: {},
                filtering: {
                  filteringPlaceholder: t("findDimension")
                }
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx3(
      LayoutSplitPanel,
      {
        open: showSplitPanel,
        onToggle: (open) => setShowSplitPanel(open),
        onDismiss: () => setShowSplitPanel(false),
        onResize: (size) => setPanelSize(size),
        closeBehavior: "hide" /* Hide */,
        header: splitPanelView === "chat" /* Chat */ ? t("getGuidance") : t("guidanceHeader"),
        size: panelSize,
        children: splitPanelView === "chat" /* Chat */ && renderMessages ? /* @__PURE__ */ jsx3(BuyerChatPanel, { renderMessages, sendMessage, isArtifactLocked, logger, t }) : /* @__PURE__ */ jsxs2(SpaceBetween, { size: "l", children: [
          /* @__PURE__ */ jsx3(TextContent, { children: /* @__PURE__ */ jsx3("p", { children: selectedGuidance }) }),
          /* @__PURE__ */ jsx3(Button2, { variant: "normal", onClick: () => setShowSplitPanel(false), children: t("close") })
        ] })
      }
    )
  ] });
};

// src/aipo/GetOffer/components/EpoOverview/EpoOverview.tsx
import { useState as useState3 } from "react";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import TextContent2 from "@amzn/awsui-components-react/polaris/text-content";
import Box2 from "@amzn/awsui-components-react/polaris/box";
import Link2 from "@amzn/awsui-components-react/polaris/link";

// src/aipo/GetOffer/assets/human-robot-success.svg
var human_robot_success_default = 'data:image/svg+xml,<svg width="200" height="130" viewBox="0 0 200 130" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_3022_49078)">%0A<g clip-path="url(%23clip1_3022_49078)">%0A<path d="M90.9358 45.1269L90.3938 46.389L105.743 52.9421L106.285 51.68C105.667 49.5004 103.537 47.5241 98.8337 45.9499C94.1307 44.3757 91.7235 44.5686 90.9358 45.1269Z" fill="%230F141A" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M94.0006 46.5281L92.9466 47.824C91.8926 49.1199 91.5855 50.8996 92.2275 52.444C92.9938 54.2944 94.1883 55.7914 96.6228 56.1577C100.167 56.6879 102.475 55.2366 103.612 51.4531C104.001 50.1542 104.154 48.8023 104.149 47.4482L104.138 44.2573C103.976 42.294 103.045 40.1745 102.56 39.0213L102.088 34.6475L101.657 29.0755C101.515 28.3076 101.218 27.3664 100.298 27.4086C99.4061 27.5145 99.5642 27.616 99.5726 28.2856L99.4504 26.8787C99.2732 26.0507 99.0488 25.158 97.9939 25.1077C97.0259 25.2564 97.4688 26.2479 97.5086 27.1408L97.2842 25.6412C97.0764 24.689 96.5761 24.0972 95.6308 24.2218C94.8661 24.4237 94.7819 25.0438 94.7819 25.0438C94.7819 25.0438 94.8905 25.5416 94.7523 25.5072C94.0339 25.3381 93.2762 25.7076 92.9998 26.3976C92.7671 26.9926 92.6903 27.6948 92.6801 28.1592L91.9566 37.0722C91.9809 37.8866 92.1099 38.2142 92.2948 39.0057C92.798 41.2083 93.8411 45.7729 94.0041 46.5361L94.0006 46.5281Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M98.4849 36.3764L97.5199 27.2969Z" fill="%23B78159"/>%0A<path d="M98.4849 36.3764L97.5199 27.2969" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M99.5967 28.3413L100.24 37.2817" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M96.0412 37.7682L95.6902 26.9501C95.6902 26.9501 95.742 25.7895 94.9627 25.5569" fill="%23B78159"/>%0A<path d="M96.0412 37.7682L95.6902 26.9501C95.6902 26.9501 95.742 25.7895 94.9627 25.5569" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M104.136 44.5141L103.931 43.101C103.731 41.7232 103.057 40.3969 102.142 39.28C101.522 38.5226 100.739 37.9124 99.8678 37.4592L99.0781 37.051L97.2895 33.7183C96.6774 32.6539 95.5613 32.2036 94.2215 32.6289C93.7393 32.7831 93.3709 33.2194 93.3564 33.7283C93.3532 33.9051 93.3842 34.0954 93.4926 34.2566L95.8971 38.6947C96.4317 39.6034 96.9317 41.6794 96.9031 41.6682" fill="%23B78159"/>%0A<path d="M104.136 44.5141L103.931 43.101C103.731 41.7232 103.057 40.3969 102.142 39.28C101.522 38.5226 100.739 37.9124 99.8678 37.4592L99.0781 37.051L97.2895 33.7183C96.6774 32.6539 95.5613 32.2036 94.2215 32.6289C93.7393 32.7831 93.3709 33.2194 93.3564 33.7283C93.3532 33.9051 93.3842 34.0954 93.4926 34.2566L95.8971 38.6947C96.4317 39.6034 96.9317 41.6794 96.9031 41.6682" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M53.4941 67.8646C53.4522 67.8616 49.0739 67.2763 49.0739 67.2763L60.3111 86.0135L80.077 88.1639C80.7505 88.2576 81.424 88.306 82.0944 88.306C86.9164 88.306 90.8212 86.9738 92.935 83.7995C94.8799 80.8787 104.088 56.8602 105.546 53.0426C105.66 52.7458 105.516 52.4296 105.227 52.2981L91.5649 46.0814C91.256 45.9409 90.8921 46.0833 90.7607 46.3962L80.5705 70.6551L53.4941 67.8646Z" fill="%23006CE0"/>%0A<path d="M55.4003 67.5835L55.4112 67.1322L55.4304 67.1327L55.4494 67.1348L55.4003 67.5835ZM80.6685 70.348L81.0872 70.5169L80.9593 70.834L80.6194 70.7968L80.6685 70.348ZM93.5264 83.8635L93.9022 84.1137L93.5264 83.8635ZM80.6685 88.2278L80.7132 87.7786L80.722 87.7795L80.7307 87.7807L80.6685 88.2278ZM64.5644 87.0772L64.1152 87.0325L64.2047 86.1341L64.6539 86.1788L64.6092 86.628L64.5644 87.0772ZM105.532 51.9976L105.35 52.4107L105.532 51.9976ZM105.861 52.7373L106.285 52.8929L105.861 52.7373ZM90.4685 46.0434L90.8872 46.2122L90.4685 46.0434ZM91.2693 45.7176L91.4512 45.3044L91.2693 45.7176ZM42.6285 67.2762L42.6394 66.8249L55.4112 67.1322L55.4003 67.5835L55.3895 68.0348L42.6176 67.7275L42.6285 67.2762ZM55.4003 67.5835L55.4494 67.1348L80.7176 69.8993L80.6685 70.348L80.6194 70.7968L55.3513 68.0323L55.4003 67.5835ZM80.6685 70.348L80.2498 70.1792L90.0498 45.8746L90.4685 46.0434L90.8872 46.2122L81.0872 70.5169L80.6685 70.348ZM91.2693 45.7176L91.4512 45.3044L105.714 51.5844L105.532 51.9976L105.35 52.4107L91.0874 46.1307L91.2693 45.7176ZM105.861 52.7373L106.285 52.8929C105.577 54.8196 102.979 61.8731 100.314 68.8111C98.9822 72.2797 97.6322 75.7221 96.493 78.4813C95.9235 79.8606 95.4054 81.0722 94.9678 82.0323C94.5348 82.9824 94.1682 83.7142 93.9022 84.1137L93.5264 83.8635L93.1507 83.6133C93.3711 83.2823 93.7106 82.6138 94.1463 81.6579C94.5775 80.7118 95.0908 79.5115 95.6584 78.1367C96.7934 75.3877 98.1403 71.9535 99.4717 68.4873C102.134 61.5557 104.73 54.5072 105.437 52.5818L105.861 52.7373ZM93.5264 83.8635L93.9022 84.1137C91.6661 87.4717 87.5724 88.8213 82.6859 88.8213V88.3699V87.9185C87.4433 87.9185 91.1593 86.6038 93.1507 83.6133L93.5264 83.8635ZM82.6859 88.3699V88.8213C81.9937 88.8213 81.2994 88.7714 80.6063 88.6749L80.6685 88.2278L80.7307 87.7807C81.3845 87.8717 82.0371 87.9185 82.6859 87.9185V88.3699ZM80.6685 88.2278L80.6238 88.677L64.5644 87.0772L64.6092 86.628L64.6539 86.1788L80.7132 87.7786L80.6685 88.2278ZM105.532 51.9976L105.714 51.5844C106.206 51.8008 106.483 52.354 106.285 52.8929L105.861 52.7373L105.437 52.5818C105.45 52.5466 105.447 52.5162 105.435 52.4897C105.423 52.4616 105.396 52.4308 105.35 52.4107L105.532 51.9976ZM90.4685 46.0434L90.0498 45.8746C90.2722 45.323 90.9069 45.0648 91.4512 45.3044L91.2693 45.7176L91.0874 46.1307C91.0096 46.0965 90.919 46.1334 90.8872 46.2122L90.4685 46.0434Z" fill="%230F141A"/>%0A<path d="M80.572 70.3479C81.4929 71.5766 82.1068 72.8053 82.7207 76.1841" stroke="%230F141A" stroke-width="0.902851"/>%0A<g clip-path="url(%23clip2_3022_49078)">%0A<path d="M68.021 135.714C68.9357 135.714 69.4207 134.921 69.2365 134.073C67.229 121.903 63.3982 100.899 63.3982 100.899L65.8907 93.5946C66.8054 90.8547 66.744 87.8137 65.6451 85.1351L62.907 78.3835C60.9609 72.3569 55.9759 67.8906 49.2841 67.8906H34.1448C26.4217 67.8906 20.5833 73.819 19.8528 81.3631C18.5144 95.5421 17.1147 114.421 13.2224 134.073C13.0383 134.927 13.5294 135.714 14.438 135.714H68.0087H68.021Z" fill="%23006CE0"/>%0A<path d="M19.8651 78.3159C18.404 93.7113 17.0103 115.152 13.2346 134.559C13.0505 135.413 13.5416 136.26 14.4502 136.26H68.0209C68.9357 136.26 69.4206 135.407 69.2365 134.559L63.3982 100.58L64.5524 97.6001C66.7441 92.0034 66.3757 85.6757 63.521 80.3187" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M55.3165 126.867L53.7143 126.702L53.7816 110.28L55.0095 110.28C56.7875 111.683 57.9081 114.279 57.5693 119.23C57.2305 124.181 56.1327 126.352 55.3165 126.867Z" fill="%230F141A" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M68.6157 124.507C70.514 124.348 71.1053 123.344 71.161 122.758C71.2917 121.382 70.1731 120.937 69.5489 120.942C70.404 120.805 71.9747 120.658 72.0789 119.208C72.1831 117.758 70.2752 117.612 70.2366 117.619C71.312 117.65 72.2391 116.781 72.1796 115.832C72.1379 114.339 69.9233 114.347 69.9233 114.347C69.9233 114.347 71.8364 113.819 71.3295 112.18C71.0088 110.35 67.9564 111.284 66.3636 111.52C65.2283 111.625 64.2721 111.937 64.2721 111.937C64.7483 111.821 66.0386 111.441 66.0629 111.424C65.7068 111.026 63.8718 107.825 61.8457 109.575C60.7327 110.537 59.2892 111.54 57.875 112.457C55.604 112.52 53.993 112.486 52.136 112.35C47.8781 112.038 44.1724 115.792 44.6812 120.099C44.9832 122.655 46.7673 124.643 49.2999 124.779C53.944 125.027 60.893 124.876 66.4104 124.553L68.6157 124.507Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M28.9165 86.9356L26.1538 109.052L55.008 110.28V126.868L16.9626 125.212C10.8863 124.948 6.38058 119.473 7.29015 113.46L12.0673 81.8746C13.3003 73.7222 20.0692 67.5345 28.3031 67.1053C32.917 66.8648 37.2442 66.6624 38.7393 66.6624" fill="%23006CE0"/>%0A<path d="M28.9165 86.9356L26.1538 109.052L55.008 110.28V126.868L16.9626 125.212C10.8863 124.948 6.38058 119.473 7.29015 113.46L12.0673 81.8746C13.3003 73.7222 20.0692 67.5345 28.3031 67.1053C32.917 66.8648 37.2442 66.6624 38.7393 66.6624" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip3_3022_49078)">%0A<path d="M50.6726 67.2834L49.5917 59.4245C49.5917 59.4245 60.8204 60.2198 59.5969 50.3383C59.0726 46.1038 58.3201 42.2518 56.3172 37.9214C53.864 32.6158 50.4949 28.6539 42.0499 29.817C35.6484 30.7244 31.1282 36.6973 32.0078 43.0926L35.62 69.3565C36.1904 73.5041 40.0234 76.4035 44.1794 75.8312C48.3353 75.2588 51.2431 71.431 50.6726 67.2834V67.2834Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M49.5916 59.4277C49.5916 59.4277 45.9152 59.38 42.5296 58.5836C42.2361 58.5145 42.0851 58.9186 42.3497 59.0593L50.1081 63.1833L49.5911 59.4245" fill="%230F141A"/>%0A<path d="M49.5916 59.4277C49.5916 59.4277 45.9152 59.38 42.5296 58.5836C42.2361 58.5145 42.0851 58.9186 42.3497 59.0593L50.1081 63.1833L49.5911 59.4245" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M46.5742 45.2258C46.2279 45.2735 45.8996 44.9668 45.841 44.5408C45.7824 44.1148 46.0157 43.7308 46.3621 43.6831C46.7085 43.6354 47.0368 43.942 47.0953 44.368C47.1539 44.794 46.9206 45.1781 46.5742 45.2258Z" fill="%230F141A"/>%0A<path d="M53.5943 42.642C53.2479 42.6897 52.9196 42.3831 52.861 41.9571C52.8024 41.531 53.0357 41.147 53.3821 41.0993C53.7285 41.0516 54.0568 41.3583 54.1154 41.7843C54.174 42.2103 53.9407 42.5943 53.5943 42.642Z" fill="%230F141A"/>%0A<path d="M48.744 40.7009C49.7891 42.3158 50.6135 43.9449 53.3133 45.2931C53.8923 45.5838 53.7738 46.4827 53.232 46.8376L52.1152 47.5648" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M52.8065 50.8809C52.8065 50.8809 49.5154 51.8044 46.8383 49.6348" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M31.9864 25.236C31.375 18.8441 24.6119 16.5246 21.1444 20.4511C15.8322 17.2792 10.2985 25.6285 17.1891 28.2471C11.959 29.9216 17.3937 38.3034 23.2424 35.0505L22.2591 36.4088C21.5147 37.4371 21.7049 38.8455 22.4896 39.8432C22.9506 40.4293 23.3201 41.06 23.258 41.5225C23.1958 41.985 23.0112 42.3002 22.8278 42.6133C22.5596 43.0714 22.2939 43.5249 22.4182 44.4287C22.6275 45.9502 25.2695 47.1367 25.2695 47.1367C24.2624 48.8257 25.3728 52.3936 28.4138 51.9748C27.7945 54.2305 29.6419 56.4566 30.908 56.5923C31.5887 59.2891 34.5767 60.738 34.5767 60.738C34.5767 60.738 36.0298 54.2112 35.5669 48.6938C35.5669 48.6938 38.7229 45.822 38.8394 45.4525C40.5072 43.6105 43.0878 37.6858 42.7184 35.2251C43.1648 38.1122 49.5458 38.1387 48.8009 34.7168C49.0267 35.6558 49.8361 36.4276 50.7797 36.614C52.0469 36.8612 53.3078 34.4488 53.3078 34.4488C54.2291 34.8363 54.8444 33.9545 55.2354 32.9297C55.8085 31.4281 55.3807 29.775 54.5674 28.3889C54.1219 27.6296 53.4442 27.0338 52.6344 26.6894L50.2506 25.6755C49.567 25.3848 48.949 24.9591 48.4336 24.424L48.2635 24.2474C47.0387 22.9757 45.2804 22.3661 43.5319 22.6069L41.7918 22.8466C41.2866 22.9161 40.7742 22.9154 40.2692 22.8443L37.9856 22.5231C36.3842 22.2978 34.7644 22.7859 33.5536 23.8587L32.2294 25.032C32.1501 25.1022 32.0691 25.1702 31.9864 25.236Z" fill="%23232B37" stroke="%230F141A" stroke-width="0.902851" stroke-miterlimit="10" stroke-linejoin="round"/>%0A<path d="M31.0659 26.1982C29.4088 27.6667 26.7002 29.9839 25.2129 33.2057" stroke="%23F3F3F7" stroke-width="1.2038"/>%0A<path d="M36.9379 49.3213C33.6442 47.6908 33.1899 45.9366 33.2856 44.8959C33.3482 44.2012 33.8069 43.5936 34.455 43.3304C35.244 43.0124 36.189 43.1013 36.9569 43.5689C38.7073 44.6324 39.3889 46.3263 39.3889 46.3263" fill="%23B78159"/>%0A<path d="M36.9379 49.3213C33.6442 47.6908 33.1899 45.9366 33.2856 44.8959C33.3482 44.2012 33.8069 43.5936 34.455 43.3304C35.244 43.0124 36.189 43.1013 36.9569 43.5689C38.7073 44.6324 39.3889 46.3263 39.3889 46.3263" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M84.374 4.94727L92.017 12.5689" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M101.024 0.156738L101.024 10.9353" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M117.673 4.94727L110.03 12.5689" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M165.158 51.3831V38.7631L154.98 32.9329" stroke="%230F141A" stroke-width="0.902851"/>%0A<ellipse cx="2.42648" cy="2.4197" rx="2.42648" ry="2.4197" transform="matrix(-1 0 0 1 167.584 36.5625)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M162.209 50.1254C162.3 49.1674 163.104 48.4355 164.066 48.4355H166.375C167.338 48.4355 168.142 49.1674 168.233 50.1254L168.274 50.5609C168.444 52.3605 167.029 53.9162 165.221 53.9162C163.413 53.9162 161.998 52.3605 162.168 50.5609L162.209 50.1254Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M126.621 33.084L118.353 41.2505L110.164 33.084" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M111.317 33.9131C109.718 33.9131 108.422 32.6168 108.422 31.0179L108.422 27.4752C108.422 25.8762 109.718 24.5799 111.317 24.5799C112.916 24.5799 114.212 25.8762 114.212 27.4752L114.212 31.0179C114.212 32.6168 112.916 33.9131 111.317 33.9131Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<ellipse cx="2.42648" cy="2.4197" rx="2.42648" ry="2.4197" transform="matrix(-1 0 0 1 120.858 38.5281)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851"/>%0A<rect x="135.873" y="24.0098" width="9.70592" height="7.86404" rx="1.2038" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M145.445 26.9066L136.336 29.4891C135.952 29.598 135.57 29.3094 135.57 28.91V24.9142C135.57 24.5817 135.839 24.3123 136.172 24.3123H145.28C145.613 24.3123 145.882 24.5817 145.882 24.9142V26.3275C145.882 26.5967 145.704 26.8331 145.445 26.9066Z" fill="%230F141A"/>%0A<path d="M151.389 8.01236C150.508 5.256 147.615 3.67433 144.819 4.42033L129.76 8.4387C126.964 9.18469 125.253 11.995 125.873 14.8209L127.972 24.3779C128.635 27.3966 131.687 29.2547 134.674 28.4578L150.615 24.2042C153.601 23.4073 155.312 20.2785 154.37 17.3341L151.389 8.01236Z" fill="%230F141A"/>%0A<path d="M149.693 8.49251C148.906 6.04684 146.337 4.64527 143.855 5.30755L128.26 9.46893C125.778 10.1312 124.257 12.6241 124.804 15.1339L126.886 24.692C127.471 27.3795 130.186 29.0359 132.844 28.3267L149.354 23.9214C152.012 23.2122 153.532 20.4256 152.689 17.8067L149.693 8.49251Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M152.875 17.9331L147.92 19.947C142.676 22.0825 137.084 23.6081 131.463 24.3445L127.093 24.822" stroke="%230F141A" stroke-width="0.902851"/>%0A<g clip-path="url(%23clip4_3022_49078)">%0A<path d="M131.606 19.858C132.576 19.5986 133.153 18.6034 132.892 17.6353C132.632 16.6672 131.634 16.0927 130.664 16.3521C129.693 16.6115 129.117 17.6066 129.377 18.5747C129.637 19.5428 130.635 20.1174 131.606 19.858Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M142.739 16.8831C143.71 16.6237 144.286 15.6286 144.026 14.6605C143.766 13.6923 142.768 13.1178 141.797 13.3772C140.827 13.6366 140.25 14.6317 140.511 15.5999C140.771 16.568 141.769 17.1425 142.739 16.8831Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A</g>%0A<path d="M125.55 35.1076C125.668 32.5368 127.786 30.5132 130.36 30.5132H151.091C153.664 30.5132 155.783 32.5368 155.901 35.1076L156.57 49.6742C156.696 52.4174 154.505 54.7102 151.759 54.7102H129.691C126.945 54.7102 124.755 52.4174 124.881 49.6742L125.55 35.1076Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M149.452 42.4223C150.676 42.4223 151.669 41.4326 151.669 40.2119C151.669 38.9911 150.676 38.0015 149.452 38.0015C148.227 38.0015 147.234 38.9911 147.234 40.2119C147.234 41.4326 148.227 42.4223 149.452 42.4223Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M141.588 39.9048H130.925" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M144.372 65.0095L143.7 64.8221C140.654 63.9729 137.425 64.0381 134.415 65.0095" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M146.861 61.0386L145.808 60.8428C141.213 59.9889 136.495 60.0555 131.926 61.0386" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M165.447 98.2012C178.763 98.2012 189.548 87.4331 189.548 74.1654C189.548 60.8978 178.751 50.1296 165.447 50.1296C152.143 50.1296 141.346 60.8978 141.346 74.1654C141.346 87.4331 152.143 98.2012 165.447 98.2012Z" fill="%2300802F" stroke="%230F141A" stroke-width="0.902851" stroke-miterlimit="10"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M179.492 67.5165L163.133 84.1695C162.594 84.719 161.865 85.0215 161.109 85.0099C160.353 84.9982 159.633 84.6733 159.109 84.1075L151.402 75.781L155.485 71.7089L161.211 77.8943L175.527 63.3203L179.492 67.5165Z" fill="white" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M162.209 50.1256C162.3 49.1677 163.104 48.4358 164.066 48.4358H166.375C167.338 48.4358 168.142 49.1677 168.233 50.1256L168.274 50.5611C168.444 52.3608 167.029 53.9165 165.221 53.9165C163.413 53.9165 161.998 52.3608 162.168 50.5611L162.209 50.1256Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A</g>%0A</g>%0A<defs>%0A<clipPath id="clip0_3022_49078">%0A<rect width="199.27" height="129.351" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_3022_49078">%0A<rect width="194.9" height="145.083" fill="white" transform="translate(0 -8.73975)"/>%0A</clipPath>%0A<clipPath id="clip2_3022_49078">%0A<rect width="64.2374" height="53.2221" fill="white" transform="translate(9.08154 65.6013)"/>%0A</clipPath>%0A<clipPath id="clip3_3022_49078">%0A<rect width="72.4427" height="70.6491" fill="white" transform="translate(8.25342 10.52)"/>%0A</clipPath>%0A<clipPath id="clip4_3022_49078">%0A<rect width="24.8668" height="8.47056" fill="white" transform="matrix(0.966106 -0.258145 0.259495 0.965744 125.934 15.1108)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/aipo/GetOffer/components/EpoOverview/EpoOverview.module.scss
var EpoOverview_module_default = {
  beforeBeginContainer: "EpoOverview_module_beforeBeginContainer",
  expandableSectionEmbeddedImage: "EpoOverview_module_expandableSectionEmbeddedImage"
};

// src/aipo/GetOffer/components/EpoOverview/EpoOverview.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var EpoOverview = ({ t, leadsCaptureEnabled = false, expanded: controlledExpanded, onExpandedChange }) => {
  const [uncontrolledExpanded, setUncontrolledExpanded] = useState3(true);
  const expanded = controlledExpanded ?? uncontrolledExpanded;
  const setExpanded = (next) => {
    onExpandedChange?.(next);
    if (controlledExpanded === void 0)
      setUncontrolledExpanded(next);
  };
  return /* @__PURE__ */ jsx4(
    ExpandableSection,
    {
      expanded,
      onChange: ({ detail }) => setExpanded(detail.expanded),
      variant: "container",
      headerText: t("gettingYourPrivateOffer"),
      "data-testid": "getting-offer-container",
      children: /* @__PURE__ */ jsxs3("div", { className: EpoOverview_module_default.beforeBeginContainer, children: [
        /* @__PURE__ */ jsx4(Box2, { padding: { horizontal: "l" }, children: /* @__PURE__ */ jsxs3(TextContent2, { children: [
          /* @__PURE__ */ jsx4("p", { children: t("enterNeedsQuoteInstantly") }),
          /* @__PURE__ */ jsxs3("ul", { children: [
            leadsCaptureEnabled && /* @__PURE__ */ jsxs3("li", { children: [
              /* @__PURE__ */ jsx4("strong", { children: t("enterContactInformationListItem") }),
              " - ",
              t("provideYourContactDetails")
            ] }),
            /* @__PURE__ */ jsxs3("li", { children: [
              /* @__PURE__ */ jsx4("strong", { children: t("enterUnitsListItem") }),
              " - ",
              t("specifyDimensionRequirements")
            ] }),
            /* @__PURE__ */ jsxs3("li", { children: [
              /* @__PURE__ */ jsx4("strong", { children: t("enterContractNeedsListItem") }),
              " - ",
              t("defineContractDurationPreferences")
            ] }),
            /* @__PURE__ */ jsxs3("li", { children: [
              /* @__PURE__ */ jsx4("strong", { children: t("answerFewQuestions") }),
              " - ",
              t("fillOutSellerEvaluation")
            ] }),
            /* @__PURE__ */ jsxs3("li", { children: [
              /* @__PURE__ */ jsx4("strong", { children: t("getYourOffer") }),
              " - ",
              t("receivePersonalizedQuote")
            ] })
          ] }),
          /* @__PURE__ */ jsx4("p", { children: t("finalSteps") }),
          /* @__PURE__ */ jsx4("ul", { children: /* @__PURE__ */ jsxs3("li", { children: [
            t("reviewPersonalizedPricing"),
            " ",
            /* @__PURE__ */ jsx4(Link2, { href: "https://us-east-1.console.aws.amazon.com/marketplace/private-offers", external: true, children: t("awsMarketplacePrivateOffers") }),
            " ",
            t("pageOrProcurementPage")
          ] }) })
        ] }) }),
        /* @__PURE__ */ jsx4(
          "img",
          {
            alt: t("humanRobotCheckmarkAlt"),
            src: human_robot_success_default,
            className: EpoOverview_module_default.expandableSectionEmbeddedImage,
            style: { width: "289px", height: "239px" }
          }
        )
      ] })
    }
  );
};

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.tsx
import { useCallback as useCallback4, useState as useState4, useMemo as useMemo2 } from "react";
import Container4 from "@amzn/awsui-components-react/polaris/container";
import SpaceBetween4 from "@amzn/awsui-components-react/polaris/space-between";
import Header4 from "@amzn/awsui-components-react/polaris/header";
import FormField2 from "@amzn/awsui-components-react/polaris/form-field";
import Select from "@amzn/awsui-components-react/polaris/select";
import RadioGroup from "@amzn/awsui-components-react/polaris/radio-group";
import DatePicker from "@amzn/awsui-components-react/polaris/date-picker";
import TextContent3 from "@amzn/awsui-components-react/polaris/text-content";
import Link4 from "@amzn/awsui-components-react/polaris/link";
import { marketplaceLinks as marketplaceLinks2 } from "@amzn/awsmp-max-link-catalog/browser";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG3 } from "@amzn/awsmp-max-agentic-renderer-interface";

// ../../node_modules/luxon/build/es6/luxon.mjs
var LuxonError = class extends Error {
};
var InvalidDateTimeError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
var InvalidIntervalError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
var InvalidDurationError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
var ConflictingSpecificationError = class extends LuxonError {
};
var InvalidUnitError = class extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
var InvalidArgumentError = class extends LuxonError {
};
var ZoneIsAbstractError = class extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var Zone = class {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
var singleton$1 = null;
var SystemZone = class _SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new _SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
var dtfCache = /* @__PURE__ */ new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
    dtfCache.set(zoneName, dtf);
  }
  return dtf;
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
var ianaZoneCache = /* @__PURE__ */ new Map();
var IANAZone = class _IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    let zone = ianaZoneCache.get(name);
    if (zone === void 0) {
      ianaZoneCache.set(name, zone = new _IANAZone(name));
    }
    return zone;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache.clear();
    dtfCache.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = _IANAZone.isValidZone(name);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    if (!this.valid)
      return NaN;
    const date = new Date(ts);
    if (isNaN(date))
      return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
};
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
var intlDTCache = /* @__PURE__ */ new Map();
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache.get(key);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache.set(key, dtf);
  }
  return dtf;
}
var intlNumCache = /* @__PURE__ */ new Map();
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache.get(key);
  if (inf === void 0) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache.set(key, inf);
  }
  return inf;
}
var intlRelCache = /* @__PURE__ */ new Map();
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache.get(key);
  if (inf === void 0) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache.set(key, inf);
  }
  return inf;
}
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
var intlResolvedOptionsCache = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  if (opts === void 0) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache.set(locString, opts);
  }
  return opts;
}
var weekInfoCache = /* @__PURE__ */ new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings, ...data };
    }
    weekInfoCache.set(locString, data);
  }
  return data;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
  }
}
var PolyNumberFormatter = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0)
        intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
};
var PolyDateFormatter = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
};
var PolyRelFormatter = class {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
};
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
var Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache.clear();
    intlNumCache.clear();
    intlRelCache.clear();
    intlResolvedOptionsCache.clear();
    weekInfoCache.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format &= !monthSpecialCase;
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        const mapper = !monthSpecialCase ? (dt) => this.extract(dt, intl, "month") : (dt) => this.dtFormatter(dt, intl).format();
        this.monthsCache[formatStr][length] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
var singleton = null;
var FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new _FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r2 = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r2) {
        return new _FixedOffsetZone(signedOffset(r2[1], r2[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
};
var InvalidZone = class extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default")
      return defaultZone2;
    else if (lowered === "local" || lowered === "system")
      return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt")
      return FixedOffsetZone.utcInstance;
    else
      return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
var digitRegexCache = /* @__PURE__ */ new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  let appendCache = digitRegexCache.get(ns);
  if (appendCache === void 0) {
    appendCache = /* @__PURE__ */ new Map();
    digitRegexCache.set(ns, appendCache);
  }
  let regex = appendCache.get(append);
  if (regex === void 0) {
    regex = new RegExp(`${numberingSystems[ns]}${append}`);
    appendCache.set(append, regex);
  }
  return regex;
}
var now = () => Date.now();
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var Settings = class {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
var Invalid = class {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
var leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday))
      obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber))
      obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear))
      obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else
    return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else
    return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else
    return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else
    return false;
}
function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
function roundTo(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else
    return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null)
        continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        case "S":
          return this.num(dt.millisecond);
        case "u":
        case "SSS":
          return this.num(dt.millisecond, 3);
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return dt.zoneName;
        case "a":
          return meridiem();
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
        let signDisplay;
        if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
          signDisplay = "never";
        } else if (this.opts.signMode === "all") {
          signDisplay = "always";
        } else {
          signDisplay = "auto";
        }
        return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
      } else {
        return token;
      }
    }, tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t)), durationInfo = {
      isNegativeDuration: collapsed < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(collapsed.values)[0]
    };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
};
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r2) => f + r2.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}
var offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr)
    result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse(s2, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
var INVALID$2 = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
};
var casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
var orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
var Duration = class _Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return _Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized)
      throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid)
      return INVALID$2;
    const showZeros = opts.showZeros !== false;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val) || val === 0 && !showZeros) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid)
      return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let s2 = "P";
    if (this.years !== 0)
      s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0)
      s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0)
      s2 += this.weeks + "W";
    if (this.days !== 0)
      s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0)
      s2 += this.hours + "H";
    if (this.minutes !== 0)
      s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P")
      s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid)
      return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5)
      return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid)
      return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid)
      return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const mixed = { ...this.values, ...normalizeObject(values, _Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid)
      return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid)
      return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid)
      return this;
    const vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0)
        return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
var INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
var Interval = class _Interval {
  /**
   * @private
   */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? this.e ? this.e.minus(1) : null : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid)
      return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid)
      return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid)
      return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid)
      return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid)
      return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid)
      return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid)
      return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid)
      return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid)
      return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid)
      return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return _Interval.fromDateTimes(s2, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s2, e);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return _Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid)
      return INVALID$1;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
var Info = class {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
};
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s2]) => s2, literal: true }), unitate = (t) => {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      case "a":
        return oneOf(loc.meridiems(), 0);
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r2) => `${f}(${r2.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r2, k) => {
    const f = toField(k);
    if (f) {
      r2[f] = matches[k];
    }
    return r2;
  }, {});
  return [vals, zone, specificOffset];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
var TokenParser = class {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
var INVALID = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0)
    c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (precision === "year")
    return c;
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    if (precision === "month")
      return c;
    c += "-";
  } else {
    c += padStart(o.c.month);
    if (precision === "month")
      return c;
  }
  c += padStart(o.c.day);
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c += padStart(o.c.hour);
      if (precision === "hour")
        break;
      if (extended) {
        c += ":";
        c += padStart(o.c.minute);
        if (precision === "minute")
          break;
        if (showSeconds) {
          c += ":";
          c += padStart(o.c.second);
        }
      } else {
        c += padStart(o.c.minute);
        if (precision === "minute")
          break;
        if (showSeconds) {
          c += padStart(o.c.second);
        }
      }
      if (precision === "second")
        break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c += ".";
        c += padStart(o.c.millisecond, 3);
      }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized)
    throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === void 0) {
    zoneOffsetTs = Settings.now();
  }
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache.get(zoneName);
  if (offsetGuess === void 0) {
    offsetGuess = zone.offset(zoneOffsetTs);
    zoneOffsetGuessCache.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({ ts, zone, loc, o });
}
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else
        return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
var zoneOffsetTs;
var zoneOffsetGuessCache = /* @__PURE__ */ new Map();
var DateTime = class _DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new _DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid)
      return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      case "quarters":
      case "months":
        o.day = 1;
      case "weeks":
      case "days":
        o.hour = 0;
      case "hours":
        o.minute = 0;
      case "minutes":
        o.second = 0;
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    const ext = format === "extended";
    let c = toISODate(this, ext, precision);
    if (orderedUnits.indexOf(precision) >= 3)
      c += "T";
    c += toISOTime(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended", normalizeUnit(precision));
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
    return c + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid)
      return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid)
      return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid)
      return null;
    const base = options.base || _DateTime.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid)
      return null;
    return diffRelative(options.base || _DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

// src/aipo/GetOffer/utils/duration-parser.ts
function parseLimitedISODurationToNumber(isoDuration2) {
  if (!isoDuration2)
    return void 0;
  const match2 = isoDuration2.match(/^P(\d+)([DMY])$/);
  return match2 ? Number(match2[1]) : void 0;
}
function parseLimitedISODurationUnit(isoDuration2) {
  if (!isoDuration2)
    return void 0;
  const match2 = isoDuration2.match(/^P(\d+)([DMY])$/);
  return match2 ? match2[2] : void 0;
}
function parseIso8601Duration(isoDuration2) {
  return Duration.fromISO(isoDuration2);
}
function convertUserInputToDuration(duration, unit) {
  switch (unit) {
    case "D":
      return Duration.fromObject({ days: duration });
    case "M":
      return Duration.fromObject({ months: duration });
    case "Y":
      return Duration.fromObject({ years: duration });
    default:
      throw new Error(`Unsupported duration unit: ${unit}`);
  }
}
function formatDurationForDisplay(isoDuration2) {
  if (!isoDuration2)
    return "";
  const number = parseInt(isoDuration2.slice(1, -1), 10);
  const unit = isoDuration2[isoDuration2.length - 1];
  let unitName;
  if (unit === "D") {
    unitName = number === 1 ? "day" : "days";
  } else if (unit === "M") {
    unitName = number === 1 ? "month" : "months";
  } else if (unit === "Y") {
    unitName = number === 1 ? "year" : "years";
  } else {
    unitName = "units";
  }
  return `${number} ${unitName}`;
}
function validateRequestedDurationIsValid(userDuration, minDuration, maxDuration) {
  if (!userDuration.isValid) {
    return { isValid: false, reason: "invalidFormat" };
  }
  if (!minDuration.isValid || !maxDuration.isValid) {
    return { isValid: true };
  }
  if (userDuration < minDuration) {
    return { isValid: false, reason: "tooShort", min: formatDurationForDisplay(minDuration.toISO()) };
  }
  if (userDuration > maxDuration) {
    return { isValid: false, reason: "tooLong", max: formatDurationForDisplay(maxDuration.toISO()) };
  }
  return { isValid: true };
}
function calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration) {
  const now2 = DateTime.now();
  const maxFutureDate = now2.plus(parseIso8601Duration(maxFutureStartDuration)).plus(parseIso8601Duration(offerExpirationDuration));
  const minAllowedFutureStart = now2.plus(parseIso8601Duration(offerExpirationDuration));
  return {
    minDate: minAllowedFutureStart,
    maxDate: maxFutureDate
  };
}
function validateFutureStartDate(selectedDateString, maxFutureStartDuration, offerExpirationDuration) {
  const futureStart = DateTime.fromISO(selectedDateString, {
    zone: "utc"
  });
  if (!futureStart.isValid) {
    return {
      isValid: false,
      errorMessage: `Invalid future start date format: ${selectedDateString}`
    };
  }
  const { minDate, maxDate } = calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration);
  if (futureStart <= minDate || futureStart > maxDate) {
    const minDateFormatted = minDate.plus({ days: 1 }).toFormat("yyyy/MM/dd");
    const maxDateFormatted = maxDate.toFormat("yyyy/MM/dd");
    return {
      isValid: false,
      errorMessage: `Future start date must be between ${minDateFormatted} and ${maxDateFormatted}.`
    };
  }
  return { isValid: true };
}
function isDateWithinConstraints(date, maxFutureStartDuration, offerExpirationDuration) {
  const { minDate, maxDate } = calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration);
  const selectedDate = DateTime.fromJSDate(date, {
    zone: "utc"
  });
  return selectedDate > minDate && selectedDate <= maxDate;
}

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.module.css
var ContractNeedsStep_default = {
  setDateField: "ContractNeedsStep_setDateField",
  durationOuterContainer: "ContractNeedsStep_durationOuterContainer",
  durationContainer: "ContractNeedsStep_durationContainer",
  flexGrow: "ContractNeedsStep_flexGrow"
};

// src/aipo/GetOffer/components/ContractNeedsStep/validation.ts
var validateContractNeedsStep = (artifact, contractDatePref, buyerOptions, t) => {
  let isValid = true;
  const errorProps = {};
  const durationNumber = parseLimitedISODurationToNumber(artifact.offerRequest.duration);
  const durationUnit = parseLimitedISODurationUnit(artifact.offerRequest.duration);
  if (!durationNumber || !durationUnit) {
    isValid = false;
    errorProps.durationError = t("validationEnterDuration");
  }
  if (contractDatePref === "custom" && !artifact.offerRequest.futureStartDate) {
    isValid = false;
    errorProps.customDateError = t("validationSelectStartDate");
  }
  if (durationNumber && durationUnit) {
    const durationValidation = isDurationValid(durationNumber, durationUnit, buyerOptions, t);
    if (!durationValidation.isValid) {
      isValid = false;
      errorProps.durationConstraintError = durationValidation.errorMessage;
    }
  }
  if (contractDatePref === "custom" && artifact.offerRequest.futureStartDate) {
    try {
      const dateValidation = validateFutureStartDate(
        artifact.offerRequest.futureStartDate,
        buyerOptions.maxFutureStartDuration,
        buyerOptions.expiration
      );
      if (!dateValidation.isValid) {
        isValid = false;
        errorProps.dateConstraintError = dateValidation.errorMessage;
      }
    } catch (error) {
      console.warn("Date constraint validation error:", error);
    }
  }
  return {
    isValid,
    errorProps
  };
};
var isDurationValid = (durationNumber, durationUnit, buyerOptions, t) => {
  try {
    const userDuration = convertUserInputToDuration(durationNumber, durationUnit);
    const result = validateRequestedDurationIsValid(
      userDuration,
      parseIso8601Duration(buyerOptions.minOfferDuration),
      parseIso8601Duration(buyerOptions.maxOfferDuration)
    );
    if (result.isValid)
      return { isValid: true };
    switch (result.reason) {
      case "tooShort":
        return { isValid: false, errorMessage: t("validationDurationTooShort", { min: result.min }) };
      case "tooLong":
        return { isValid: false, errorMessage: t("validationDurationTooLong", { max: result.max }) };
      case "invalidFormat":
        return {
          isValid: false,
          errorMessage: t("validationInvalidDuration", {
            min: formatDurationForDisplay(buyerOptions.minOfferDuration),
            max: formatDurationForDisplay(buyerOptions.maxOfferDuration)
          })
        };
    }
  } catch (error) {
    console.warn("Duration constraint validation error:", error);
    return {
      isValid: false,
      errorMessage: t("validationInvalidDuration", {
        min: formatDurationForDisplay(buyerOptions.minOfferDuration),
        max: formatDurationForDisplay(buyerOptions.maxOfferDuration)
      })
    };
  }
};

// src/aipo/GetOffer/components/ContractNeedsStep/PaymentPreferencesCard.tsx
import Container2 from "@amzn/awsui-components-react/polaris/container";
import Header2 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween2 from "@amzn/awsui-components-react/polaris/space-between";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Tiles from "@amzn/awsui-components-react/polaris/tiles";
import Alert2 from "@amzn/awsui-components-react/polaris/alert";
import { PAYMENT_METHOD as PAYMENT_METHOD2 } from "@amzn/awsmp-max-model";

// src/aipo/shared/fps.ts
import {
  PAYMENT_METHOD,
  PAYMENT_METHODS,
  PaymentFrequency
} from "@amzn/awsmp-max-model";
var INSTALLMENT_FREQUENCIES = [
  PaymentFrequency.MONTHLY,
  PaymentFrequency.QUARTERLY,
  PaymentFrequency.ANNUALLY
];
var FREQUENCY_TRANSLATION_KEY = {
  MONTHLY: "installmentFrequencyMonthly",
  QUARTERLY: "installmentFrequencyQuarterly",
  ANNUALLY: "installmentFrequencyAnnually"
};
var frequencyLabel = (f, t) => t(FREQUENCY_TRANSLATION_KEY[f]);
var isPaymentFrequency = (v) => v !== void 0 && INSTALLMENT_FREQUENCIES.includes(v);
var isPaymentMethod = (v) => PAYMENT_METHODS.some((m) => m === v);
var buyerOptionsSupportFps = (options) => options != null && options.allowedFrequencies !== void 0 && options.allowedFrequencies.length > 0 && options.initialPaymentAllowed !== void 0;
function applyFpsToArtifact(artifact, patch) {
  const merged = { ...artifact.offerRequest, ...patch };
  const offerRequest = merged.paymentMethod === PAYMENT_METHOD.UPFRONT ? { ...merged, frequency: void 0, firstInstallmentDate: void 0, initialPaymentAmount: void 0, dayOfMonth: void 0 } : merged;
  return { ...artifact, offerRequest };
}
function readFpsScheduleInputs(artifact) {
  const { frequency, firstInstallmentDate, dayOfMonth, initialPaymentAmount } = artifact.offerRequest;
  return {
    frequency,
    firstInvoiceDate: firstInstallmentDate ?? "",
    dayOfMonth: dayOfMonth ?? "",
    initialPayment: initialPaymentAmount ?? ""
  };
}
function toIsoDate(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
function defaultFirstInvoiceDate(now2 = /* @__PURE__ */ new Date()) {
  const tomorrow = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate() + 1);
  return toIsoDate(tomorrow);
}

// src/aipo/GetOffer/components/ContractNeedsStep/PaymentPreferencesCard.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var PaymentPreferencesCard = ({ t, logger, writeableArtifact, disabled = false }) => {
  const { artifact, setArtifact } = writeableArtifact;
  const { offerRequest } = artifact;
  const paymentMethod = offerRequest.paymentMethod ?? PAYMENT_METHOD2.UPFRONT;
  const onTilesChange = (value) => {
    if (!isPaymentMethod(value))
      return;
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "payment-preferences",
        ClickObj: value,
        ClickAct: "payment-method-tiles"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => applyFpsToArtifact(prev, { paymentMethod: value }));
  };
  return /* @__PURE__ */ jsx5(Container2, { header: /* @__PURE__ */ jsx5(Header2, { description: t("paymentPreferencesDescription"), children: t("paymentPreferencesHeader") }), children: /* @__PURE__ */ jsxs4(SpaceBetween2, { size: "l", children: [
    /* @__PURE__ */ jsx5(FormField, { stretch: true, label: t("paymentMethod"), description: t("paymentMethodDescription"), children: /* @__PURE__ */ jsx5("div", { "data-testid": "payment-method-tiles", children: /* @__PURE__ */ jsx5(
      Tiles,
      {
        columns: 2,
        value: paymentMethod,
        onChange: ({ detail }) => onTilesChange(detail.value),
        items: [
          { value: "upfront", label: t("payInFull"), description: t("payInFullDescription"), disabled },
          { value: "installments", label: t("payInInstallments"), description: t("payInInstallmentsDescription"), disabled }
        ]
      }
    ) }) }),
    paymentMethod === PAYMENT_METHOD2.INSTALLMENTS && /* @__PURE__ */ jsx5(Alert2, { type: "info", children: t("installmentInfoAlert") })
  ] }) });
};

// src/aipo/GetOffer/components/RenewalTermsContainer/RenewalTermsContainer.tsx
import Alert3 from "@amzn/awsui-components-react/polaris/alert";
import Box3 from "@amzn/awsui-components-react/polaris/box";
import ColumnLayout from "@amzn/awsui-components-react/polaris/column-layout";
import Container3 from "@amzn/awsui-components-react/polaris/container";
import Header3 from "@amzn/awsui-components-react/polaris/header";
import Link3 from "@amzn/awsui-components-react/polaris/link";
import SpaceBetween3 from "@amzn/awsui-components-react/polaris/space-between";
import { AppTrans, useAppTranslation } from "@amzn/awsmp-max-translations";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG2 } from "@amzn/awsmp-max-agentic-renderer-interface";

// src/aipo/shared/renewal.ts
var PERCENTAGE_MIN = 0.01;
var PERCENTAGE_MAX = 100;
var NO_UPLIFT_FIXED_PERCENTAGE = "0.00";
var isNoUpliftFixedPercentage = (value) => Number.parseFloat(value) === 0;
var ADJUSTMENT_DEADLINE_MIN_GAP_DAYS = 1;
var PERCENTAGE_REGEX = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
function daysToIsoDuration(days) {
  if (!Number.isInteger(days) || days <= 0) {
    throw new Error(`daysToIsoDuration expects a positive integer number of days, received: ${days}`);
  }
  return `P${days}D`;
}
function buildEvolvingPriceIncrease(req) {
  switch (req.renewalUpliftType) {
    case "fixed":
      if (req.renewalFixedPercentage === void 0)
        return void 0;
      return { Type: "FixedPercentage", Value: req.renewalFixedPercentage };
    case "range":
      if (req.renewalRangeMin === void 0 || req.renewalRangeMax === void 0 || req.renewalRangeDefault === void 0) {
        return void 0;
      }
      return {
        Type: "PercentageRange",
        Range: { MinValue: req.renewalRangeMin, MaxValue: req.renewalRangeMax, DefaultValue: req.renewalRangeDefault }
      };
    case void 0:
      return void 0;
    default: {
      const _exhaustive = req.renewalUpliftType;
      throw new Error(`Unhandled renewalUpliftType: ${String(_exhaustive)}`);
    }
  }
}
function assembleRenewalTerm(priceIncrease, req) {
  const renewalTerm = { PriceIncrease: priceIncrease };
  if (req.renewalMaximumMode === "definite" && req.renewalMaxRenewals !== void 0) {
    renewalTerm.MaxRenewals = req.renewalMaxRenewals;
  }
  if (req.renewalLockoutDays !== void 0) {
    renewalTerm.LockoutPeriod = daysToIsoDuration(req.renewalLockoutDays);
  }
  if (priceIncrease.Type === "PercentageRange" && req.renewalAdjustmentDeadlineDays !== void 0) {
    renewalTerm.AdjustmentDeadline = daysToIsoDuration(req.renewalAdjustmentDeadlineDays);
  }
  return renewalTerm;
}
function buildRenewalTerm(req) {
  switch (req.renewalPricing) {
    case void 0:
    case "none":
      return void 0;
    case "identical":
      return assembleRenewalTerm({ Type: "FixedPercentage", Value: NO_UPLIFT_FIXED_PERCENTAGE }, req);
    case "evolving": {
      const priceIncrease = buildEvolvingPriceIncrease(req);
      if (priceIncrease === void 0)
        return void 0;
      return assembleRenewalTerm(priceIncrease, req);
    }
    default: {
      const _exhaustive = req.renewalPricing;
      throw new Error(`Unhandled renewalPricing: ${String(_exhaustive)}`);
    }
  }
}
function optionalIsoDurationToDays(iso) {
  if (iso === void 0)
    return void 0;
  const days = isoDurationToDays(iso);
  return days !== null && days > 0 ? days : void 0;
}
function renewalTermToInput(renewalTerm) {
  if (renewalTerm === void 0)
    return {};
  const shared = {
    renewalMaximumMode: renewalTerm.MaxRenewals !== void 0 ? "definite" : "indefinite",
    renewalMaxRenewals: renewalTerm.MaxRenewals,
    renewalLockoutDays: optionalIsoDurationToDays(renewalTerm.LockoutPeriod)
  };
  const priceIncrease = renewalTerm.PriceIncrease;
  if (priceIncrease.Type === "FixedPercentage") {
    if (isNoUpliftFixedPercentage(priceIncrease.Value)) {
      return { ...shared, renewalPricing: "identical" };
    }
    return { ...shared, renewalPricing: "evolving", renewalUpliftType: "fixed", renewalFixedPercentage: priceIncrease.Value };
  }
  if (priceIncrease.Type === "PercentageRange") {
    return {
      ...shared,
      renewalPricing: "evolving",
      renewalUpliftType: "range",
      renewalRangeMin: priceIncrease.Range.MinValue,
      renewalRangeMax: priceIncrease.Range.MaxValue,
      renewalRangeDefault: priceIncrease.Range.DefaultValue,
      renewalAdjustmentDeadlineDays: optionalIsoDurationToDays(renewalTerm.AdjustmentDeadline)
    };
  }
  return { ...shared };
}
var RENEWAL_ROW_LABEL_KEYS = {
  pricing: "renewalPricingLabel",
  priceAdjustment: "renewalPriceAdjustmentLabel",
  priceUplift: "renewalPriceUpliftLabel",
  upliftRange: "renewalUpliftRangeLabel",
  upliftDefault: "renewalUpliftDefaultLabel",
  maximum: "renewalMaximumLabel",
  // Read-only surfaces use the clean review label ("Renewal decision deadline"),
  // NOT the seller-form key `renewalLockoutLabel` — that one carries the
  // "- optional" input hint, which is meaningless on this read-back display.
  lockout: "renewalLockoutReviewLabel",
  adjustmentDeadline: "renewalSellerAdjustmentDeadlineLabel"
};
var ISO_DAYS_DURATION_REGEX = /^P(\d+)D$/;
function isoDurationToDays(iso) {
  const daysText = ISO_DAYS_DURATION_REGEX.exec(iso)?.[1];
  return daysText === void 0 ? null : Number.parseInt(daysText, 10);
}
function isNoUplift(increase) {
  return Number.parseFloat(increase.value) === 0;
}
function classifyPriceIncrease(priceIncrease) {
  if (priceIncrease == null) {
    return { kind: "unknown" };
  }
  if (priceIncrease.fixedPercentage !== void 0) {
    return isNoUplift(priceIncrease.fixedPercentage) ? { kind: "noUplift" } : { kind: "fixedPercentage", increase: priceIncrease.fixedPercentage };
  }
  if (priceIncrease.percentageRange !== void 0) {
    return { kind: "percentageRange", increase: priceIncrease.percentageRange };
  }
  return { kind: "unknown" };
}
function renewalUpliftValues(priceIncrease, t) {
  const active = classifyPriceIncrease(priceIncrease);
  switch (active.kind) {
    case "noUplift":
      return { kind: "none" };
    case "unknown":
      return { kind: "unknown" };
    case "fixedPercentage":
      return {
        kind: "fixed",
        perCycle: t("renewalUpliftPerCycleValue", { percent: active.increase.value }),
        percent: t("renewalPercentageValue", { percent: active.increase.value })
      };
    case "percentageRange": {
      const { minValue, maxValue, defaultValue } = active.increase.rangeConfiguration;
      return {
        kind: "range",
        range: t("renewalUpliftRangeValue", { min: minValue, max: maxValue }),
        default: t("renewalUpliftDefaultValue", { percent: defaultValue }),
        adjustmentDeadline: active.increase.adjustmentDeadline
      };
    }
    default: {
      const _exhaustive = active;
      throw new Error(`Unhandled renewal price increase kind: ${String(_exhaustive)}`);
    }
  }
}
function renewalScopeRows(terms, t) {
  const rows = [
    {
      labelKey: RENEWAL_ROW_LABEL_KEYS.maximum,
      // A finite count is a bare integer; absence means no cap → "Unlimited".
      value: terms.maxRenewals !== void 0 ? String(terms.maxRenewals) : t("renewalMaximumUnlimited")
    }
  ];
  if (terms.lockoutPeriod !== void 0) {
    const days = isoDurationToDays(terms.lockoutPeriod);
    if (days !== null) {
      rows.push({ labelKey: RENEWAL_ROW_LABEL_KEYS.lockout, value: t("renewalLockoutPhrase", { days, count: days }) });
    }
  }
  return rows;
}
function toRenewalRows(terms, t) {
  const uplift = renewalUpliftValues(terms.priceIncrease, t);
  switch (uplift.kind) {
    case "unknown":
      return [];
    case "none":
      return [
        { labelKey: RENEWAL_ROW_LABEL_KEYS.pricing, value: t("renewalPricingNoUplift") },
        { labelKey: RENEWAL_ROW_LABEL_KEYS.priceAdjustment, value: t("renewalPriceAdjustmentNone") },
        ...renewalScopeRows(terms, t)
      ];
    case "fixed":
      return [
        { labelKey: RENEWAL_ROW_LABEL_KEYS.pricing, value: t("renewalPricingUplift") },
        { labelKey: RENEWAL_ROW_LABEL_KEYS.priceUplift, value: uplift.perCycle },
        ...renewalScopeRows(terms, t)
      ];
    case "range": {
      const rows = [
        { labelKey: RENEWAL_ROW_LABEL_KEYS.pricing, value: t("renewalPricingUpliftRange") },
        { labelKey: RENEWAL_ROW_LABEL_KEYS.upliftRange, value: uplift.range },
        { labelKey: RENEWAL_ROW_LABEL_KEYS.upliftDefault, value: uplift.default },
        ...renewalScopeRows(terms, t)
      ];
      if (uplift.adjustmentDeadline !== void 0) {
        const days = isoDurationToDays(uplift.adjustmentDeadline);
        if (days !== null) {
          rows.push({
            labelKey: RENEWAL_ROW_LABEL_KEYS.adjustmentDeadline,
            value: t("renewalAdjustmentDeadlinePhrase", { days, count: days })
          });
        }
      }
      return rows;
    }
    default: {
      const _exhaustive = uplift;
      throw new Error(`Unhandled renewal uplift kind: ${String(_exhaustive)}`);
    }
  }
}
var RENEWAL_SUMMARY_LABEL_KEYS = {
  pricing: "renewalPricingLabel",
  upliftType: "renewalPriceUpliftTypeLabel",
  upliftPercentage: "renewalPriceUpliftPercentageLabel",
  // Range arm: reuse the container's two-row range/default labels verbatim.
  upliftRange: "renewalUpliftRangeLabel",
  upliftDefault: "renewalUpliftDefaultLabel",
  maximum: "renewalMaximumLabel",
  // Share the container's review label ("Renewal decision deadline") for the same field.
  lockoutDate: "renewalLockoutReviewLabel"
};
function toRenewalSummaryRows(terms, t) {
  const uplift = renewalUpliftValues(terms.priceIncrease, t);
  if (uplift.kind === "unknown")
    return [];
  const rows = [
    {
      labelKey: RENEWAL_SUMMARY_LABEL_KEYS.pricing,
      value: uplift.kind === "none" ? t("renewalPricingNoUplift") : t("renewalPricingUplift")
    }
  ];
  if (uplift.kind === "fixed") {
    rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.upliftType, value: t("renewalPriceUpliftTypeFixedValue") });
    rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.upliftPercentage, value: uplift.percent });
  } else if (uplift.kind === "range") {
    rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.upliftType, value: t("renewalPriceUpliftTypeRangeValue") });
    rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.upliftRange, value: uplift.range });
    rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.upliftDefault, value: uplift.default });
  }
  rows.push({
    labelKey: RENEWAL_SUMMARY_LABEL_KEYS.maximum,
    value: terms.maxRenewals !== void 0 ? String(terms.maxRenewals) : t("renewalMaximumUnlimited")
  });
  if (terms.lockoutPeriod !== void 0) {
    const days = isoDurationToDays(terms.lockoutPeriod);
    if (days !== null) {
      rows.push({ labelKey: RENEWAL_SUMMARY_LABEL_KEYS.lockoutDate, value: t("renewalLockoutPhrase", { days, count: days }) });
    }
  }
  return rows;
}

// src/aipo/GetOffer/components/RenewalTermsContainer/RenewalTermsContainer.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var RenewalTermsContainer = ({
  renewalTerms,
  openHelpPanel,
  helpPathslug = HELP_PANEL_PATHSLUG2.EPO_RENEWAL_TERMS
}) => {
  const { t } = useAppTranslation();
  const rows = toRenewalRows(renewalTerms, t);
  if (rows.length === 0)
    return null;
  const headerText = t("renewalTermsAvailableHeader");
  const buyerIntro = /* @__PURE__ */ jsx6(AppTrans, { i18nKey: "renewalTermsBuyerIntro", children: /* @__PURE__ */ jsx6(Box3, { variant: "strong", display: "inline", children: "Manage Subscriptions" }) });
  const infoLink = openHelpPanel ? /* @__PURE__ */ jsx6(Link3, { variant: "info", ariaLabel: t("infoAriaLabel", { section: t("renewalTermsAvailableHeader") }), onFollow: () => openHelpPanel(helpPathslug), children: t("info") }) : void 0;
  const fields = /* @__PURE__ */ jsx6(ColumnLayout, { columns: 3, variant: "text-grid", children: rows.map((row) => /* @__PURE__ */ jsxs5("div", { children: [
    /* @__PURE__ */ jsx6(Box3, { variant: "awsui-key-label", children: t(row.labelKey) }),
    /* @__PURE__ */ jsx6(Box3, { children: row.value })
  ] }, row.labelKey)) });
  return /* @__PURE__ */ jsx6(
    Container3,
    {
      header: /* @__PURE__ */ jsx6(Header3, { variant: "h2", info: infoLink, children: headerText }),
      children: /* @__PURE__ */ jsxs5(SpaceBetween3, { size: "l", children: [
        /* @__PURE__ */ jsx6(Alert3, { type: "info", children: buyerIntro }),
        fields
      ] })
    }
  );
};

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var getEarliestValidDate = (buyerOptions) => {
  const { minDate } = calculateDateConstraints(buyerOptions.maxFutureStartDuration, buyerOptions.expiration);
  return minDate.plus({ days: 1 }).toFormat("yyyy-MM-dd");
};
var getDurationOptions = (unit, buyerOptions, t) => {
  const baseOptions = unit === "M" ? Array.from({ length: 60 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) : Array.from({ length: 5 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }));
  return baseOptions.map((option) => {
    const duration = parseInt(option.value, 10);
    const durationValidation = isDurationValid(unit === "Y" ? duration * 12 : duration, "M", buyerOptions, t);
    return durationValidation.isValid ? option : {
      ...option,
      disabled: true,
      disabledReason: t("optionNotIncludedInConfiguration")
    };
  });
};
var getDurationUnitOptions = (buyerOptions, t) => {
  const yearDurationOptions = getDurationOptions("Y", buyerOptions, t);
  const hasValidYear = yearDurationOptions.find((option) => !option.disabled) !== void 0;
  const baseYearOption = { label: t("years"), value: "Y" };
  const yearOption = hasValidYear ? baseYearOption : {
    ...baseYearOption,
    disabled: true,
    disabledReason: t("optionNotIncludedInConfiguration")
  };
  return [{ label: t("months"), value: "M" }, yearOption];
};
var isContractDatePref = (v) => v === "auto" || v === "custom";
var ContractNeedsStep = (props) => {
  const {
    errors,
    clearFieldError,
    contractDatePref,
    setContractDatePref,
    eulaUrl,
    listingId,
    buyerOptions,
    writeableArtifact,
    isArtifactLocked,
    logger,
    t
  } = props;
  const { artifact, setArtifact } = writeableArtifact;
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.CONTRACT_NEEDS);
  const [duration, setDuration] = useState4(parseLimitedISODurationToNumber(artifact.offerRequest?.duration));
  const [unit, setUnit] = useState4(parseLimitedISODurationUnit(artifact.offerRequest?.duration) ?? "M");
  const [customContractDate, setCustomContractDate] = useState4(artifact.offerRequest.futureStartDate || getEarliestValidDate(buyerOptions));
  const durationOptions = useMemo2(() => getDurationOptions(unit, buyerOptions, t), [unit, buyerOptions, t]);
  const durationUnitOptions = useMemo2(() => getDurationUnitOptions(buyerOptions, t), [buyerOptions, t]);
  const selectedDurationUnit = durationUnitOptions.find((option) => option.value === unit) ?? null;
  const updateArtifactDuration = useCallback4(
    (newDuration, newUnit) => {
      let durationToSet;
      if (newDuration && newDuration > 0) {
        if (newUnit === "Y") {
          durationToSet = `P${newDuration * 12}M`;
        } else {
          durationToSet = `P${newDuration}${newUnit}`;
        }
      }
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          duration: durationToSet
        }
      }));
    },
    [setArtifact]
  );
  const updateArtifactFutureStartDate = useCallback4(
    (newContractDatePref, newFutureStartDate) => {
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          futureStartDate: newContractDatePref === "auto" ? void 0 : newFutureStartDate
        }
      }));
    },
    [setArtifact]
  );
  const onDurationChanged = useCallback4(
    (e) => {
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "duration-dropdown",
          // Cloudscape types selectedOption.value as string|undefined, but every duration
          // option carries a defined value, so the `|| ""` fallback is defensive narrowing.
          /* v8 ignore next */
          ClickAct: e.detail.selectedOption.value || ""
        }
      });
      const newDuration = parseInt(e.detail.selectedOption.value || "0", 10);
      setDuration(newDuration);
      updateArtifactDuration(newDuration, unit);
    },
    [unit, updateArtifactDuration, logger]
  );
  const onUnitChanged = useCallback4(
    (e) => {
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "duration-unit-dropdown",
          ClickAct: e.detail.selectedOption.label
        }
      });
      setUnit(e.detail.selectedOption.value);
      setDuration(void 0);
      updateArtifactDuration(void 0, e.detail.selectedOption.value);
    },
    [updateArtifactDuration, logger]
  );
  const onContractDatePrefChanged = useCallback4(
    (e) => {
      const newPref = e.detail.value;
      if (!isContractDatePref(newPref))
        return;
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "contract-start-date",
          ClickAct: newPref === "auto" ? "start-immediate" : "start-custom-date"
        }
      });
      setContractDatePref(newPref);
      updateArtifactFutureStartDate(newPref, customContractDate);
    },
    [customContractDate, updateArtifactFutureStartDate, setContractDatePref, logger]
  );
  const onCustomContractDateChanged = useCallback4(
    (e) => {
      setCustomContractDate(e.detail.value);
      updateArtifactFutureStartDate(contractDatePref, e.detail.value);
    },
    [contractDatePref, updateArtifactFutureStartDate]
  );
  const onCustomContractDateBlur = useCallback4(() => {
    if (errors?.customDateError) {
      clearFieldError("customDateError");
    }
    if (errors?.dateConstraintError) {
      clearFieldError("dateConstraintError");
    }
  }, [errors?.customDateError, errors?.dateConstraintError, clearFieldError]);
  const onDurationBlur = useCallback4(() => {
    if (errors?.durationError) {
      clearFieldError("durationError");
    }
    if (errors?.durationConstraintError) {
      clearFieldError("durationConstraintError");
    }
  }, [errors?.durationError, errors?.durationConstraintError, clearFieldError]);
  const canSelectCustomDate = useMemo2(() => {
    return Duration.fromISO(buyerOptions.maxFutureStartDuration).toMillis() > 0;
  }, [buyerOptions.maxFutureStartDuration]);
  const radioGroupItems = useMemo2(() => {
    return [
      {
        value: "auto",
        label: t("startDateAcceptOffer"),
        disabled: isArtifactLocked
      },
      ...canSelectCustomDate ? [
        {
          value: "custom",
          label: t("startOnSpecificDate"),
          disabled: isArtifactLocked
        }
      ] : []
    ];
  }, [canSelectCustomDate]);
  return /* @__PURE__ */ jsxs6(SpaceBetween4, { size: "s", children: [
    /* @__PURE__ */ jsx7(Container4, { header: /* @__PURE__ */ jsx7(Header4, { description: t("contractDurationDescription"), children: t("contractDurationAndStartDate") }), children: /* @__PURE__ */ jsxs6(SpaceBetween4, { size: "s", children: [
      /* @__PURE__ */ jsx7("div", { className: ContractNeedsStep_default.durationOuterContainer, children: /* @__PURE__ */ jsxs6("div", { className: ContractNeedsStep_default.durationContainer, children: [
        /* @__PURE__ */ jsx7("div", { className: ContractNeedsStep_default.flexGrow, children: /* @__PURE__ */ jsx7(FormField2, { label: t("unitOfTime"), controlId: "unit-of-time", children: /* @__PURE__ */ jsx7(
          Select,
          {
            options: durationUnitOptions,
            selectedOption: selectedDurationUnit,
            onChange: onUnitChanged,
            disabled: isArtifactLocked,
            placeholder: t("chooseAnOption")
          }
        ) }) }),
        /* @__PURE__ */ jsx7("div", { className: ContractNeedsStep_default.flexGrow, children: /* @__PURE__ */ jsx7(
          FormField2,
          {
            label: t("duration"),
            errorText: errors?.durationError || errors?.durationConstraintError,
            controlId: "duration",
            "data-testid": "duration-form-field",
            children: /* @__PURE__ */ jsx7(
              Select,
              {
                "data-testid": "duration-select",
                options: durationOptions,
                selectedOption: duration ? { label: duration.toString(), value: duration.toString() } : null,
                onChange: onDurationChanged,
                onBlur: onDurationBlur,
                disabled: isArtifactLocked,
                placeholder: t("chooseAnOption"),
                virtualScroll: true
              }
            )
          }
        ) })
      ] }) }),
      /* @__PURE__ */ jsxs6("div", { children: [
        /* @__PURE__ */ jsx7(FormField2, { label: t("contractStartDate"), description: t("selectYourStartDate"), children: /* @__PURE__ */ jsx7(RadioGroup, { value: contractDatePref, items: radioGroupItems, onChange: onContractDatePrefChanged }) }),
        contractDatePref === "custom" && /* @__PURE__ */ jsx7(
          FormField2,
          {
            label: t("setDate"),
            className: ContractNeedsStep_default.setDateField,
            errorText: errors?.customDateError || errors?.dateConstraintError,
            description: t("startDateConstraintDescription"),
            constraintText: t("dateFormatConstraint"),
            "data-testid": "custom-date-form-field",
            children: /* @__PURE__ */ jsx7(
              DatePicker,
              {
                "data-testid": "contract-start-date-picker",
                placeholder: "YYYY/MM/DD",
                value: customContractDate,
                onChange: onCustomContractDateChanged,
                onBlur: onCustomContractDateBlur,
                isDateEnabled: (date) => isDateWithinConstraints(date, buyerOptions.maxFutureStartDuration, buyerOptions.expiration),
                disabled: isArtifactLocked
              }
            )
          }
        )
      ] })
    ] }) }),
    props.fpsEnabled === true && /* @__PURE__ */ jsx7(PaymentPreferencesCard, { t, logger, writeableArtifact, disabled: isArtifactLocked }),
    /* @__PURE__ */ jsx7(Container4, { header: /* @__PURE__ */ jsx7(Header4, { children: t("eulaHeader") }), children: /* @__PURE__ */ jsxs6(SpaceBetween4, { size: "m", children: [
      /* @__PURE__ */ jsx7(TextContent3, { children: /* @__PURE__ */ jsxs6("p", { children: [
        t("offerGeneratedWithVendorEula"),
        " ",
        /* @__PURE__ */ jsx7(Link4, { variant: "primary", href: eulaUrl, external: true, children: t("endUserLicenseAgreement") }),
        "."
      ] }) }),
      /* @__PURE__ */ jsxs6(TextContent3, { children: [
        /* @__PURE__ */ jsx7("p", { children: /* @__PURE__ */ jsx7("strong", { children: t("doYouNeedCustomTerms") }) }),
        /* @__PURE__ */ jsx7("p", { children: /* @__PURE__ */ jsx7(
          Link4,
          {
            variant: "primary",
            href: marketplaceLinks2.get("RequestPrivateOffer", { listingId }),
            external: true,
            onFollow: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: "eula-container",
                  ClickAct: "request-custom-offer"
                }
              });
            },
            children: t("connectWithRepresentative")
          }
        ) })
      ] })
    ] }) }),
    buyerOptions.renewalTerms != null && /* @__PURE__ */ jsx7(
      RenewalTermsContainer,
      {
        renewalTerms: buyerOptions.renewalTerms,
        openHelpPanel: props.openHelpPanel,
        helpPathslug: HELP_PANEL_PATHSLUG3.BUYER_REQUEST_OFFER_AUTO_RENEWAL_TERMS
      }
    )
  ] });
};

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/ConfigurePaymentPlanPage.tsx
import React from "react";
import Box7 from "@amzn/awsui-components-react/polaris/box";
import Button3 from "@amzn/awsui-components-react/polaris/button";
import ContentLayout from "@amzn/awsui-components-react/polaris/content-layout";
import Header8 from "@amzn/awsui-components-react/polaris/header";
import Link6 from "@amzn/awsui-components-react/polaris/link";
import SpaceBetween8 from "@amzn/awsui-components-react/polaris/space-between";
import Grid from "@amzn/awsui-components-react/polaris/grid";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG5 } from "@amzn/awsmp-max-agentic-renderer-interface";

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/metrics-constants.js
var CustomOpsMetricName;
(function(CustomOpsMetricName2) {
  CustomOpsMetricName2["ClientSide404"] = "ClientSide404";
  CustomOpsMetricName2["ClientSide500"] = "ClientSide500";
  CustomOpsMetricName2["ClientSide500Ignored"] = "ClientSide500Ignored";
  CustomOpsMetricName2["ClientSideNonFatalToolCallError"] = "ClientSideNonFatalToolCallError";
  CustomOpsMetricName2["ClientSideThrottled"] = "ClientSideThrottled";
  CustomOpsMetricName2["ClientSideReconnectionRateLimited"] = "ClientSideReconnectionRateLimited";
  CustomOpsMetricName2["MintRefused"] = "MintRefused";
  CustomOpsMetricName2["ArtifactFallbackRender"] = "ArtifactFallbackRender";
  CustomOpsMetricName2["FederatedArtifactRenderSuccess"] = "FederatedArtifactRenderSuccess";
  CustomOpsMetricName2["FederatedArtifactRenderError"] = "FederatedArtifactRenderError";
  CustomOpsMetricName2["FederatedArtifactRenderLatency"] = "FederatedArtifactRenderLatency";
  CustomOpsMetricName2["EPOBuyerUnonboardedPageRender"] = "EPOBuyerUnonboardedPageRender";
  CustomOpsMetricName2["EPOBuyerLeadReferralValueInvalid"] = "EPOBuyerLeadReferralValueInvalid";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadFailure"] = "EPOBuyerLeadFormLoadFailure";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadSuccess"] = "EPOBuyerLeadFormLoadSuccess";
  CustomOpsMetricName2["EPOBuyerLeadSubmitFailure"] = "EPOBuyerLeadSubmitFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitSuccess"] = "EPOBuyerLeadSubmitSuccess";
  CustomOpsMetricName2["EPOBuyerLeadValidationFailure"] = "EPOBuyerLeadValidationFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitNotReady"] = "EPOBuyerLeadSubmitNotReady";
  CustomOpsMetricName2["EPOBuyerLeadTerminalSubmitFailure"] = "EPOBuyerLeadTerminalSubmitFailure";
  CustomOpsMetricName2["EPOBuyerRenewalPreviewDerivationFailure"] = "EPOBuyerRenewalPreviewDerivationFailure";
  CustomOpsMetricName2["RecommendUnitsError"] = "RecommendUnitsError";
  CustomOpsMetricName2["EPOSellerMultiplePublicOffers"] = "EPOSellerMultiplePublicOffers";
  CustomOpsMetricName2["EPOSellerUnexpectedEulaType"] = "EPOSellerUnexpectedEulaType";
  CustomOpsMetricName2["EPOSellerBatchDescribePartialFailure"] = "EPOSellerBatchDescribePartialFailure";
  CustomOpsMetricName2["EPOSellerBatchDescribeFailure"] = "EPOSellerBatchDescribeFailure";
  CustomOpsMetricName2["EPOSellerNoPublicOfferFound"] = "EPOSellerNoPublicOfferFound";
})(CustomOpsMetricName || (CustomOpsMetricName = {}));
var CustomOpsSdkServiceName;
(function(CustomOpsSdkServiceName2) {
  CustomOpsSdkServiceName2["MARKETPLACE_DISCOVERY"] = "MarketplaceDiscovery";
  CustomOpsSdkServiceName2["MARKETPLACE_AGREEMENT"] = "MarketplaceAgreement";
  CustomOpsSdkServiceName2["MARKETPLACE_CATALOG"] = "MarketplaceCatalog";
})(CustomOpsSdkServiceName || (CustomOpsSdkServiceName = {}));

// ../../node_modules/@smithy/smithy-client/dist-es/exceptions.js
var ServiceException = class _ServiceException extends Error {
  $fault;
  $response;
  $retryable;
  $metadata;
  constructor(options) {
    super(options.message);
    Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype);
    this.name = options.name;
    this.$fault = options.$fault;
    this.$metadata = options.$metadata;
  }
  static isInstance(value) {
    if (!value)
      return false;
    const candidate = value;
    return _ServiceException.prototype.isPrototypeOf(candidate) || Boolean(candidate.$fault) && Boolean(candidate.$metadata) && (candidate.$fault === "client" || candidate.$fault === "server");
  }
  static [Symbol.hasInstance](instance) {
    if (!instance)
      return false;
    const candidate = instance;
    if (this === _ServiceException) {
      return _ServiceException.isInstance(instance);
    }
    if (_ServiceException.isInstance(instance)) {
      if (candidate.name && this.name) {
        return this.prototype.isPrototypeOf(instance) || candidate.name === this.name;
      }
      return this.prototype.isPrototypeOf(instance);
    }
    return false;
  }
};

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/sdk-metrics/types.js
var STATUS_CODE_CLASS;
(function(STATUS_CODE_CLASS2) {
  STATUS_CODE_CLASS2["TWO_HUNDRED"] = "200";
  STATUS_CODE_CLASS2["FOUR_HUNDRED"] = "400";
  STATUS_CODE_CLASS2["FIVE_HUNDRED"] = "500";
})(STATUS_CODE_CLASS || (STATUS_CODE_CLASS = {}));

// src/aipo/GetOffer/utils/format.ts
var formatCurrency = (amount, currencyCode) => new Intl.NumberFormat("en-US", { style: "currency", currency: currencyCode }).format(typeof amount === "string" ? Number(amount) : amount);
var formatChargeDate = (chargeDate) => new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  year: "numeric",
  month: "short",
  day: "numeric"
}).format(/* @__PURE__ */ new Date(`${chargeDate}T00:00:00.000Z`));

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/usePaymentPlanForm.ts
import { useRef as useRef5, useState as useState5 } from "react";

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/validation.ts
var DAY_OF_MONTH_MIN = 1;
var DAY_OF_MONTH_MAX = 31;
var startOfLocalDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
var addMonthsClampedLocal = (base, months2) => {
  const targetYear = base.getFullYear();
  const targetMonth = base.getMonth() + months2;
  const anchorDay = base.getDate();
  const lastDayOfTargetMonth = new Date(targetYear, targetMonth + 1, 0).getDate();
  const clampedDay = Math.min(anchorDay, lastDayOfTargetMonth);
  return new Date(targetYear, targetMonth, clampedDay);
};
var parseCalendarDate = (raw) => {
  const match2 = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw.trim());
  if (!match2)
    return void 0;
  const year = Number(match2[1]);
  const month = Number(match2[2]);
  const day = Number(match2[3]);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return void 0;
  }
  return date;
};
var firstInvoiceWindow = (today) => {
  const creationDay = startOfLocalDay(today);
  const start = new Date(creationDay);
  start.setDate(start.getDate() + 1);
  const oneMonthOut = addMonthsClampedLocal(creationDay, 1);
  const max = new Date(oneMonthOut);
  max.setDate(max.getDate() - 1);
  return { start, max };
};
var isFirstInvoiceDateEnabled = (date, today) => {
  const { start, max } = firstInvoiceWindow(today);
  const day = startOfLocalDay(date);
  return day.getTime() >= start.getTime() && day.getTime() <= max.getTime();
};
var validateFirstInvoiceDate = (raw, today, t) => {
  if (raw.trim() === "")
    return t("validationFirstInvoiceDateRequired");
  const parsed = parseCalendarDate(raw);
  if (!parsed)
    return t("validationFirstInvoiceDateRange");
  const { start, max } = firstInvoiceWindow(today);
  if (parsed.getTime() < start.getTime() || parsed.getTime() > max.getTime()) {
    return t("validationFirstInvoiceDateRange");
  }
  return void 0;
};
var INITIAL_PAYMENT_MAX_DECIMALS = 2;
var IN_PROGRESS_INITIAL_PAYMENT = /^-?\d*\.?\d*$/;
var restrictInitialPaymentInput = (next, previous) => {
  if (next === "")
    return next;
  if (!IN_PROGRESS_INITIAL_PAYMENT.test(next)) {
    return previous;
  }
  const decimals = next.split(".")[1];
  if (decimals !== void 0 && decimals.length > INITIAL_PAYMENT_MAX_DECIMALS) {
    return previous;
  }
  return next;
};
var validateInitialPayment = (raw, contractTotalNumeric, contractTotalDisplay, t) => {
  if (raw === "")
    return void 0;
  const n2 = parseFloat(raw);
  if (Number.isNaN(n2) || n2 <= 0)
    return t("validationInitialPaymentPositive");
  const decimals = raw.trim().split(".")[1];
  if (decimals !== void 0 && decimals.length > INITIAL_PAYMENT_MAX_DECIMALS) {
    return t("validationInitialPaymentMaxDecimals");
  }
  if (n2 >= contractTotalNumeric) {
    return t("validationInitialPaymentLessThanTotal", { contractTotal: contractTotalDisplay });
  }
  return void 0;
};
var validateDayOfMonth = (raw, t) => {
  if (raw === "")
    return void 0;
  if (!/^\d+$/.test(raw.trim()))
    return t("validationDayOfMonthRange");
  const n2 = parseInt(raw, 10);
  if (n2 < DAY_OF_MONTH_MIN || n2 > DAY_OF_MONTH_MAX)
    return t("validationDayOfMonthRange");
  return void 0;
};

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/usePaymentPlanForm.ts
var usePaymentPlanForm = ({
  writeableArtifact,
  onCancel,
  onGenerateOffer,
  isGeneratingOffer,
  logger,
  t,
  allowedFrequencies,
  initialPaymentAllowed,
  contractTotal,
  generateInstallmentSchedule,
  scheduleAnchorDate,
  currencyCode
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.EDIT_PAYMENT_SCHEDULE);
  const inputs = readFpsScheduleInputs(artifact);
  const paymentFrequency = inputs.frequency;
  const firstInvoiceDate = inputs.firstInvoiceDate;
  const initialPayment = inputs.initialPayment;
  const dayOfMonth = inputs.dayOfMonth;
  const [today, setToday] = useState5(() => /* @__PURE__ */ new Date());
  const contractTotalDisplay = formatCurrency(contractTotal, currencyCode);
  const initialPaymentError = initialPaymentAllowed ? validateInitialPayment(initialPayment, contractTotal, contractTotalDisplay, t) : void 0;
  const firstInvoiceDateError = validateFirstInvoiceDate(firstInvoiceDate, today, t);
  const dayOfMonthError = validateDayOfMonth(dayOfMonth, t);
  const generateDisabled = paymentFrequency === void 0 || Boolean(firstInvoiceDateError || initialPaymentError || dayOfMonthError) || isGeneratingOffer;
  const trackClick = (clickAct, clickObj) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "payment-schedule",
        ...clickObj !== void 0 ? { ClickObj: clickObj } : {},
        ClickAct: clickAct
      },
      value: 1,
      unit: "Count"
    });
  };
  const frequencyOptions = allowedFrequencies.map((value) => ({
    value,
    label: frequencyLabel(value, t)
  }));
  const selectedFrequencyOption = paymentFrequency ? { value: paymentFrequency, label: frequencyLabel(paymentFrequency, t) } : null;
  const onFirstInvoiceDateChange = (value) => {
    trackClick("first-invoice-date", value);
    setArtifact((prev) => applyFpsToArtifact(prev, { firstInstallmentDate: value || void 0 }));
  };
  const onFrequencyChange = (value) => {
    if (!isPaymentFrequency(value))
      return;
    trackClick("frequency", value);
    setArtifact((prev) => applyFpsToArtifact(prev, { frequency: value }));
  };
  const onDayOfMonthChange = (value) => {
    setArtifact((prev) => applyFpsToArtifact(prev, { dayOfMonth: value || void 0 }));
  };
  const onInitialPaymentChange = (value) => {
    const withoutSeparators = value.replace(/,/g, "");
    const restricted = restrictInitialPaymentInput(withoutSeparators, initialPayment);
    setArtifact((prev) => applyFpsToArtifact(prev, { initialPaymentAmount: restricted || void 0 }));
  };
  const onInitialPaymentBlur = () => {
    const n2 = parseFloat(initialPayment);
    if (!initialPayment || Number.isNaN(n2))
      return;
    setArtifact((prev) => applyFpsToArtifact(prev, { initialPaymentAmount: n2.toFixed(2) }));
  };
  const rows = generateInstallmentSchedule({
    frequency: paymentFrequency,
    firstInvoiceDate,
    dayOfMonth,
    initialPayment: initialPaymentAllowed ? initialPayment : "",
    durationISO: artifact.offerRequest.duration,
    total: contractTotal,
    anchorDate: scheduleAnchorDate
  });
  const lastValidRowCount = useRef5(0);
  if (rows !== null) {
    lastValidRowCount.current = rows.length;
  }
  const previewState = rows !== null ? { kind: "rows", rows } : paymentFrequency === void 0 ? { kind: "prompt" } : { kind: "placeholder", rowCount: lastValidRowCount.current };
  return {
    contractTotalDisplay,
    firstInvoiceDate,
    firstInvoiceDateError,
    isDateEnabled: (date) => isFirstInvoiceDateEnabled(date, today),
    onFirstInvoiceDateChange,
    paymentFrequency,
    durationISO: artifact.offerRequest.duration,
    frequencyOptions,
    selectedFrequencyOption,
    onFrequencyChange,
    dayOfMonth,
    dayOfMonthError,
    onDayOfMonthChange,
    onDayOfMonthFocus: () => trackClick("day-of-month"),
    initialPaymentAllowed,
    initialPayment,
    initialPaymentError,
    onInitialPaymentChange,
    onInitialPaymentBlur,
    onInitialPaymentFocus: () => trackClick("initial-payment"),
    previewState,
    generateDisabled,
    onCancelClick: () => {
      trackClick("cancel");
      onCancel();
    },
    onGenerateClick: () => {
      trackClick("generate-offer");
      const now2 = /* @__PURE__ */ new Date();
      if (validateFirstInvoiceDate(firstInvoiceDate, now2, t) !== void 0) {
        setToday(now2);
        return;
      }
      onGenerateOffer();
    }
  };
};

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/PaymentPlanForm.tsx
import Box4 from "@amzn/awsui-components-react/polaris/box";
import ColumnLayout2 from "@amzn/awsui-components-react/polaris/column-layout";
import Container5 from "@amzn/awsui-components-react/polaris/container";
import Header5 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween5 from "@amzn/awsui-components-react/polaris/space-between";
import FormField3 from "@amzn/awsui-components-react/polaris/form-field";
import Select2 from "@amzn/awsui-components-react/polaris/select";
import DatePicker2 from "@amzn/awsui-components-react/polaris/date-picker";
import Input2 from "@amzn/awsui-components-react/polaris/input";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var PaymentPlanForm = ({ model, t, hasRenewal }) => {
  const firstInvoiceDateField = /* @__PURE__ */ jsx8(
    FormField3,
    {
      label: t("firstInvoiceDate"),
      description: t("firstInvoiceDateDescription"),
      constraintText: t("firstInvoiceDateConstraint"),
      errorText: model.firstInvoiceDateError,
      children: /* @__PURE__ */ jsx8("div", { "data-testid": "edit-first-invoice-date-picker", children: /* @__PURE__ */ jsx8(
        DatePicker2,
        {
          placeholder: "YYYY/MM/DD",
          value: model.firstInvoiceDate,
          ariaRequired: true,
          isDateEnabled: model.isDateEnabled,
          dateDisabledReason: () => t("firstInvoiceDateDisabledReason"),
          onChange: ({ detail }) => model.onFirstInvoiceDateChange(detail.value)
        }
      ) })
    }
  );
  const initialPaymentField = model.initialPaymentAllowed ? /* @__PURE__ */ jsx8(
    FormField3,
    {
      label: /* @__PURE__ */ jsxs7("span", { children: [
        t("initialPaymentLabel"),
        " - ",
        /* @__PURE__ */ jsx8("i", { children: t("optionalLabel") })
      ] }),
      description: t("initialPaymentDescription"),
      constraintText: t("initialPaymentConstraint"),
      errorText: model.initialPaymentError,
      children: /* @__PURE__ */ jsx8("div", { "data-testid": "edit-initial-payment-input", children: /* @__PURE__ */ jsx8(
        Input2,
        {
          type: "text",
          inputMode: "decimal",
          placeholder: t("enterAmountPlaceholder"),
          value: model.initialPayment,
          onFocus: model.onInitialPaymentFocus,
          onBlur: model.onInitialPaymentBlur,
          onChange: ({ detail }) => model.onInitialPaymentChange(detail.value)
        }
      ) })
    }
  ) : null;
  const frequencyField = /* @__PURE__ */ jsx8(FormField3, { label: t("frequencyLabel"), description: t("frequencyDescription"), children: /* @__PURE__ */ jsx8("div", { "data-testid": "edit-frequency-select", children: /* @__PURE__ */ jsx8(
    Select2,
    {
      placeholder: t("selectFrequency"),
      options: model.frequencyOptions,
      selectedOption: model.selectedFrequencyOption,
      ariaRequired: true,
      onChange: ({ detail }) => model.onFrequencyChange(detail.selectedOption.value)
    }
  ) }) });
  const dayOfMonthField = /* @__PURE__ */ jsx8(
    FormField3,
    {
      label: /* @__PURE__ */ jsxs7("span", { children: [
        t("dayOfMonthLabel"),
        " - ",
        /* @__PURE__ */ jsx8("i", { children: t("optionalLabel") })
      ] }),
      description: t("dayOfMonthDescription"),
      constraintText: t("dayOfMonthConstraint"),
      errorText: model.dayOfMonthError,
      children: /* @__PURE__ */ jsx8("div", { "data-testid": "edit-day-of-month-input", children: /* @__PURE__ */ jsx8(
        Input2,
        {
          type: "number",
          inputMode: "numeric",
          placeholder: t("dayOfMonthPlaceholder"),
          value: model.dayOfMonth,
          onFocus: model.onDayOfMonthFocus,
          onChange: ({ detail }) => model.onDayOfMonthChange(detail.value)
        }
      ) })
    }
  );
  return /* @__PURE__ */ jsx8(Container5, { header: /* @__PURE__ */ jsx8(Header5, { variant: "h2", children: t("installmentPlanContainerHeader") }), children: /* @__PURE__ */ jsx8(SpaceBetween5, { size: "l", children: hasRenewal ? (
    // Two labelled sub-sections separated by a Cloudscape hairline. ColumnLayout with a
    // single column + horizontal borders draws the divider between the sections (matches
    // the approved design) using only Cloudscape primitives.
    /* @__PURE__ */ jsxs7(ColumnLayout2, { columns: 1, borders: "horizontal", children: [
      /* @__PURE__ */ jsx8("div", { "data-testid": "edit-first-installment-plan-settings", children: /* @__PURE__ */ jsx8(Box4, { padding: { bottom: "m" }, children: /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "l", children: [
        /* @__PURE__ */ jsx8(Header5, { variant: "h3", description: t("firstInstallmentPlanSettingsDescription"), children: t("firstInstallmentPlanSettingsHeader") }),
        /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "l", children: [
          firstInvoiceDateField,
          initialPaymentField
        ] })
      ] }) }) }),
      /* @__PURE__ */ jsx8("div", { "data-testid": "edit-shared-installment-plan-settings", children: /* @__PURE__ */ jsx8(Box4, { padding: { top: "m" }, children: /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "l", children: [
        /* @__PURE__ */ jsx8(Header5, { variant: "h3", description: t("firstAndRenewalInstallmentPlanSettingsDescription"), children: t("firstAndRenewalInstallmentPlanSettingsHeader") }),
        /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "l", children: [
          frequencyField,
          dayOfMonthField
        ] })
      ] }) }) })
    ] })
  ) : (
    // No renewal: the first/renewal distinction is meaningless, so the fields stay
    // in one flat list — first invoice date → initial payment → frequency → day of month.
    /* @__PURE__ */ jsxs7(SpaceBetween5, { size: "l", children: [
      firstInvoiceDateField,
      initialPaymentField,
      frequencyField,
      dayOfMonthField
    ] })
  ) }) });
};

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/PaymentSchedulePreviewTable.tsx
import Box5 from "@amzn/awsui-components-react/polaris/box";
import Container6 from "@amzn/awsui-components-react/polaris/container";
import Header6 from "@amzn/awsui-components-react/polaris/header";
import KeyValuePairs from "@amzn/awsui-components-react/polaris/key-value-pairs";
import SpaceBetween6 from "@amzn/awsui-components-react/polaris/space-between";
import Table from "@amzn/awsui-components-react/polaris/table";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var EMPTY_CELL = "-";
var PaymentSchedulePreviewTable = ({ previewState, currencyCode, contractTotalDisplay, t }) => {
  const rows = previewState.kind === "rows" ? previewState.rows : previewState.kind === "placeholder" ? Array.from({ length: Math.max(previewState.rowCount, 1) }, (_, i) => ({ paymentNumber: i + 1, chargeAmount: "", chargeDate: "" })) : [];
  return /* @__PURE__ */ jsx9(
    Container6,
    {
      header: /* @__PURE__ */ jsx9(Header6, { variant: "h2", description: t("paymentSchedulePreviewDescription"), children: t("paymentSchedulePreviewHeader") }),
      children: /* @__PURE__ */ jsxs8(SpaceBetween6, { size: "l", children: [
        /* @__PURE__ */ jsx9(KeyValuePairs, { columns: 1, items: [{ label: t("contractTotalUsd"), value: contractTotalDisplay }] }),
        /* @__PURE__ */ jsx9("div", { "data-testid": "edit-installment-plan-table", children: /* @__PURE__ */ jsx9(
          Table,
          {
            variant: "embedded",
            columnDefinitions: [
              { id: "n", header: t("installmentNumberColumn"), cell: (item) => item.paymentNumber ?? EMPTY_CELL },
              {
                id: "amount",
                header: t("paymentAmountUsdColumn"),
                // chargeAmount is a numeric string; fall back to "-" when it is empty
                // or non-numeric (placeholder rows, or an incomplete real row).
                cell: (item) => item.chargeAmount && !Number.isNaN(Number(item.chargeAmount)) ? formatCurrency(item.chargeAmount, currencyCode) : EMPTY_CELL
              },
              {
                id: "date",
                header: t("invoiceDateColumn"),
                // chargeDate is a "YYYY-MM-DD" string; fall back to "-" when empty.
                cell: (item) => item.chargeDate ? formatChargeDate(item.chargeDate) : EMPTY_CELL
              }
            ],
            items: rows,
            empty: (
              // Only reached in the "prompt" state (no frequency chosen): "rows" has
              // real rows and "placeholder" always renders ≥1 row, so this empty slot
              // renders solely before a frequency is chosen.
              /* @__PURE__ */ jsx9(Box5, { textAlign: "center", color: "text-body-secondary", children: /* @__PURE__ */ jsx9("i", { children: t("paymentSchedulePreviewEmpty") }) })
            )
          }
        ) })
      ] })
    }
  );
};

// src/aipo/GetOffer/components/RenewalInstallmentPlanPreview/RenewalInstallmentPlanPreview.tsx
import Box6 from "@amzn/awsui-components-react/polaris/box";
import Container7 from "@amzn/awsui-components-react/polaris/container";
import Header7 from "@amzn/awsui-components-react/polaris/header";
import KeyValuePairs2 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link5 from "@amzn/awsui-components-react/polaris/link";
import SpaceBetween7 from "@amzn/awsui-components-react/polaris/space-between";
import Table2 from "@amzn/awsui-components-react/polaris/table";
import { useAppTranslation as useAppTranslation2 } from "@amzn/awsmp-max-translations";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG4 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var RenewalInstallmentPlanPreview = ({
  renewalCycleTotal,
  priceUplift,
  priceUpliftRange,
  priceUpliftDefault,
  showDayOfMonthColumn,
  rows,
  openHelpPanel
}) => {
  const { t } = useAppTranslation2();
  const hasSchedule = rows.length > 0;
  const summaryItems = [
    ...priceUplift != null ? [{ label: t("renewalPriceUpliftLabel"), value: priceUplift }] : [],
    ...priceUpliftRange != null ? [{ label: t("renewalUpliftRangeLabel"), value: priceUpliftRange }] : [],
    ...priceUpliftDefault != null ? [{ label: t("renewalUpliftDefaultLabel"), value: priceUpliftDefault }] : [],
    { label: t("renewalInstallmentPreviewCycleTotalLabel"), value: renewalCycleTotal }
  ];
  const columnDefinitions = [
    { id: "installment", header: t("renewalInstallmentPreviewInstallmentColumn"), cell: (row) => row.installmentNumber },
    { id: "timing", header: t("renewalInstallmentPreviewTimingColumn"), cell: (row) => row.paymentTiming },
    ...showDayOfMonthColumn === true ? [
      {
        id: "dayOfMonth",
        header: t("renewalInstallmentPreviewDayOfMonthColumn"),
        cell: (row) => row.dayOfMonth != null ? row.dayOfMonth : "-"
      }
    ] : [],
    { id: "percent", header: t("renewalInstallmentPreviewPercentColumn"), cell: (row) => row.percentOfTotal },
    { id: "amount", header: t("renewalInstallmentPreviewAmountColumn"), cell: (row) => row.amount }
  ];
  const infoLink = openHelpPanel ? /* @__PURE__ */ jsx10(
    Link5,
    {
      variant: "info",
      ariaLabel: t("infoAriaLabel", { section: t("renewalInstallmentPreviewHeader") }),
      onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG4.BUYER_CONFIGURE_INSTALLMENT_PLAN_RENEWAL_PREVIEW),
      children: t("info")
    }
  ) : void 0;
  return /* @__PURE__ */ jsx10(
    Container7,
    {
      header: /* @__PURE__ */ jsx10(Header7, { variant: "h2", info: infoLink, description: t("renewalInstallmentPreviewIntro"), children: t("renewalInstallmentPreviewHeader") }),
      children: /* @__PURE__ */ jsx10(SpaceBetween7, { size: "l", children: hasSchedule ? /* @__PURE__ */ jsxs9(Fragment2, { children: [
        /* @__PURE__ */ jsx10(KeyValuePairs2, { columns: 2, items: summaryItems }),
        /* @__PURE__ */ jsx10(
          Table2,
          {
            variant: "embedded",
            wrapLines: true,
            columnDefinitions,
            items: rows
          }
        )
      ] }) : /* @__PURE__ */ jsx10(Box6, { textAlign: "center", color: "text-body-secondary", children: /* @__PURE__ */ jsx10("i", { children: t("renewalInstallmentPreviewEmpty") }) }) })
    }
  );
};

// src/aipo/GetOffer/components/RenewalInstallmentPlanPreview/renewalCycleSchedule.ts
var import_payment_schedule = __toESM(require_payment_schedule(), 1);
var monthsFromOffset = (chargeDateOffset) => {
  const match2 = /^P(\d+)M$/.exec(chargeDateOffset);
  if (match2 === null) {
    throw new Error(`Unexpected renewal charge-date offset: ${chargeDateOffset}`);
  }
  return Number(match2[1]);
};
var paymentTimingLabel = (months2, t) => months2 === 0 ? t("renewalInstallmentPreviewTimingStart") : t("renewalInstallmentPreviewTimingAfterStart", { count: months2, months: months2 });
var deriveRenewalCycleSchedule = (args) => {
  const { frequency, durationISO, markedUpTotal, t, currencyCode, dayOfMonth } = args;
  const template = frequency !== void 0 && durationISO !== void 0 && durationISO !== "" ? (0, import_payment_schedule.deriveRenewalTermTemplate)({ frequency, durationISO, dayOfMonth }) : [];
  const { totalAmount: renewalCycleTotal, chargeAmounts } = (0, import_payment_schedule.distributeCharges)({
    total: markedUpTotal,
    currencyCode,
    percentages: template.map((entry) => entry.chargePercentage)
  });
  const rows = template.map((entry, index) => {
    const months2 = monthsFromOffset(entry.chargeDateOffset);
    return {
      installmentNumber: index + 1,
      paymentTiming: paymentTimingLabel(months2, t),
      dayOfMonth: months2 === 0 ? void 0 : entry.dayOfMonth,
      percentOfTotal: t("renewalInstallmentPreviewPercentValue", { percent: entry.chargePercentage }),
      amount: formatCurrency(chargeAmounts[index], currencyCode)
    };
  });
  return { rows, renewalCycleTotal };
};
var deriveRenewalCycleTimingRows = (args) => {
  const { frequency, durationISO, t, dayOfMonth } = args;
  const template = frequency !== void 0 && durationISO !== void 0 && durationISO !== "" ? (0, import_payment_schedule.deriveRenewalTermTemplate)({ frequency, durationISO, dayOfMonth }) : [];
  return template.map((entry, index) => ({
    installmentNumber: index + 1,
    paymentTiming: paymentTimingLabel(monthsFromOffset(entry.chargeDateOffset), t),
    dayOfMonth: entry.dayOfMonth,
    percentOfTotal: t("renewalInstallmentPreviewPercentValue", { percent: entry.chargePercentage })
  }));
};

// src/aipo/GetOffer/components/ConfigurePaymentPlanPage/ConfigurePaymentPlanPage.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var renewalUpliftKvps = (priceIncrease, t) => {
  if (priceIncrease === void 0)
    return {};
  const uplift = renewalUpliftValues(priceIncrease, t);
  switch (uplift.kind) {
    case "fixed":
      return { priceUplift: uplift.percent };
    case "range":
      return { priceUpliftRange: uplift.range, priceUpliftDefault: uplift.default };
    case "none":
    case "unknown":
      return {};
    default: {
      const _exhaustive = uplift;
      throw new Error(`Unhandled renewal uplift kind: ${String(_exhaustive)}`);
    }
  }
};
var ConfigurePaymentPlanPage = ({
  t,
  currencyCode,
  renewalCyclePreview,
  helpPanelsEnabled,
  openHelpPanel,
  ...formArgs
}) => {
  const model = usePaymentPlanForm({ ...formArgs, t, currencyCode });
  const baseDayOfMonth = model.dayOfMonth.trim() !== "" && model.dayOfMonthError === void 0 ? Number(model.dayOfMonth) : void 0;
  const renewalCycleResult = React.useMemo(() => {
    if (renewalCyclePreview == null)
      return {};
    try {
      return {
        cycle: deriveRenewalCycleSchedule({
          frequency: model.paymentFrequency,
          durationISO: model.durationISO,
          // Consume the backend's marked-up renewal-cycle total rather than re-applying the
          // uplift on the client, so the preview bills to the cent what the generated offer
          // will; the rows are distributed from this backend total.
          markedUpTotal: renewalCyclePreview.illustrativeTotalContractValue,
          t,
          currencyCode,
          dayOfMonth: baseDayOfMonth
        }),
        uplift: renewalUpliftKvps(renewalCyclePreview.priceIncrease, t)
      };
    } catch (error) {
      return { error: error instanceof Error ? error : new Error(String(error)) };
    }
  }, [renewalCyclePreview, model.paymentFrequency, model.durationISO, baseDayOfMonth, currencyCode, t]);
  const renewalCycle = renewalCycleResult.cycle;
  const renewalUplift = renewalCycleResult.uplift ?? {};
  const renewalDerivationError = renewalCycleResult.error;
  const { logger } = formArgs;
  React.useEffect(() => {
    if (renewalDerivationError == null)
      return;
    logger.error("Renewal installment-plan preview derivation failed; suppressing preview", renewalDerivationError);
    logger.opsMetric({ metricName: CustomOpsMetricName.EPOBuyerRenewalPreviewDerivationFailure, unit: "Count", value: 1 });
  }, [renewalDerivationError, logger]);
  return /* @__PURE__ */ jsx11("div", { "data-testid": "edit-installment-plan-page", children: /* @__PURE__ */ jsxs10(
    ContentLayout,
    {
      header: /* @__PURE__ */ jsx11(
        Header8,
        {
          variant: "h1",
          description: t("editInstallmentPlanDescription"),
          info: openHelpPanel ? /* @__PURE__ */ jsx11(
            Link6,
            {
              variant: "info",
              ariaLabel: t("infoAriaLabel", { section: t("editInstallmentPlanTitle") }),
              onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG5.BUYER_CONFIGURE_INSTALLMENT_PLAN),
              children: t("info")
            }
          ) : void 0,
          children: t("editInstallmentPlanTitle")
        }
      ),
      children: [
        /* @__PURE__ */ jsxs10(Grid, { gridDefinition: [{ colspan: { default: 12, s: 4 } }, { colspan: { default: 12, s: 8 } }], children: [
          /* @__PURE__ */ jsx11(PaymentPlanForm, { model, t, hasRenewal: helpPanelsEnabled === true && renewalCycle != null }),
          renewalCycle != null ? /* @__PURE__ */ jsxs10(SpaceBetween8, { size: "l", children: [
            /* @__PURE__ */ jsx11(
              PaymentSchedulePreviewTable,
              {
                previewState: model.previewState,
                currencyCode,
                contractTotalDisplay: model.contractTotalDisplay,
                t
              }
            ),
            /* @__PURE__ */ jsx11(
              RenewalInstallmentPlanPreview,
              {
                renewalCycleTotal: formatCurrency(renewalCycle.renewalCycleTotal, currencyCode),
                priceUplift: renewalUplift.priceUplift,
                priceUpliftRange: renewalUplift.priceUpliftRange,
                priceUpliftDefault: renewalUplift.priceUpliftDefault,
                showDayOfMonthColumn: baseDayOfMonth !== void 0,
                rows: renewalCycle.rows,
                openHelpPanel
              }
            )
          ] }) : /* @__PURE__ */ jsx11(
            PaymentSchedulePreviewTable,
            {
              previewState: model.previewState,
              currencyCode,
              contractTotalDisplay: model.contractTotalDisplay,
              t
            }
          )
        ] }),
        /* @__PURE__ */ jsx11(Box7, { float: "right", margin: { top: "l" }, children: /* @__PURE__ */ jsxs10(SpaceBetween8, { direction: "horizontal", size: "xs", children: [
          /* @__PURE__ */ jsx11("div", { "data-testid": "edit-installment-plan-cancel", children: /* @__PURE__ */ jsx11(Button3, { variant: "link", onClick: model.onCancelClick, children: t("cancelButton") }) }),
          /* @__PURE__ */ jsx11("div", { "data-testid": "edit-installment-plan-save", children: /* @__PURE__ */ jsx11(Button3, { variant: "primary", disabled: model.generateDisabled, loading: formArgs.isGeneratingOffer, onClick: model.onGenerateClick, children: t("generateOffer") }) })
        ] }) })
      ]
    }
  ) });
};

// src/aipo/GetOffer/components/AssessmentStep/AssessmentStep.tsx
import { useCallback as useCallback5 } from "react";
import Container8 from "@amzn/awsui-components-react/polaris/container";
import SpaceBetween9 from "@amzn/awsui-components-react/polaris/space-between";
import FormField4 from "@amzn/awsui-components-react/polaris/form-field";
import Textarea from "@amzn/awsui-components-react/polaris/textarea";
import { jsx as jsx12 } from "react/jsx-runtime";
var AssessmentStep = ({ errors, clearFieldError, writeableArtifact, isArtifactLocked, logger, t }) => {
  const { artifact, setArtifact } = writeableArtifact;
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.ASSESSMENT);
  const qualificationResponses = artifact.offerRequest.qualificationResponses || [];
  const updateResponse = (index, value) => {
    const truncatedValue = value.slice(0, 1e3);
    const updatedResponses = qualificationResponses.map((item, i) => i === index ? { ...item, response: truncatedValue } : item);
    setArtifact((prevArtifact) => ({
      ...prevArtifact,
      offerRequest: {
        ...prevArtifact.offerRequest,
        qualificationResponses: updatedResponses
      }
    }));
  };
  const onQuestionBlur = useCallback5(
    (index) => {
      if (errors?.[`${index}`]) {
        clearFieldError(`${index}`);
      }
    },
    [errors, clearFieldError]
  );
  return /* @__PURE__ */ jsx12(Container8, { "data-testid": "step3-assessment-root", children: /* @__PURE__ */ jsx12(SpaceBetween9, { size: "l", children: qualificationResponses.map((item, index) => /* @__PURE__ */ jsx12(
    FormField4,
    {
      label: item.question,
      errorText: errors?.[`${index}`],
      constraintText: t("characterCountGetOffer", { count: item.response.length }),
      "data-testid": `getOfferAssessmentFormField${index}`,
      children: /* @__PURE__ */ jsx12(
        Textarea,
        {
          value: item.response,
          onChange: ({ detail }) => updateResponse(index, detail.value),
          onBlur: () => onQuestionBlur(index),
          placeholder: item._exampleResponse,
          rows: 3,
          disabled: isArtifactLocked
        }
      )
    },
    index
  )) }) });
};

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.tsx
import SpaceBetween10 from "@amzn/awsui-components-react/polaris/space-between";
import Container9 from "@amzn/awsui-components-react/polaris/container";
import Header9 from "@amzn/awsui-components-react/polaris/header";
import Button4 from "@amzn/awsui-components-react/polaris/button";
import KeyValuePairs3 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link7 from "@amzn/awsui-components-react/polaris/link";
import Box8 from "@amzn/awsui-components-react/polaris/box";
import { ManagedTable as ManagedTable2 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG6 } from "@amzn/awsmp-max-agentic-renderer-interface";

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.module.css
var ReviewOfferStep_default = {
  sectionHeader: "ReviewOfferStep_sectionHeader",
  nowrap: "ReviewOfferStep_nowrap"
};

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.tsx
import { PAYMENT_METHOD as PAYMENT_METHOD3 } from "@amzn/awsmp-max-model";

// src/aipo/GetOffer/leadCapture/types.ts
var EMPTY_LEAD_IDENTITY = {
  firstName: "",
  lastName: "",
  email: "",
  company: "",
  phone: "",
  country: "",
  state: "",
  postalCode: ""
};

// src/aipo/GetOffer/leadCapture/validation.ts
var import_isEmail = __toESM(require_isEmail(), 1);
var MIN_PHONE_DIGITS = 7;
var MAX_PHONE_DIGITS = 15;
var REQUIRED_FIELDS = ["firstName", "lastName", "email", "company", "phone", "country", "postalCode"];
var digitsOnly = (value) => value.replace(/\D/g, "");
var FIELD_VALIDATORS = {
  email: (value) => (0, import_isEmail.default)(value) ? void 0 : "invalidEmail",
  phone: (value) => {
    const digits = digitsOnly(value);
    if (digits.length < MIN_PHONE_DIGITS || digits.length > MAX_PHONE_DIGITS)
      return "invalidPhone";
    return void 0;
  }
  // Country/Region has no format validator: it is a Cloudscape Select constrained
  // to the live Marketo option list, so the buyer can only pick a valid entry —
  // the required-non-empty check above is the only gate it needs. The label→ISO
  // code the Marketo field wants is resolved from the live options at submit.
};
function validateLeadCapture(state, stateRequired) {
  const errors = {};
  const requiredFields = stateRequired ? [...REQUIRED_FIELDS, "state"] : REQUIRED_FIELDS;
  requiredFields.forEach((field) => {
    const value = state.identity[field].trim();
    if (value.length === 0) {
      errors[field] = "required";
      return;
    }
    const formatError = FIELD_VALIDATORS[field]?.(value);
    if (formatError)
      errors[field] = formatError;
  });
  return errors;
}
function isLeadCaptureComplete(state, stateRequired) {
  return Object.keys(validateLeadCapture(state, stateRequired)).length === 0;
}
function isLeadIdentityComplete(identity) {
  return isLeadCaptureComplete({ identity }, false);
}

// src/aipo/GetOffer/leadCapture/leadCaptureUtils.ts
import { OFFER_ELIGIBILITY } from "@amzn/awsmp-max-model";
function isStateFieldShown(stateOptions) {
  return stateOptions.length > 0;
}
function leadIdentityKeyValuePairs(t, identity) {
  return [
    { label: t("leadBusinessEmailLabel"), value: identity.email },
    { label: t("leadFirstNameLabel"), value: identity.firstName },
    { label: t("leadLastNameLabel"), value: identity.lastName },
    { label: t("leadPhoneLabel"), value: identity.phone },
    { label: t("leadCompanyLabel"), value: identity.company },
    { label: t("leadCountryLabel"), value: identity.country },
    ...identity.state ? [{ label: t("leadStateProvinceLabel"), value: identity.state }] : [],
    { label: t("leadPostalCodeLabel"), value: identity.postalCode }
  ];
}
function toEpoLeadStatus(offer) {
  if (offer?.eligibility === OFFER_ELIGIBILITY.ELIGIBLE)
    return "epo-created";
  if (offer?.eligibility === OFFER_ELIGIBILITY.INELIGIBLE)
    return "epo-not-qualified";
  return "epo-started";
}
function toRequestedDimensions(selections) {
  return (selections ?? []).map((d) => ({ dimensionKey: d.dimensionKey, quantity: d.quantity }));
}
function parseAwsAccountId(cookieString) {
  const match2 = cookieString.match(/aws-userInfo=([^;]+)/);
  if (!match2)
    return void 0;
  try {
    const decoded = decodeURIComponent(match2[1]);
    const parsed = JSON.parse(decoded);
    if (typeof parsed !== "object" || parsed === null || !("arn" in parsed))
      return void 0;
    const arn = parsed.arn;
    if (typeof arn !== "string")
      return void 0;
    const accountId = arn.split(":")[4];
    return accountId && /^\d{12}$/.test(accountId) ? accountId : void 0;
  } catch {
    return void 0;
  }
}
function buildReconciliationBlob(args) {
  const blob = {
    epoStatus: args.status,
    requestedDimensions: toRequestedDimensions(args.dimensions)
  };
  if (args.awsAccountId)
    blob.awsAccountId = args.awsAccountId;
  return blob;
}
function selectFailureMetric(reason, status) {
  switch (reason) {
    case "validation":
      return CustomOpsMetricName.EPOBuyerLeadValidationFailure;
    case "form-not-ready":
      return CustomOpsMetricName.EPOBuyerLeadSubmitNotReady;
    case "observer":
      return status === "epo-started" ? CustomOpsMetricName.EPOBuyerLeadSubmitFailure : CustomOpsMetricName.EPOBuyerLeadTerminalSubmitFailure;
    case "unknown":
      return CustomOpsMetricName.EPOBuyerLeadSubmitFailure;
  }
}
function toMarketoFieldValues(args) {
  const { identity, countryValue, stateValue, campaignId, blob } = args;
  return {
    Email: identity.email,
    FirstName: identity.firstName,
    LastName: identity.lastName,
    Phone: identity.phone,
    Company: identity.company,
    zOPprogressiveprofilingcntry: countryValue,
    zOPprogressiveprofilingsprov: stateValue,
    zOPprogressiveprofilingpcode: identity.postalCode,
    Compliance_Optin__c: "",
    Decanter_SFDC_Campaign_ID: campaignId,
    Project_Description__c: JSON.stringify(blob)
  };
}

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.tsx
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var DEFAULT_EDITABLE_STEP_NUMBERS = {
  lead: 1,
  units: 1,
  contractNeeds: 2,
  assessment: 3
};
var ReviewOfferStep = ({
  onEditStep,
  writeableArtifact,
  isArtifactLocked,
  logger,
  buyerOptions,
  t,
  fpsEnabled = false,
  editableStepNumbers = DEFAULT_EDITABLE_STEP_NUMBERS,
  leadIdentity = EMPTY_LEAD_IDENTITY,
  openHelpPanel
}) => {
  const { artifact } = writeableArtifact;
  const paymentMethod = artifact.offerRequest.paymentMethod ?? PAYMENT_METHOD3.UPFRONT;
  const showYourDetails = isLeadIdentityComplete(leadIdentity);
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.REVIEW);
  const dimensionMap = new Map(buyerOptions.configurableUpfrontPricingTerms.rateCards.map((card) => [card.dimensionKey, card]));
  const dimensionTableItems = artifact.offerRequest.configurableUpfrontDimensionSelections?.map((selection) => {
    const rateCard = dimensionMap.get(selection.dimensionKey);
    return {
      dimensionKey: selection.dimensionKey,
      displayName: rateCard?.displayName || selection.dimensionKey,
      description: rateCard?.description || t("noDescriptionProvided"),
      numberOfUnits: selection.quantity
    };
  }) ?? [];
  const formatStartDate = () => {
    if (artifact.offerRequest.futureStartDate) {
      return `${artifact.offerRequest.futureStartDate}`;
    }
    return t("startDateAcceptOfferReview");
  };
  const formatDuration = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    return duration.slice(1, -1);
  };
  const formatUnit = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    const unit = duration[duration.length - 1];
    return unit === "D" ? t("days") : unit === "M" ? t("months") : t("years");
  };
  const contractSummary = fpsEnabled ? (
    // FPS layout: separate containers for duration/start date, payment
    // preferences, and the EULA (vs. the non-FPS single merged container).
    /* @__PURE__ */ jsxs11(SpaceBetween10, { size: "l", children: [
      /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("contractStartDateAndDuration") }), children: /* @__PURE__ */ jsxs11(SpaceBetween10, { size: "m", children: [
        /* @__PURE__ */ jsx13(
          KeyValuePairs3,
          {
            columns: 2,
            items: [
              { label: t("duration"), value: formatDuration() || t("notSet") },
              { label: t("unitOfTime"), value: formatUnit() || t("notSet") }
            ]
          }
        ),
        /* @__PURE__ */ jsx13(KeyValuePairs3, { columns: 1, items: [{ label: t("contractStartDate"), value: formatStartDate() }] })
      ] }) }),
      /* @__PURE__ */ jsx13(
        Container9,
        {
          header: /* @__PURE__ */ jsx13(
            Header9,
            {
              info: openHelpPanel ? /* @__PURE__ */ jsx13(
                Link7,
                {
                  variant: "info",
                  ariaLabel: t("infoAriaLabel", { section: t("paymentPreferencesHeader") }),
                  onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG6.BUYER_OFFER_PREVIEW_PAYMENT_DETAILS),
                  children: t("info")
                }
              ) : void 0,
              children: t("paymentPreferencesHeader")
            }
          ),
          "data-testid": "review-payment-preferences-container",
          children: /* @__PURE__ */ jsx13(
            KeyValuePairs3,
            {
              columns: 3,
              "data-testid": "review-payment-preferences-keyvaluepairs",
              items: [
                {
                  label: t("paymentMethod"),
                  value: /* @__PURE__ */ jsx13("span", { "data-testid": "review-payment-method", children: paymentMethod === PAYMENT_METHOD3.INSTALLMENTS ? t("payInInstallments") : t("payInFull") })
                }
              ]
            }
          )
        }
      ),
      /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("eulaHeader") }), "data-testid": "review-eula-container", children: /* @__PURE__ */ jsx13(Link7, { href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") }) })
    ] })
  ) : (
    // Non-FPS layout (unchanged): contract duration/start date and the
    // EULA share a single container.
    /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("contractStartDateAndDuration") }), children: /* @__PURE__ */ jsxs11(SpaceBetween10, { size: "m", children: [
      /* @__PURE__ */ jsx13(
        KeyValuePairs3,
        {
          columns: 2,
          items: [
            { label: t("duration"), value: formatDuration() || t("notSet") },
            { label: t("unitOfTime"), value: formatUnit() || t("notSet") }
          ]
        }
      ),
      /* @__PURE__ */ jsx13(
        KeyValuePairs3,
        {
          columns: 1,
          items: [
            { label: t("contractStartDate"), value: formatStartDate() },
            {
              label: t("eulaHeader"),
              value: /* @__PURE__ */ jsx13(Link7, { href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") })
            }
          ]
        }
      )
    ] }) })
  );
  return /* @__PURE__ */ jsx13("div", { "data-testid": "step4-review-offer-root", children: /* @__PURE__ */ jsxs11(SpaceBetween10, { size: "l", children: [
    showYourDetails && /* @__PURE__ */ jsxs11("div", { "data-testid": "review-your-details-container", children: [
      /* @__PURE__ */ jsxs11("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx13("h3", { children: t("contactInformationStepTitle", { number: editableStepNumbers.lead }) }),
        /* @__PURE__ */ jsx13(Button4, { variant: "normal", "data-testid": "review-your-details-edit", onClick: () => onEditStep("lead"), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("contactInformationHeader") }), children: /* @__PURE__ */ jsx13(KeyValuePairs3, { columns: 2, items: leadIdentityKeyValuePairs(t, leadIdentity) }) })
    ] }),
    /* @__PURE__ */ jsxs11("div", { children: [
      /* @__PURE__ */ jsxs11("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx13("h3", { children: t("unitsStepTitle", { number: editableStepNumbers.units }) }),
        /* @__PURE__ */ jsx13(Button4, { variant: "normal", onClick: () => onEditStep("units"), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("specifiedDimensions") }), children: /* @__PURE__ */ jsx13(
        ManagedTable2,
        {
          hidePreferences: true,
          preferenceKey: "review-dimensions-table",
          defaultPreferences: {
            contentDensity: "compact",
            pageSize: 10
          },
          columnDefinitions: [
            {
              id: "dimension",
              header: /* @__PURE__ */ jsx13(Box8, { display: "inline", className: ReviewOfferStep_default.nowrap, children: t("dimension") }),
              cell: (item) => item.displayName,
              // Just wide enough for the header + typical dimension names; the
              // nowrap header prevents wrapping at this width.
              width: 180,
              minWidth: 160
            },
            {
              id: "description",
              header: t("description"),
              cell: (item) => item.description,
              // Description takes the remaining space so the long paragraph
              // wraps in few lines while the two side columns stay compact.
              minWidth: 320
            },
            {
              id: "units",
              header: /* @__PURE__ */ jsx13(Box8, { display: "inline", className: ReviewOfferStep_default.nowrap, children: t("numberOfUnits") }),
              cell: (item) => (item.numberOfUnits ?? 0).toString(),
              // Read-only number; size to the "Number of units" header only.
              width: 150,
              minWidth: 140
            }
          ],
          items: dimensionTableItems,
          pagination: {},
          variant: "embedded",
          trackBy: "dimensionKey"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs11("div", { children: [
      /* @__PURE__ */ jsxs11("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx13("h3", { children: t("contractNeedsStepTitle", { number: editableStepNumbers.contractNeeds }) }),
        /* @__PURE__ */ jsx13(Button4, { variant: "normal", onClick: () => onEditStep("contractNeeds"), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      buyerOptions.renewalTerms != null ? /* @__PURE__ */ jsxs11(SpaceBetween10, { size: "l", children: [
        contractSummary,
        /* @__PURE__ */ jsx13(
          RenewalTermsContainer,
          {
            renewalTerms: buyerOptions.renewalTerms,
            openHelpPanel,
            helpPathslug: HELP_PANEL_PATHSLUG6.BUYER_OFFER_PREVIEW_RENEWAL_TERMS
          }
        )
      ] }) : contractSummary
    ] }),
    artifact.offerRequest.qualificationResponses.length > 0 && /* @__PURE__ */ jsxs11("div", { children: [
      /* @__PURE__ */ jsxs11("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx13("h3", { children: t("questionnaireStepTitle", { number: editableStepNumbers.assessment }) }),
        /* @__PURE__ */ jsx13(Button4, { variant: "normal", onClick: () => onEditStep("assessment"), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx13(Container9, { header: /* @__PURE__ */ jsx13(Header9, { children: t("questionnaire") }), children: /* @__PURE__ */ jsx13(
        KeyValuePairs3,
        {
          columns: 1,
          items: (
            /* The `|| []` side is unreachable: the enclosing block only renders when
               `qualificationResponses.length > 0`, so `?.map` always returns an array.
               The optional-chain + fallback narrow the type defensively. */
            /* v8 ignore next 4 */
            artifact.offerRequest.qualificationResponses?.map((qa) => ({
              label: qa.question,
              value: qa.response || t("noAnswerProvided")
            })) || []
          )
        }
      ) })
    ] })
  ] }) });
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.tsx
import { useEffect as useEffect2, useState as useState6 } from "react";
import SpaceBetween12 from "@amzn/awsui-components-react/polaris/space-between";
import Container12 from "@amzn/awsui-components-react/polaris/container";
import Header12 from "@amzn/awsui-components-react/polaris/header";
import Button5 from "@amzn/awsui-components-react/polaris/button";
import KeyValuePairs5 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link8 from "@amzn/awsui-components-react/polaris/link";
import Box10 from "@amzn/awsui-components-react/polaris/box";
import TextContent4 from "@amzn/awsui-components-react/polaris/text-content";
import { AppTrans as AppTrans3 } from "@amzn/awsmp-max-translations";
import { OFFER_ELIGIBILITY as OFFER_ELIGIBILITY2, PAYMENT_METHOD as PAYMENT_METHOD4 } from "@amzn/awsmp-max-model";
import { OfferPollingData } from "@amzn/awsmp-max-data";
import { marketplaceLinks as marketplaceLinks3 } from "@amzn/awsmp-max-link-catalog/browser";

// src/utils/marketplace-hosts.ts
var NEW_TLD_HOSTS = ["marketplace.aws.com", "awsmp-preprod.aws.com", "awsmp-integ.aws.com"];

// src/aipo/GetOffer/utils/auth-utils.ts
var USER_INFO_SIGNED_COOKIE_NAME = "aws-userInfo-signed";
var MAX_FRAGMENT_OVERRIDE_QUERY_PARAM = "awsmpMaxFragmentOverride";
function parseCookie(cookieName, cookieString) {
  const cookie = cookieString.match(`${cookieName}=([^;]*)`);
  if (!cookie || !cookie[1]) {
    return void 0;
  }
  return cookie[1];
}
function isAuthenticated() {
  return !!parseCookie(USER_INFO_SIGNED_COOKIE_NAME, document.cookie);
}
function isAuthenticationError(error) {
  return typeof error === "object" && error !== null && "name" in error && error.name === "AuthenticationError";
}
async function epoBuyerSignIn(props) {
  return clientSideSignIn({
    hashRoute: "epo/offer",
    hashQueryParams: props
  });
}
async function epoSellerSignIn() {
  return clientSideSignIn({
    hashRoute: "epo",
    hashQueryParams: {}
  });
}
function resolveSignInBase() {
  const { hostname, origin } = window.location;
  if (hostname === "localhost") {
    return "https://aws.amazon.com/marketplace";
  }
  if (NEW_TLD_HOSTS.includes(hostname)) {
    return origin;
  }
  return `${origin}/marketplace`;
}
async function clientSideSignIn(props) {
  const { hashRoute, hashQueryParams } = props;
  const signInUrl = `${resolveSignInBase()}/login`;
  if (hashRoute.startsWith("#") || hashRoute.startsWith("/")) {
    throw new Error(`Client-side sign in: HashRoute must not start with # or /. Passed hashRoute was: ${hashRoute}`);
  }
  if (hashRoute.includes("#") || hashRoute.includes("%")) {
    throw new Error(`Client-side sign in: HashRoute cannot include # or % characters. Passed hashRoute was: ${hashRoute}`);
  }
  const searchParams = new URLSearchParams();
  let setQuery = false;
  for (const searchParamKey of Object.keys(hashQueryParams)) {
    searchParams.set(searchParamKey, hashQueryParams[searchParamKey]);
    setQuery = true;
  }
  const hashPath = setQuery ? `${hashRoute}?${searchParams.toString()}` : hashRoute;
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set(MAX_FRAGMENT_OVERRIDE_QUERY_PARAM, encodeURIComponent(hashPath));
  window.history.replaceState({}, "", currentUrl.toString());
  window.location.href = signInUrl;
  await new Promise((resolve) => setTimeout(resolve, 6e4));
}

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.tsx
import Container10 from "@amzn/awsui-components-react/polaris/container";

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.module.css
var HeroContainer_default = {
  heroLayout: "HeroContainer_heroLayout",
  imageSection: "HeroContainer_imageSection",
  heroImage: "HeroContainer_heroImage",
  contentSection: "HeroContainer_contentSection"
};

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.tsx
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var HeroContainer = ({ imageSrc, imageAlt, children, imageWidthPx, imageHeightPx }) => {
  const imageStyle = {
    ...imageWidthPx !== void 0 && { width: `${imageWidthPx}px` },
    ...imageHeightPx !== void 0 && { height: `${imageHeightPx}px` }
  };
  return /* @__PURE__ */ jsx14(Container10, { children: /* @__PURE__ */ jsxs12("div", { className: HeroContainer_default.heroLayout, children: [
    /* @__PURE__ */ jsx14("div", { className: HeroContainer_default.imageSection, children: /* @__PURE__ */ jsx14("img", { src: imageSrc, alt: imageAlt, className: HeroContainer_default.heroImage, style: Object.keys(imageStyle).length > 0 ? imageStyle : void 0 }) }),
    /* @__PURE__ */ jsx14("div", { className: HeroContainer_default.contentSection, children })
  ] }) });
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.module.css
var SuccessPage_default = {
  largePrice: "SuccessPage_largePrice",
  nowrap: "SuccessPage_nowrap"
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.tsx
import { ManagedTable as ManagedTable3 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";

// src/aipo/GetOffer/components/SuccessPage/ReviewInstallmentPlanContainer.tsx
import Header10 from "@amzn/awsui-components-react/polaris/header";
import Table3 from "@amzn/awsui-components-react/polaris/table";
import { jsx as jsx15 } from "react/jsx-runtime";
var ReviewInstallmentPlanContainer = ({
  t,
  writeableArtifact,
  generateInstallmentSchedule,
  scheduleAnchorDate,
  contractTotal,
  currencyCode
}) => {
  const { artifact } = writeableArtifact;
  const rows = generateInstallmentSchedule({
    ...readFpsScheduleInputs(artifact),
    durationISO: artifact.offerRequest.duration,
    total: contractTotal,
    anchorDate: scheduleAnchorDate
  });
  if (rows === null) {
    return null;
  }
  return /* @__PURE__ */ jsx15("div", { "data-testid": "review-installment-plan-container", children: /* @__PURE__ */ jsx15("div", { "data-testid": "review-installment-plan-table", children: /* @__PURE__ */ jsx15(
    Table3,
    {
      variant: "embedded",
      header: /* @__PURE__ */ jsx15(Header10, { variant: "h3", description: t("installmentPlanDescription"), children: t("installmentPlanHeader") }),
      columnDefinitions: [
        // Constrain the payment-number column to its content: the values are
        // 1-2 digit integers, so the "Payment number" header is the widest
        // element. width + minWidth (per Cloudscape "set width/minWidth based
        // on content length") keep it snug instead of taking a third of the
        // table; date/amount take the remaining space.
        { id: "n", header: t("paymentNumberColumn"), cell: (item) => item.paymentNumber, width: 120, minWidth: 120 },
        { id: "date", header: t("invoiceDateColumn"), cell: (item) => formatChargeDate(item.chargeDate) },
        { id: "amount", header: t("amountUsdColumn"), cell: (item) => formatCurrency(item.chargeAmount, currencyCode) }
      ],
      items: rows
    }
  ) }) });
};

// src/aipo/GetOffer/components/SuccessPage/SuccessRenewalTermsCard.tsx
import Box9 from "@amzn/awsui-components-react/polaris/box";
import Container11 from "@amzn/awsui-components-react/polaris/container";
import Header11 from "@amzn/awsui-components-react/polaris/header";
import KeyValuePairs4 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import SpaceBetween11 from "@amzn/awsui-components-react/polaris/space-between";
import Table4 from "@amzn/awsui-components-react/polaris/table";
import { AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx16, jsxs as jsxs13 } from "react/jsx-runtime";
var SuccessRenewalTermsCard = ({ renewalTerms, t, paymentFrequency, durationISO, dayOfMonth }) => {
  let rows;
  try {
    rows = toRenewalSummaryRows(renewalTerms, t);
  } catch {
    return null;
  }
  if (rows.length === 0)
    return null;
  let timingRows = [];
  try {
    timingRows = deriveRenewalCycleTimingRows({ frequency: paymentFrequency, durationISO, t, dayOfMonth });
  } catch {
    timingRows = [];
  }
  const showDayOfMonthColumn = dayOfMonth !== void 0;
  const previewIntro = /* @__PURE__ */ jsx16(AppTrans2, { i18nKey: "renewalTermsPreviewIntro", children: /* @__PURE__ */ jsx16(Box9, { variant: "strong", display: "inline", children: "Manage Subscriptions" }) });
  return /* @__PURE__ */ jsx16(
    Container11,
    {
      header: /* @__PURE__ */ jsx16(Header11, { variant: "h2", description: previewIntro, children: t("renewalTermsHeader") }),
      "data-testid": "success-renewal-terms-container",
      children: /* @__PURE__ */ jsxs13(SpaceBetween11, { size: "l", children: [
        /* @__PURE__ */ jsx16(KeyValuePairs4, { columns: 3, items: rows.map((row) => ({ label: t(row.labelKey), value: row.value })) }),
        timingRows.length > 0 && paymentFrequency !== void 0 && /* @__PURE__ */ jsxs13(SpaceBetween11, { size: "s", children: [
          /* @__PURE__ */ jsx16(Header11, { variant: "h3", description: t("renewalInstallmentPlanPreviewIntro"), children: t("renewalInstallmentPlan") }),
          /* @__PURE__ */ jsx16(
            KeyValuePairs4,
            {
              columns: 1,
              items: [{ label: t("renewalInstallmentPreviewFrequencyLabel"), value: frequencyLabel(paymentFrequency, t) }]
            }
          ),
          /* @__PURE__ */ jsx16(
            Table4,
            {
              variant: "embedded",
              "data-testid": "success-renewal-installment-table",
              ariaLabels: { tableLabel: t("renewalInstallmentPlan") },
              columnDefinitions: [
                { id: "installment", header: t("renewalInstallmentPreviewInstallmentColumn"), cell: (row) => row.installmentNumber },
                { id: "timing", header: t("renewalInstallmentPreviewTimingColumn"), cell: (row) => row.paymentTiming },
                // Day-of-month column (between timing and % of total) only when the base offer set a
                // billing day; its P0M first-charge cell (no pinned day) shows "-", matching the fuller preview.
                ...showDayOfMonthColumn ? [
                  {
                    id: "dayOfMonth",
                    header: t("renewalInstallmentPreviewDayOfMonthColumn"),
                    cell: (row) => row.dayOfMonth != null ? row.dayOfMonth : "-"
                  }
                ] : [],
                { id: "percent", header: t("renewalInstallmentPreviewPercentColumn"), cell: (row) => row.percentOfTotal }
              ],
              items: timingRows
            }
          )
        ] })
      ] })
    }
  );
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.tsx
import { jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var LOADING_FLASHBAR_ID = "epo-successpage-loading-flashbar";
var SUCCESS_FLASHBAR_ID = "epo-successpage-success-flashbar";
var ERROR_FLASHBAR_ID = "epo-successpage-error-flashbar";
var SuccessPage = ({
  writeableArtifact,
  buyerOptions,
  flashbarManager,
  logger,
  withAsyncErrors,
  projectId,
  t,
  fpsEnabled = false,
  generateInstallmentSchedule,
  scheduleAnchorDate,
  contractTotal,
  leadSubmitted = false,
  leadIdentity = EMPTY_LEAD_IDENTITY
}) => {
  const { artifact } = writeableArtifact;
  const [foundOfferId, setFoundOfferId] = useState6(null);
  const showContactInfo = isLeadIdentityComplete(leadIdentity);
  const leadWasSubmitted = leadSubmitted;
  const paymentMethod = artifact.offerRequest.paymentMethod ?? PAYMENT_METHOD4.UPFRONT;
  const paymentFrequency = artifact.offerRequest.frequency;
  const renewalDayOfMonth = (() => {
    const raw = artifact.offerRequest.dayOfMonth;
    if (raw === void 0 || raw === "")
      return void 0;
    const n2 = Number(raw);
    return Number.isInteger(n2) && n2 >= 1 && n2 <= 31 ? n2 : void 0;
  })();
  const firstInvoiceDate = artifact.offerRequest.firstInstallmentDate ?? "";
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.SUCCESS);
  const offer = artifact.offer;
  const getProcurementUrl = (offerIdOverride) => {
    const baseUrl = marketplaceLinks3.get("Procurement", { productId: artifact.offerRequest.productId });
    const offerId = offerIdOverride || foundOfferId;
    return offerId ? `${baseUrl}&offerId=${offerId}` : baseUrl;
  };
  useEffect2(() => {
    if (!offer || offer.eligibility !== OFFER_ELIGIBILITY2.ELIGIBLE) {
      return;
    }
    const offerName = offer.offerTitle;
    flashbarManager.addItem({
      type: "in-progress",
      header: t("offerBeingGenerated"),
      content: /* @__PURE__ */ jsx17(TextContent4, { "data-testid": "success-page-in-progress-flashbar-content", children: /* @__PURE__ */ jsx17(
        AppTrans3,
        {
          i18nKey: "offerGenerationMessage",
          values: { offerTitle: offerName },
          components: {
            i: /* @__PURE__ */ jsx17("i", {})
          }
        }
      ) }),
      dismissible: false,
      id: LOADING_FLASHBAR_ID,
      loading: true
    });
    withAsyncErrors(
      (async () => {
        try {
          const offerPollingData = OfferPollingData.getInstance(logger);
          const { offerDetail: foundOffer, iterations } = await offerPollingData.pollUntilFound(artifact.offerRequest.productId, offerName);
          if (iterations > 1) {
            await new Promise((resolve) => setTimeout(resolve, 3e4));
          }
          setFoundOfferId(foundOffer.id);
          flashbarManager.removeItem(LOADING_FLASHBAR_ID);
          flashbarManager.removeItem(ERROR_FLASHBAR_ID);
          flashbarManager.addItem({
            type: "success",
            header: t("offerReady"),
            content: /* @__PURE__ */ jsx17(TextContent4, { "data-testid": "success-page-completed-flashbar-content", children: /* @__PURE__ */ jsx17(
              AppTrans3,
              {
                i18nKey: "offerReadyMessage",
                components: {
                  strong: /* @__PURE__ */ jsx17("strong", {}),
                  PrivateOfferPageLink: /* @__PURE__ */ jsx17(Link8, { external: true, variant: "primary", href: "https://console.aws.amazon.com/marketplace/private-offers", children: t("privateOffersPageLowercase") })
                }
              }
            ) }),
            action: /* @__PURE__ */ jsx17(
              Button5,
              {
                "data-testid": "view-accept-offer-success-flashbar",
                href: getProcurementUrl(foundOffer.id),
                target: "_blank",
                iconAlign: "right",
                iconName: "external",
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    value: 1,
                    unit: "Count",
                    dimensions: {
                      ClickFeat: "offer-ready-alert",
                      ClickAct: "accept-private-offer"
                    }
                  });
                },
                children: t("viewAndAcceptPrivateOffer")
              }
            ),
            dismissible: true,
            id: SUCCESS_FLASHBAR_ID
          });
        } catch (error) {
          if (isAuthenticationError(error)) {
            logger.info("Handling authentication error in offer polling");
            await epoBuyerSignIn({
              projectId,
              productId: artifact.offerRequest.productId,
              listingId: buyerOptions.listingId
            });
            return;
          }
          logger.error("Discovery offer polling failed", void 0, { error });
          console.error("Discovery offer polling failed", { error });
          flashbarManager.addItem({
            type: "error",
            header: t("errorCheckingOfferStatus"),
            content: t("errorCheckingOfferStatusMessage"),
            dismissible: true,
            id: ERROR_FLASHBAR_ID
          });
        }
      })()
    );
    return () => {
      flashbarManager.removeItem(LOADING_FLASHBAR_ID);
      flashbarManager.removeItem(SUCCESS_FLASHBAR_ID);
      flashbarManager.removeItem(ERROR_FLASHBAR_ID);
    };
  }, [offer, artifact.offerRequest.productId, projectId, buyerOptions.listingId]);
  const eligibleOffer = offer && offer.eligibility === OFFER_ELIGIBILITY2.ELIGIBLE ? offer : void 0;
  if (!eligibleOffer) {
    return null;
  }
  const displayPricing = {
    listPrice: eligibleOffer.listPrice,
    discountedPrice: eligibleOffer.discountedPrice,
    offerTitle: eligibleOffer.offerTitle
  };
  const formatStartDate = () => {
    if (artifact.offerRequest.futureStartDate) {
      return `${artifact.offerRequest.futureStartDate}`;
    }
    return t("dayIAcceptPrivateOffer");
  };
  const formatDuration = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    const number = duration.slice(1, -1);
    const unit = duration[duration.length - 1];
    const unitName = unit === "D" ? t("daysLowercase") : unit === "M" ? t("monthsLowercase") : t("yearsLowercase");
    return `${number} ${unitName}`;
  };
  const discountPercentage = displayPricing.listPrice && displayPricing.discountedPrice ? Math.round((displayPricing.listPrice - displayPricing.discountedPrice) / displayPricing.listPrice * 100) : 0;
  const showDiscount = discountPercentage > 0;
  const trackOfferDetailsClick = () => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: "offer-details",
        ClickAct: "accept-private-offer"
      }
    });
  };
  const trackProvideDetailsClick = () => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: "offer-details",
        ClickObj: "provide-details",
        ClickAct: "request-custom-offer"
      }
    });
  };
  const getCurrencyDisplay = () => {
    const currencyName = new Intl.DisplayNames(["en"], { type: "currency" }).of(buyerOptions.currencyCode) || buyerOptions.currencyCode;
    return `${currencyName} | ${buyerOptions.currencyCode} (${new Intl.NumberFormat("en-US", { style: "currency", currency: buyerOptions.currencyCode }).format(0).replace("0.00", "").trim()})`;
  };
  const dimensionMap = new Map(buyerOptions.configurableUpfrontPricingTerms.rateCards.map((card) => [card.dimensionKey, card]));
  const dimensionTableItems = artifact.offerRequest.configurableUpfrontDimensionSelections?.map((selection) => {
    const rateCard = dimensionMap.get(selection.dimensionKey);
    return {
      dimensionKey: selection.dimensionKey,
      displayName: rateCard?.displayName || selection.dimensionKey,
      description: rateCard?.description || t("noDescriptionProvided"),
      numberOfUnits: selection.quantity
    };
  }) ?? [];
  return /* @__PURE__ */ jsx17("div", { "data-testid": "success-page-root", children: /* @__PURE__ */ jsxs14(SpaceBetween12, { size: "l", children: [
    /* @__PURE__ */ jsx17(TextContent4, { children: /* @__PURE__ */ jsx17("h2", { children: t("congratulationsOfferDetails") }) }),
    /* @__PURE__ */ jsx17(HeroContainer, { imageSrc: human_robot_success_default, imageAlt: t("successImageAlt"), imageWidthPx: 278, children: /* @__PURE__ */ jsx17("div", { style: { paddingLeft: "20px", paddingRight: "20px" }, children: /* @__PURE__ */ jsxs14(SpaceBetween12, { size: "m", children: [
      /* @__PURE__ */ jsxs14(TextContent4, { children: [
        /* @__PURE__ */ jsx17("h3", { children: t("nextSteps") }),
        /* @__PURE__ */ jsxs14("ol", { children: [
          /* @__PURE__ */ jsx17("li", { children: /* @__PURE__ */ jsx17(
            AppTrans3,
            {
              i18nKey: showDiscount ? "reviewOfferWithDiscount" : "reviewOfferWithoutDiscount",
              components: {
                strong: /* @__PURE__ */ jsx17("strong", {})
              }
            }
          ) }),
          !leadWasSubmitted && /* @__PURE__ */ jsx17("li", { children: /* @__PURE__ */ jsx17(
            AppTrans3,
            {
              i18nKey: "shareContactDetailsComplete",
              components: {
                strong: /* @__PURE__ */ jsx17("strong", {}),
                provideInfoLink: /* @__PURE__ */ jsx17(
                  Link8,
                  {
                    variant: "primary",
                    href: marketplaceLinks3.get("RequestPrivateOffer", { listingId: buyerOptions.listingId }),
                    external: true,
                    onFollow: trackProvideDetailsClick,
                    children: t("provideInfoLinkText")
                  }
                )
              }
            }
          ) }),
          /* @__PURE__ */ jsx17("li", { children: /* @__PURE__ */ jsx17(
            AppTrans3,
            {
              i18nKey: "acceptYourOfferComplete",
              components: {
                strong: /* @__PURE__ */ jsx17("strong", {}),
                viewAcceptOfferLink: foundOfferId !== null ? /* @__PURE__ */ jsx17(Link8, { variant: "primary", href: getProcurementUrl(), external: true, onFollow: trackOfferDetailsClick, children: t("viewAcceptOfferLinkText") }) : /* @__PURE__ */ jsx17("span", { children: t("viewAcceptOfferLinkText") })
              }
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs14(SpaceBetween12, { direction: "horizontal", size: "s", children: [
        !leadWasSubmitted && /* @__PURE__ */ jsx17(
          Button5,
          {
            "data-testid": "provide-details-button",
            variant: "normal",
            href: marketplaceLinks3.get("RequestPrivateOffer", { listingId: buyerOptions.listingId }),
            target: "_blank",
            iconAlign: "right",
            iconName: "external",
            onClick: trackProvideDetailsClick,
            children: t("provideMyDetails")
          }
        ),
        /* @__PURE__ */ jsx17(
          Button5,
          {
            "data-testid": "view-accept-offer-button",
            variant: "primary",
            href: getProcurementUrl(),
            target: "_blank",
            iconAlign: "right",
            iconName: "external",
            onClick: trackOfferDetailsClick,
            disabled: foundOfferId === null,
            disabledReason: foundOfferId === null ? t("offerCtaNotAvailable") : void 0,
            children: t("viewAndAcceptPrivateOffer")
          }
        )
      ] })
    ] }) }) }),
    showContactInfo && /* @__PURE__ */ jsx17(Container12, { header: /* @__PURE__ */ jsx17(Header12, { children: t("contactInformationHeader") }), "data-testid": "success-your-details-container", children: /* @__PURE__ */ jsx17(KeyValuePairs5, { columns: 2, items: leadIdentityKeyValuePairs(t, leadIdentity) }) }),
    /* @__PURE__ */ jsx17(Container12, { header: /* @__PURE__ */ jsx17(Header12, { children: t("offerDetails") }), children: /* @__PURE__ */ jsxs14(SpaceBetween12, { size: "m", children: [
      /* @__PURE__ */ jsx17(KeyValuePairs5, { columns: 1, items: [{ label: t("offerName"), value: displayPricing.offerTitle || t("expressPrivateOffer") }] }),
      /* @__PURE__ */ jsx17(
        ManagedTable3,
        {
          columnDefinitions: [
            {
              id: "dimension",
              header: /* @__PURE__ */ jsx17(Box10, { display: "inline", className: SuccessPage_default.nowrap, children: t("dimension") }),
              cell: (item) => item.displayName,
              width: 240,
              minWidth: 200
            },
            {
              id: "description",
              header: t("description"),
              cell: (item) => item.description,
              // Cap so a long dimension description doesn't stretch to fill the
              // whole table and dwarf the other columns.
              width: 400,
              minWidth: 280
            },
            {
              id: "units",
              header: /* @__PURE__ */ jsx17(Box10, { display: "inline", className: SuccessPage_default.nowrap, children: t("numberOfUnits") }),
              cell: (item) => (item.numberOfUnits ?? 0).toString(),
              width: 200,
              minWidth: 170
            }
          ],
          items: dimensionTableItems,
          variant: "borderless",
          header: /* @__PURE__ */ jsx17(Header12, { children: t("specifiedDimensions") }),
          hidePreferences: true,
          preferenceKey: "review-dimensions-table",
          defaultPreferences: {
            contentDensity: "compact",
            pageSize: 10
          },
          pagination: {},
          trackBy: "dimensionKey"
        }
      ),
      /* @__PURE__ */ jsx17(
        KeyValuePairs5,
        {
          columns: 3,
          items: [
            {
              label: t("totalContractPrice"),
              value: /* @__PURE__ */ jsx17("div", { className: SuccessPage_default.largePrice, children: formatCurrency(displayPricing.discountedPrice || 0, buyerOptions.currencyCode) })
            },
            { label: t("offerCurrency"), value: getCurrencyDisplay() },
            ...showDiscount ? [{ label: t("discount"), value: `${discountPercentage}%` }] : []
          ]
        }
      ),
      fpsEnabled && /* @__PURE__ */ jsx17(
        KeyValuePairs5,
        {
          columns: 3,
          items: [
            { label: t("startDate"), value: formatStartDate() },
            { label: t("duration"), value: formatDuration() },
            {
              label: t("eulaHeader"),
              value: /* @__PURE__ */ jsxs14("span", { children: [
                t("vendorsLabel"),
                " ",
                /* @__PURE__ */ jsx17(Link8, { variant: "secondary", href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") })
              ] })
            }
          ]
        }
      )
    ] }) }),
    fpsEnabled ? /* @__PURE__ */ jsx17(Container12, { header: /* @__PURE__ */ jsx17(Header12, { children: t("paymentDetailsHeader") }), children: /* @__PURE__ */ jsxs14(SpaceBetween12, { size: "m", children: [
      /* @__PURE__ */ jsx17(
        KeyValuePairs5,
        {
          columns: 3,
          items: [
            {
              label: t("paymentMethod"),
              value: /* @__PURE__ */ jsx17("span", { "data-testid": "success-payment-method", children: paymentMethod === PAYMENT_METHOD4.INSTALLMENTS ? t("payInInstallments") : t("payInFull") })
            },
            ...paymentMethod === PAYMENT_METHOD4.INSTALLMENTS && paymentFrequency ? [
              {
                label: t("paymentFrequency"),
                value: /* @__PURE__ */ jsx17("span", { "data-testid": "success-payment-frequency", children: frequencyLabel(paymentFrequency, t) })
              }
            ] : [],
            ...paymentMethod === PAYMENT_METHOD4.INSTALLMENTS && firstInvoiceDate ? [
              {
                label: t("firstInvoiceDate"),
                value: /* @__PURE__ */ jsx17("span", { "data-testid": "success-first-invoice-date", children: firstInvoiceDate })
              }
            ] : []
          ]
        }
      ),
      paymentMethod === PAYMENT_METHOD4.INSTALLMENTS && paymentFrequency && firstInvoiceDate && generateInstallmentSchedule && scheduleAnchorDate && contractTotal !== void 0 && // View-only schedule on the committed offer (Δ4): pricing is
      // locked and there is no way back to edit, so the table renders
      // without an Edit action.
      /* @__PURE__ */ jsx17("div", { id: "review-installment-plan", children: /* @__PURE__ */ jsx17(
        ReviewInstallmentPlanContainer,
        {
          t,
          writeableArtifact,
          generateInstallmentSchedule,
          scheduleAnchorDate,
          contractTotal,
          currencyCode: buyerOptions.currencyCode
        }
      ) })
    ] }) }) : /* @__PURE__ */ jsx17(Container12, { header: /* @__PURE__ */ jsx17(Header12, { children: t("contractNeeds") }), children: /* @__PURE__ */ jsx17(
      KeyValuePairs5,
      {
        columns: 3,
        items: [
          { label: t("startDate"), value: formatStartDate() },
          { label: t("duration"), value: formatDuration() },
          {
            label: t("eulaHeader"),
            value: /* @__PURE__ */ jsx17(Link8, { variant: "secondary", href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") })
          }
        ]
      }
    ) }),
    buyerOptions.renewalTerms != null && /* @__PURE__ */ jsx17(
      SuccessRenewalTermsCard,
      {
        renewalTerms: buyerOptions.renewalTerms,
        t,
        paymentFrequency: paymentMethod === PAYMENT_METHOD4.INSTALLMENTS ? paymentFrequency : void 0,
        durationISO: artifact.offerRequest.duration,
        dayOfMonth: paymentMethod === PAYMENT_METHOD4.INSTALLMENTS ? renewalDayOfMonth : void 0
      }
    )
  ] }) });
};

// src/aipo/GetOffer/components/IneligiblePage/IneligiblePage.tsx
import SpaceBetween13 from "@amzn/awsui-components-react/polaris/space-between";
import Button6 from "@amzn/awsui-components-react/polaris/button";
import TextContent5 from "@amzn/awsui-components-react/polaris/text-content";
import { marketplaceLinks as marketplaceLinks4 } from "@amzn/awsmp-max-link-catalog/browser";

// src/aipo/GetOffer/assets/human-human-success.svg
var human_human_success_default = 'data:image/svg+xml,<svg width="284" height="212" viewBox="0 0 284 212" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_3291_629435)">%0A<path d="M165.005 142.178L166.31 146.086L143.481 153.022L142.611 150.85C143.487 147.768 146.245 144.884 152.913 142.659C159.58 140.433 163.888 141.388 165.005 142.178Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M159.759 142.246L161.253 144.079C162.747 145.911 163.183 148.427 162.273 150.611C161.186 153.227 159.493 155.343 156.042 155.861C151.018 156.611 147.745 154.559 146.134 149.21C145.582 147.373 145.365 145.462 145.371 143.547L145.387 139.036C145.617 136.26 146.937 133.263 147.625 131.633L148.293 125.449L148.905 117.571C149.105 116.485 149.527 115.155 150.831 115.214C152.096 115.364 151.872 115.507 151.86 116.454L152.033 114.465C152.284 113.294 152.602 112.032 154.098 111.961C155.47 112.171 154.842 113.573 154.786 114.836L155.104 112.715C155.398 111.369 156.108 110.532 157.448 110.709C158.532 110.994 158.651 111.871 158.651 111.871C158.651 111.871 158.497 112.575 158.693 112.526C159.712 112.287 160.786 112.809 161.178 113.785C161.508 114.626 161.617 115.619 161.631 116.275L162.657 128.877C162.622 130.029 162.439 130.492 162.177 131.611C161.464 134.725 159.985 141.179 159.754 142.258L159.759 142.246Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M153.402 127.893L154.77 115.056" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M151.826 116.533L150.913 129.173" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M156.866 129.861L157.363 114.566C157.363 114.566 157.29 112.925 158.394 112.596" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M145.39 139.399L145.681 137.401C145.964 135.453 146.92 133.578 148.217 131.999C149.096 130.928 150.206 130.065 151.441 129.424L152.561 128.847L155.096 124.135C155.964 122.63 157.546 121.994 159.446 122.595C160.129 122.813 160.652 123.43 160.672 124.149C160.677 124.399 160.633 124.668 160.479 124.896L157.07 131.171C156.312 132.456 155.603 135.391 155.644 135.375" fill="%23D6AA8A"/>%0A<path d="M145.39 139.399L145.681 137.401C145.964 135.453 146.92 133.578 148.217 131.999C149.096 130.928 150.206 130.065 151.441 129.424L152.561 128.847L155.096 124.135C155.964 122.63 157.546 121.994 159.446 122.595C160.129 122.813 160.652 123.43 160.672 124.149C160.677 124.399 160.633 124.668 160.479 124.896L157.07 131.171C156.312 132.456 155.603 135.391 155.644 135.375" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M196.335 150.429L187.739 173.059C181.678 189.013 159.29 189.508 152.531 173.837L142.809 151.297L165.002 142.612L170.224 155.206L176.005 140.989C179.96 131.264 188.859 124.41 199.292 123.242C206.205 122.469 213.133 121.766 215.482 121.766" fill="%23006CE0"/>%0A<path d="M196.335 150.429L187.739 173.059C181.678 189.013 159.29 189.508 152.531 173.837L142.809 151.297L165.002 142.612L170.224 155.206L176.005 140.989C179.96 131.264 188.859 124.41 199.292 123.242C206.205 122.469 213.133 121.766 215.482 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M168.861 154.709C168.656 154.197 168.905 153.615 169.418 153.409C169.93 153.204 170.512 153.453 170.718 153.965L169.79 154.337L168.861 154.709ZM169.79 154.337L170.718 153.965L175.94 166.994L175.012 167.366L174.084 167.738L168.861 154.709L169.79 154.337Z" fill="%230F141A"/>%0A<path d="M257.884 212.676C259.167 212.676 258.619 210.834 258.375 209.611C253.712 181.504 252.875 161.329 250.957 141.121C249.937 130.387 240.713 123.503 229.634 123.503H207.93C196.86 123.503 189.063 130.437 187.477 141.094C184.141 163.499 184.537 180.554 180.16 210.656C179.888 211.861 179.938 213.069 181.203 213.069L257.884 212.676Z" fill="%23006CE0"/>%0A<path d="M187.427 146.346C184.286 168.359 183.471 188.212 179.468 217.762C179.196 218.976 179.944 220.153 181.209 220.153H257.885C259.168 220.153 259.857 218.994 259.617 217.762C254.245 190.06 253.121 160.528 250.959 138.529" fill="%23006CE0"/>%0A<path d="M187.427 146.346C184.286 168.359 183.471 188.212 179.468 217.762C179.196 218.976 179.944 220.153 181.209 220.153H257.885C259.168 220.153 259.857 218.994 259.617 217.762C254.245 190.06 253.121 160.528 250.959 138.529" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M284.441 252.292C284.387 253.65 283.256 254.709 281.916 254.657C280.94 254.619 280.123 253.996 279.775 253.139C279.756 254.29 279.725 255.41 279.684 256.442C279.631 257.801 278.5 258.86 277.16 258.808C275.819 258.755 274.775 257.611 274.828 256.253L274.834 256.088C274.774 256.959 274.708 257.791 274.635 258.544C274.505 259.899 273.291 260.886 271.975 260.756C270.638 260.626 269.664 259.423 269.794 258.064C270.069 255.211 270.231 247.369 270.35 243.893C270.35 243.893 268.018 252.61 267.389 255.519C267.101 256.85 265.803 257.695 264.494 257.396C263.184 257.106 262.356 255.791 262.644 254.464C263.313 251.409 264.143 248.296 264.816 245.789C265.158 244.516 265.529 243.135 265.775 242.111C265.578 241.443 265.447 240.751 265.403 240.019L265.342 239.043C263.843 241.305 262.652 242.888 262.562 243.002C261.744 244.078 260.316 244.512 259.073 244.175C258.159 243.993 256.982 243.082 256.973 242.354C256.966 241.819 258.361 240.457 258.708 240.001C258.749 239.955 262.305 235.244 264.76 230.486C264.47 228.187 264.195 226.504 263.839 224.836C262.517 218.65 266.993 212.757 273.315 213.004C276.902 213.144 280.025 215.355 280.77 218.866C282.897 228.891 284.667 246.743 284.45 252.283L284.445 252.283L284.441 252.292Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M242.579 150.429C242.579 150.429 249.126 169.183 252.588 181.698C257.266 198.603 259.986 225.996 259.986 225.996H285.226C285.226 225.996 283.445 208.624 275.652 178.224C272.497 165.915 268.616 154.817 265.113 145.966C259.77 132.467 247.013 123.735 232.556 122.41C228.448 122.033 224.981 121.766 223.432 121.766" fill="%23006CE0"/>%0A<path d="M242.579 150.429C242.579 150.429 249.126 169.183 252.588 181.698C257.266 198.603 259.986 225.996 259.986 225.996H285.226C285.226 225.996 283.445 208.624 275.652 178.224C272.497 165.915 268.616 154.817 265.113 145.966C259.77 132.467 247.013 123.735 232.556 122.41C228.448 122.033 224.981 121.766 223.432 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M207.689 125.193V113.977C207.689 113.977 192.073 117.257 191.882 103.18C191.801 97.1481 192.113 91.6077 194.09 85.156C196.51 77.2515 200.477 71.0524 212.562 71.0524C221.728 71.0885 229.23 78.5824 229.23 87.7096V125.193C229.23 131.112 224.407 135.913 218.459 135.913C212.512 135.913 207.689 131.112 207.689 125.193Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M207.689 113.981C207.689 113.981 212.844 113.205 217.445 111.437C217.843 111.283 218.134 111.82 217.789 112.068L207.689 119.341V113.977" fill="%230F141A"/>%0A<path d="M207.689 113.981C207.689 113.981 212.844 113.205 217.445 111.437C217.843 111.283 218.134 111.82 217.789 112.068L207.689 119.341V113.977" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M209.186 93.4752C209.681 93.4752 210.083 92.9823 210.083 92.3743C210.083 91.7663 209.681 91.2734 209.186 91.2734C208.69 91.2734 208.288 91.7663 208.288 92.3743C208.288 92.9823 208.69 93.4752 209.186 93.4752Z" fill="%230F141A"/>%0A<path d="M198.827 91.21C199.323 91.21 199.725 90.7171 199.725 90.1092C199.725 89.5012 199.323 89.0083 198.827 89.0083C198.332 89.0083 197.93 89.5012 197.93 90.1092C197.93 90.7171 198.332 91.21 198.827 91.21Z" fill="%230F141A"/>%0A<path d="M205.264 87.5558C204.108 90.0192 203.265 92.46 199.734 94.8693C198.977 95.3881 199.317 96.6243 200.146 97.0168L201.855 97.8199" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M201.525 102.598C201.525 102.598 206.326 103.256 209.667 99.7012" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M222.703 89.7275L219.656 93.2018C217.869 91.5838 219.007 86.6585 217.462 85.5861C214.976 83.8551 214.672 80.7789 214.985 78.6576C214.985 78.6576 196.341 84.8711 193.056 73.4506C191.91 69.4713 193.46 66.4563 196.265 64.2738C198.832 62.2747 202.084 61.5127 205.349 61.4986C210.645 61.4845 217.847 64.3302 220.49 63.841C222.425 63.4835 223.837 62.7733 224.127 62.6228C225.477 61.9313 230.112 61.588 232.555 66.8561C232.555 66.8561 234.828 72.6698 237.88 73.6764C237.88 73.6764 246.18 74.8664 239.995 87.9097L228.795 108.836L225.749 89.7275H222.703Z" fill="%23232B37" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M223.511 97.3853C227.822 94.4662 228.121 91.9216 227.786 90.4824C227.564 89.5214 226.802 88.7589 225.841 88.5153C224.671 88.222 223.361 88.5288 222.373 89.3319C220.12 91.1592 219.49 93.6632 219.49 93.6632" fill="%23D6AA8A"/>%0A<path d="M223.511 97.3853C227.822 94.4662 228.121 91.9216 227.786 90.4824C227.564 89.5214 226.802 88.7589 225.841 88.5153C224.671 88.222 223.361 88.5288 222.373 89.3319C220.12 91.1592 219.49 93.6632 219.49 93.6632" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M222.686 98.5034C221.399 102.322 217.591 103.624 214.436 103.624" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M212.927 105.524C211.842 105.524 210.962 104.646 210.962 103.563C210.962 102.48 211.842 101.602 212.927 101.602C214.012 101.602 214.892 102.48 214.892 103.563C214.892 104.646 214.012 105.524 212.927 105.524Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M223.689 98.6202C220.147 98.6202 217.276 95.7544 217.276 92.2193C217.276 88.6842 220.147 85.8185 223.689 85.8185C227.231 85.8185 230.103 88.6842 230.103 92.2193C230.103 95.7544 227.231 98.6202 223.689 98.6202Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M120.737 120.463L118.57 123.467L137.203 136.098L140.236 132.623C139.802 129.583 136.792 126.979 130.732 123.467C124.672 119.955 121.984 119.913 120.737 120.463Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M123.321 121.894L121.397 123.258C119.473 124.623 118.382 126.931 118.67 129.278C119.012 132.089 120.07 134.581 123.241 136.004C127.86 138.072 131.547 136.972 134.526 132.25C135.547 130.629 136.266 128.846 136.773 127L137.965 122.649C138.489 119.914 138.025 116.674 137.801 114.919L138.816 108.783L140.338 101.03C140.436 99.9303 140.388 98.5353 139.121 98.2436C137.868 98.0493 138.045 98.2476 137.803 99.1628L138.169 97.2002C138.242 96.0051 138.274 94.704 136.859 94.235C135.486 94.0701 135.713 95.5886 135.429 96.8199L135.692 94.6922C135.77 93.3165 135.313 92.3205 133.981 92.1313C132.865 92.1161 132.515 92.9286 132.515 92.9286C132.515 92.9286 132.475 93.6478 132.3 93.5486C131.387 93.0454 130.217 93.2612 129.58 94.096C129.038 94.818 128.668 95.7452 128.478 96.3738L124.12 108.239C123.845 109.357 123.897 109.852 123.848 111C123.699 114.191 123.39 120.804 123.322 121.906L123.321 121.894Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M133.261 109.769L135.386 97.0368" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M137.815 99.2475L135.306 111.669" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M129.412 110.737L133.029 95.8698C133.029 95.8698 133.539 94.3087 132.567 93.696" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M137.866 122.999L138.122 120.996C138.372 119.044 137.957 116.981 137.136 115.113C136.579 113.846 135.745 112.717 134.732 111.769L133.813 110.913L132.642 105.695C132.213 104.013 130.865 102.976 128.883 103.047C128.168 103.074 127.502 103.528 127.29 104.216C127.219 104.455 127.189 104.726 127.275 104.987L128.865 111.945C129.248 113.385 129.142 116.402 129.107 116.376" fill="%23B78159"/>%0A<path d="M137.866 122.999L138.122 120.996C138.372 119.044 137.957 116.981 137.136 115.113C136.579 113.846 135.745 112.717 134.732 111.769L133.813 110.913L132.642 105.695C132.213 104.013 130.865 102.976 128.883 103.047C128.168 103.074 127.502 103.528 127.29 104.216C127.219 104.455 127.189 104.726 127.275 104.987L128.865 111.945C129.248 113.385 129.142 116.402 129.107 116.376" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M73.5032 150.429L96.2689 162.777C104.397 167.186 114.518 165.103 120.245 157.844L139.799 133.057L120.3 120.897L105.568 140.875L84.2797 127.233C80.888 125.06 77.0868 123.612 73.1002 123.034C66.9188 122.138 57.7599 120.897 54.4379 120.897" fill="%23DEDEE3"/>%0A<path d="M73.5032 150.429L96.2689 162.777C104.397 167.186 114.518 165.103 120.245 157.844L139.799 133.057L120.3 120.897L105.568 140.875L84.2797 127.233C80.888 125.06 77.0868 123.612 73.1002 123.034C66.9188 122.138 57.7599 120.897 54.4379 120.897" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M106.521 141.19C106.695 140.666 106.412 140.1 105.888 139.925C105.364 139.751 104.798 140.035 104.623 140.559L105.572 140.874L106.521 141.19ZM105.572 140.874C104.623 140.559 104.623 140.559 104.623 140.559C104.623 140.559 104.623 140.56 104.623 140.56C104.623 140.56 104.623 140.561 104.622 140.561C104.622 140.562 104.622 140.563 104.621 140.564C104.621 140.567 104.62 140.57 104.618 140.574C104.616 140.581 104.613 140.592 104.609 140.604C104.601 140.629 104.59 140.665 104.576 140.71C104.55 140.8 104.513 140.93 104.469 141.098C104.382 141.432 104.268 141.918 104.155 142.542C103.929 143.788 103.706 145.585 103.706 147.823H104.706H105.706C105.706 145.718 105.916 144.041 106.123 142.899C106.226 142.328 106.329 141.891 106.405 141.601C106.442 141.457 106.473 141.349 106.493 141.28C106.504 141.245 106.511 141.22 106.516 141.205C106.519 141.198 106.52 141.193 106.521 141.19C106.521 141.189 106.522 141.188 106.522 141.188C106.522 141.188 106.522 141.188 106.522 141.189C106.521 141.189 106.521 141.189 106.521 141.189C106.521 141.189 106.521 141.189 106.521 141.19C106.521 141.19 106.521 141.19 105.572 140.874Z" fill="%230F141A"/>%0A<path d="M12.2223 212.676C10.9449 212.676 11.4898 210.834 11.7335 209.611C16.3759 181.504 17.2098 161.329 19.119 141.121C20.1346 130.387 29.3197 123.503 40.3509 123.503H61.9619C72.984 123.503 80.7474 130.437 82.3271 141.094C85.6491 163.499 85.2546 180.554 89.6128 210.656C89.8836 211.861 89.8332 213.069 88.5739 213.069L12.2223 212.676Z" fill="%23DEDEE3"/>%0A<path d="M82.3768 146.346C85.5047 168.359 86.316 188.212 90.3015 217.762C90.5723 218.976 89.8276 220.153 88.5683 220.153H12.2212C10.9438 220.153 10.2578 218.994 10.497 217.762C15.8456 190.06 16.9651 160.528 19.1181 138.529" fill="%23DEDEE3"/>%0A<path d="M82.3768 146.346C85.5047 168.359 86.316 188.212 90.3015 217.762C90.5723 218.976 89.8276 220.153 88.5683 220.153H12.2212C10.9438 220.153 10.2578 218.994 10.497 217.762C15.8456 190.06 16.9651 160.528 19.1181 138.529" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M69.9223 206.887L67.6606 206.652L67.7556 183.435L69.4889 183.435C71.9987 185.418 73.5806 189.089 73.1023 196.088C72.6241 203.088 71.0744 206.157 69.9223 206.887Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M95.7979 202.811C97.1323 202.569 98.0223 201.304 97.7847 199.986C97.6116 199.027 96.883 198.307 95.9884 198.082C97.1226 197.903 98.2248 197.716 99.2394 197.532C100.574 197.29 101.464 196.025 101.226 194.708C100.989 193.39 99.7129 192.517 98.3785 192.759L98.2165 192.789C99.0688 192.608 99.8813 192.426 100.615 192.25C101.936 191.932 102.743 190.595 102.432 189.313C102.118 188.009 100.795 187.214 99.4697 187.533C96.6891 188.202 88.964 189.454 85.5462 190.056C85.5462 190.056 93.8354 186.537 96.6219 185.51C97.8974 185.04 98.5517 183.639 98.0748 182.387C97.6065 181.133 96.1933 180.498 94.922 180.968C91.9966 182.054 89.0353 183.308 86.6516 184.322C85.4414 184.837 84.1291 185.397 83.1509 185.783C82.4634 185.681 81.7618 185.647 81.0326 185.706L80.0602 185.782C82.087 183.985 83.486 182.588 83.5859 182.483C84.5356 181.524 84.7658 180.053 84.2609 178.871C83.954 177.993 82.8915 176.958 82.1709 177.049C81.6411 177.117 80.4887 178.686 80.0863 179.092C80.0462 179.139 75.8853 183.309 71.5249 186.398C69.215 186.431 67.5156 186.395 65.819 186.275C59.522 185.83 54.3183 191.075 55.4391 197.289C56.0749 200.813 58.6924 203.591 62.2646 203.838C72.4648 204.544 90.3479 203.807 95.7909 202.821L95.7902 202.817L95.7979 202.811Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M98.3377 192.765L86.6627 194.499L98.3377 192.765Z" fill="%23B78159"/>%0A<path d="M98.3377 192.765L86.6627 194.499" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M95.919 198.091L85.4729 198.883L95.919 198.091Z" fill="%23B78159"/>%0A<path d="M95.919 198.091L85.4729 198.883" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M32.6568 150.429L28.7569 181.698L69.4874 183.435V206.887L18.6185 204.67C8.52538 204.23 1.04077 195.137 2.54925 185.148L8.3492 146.739C10.3948 133.193 21.6443 122.896 35.3271 122.211C40.4189 121.956 44.8009 121.766 46.5225 121.766" fill="%23DEDEE3"/>%0A<path d="M32.6568 150.429L28.7569 181.698L69.4874 183.435V206.887L18.6185 204.67C8.52538 204.23 1.04077 195.137 2.54925 185.148L8.3492 146.739C10.3948 133.193 21.6443 122.896 35.3271 122.211C40.4189 121.956 44.8009 121.766 46.5225 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip1_3291_629435)">%0A<path d="M63.3677 122.644L61.8419 111.533C61.8419 111.533 77.6922 112.657 75.9651 98.6863C75.225 92.6994 74.1628 87.2533 71.3356 81.1308C67.8725 73.6295 63.1168 68.028 51.1959 69.6724C42.1596 70.9553 35.7789 79.4001 37.0205 88.442L42.1195 125.575C42.9247 131.439 48.3354 135.539 54.2019 134.729C60.0684 133.92 64.1729 128.508 63.3677 122.644Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M61.842 111.537C61.842 111.537 56.6525 111.47 51.8734 110.344C51.459 110.246 51.2459 110.818 51.6195 111.016L62.5712 116.847L61.8414 111.533" fill="%230F141A"/>%0A<path d="M61.842 111.537C61.842 111.537 56.6525 111.47 51.8734 110.344C51.459 110.246 51.2459 110.818 51.6195 111.016L62.5712 116.847L61.8414 111.533" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M57.5817 91.4579C57.0927 91.5254 56.6293 91.0918 56.5466 90.4895C56.4638 89.8872 56.7932 89.3442 57.2821 89.2768C57.7711 89.2093 58.2345 89.6429 58.3172 90.2452C58.3999 90.8475 58.0706 91.3905 57.5817 91.4579Z" fill="%230F141A"/>%0A<path d="M67.4913 87.8045C67.0024 87.8719 66.5389 87.4384 66.4562 86.8361C66.3735 86.2337 66.7029 85.6908 67.1918 85.6233C67.6808 85.5559 68.1442 85.9895 68.2269 86.5918C68.3096 87.1941 67.9803 87.7371 67.4913 87.8045Z" fill="%230F141A"/>%0A<path d="M60.645 85.0603C62.1203 87.3434 63.284 89.6467 67.095 91.553C67.9123 91.964 67.7451 93.2349 66.9803 93.7366L65.4038 94.7648" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M65.8308 98.4363C65.8308 98.4363 62.1257 98.5733 58.833 97.5852Z" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M70.7274 77.3699C72.1558 76.1344 72.1462 73.4429 70.479 72.5552C76.8883 68.3974 70.5092 62.6479 65.4823 66.3862C74.6201 57.1615 56.1097 50.9303 54.7232 61.2947C55.5848 51.3283 40.1893 50.1906 42.1566 62.1515C36.4108 52.9823 20.0977 59.8546 30.1654 70.3814C16.4544 65.5494 14.9013 83.4494 27.0224 85.7199C18.19 84.0606 17.2509 90.1365 17.1186 93.2236C16.9108 98.0743 21.6663 101.67 25.6565 101.252C24.0851 108.921 32.5955 110.377 35.3206 104.741C37.6875 109.237 41.7438 106.924 42.9882 103.245C43.7443 99.1953 41.1254 96.0495 41.1254 96.0495C38.7428 94.6246 46.6824 91.9247 47.1836 91.8555C49.5231 89.2624 51.3226 80.6275 50.804 77.1701C51.4339 81.2458 60.4802 81.2651 59.3267 76.3817C59.6175 77.732 60.773 78.8575 62.1174 79.1208C63.8944 79.4653 65.6684 76.0789 65.6684 76.0789C65.6684 76.0789 69.0423 78.7816 70.7153 77.3452L70.7188 77.3711L70.7274 77.3699Z" fill="%23232B37" stroke="%230F141A" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round"/>%0A<path d="M43.978 97.2487C39.3285 94.9435 38.6873 92.4634 38.8224 90.9919C38.9108 90.0097 39.5582 89.1507 40.473 88.7786C41.5868 88.3289 42.9207 88.4546 44.0048 89.1157C46.4756 90.6193 47.4378 93.0142 47.4378 93.0142" fill="%23B78159"/>%0A<path d="M43.978 97.2487C39.3285 94.9435 38.6873 92.4634 38.8224 90.9919C38.9108 90.0097 39.5582 89.1507 40.473 88.7786C41.5868 88.3289 42.9207 88.4546 44.0048 89.1157C46.4756 90.6193 47.4378 93.0142 47.4378 93.0142" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M144.753 71.6574C160.922 71.6574 174.019 58.5451 174.019 42.3891C174.019 26.2332 160.908 13.1208 144.753 13.1208C128.599 13.1208 115.488 26.2332 115.488 42.3891C115.488 58.5451 128.599 71.6574 144.753 71.6574Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.5" stroke-miterlimit="10"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M161.808 34.2926L141.944 54.5709C141.288 55.2399 140.403 55.6084 139.485 55.5942C138.568 55.58 137.693 55.1843 137.057 54.4953L127.698 44.3562L132.657 39.3976L139.609 46.9296L156.993 29.1829L161.808 34.2926Z" fill="white" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M153.285 80.5094L150.78 90.7061" stroke="%230F141A" stroke-width="1.5"/>%0A<path d="M164.167 86.0964L156.899 93.6744" stroke="%230F141A" stroke-width="1.5"/>%0A<path d="M170.335 96.8625L160.252 99.7912" stroke="%230F141A" stroke-width="1.5"/>%0A<line x1="-8.74228e-08" y1="211" x2="283.512" y2="211" stroke="%230F141A" stroke-width="2"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_3291_629435">%0A<rect width="284" height="212" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_3291_629435">%0A<rect width="102.26" height="99.8871" fill="white" transform="translate(3.48828 42.3892)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/aipo/GetOffer/components/IneligiblePage/IneligiblePage.tsx
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var IneligiblePage = ({ buyerOptions, logger, t, leadSubmitted = false }) => {
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.INELIGIBLE);
  return /* @__PURE__ */ jsxs15(SpaceBetween13, { size: "l", children: [
    /* @__PURE__ */ jsx18(TextContent5, { children: /* @__PURE__ */ jsx18("h1", { children: t("didNotQualifyForOffer") }) }),
    /* @__PURE__ */ jsx18(HeroContainer, { imageSrc: human_human_success_default, imageAlt: t("humanToHumanSuccessAlt"), imageWidthPx: 202, imageHeightPx: 133, children: /* @__PURE__ */ jsx18("div", { style: { paddingLeft: "24px", paddingRight: "24px" }, children: leadSubmitted ? /* @__PURE__ */ jsxs15(TextContent5, { "data-testid": "ineligible-lead-submitted", children: [
      /* @__PURE__ */ jsx18("h3", { children: t("detailsSharedWithSeller") }),
      /* @__PURE__ */ jsx18("p", { children: t("detailsSharedWithSellerMessage") })
    ] }) : /* @__PURE__ */ jsxs15(SpaceBetween13, { size: "m", children: [
      /* @__PURE__ */ jsxs15(TextContent5, { children: [
        /* @__PURE__ */ jsx18("h3", { children: t("startDiscussionWithSales") }),
        /* @__PURE__ */ jsx18("p", { children: t("expressOffersNotAvailableMessage") })
      ] }),
      /* @__PURE__ */ jsx18(
        Button6,
        {
          variant: "primary",
          href: marketplaceLinks4.get("RequestPrivateOffer", { listingId: buyerOptions.listingId }),
          target: "_blank",
          iconAlign: "right",
          iconName: "external",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickFeat: "ineligible-container",
                ClickAct: "request-custom-offer"
              }
            });
          },
          children: t("connectWithRepresentative")
        }
      )
    ] }) }) })
  ] });
};

// src/aipo/GetOffer/components/UnonboardedPage/UnonboardedPage.tsx
import { useEffect as useEffect3 } from "react";
import SpaceBetween14 from "@amzn/awsui-components-react/polaris/space-between";
import Button7 from "@amzn/awsui-components-react/polaris/button";
import TextContent6 from "@amzn/awsui-components-react/polaris/text-content";
import { marketplaceLinks as marketplaceLinks5 } from "@amzn/awsmp-max-link-catalog/browser";

// src/aipo/GetOffer/assets/human-robot-error.svg
var human_robot_error_default = 'data:image/svg+xml,<svg width="186" height="129" viewBox="0 0 186 129" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_5688_91748)">%0A<path d="M122.816 97.3877L121.362 97.3797L121.362 115.004L122.816 115.012C124.685 113.505 125.651 110.618 125.244 105.363C124.836 100.109 123.686 97.9274 122.816 97.3877Z" fill="%230F141A" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M138.218 107.452C138.631 107.885 140.779 110.237 141.604 111.137C141.804 111.361 141.841 111.687 141.683 111.94C140.452 113.947 138.263 112.809 138.263 112.809C138.263 112.809 139.249 114.004 139.881 114.641C140.514 115.272 143.655 116.053 144.838 116.949C146.021 117.845 145.487 118.905 145.487 118.905C145.295 119.301 144.968 119.586 144.657 119.486C144.267 119.359 143.483 119.033 143.483 119.033C143.483 119.033 144.983 120.167 144.422 121.285C144.012 122.215 143.003 122.39 142.38 122.222C142.27 122.189 141.892 121.468 141.892 121.468C141.892 121.468 142.411 122.412 141.969 123.256C141.679 123.822 141.098 124.072 140.604 124.14C140.155 124.202 139.785 124.056 139.364 123.889L137.095 122.894C137.095 122.894 137.057 122.789 136.605 123.223C135.577 124.213 134.098 122.826 133.535 122.528C130.175 120.617 127.744 117.852 125.609 114.697C125.049 113.949 121.898 111.779 121.898 111.779C118.013 111.43 114.09 112.614 114.137 106.247C114.17 101.843 116.577 98.1743 123.613 99.793L130.1 101.799C134.31 102.287 137.696 106.88 138.199 107.425L138.218 107.439L138.218 107.452Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<mask id="path-3-inside-1_5688_91748" fill="white">%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957"/>%0A</mask>%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957" fill="%23EAC7AF"/>%0A<path d="M135.473 119.868L135.826 119.233L135.855 119.249L135.883 119.268L135.473 119.868ZM137.048 122.17C136.332 122.045 136.332 122.046 136.332 122.047C136.332 122.047 136.332 122.047 136.332 122.048C136.332 122.049 136.332 122.049 136.332 122.05C136.331 122.052 136.331 122.053 136.331 122.055C136.33 122.057 136.33 122.06 136.33 122.062C136.329 122.067 136.328 122.071 136.328 122.074C136.327 122.08 136.327 122.082 136.327 122.081C136.328 122.079 136.328 122.065 136.326 122.038C136.322 121.986 136.307 121.885 136.25 121.746C136.139 121.474 135.848 121.005 135.062 120.468L135.473 119.868L135.883 119.268C136.863 119.938 137.36 120.62 137.596 121.197C137.712 121.483 137.76 121.731 137.775 121.922C137.783 122.017 137.782 122.097 137.779 122.16C137.777 122.191 137.775 122.218 137.772 122.241C137.771 122.252 137.769 122.262 137.768 122.271C137.768 122.276 137.767 122.28 137.766 122.284C137.766 122.286 137.766 122.287 137.765 122.289C137.765 122.29 137.765 122.291 137.765 122.292C137.765 122.292 137.765 122.293 137.765 122.293C137.765 122.294 137.765 122.294 137.048 122.17ZM135.473 119.868C135.119 120.503 135.119 120.503 135.119 120.503C135.119 120.503 135.119 120.503 135.119 120.503C135.118 120.503 135.118 120.502 135.118 120.502C135.117 120.502 135.116 120.501 135.115 120.501C135.113 120.5 135.11 120.498 135.107 120.496C135.099 120.492 135.089 120.486 135.076 120.479C135.05 120.464 135.012 120.442 134.964 120.414C134.867 120.357 134.73 120.275 134.561 120.171C134.223 119.962 133.759 119.66 133.248 119.291C132.244 118.564 130.994 117.525 130.216 116.361L130.82 115.957L131.424 115.553C132.054 116.495 133.131 117.411 134.101 118.113C134.577 118.458 135.012 118.74 135.327 118.935C135.484 119.033 135.611 119.108 135.697 119.159C135.741 119.184 135.774 119.203 135.796 119.216C135.807 119.222 135.815 119.226 135.82 119.229C135.822 119.231 135.824 119.232 135.825 119.232C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.473 119.868Z" fill="%230F141A" mask="url(%23path-3-inside-1_5688_91748)"/>%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957C130.984 114.889 131.126 112.417 130.356 111.106C129.926 110.339 128.684 108.614 127.129 107.819" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<mask id="path-6-inside-2_5688_91748" fill="white">%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.649 114.83"/>%0A</mask>%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.649 114.83" fill="%23EAC7AF"/>%0A<path d="M140.617 120.54L140.887 119.865L140.901 119.871L140.915 119.877L140.617 120.54ZM138.005 119.496L138.272 118.82L138.274 118.821L138.005 119.496ZM135.055 117.458L134.519 117.949L134.519 117.948L135.055 117.458ZM141.962 121.594C141.309 121.913 141.309 121.913 141.309 121.914C141.309 121.914 141.31 121.914 141.31 121.914C141.31 121.915 141.31 121.915 141.31 121.916C141.311 121.917 141.311 121.918 141.312 121.919C141.313 121.92 141.313 121.922 141.314 121.923C141.316 121.926 141.317 121.928 141.318 121.93C141.32 121.934 141.321 121.936 141.321 121.936C141.32 121.935 141.316 121.927 141.306 121.913C141.286 121.884 141.244 121.83 141.174 121.759C141.034 121.619 140.771 121.406 140.319 121.203L140.617 120.54L140.915 119.877C141.526 120.152 141.936 120.465 142.203 120.733C142.335 120.866 142.431 120.985 142.497 121.08C142.53 121.127 142.555 121.168 142.575 121.201C142.584 121.217 142.593 121.232 142.599 121.244C142.602 121.25 142.605 121.256 142.608 121.261C142.609 121.263 142.611 121.266 142.612 121.268C142.612 121.269 142.613 121.27 142.613 121.271C142.614 121.272 142.614 121.272 142.614 121.273C142.614 121.273 142.614 121.274 142.614 121.274C142.615 121.274 142.615 121.274 141.962 121.594ZM140.617 120.54L140.348 121.215L137.735 120.171L138.005 119.496L138.274 118.821L140.887 119.865L140.617 120.54ZM138.005 119.496L137.738 120.172C136.504 119.684 135.411 118.921 134.519 117.949L135.055 117.458L135.591 116.966C136.338 117.781 137.249 118.416 138.272 118.82L138.005 119.496ZM135.055 117.458L134.519 117.948L132.113 115.32L132.649 114.83L133.185 114.339L135.591 116.967L135.055 117.458Z" fill="%230F141A" mask="url(%23path-6-inside-2_5688_91748)"/>%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.901 115.112" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M135.227 113.446L137.744 115.957C138.287 116.477 138.895 116.84 139.569 117.165C140.398 117.576 142.692 118.63 143.372 118.994" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M136.028 111.572C134.812 113.324 133.907 114.394 131.949 115.358" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M138.256 112.811L134.009 108.629C133.346 108.845 131.827 109.016 131.054 107.966" stroke="%230F141A" stroke-width="1.09021" stroke-miterlimit="10"/>%0A<path d="M70.4752 99.6705L83.0856 111.332C85.6376 113.692 88.9856 115.003 92.4616 115.003H122.49V97.3869H95.5074L78.3507 81.5119C73.2466 76.7891 66.7145 73.8804 59.7785 73.3826C56.2664 73.1306 52.8621 72.9199 51.2947 72.9199" fill="%23006CE0"/>%0A<path d="M70.4752 99.6705L83.0856 111.332C85.6376 113.692 88.9856 115.003 92.4616 115.003H122.49V97.3869H95.5074L78.3507 81.5119C73.2466 76.7891 66.7145 73.8804 59.7785 73.3826C56.2664 73.1306 52.8621 72.9199 51.2947 72.9199" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip1_5688_91748)">%0A<path d="M75.715 145.929C76.6838 145.929 77.1974 145.088 77.0024 144.187C74.8763 131.262 70.8191 108.955 70.8191 108.955L73.4589 101.197C74.4276 98.2871 74.3626 95.0575 73.1988 92.2128L70.299 85.0423C68.2379 78.6418 62.9583 73.8984 55.8713 73.8984H39.8377C31.6583 73.8984 25.475 80.1946 24.7013 88.2067C23.2839 103.265 21.8015 123.315 17.6793 144.187C17.4842 145.094 18.0044 145.929 18.9667 145.929H75.702H75.715Z" fill="%23006CE0"/>%0A<path d="M24.7141 84.9707C23.1667 101.321 21.6906 124.092 17.692 144.703C17.4969 145.61 18.0171 146.51 18.9794 146.51H75.7147C76.6835 146.51 77.1971 145.603 77.0021 144.703L70.819 108.616L72.0413 105.451C74.3625 99.5074 73.9724 92.7871 70.949 87.0977" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M51.0563 43.2592L49.8063 45.7437L34.9326 37.7309L36.1955 34.5068C38.3708 33.7398 41.1494 34.839 45.59 37.652C50.0306 40.4651 50.9906 42.2385 51.0563 43.2592Z" fill="%230F141A" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M46.1717 42.05C46.4949 41.5471 48.1575 38.8376 48.7974 37.8C48.9513 37.5434 48.9247 37.2167 48.7208 36.9985C47.1251 35.2653 45.1891 36.7943 45.1891 36.7943C45.1891 36.7943 45.9303 35.4377 46.4304 34.6936C46.9319 33.9559 49.8732 32.5979 50.8657 31.4965C51.8583 30.395 51.1293 29.4583 51.1293 29.4583C50.8648 29.106 50.4883 28.8891 50.2011 29.0461C49.8425 29.2439 49.1331 29.711 49.1331 29.711C49.1331 29.711 50.392 28.3173 49.6257 27.3282C49.044 26.4949 48.0175 26.514 47.4367 26.7961C47.3346 26.8497 47.1004 27.6269 47.1004 27.6269C47.1004 27.6269 47.431 26.6046 46.8342 25.8606C46.4402 25.3616 45.8211 25.2263 45.3213 25.2531C44.8675 25.2774 44.5319 25.4905 44.1492 25.733L42.108 27.137C42.108 27.137 42.0904 27.2467 41.5627 26.9072C40.3611 26.1313 39.1721 27.77 38.6747 28.1683C35.7343 30.6749 33.8724 33.8426 32.3758 37.3358C31.968 38.1743 29.284 40.8953 29.284 40.8953C25.5274 41.9713 21.4403 41.5527 22.7071 47.7809C23.5832 52.0882 26.6546 55.2265 33.268 52.3114L39.2668 49.1206C43.3155 47.8468 45.7672 42.7085 46.1577 42.0793L46.1743 42.0627L46.1717 42.05Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M42.1999 27.8546C42.1999 27.8546 42.5968 28.8909 41.0904 30.4071C41.0904 30.4071 38.2442 32.7887 37.2618 35.1166" fill="%23EAC7AF"/>%0A<path d="M42.1999 27.8546C42.1999 27.8546 42.5968 28.8909 41.0904 30.4071C41.0904 30.4071 38.2442 32.7887 37.2618 35.1166C37.628 36.1325 38.2413 38.5267 37.7343 39.9561C37.4581 40.7883 36.5666 42.7129 35.1892 43.785" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M47.1455 27.4922C47.1455 27.4922 46.9786 28.1099 46.0244 28.7787L43.6538 30.2949C42.6292 30.9446 41.7766 31.8188 41.1418 32.8488L39.2782 35.8774" fill="%23EAC7AF"/>%0A<path d="M47.1455 27.4922C47.1455 27.4922 46.9786 28.1099 46.0244 28.7787L43.6537 30.2949C42.6292 30.9446 41.7766 31.8188 41.1418 32.8488L39.4715 35.5532" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M42.081 36.7451L44.0766 33.8097C44.5107 33.1983 45.0398 32.7274 45.6406 32.282C46.3778 31.7229 48.4328 30.2565 49.0322 29.7715" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M43.2271 38.4284C41.6948 36.9415 40.5991 36.0648 38.4879 35.4905" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M45.1826 36.7949L41.8047 41.6933C41.2279 41.6469 39.8578 41.7966 38.9915 42.7666" stroke="%230F141A" stroke-width="1.09021" stroke-miterlimit="10"/>%0A<path d="M26.3924 85.0848L11.2139 76.1114C3.06248 71.2924 2.06922 59.8856 9.26497 53.7302L24.7526 40.4819L33.4744 49.5669L19.6649 61.9227L37.1079 69.8718C40.3731 71.3598 43.2082 73.6515 45.3011 76.5662C48.0036 80.33 51.5944 85.4446 52.6752 87.5187" fill="%23006CE0"/>%0A<path d="M26.3924 85.0848L11.2139 76.1114C3.06248 71.2924 2.06922 59.8856 9.26497 53.7302L24.7526 40.4819L33.4744 49.5669L19.6649 61.9227L37.1079 69.8718C40.3731 71.3598 43.2082 73.6515 45.3011 76.5662C48.0036 80.33 51.5944 85.4446 52.6752 87.5187" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M20.521 60.0538C20.7305 59.8376 21.0756 59.8322 21.2918 60.0417C21.508 60.2512 21.5134 60.5963 21.3039 60.8125L20.9124 60.4332L20.521 60.0538ZM20.9124 60.4332C21.3039 60.8125 21.3038 60.8126 21.3037 60.8127C21.3036 60.8128 21.3035 60.8129 21.3034 60.813C21.3033 60.8131 21.3031 60.8133 21.3029 60.8136C21.3025 60.814 21.3019 60.8145 21.3013 60.8151C21.3001 60.8164 21.2986 60.8179 21.2967 60.8199C21.2929 60.8237 21.2876 60.829 21.281 60.8357C21.2677 60.8489 21.2488 60.8677 21.2242 60.8915C21.1749 60.9391 21.103 61.0071 21.0084 61.0926C20.8191 61.2636 20.5388 61.5047 20.1672 61.7929C19.4239 62.3693 18.3145 63.1348 16.8359 63.9052L16.584 63.4218L16.3321 62.9384C17.7466 62.2013 18.8014 61.4725 19.4991 60.9314C19.8479 60.6609 20.1073 60.4375 20.2775 60.2837C20.3627 60.2068 20.4255 60.1473 20.4661 60.108C20.4863 60.0884 20.5011 60.0738 20.5102 60.0647C20.5148 60.0601 20.518 60.0569 20.5198 60.055C20.5207 60.0541 20.5212 60.0536 20.5214 60.0534C20.5215 60.0533 20.5215 60.0532 20.5215 60.0533C20.5214 60.0534 20.5214 60.0534 20.5213 60.0535C20.5212 60.0535 20.5212 60.0536 20.5211 60.0536C20.5211 60.0537 20.521 60.0538 20.9124 60.4332Z" fill="%230F141A"/>%0A<g clip-path="url(%23clip2_5688_91748)">%0A<path d="M57.3535 76.9455L58.8727 68.6593C58.8727 68.6593 69.902 73.2008 71.9485 62.8273C72.8255 58.382 73.3461 54.2465 72.7679 49.2121C72.06 43.0441 69.9855 37.9264 61.1064 36.2871C54.3672 35.0705 47.8402 39.5892 46.604 46.3321L41.527 74.0236C40.7253 78.3966 43.6187 82.5973 47.9883 83.404C52.3579 84.2107 56.5518 81.3185 57.3535 76.9455Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M58.8714 68.6616C58.8714 68.6616 55.1897 67.3892 52.0488 65.4585C51.7765 65.2911 51.4906 65.6484 51.7102 65.8784L58.1454 72.6213L58.872 68.6583" fill="%230F141A"/>%0A<path d="M58.8714 68.6616C58.8714 68.6616 55.1897 67.3892 52.0488 65.4585C51.7765 65.2911 51.4906 65.6484 51.7102 65.8784L58.1454 72.6213L58.872 68.6583" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip3_5688_91748)">%0A<path d="M60.5502 53.3154C60.186 53.2481 59.9575 52.8295 60.0398 52.3803C60.1222 51.9312 60.4842 51.6216 60.8484 51.6888C61.2126 51.756 61.4411 52.1747 61.3587 52.6238C61.2764 53.073 60.9144 53.3826 60.5502 53.3154Z" fill="%230F141A"/>%0A<path d="M68.4672 53.0478C68.103 52.9805 67.8745 52.5619 67.9568 52.1128C68.0392 51.6636 68.4012 51.354 68.7654 51.4212C69.1296 51.4885 69.358 51.9071 69.2757 52.3562C69.1933 52.8054 68.8314 53.115 68.4672 53.0478Z" fill="%230F141A"/>%0A<path d="M64.2328 49.4759C64.7484 51.4526 65.0373 53.3702 67.3054 55.629C67.7913 56.115 67.3741 56.9822 66.7115 57.1597L65.3471 57.5211" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M60.8462 58.8004C60.8462 58.8004 63.4631 58.9519 64.4479 60.7922" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<line x1="0.545107" y1="-0.545107" x2="1.87852" y2="-0.545107" transform="matrix(-0.999779 -0.00209776 -0.00208409 1.00021 67.041 52.6406)" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round"/>%0A<ellipse cx="3.90156" cy="3.91426" rx="3.90156" ry="3.91426" transform="matrix(-0.983381 -0.181552 -0.180334 0.983605 75.2305 48.8457)" stroke="%230F141A" stroke-width="1.09021"/>%0A<ellipse cx="3.90156" cy="3.91426" rx="3.90156" ry="3.91426" transform="matrix(-0.983381 -0.181552 -0.180334 0.983605 65.2471 49.2129)" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M45.4075 54.7259C45.646 55.7362 45.6792 56.8123 45.4689 57.8974C45.1308 59.6456 44.2182 61.134 42.9657 62.2036L42.9268 62.829L42.8142 62.3297C41.1502 63.6772 38.9269 64.3053 36.6607 63.864C32.5828 63.0699 29.923 59.1106 30.7148 55.0251C31.5062 50.933 35.4517 48.2639 39.523 49.0585C39.6284 49.079 39.7328 49.1016 39.8362 49.1263L39.6408 48.2597C38.8275 44.6446 39.5381 38.8971 41.1139 35.5517C45.2483 26.7838 52.481 28.3252 58.5245 29.6132C61.1934 30.182 63.6304 30.7014 65.4662 30.2616C74.1408 28.1809 78.4684 37.1838 74.989 41.5225C70.5386 47.0685 59.6223 40.3638 59.6223 40.3638C59.5441 41.9773 57.759 45.5128 55.6947 46.4381C55.0648 46.7193 54.5969 47.7303 54.1021 48.7994C53.5871 49.9123 53.043 51.0882 52.2566 51.5695L50.8088 48.6486C50.8088 48.6486 49.5314 54.2392 45.4075 54.7259Z" fill="%23855900" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M49.4976 54.256C46.7257 51.5148 46.8506 49.5943 47.292 48.5766C47.5853 47.8967 48.2481 47.4367 48.9872 47.3871C49.8862 47.3291 50.8071 47.7334 51.4244 48.4608C52.8322 50.1163 52.9559 52.0516 52.9559 52.0516" fill="%23EAC7AF"/>%0A<path d="M49.4976 54.256C46.7257 51.5148 46.8506 49.5943 47.292 48.5765C47.5853 47.8967 48.2481 47.4367 48.9872 47.3871C49.8862 47.3291 50.8071 47.7334 51.4244 48.4608C52.8322 50.1163 52.9559 52.0516 52.9559 52.0516" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M40.3086 50.0273C40.5107 50.7281 43.0941 52.8635 44.5751 53.8003" stroke="%23F3F3F7" stroke-width="1.45362"/>%0A<path d="M48.8188 58.232C46.9677 57.8903 47.1267 56.5523 47.8982 55.197C48.6445 53.8859 50.5232 54.2327 50.7556 55.7245C50.9959 57.2666 50.6699 58.5738 48.8188 58.232Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A</g>%0A<path d="M160.252 50.5519V37.149L149.473 30.957" stroke="%230F141A" stroke-width="1.09021"/>%0A<circle cx="2.56982" cy="2.56982" r="2.56982" transform="matrix(-1 0 0 1 162.822 34.8105)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M157.129 49.2152C157.225 48.1975 158.079 47.4199 159.101 47.4199H161.535C162.558 47.4199 163.412 48.1975 163.508 49.2152L163.553 49.687C163.732 51.5931 162.233 53.2406 160.318 53.2406C158.404 53.2406 156.904 51.5931 157.084 49.687L157.129 49.2152Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M117.039 45.8955L107.324 36.5193L120.173 30.4766" stroke="%230F141A" stroke-width="1.09021"/>%0A<ellipse cx="2.56982" cy="2.56982" rx="2.56982" ry="2.56982" transform="matrix(-1 0 0 1 110.536 35.1504)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M118.045 46.031C119.242 47.2285 119.242 49.1699 118.045 50.3674L115.372 53.04C114.175 54.2375 112.233 54.2375 111.036 53.04C109.838 51.8426 109.838 49.9011 111.036 48.7037L113.708 46.031C114.906 44.8336 116.847 44.8336 118.045 46.031Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<rect x="129.238" y="21.4805" width="10.2793" height="8.35192" rx="1.45362" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M139.311 24.5744L129.843 27.2663C129.378 27.3982 128.917 27.0497 128.917 26.5672V22.5276C128.917 22.1262 129.242 21.8008 129.644 21.8008H139.112C139.513 21.8008 139.839 22.1262 139.839 22.5276V23.8753C139.839 24.2001 139.623 24.4855 139.311 24.5744Z" fill="%230F141A"/>%0A<path d="M145.909 5.21079C144.849 1.88144 141.359 -0.0265024 137.983 0.877861L123.504 4.75759C120.129 5.66195 118.061 9.05927 118.807 12.4729L120.685 21.0647C121.482 24.7108 125.163 26.9522 128.768 25.9862L144.039 21.8944C147.644 20.9284 149.711 17.1467 148.579 13.5906L145.909 5.21079Z" fill="%230F141A"/>%0A<path d="M144.086 5.63893C143.14 2.68486 140.041 0.994165 137.044 1.79704L121.831 5.87336C118.835 6.67623 116.997 9.6899 117.654 12.7215L119.554 21.486C120.257 24.7322 123.533 26.7302 126.741 25.8705L142.791 21.57C145.999 20.7103 147.837 17.3422 146.823 14.1792L144.086 5.63893Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M147.243 15.0274L141.996 17.1663C136.442 19.4343 130.519 21.0545 124.567 21.8366L119.938 22.3438" stroke="%230F141A" stroke-width="1.09021"/>%0A<g clip-path="url(%23clip4_5688_91748)">%0A<path d="M124.718 17.0703C125.746 16.7947 126.356 15.7379 126.081 14.7097C125.805 13.6815 124.748 13.0714 123.72 13.3469C122.692 13.6224 122.082 14.6792 122.357 15.7074C122.633 16.7356 123.69 17.3458 124.718 17.0703Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M136.51 13.912C137.538 13.6365 138.148 12.5797 137.873 11.5515C137.597 10.5233 136.54 9.91316 135.512 10.1887C134.484 10.4642 133.874 11.521 134.149 12.5492C134.425 13.5774 135.482 14.1875 136.51 13.912Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A</g>%0A<path d="M118.274 33.9353C118.416 30.8307 120.974 28.3867 124.082 28.3867H144.671C147.779 28.3867 150.337 30.8307 150.479 33.9353L151.123 48.0046C151.275 51.3167 148.631 54.0849 145.315 54.0849H123.438C120.123 54.0849 117.478 51.3167 117.63 48.0046L118.274 33.9353Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M143.619 41.0349C144.916 41.0349 145.967 39.9839 145.967 38.6874C145.967 37.3909 144.916 36.3398 143.619 36.3398C142.322 36.3398 141.271 37.3909 141.271 38.6874C141.271 39.9839 142.322 41.0349 143.619 41.0349Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M135.291 38.3613H123.997" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M138.239 65.0234L137.528 64.8245C134.302 63.9227 130.881 63.9919 127.694 65.0234" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M140.876 60.8047L139.76 60.5968C134.895 59.69 129.897 59.7606 125.059 60.8047" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M157.414 54.6718C158.813 52.2491 162.309 52.2491 163.708 54.6718L185.048 91.6327C186.446 94.0554 184.698 97.0838 181.9 97.0838H139.222C136.424 97.0838 134.676 94.0554 136.074 91.6327L157.414 54.6718Z" fill="%23DB0000" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M157.481 83.248L163.64 83.248L163.64 65.7988L157.481 65.7988L157.481 83.248Z" fill="white" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M160.561 86.4742C158.86 86.4742 157.481 87.8529 157.481 89.5535C157.481 91.2542 158.86 92.6328 160.561 92.6328C162.261 92.6328 163.64 91.2542 163.64 89.5535C163.64 87.8529 162.261 86.4742 160.561 86.4742Z" fill="white" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_5688_91748">%0A<rect width="186" height="129" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_5688_91748">%0A<rect width="68.0322" height="56.524" fill="white" transform="translate(13.293 71.4668)"/>%0A</clipPath>%0A<clipPath id="clip2_5688_91748">%0A<rect width="76.7222" height="75.0321" fill="white" transform="translate(12.416 12.9688)"/>%0A</clipPath>%0A<clipPath id="clip3_5688_91748">%0A<rect width="23.4094" height="16.3095" fill="white" transform="matrix(0.983381 0.181552 -0.180334 0.983605 54.0117 45.5977)"/>%0A</clipPath>%0A<clipPath id="clip4_5688_91748">%0A<rect width="26.3407" height="8.99438" fill="white" transform="translate(118.712 12.0293) rotate(-15)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/aipo/GetOffer/components/UnonboardedPage/UnonboardedPage.tsx
import { jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var UnonboardedPage = ({ listingId, logger, t }) => {
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.UNONBOARDED);
  useEffect3(() => {
    logger.opsMetric({
      metricName: CustomOpsMetricName.EPOBuyerUnonboardedPageRender,
      unit: "Count",
      value: 1
    });
  }, []);
  return /* @__PURE__ */ jsxs16(SpaceBetween14, { size: "l", children: [
    /* @__PURE__ */ jsx19(TextContent6, { children: /* @__PURE__ */ jsx19("h1", { children: t("expressOffersNotAvailableForProduct") }) }),
    /* @__PURE__ */ jsx19(HeroContainer, { imageSrc: human_robot_error_default, imageAlt: t("humanRobotErrorAlt"), imageWidthPx: 186, imageHeightPx: 129, children: /* @__PURE__ */ jsx19("div", { style: { paddingLeft: "24px", paddingRight: "24px" }, children: /* @__PURE__ */ jsxs16(SpaceBetween14, { size: "m", children: [
      /* @__PURE__ */ jsxs16(TextContent6, { children: [
        /* @__PURE__ */ jsx19("h3", { children: t("startDiscussionWithSales") }),
        /* @__PURE__ */ jsx19("p", { children: t("expressOffersNotEnabledMessage") })
      ] }),
      /* @__PURE__ */ jsx19(
        Button7,
        {
          variant: "primary",
          href: marketplaceLinks5.get("RequestPrivateOffer", { listingId }),
          target: "_blank",
          iconAlign: "right",
          iconName: "external",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickFeat: "unonboarded-container",
                ClickAct: "request-custom-offer"
              }
            });
          },
          children: t("connectWithRepresentative")
        }
      )
    ] }) }) })
  ] });
};

// src/aipo/GetOffer/GetOffer.tsx
import { LoadingSpinner } from "@amzn/awsmp-max-ux-patterns/LoadingSpinner";
import { marketplaceLinks as marketplaceLinks6 } from "@amzn/awsmp-max-link-catalog/browser";

// src/aipo/GetOffer/components/UnitsStep/validation.ts
var validateUnitsStep = (artifact, t) => {
  const errorProps = {};
  let isValid = true;
  const selections = artifact.offerRequest.configurableUpfrontDimensionSelections || [];
  const hasUnits = selections.some((s2) => s2.quantity > 0);
  if (!hasUnits) {
    isValid = false;
    errorProps.unitsTableError = t("validationSelectAtLeastOneUnit");
  }
  const areUnitsOverLimit = selections.some((s2) => s2.quantity > 1e6);
  if (areUnitsOverLimit) {
    isValid = false;
    errorProps.unitsTableError = t("validationUnitsOverLimit");
  }
  const hasFractionalUnits = selections.some((s2) => s2.quantity % 1 !== 0);
  if (hasFractionalUnits) {
    isValid = false;
    errorProps.unitsTableError = t("numberOfUnitsFractionalError");
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/GetOffer/components/AssessmentStep/validation.ts
var validateAssessmentStep = (artifact, t) => {
  let isValid = true;
  const errorProps = {};
  const responses = artifact.offerRequest.qualificationResponses || [];
  responses.forEach((response, index) => {
    if (!response.response || response.response.trim() === "") {
      isValid = false;
      errorProps[`${index}`] = t("validationQuestionRequired");
    }
  });
  return {
    isValid,
    errorProps
  };
};

// src/aipo/GetOffer/GetOffer.tsx
import { ScrollToTop } from "@amzn/awsmp-max-ux-patterns/ScrollToTop";
import {
  isEpoErrorOutput as isEpoErrorOutput2,
  ErrorType,
  ContentBlockVisibility,
  AgentId as AgentId3,
  OFFER_ELIGIBILITY as OFFER_ELIGIBILITY4,
  PAYMENT_METHOD as PAYMENT_METHOD6
} from "@amzn/awsmp-max-model";

// src/aipo/GetOffer/hooks/useEpoBuyerSubmit.ts
import { useCallback as useCallback6, useState as useState7 } from "react";
import { MaxTokenData, GrantAction } from "@amzn/awsmp-max-data";
import {
  isEpoErrorOutput,
  PAYMENT_METHOD as PAYMENT_METHOD5,
  OFFER_ELIGIBILITY as OFFER_ELIGIBILITY3
} from "@amzn/awsmp-max-model";
var TOOL_NAME = "processEpoBuyerRequest";
var INTENT = { PREVIEW: "preview", CREATE_OFFER: "createOffer" };
var FLASHBAR_ID = {
  PREVIEW_REFRESHED: "epo-fps-preview-refreshed"
};
var isPreviewResult = (r2) => "preview" in r2;
var isOfferResult = (r2) => "offer" in r2;
var isPreviewNotEligibleError = (r2) => isEpoErrorOutput(r2) && r2.statusCode === 404 && r2.exceptionName === "ResourceNotFoundException";
var toPreview = (raw) => ({
  previewId: raw.previewId,
  listPrice: raw.listPrice,
  discountedPrice: raw.discountedPrice
});
var requirePublishedAnchor = (preview) => {
  if (preview.offerContractWindowAnchor === void 0) {
    throw new Error(
      "FPS preview did not return offerContractWindowAnchor; cannot freeze a schedule window. AIPO must publish the resolved contract-window anchor for FPS-eligible previews."
    );
  }
  return preview.offerContractWindowAnchor;
};
var wrapNonFatal = (error) => {
  throw { wrappedError: { error, isFatal: false } };
};
var unhandledShape = (r2) => new Error(`${TOOL_NAME}: unhandled response shape: ${JSON.stringify(r2)}`);
var useEpoBuyerSubmit = ({
  projectId,
  writeableArtifact,
  buyerOptions,
  fpsEnabled,
  flashbarManager,
  logger,
  t,
  refreshBuyerOptions,
  generateInstallmentSchedule
}) => {
  const { artifact, setArtifact, callMcpTool, commitArtifactUpdate, shareProject } = writeableArtifact;
  const [isSubmitting, setIsSubmitting] = useState7(false);
  const [isGeneratingPrivateOffer, setIsGeneratingPrivateOffer] = useState7(false);
  const userIsAuthenticated = isAuthenticated();
  const signInForOffer = useCallback6(
    () => epoBuyerSignIn({
      projectId,
      listingId: buyerOptions.listingId,
      productId: artifact.offerRequest.productId
    }),
    [projectId, buyerOptions, artifact.offerRequest]
  );
  const generateTokenAndShare = useCallback6(async () => {
    const tokens = await MaxTokenData.getInstance(logger).generateTokens([
      { action: GrantAction.RequestExpressPrivateOffer, productId: artifact.offerRequest.productId, requireUsagesRemaining: true }
    ]);
    await shareProject(projectId, tokens[0]);
    return tokens[0];
  }, [logger, projectId, shareProject, artifact.offerRequest.productId]);
  const callProcessRequest = useCallback6(
    async (args, token, override) => {
      const result = override === void 0 ? await callMcpTool(TOOL_NAME, args, token) : await callMcpTool(TOOL_NAME, args, token, override);
      return result;
    },
    [callMcpTool]
  );
  const withCommittedSchedule = useCallback6(
    (base, lockedTcv) => {
      const anchor = base.offerRequest.scheduleAnchorDate;
      if (anchor === void 0) {
        throw new Error("Cannot commit FPS offer: scheduleAnchorDate was not frozen at preview.");
      }
      const rows = generateInstallmentSchedule({
        ...readFpsScheduleInputs(base),
        durationISO: base.offerRequest.duration,
        total: lockedTcv,
        anchorDate: new Date(anchor)
      });
      if (rows === null) {
        throw new Error("Cannot commit FPS offer: the buyer's inputs did not produce a valid installment schedule.");
      }
      const paymentScheduleTerms = rows.map(({ chargeDate, chargeAmount }) => ({ chargeDate, chargeAmount }));
      return { ...base, offerRequest: { ...base.offerRequest, paymentScheduleTerms } };
    },
    [generateInstallmentSchedule]
  );
  const applyResult = useCallback6(
    async (result, base, token) => {
      if (isPreviewResult(result)) {
        const offerRequest = {
          ...base.offerRequest,
          scheduleAnchorDate: requirePublishedAnchor(result.preview),
          // `||` not `??`: "" means "not set" here, so it must fall back to the default.
          firstInstallmentDate: base.offerRequest.firstInstallmentDate || defaultFirstInvoiceDate()
        };
        const updated = { ...base, offerRequest, offerPreview: toPreview(result.preview) };
        await commitArtifactUpdate(updated, token);
        setArtifact(updated);
        return true;
      }
      if (isOfferResult(result)) {
        const updated = { ...base, offer: result.offer };
        setArtifact(updated);
        await commitArtifactUpdate(updated, token);
        return true;
      }
      return false;
    },
    [setArtifact, commitArtifactUpdate]
  );
  const recoverFromPreviewRnfe = useCallback6(
    async (token) => {
      const refreshed = await refreshBuyerOptions();
      if (refreshed && buyerOptionsSupportFps(refreshed)) {
        const currentFreq = artifact.offerRequest.frequency;
        if (currentFreq && !refreshed.allowedFrequencies.includes(currentFreq)) {
          setArtifact({ ...artifact, offer: { eligibility: OFFER_ELIGIBILITY3.INELIGIBLE } });
          return;
        }
        const retry = await callProcessRequest({ intent: INTENT.PREVIEW }, token, artifact);
        if (await applyResult(retry, artifact, token))
          return;
      }
      const fallback = await callProcessRequest({}, token);
      if (isEpoErrorOutput(fallback))
        throw fallback;
      await applyResult(fallback, artifact, token);
    },
    [refreshBuyerOptions, callProcessRequest, applyResult, artifact, setArtifact]
  );
  const handleSubmit = useCallback6(async () => {
    if (isSubmitting)
      return;
    if (!buyerOptions)
      return;
    if (!userIsAuthenticated) {
      await signInForOffer();
      return;
    }
    setIsSubmitting(true);
    try {
      const token = await generateTokenAndShare();
      const isFpsInstallments = fpsEnabled && artifact.offerRequest.paymentMethod === PAYMENT_METHOD5.INSTALLMENTS;
      if (!isFpsInstallments) {
        const result = await callProcessRequest({}, token);
        if (isEpoErrorOutput(result))
          throw result;
        await applyResult(result, artifact, token);
        return;
      }
      const previewResult = await callProcessRequest({ intent: INTENT.PREVIEW }, token, artifact);
      if (await applyResult(previewResult, artifact, token))
        return;
      if (isPreviewNotEligibleError(previewResult)) {
        await recoverFromPreviewRnfe(token);
        return;
      }
      if (isEpoErrorOutput(previewResult))
        throw previewResult;
      throw unhandledShape(previewResult);
    } catch (error) {
      if (isAuthenticationError(error)) {
        await signInForOffer();
        return;
      }
      wrapNonFatal(error);
    } finally {
      setIsSubmitting(false);
    }
  }, [
    isSubmitting,
    buyerOptions,
    userIsAuthenticated,
    signInForOffer,
    generateTokenAndShare,
    fpsEnabled,
    callProcessRequest,
    applyResult,
    recoverFromPreviewRnfe,
    artifact
  ]);
  const handleGeneratePrivateOffer = useCallback6(async () => {
    const preview = artifact.offerPreview;
    if (!preview || isGeneratingPrivateOffer)
      return;
    setIsGeneratingPrivateOffer(true);
    try {
      const token = await generateTokenAndShare();
      const committed = withCommittedSchedule(artifact, preview.discountedPrice);
      const result = await callProcessRequest(
        { intent: INTENT.CREATE_OFFER, previewId: preview.previewId, discountedPrice: preview.discountedPrice },
        token,
        committed
      );
      if (isPreviewResult(result)) {
        const refreshed = {
          ...artifact,
          offerRequest: { ...artifact.offerRequest, scheduleAnchorDate: requirePublishedAnchor(result.preview) },
          offerPreview: toPreview(result.preview)
        };
        await commitArtifactUpdate(refreshed, token);
        setArtifact(refreshed);
        flashbarManager.addItem({
          type: "warning",
          header: t("offerBeingGenerated"),
          content: t("offerPreviewLoadingMessage"),
          dismissible: true,
          id: FLASHBAR_ID.PREVIEW_REFRESHED
        });
        return;
      }
      if (isOfferResult(result)) {
        const updated = { ...artifact, offer: result.offer, offerPreview: void 0 };
        setArtifact(updated);
        await commitArtifactUpdate(updated, token);
        return;
      }
      if (isEpoErrorOutput(result))
        throw result;
      throw unhandledShape(result);
    } catch (error) {
      if (isAuthenticationError(error)) {
        await signInForOffer();
        return;
      }
      wrapNonFatal(error);
    } finally {
      setIsGeneratingPrivateOffer(false);
    }
  }, [
    isGeneratingPrivateOffer,
    artifact,
    signInForOffer,
    generateTokenAndShare,
    callProcessRequest,
    withCommittedSchedule,
    setArtifact,
    commitArtifactUpdate,
    flashbarManager,
    t
  ]);
  return { isSubmitting, isGeneratingPrivateOffer, handleSubmit, handleGeneratePrivateOffer };
};

// src/aipo/GetOffer/utils/wizard-utils.ts
function determineWizardStepKey(artifact) {
  const { offerRequest } = artifact;
  if (!offerRequest?.configurableUpfrontDimensionSelections || offerRequest.configurableUpfrontDimensionSelections.length === 0) {
    return "units";
  }
  const qualificationResponses = offerRequest?.qualificationResponses || [];
  if (!offerRequest?.duration || qualificationResponses.length === 0) {
    return "contractNeeds";
  }
  const hasIncompleteResponses = qualificationResponses.some((q) => !q.response || q.response.trim() === "");
  if (hasIncompleteResponses) {
    return "assessment";
  }
  return "review";
}
function getWizardSubmitButtonTextKey({
  isSubmitting,
  userIsAuthenticated,
  isFpsInstallments
}) {
  if (isSubmitting)
    return "generating";
  if (isFpsInstallments) {
    return userIsAuthenticated ? "submitOffer" : "signInAndSubmitOffer";
  }
  return userIsAuthenticated ? "generateMyOffer" : "signInAndGenerateOffer";
}

// src/aipo/GetOffer/leadCapture/useEpoLeadCapture.ts
import { useCallback as useCallback9, useEffect as useEffect5, useRef as useRef7, useState as useState9 } from "react";

// src/aipo/GetOffer/marketo/useMarketoForm.ts
import { useCallback as useCallback7, useEffect as useEffect4, useRef as useRef6, useState as useState8 } from "react";

// src/aipo/GetOffer/marketo/marketo-config.ts
var MARKETO_BASE_URL = "//pages.awscloud.com";
var MARKETO_MUNCHKIN_ID = "112-TZM-766";
var MARKETO_FORM_ID = 96388;
var MARKETO_SCRIPT_URL = `${MARKETO_BASE_URL}/js/forms2/js/forms2.min.js`;
var MARKETO_FORM_READY_TIMEOUT_MS = 4e3;

// src/aipo/GetOffer/marketo/useMarketoForm.ts
var COUNTRY_FIELD = "zOPprogressiveprofilingcntry";
var STATE_FIELD = "zOPprogressiveprofilingsprov";
function extractSelectOptions(form) {
  const map = {};
  const formElem = form.getFormElem?.();
  const selects = formElem?.find ? formElem.find("select") : [];
  for (const select of Array.from(selects)) {
    map[select.name] = Array.from(select.options).filter((opt) => !!opt.value).map((opt) => ({ value: opt.value, label: opt.innerText }));
  }
  return map;
}
var formInitPromise = null;
function loadScriptOnce() {
  if (window.MktoForms2)
    return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${MARKETO_SCRIPT_URL}"]`);
    if (existing) {
      if (window.MktoForms2)
        return resolve();
      existing.remove();
    }
    const script = document.createElement("script");
    script.src = MARKETO_SCRIPT_URL;
    script.async = true;
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", () => reject(new Error("Failed to load MktoForms2 script")));
    document.body.appendChild(script);
  });
}
function ensureFormElement() {
  const id = `mktoForm_${MARKETO_FORM_ID}`;
  if (document.getElementById(id))
    return;
  const el = document.createElement("form");
  el.id = id;
  el.style.display = "none";
  document.body.appendChild(el);
}
function initForm() {
  if (formInitPromise)
    return formInitPromise;
  formInitPromise = loadScriptOnce().then(
    () => new Promise((resolve, reject) => {
      if (!window.MktoForms2) {
        reject(new Error("MktoForms2 is not initialized"));
        return;
      }
      ensureFormElement();
      window.MktoForms2.loadForm(MARKETO_BASE_URL, MARKETO_MUNCHKIN_ID, MARKETO_FORM_ID);
      window.MktoForms2.whenReady((form) => resolve(form));
    })
  ).catch((e) => {
    formInitPromise = null;
    throw e;
  });
  return formInitPromise;
}
function useMarketoForm(enabled) {
  const [form, setForm] = useState8(null);
  const [error, setError] = useState8(null);
  const [status, setStatus] = useState8("loading");
  const [countryOptions, setCountryOptions] = useState8([]);
  const [stateOptions, setStateOptions] = useState8([]);
  const formRef = useRef6(null);
  useEffect4(() => {
    if (!enabled)
      return;
    let settled = false;
    const timeoutId = setTimeout(() => {
      if (settled)
        return;
      settled = true;
      setStatus("failed");
    }, MARKETO_FORM_READY_TIMEOUT_MS);
    initForm().then((f) => {
      if (settled)
        return;
      settled = true;
      clearTimeout(timeoutId);
      formRef.current = f;
      setForm(f);
      const options = extractSelectOptions(f);
      if (options[COUNTRY_FIELD]?.length)
        setCountryOptions(options[COUNTRY_FIELD]);
      setStateOptions(options[STATE_FIELD] ?? []);
      setStatus("ready");
    }).catch((e) => {
      if (settled)
        return;
      settled = true;
      clearTimeout(timeoutId);
      setError(e instanceof Error ? e : new Error("Marketo form init failed"));
      setStatus("failed");
    });
    return () => {
      settled = true;
      clearTimeout(timeoutId);
    };
  }, [enabled]);
  const updateCountry = useCallback7((countryValue) => {
    const f = formRef.current;
    if (!f)
      return;
    f.setValues({ [COUNTRY_FIELD]: countryValue });
    setStateOptions(extractSelectOptions(f)[STATE_FIELD] ?? []);
  }, []);
  return { form, error, status, countryOptions, stateOptions, updateCountry };
}

// src/aipo/GetOffer/marketo/useMarketoLeadSubmit.ts
import { useCallback as useCallback8 } from "react";

// src/aipo/GetOffer/marketo/marketoErrorObserver.ts
function observeSubmitError(form, onError) {
  const formElem = form.getFormElem();
  const buttons = formElem.find(".mktoButton").get();
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === "disabled" && mutation.oldValue === "disabled") {
        onError(readVisibleErrorText(formElem));
        return;
      }
    }
  });
  for (const button of buttons) {
    observer.observe(button, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["disabled"]
    });
  }
  return observer;
}
function readInvalidFieldNames(form) {
  const names = form.getFormElem().find(".mktoInvalid").get().map((el) => el.getAttribute("name")).filter((name) => name !== null && name.length > 0);
  const unique = Array.from(new Set(names));
  return unique.length > 0 ? unique.join(", ") : null;
}
function clearInvalidFieldMarks(form) {
  form.getFormElem().find(".mktoInvalid").get().forEach((el) => el.classList.remove("mktoInvalid"));
}
function readVisibleErrorText(formElem) {
  const detail = formElem.find(".mktoError").get().filter(isRenderedNode).map((el) => el.textContent?.trim() ?? "").filter((text) => text.length > 0).join("; ");
  return detail.length > 0 ? detail : null;
}
function isRenderedNode(el) {
  if (el.hidden)
    return false;
  const style = el.ownerDocument?.defaultView?.getComputedStyle(el);
  return !style || style.display !== "none" && style.visibility !== "hidden";
}

// src/aipo/GetOffer/marketo/useMarketoLeadSubmit.ts
var MarketoSubmitError = class extends Error {
  constructor(message, reason, detail = null) {
    super(message);
    this.reason = reason;
    this.detail = detail;
    this.name = "MarketoSubmitError";
  }
};
function useMarketoLeadSubmit(form) {
  return useCallback8(
    (values) => new Promise((resolve, reject) => {
      if (!form) {
        reject(new MarketoSubmitError("Marketo form not ready", "form-not-ready"));
        return;
      }
      form.setValues(values);
      clearInvalidFieldMarks(form);
      if (!form.validate()) {
        const detail = readInvalidFieldNames(form);
        reject(
          new MarketoSubmitError(detail ? `Marketo form validation failed: ${detail}` : "Marketo form validation failed", "validation", detail)
        );
        return;
      }
      let settled = false;
      const settle = (outcome) => {
        if (settled)
          return;
        settled = true;
        observer.disconnect();
        outcome();
      };
      const observer = observeSubmitError(
        form,
        (detail) => settle(
          () => reject(new MarketoSubmitError(detail ? `Marketo submission failed: ${detail}` : "Marketo submission failed", "observer", detail))
        )
      );
      form.onSuccess(() => {
        settle(() => resolve());
        return false;
      });
      form.submit();
    }),
    [form]
  );
}

// src/aipo/GetOffer/leadCapture/LeadCaptureStep.tsx
import Container13 from "@amzn/awsui-components-react/polaris/container";
import Header13 from "@amzn/awsui-components-react/polaris/header";
import FormField5 from "@amzn/awsui-components-react/polaris/form-field";
import Input3 from "@amzn/awsui-components-react/polaris/input";
import Select3 from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween15 from "@amzn/awsui-components-react/polaris/space-between";
import Box11 from "@amzn/awsui-components-react/polaris/box";
import Link9 from "@amzn/awsui-components-react/polaris/link";
import { AppTrans as AppTrans4 } from "@amzn/awsmp-max-translations";
import { jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var PRIVACY_NOTICE_URL = "https://aws.amazon.com/privacy/";
var TEXT_FIELDS_BEFORE = [
  { field: "email", labelKey: "leadFormEmailLabel", type: "email" },
  { field: "firstName", labelKey: "leadFormFirstNameLabel" },
  { field: "lastName", labelKey: "leadFormLastNameLabel" },
  { field: "phone", labelKey: "leadFormPhoneLabel" },
  { field: "company", labelKey: "leadFormCompanyLabel" }
];
var TEXT_FIELDS_AFTER = [{ field: "postalCode", labelKey: "leadFormPostalCodeLabel" }];
var LEAD_FIELD_ORDER = [
  ...TEXT_FIELDS_BEFORE.map((spec) => spec.field),
  "country",
  "state",
  ...TEXT_FIELDS_AFTER.map((spec) => spec.field)
];
var ERROR_MESSAGE_KEY = {
  invalidEmail: "leadFormErrorInvalidEmail",
  invalidPhone: "leadFormErrorInvalidPhone"
};
var LeadCaptureStep = ({
  state,
  errors,
  onIdentityChange,
  fieldRefs,
  countryOptions,
  stateOptions,
  logger,
  t
}) => {
  useSubPageHit(logger, PAGE_CONTEXT.SUB_PAGE_TYPES.ENTER_CONTACT_INFORMATION);
  const errorText = (field, labelKey) => {
    const code = errors[field];
    if (!code)
      return void 0;
    return code === "required" ? t("leadFormErrorRequired", { field: t(labelKey) }) : t(ERROR_MESSAGE_KEY[code]);
  };
  const privacyLink = /* @__PURE__ */ jsx20(Link9, { external: true, href: PRIVACY_NOTICE_URL, variant: "primary", fontSize: "inherit" });
  const renderTextField = ({ field, labelKey, type }) => /* @__PURE__ */ jsx20(FormField5, { label: t(labelKey), errorText: errorText(field, labelKey), children: /* @__PURE__ */ jsx20(
    Input3,
    {
      ref: (r2) => {
        fieldRefs.current[field] = r2;
      },
      value: state.identity[field],
      type: type ?? "text",
      "data-testid": `lead-capture-${field}`,
      ariaRequired: true,
      onChange: ({ detail }) => onIdentityChange(field, detail.value)
    }
  ) }, field);
  const renderSelect = (field, labelKey, options, placeholderKey, required = false) => {
    const selectedOption = options.find((o) => o.label === state.identity[field]) ?? null;
    return /* @__PURE__ */ jsx20(FormField5, { label: t(labelKey), errorText: errorText(field, labelKey), children: /* @__PURE__ */ jsx20(
      Select3,
      {
        ref: (r2) => {
          fieldRefs.current[field] = r2;
        },
        selectedOption,
        options,
        filteringType: "auto",
        placeholder: t(placeholderKey),
        "data-testid": `lead-capture-${field}`,
        ariaRequired: required,
        onChange: ({ detail }) => onIdentityChange(field, detail.selectedOption?.label ?? "")
      }
    ) }, field);
  };
  return /* @__PURE__ */ jsxs17(SpaceBetween15, { size: "l", children: [
    /* @__PURE__ */ jsx20(Container13, { header: /* @__PURE__ */ jsx20(Header13, { variant: "h2", children: t("contactInformationHeader") }), "data-testid": "lead-capture-step", children: /* @__PURE__ */ jsxs17(SpaceBetween15, { size: "l", children: [
      TEXT_FIELDS_BEFORE.map(renderTextField),
      renderSelect("country", "leadFormCountryLabel", countryOptions, "leadFormCountryPlaceholder", true),
      isStateFieldShown(stateOptions) && renderSelect("state", "leadFormStateLabel", stateOptions, "leadFormStatePlaceholder", true),
      TEXT_FIELDS_AFTER.map(renderTextField)
    ] }) }),
    /* @__PURE__ */ jsx20(Container13, { header: /* @__PURE__ */ jsx20(Header13, { variant: "h2", children: t("leadFormDisclaimersHeader") }), children: /* @__PURE__ */ jsxs17(SpaceBetween15, { size: "xxs", children: [
      /* @__PURE__ */ jsx20(Box11, { variant: "h4", children: t("leadFormPrivacyNoticeHeader") }),
      /* @__PURE__ */ jsx20(Box11, { variant: "p", children: /* @__PURE__ */ jsx20(AppTrans4, { i18nKey: "leadFormPrivacyNoticeBody", components: { privacyLink } }) }),
      /* @__PURE__ */ jsx20(Box11, { variant: "small", children: /* @__PURE__ */ jsx20(AppTrans4, { i18nKey: "leadFormPrivacyNoticeDataHandling", components: { privacyLink } }) })
    ] }) })
  ] });
};

// src/aipo/GetOffer/leadCapture/useEpoLeadCapture.ts
var NOOP_FORM_PROPS = {
  state: { identity: EMPTY_LEAD_IDENTITY },
  errors: {},
  onIdentityChange: () => void 0,
  // Never rendered when disabled, so a throwaway ref container is fine.
  fieldRefs: { current: {} },
  countryOptions: [],
  stateOptions: []
};
var LOG = "[epo-lead-capture]";
function useEpoLeadCapture(args) {
  const { enabled, leadCampaignId, offer, offerRequest, logger } = args;
  const [state, setState] = useState9({ identity: EMPTY_LEAD_IDENTITY });
  const [errors, setErrors] = useState9({});
  const fieldRefs = useRef7({});
  const attemptedStatusesRef = useRef7(/* @__PURE__ */ new Set());
  const issuedStatusesRef = useRef7(/* @__PURE__ */ new Set());
  const [leadSubmitted, setLeadSubmitted] = useState9(false);
  const hasTerminalStatusAttempted = () => attemptedStatusesRef.current.has("epo-created") || attemptedStatusesRef.current.has("epo-not-qualified");
  const campaignId = leadCampaignId?.trim() || null;
  const { form, status: formStatus, error: formError, countryOptions, stateOptions, updateCountry } = useMarketoForm(enabled);
  const submitViaSdk = useMarketoLeadSubmit(form);
  const emitLeadOutcome = useCallback9(
    (fired, complement) => {
      logger.opsMetric({ metricName: fired, value: 1, unit: "Count" });
      logger.opsMetric({ metricName: complement, value: 0, unit: "Count" });
    },
    [logger]
  );
  const formLoadFailureReportedRef = useRef7(false);
  useEffect5(() => {
    if (!enabled || formStatus !== "failed" || formLoadFailureReportedRef.current)
      return;
    formLoadFailureReportedRef.current = true;
    logger.warn(`${LOG} Marketo form failed to load \u2014 falling back to legacy wizard`, { error: formError ? String(formError) : "timeout" });
    emitLeadOutcome(CustomOpsMetricName.EPOBuyerLeadFormLoadFailure, CustomOpsMetricName.EPOBuyerLeadFormLoadSuccess);
  }, [enabled, formStatus, formError, logger, emitLeadOutcome]);
  const formLoadSuccessReportedRef = useRef7(false);
  useEffect5(() => {
    if (!enabled || formStatus !== "ready" || formLoadSuccessReportedRef.current)
      return;
    formLoadSuccessReportedRef.current = true;
    emitLeadOutcome(CustomOpsMetricName.EPOBuyerLeadFormLoadSuccess, CustomOpsMetricName.EPOBuyerLeadFormLoadFailure);
  }, [enabled, formStatus, logger, emitLeadOutcome]);
  const setIdentityField = useCallback9(
    (field, value) => {
      setState((prev) => {
        const identity = field === "country" ? { ...prev.identity, country: value, state: "" } : { ...prev.identity, [field]: value };
        return { ...prev, identity };
      });
      setErrors((prev) => ({ ...prev, [field]: void 0 }));
      if (field === "country")
        updateCountry(countryOptions.find((o) => o.label === value)?.value ?? "");
    },
    [updateCountry, countryOptions]
  );
  const validateStep = useCallback9(() => {
    const validationErrors = validateLeadCapture(state, isStateFieldShown(stateOptions));
    setErrors(validationErrors);
    const valid = Object.keys(validationErrors).length === 0;
    if (!valid) {
      const firstErrored = LEAD_FIELD_ORDER.find((field) => validationErrors[field] !== void 0);
      if (firstErrored) {
        requestAnimationFrame(() => fieldRefs.current[firstErrored]?.focus());
      }
    }
    return valid;
  }, [state, stateOptions]);
  const buildValues = useCallback9(
    (status) => {
      if (!enabled)
        return null;
      const gates = {
        complete: isLeadCaptureComplete(state, isStateFieldShown(stateOptions)),
        hasCampaignId: !!campaignId,
        statusAlreadyAttempted: attemptedStatusesRef.current.has(status),
        // A late drop-off must not re-attempt after a terminal lead was already
        // attempted — the terminal signal is the highest-value one, so once we
        // have tried it we stop, whether or not its POST issued.
        terminalAlreadyAttempted: status === "epo-started" && hasTerminalStatusAttempted()
      };
      if (!gates.complete || !campaignId || gates.statusAlreadyAttempted || gates.terminalAlreadyAttempted) {
        logger.debug(`${LOG} skip build \u2014 gate not satisfied`, { epoStatus: status, ...gates });
        return null;
      }
      const blob = buildReconciliationBlob({
        status,
        dimensions: offerRequest.configurableUpfrontDimensionSelections,
        // Only attach the account id when the authoritative signed-in cookie
        // (`aws-userInfo-signed`) is present. The account id itself comes from the
        // JS-readable `aws-userInfo` cookie, which carries no verifiable expiry —
        // gating on the signed-in signal means a signed-out/expired session emits
        // no account id rather than a stale one (worst case: the wrong account).
        awsAccountId: typeof document === "undefined" || !isAuthenticated() ? void 0 : parseAwsAccountId(document.cookie)
      });
      logger.info(`${LOG} built lead values`, {
        epoStatus: status,
        campaignId,
        dimensionCount: blob.requestedDimensions.length,
        hasAwsAccountId: !!blob.awsAccountId
      });
      return toMarketoFieldValues({
        identity: state.identity,
        // Country and State options are dynamic (from the live form); identity
        // stores the display labels, so resolve each to its Marketo value here.
        // Falls back to the stored string when no option matches (e.g. options not
        // yet loaded — though the form-ready gate makes that unreachable here).
        countryValue: countryOptions.find((o) => o.label === state.identity.country)?.value ?? state.identity.country,
        stateValue: stateOptions.find((o) => o.label === state.identity.state)?.value ?? state.identity.state,
        campaignId,
        blob
      });
    },
    [enabled, state, countryOptions, stateOptions, campaignId, offerRequest.configurableUpfrontDimensionSelections, logger]
  );
  const submitLead = useCallback9(
    (status) => {
      const values = buildValues(status);
      if (!values)
        return;
      attemptedStatusesRef.current.add(status);
      setLeadSubmitted(true);
      logger.info(`${LOG} submitting lead`, { epoStatus: status, campaignId });
      submitViaSdk(values).then(() => {
        issuedStatusesRef.current.add(status);
        setLeadSubmitted(true);
        logger.info(`${LOG} lead submission succeeded`, { epoStatus: status, campaignId });
        emitLeadOutcome(CustomOpsMetricName.EPOBuyerLeadSubmitSuccess, CustomOpsMetricName.EPOBuyerLeadSubmitFailure);
      }).catch((error) => {
        const reason = error instanceof MarketoSubmitError ? error.reason : "unknown";
        const releaseGuard = reason === "form-not-ready" || reason === "unknown";
        if (releaseGuard) {
          attemptedStatusesRef.current.delete(status);
        }
        if (reason === "observer") {
          issuedStatusesRef.current.add(status);
          setLeadSubmitted(true);
        } else {
          setLeadSubmitted(issuedStatusesRef.current.size > 0);
        }
        const metricName = selectFailureMetric(reason, status);
        logger.warn(`${LOG} lead submission failed`, {
          epoStatus: status,
          reason,
          metricName,
          detail: error instanceof MarketoSubmitError ? error.detail : null,
          errorMessage: error instanceof Error ? error.message : String(error),
          errorName: error instanceof Error ? error.name : typeof error
        });
        emitLeadOutcome(metricName, CustomOpsMetricName.EPOBuyerLeadSubmitSuccess);
      });
    },
    [buildValues, submitViaSdk, campaignId, logger, emitLeadOutcome]
  );
  const submitLeadRef = useRef7(submitLead);
  submitLeadRef.current = submitLead;
  const terminalStatus = toEpoLeadStatus(offer);
  const identityComplete = isLeadCaptureComplete(state, isStateFieldShown(stateOptions));
  useEffect5(() => {
    if (terminalStatus === "epo-started")
      return;
    if (!identityComplete || !campaignId)
      return;
    if (enabled)
      logger.debug(`${LOG} offer resolved`, { epoStatus: terminalStatus });
    submitLeadRef.current(terminalStatus);
  }, [terminalStatus, identityComplete, campaignId, enabled, logger]);
  const submitEarlyLead = useCallback9(() => {
    if (!enabled)
      return;
    if (toEpoLeadStatus(offer) !== "epo-started")
      return;
    submitLead("epo-started");
  }, [enabled, offer, submitLead]);
  useEffect5(() => {
    if (!enabled)
      return;
    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        logger.debug(`${LOG} page hidden \u2014 attempting drop-off lead`);
        submitLead("epo-started");
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [enabled, submitLead, logger]);
  if (!enabled) {
    return {
      formProps: { ...NOOP_FORM_PROPS, logger },
      validateStep: () => true,
      submitEarlyLead: () => void 0,
      leadSubmitted: false,
      identity: EMPTY_LEAD_IDENTITY,
      // Nothing loads when disabled — report "failed" so the caller's ready-gate
      // uniformly means "show lead capture" without a disabled special case.
      formStatus: "failed"
    };
  }
  return {
    formProps: { state, errors, onIdentityChange: setIdentityField, fieldRefs, countryOptions, stateOptions, logger },
    validateStep,
    submitEarlyLead,
    leadSubmitted,
    identity: state.identity,
    formStatus
  };
}

// src/aipo/GetOffer/GetOffer.tsx
import Box12 from "@amzn/awsui-components-react/polaris/box";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG7 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { Fragment as Fragment3, jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
var toClientBuyerOptions = (data) => ({
  ...data,
  configurableUpfrontPricingTerms: {
    ...data.configurableUpfrontPricingTerms,
    rateCards: data.configurableUpfrontPricingTerms.rateCards.map((card) => ({
      dimensionKey: card.dimensionKey,
      displayName: card.displayName,
      unit: card.unit,
      description: card.description,
      supplementaryDescription: card.sellerGuidance
    }))
  }
});
var isInvalidProductIdError = (error) => isEpoErrorOutput2(error) && error.statusCode === 400 && error.exceptionName === ErrorType.VALIDATION_EXCEPTION;
var GetOffer = ({
  projectId,
  validateProductId,
  writeableArtifact,
  renderMessages,
  layoutComponents,
  flashbarManager,
  logger,
  queryParamListingId,
  setBreadcrumbs,
  NotFound,
  withAsyncErrors,
  t,
  renderContext,
  helpPanelsEnabled,
  hasAttributionId,
  leadsCaptureEnabled = false,
  generateInstallmentSchedule,
  scheduleAnchorDate
}) => {
  const { artifact, isArtifactLocked, setArtifact, callMcpTool, commitArtifactUpdate, sendMessage } = writeableArtifact;
  const effectiveScheduleAnchorDate = artifact.offerRequest.scheduleAnchorDate ? new Date(artifact.offerRequest.scheduleAnchorDate) : scheduleAnchorDate;
  const [buyerOptions, setBuyerOptions] = useState10(null);
  const [isUnonboarded, setIsUnonboarded] = useState10(false);
  const effectiveFpsEnabled = buyerOptionsSupportFps(buyerOptions);
  const standardFlowLogged = useRef8(false);
  useEffect6(() => {
    if (buyerOptions !== null && !effectiveFpsEnabled && !standardFlowLogged.current) {
      standardFlowLogged.current = true;
      logger.info("non-FPS buyerOptions; rendering standard EPO flow", {
        productId: artifact.offerRequest.productId,
        listingId: buyerOptions.listingId
      });
    }
  }, [buyerOptions, effectiveFpsEnabled, logger]);
  const leadCampaignId = artifact.buyerOptions?.leadCampaignId;
  const leadCaptureEligible = leadsCaptureEnabled && !!leadCampaignId;
  const leadCapture = useEpoLeadCapture({
    enabled: leadCaptureEligible,
    // AIPOS-sourced EPO Marketo campaign id from the buyer-options artifact.
    leadCampaignId,
    offer: artifact.offer,
    offerRequest: artifact.offerRequest,
    logger
  });
  const leadCaptureActive = leadCaptureEligible && leadCapture.formStatus === "ready";
  const leadSubmitted = leadCaptureActive && leadCapture.leadSubmitted;
  const hasQuestionnaireStep = (artifact.offerRequest?.qualificationResponses ?? []).length > 0;
  const stepRegistry = [
    { key: "lead", present: leadCaptureActive },
    { key: "units", present: true },
    { key: "contractNeeds", present: true },
    { key: "assessment", present: hasQuestionnaireStep },
    { key: "review", present: true }
  ].filter((s2) => s2.present);
  const stepKeys = stepRegistry.map((s2) => s2.key);
  const stepIndex = (key) => Math.max(0, stepKeys.indexOf(key));
  const stepNumber = (key) => stepIndex(key) + 1;
  const [initialArtifactStepKey] = useState10(() => determineWizardStepKey(artifact));
  const [activeStepIndex, setActiveStepIndex] = useState10(null);
  const openOnLeadStep = leadCaptureActive && initialArtifactStepKey === "units";
  const resolvedStepIndex = activeStepIndex ?? stepIndex(openOnLeadStep ? "lead" : initialArtifactStepKey);
  const isReviewStep = stepKeys[resolvedStepIndex] === "review";
  const isLeadStep = stepKeys[resolvedStepIndex] === "lead";
  const [stepErrors, setStepErrors] = useState10({});
  const [contractDatePref, setContractDatePref] = useState10(artifact.offerRequest?.futureStartDate ? "custom" : "auto");
  const [helpPanelOpen, setHelpPanelOpen] = useState10(false);
  const [helpPanelPathslug, setHelpPanelPathslug] = useState10(HELP_PANEL_PATHSLUG7.EPO_SPECIFY_UNITS);
  const { LayoutHelpPanel } = layoutComponents;
  const openHelpPanel = useCallback10((pathslug) => {
    setHelpPanelPathslug(pathslug);
    setHelpPanelOpen(true);
  }, []);
  const buyerOptionsMessageSent = useRef8(false);
  const [overviewExpanded, setOverviewExpanded] = useState10(true);
  const handleShowChat = React4.useCallback(() => {
    if (isArtifactLocked)
      return;
    setOverviewExpanded(false);
    if (renderContext?.agent?.agentId === AgentId3.EpoBuyerUnitGuidance)
      return;
    withAsyncErrors(
      sendMessage([
        { text: t("helpMeEstimateUnits"), visibility: ContentBlockVisibility.DISPLAY_ONLY },
        { switchAgent: { agentId: AgentId3.EpoBuyerUnitGuidance, reason: "Buyer opened chat panel" } }
      ])
    );
  }, [isArtifactLocked, renderContext?.agent?.agentId, sendMessage, withAsyncErrors, t]);
  useEffect6(() => {
    validateProductId();
  }, []);
  usePageHit(logger, hasAttributionId ? PAGE_CONTEXT.REQUEST_WITH_LEAD_REFERRAL_PAGE_TYPE : PAGE_CONTEXT.PAGE_TYPE);
  const userIsAuthenticated = isAuthenticated();
  useEffect6(() => {
    if (buyerOptionsMessageSent.current || isArtifactLocked)
      return;
    const isTerminalOrPreview = artifact.offer !== void 0 || artifact.offerPreview !== void 0;
    const needsQuestions = artifact.offerRequest?.qualificationResponses === void 0 && !isTerminalOrPreview;
    const preloadedOptions = artifact.buyerOptions;
    if (preloadedOptions) {
      buyerOptionsMessageSent.current = true;
      setBuyerOptions(toClientBuyerOptions(preloadedOptions));
      setBreadcrumbs([
        { text: t("awsMarketplace"), href: marketplaceLinks6.get("Home"), isAbsoluteUrl: true },
        {
          text: preloadedOptions.productName,
          href: marketplaceLinks6.get("ListingDetails", { listingId: preloadedOptions.listingId }),
          isAbsoluteUrl: true
        },
        { text: t("getExpressPrivateOffer"), href: "/#/epo/offer" }
      ]);
      if (needsQuestions)
        withAsyncErrors(loadQuestions());
      return;
    }
    const loadBuyerOptions = async () => {
      buyerOptionsMessageSent.current = true;
      try {
        const result = await callMcpTool("getExpressPrivateOfferBuyerOptions", {
          productId: artifact.offerRequest.productId
        });
        setBuyerOptions(result);
        setBreadcrumbs([
          { text: t("awsMarketplace"), href: marketplaceLinks6.get("Home"), isAbsoluteUrl: true },
          {
            text: result.productName,
            href: marketplaceLinks6.get("ListingDetails", { listingId: result.listingId }),
            isAbsoluteUrl: true
          },
          { text: t("getExpressPrivateOffer"), href: "/#/epo/offer" }
        ]);
      } catch (error) {
        if (isEpoErrorOutput2(error) && error.statusCode === 404) {
          setIsUnonboarded(true);
        } else if (isInvalidProductIdError(error)) {
          throw {
            wrappedError: {
              error,
              isNotFound: true
            }
          };
        } else {
          throw {
            wrappedError: {
              error,
              isFatal: true
            }
          };
        }
        return;
      }
      if (needsQuestions)
        await loadQuestions();
    };
    withAsyncErrors(loadBuyerOptions());
  }, [isArtifactLocked, callMcpTool]);
  const offer = artifact.offer;
  const offerPreview = artifact.offerPreview;
  const hasTerminalState = offer && (offer.eligibility === OFFER_ELIGIBILITY4.ELIGIBLE || offer.eligibility === OFFER_ELIGIBILITY4.INELIGIBLE);
  const eligibleOffer = offer && offer.eligibility === OFFER_ELIGIBILITY4.ELIGIBLE;
  const onConfigurePaymentPlan = effectiveFpsEnabled && artifact.offerRequest.paymentMethod === PAYMENT_METHOD6.INSTALLMENTS && offerPreview !== void 0 && !eligibleOffer && offer?.eligibility !== OFFER_ELIGIBILITY4.INELIGIBLE;
  const showSuccessOrPreview = hasTerminalState || offerPreview !== void 0;
  useEffect6(() => {
    const unloadEvent = (event) => {
      if (!isReviewStep || onConfigurePaymentPlan) {
        event.preventDefault();
        event.returnValue = "";
        return t("unsavedChangesWarning");
      }
    };
    window.addEventListener("beforeunload", unloadEvent);
    return () => window.removeEventListener("beforeunload", unloadEvent);
  }, [isReviewStep, onConfigurePaymentPlan]);
  useEffect6(() => {
    if (!buyerOptions)
      return;
    const baseCrumbs = [
      { text: t("awsMarketplace"), href: marketplaceLinks6.get("Home"), isAbsoluteUrl: true },
      {
        text: buyerOptions.productName,
        href: marketplaceLinks6.get("ListingDetails", { listingId: buyerOptions.listingId }),
        isAbsoluteUrl: true
      }
    ];
    const offerCrumb = { text: t("getExpressPrivateOffer"), href: onConfigurePaymentPlan ? "" : "/#/epo/offer" };
    setBreadcrumbs([...baseCrumbs, offerCrumb]);
  }, [onConfigurePaymentPlan, buyerOptions, setBreadcrumbs, t]);
  const cancelUrl = React4.useMemo(() => {
    if (!buyerOptions) {
      return marketplaceLinks6.get("Home");
    }
    return marketplaceLinks6.get("ListingDetails", { listingId: buyerOptions.listingId });
  }, [buyerOptions]);
  const refreshBuyerOptions = useCallback10(async () => {
    try {
      const result = await callMcpTool("getExpressPrivateOfferBuyerOptions", {
        productId: artifact.offerRequest.productId
      });
      setBuyerOptions(result);
      return result;
    } catch {
      return null;
    }
  }, [callMcpTool, artifact.offerRequest.productId]);
  const { isSubmitting, isGeneratingPrivateOffer, handleSubmit, handleGeneratePrivateOffer } = useEpoBuyerSubmit({
    projectId,
    writeableArtifact,
    buyerOptions,
    fpsEnabled: effectiveFpsEnabled,
    flashbarManager,
    logger,
    t,
    refreshBuyerOptions,
    generateInstallmentSchedule
  });
  const clearStepErrors = () => {
    setStepErrors({});
  };
  const clearFieldError = (errorKey) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[errorKey];
      return newErrors;
    });
  };
  const stepValidations = {
    // Lead capture (when active): the hook owns its own field errors, so this
    // entry only reports validity to block Next.
    ...leadCaptureActive ? { lead: () => ({ isValid: leadCapture.validateStep(), errorProps: {} }) } : {},
    units: (artifact2) => validateUnitsStep(artifact2, t),
    contractNeeds: (artifact2) => validateContractNeedsStep(artifact2, contractDatePref, buyerOptions, t),
    assessment: (artifact2) => validateAssessmentStep(artifact2, t)
  };
  const validateCurrentStep = () => {
    const validation = stepValidations[stepKeys[resolvedStepIndex]]?.(artifact);
    if (validation && !validation.isValid) {
      setStepErrors(validation.errorProps);
      return false;
    }
    return true;
  };
  const loadQuestions = async () => {
    try {
      const result = await callMcpTool("getExpressPrivateOfferBuyerQuestions", {
        productId: artifact.offerRequest.productId
      });
      const formattedQuestions = (result.questions ?? []).map((q) => ({
        question: q.question,
        response: "",
        _exampleResponse: q.exampleResponse || ""
      }));
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          qualificationResponses: formattedQuestions
        }
      }));
    } catch (error) {
      throw {
        wrappedError: { error, isFatal: true }
      };
    }
  };
  if (isUnonboarded) {
    if (!queryParamListingId) {
      return /* @__PURE__ */ jsx21(NotFound, {});
    } else {
      return /* @__PURE__ */ jsxs18(Fragment3, { children: [
        /* @__PURE__ */ jsx21(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx21(UnonboardedPage, { listingId: queryParamListingId, logger, t })
      ] });
    }
  }
  if (showSuccessOrPreview && buyerOptions) {
    if (offer && offer.eligibility === OFFER_ELIGIBILITY4.INELIGIBLE) {
      return /* @__PURE__ */ jsxs18(Fragment3, { children: [
        /* @__PURE__ */ jsx21(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx21(IneligiblePage, { buyerOptions, logger, t, leadSubmitted })
      ] });
    }
    const contractTotal = offer && offer.eligibility === OFFER_ELIGIBILITY4.ELIGIBLE ? offer.discountedPrice : offerPreview?.discountedPrice ?? 0;
    if (onConfigurePaymentPlan) {
      return /* @__PURE__ */ jsxs18(Fragment3, { children: [
        /* @__PURE__ */ jsx21(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx21(
          ConfigurePaymentPlanPage,
          {
            writeableArtifact,
            onCancel: () => window.location.href = cancelUrl,
            onGenerateOffer: () => withAsyncErrors(handleGeneratePrivateOffer()),
            isGeneratingOffer: isGeneratingPrivateOffer,
            logger,
            t,
            allowedFrequencies: buyerOptions.allowedFrequencies,
            initialPaymentAllowed: buyerOptions.initialPaymentAllowed,
            contractTotal,
            currencyCode: buyerOptions.currencyCode,
            generateInstallmentSchedule,
            scheduleAnchorDate: effectiveScheduleAnchorDate,
            renewalCyclePreview: artifact.buyerOptions?.renewalCyclePreview,
            helpPanelsEnabled,
            openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
          }
        ),
        helpPanelsEnabled && /* @__PURE__ */ jsx21(LayoutHelpPanel, { pathslug: helpPanelPathslug, open: helpPanelOpen, onToggle: setHelpPanelOpen })
      ] });
    }
    return /* @__PURE__ */ jsxs18(Fragment3, { children: [
      /* @__PURE__ */ jsx21(ScrollToTop, { forceScroll: true }),
      /* @__PURE__ */ jsx21(
        SuccessPage,
        {
          writeableArtifact,
          buyerOptions,
          flashbarManager,
          logger,
          withAsyncErrors,
          projectId,
          t,
          fpsEnabled: effectiveFpsEnabled,
          generateInstallmentSchedule,
          scheduleAnchorDate: effectiveScheduleAnchorDate,
          contractTotal,
          leadSubmitted,
          leadIdentity: leadCapture.identity
        }
      )
    ] });
  }
  const awaitingLeadForm = leadCaptureEligible && leadCapture.formStatus === "loading";
  if (!buyerOptions || artifact.offerRequest?.qualificationResponses === void 0 || awaitingLeadForm) {
    return /* @__PURE__ */ jsx21(LoadingSpinner, {});
  }
  const unitsStepProps = {
    buyerData: buyerOptions,
    errors: stepErrors,
    clearFieldError,
    writeableArtifact,
    isArtifactLocked,
    renderMessages,
    layoutComponents,
    openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0,
    logger,
    t,
    onShowChat: handleShowChat
  };
  const requestOfferInfo = helpPanelsEnabled ? /* @__PURE__ */ jsx21(
    Link10,
    {
      variant: "info",
      ariaLabel: t("infoAriaLabel", { section: t("getExpressPrivateOffer") }),
      onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG7.BUYER_REQUEST_OFFER),
      children: t("info")
    }
  ) : void 0;
  const stepContent = {
    // Step 1 is renamed "Enter contact information", no step
    // description, and the unit-selection table lives on the units step. The
    // "Getting your private offer" overview sits at the top of the FIRST step —
    // the lead step here (above the contact form), the units step otherwise.
    lead: {
      title: t("enterContactInformationTitle"),
      info: requestOfferInfo,
      content: /* @__PURE__ */ jsxs18(SpaceBetween16, { size: "l", children: [
        /* @__PURE__ */ jsx21(EpoOverview, { t, leadsCaptureEnabled: leadCaptureActive }),
        /* @__PURE__ */ jsx21(LeadCaptureStep, { ...leadCapture.formProps, t })
      ] })
    },
    units: {
      title: leadCaptureActive ? t("enterUnitsHeader") : t("specifyUnitsTitle"),
      description: leadCaptureActive ? t("enterUnitsStepDescription") : t("specifyUnitsDescription"),
      info: helpPanelsEnabled ? /* @__PURE__ */ jsx21(Link10, { variant: "info", onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG7.EPO_SPECIFY_UNITS), children: t("info") }) : void 0,
      // Legacy (no lead step): the overview leads the units step, which is step 1.
      // Under lead capture the overview already rendered on the lead step.
      content: leadCaptureActive ? /* @__PURE__ */ jsx21(UnitsStep, { ...unitsStepProps }) : /* @__PURE__ */ jsxs18(SpaceBetween16, { size: "l", children: [
        /* @__PURE__ */ jsx21(EpoOverview, { t, expanded: overviewExpanded, onExpandedChange: setOverviewExpanded }),
        /* @__PURE__ */ jsx21(UnitsStep, { ...unitsStepProps })
      ] })
    },
    contractNeeds: {
      title: t("enterContractNeedsTitle"),
      description: t("enterContractNeedsDescription"),
      content: /* @__PURE__ */ jsx21(
        ContractNeedsStep,
        {
          errors: stepErrors,
          clearFieldError,
          contractDatePref,
          setContractDatePref,
          eulaUrl: buyerOptions.eulaUrl,
          listingId: buyerOptions.listingId,
          buyerOptions,
          writeableArtifact,
          isArtifactLocked,
          logger,
          t,
          fpsEnabled: effectiveFpsEnabled,
          openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
        }
      )
    },
    assessment: {
      title: t("answerQuestionnaireTitle"),
      description: t("answerQuestionnaireDescription"),
      content: /* @__PURE__ */ jsx21(
        AssessmentStep,
        {
          errors: stepErrors,
          clearFieldError,
          writeableArtifact,
          isArtifactLocked,
          logger,
          t
        }
      )
    },
    review: {
      title: t("reviewYourOfferTitle"),
      content: /* @__PURE__ */ jsx21(
        ReviewOfferStep,
        {
          onEditStep: (key) => setActiveStepIndex(stepIndex(key)),
          writeableArtifact,
          isArtifactLocked,
          logger,
          buyerOptions,
          t,
          fpsEnabled: effectiveFpsEnabled,
          editableStepNumbers: {
            lead: stepNumber("lead"),
            units: stepNumber("units"),
            contractNeeds: stepNumber("contractNeeds"),
            assessment: stepNumber("assessment")
          },
          leadIdentity: leadCapture.identity,
          openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
        }
      )
    }
  };
  return /* @__PURE__ */ jsxs18(SpaceBetween16, { size: "xs", children: [
    helpPanelsEnabled && /* @__PURE__ */ jsx21(LayoutHelpPanel, { pathslug: helpPanelPathslug, open: helpPanelOpen, onToggle: setHelpPanelOpen }),
    /* @__PURE__ */ jsx21(
      Wizard,
      {
        activeStepIndex: resolvedStepIndex,
        i18nStrings: isLeadStep ? { nextButton: t("leadFormSubmitAndContinue") } : void 0,
        submitButtonText: t(
          getWizardSubmitButtonTextKey({
            isSubmitting,
            userIsAuthenticated,
            isFpsInstallments: effectiveFpsEnabled && artifact.offerRequest.paymentMethod === PAYMENT_METHOD6.INSTALLMENTS
          })
        ),
        isLoadingNextStep: isSubmitting || isArtifactLocked,
        onSubmit: () => {
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "review-actions",
              ClickAct: "generate-private-offer"
            },
            value: 1,
            unit: "Count"
          });
          withAsyncErrors(handleSubmit());
        },
        onNavigate: async ({ detail }) => {
          const isValid = validateCurrentStep();
          if (!isValid) {
            return;
          }
          clearStepErrors();
          if (detail.reason === "next") {
            if (isLeadStep)
              leadCapture.submitEarlyLead();
            await commitArtifactUpdate();
          }
          setActiveStepIndex(detail.requestedStepIndex);
        },
        steps: stepKeys.map((key) => {
          const { title, description, info, content } = stepContent[key];
          return { title, description, info, content };
        }),
        onCancel: () => window.location.href = cancelUrl
      }
    ),
    isSubmitting && /* @__PURE__ */ jsx21("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-end" }, children: /* @__PURE__ */ jsx21(Box12, { variant: "small", color: "text-status-inactive", children: t("offerPreviewLoadingMessage") }) })
  ] });
};

// src/aipo/GetOffer/constants/mockData.ts
var mockQualificationResponses = [
  {
    response: "",
    question: "What is your company size?",
    _exampleResponse: "Ex. 1-50 employees, 51-200 employees, 200+ employees"
  },
  {
    response: "",
    question: "What industry is your company in?",
    _exampleResponse: "Ex. Healthcare, Technology, Finance, Retail, Manufacturing"
  },
  {
    response: "",
    question: "What will you use this product for?",
    _exampleResponse: "Ex. Data analytics, Customer management, Reporting, Compliance"
  }
];

// src/aipo/GetOffer/utils/useAttributionIdCapture.ts
import { useRef as useRef9 } from "react";

// src/aipo/GetOffer/utils/attribution-id-store.ts
var STORAGE_PREFIX = "epo:offer:epo_ref:";
var TTL_MS = 7 * 24 * 60 * 60 * 1e3;
function writeAttributionId(productId, attributionId, logger) {
  try {
    const key = `${STORAGE_PREFIX}${productId}`;
    const entry = { attributionId, capturedAt: Date.now() };
    localStorage.setItem(key, JSON.stringify(entry));
    return true;
  } catch (e) {
    logger.warn("attribution-id-store: failed to write localStorage", { productId, attributionId, error: String(e) });
    return false;
  }
}
function isStoredEntry(value) {
  return typeof value === "object" && value !== null && typeof value.attributionId === "string" && typeof value.capturedAt === "number";
}
function readAttributionId(productId, logger) {
  try {
    const key = `${STORAGE_PREFIX}${productId}`;
    const raw = localStorage.getItem(key);
    if (!raw)
      return void 0;
    const parsed = JSON.parse(raw);
    if (!isStoredEntry(parsed))
      return void 0;
    if (Date.now() - parsed.capturedAt >= TTL_MS) {
      localStorage.removeItem(key);
      return void 0;
    }
    return parsed.attributionId;
  } catch (e) {
    logger.warn("attribution-id-store: failed to read localStorage", { productId, error: String(e) });
    return void 0;
  }
}

// src/aipo/GetOffer/utils/useAttributionIdCapture.ts
var MAX_ATTRIBUTION_ID_LENGTH = 128;
function useAttributionIdCapture(productId, attributionId, logger) {
  const capturedRef = useRef9(false);
  if (capturedRef.current || !attributionId)
    return;
  capturedRef.current = true;
  if (attributionId.length > MAX_ATTRIBUTION_ID_LENGTH) {
    logger.opsMetric({ metricName: CustomOpsMetricName.EPOBuyerLeadReferralValueInvalid, value: 1, unit: "Count" });
    logger.warn("attributionId exceeds max length", { productId, attributionId, length: attributionId.length });
    return;
  }
  if (!writeAttributionId(productId, attributionId, logger))
    return;
  logger.info("attributionId captured", { productId, attributionId });
}

// src/aipo/config/epoCapiTransformers.ts
import { EpocEulaType } from "@amzn/awsmp-max-model";

// src/aipo/CreateConfig/components/DiscountStrategyStep/qualifyingThemeConstants.ts
import { QualifyingTheme } from "@amzn/awsmp-max-data";
var QUALIFYING_THEME_OPTIONS = [
  { translationKey: "companySizeOption", value: "Company size", capiValue: QualifyingTheme.CompanySize },
  { translationKey: "industryOption", value: "Industry", capiValue: QualifyingTheme.Industry },
  { translationKey: "useCaseOption", value: "Use case", capiValue: QualifyingTheme.UseCase },
  { translationKey: "otherOption", value: "Other", capiValue: QualifyingTheme.Other }
];
var QUALIFYING_THEME_TO_CAPI = {
  "Company size": QualifyingTheme.CompanySize,
  Industry: QualifyingTheme.Industry,
  "Use case": QualifyingTheme.UseCase,
  Other: QualifyingTheme.Other
};
var QUALIFYING_THEME_FROM_CAPI = {
  [QualifyingTheme.CompanySize]: "Company size",
  [QualifyingTheme.Industry]: "Industry",
  [QualifyingTheme.UseCase]: "Use case",
  [QualifyingTheme.Other]: "Other"
};

// src/aipo/config/epoCapiTransformers.ts
var mapTiersToCapiFormat = (tiers) => tiers.map((tier) => ({
  MinValue: tier.minValue,
  MaxValue: tier.maxValue,
  UpfrontDiscountPercentage: tier.discountPercentage
}));
var mapTiersFromCapiFormat = (tiers) => tiers.map((t) => ({
  minValue: t.MinValue,
  maxValue: t.MaxValue,
  discountPercentage: t.UpfrontDiscountPercentage
}));
var fromCapiDiscountRules = (rules) => ({
  ...rules.DimensionQuantity?.PerDimensionTiers && {
    perDimensionTcvTiers: Object.fromEntries(
      Object.entries(rules.DimensionQuantity.PerDimensionTiers).map(([key, tiers]) => [key, mapTiersFromCapiFormat(tiers)])
    )
  },
  ...rules.TotalContractValue?.Tiers && {
    totalTcvTiers: mapTiersFromCapiFormat(rules.TotalContractValue.Tiers)
  },
  ...rules.Qualification?.Questions && {
    qualifications: rules.Qualification.Questions.map((q) => ({
      qualifyingTheme: QUALIFYING_THEME_FROM_CAPI[q.QualifyingTheme] ?? q.QualifyingTheme,
      detail: q.Instructions,
      buyerQuestions: q.BuyerQuestions.map((bq) => ({
        question: bq.Question,
        exampleResponse: bq.ExampleResponse
      }))
    }))
  }
});
var toDiscountStrategy = (rules) => {
  const { perDimensionTcvTiers, totalTcvTiers, qualifications } = rules;
  if (perDimensionTcvTiers) {
    return qualifications?.length ? { strategy: "PER_DIMENSION_TCV_WITH_QUALIFICATION", perDimensionTcvTiers, qualifications } : { strategy: "PER_DIMENSION_TCV", perDimensionTcvTiers };
  }
  if (totalTcvTiers) {
    return qualifications?.length ? { strategy: "TOTAL_TCV_WITH_QUALIFICATION", totalTcvTiers, qualifications } : { strategy: "TOTAL_TCV", totalTcvTiers };
  }
  if (qualifications?.length) {
    return { strategy: "QUALIFICATION", qualifications };
  }
  return void 0;
};
var fromCapiDoc = (doc) => ({
  productId: doc.ProductId,
  currencyCode: doc.CurrencyCode,
  maxDiscountPercentage: doc.Guardrails.MaxDiscountPercentage,
  maxTotalContractValue: doc.Guardrails.MaxTotalContractValue,
  minTotalContractValue: doc.Guardrails.MinTotalContractValue,
  minOfferDuration: doc.OfferSettings.MinOfferDuration,
  maxOfferDuration: doc.OfferSettings.MaxOfferDuration,
  expiration: doc.OfferSettings.Expiration,
  maxFutureStartDuration: doc.OfferSettings.MaxFutureStartDuration,
  eulaType: doc.OfferSettings.Eula.Type === "OFFER_EULA" ? EpocEulaType.PUBLIC_OFFER_EULA : EpocEulaType.STANDARD_CONTRACT_MARKETPLACE,
  configurableUpfrontDimensionRates: {
    duration: doc.OfferRates.ConfigurableUpfrontDimensionRates.Duration,
    // `supplementaryDescription` is optional and never carried by the CAPI
    // configuration document (only `DimensionKey` / `Price` round-trip), so it
    // is always absent here. It is kept on the element type — the same shape
    // the former AIPO `GetAipoConfigurationOutput` view type exposed — so
    // ViewConfig's per-dimension render (`rate.supplementaryDescription ?? "-"`)
    // stays type-correct without a behavior change.
    dimensionRates: doc.OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates.map(
      (dr) => ({
        dimensionKey: dr.DimensionKey,
        price: dr.Price
      })
    )
  },
  discountStrategy: doc.DiscountRules ? toDiscountStrategy(fromCapiDiscountRules(doc.DiscountRules)) : void 0,
  // Prefill the progressive-disclosure gate from whether the config has a payment
  // schedule. Persisted in the schema now, so it survives the prefill updateArtifact
  // and the card/validation/Review read it directly (no per-reader derivation).
  paymentScheduleAllowed: doc.PaymentSchedule !== void 0,
  ...doc.PaymentSchedule && {
    allowedFrequencies: doc.PaymentSchedule.AllowedFrequencies,
    initialPaymentAllowed: doc.PaymentSchedule.InitialPaymentAllowed
  }
});
var renewalFromCapiDoc = (doc) => doc.RenewalTerm;

// src/aipo/ListConfig/ListConfig.tsx
import * as React8 from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { ManagedTable as ManagedTable4 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { marketplaceLinks as marketplaceLinks7 } from "@amzn/awsmp-max-link-catalog/browser";
import Box13 from "@amzn/awsui-components-react/polaris/box";

// src/aipo/ListConfig/hooks/useListConfigurations.ts
import * as React5 from "react";
import { createMaxWrappedError } from "@amzn/awsmp-max-agentic-renderer-interface";
import { EpoCapiData, EpoChangeType, EpoEntityState, PendingChangeSetStatus, CapiProductData } from "@amzn/awsmp-max-data";
var enrichProductNames = async (items, logger) => {
  const productIds = [...new Set(items.map((item) => item.id))];
  if (productIds.length === 0) {
    return items;
  }
  const detailsMap = await CapiProductData.getInstance(logger).fetchProductDetails(productIds);
  return items.map((item) => {
    const name = detailsMap.get(item.id)?.name;
    return name && name !== item.id ? { ...item, product: `${name} (${item.id})` } : item;
  });
};
var useListConfigurations = ({ logger, withAsyncErrors }) => {
  const [configurations, setConfigurations] = React5.useState([]);
  const [isLoading, setIsLoading] = React5.useState(true);
  const loadConfigurations = React5.useCallback(async () => {
    try {
      const epoData = EpoCapiData.getInstance(logger);
      const listResult = await epoData.listConfigs({ state: EpoEntityState.Active });
      const entityIds = (listResult.EntitySummaryList ?? []).map((e) => e.EntityId).filter((id) => id != null);
      const detailsMap = entityIds.length > 0 ? await epoData.batchDescribeConfigs(entityIds) : {};
      const activeItems = Object.entries(detailsMap).map(([entityId, doc]) => ({
        id: doc.ProductId,
        entityId,
        product: doc.ProductId,
        status: "ACTIVE",
        dateCreated: listResult.EntitySummaryList?.find((e) => e.EntityId === entityId)?.LastModifiedDate ?? null
      }));
      const pendingItems = await epoData.listPendingChangeSets(EpoChangeType.Create, [PendingChangeSetStatus.Preparing]);
      const pendingConfigItems = pendingItems.map((p) => ({
        id: p.productId,
        product: p.productId,
        status: "PENDING",
        dateCreated: p.startTime ?? null
      }));
      const pendingProductIds = new Set(pendingConfigItems.map((p) => p.id));
      const deduplicatedActiveItems = activeItems.filter((a) => !pendingProductIds.has(a.id));
      const items = await enrichProductNames([...deduplicatedActiveItems, ...pendingConfigItems], logger);
      setConfigurations(items);
    } catch (error) {
      if (isAuthenticationError(error)) {
        await epoSellerSignIn();
        return;
      }
      throw createMaxWrappedError(error);
    }
  }, [logger]);
  const reload = React5.useCallback(async () => {
    setIsLoading(true);
    try {
      await loadConfigurations();
    } finally {
      setIsLoading(false);
    }
  }, [loadConfigurations]);
  React5.useEffect(() => {
    withAsyncErrors(reload());
  }, [reload, withAsyncErrors]);
  return { configurations, isLoading, reload };
};

// src/aipo/ListConfig/hooks/useDeleteConfiguration.ts
import * as React6 from "react";
import { createMaxWrappedError as createMaxWrappedError2 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { EpoCapiData as EpoCapiData2 } from "@amzn/awsmp-max-data";
var useDeleteConfiguration = ({ logger, onSuccess }) => {
  const [isDeleting, setIsDeleting] = React6.useState(false);
  const handleDelete = React6.useCallback(
    async (item) => {
      setIsDeleting(true);
      try {
        const epoData = EpoCapiData2.getInstance(logger);
        const changeSetId = await epoData.deleteConfig(item.entityId);
        await epoData.waitForChangeCompletion(changeSetId);
        await onSuccess(item);
      } catch (error) {
        if (isAuthenticationError(error)) {
          await epoSellerSignIn();
          return;
        }
        throw createMaxWrappedError2(error, { isFatal: false });
      } finally {
        setIsDeleting(false);
      }
    },
    [logger, onSuccess]
  );
  return { handleDelete, isDeleting };
};

// src/aipo/ListConfig/hooks/useFlashbarFromQueryParams.tsx
import * as React7 from "react";
import { useLocation, useNavigate } from "react-router-dom";

// src/aipo/ListConfig/config/constants.ts
var METRIC_NAMES = {
  CLICK: "Click"
};
var METRIC_FEATURE = "express-private-offer-configurations-table";
var PAGE_CONTEXT2 = {
  // Bound to the canonical EPO page-type set (@amzn/awsmp-max-model); see CreateConfig constants.
  PAGE_TYPE: "AWSMP-EPO-List-Config",
  SUB_PAGE_TYPES: {
    LIST_CONFIGURATION: "AWSMP-List-Configuration"
  }
};
var TABLE_PREFERENCE_KEY = "aipo-configurations-table";
var STATUS_COLORS = {
  active: "#037f0c",
  pending: "#5f6b7a",
  failed: "#d91515"
};

// src/aipo/ListConfig/hooks/useFlashbarFromQueryParams.tsx
var useFlashbarFromQueryParams = ({ flashbarManager, t }) => {
  const location = useLocation();
  const navigate = useNavigate();
  React7.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const created = params.get(QUERY_PARAMS.CREATED);
    const deleted = params.get(QUERY_PARAMS.DELETED);
    const productId = params.get(QUERY_PARAMS.PRODUCT_ID);
    const productName = params.get(QUERY_PARAMS.PRODUCT_NAME);
    if (!productId || !productName) {
      return;
    }
    if (created === "true") {
      flashbarManager.addItem({
        id: `CONFIG_CREATED_${productId}_${crypto.randomUUID()}`,
        type: "success",
        content: t("configurationCreatedSuccess", { productName }),
        dismissible: true
      });
    } else if (deleted === "true") {
      flashbarManager.addItem({
        id: `CONFIG_DELETED_${productId}_${crypto.randomUUID()}`,
        type: "success",
        content: t("configurationDeletedSuccess", { productName }),
        dismissible: true
      });
    }
    navigate(EPO_ROUTES.LIST, { replace: true });
  }, [location.search]);
};

// src/aipo/ListConfig/components/ConfigurationStatus.tsx
import SpaceBetween17 from "@amzn/awsui-components-react/polaris/space-between";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import { jsx as jsx22, jsxs as jsxs19 } from "react/jsx-runtime";
var STATUS_MAP = {
  ACTIVE: (t) => ({ icon: "status-positive", variant: "success", color: STATUS_COLORS.active, text: t("statusActive") }),
  PENDING: (t) => ({ icon: "status-pending", variant: "subtle", color: STATUS_COLORS.pending, text: t("statusPending") }),
  FAILED: (t) => ({ icon: "status-negative", variant: "error", color: STATUS_COLORS.failed, text: t("statusFailed") })
};
var getStatusConfig = (status, t) => {
  return STATUS_MAP[status](t);
};
var ConfigurationStatus = ({ status, t }) => {
  const config = getStatusConfig(status, t);
  return /* @__PURE__ */ jsx22("span", { "data-testid": `config-status-${status}`, children: /* @__PURE__ */ jsxs19(SpaceBetween17, { direction: "horizontal", size: "xs", alignItems: "center", children: [
    /* @__PURE__ */ jsx22(Icon, { name: config.icon, variant: config.variant }),
    /* @__PURE__ */ jsx22("span", { style: { color: config.color }, children: config.text })
  ] }) });
};

// src/aipo/ListConfig/utils/formatRelativeTime.ts
var formatRelativeTime2 = (dateString) => {
  const now2 = /* @__PURE__ */ new Date();
  const date = new Date(dateString);
  const diffInMs = now2.getTime() - date.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1e3 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMinutes < 1) {
    return "Just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
  } else if (diffInDays < 30) {
    return `${diffInWeeks} week${diffInWeeks === 1 ? "" : "s"} ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths === 1 ? "" : "s"} ago`;
  } else {
    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} year${diffInYears === 1 ? "" : "s"} ago`;
  }
};

// src/aipo/ListConfig/config/columnDefinitions.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var createColumnDefinitions = (t) => [
  {
    id: "product",
    header: t("product"),
    cell: (item) => item.product,
    sortingField: "product"
  },
  {
    id: "status",
    header: t("status"),
    cell: (item) => /* @__PURE__ */ jsx23(ConfigurationStatus, { status: item.status, t }),
    sortingField: "status"
  },
  {
    id: "dateCreated",
    header: t("dateCreated"),
    cell: (item) => item.dateCreated ? formatRelativeTime2(item.dateCreated) : "\u2014",
    sortingField: "dateCreated"
  }
];

// src/aipo/ListConfig/components/ListConfigHeader.tsx
import Header14 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween18 from "@amzn/awsui-components-react/polaris/space-between";
import Button8 from "@amzn/awsui-components-react/polaris/button";
import Link11 from "@amzn/awsui-components-react/polaris/link";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG8 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { jsx as jsx24, jsxs as jsxs20 } from "react/jsx-runtime";
var ListConfigHeader = ({
  count,
  hasSelection,
  isDeleting,
  isRemoveDisabledForPending,
  isViewDisabledForPending,
  onViewDetails,
  onRemove,
  onCreate,
  t,
  openHelpPanel
}) => /* @__PURE__ */ jsx24(
  Header14,
  {
    counter: `(${count})`,
    description: t("expressPrivateOfferDescription"),
    info: openHelpPanel ? /* @__PURE__ */ jsx24(
      Link11,
      {
        variant: "info",
        ariaLabel: t("infoAriaLabel", { section: t("expressPrivateOfferConfigurations") }),
        onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG8.CONFIGURATIONS_LIST),
        children: t("info")
      }
    ) : void 0,
    actions: /* @__PURE__ */ jsxs20(SpaceBetween18, { direction: "horizontal", size: "xs", children: [
      /* @__PURE__ */ jsx24(Button8, { disabled: !hasSelection || isViewDisabledForPending === true, onClick: onViewDetails, children: t("viewDetails") }),
      /* @__PURE__ */ jsx24(
        Button8,
        {
          "data-testid": "list-config-remove-button",
          disabled: !hasSelection || isDeleting || isRemoveDisabledForPending === true,
          loading: isDeleting,
          onClick: onRemove,
          children: t("remove")
        }
      ),
      /* @__PURE__ */ jsx24(Button8, { variant: "primary", onClick: onCreate, children: t("createConfiguration") })
    ] }),
    children: t("expressPrivateOfferConfigurations")
  }
);

// src/aipo/ListConfig/ListConfig.tsx
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG9 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { jsx as jsx25, jsxs as jsxs21 } from "react/jsx-runtime";
var PENDING_STATUS = "PENDING";
var ListConfig = ({
  t,
  flashbarManager,
  setBreadcrumbs,
  logger,
  withAsyncErrors,
  helpPanelsEnabled,
  layoutComponents
}) => {
  const LayoutHelpPanel = layoutComponents?.LayoutHelpPanel;
  const [helpPanelOpen, setHelpPanelOpen] = React8.useState(false);
  const openHelpPanel = React8.useCallback((_pathslug) => setHelpPanelOpen(true), []);
  const navigate = useNavigate2();
  usePageHit(logger, PAGE_CONTEXT2.PAGE_TYPE);
  useSubPageHit(logger, PAGE_CONTEXT2.SUB_PAGE_TYPES.LIST_CONFIGURATION);
  React8.useEffect(() => {
    setBreadcrumbs([
      { text: t("awsMarketplace"), href: marketplaceLinks7.get("Home"), isAbsoluteUrl: true },
      { text: t("expressPrivateOfferConfigurations"), href: EPO_ROUTES.LIST }
    ]);
  }, []);
  useFlashbarFromQueryParams({ flashbarManager, t });
  const { configurations, isLoading, reload } = useListConfigurations({
    logger,
    withAsyncErrors
  });
  const onDeleteSuccess = React8.useCallback(
    async (item) => {
      flashbarManager.addItem({
        type: "success",
        content: t("configurationDeletedSuccess", { productName: item.product }),
        dismissible: true
      });
      await reload();
      setSelectedItems([]);
    },
    [reload, flashbarManager, t]
  );
  const { handleDelete, isDeleting } = useDeleteConfiguration({
    logger,
    onSuccess: onDeleteSuccess
  });
  const [selectedItems, setSelectedItems] = React8.useState([]);
  const hasSelection = selectedItems.length > 0;
  const selectedItem = selectedItems[0];
  const isRemoveDisabledForPending = selectedItem?.status === PENDING_STATUS;
  const isViewDisabledForPending = selectedItem?.status === PENDING_STATUS;
  const logClick = (clickAct) => {
    logger.biMetric({
      metricName: METRIC_NAMES.CLICK,
      dimensions: { ClickFeat: METRIC_FEATURE, ClickAct: clickAct },
      value: 1,
      unit: "Count"
    });
  };
  return /* @__PURE__ */ jsxs21("div", { "data-testid": "list-config-page", style: { marginTop: "4px" }, children: [
    /* @__PURE__ */ jsx25(
      ManagedTable4,
      {
        "data-testid": "list-config-table",
        preferenceKey: TABLE_PREFERENCE_KEY,
        defaultPreferences: { pageSize: 10, wrapLines: true },
        hidePreferences: true,
        columnDefinitions: createColumnDefinitions(t),
        items: configurations,
        loading: isLoading,
        variant: "embedded",
        selectedItems,
        onSelectionChange: ({ detail }) => setSelectedItems(detail.selectedItems),
        selectionType: "single",
        ariaLabels: {
          allItemsSelectionLabel: () => t("allConfigurations"),
          itemSelectionLabel: (_, item) => item.product
        },
        trackBy: "id",
        pagination: {},
        filtering: {
          filteringPlaceholder: t("searchByProduct"),
          filteringFunction: (item, filteringText) => item.product.toLowerCase().includes(filteringText.toLowerCase())
        },
        empty: /* @__PURE__ */ jsxs21(Box13, { textAlign: "center", color: "inherit", children: [
          /* @__PURE__ */ jsx25("b", { children: t("noConfigurationsFound") }),
          /* @__PURE__ */ jsx25(Box13, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("createFirstConfiguration") })
        ] }),
        header: /* @__PURE__ */ jsx25(
          ListConfigHeader,
          {
            count: configurations.length,
            hasSelection,
            isDeleting,
            isRemoveDisabledForPending,
            isViewDisabledForPending,
            onViewDetails: () => {
              logClick("view");
              const item = selectedItems[0];
              if (hasSelection && item?.entityId) {
                navigate(EPO_ROUTES.VIEW(item.entityId));
              }
            },
            onRemove: () => {
              logClick("remove");
              if (hasSelection) {
                withAsyncErrors(handleDelete(selectedItems[0]));
              }
            },
            onCreate: () => {
              logClick("Create-express-private-offer-button");
              navigate(EPO_ROUTES.CREATE);
            },
            t,
            openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
          }
        )
      }
    ),
    helpPanelsEnabled && LayoutHelpPanel && /* @__PURE__ */ jsx25(LayoutHelpPanel, { pathslug: HELP_PANEL_PATHSLUG9.CONFIGURATIONS_LIST, open: helpPanelOpen, onToggle: setHelpPanelOpen })
  ] });
};

// src/aipo/CreateConfig/CreateConfig.tsx
import * as React31 from "react";
import { useNavigate as useNavigate5, useSearchParams } from "react-router-dom";
import Wizard2 from "@amzn/awsui-components-react/polaris/wizard";
import Link18 from "@amzn/awsui-components-react/polaris/link";

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/validation.ts
var validateSelectProductDimensionsStep = (artifact, t) => {
  const errorProps = {};
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const selectedProductId = artifact.configurationRequest.productId || "";
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates;
  if (!selectedProductId || selectedProductId.trim() === "") {
    errorProps.productError = t("validationSelectProduct");
  }
  if (selectedProductId && (!dimensionRates || !dimensionRates.dimensionRates || dimensionRates.dimensionRates.length === 0)) {
    errorProps.dimensionsError = t("validationSelectDimension");
  }
  if (dimensionRates && dimensionRates.dimensionRates && dimensionRates.dimensionRates.length > 25) {
    errorProps.dimensionLimitError = t("validationDimensionLimit");
  }
  return {
    isValid: Object.keys(errorProps).length === 0,
    errorProps
  };
};

// src/aipo/CreateConfig/components/AdditionalInformationStep/validation.ts
var validateAdditionalInformationStep = (artifact, t) => {
  const errorProps = {};
  if (!artifact) {
    return { isValid: false, errorProps: {} };
  }
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
  const missingPrices = dimensionRates.filter((dimension) => dimension.price === null || dimension.price === void 0 || dimension.price <= 0);
  if (missingPrices.length > 0) {
    errorProps.missingPricesError = t("validationMissingPrices");
  }
  return {
    isValid: Object.keys(errorProps).length === 0,
    errorProps
  };
};

// src/aipo/CreateConfig/utils/isoFormatUtils.ts
var monthsToISO8601 = (months2) => `P${months2}M`;
var iso8601ToMonths = (duration) => duration ? duration.slice(1, -1) : "";
var daysToISO8601 = (days) => `P${days}D`;
var iso8601ToDays = (duration) => duration ? duration.slice(1, -1) : "";

// src/aipo/CreateConfig/components/OfferSettingsStep/validation.ts
var iso8601ToMonths2 = (duration) => duration ? parseInt(iso8601ToMonths(duration), 10) : 0;
var iso8601ToDays2 = (duration) => duration ? parseInt(iso8601ToDays(duration), 10) : 0;
var MIN_FDA_DURATION_DAYS = 1;
var MAX_FDA_DURATION_DAYS = 365;
var validateOfferSettingsStep = (artifact, t, fdaEnabled) => {
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const errorProps = {};
  let isValid = true;
  if (!artifact.configurationRequest.minOfferDuration) {
    errorProps.minOfferDurationError = t("validationMinOfferDurationRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.maxOfferDuration) {
    errorProps.maxOfferDurationError = t("validationMaxOfferDurationRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.eulaType) {
    errorProps.eulaTypeError = t("validationEulaRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.expiration) {
    errorProps.expirationError = t("validationOfferExpirationRequired");
    isValid = false;
  }
  if (fdaEnabled) {
    if (!artifact.configurationRequest.maxFutureStartDuration) {
      errorProps.maxFutureStartDurationError = t("validationFdaRequired");
      isValid = false;
    } else {
      const fdaDays = iso8601ToDays2(artifact.configurationRequest.maxFutureStartDuration);
      if (fdaDays < MIN_FDA_DURATION_DAYS || fdaDays > MAX_FDA_DURATION_DAYS) {
        errorProps.maxFutureStartDurationError = t("fdaValidityRangeError");
        isValid = false;
      }
    }
  }
  if (artifact.configurationRequest.minOfferDuration) {
    const minMonths = iso8601ToMonths2(artifact.configurationRequest.minOfferDuration);
    if (minMonths > 60) {
      errorProps.minOfferDurationError = t("validationMinOfferDurationLimit");
      isValid = false;
    }
  }
  if (artifact.configurationRequest.maxOfferDuration) {
    const maxMonths = iso8601ToMonths2(artifact.configurationRequest.maxOfferDuration);
    if (maxMonths > 60) {
      errorProps.maxOfferDurationError = t("validationMaxOfferDurationLimit");
      isValid = false;
    }
  }
  if (artifact.configurationRequest.minOfferDuration && artifact.configurationRequest.maxOfferDuration) {
    const minMonths = iso8601ToMonths2(artifact.configurationRequest.minOfferDuration);
    const maxMonths = iso8601ToMonths2(artifact.configurationRequest.maxOfferDuration);
    if (minMonths > maxMonths) {
      errorProps.maxOfferDurationError = t("validationMaxOfferDurationGreaterThanMin");
      isValid = false;
    }
  }
  const paymentScheduleAllowed = artifact.configurationRequest.paymentScheduleAllowed;
  if (paymentScheduleAllowed === void 0) {
    errorProps.paymentScheduleAllowedError = t("validationPaymentScheduleAllowedRequired");
    isValid = false;
  } else if (paymentScheduleAllowed === true) {
    const allowedFrequenciesSet = (artifact.configurationRequest.allowedFrequencies?.length ?? 0) > 0;
    const initialPaymentAllowedSet = artifact.configurationRequest.initialPaymentAllowed !== void 0;
    if (!allowedFrequenciesSet) {
      errorProps.allowedFrequenciesError = t("validationAllowedFrequenciesRequired");
      isValid = false;
    }
    if (!initialPaymentAllowedSet) {
      errorProps.initialPaymentAllowedError = t("validationInitialPaymentAllowedRequired");
      isValid = false;
    }
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/types.ts
var MAX_TCV_VALUE = 1e6;
var MIN_DISCOUNT_PERCENTAGE = 0;
var MAX_DISCOUNT_PERCENTAGE = 100;
var MAX_TOTAL_TIERS = 25;
var MAX_TCV_TIERS = 10;
var MIN_TCV_EXCEEDS_MAX_MESSAGE_KEY = "validationMinTcvExceedsMaxTcv";
var MAX_TCV_BELOW_MIN_MESSAGE_KEY = "validationMaxTcvBelowMinTcv";

// src/aipo/CreateConfig/components/DiscountStrategyStep/discountValidationHelpers.ts
var rangesOverlap = (range1, range2, allowBoundaryTouch) => {
  const { minValue: r1Min, maxValue: r1Max } = range1;
  const { minValue: r2Min, maxValue: r2Max } = range2;
  if (r1Min !== null && r1Max !== null && r2Min !== null && r2Max !== null) {
    return allowBoundaryTouch ? r1Min < r2Max && r2Min < r1Max : r1Min <= r2Max && r2Min <= r1Max;
  }
  if (r1Min !== null && r1Max !== null) {
    if (allowBoundaryTouch) {
      return r2Min !== null && r2Min >= r1Min && r2Min < r1Max || r2Max !== null && r2Max > r1Min && r2Max <= r1Max;
    }
    return r2Min !== null && r2Min >= r1Min && r2Min <= r1Max || r2Max !== null && r2Max >= r1Min && r2Max <= r1Max;
  }
  if (r2Min !== null && r2Max !== null) {
    if (allowBoundaryTouch) {
      return r1Min !== null && r1Min >= r2Min && r1Min < r2Max || r1Max !== null && r1Max > r2Min && r1Max <= r2Max;
    }
    return r1Min !== null && r1Min >= r2Min && r1Min <= r2Max || r1Max !== null && r1Max >= r2Min && r1Max <= r2Max;
  }
  return r1Min !== null && r2Min !== null && r1Max === null && r2Max === null && r1Min === r2Min || r1Max !== null && r2Max !== null && r1Min === null && r2Min === null && r1Max === r2Max;
};
var detectRangeErrors = (prefix, tiers, t, allowBoundaryTouch) => {
  const errorFlags = {};
  const errorMessages = {};
  if (!tiers || tiers.length === 0) {
    return { errorFlags, errorMessages };
  }
  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i];
    if (tier.minValue !== null && typeof tier.minValue === "number" && tier.minValue < 0) {
      const key = `${prefix}-${i}-minValue`;
      errorFlags[key] = true;
      errorMessages[key] = t("validationMinimumValueMustBeZeroOrAbove");
    }
    if (tier.minValue !== null && tier.maxValue !== null && typeof tier.minValue === "number" && typeof tier.maxValue === "number" && tier.maxValue < tier.minValue) {
      const key = `${prefix}-${i}-maxValue-range`;
      errorFlags[key] = true;
      errorMessages[key] = t("validationAdjustMaxValueLargerThanMin");
    }
  }
  if (tiers.length < 2) {
    return { errorFlags, errorMessages };
  }
  for (let i = 0; i < tiers.length - 1; i++) {
    const tierA = tiers[i];
    for (let j = i + 1; j < tiers.length; j++) {
      const tierB = tiers[j];
      if (rangesOverlap(tierA, tierB, allowBoundaryTouch)) {
        const overlappingTiers = [
          { tier: tierA, index: i },
          { tier: tierB, index: j }
        ];
        overlappingTiers.forEach(({ tier, index }) => {
          if (tier.minValue !== null) {
            const key = `${prefix}-${index}-minValue`;
            if (!errorMessages[key]) {
              errorFlags[key] = true;
              errorMessages[key] = t("validationAdjustValueNoRangesOverlap");
            }
          }
          if (tier.maxValue !== null) {
            const key = `${prefix}-${index}-maxValue`;
            if (!errorMessages[key]) {
              errorFlags[key] = true;
              errorMessages[key] = t("validationAdjustValueNoRangesOverlap");
            }
          }
        });
      }
    }
  }
  return { errorFlags, errorMessages };
};
var detectGaps = (tiers, allowBoundaryTouch) => {
  const completeTiers = tiers.reduce((acc, tier) => {
    if (tier.minValue !== null && tier.maxValue !== null) {
      acc.push({ minValue: tier.minValue, maxValue: tier.maxValue });
    }
    return acc;
  }, []);
  if (completeTiers.length < 2) {
    return false;
  }
  const sorted = [...completeTiers].sort((a, b) => a.minValue - b.minValue);
  for (let i = 0; i < sorted.length - 1; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];
    if (allowBoundaryTouch) {
      if (current.maxValue > next.minValue)
        continue;
      if (current.maxValue < next.minValue)
        return true;
    } else {
      if (current.maxValue >= next.minValue)
        continue;
      if (current.maxValue + 1 < next.minValue)
        return true;
    }
  }
  return false;
};
var getErrorText = (errorMessages, key) => {
  return errorMessages[key] || void 0;
};
var getIncompleteFieldError = (value, fieldType, t) => {
  if (value === null || value === void 0) {
    return fieldType === "quantity" ? t("validationUnitQuantityRequired") : t("validationDiscountRequired");
  }
  return void 0;
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/validation.ts
function validateQualifications(qualifications, emptyMessage) {
  if (!qualifications || qualifications.length === 0) {
    return { error: { body: emptyMessage }, isValid: false };
  }
  const hasEmptyDetail = qualifications.some((qual) => !qual.detail || qual.detail.trim() === "");
  if (hasEmptyDetail) {
    return { error: { showFieldLevelErrors: true }, isValid: false };
  }
  return { isValid: true };
}
var validateDiscountStrategyStep = (artifact, t) => {
  const errorProps = {};
  let isValid = true;
  const allowBoundaryTouchPerDim = false;
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const maxDiscountPercentage = artifact.configurationRequest.maxDiscountPercentage;
  const maxTotalContractValue = artifact.configurationRequest.maxTotalContractValue;
  const minTotalContractValue = artifact.configurationRequest.minTotalContractValue;
  if (!discountStrategy && maxDiscountPercentage !== 0) {
    errorProps.discountStrategyError = { body: t("validationDiscountStrategyRequired") };
    isValid = false;
  }
  if (maxDiscountPercentage === null || maxDiscountPercentage === void 0) {
    errorProps.maxDiscountError = t("validationFieldRequired");
    isValid = false;
  } else if (maxDiscountPercentage < 0 || maxDiscountPercentage >= MAX_DISCOUNT_PERCENTAGE) {
    errorProps.maxDiscountError = t("validationDiscountPercentageRange");
    isValid = false;
  } else if (maxDiscountPercentage === 0 && discountStrategy) {
    errorProps.maxDiscountError = t("validationDiscountGreaterThanZero");
    isValid = false;
  }
  if (maxTotalContractValue === null || maxTotalContractValue === void 0) {
    errorProps.maxTcvError = t("validationFieldRequired");
    isValid = false;
  } else if (maxTotalContractValue <= 0) {
    errorProps.maxTcvError = t("validationMaxTcvGreaterThanZero");
    isValid = false;
  } else if (maxTotalContractValue >= MAX_TCV_VALUE) {
    errorProps.maxTcvError = t("validationMaxTcvBelowLimit");
    isValid = false;
  } else if (minTotalContractValue !== null && minTotalContractValue !== void 0 && maxTotalContractValue < minTotalContractValue) {
    errorProps.maxTcvError = t(MAX_TCV_BELOW_MIN_MESSAGE_KEY);
    isValid = false;
  }
  if (discountStrategy) {
    switch (discountStrategy.strategy) {
      case "PER_DIMENSION_TCV":
      case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
        if (!discountStrategy.perDimensionTcvTiers || Object.keys(discountStrategy.perDimensionTcvTiers).length === 0) {
          errorProps.perDimensionError = { body: t("validationPerDimensionRequiresTiers") };
          isValid = false;
        } else {
          const totalTiers = Object.values(discountStrategy.perDimensionTcvTiers).reduce((total, tiers) => total + (tiers?.length || 0), 0);
          if (totalTiers === 0) {
            errorProps.perDimensionError = { body: t("validationDefineOneTier") };
            isValid = false;
          } else {
            const hasIncompleteFields = Object.values(discountStrategy.perDimensionTcvTiers).some(
              (tiers) => tiers?.some((tier) => tier.minValue === null || tier.maxValue === null || tier.discountPercentage === null)
            );
            const hasInvalidDiscountPercentage = Object.values(discountStrategy.perDimensionTcvTiers).some(
              (tiers) => tiers?.some(
                (tier) => tier.discountPercentage !== null && (tier.discountPercentage <= MIN_DISCOUNT_PERCENTAGE || tier.discountPercentage >= MAX_DISCOUNT_PERCENTAGE)
              )
            );
            const hasRangeErrors = Object.entries(discountStrategy.perDimensionTcvTiers).some(([dimensionKey, tiers]) => {
              const tierData = tiers?.map((tier) => ({
                minValue: tier.minValue,
                maxValue: tier.maxValue,
                discountPercentage: tier.discountPercentage
              }));
              const { errorFlags } = detectRangeErrors(dimensionKey, tierData || [], t, allowBoundaryTouchPerDim);
              return Object.keys(errorFlags).length > 0;
            });
            if (hasIncompleteFields || hasInvalidDiscountPercentage || hasRangeErrors) {
              errorProps.perDimensionError = { showFieldLevelErrors: true };
              isValid = false;
            }
          }
        }
        if (discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
          const qualResult = validateQualifications(discountStrategy.qualifications, t("validationPerDimensionQualificationRequired"));
          if (!qualResult.isValid) {
            errorProps.buyerProfileError = qualResult.error;
            isValid = false;
          }
        }
        break;
      case "TOTAL_TCV":
      case "TOTAL_TCV_WITH_QUALIFICATION":
        if (!discountStrategy.totalTcvTiers || discountStrategy.totalTcvTiers.length === 0) {
          errorProps.tcvDiscountsError = { body: t("validationTcvRequiresTiers") };
          isValid = false;
        } else {
          const hasIncompleteFields = discountStrategy.totalTcvTiers.some(
            (tier) => tier.minValue === null || tier.maxValue === null || tier.discountPercentage === null
          );
          const hasInvalidDiscountPercentage = discountStrategy.totalTcvTiers.some(
            (tier) => tier.discountPercentage !== null && (tier.discountPercentage <= MIN_DISCOUNT_PERCENTAGE || tier.discountPercentage >= MAX_DISCOUNT_PERCENTAGE)
          );
          const tierData = discountStrategy.totalTcvTiers.map((tier) => ({
            minValue: tier.minValue,
            maxValue: tier.maxValue,
            discountPercentage: tier.discountPercentage
          }));
          const { errorFlags } = detectRangeErrors("tcv", tierData, t, true);
          const hasRangeErrors = Object.keys(errorFlags).length > 0;
          if (hasIncompleteFields || hasInvalidDiscountPercentage || hasRangeErrors) {
            errorProps.tcvDiscountsError = { showFieldLevelErrors: true };
            isValid = false;
          }
        }
        if (discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION") {
          const qualResult = validateQualifications(discountStrategy.qualifications, t("validationTcvQualificationRequired"));
          if (!qualResult.isValid) {
            errorProps.buyerProfileError = qualResult.error;
            isValid = false;
          }
        }
        break;
      case "QUALIFICATION": {
        const qualResult = validateQualifications(discountStrategy.qualifications, t("validationQualificationRequired"));
        if (!qualResult.isValid) {
          errorProps.buyerProfileError = qualResult.error;
          isValid = false;
        }
        break;
      }
    }
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/CreateConfig/components/GuidanceStep/validation.ts
import { GuidanceStatus } from "@amzn/awsmp-max-model";

// src/aipo/CreateConfig/config/constants.ts
var SEARCH_PARAMS = { INCLUDE_LIMITED: "includeLimited" };
var MAX_DESCRIPTION_LENGTH = 1e3;
var UNSUPPORTED_CHARACTER_PATTERN = /[^\u0000-\u007e\u00a9\u00ae\u2122\u00a2-\u00a5]/;
var SPACE_BEFORE_TRADEMARK_PATTERN = /\s\u2122/;
var PAGE_CONTEXT3 = {
  // `satisfies EpoPageType` binds these to the canonical page-type set in @amzn/awsmp-max-model:
  // a value not in that set is a compile error here, and the deployment guard test ensures the set
  // is monitored — together they close the client-vs-monitoring drift behind incident V2315691139.
  PAGE_TYPE: "AWSMP-EPO-Create-Config",
  // Edit reuses the create wizard (isEditMode) but must attribute its page hit
  // to a distinct page type per the AIPO adoption-metrics spec. Sub-page types
  // are shared between create and edit.
  // Spec: specs/epo/2026-07-09-fps-update-changetype-bi-telemetry/spec.md
  EDIT_PAGE_TYPE: "AWSMP-EPO-Edit-Config",
  SUB_PAGE_TYPES: {
    CREATE_CONFIGURATION: "AWSMP-Create-Configuration",
    SELECT_PRODUCT_DIMENSIONS: "AWSMP-Select-Product-Dimensions",
    SET_PRICING_AND_DETAILS: "AWSMP-Set-Pricing",
    ENHANCE_DIMENSIONS: "AWSMP-Enhance-Dimension-Descriptions",
    CONFIGURE_OFFER_SETTINGS: "AWSMP-Configure-Offer-Settings",
    CONFIGURE_DISCOUNT_STRATEGY: "AWSMP-Configure-Discount-Strategy",
    CONFIGURE_RENEWAL_TERMS: "AWSMP-Configure-Renewal-Terms",
    REVIEW_AND_CREATE: "AWSMP-Review-And-Create"
  }
};

// src/aipo/CreateConfig/components/GuidanceStep/validation.ts
var validateDescriptionContent = (content) => {
  const isOverLimit = content.length > MAX_DESCRIPTION_LENGTH;
  const unsupportedChars = content.match(new RegExp(UNSUPPORTED_CHARACTER_PATTERN, "g"));
  const hasSpaceBeforeTrademark = SPACE_BEFORE_TRADEMARK_PATTERN.test(content);
  const hasError = isOverLimit || unsupportedChars !== null && unsupportedChars.length > 0 || hasSpaceBeforeTrademark;
  return { isOverLimit, unsupportedChars, hasSpaceBeforeTrademark, hasError };
};
var getGuidanceErrors = (artifact, productDimensions) => {
  const proposedGuidance = artifact.proposedGuidance ?? {};
  const overLimit = [];
  const unsupportedChars = [];
  const spaceBeforeTrademark = [];
  for (const [dimensionKey, guidance] of Object.entries(proposedGuidance)) {
    if (guidance.status === GuidanceStatus.Enhancing)
      continue;
    const dim = productDimensions.get(dimensionKey);
    if (!dim)
      throw new Error(`proposedGuidance key "${dimensionKey}" has no matching product dimension`);
    const name = dim.dimension;
    const errors = validateDescriptionContent(guidance.content);
    if (errors.isOverLimit)
      overLimit.push(name);
    if (errors.unsupportedChars)
      unsupportedChars.push(name);
    if (errors.hasSpaceBeforeTrademark)
      spaceBeforeTrademark.push(name);
  }
  return { overLimit, unsupportedChars, spaceBeforeTrademark };
};
var validateGuidanceStep = (artifact, productDimensions) => {
  const { overLimit, unsupportedChars, spaceBeforeTrademark } = getGuidanceErrors(artifact, productDimensions);
  const errorProps = {};
  if (overLimit.length > 0) {
    errorProps.guidanceOverLimitError = overLimit.join(", ");
  }
  if (unsupportedChars.length > 0) {
    errorProps.guidanceUnsupportedCharsError = unsupportedChars.join(", ");
  }
  if (spaceBeforeTrademark.length > 0) {
    errorProps.guidanceSpaceBeforeTrademarkError = spaceBeforeTrademark.join(", ");
  }
  return {
    isValid: Object.keys(errorProps).length === 0,
    errorProps
  };
};

// src/aipo/CreateConfig/components/RenewalTermsStep/validation.ts
var DAYS_PER_MONTH = 30;
var maxOfferDurationDays = (duration) => {
  if (!duration)
    return void 0;
  const months2 = parseInt(iso8601ToMonths(duration), 10);
  return Number.isNaN(months2) ? void 0 : months2 * DAYS_PER_MONTH;
};
var isPercentageInRange = (value) => {
  if (!PERCENTAGE_REGEX.test(value))
    return false;
  const num = Number(value);
  return num >= PERCENTAGE_MIN && num <= PERCENTAGE_MAX;
};
var isPositiveInteger = (value) => Number.isInteger(value) && value >= 1;
var validateRenewalTermsStep = (artifact, t, renewalEnabled) => {
  const errorProps = {};
  if (!renewalEnabled || !artifact) {
    return { isValid: true, errorProps };
  }
  const req = artifact.configurationRequest;
  let isValid = true;
  const fail = (key, message) => {
    errorProps[key] = message;
    isValid = false;
  };
  if (req.renewalPricing === void 0) {
    fail("renewalPricingError", t("validationRenewalPricingRequired"));
    return { isValid, errorProps };
  }
  if (req.renewalPricing === "none") {
    return { isValid, errorProps };
  }
  if (req.renewalMaximumMode === void 0) {
    fail("renewalMaximumError", t("validationRenewalMaximumRequired"));
  } else if (req.renewalMaximumMode === "definite") {
    if (req.renewalMaxRenewals === void 0) {
      fail("renewalMaxRenewalsError", t("validationRenewalCountRequired"));
    } else if (!isPositiveInteger(req.renewalMaxRenewals)) {
      fail("renewalMaxRenewalsError", t("validationRenewalCountInvalid"));
    }
  }
  const lockoutDays = req.renewalLockoutDays;
  if (lockoutDays !== void 0) {
    if (!isPositiveInteger(lockoutDays)) {
      fail("renewalLockoutError", t("validationRenewalLockoutInvalid"));
    } else {
      const contractDays = maxOfferDurationDays(req.maxOfferDuration);
      if (contractDays !== void 0 && lockoutDays >= contractDays) {
        fail("renewalLockoutError", t("validationRenewalLockoutTooLong"));
      }
    }
  }
  if (req.renewalPricing === "evolving") {
    if (req.renewalUpliftType === void 0) {
      fail("renewalUpliftTypeError", t("validationRenewalUpliftTypeRequired"));
    } else if (req.renewalUpliftType === "fixed") {
      validateFixed(req.renewalFixedPercentage, t, fail);
    } else {
      validateRange(req, t, fail);
    }
  }
  return { isValid, errorProps };
};
function validateFixed(value, t, fail) {
  if (value === void 0 || value === "") {
    fail("renewalFixedPercentageError", t("validationRenewalFixedPercentageRequired"));
    return;
  }
  if (PERCENTAGE_REGEX.test(value) && Number(value) === 0) {
    fail("renewalFixedPercentageError", t("validationRenewalFixedPercentageZero"));
    return;
  }
  if (!isPercentageInRange(value)) {
    fail("renewalFixedPercentageError", t("validationRenewalFixedPercentageRange"));
  }
}
function validateRange(req, t, fail) {
  const min = req.renewalRangeMin;
  const max = req.renewalRangeMax;
  let rangeValid = false;
  if (min === void 0 || min === "" || max === void 0 || max === "") {
    fail("renewalRangeError", t("validationRenewalRangeRequired"));
  } else if (!isPercentageInRange(min) || !isPercentageInRange(max) || Number(min) > Number(max)) {
    fail("renewalRangeError", t("validationRenewalRangeInvalid"));
  } else {
    rangeValid = true;
  }
  const def = req.renewalRangeDefault;
  if (def === void 0 || def === "") {
    fail("renewalDefaultError", t("validationRenewalDefaultRequired"));
  } else if (!isPercentageInRange(def) || rangeValid && (Number(def) < Number(min) || Number(def) > Number(max))) {
    fail("renewalDefaultError", t("validationRenewalDefaultOutOfRange"));
  }
  const deadline = req.renewalAdjustmentDeadlineDays;
  if (deadline === void 0) {
    fail("renewalAdjustmentDeadlineError", t("validationRenewalAdjustmentDeadlineRequired"));
  } else if (!(Number.isInteger(deadline) && deadline >= ADJUSTMENT_DEADLINE_MIN_GAP_DAYS)) {
    fail("renewalAdjustmentDeadlineError", t("validationRenewalAdjustmentDeadlineInvalid"));
  } else {
    const contractDays = maxOfferDurationDays(req.maxOfferDuration);
    const lockoutDays = req.renewalLockoutDays ?? 0;
    const lockoutFits = (req.renewalLockoutDays === void 0 || isPositiveInteger(req.renewalLockoutDays)) && (contractDays === void 0 || lockoutDays < contractDays);
    if (contractDays !== void 0 && lockoutFits && lockoutDays + deadline > contractDays) {
      fail("renewalAdjustmentDeadlineError", t("validationRenewalAdjustmentDeadlineExceedsContract"));
    }
  }
}

// src/aipo/CreateConfig/wizardSteps.tsx
import Link17 from "@amzn/awsui-components-react/polaris/link";

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/SelectProductDimensionsStep.tsx
import * as React9 from "react";
import Container14 from "@amzn/awsui-components-react/polaris/container";
import Header17 from "@amzn/awsui-components-react/polaris/header";
import FormField6 from "@amzn/awsui-components-react/polaris/form-field";
import Select4 from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween21 from "@amzn/awsui-components-react/polaris/space-between";
import Alert5 from "@amzn/awsui-components-react/polaris/alert";

// src/aipo/CreateConfig/capabilities/artifact-utils.ts
var DEFAULT_CONFIGURATION_REQUEST = {
  productId: "",
  currencyCode: "USD",
  maxFutureStartDuration: "P0D"
};
function isFdaEnabled(maxFutureStartDuration) {
  return maxFutureStartDuration !== void 0 && maxFutureStartDuration !== DEFAULT_CONFIGURATION_REQUEST.maxFutureStartDuration;
}
var DEFAULT_PROPOSED_GUIDANCE = {};

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/dimensionUtils.ts
var cleanupPerDimensionDiscountTiers = (discountStrategy, selectedDimensionKeys) => {
  if (!discountStrategy || discountStrategy.strategy !== "PER_DIMENSION_TCV" && discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
    return discountStrategy;
  }
  const existingTiers = discountStrategy.perDimensionTcvTiers;
  const cleanedTiers = {};
  for (const [dimensionKey, tiers] of Object.entries(existingTiers)) {
    if (selectedDimensionKeys.has(dimensionKey)) {
      cleanedTiers[dimensionKey] = tiers;
    }
  }
  return {
    ...discountStrategy,
    perDimensionTcvTiers: cleanedTiers
  };
};
var cleanupProposedGuidance = (proposedGuidance, selectedDimensionKeys) => {
  if (!proposedGuidance)
    return proposedGuidance;
  const cleaned = {};
  for (const [key, value] of Object.entries(proposedGuidance)) {
    if (selectedDimensionKeys.has(key)) {
      cleaned[key] = value;
    }
  }
  return Object.keys(cleaned).length > 0 ? cleaned : void 0;
};
var preserveDimensionRates = (existingRates, targetDimensions) => {
  const existingRatesMap = new Map(existingRates.map((rate) => [rate.dimensionKey, rate]));
  return targetDimensions.map((dim) => {
    const existing = existingRatesMap.get(dim.apiIdentifier);
    return existing || {
      dimensionKey: dim.apiIdentifier,
      price: 0,
      supplementaryDescription: void 0
    };
  });
};

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/AvailableDimensionsTable.tsx
import Header15 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween19 from "@amzn/awsui-components-react/polaris/space-between";
import Box14 from "@amzn/awsui-components-react/polaris/box";
import Button9 from "@amzn/awsui-components-react/polaris/button";
import Alert4 from "@amzn/awsui-components-react/polaris/alert";
import { ManagedTable as ManagedTable5 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { AppTrans as AppTrans5 } from "@amzn/awsmp-max-translations";
import TextContent7 from "@cloudscape-design/components/text-content";

// src/aipo/CreateConfig/components/AdditionalInformationStep/priceValidation.ts
var MAX_PRICE = 1e6;
var DIMENSION_PRICE_PRECISION = 7;
var restrictPriceInput = (next, previous) => restrictDecimalInput(next, previous, DIMENSION_PRICE_PRECISION);
var validatePrice = (value, t) => {
  const trimmedValue = value.replace(/,/g, "").trim();
  if (!trimmedValue) {
    return { isValid: true, numericValue: 0 };
  }
  const numericValue = parseFloat(trimmedValue);
  if (isNaN(numericValue)) {
    return { isValid: false, error: t("validationPriceValidNumber"), numericValue: null };
  }
  if (numericValue < 0) {
    return { isValid: false, error: t("validationPriceGreaterThanZero"), numericValue: null };
  }
  if (numericValue > MAX_PRICE) {
    return { isValid: false, error: t("validationPriceMaxExceeded"), numericValue: null };
  }
  const decimalIndex = trimmedValue.indexOf(".");
  if (decimalIndex !== -1) {
    const decimalPlaces = trimmedValue.length - decimalIndex - 1;
    if (decimalPlaces > DIMENSION_PRICE_PRECISION) {
      return { isValid: false, error: t("validationPriceMaxDecimals"), numericValue: null };
    }
  }
  return { isValid: true, numericValue };
};

// src/aipo/CreateConfig/components/ReviewAndCreate/config/reviewColumnDefinitions.ts
var DESCRIPTION_COLUMN_WIDTH = "400px";
var DIMENSION_NAME_MIN_WIDTH = "150px";
var API_IDENTIFIER_MIN_WIDTH = "130px";
var createDimensionNameColumn = (t, productDimensions, minWidth) => ({
  id: "dimension",
  header: t("dimensionName"),
  cell: (item) => {
    const matchingDimension = productDimensions.get(item.dimensionKey);
    return matchingDimension?.dimension || item.dimensionKey;
  },
  sortingField: "dimensionKey",
  minWidth
});
var createApiIdentifierColumn = (t, minWidth) => ({
  id: "apiIdentifier",
  header: t("apiIdentifier"),
  cell: (item) => item.dimensionKey,
  sortingField: "dimensionKey",
  minWidth
});
var createDimensionColumns = (t, productDimensions) => [
  createDimensionNameColumn(t, productDimensions, DIMENSION_NAME_MIN_WIDTH),
  createApiIdentifierColumn(t, API_IDENTIFIER_MIN_WIDTH),
  {
    id: "description",
    header: t("description"),
    cell: (item) => {
      const matchingDimension = productDimensions.get(item.dimensionKey);
      return matchingDimension?.description || t("noDescriptionProvided");
    },
    sortingField: "description",
    width: DESCRIPTION_COLUMN_WIDTH
  }
];
var createPriceColumns = (t, productDimensions) => [
  createDimensionNameColumn(t, productDimensions, "162px"),
  createApiIdentifierColumn(t, "113px"),
  {
    id: "pricePerMonth",
    header: t("pricePerMonth"),
    // Preserve the full entered precision: toLocaleString defaults to a max of 3
    // fraction digits, which would truncate a 7-decimal price (e.g. 10.1234567 →
    // "10.123"). Cap at the same DIMENSION_PRICE_PRECISION the input accepts.
    cell: (item) => item.price !== null && item.price !== void 0 ? `$${item.price.toLocaleString("en-US", { maximumFractionDigits: DIMENSION_PRICE_PRECISION })}` : "$0",
    sortingField: "price",
    minWidth: "146px"
  }
];
var createDescriptionReviewColumns = (t, proposedGuidance) => [
  {
    id: "dimensionName",
    header: t("dimensionName"),
    cell: (item) => item.dimension || "",
    minWidth: DIMENSION_NAME_MIN_WIDTH
  },
  {
    id: "description",
    header: t("description"),
    cell: (item) => {
      const content = proposedGuidance?.[item.apiIdentifier]?.content;
      return content || item.description || t("noDescriptionProvided");
    },
    width: DESCRIPTION_COLUMN_WIDTH
  }
];
var createPerDimensionDiscountColumns = (t) => [
  {
    id: "minUnitQuantity",
    header: t("minimumUnitQuantity"),
    cell: (item) => item.minValue.toLocaleString(),
    sortingField: "minValue"
  },
  {
    id: "maxUnitQuantity",
    header: t("maximumUnitQuantity"),
    cell: (item) => item.maxValue.toLocaleString(),
    sortingField: "maxValue"
  },
  {
    id: "discountPercent",
    header: t("discountPercentage"),
    cell: (item) => `${item.discountPercentage}%`,
    sortingField: "discountPercentage"
  }
];
var createTcvDiscountColumns = (t) => [
  {
    id: "fromAmount",
    header: t("minimumValueUsd"),
    cell: (item) => `$${item.minValue.toLocaleString("en-US")}`,
    sortingField: "minValue"
  },
  {
    id: "toAmount",
    header: t("maximumValueUsd"),
    cell: (item) => `$${item.maxValue.toLocaleString("en-US")}`,
    sortingField: "maxValue"
  },
  {
    id: "discountPercent",
    header: t("discountPercentage"),
    cell: (item) => `${item.discountPercentage}%`,
    sortingField: "discountPercentage"
  }
];

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/config/columnDefinitions.ts
var createDimensionColumnDefinitions = (t) => [
  {
    id: "dimension",
    header: t("dimensionName"),
    cell: (item) => item.dimension,
    sortingField: "dimension",
    width: "200px"
  },
  {
    id: "apiIdentifier",
    header: t("apiIdentifier"),
    cell: (item) => item.apiIdentifier,
    sortingField: "apiIdentifier",
    width: "150px"
  },
  {
    id: "description",
    header: t("description"),
    cell: (item) => item.description,
    sortingField: "description",
    // Explicit width (not just maxWidth): as the last column, Description would
    // otherwise stretch to fill all leftover table width. maxWidth caps content
    // sizing but does NOT stop the fill-stretch. This shares the same bounded
    // width as the ReviewAndCreate description column intentionally, so the two
    // description columns stay visually consistent.
    width: DESCRIPTION_COLUMN_WIDTH
  }
];
var commonTableProps = {
  wrapLines: true,
  selectionType: "multi",
  variant: "embedded",
  trackBy: "apiIdentifier",
  sorting: { defaultState: { sortingColumn: { sortingField: "dimension" } } },
  pagination: {}
};

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/AvailableDimensionsTable.tsx
import { jsx as jsx26, jsxs as jsxs22 } from "react/jsx-runtime";
var AvailableDimensionsTable = ({
  items,
  selectedItems,
  onSelectionChange,
  onSelectAll,
  isLoading,
  totalDimensionCount,
  isAlertDismissed,
  onDismissAlert,
  t
}) => {
  const dimensionColumns = createDimensionColumnDefinitions(t);
  return /* @__PURE__ */ jsx26(
    ManagedTable5,
    {
      ...commonTableProps,
      columnDefinitions: dimensionColumns,
      preferenceKey: "product-dimensions-table",
      hidePreferences: true,
      "data-testid": "product-dimensions-table",
      items,
      selectedItems,
      onSelectionChange: ({ detail }) => onSelectionChange(detail),
      loading: isLoading,
      loadingText: t("loading"),
      ariaLabels: {
        selectionGroupLabel: t("productDimensionsSelection"),
        allItemsSelectionLabel: ({ selectedItems: selectedItems2 }) => `${selectedItems2.length} ${selectedItems2.length === 1 ? t("dimension") : t("dimensions")} selected`,
        itemSelectionLabel: ({ selectedItems: selectedItems2 }, item) => {
          const isItemSelected = selectedItems2.filter((i) => i.apiIdentifier === item.apiIdentifier).length;
          return t(isItemSelected ? "isSelected" : "isNotSelected", { name: item.dimension });
        }
      },
      filtering: {
        filteringPlaceholder: t("findDimensions"),
        filteringAriaLabel: t("findDimensions")
      },
      header: /* @__PURE__ */ jsx26(
        Header15,
        {
          counter: selectedItems.length > 0 ? `(${selectedItems.length}/${totalDimensionCount})` : `(${totalDimensionCount})`,
          description: /* @__PURE__ */ jsxs22(SpaceBetween19, { direction: "vertical", size: "s", children: [
            /* @__PURE__ */ jsx26(Box14, { color: "text-body-secondary", children: t("productDimensionsStepDescription") }),
            !isAlertDismissed && /* @__PURE__ */ jsx26(
              Alert4,
              {
                type: "info",
                dismissible: true,
                onDismiss: onDismissAlert,
                action: /* @__PURE__ */ jsx26(
                  Button9,
                  {
                    iconName: "external",
                    iconAlign: "right",
                    target: "_blank",
                    href: "https://docs.aws.amazon.com/marketplace/latest/userguide/express-private-offers-custom-dimensions.html",
                    children: t("viewDocumentation")
                  }
                ),
                children: /* @__PURE__ */ jsx26(TextContent7, { children: /* @__PURE__ */ jsx26(AppTrans5, { i18nKey: "dimensionsImportAlert", children: /* @__PURE__ */ jsx26("strong", {}) }) })
              }
            )
          ] }),
          actions: /* @__PURE__ */ jsx26(Button9, { onClick: onSelectAll, disabled: selectedItems.length === totalDimensionCount, children: t("selectAll") }),
          children: t("productDimensions")
        }
      )
    }
  );
};

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/SelectedDimensionsTable.tsx
import Header16 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween20 from "@amzn/awsui-components-react/polaris/space-between";
import Box15 from "@amzn/awsui-components-react/polaris/box";
import Button10 from "@amzn/awsui-components-react/polaris/button";
import { ManagedTable as ManagedTable6 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { jsx as jsx27, jsxs as jsxs23 } from "react/jsx-runtime";
var SelectedDimensionsTable = ({
  items,
  selectedItems,
  onSelectionChange,
  onSelectAll,
  onRemove,
  t
}) => {
  const dimensionColumns = createDimensionColumnDefinitions(t);
  return /* @__PURE__ */ jsx27(
    ManagedTable6,
    {
      ...commonTableProps,
      columnDefinitions: dimensionColumns,
      preferenceKey: "selected-dimensions-table",
      hidePreferences: true,
      items,
      selectedItems,
      onSelectionChange: ({ detail }) => onSelectionChange(detail),
      ariaLabels: {
        selectionGroupLabel: t("selectedDimensionsSelection"),
        allItemsSelectionLabel: ({ selectedItems: selectedItems2 }) => `${selectedItems2.length} ${selectedItems2.length === 1 ? t("dimension") : t("dimensions")} ${t("selectedFromSelectedDimensions")}`,
        itemSelectionLabel: ({ selectedItems: selectedItems2 }, item) => {
          const isItemSelected = selectedItems2.filter((i) => i.apiIdentifier === item.apiIdentifier).length;
          return t(isItemSelected ? "isSelected" : "isNotSelected", { name: item.dimension });
        }
      },
      filtering: {
        filteringPlaceholder: t("findSelectedDimensions"),
        filteringAriaLabel: t("findSelectedDimensions")
      },
      empty: /* @__PURE__ */ jsxs23(Box15, { textAlign: "center", color: "inherit", children: [
        /* @__PURE__ */ jsx27("b", { children: t("noDimensions") }),
        /* @__PURE__ */ jsx27(Box15, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionsToDisplay") })
      ] }),
      header: /* @__PURE__ */ jsx27(
        Header16,
        {
          counter: selectedItems.length > 0 ? `(${selectedItems.length}/${items.length})` : `(${items.length})`,
          actions: /* @__PURE__ */ jsxs23(SpaceBetween20, { direction: "horizontal", size: "xs", children: [
            /* @__PURE__ */ jsx27(Button10, { onClick: onSelectAll, disabled: selectedItems.length === items.length || items.length === 0, children: t("selectAll") }),
            /* @__PURE__ */ jsx27(Button10, { onClick: onRemove, disabled: selectedItems.length === 0, children: t("remove") })
          ] }),
          children: t("selectedDimensions")
        }
      )
    }
  );
};

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/SelectProductDimensionsStep.tsx
import { jsx as jsx28, jsxs as jsxs24 } from "react/jsx-runtime";
var SelectProductDimensionsStep = ({
  availableProducts,
  writeableArtifact,
  errors,
  clearFieldError,
  productDimensions = /* @__PURE__ */ new Map(),
  isLoadingDimensions,
  isLoadingProducts,
  logger,
  t,
  isEditMode = false
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const selectedProductId = artifact.configurationRequest.productId;
  const [selectedFromSelectedDimensions, setSelectedFromSelectedDimensions] = React9.useState([]);
  const [isAlertDismissed, setIsAlertDismissed] = React9.useState(false);
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.SELECT_PRODUCT_DIMENSIONS);
  const productDimensionsArray = React9.useMemo(() => {
    return Array.from(productDimensions.values());
  }, [productDimensions]);
  const selectedDimensions = React9.useMemo(() => {
    if (!artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates) {
      return [];
    }
    return artifact.configurationRequest.configurableUpfrontDimensionRates.dimensionRates.reduce((acc, dimRate) => {
      const dimension = productDimensions.get(dimRate.dimensionKey);
      if (dimension)
        acc.push(dimension);
      return acc;
    }, []);
  }, [artifact.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handleSelectAll = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "product-dimensions-table",
        ClickAct: "select-all"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => {
      const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
      const dimensionRates = preserveDimensionRates(existingRates, Array.from(productDimensions.values()));
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            duration: "P1M",
            dimensionRates
          }
        }
      };
    });
  };
  const handleSelectAllSelected = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "selected-dimensions-table",
        ClickAct: "select-all"
      },
      value: 1,
      unit: "Count"
    });
    setSelectedFromSelectedDimensions([...selectedDimensions]);
  };
  const handleRemoveSelected = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "selected-dimensions-table",
        ClickAct: "remove"
      },
      value: 1,
      unit: "Count"
    });
    const idsToRemove = selectedFromSelectedDimensions.map((item) => item.apiIdentifier);
    const remainingDimensionKeys = new Set(
      selectedDimensions.filter((item) => !idsToRemove.includes(item.apiIdentifier)).map((item) => item.apiIdentifier)
    );
    setArtifact((prev) => {
      const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
      const dimensionRates = existingRates.filter((rate) => remainingDimensionKeys.has(rate.dimensionKey));
      const discountStrategy = cleanupPerDimensionDiscountTiers(prev.configurationRequest.discountStrategy, remainingDimensionKeys);
      const proposedGuidance = cleanupProposedGuidance(prev.proposedGuidance, remainingDimensionKeys);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            duration: "P1M",
            dimensionRates
          },
          discountStrategy
        },
        proposedGuidance
      };
    });
    setSelectedFromSelectedDimensions([]);
  };
  const productOptions = availableProducts.map((product) => ({
    label: `${product.name} (${product.id})`,
    value: product.id
  }));
  const productOptionsWithPlaceholder = isLoadingProducts || productOptions.length > 0 ? [{ label: t("selectProductPlaceholder"), value: "" }, ...productOptions] : productOptions;
  const handleDimensionSelectionChange = ({ selectedItems }) => {
    selectedItems.forEach((item) => {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "product-dimensions-table",
          ClickObj: "product-dimension-row-select",
          ClickAct: item.dimension
        },
        value: 1,
        unit: "Count"
      });
    });
    const selectedDimensionKeys = new Set(selectedItems.map((item) => item.apiIdentifier));
    setArtifact((prev) => {
      const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
      const dimensionRates = preserveDimensionRates(existingRates, selectedItems);
      const discountStrategy = cleanupPerDimensionDiscountTiers(prev.configurationRequest.discountStrategy, selectedDimensionKeys);
      const proposedGuidance = cleanupProposedGuidance(prev.proposedGuidance, selectedDimensionKeys);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            duration: "P1M",
            dimensionRates
          },
          discountStrategy
        },
        proposedGuidance
      };
    });
    if (selectedItems.length > 0 && errors.dimensionsError) {
      clearFieldError("dimensionsError");
    }
  };
  const handleSelectedDimensionSelectionChange = ({ selectedItems }) => {
    selectedItems.forEach((item) => {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "selected-dimensions-table",
          ClickObj: "selected-dimensions-row-select",
          ClickAct: item.dimension
        },
        value: 1,
        unit: "Count"
      });
    });
    setSelectedFromSelectedDimensions(selectedItems);
  };
  return /* @__PURE__ */ jsxs24(SpaceBetween21, { direction: "vertical", size: "l", children: [
    !isEditMode && /* @__PURE__ */ jsx28(Container14, { header: /* @__PURE__ */ jsx28(Header17, { variant: "h2", children: t("productSelection") }), children: /* @__PURE__ */ jsx28(FormField6, { errorText: errors.productError, label: t("product"), description: t("productDescriptionEpo"), children: /* @__PURE__ */ jsx28(
      Select4,
      {
        "data-testid": "product-select",
        selectedOption: productOptionsWithPlaceholder.find((option) => option.value === selectedProductId) || productOptionsWithPlaceholder[0],
        empty: t("noEligibleProducts"),
        onChange: ({ detail }) => {
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "product-container",
              ClickAct: "product-selection-dropdown"
            },
            value: 1,
            unit: "Count"
          });
          setArtifact((prev) => ({
            ...prev,
            configurationRequest: {
              ...DEFAULT_CONFIGURATION_REQUEST,
              productId: detail.selectedOption.value ?? ""
            },
            proposedGuidance: DEFAULT_PROPOSED_GUIDANCE
          }));
          clearFieldError("productError");
        },
        options: isLoadingProducts ? [] : productOptionsWithPlaceholder,
        placeholder: t("selectProductPlaceholder"),
        loadingText: t("loadingProducts"),
        statusType: isLoadingProducts ? "loading" : void 0
      }
    ) }) }),
    selectedProductId && /* @__PURE__ */ jsx28(Container14, { children: /* @__PURE__ */ jsxs24("div", { style: { display: "flex", flexDirection: "column", gap: "40px" }, children: [
      /* @__PURE__ */ jsx28(
        AvailableDimensionsTable,
        {
          items: productDimensionsArray,
          selectedItems: selectedDimensions,
          onSelectionChange: handleDimensionSelectionChange,
          onSelectAll: handleSelectAll,
          isLoading: isLoadingDimensions || isLoadingProducts,
          totalDimensionCount: productDimensions.size,
          isAlertDismissed,
          onDismissAlert: () => setIsAlertDismissed(true),
          t
        }
      ),
      /* @__PURE__ */ jsx28(
        SelectedDimensionsTable,
        {
          items: selectedDimensions,
          selectedItems: selectedFromSelectedDimensions,
          onSelectionChange: handleSelectedDimensionSelectionChange,
          onSelectAll: handleSelectAllSelected,
          onRemove: handleRemoveSelected,
          t
        }
      ),
      errors.dimensionsError && /* @__PURE__ */ jsx28(Alert5, { type: "error", "data-testid": "dimensions-error", dismissible: true, onDismiss: () => clearFieldError("dimensionsError"), children: errors.dimensionsError }),
      errors.dimensionLimitError && /* @__PURE__ */ jsx28(
        Alert5,
        {
          type: "error",
          dismissible: true,
          onDismiss: () => clearFieldError("dimensionLimitError"),
          header: t("dimensionLimitExceededHeader"),
          children: errors.dimensionLimitError
        }
      )
    ] }) })
  ] });
};

// src/aipo/CreateConfig/components/AdditionalInformationStep/AdditionalInformationStep.tsx
import * as React10 from "react";
import Header18 from "@amzn/awsui-components-react/polaris/header";
import Input4 from "@amzn/awsui-components-react/polaris/input";
import FormField7 from "@amzn/awsui-components-react/polaris/form-field";
import SpaceBetween22 from "@amzn/awsui-components-react/polaris/space-between";
import Alert6 from "@amzn/awsui-components-react/polaris/alert";
import { ManagedTable as ManagedTable7 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { jsx as jsx29, jsxs as jsxs25 } from "react/jsx-runtime";
var AdditionalInformationStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  layoutComponents: _layoutComponents,
  productDimensions = /* @__PURE__ */ new Map(),
  logger,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const priceValidationErrors = React10.useRef(/* @__PURE__ */ new Map());
  const [rawPriceInputs, setRawPriceInputs] = React10.useState({});
  React10.useEffect(() => {
    const errorsRef = priceValidationErrors.current;
    return () => {
      errorsRef.clear();
    };
  }, []);
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.SET_PRICING_AND_DETAILS);
  const selectedDimensions = React10.useMemo(() => {
    if (!artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates) {
      return [];
    }
    return artifact.configurationRequest.configurableUpfrontDimensionRates.dimensionRates.reduce((acc, dimRate) => {
      const matchingDimension = productDimensions.get(dimRate.dimensionKey);
      if (matchingDimension) {
        acc.push({
          ...matchingDimension,
          pricePerUnit: dimRate.price,
          expressPrivateOfferDescription: dimRate.supplementaryDescription
        });
      }
      return acc;
    }, []);
  }, [artifact.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handlePriceChange = (dimensionId, newPrice) => {
    setArtifact((prev) => {
      const currentRates = prev.configurationRequest.configurableUpfrontDimensionRates;
      if (!currentRates?.dimensionRates) {
        return prev;
      }
      const updatedDimensionRates = currentRates.dimensionRates.map(
        (dimRate) => dimRate.dimensionKey === dimensionId ? { ...dimRate, price: newPrice || 0 } : dimRate
      );
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            dimensionRates: updatedDimensionRates,
            ...currentRates.duration && { duration: currentRates.duration }
          }
        }
        // TS can't verify nested spread matches Partial<Pick<...>> — safe cast
      };
    });
    if (newPrice !== null && newPrice !== void 0 && errors.missingPricesError) {
      clearFieldError("missingPricesError");
    }
  };
  return /* @__PURE__ */ jsxs25(SpaceBetween22, { size: "l", children: [
    /* @__PURE__ */ jsx29(
      ManagedTable7,
      {
        preferenceKey: "aipo-dimension-prices-table",
        hidePreferences: true,
        stickyColumns: { last: 1 },
        wrapLines: false,
        filtering: {
          filteringPlaceholder: "Find dimensions",
          filteringAriaLabel: "Find dimensions"
        },
        pagination: {},
        columnDefinitions: [
          {
            id: "dimension",
            header: t("dimensionName"),
            cell: (item) => item.dimension,
            sortingField: "dimension"
          },
          {
            id: "apiIdentifier",
            header: t("apiIdentifier"),
            cell: (item) => item.apiIdentifier,
            sortingField: "apiIdentifier"
          },
          {
            id: "pricePerUnit",
            header: t("pricePerMonth"),
            cell: (item) => {
              const rawValue = rawPriceInputs[item.apiIdentifier];
              const storedValue = item.pricePerUnit !== null && item.pricePerUnit !== void 0 ? item.pricePerUnit.toString() : "";
              const currentValue = rawValue !== void 0 ? rawValue : storedValue;
              const errorMessage = priceValidationErrors.current.get(item.apiIdentifier);
              return /* @__PURE__ */ jsx29(FormField7, { errorText: errorMessage, children: /* @__PURE__ */ jsx29(
                Input4,
                {
                  ariaRequired: true,
                  type: "text",
                  inputMode: "decimal",
                  value: currentValue,
                  onChange: ({ detail }) => {
                    const withoutSeparators = detail.value.replace(/,/g, "");
                    const restricted = restrictPriceInput(withoutSeparators, currentValue);
                    setRawPriceInputs((prev) => ({ ...prev, [item.apiIdentifier]: restricted }));
                    const result = validatePrice(restricted, t);
                    if (result.isValid) {
                      priceValidationErrors.current.delete(item.apiIdentifier);
                      handlePriceChange(item.apiIdentifier, result.numericValue);
                    } else {
                      priceValidationErrors.current.set(item.apiIdentifier, result.error);
                    }
                  },
                  onFocus: () => {
                    logger.biMetric({
                      metricName: "Click",
                      dimensions: {
                        ClickFeat: "price-and-details-table",
                        ClickObj: "price-per-month-column",
                        ClickAct: item.dimension
                      },
                      value: 1,
                      unit: "Count"
                    });
                  },
                  placeholder: "0",
                  invalid: !!errorMessage
                }
              ) });
            },
            minWidth: 211
          }
        ],
        items: selectedDimensions,
        trackBy: "apiIdentifier",
        header: /* @__PURE__ */ jsx29(SpaceBetween22, { size: "s", children: /* @__PURE__ */ jsx29(Header18, { variant: "h2", counter: `(${selectedDimensions.length})`, description: t("pricingDescription"), children: t("pricingHeader") }) })
      }
    ),
    errors.missingPricesError && /* @__PURE__ */ jsx29(Alert6, { "data-testid": "missing-prices-error", type: "error", dismissible: true, onDismiss: () => clearFieldError("missingPricesError"), children: errors.missingPricesError })
  ] });
};

// src/aipo/CreateConfig/components/OfferSettingsStep/OfferSettingsStep.tsx
import * as React11 from "react";
import Container16 from "@amzn/awsui-components-react/polaris/container";
import Header20 from "@amzn/awsui-components-react/polaris/header";
import FormField9 from "@amzn/awsui-components-react/polaris/form-field";
import Input5 from "@amzn/awsui-components-react/polaris/input";
import Select5 from "@amzn/awsui-components-react/polaris/select";
import Checkbox from "@amzn/awsui-components-react/polaris/checkbox";
import SpaceBetween24 from "@amzn/awsui-components-react/polaris/space-between";
import { EULA_DOCUMENT_TYPE } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/components/OfferSettingsStep/offerSettingsUtils.ts
var validateDuration = (value, constraints) => {
  if (value === "") {
    return { newValue: "", errorMessage: void 0 };
  }
  const integerValue = parseIntegerValue(value);
  let errorMessage;
  if (integerValue !== void 0) {
    const { min, max } = constraints;
    if (min !== void 0 ? integerValue < min || integerValue > max : integerValue > max) {
      errorMessage = constraints.errorMessage;
    }
  }
  const toISO = constraints.unit === "months" ? monthsToISO8601 : daysToISO8601;
  const effectiveValue = integerValue ?? 0;
  const newValue = effectiveValue > 0 ? toISO(effectiveValue) : "";
  return { newValue, errorMessage };
};

// src/aipo/CreateConfig/components/OfferSettingsStep/BuyerInstallmentPlanCard.tsx
import Container15 from "@amzn/awsui-components-react/polaris/container";
import Header19 from "@amzn/awsui-components-react/polaris/header";
import FormField8 from "@amzn/awsui-components-react/polaris/form-field";
import Multiselect from "@amzn/awsui-components-react/polaris/multiselect";
import RadioGroup2 from "@amzn/awsui-components-react/polaris/radio-group";
import SpaceBetween23 from "@amzn/awsui-components-react/polaris/space-between";
import Link12 from "@amzn/awsui-components-react/polaris/link";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG10 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { jsx as jsx30, jsxs as jsxs26 } from "react/jsx-runtime";
var parseFrequencies = (selected) => {
  return selected.map((option) => option.value).filter(isPaymentFrequency);
};
var BOOLEAN_RADIO_TRUE = "true";
var BOOLEAN_RADIO_FALSE = "false";
var radioValueFor = (value) => {
  if (value === void 0)
    return null;
  return value ? BOOLEAN_RADIO_TRUE : BOOLEAN_RADIO_FALSE;
};
var BuyerInstallmentPlanCard = ({
  t,
  logger,
  writeableArtifact,
  paymentScheduleAllowedError,
  allowedFrequenciesError,
  initialPaymentAllowedError,
  clearFieldError,
  openHelpPanel
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const selectedFrequencies = artifact.configurationRequest.allowedFrequencies ?? [];
  const initialPaymentAllowed = artifact.configurationRequest.initialPaymentAllowed;
  const paymentScheduleAllowed = artifact.configurationRequest.paymentScheduleAllowed;
  const options = INSTALLMENT_FREQUENCIES.map((value) => ({
    value,
    label: frequencyLabel(value, t)
  }));
  const selectedOptions = selectedFrequencies.map((value) => ({
    value,
    label: frequencyLabel(value, t)
  }));
  const paymentScheduleGateItems = [
    {
      value: BOOLEAN_RADIO_TRUE,
      label: t("paymentScheduleAllowedLabel"),
      description: t("paymentScheduleAllowedDescription")
    },
    {
      value: BOOLEAN_RADIO_FALSE,
      label: t("paymentScheduleNotAllowedLabel"),
      description: t("paymentScheduleNotAllowedDescription")
    }
  ];
  const initialCustomPaymentItems = [
    {
      value: BOOLEAN_RADIO_TRUE,
      label: t("initialCustomPaymentAllowedLabel"),
      description: t("initialCustomPaymentAllowedDescription")
    },
    {
      value: BOOLEAN_RADIO_FALSE,
      label: t("initialCustomPaymentNotAllowedLabel"),
      description: t("initialCustomPaymentNotAllowedDescription")
    }
  ];
  const onPaymentScheduleAllowedChange = ({ detail }) => {
    const allowed = detail.value === BOOLEAN_RADIO_TRUE;
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "buyer-payment-schedule",
        ClickObj: allowed ? "Allowed" : "Not allowed",
        ClickAct: "payment-schedule-gate"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        paymentScheduleAllowed: allowed,
        ...allowed ? {} : { allowedFrequencies: void 0, initialPaymentAllowed: void 0 }
      }
    }));
    clearFieldError("paymentScheduleAllowedError");
    if (!allowed) {
      clearFieldError("allowedFrequenciesError");
      clearFieldError("initialPaymentAllowedError");
    }
  };
  const onInitialPaymentAllowedChange = ({ detail }) => {
    const allowed = detail.value === BOOLEAN_RADIO_TRUE;
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "buyer-payment-schedule",
        ClickObj: allowed ? "Allowed" : "Not allowed",
        ClickAct: "initial-custom-payment"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: { ...prev.configurationRequest, initialPaymentAllowed: allowed }
    }));
    clearFieldError("initialPaymentAllowedError");
  };
  const onFrequenciesChange = (newSelection) => {
    const added = newSelection.filter((f) => !selectedFrequencies.includes(f));
    const removed = selectedFrequencies.filter((f) => !newSelection.includes(f));
    for (const frequency of added) {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "buyer-payment-schedule",
          ClickObj: frequency,
          ClickAct: "select-installment-frequency"
        },
        value: 1,
        unit: "Count"
      });
    }
    for (const frequency of removed) {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "buyer-payment-schedule",
          ClickObj: frequency,
          ClickAct: "remove-installment-frequency"
        },
        value: 1,
        unit: "Count"
      });
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        allowedFrequencies: newSelection.length > 0 ? newSelection : void 0
      }
    }));
    if (newSelection.length > 0) {
      clearFieldError("allowedFrequenciesError");
    }
  };
  return /* @__PURE__ */ jsx30(
    Container15,
    {
      header: /* @__PURE__ */ jsx30(
        Header19,
        {
          variant: "h2",
          description: t("buyerInstallmentPlanDescription"),
          info: openHelpPanel ? /* @__PURE__ */ jsx30(
            Link12,
            {
              variant: "info",
              ariaLabel: t("infoAriaLabel", { section: t("buyerPaymentSchedule") }),
              onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG10.CONFIG_BUYER_INSTALLMENT_PLAN),
              children: t("info")
            }
          ) : void 0,
          children: t("buyerPaymentSchedule")
        }
      ),
      children: /* @__PURE__ */ jsxs26(SpaceBetween23, { direction: "vertical", size: "l", children: [
        /* @__PURE__ */ jsx30(
          FormField8,
          {
            stretch: true,
            label: t("paymentScheduleGateLabel"),
            description: t("paymentScheduleGateDescription"),
            errorText: paymentScheduleAllowedError,
            children: /* @__PURE__ */ jsx30(
              RadioGroup2,
              {
                ariaRequired: true,
                "data-testid": "payment-schedule-gate-radiogroup",
                value: radioValueFor(paymentScheduleAllowed),
                items: paymentScheduleGateItems,
                onChange: onPaymentScheduleAllowedChange
              }
            )
          }
        ),
        paymentScheduleAllowed === true && /* @__PURE__ */ jsxs26(SpaceBetween23, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx30(
            FormField8,
            {
              label: t("allowedInstallmentFrequencies"),
              description: t("allowedInstallmentFrequenciesDescription"),
              errorText: allowedFrequenciesError,
              children: /* @__PURE__ */ jsx30(
                Multiselect,
                {
                  "data-testid": "allowed-installment-frequencies-multiselect",
                  placeholder: t("selectFrequencies"),
                  options,
                  selectedOptions,
                  invalid: !!allowedFrequenciesError,
                  ariaRequired: true,
                  onChange: ({ detail }) => {
                    onFrequenciesChange(parseFrequencies(detail.selectedOptions));
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ jsx30(
            FormField8,
            {
              stretch: true,
              label: t("initialCustomPayment"),
              description: t("initialCustomPaymentDescription"),
              errorText: initialPaymentAllowedError,
              children: /* @__PURE__ */ jsx30(
                RadioGroup2,
                {
                  "data-testid": "initial-custom-payment-radiogroup",
                  value: radioValueFor(initialPaymentAllowed),
                  items: initialCustomPaymentItems,
                  ariaRequired: true,
                  onChange: onInitialPaymentAllowedChange
                }
              )
            }
          )
        ] })
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/OfferSettingsStep/OfferSettingsStep.tsx
import { Fragment as Fragment4, jsx as jsx31, jsxs as jsxs27 } from "react/jsx-runtime";
var MAX_OFFER_DURATION_MONTHS = 60;
var MIN_EXPIRATION_DAYS = 1;
var MAX_EXPIRATION_DAYS = 365;
var MIN_FDA_DURATION_DAYS2 = 1;
var MAX_FDA_DURATION_DAYS2 = 365;
var OfferSettingsStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  setFieldError,
  hasPublicOffer,
  eulaDocumentType,
  logger,
  t,
  openHelpPanel
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.CONFIGURE_OFFER_SETTINGS);
  const minOfferDuration = iso8601ToMonths(artifact.configurationRequest.minOfferDuration || "");
  const maxOfferDuration = iso8601ToMonths(artifact.configurationRequest.maxOfferDuration || "");
  const eulaType = artifact.configurationRequest.eulaType || "";
  const expiration = iso8601ToDays(artifact.configurationRequest.expiration || "");
  const maxFutureStartDuration = iso8601ToDays(artifact.configurationRequest.maxFutureStartDuration || "");
  const fdaEnabled = isFdaEnabled(artifact.configurationRequest.maxFutureStartDuration);
  const handleMinOfferDurationChange = (value) => {
    const { newValue, errorMessage } = validateDuration(value, {
      max: MAX_OFFER_DURATION_MONTHS,
      unit: "months",
      errorMessage: "Minimum offer duration must not be greater than 60"
    });
    setFieldError("minOfferDurationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: { ...prev.configurationRequest, minOfferDuration: newValue }
    }));
  };
  const handleMaxOfferDurationChange = (value) => {
    const { newValue, errorMessage } = validateDuration(value, {
      max: MAX_OFFER_DURATION_MONTHS,
      unit: "months",
      errorMessage: "Maximum offer duration must not be greater than 60."
    });
    setFieldError("maxOfferDurationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: { ...prev.configurationRequest, maxOfferDuration: newValue }
    }));
  };
  const eulaOptions = React11.useMemo(() => {
    const publicOfferOption = {
      label: t("publicOfferEula"),
      value: "PUBLIC_OFFER_EULA"
    };
    if (hasPublicOffer === false) {
      publicOfferOption.disabled = true;
      publicOfferOption.disabledReason = t("eulaDisabledNoPublicOffer");
    } else if (eulaDocumentType === EULA_DOCUMENT_TYPE.StandardEula) {
      publicOfferOption.disabled = true;
      publicOfferOption.disabledReason = t("eulaDisabledStandardContract");
    }
    return [publicOfferOption, { label: t("standardContractForMarketplace"), value: "STANDARD_CONTRACT_MARKETPLACE" }];
  }, [hasPublicOffer, eulaDocumentType, t]);
  const handleEulaTypeChange = (selectedOption) => {
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        eulaType: selectedOption.value || "PUBLIC_OFFER_EULA"
      }
    }));
    if (errors.eulaTypeError) {
      clearFieldError("eulaTypeError");
    }
  };
  const handleExpirationChange = (value) => {
    const { newValue, errorMessage } = validateDuration(value, {
      min: MIN_EXPIRATION_DAYS,
      max: MAX_EXPIRATION_DAYS,
      unit: "days",
      errorMessage: "Adjust the value to ensure it is between 1 and 365 days."
    });
    setFieldError("expirationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: { ...prev.configurationRequest, expiration: newValue }
    }));
  };
  const handleMaxFutureStartDurationChange = (value) => {
    const { newValue, errorMessage } = validateDuration(value, {
      min: MIN_FDA_DURATION_DAYS2,
      max: MAX_FDA_DURATION_DAYS2,
      unit: "days",
      errorMessage: t("fdaValidityRangeError")
    });
    setFieldError("maxFutureStartDurationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: { ...prev.configurationRequest, maxFutureStartDuration: newValue }
    }));
  };
  const handleFdaEnabledChange = (checked) => {
    if (checked) {
      setArtifact((prev) => ({
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          maxFutureStartDuration: ""
        }
      }));
    } else {
      setArtifact((prev) => ({
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          maxFutureStartDuration: daysToISO8601(0)
        }
      }));
      if (errors.maxFutureStartDurationError) {
        clearFieldError("maxFutureStartDurationError");
      }
    }
  };
  const offerSettingsBody = /* @__PURE__ */ jsxs27(SpaceBetween24, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsxs27(SpaceBetween24, { direction: "horizontal", size: "l", children: [
      /* @__PURE__ */ jsx31(FormField9, { label: t("minimumOfferDurationInMonths"), errorText: errors.minOfferDurationError, children: /* @__PURE__ */ jsx31(
        Input5,
        {
          "data-testid": "min-offer-duration-input",
          value: minOfferDuration,
          onFocus: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "offer-settings",
                ClickAct: "minimum-offer-duration"
              },
              value: 1,
              unit: "Count"
            });
          },
          onChange: ({ detail }) => handleMinOfferDurationChange(detail.value),
          type: "number",
          placeholder: t("enterDuration"),
          invalid: !!errors.minOfferDurationError
        }
      ) }),
      /* @__PURE__ */ jsx31(FormField9, { label: t("maximumOfferDurationInMonths"), errorText: errors.maxOfferDurationError, children: /* @__PURE__ */ jsx31(
        Input5,
        {
          "data-testid": "max-offer-duration-input",
          value: maxOfferDuration,
          onFocus: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "offer-settings",
                ClickAct: "maximum-offer-duration"
              },
              value: 1,
              unit: "Count"
            });
          },
          onChange: ({ detail }) => handleMaxOfferDurationChange(detail.value),
          type: "number",
          placeholder: t("enterDuration"),
          invalid: !!errors.maxOfferDurationError
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx31(
      FormField9,
      {
        label: t("offerExpirationDurationInDays"),
        description: t("offerExpirationDurationDescription"),
        constraintText: t("offerExpirationDurationConstraint"),
        errorText: errors.expirationError,
        children: /* @__PURE__ */ jsx31(
          Input5,
          {
            "data-testid": "offer-expiration-input",
            value: expiration,
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "offer-settings",
                  ClickAct: "offer-expiration-duration"
                },
                value: 1,
                unit: "Count"
              });
            },
            onChange: ({ detail }) => handleExpirationChange(detail.value),
            type: "number",
            placeholder: t("enterExpirationDuration"),
            invalid: !!errors.expirationError
          }
        )
      }
    ),
    /* @__PURE__ */ jsx31(
      FormField9,
      {
        label: /* @__PURE__ */ jsxs27(Fragment4, { children: [
          /* @__PURE__ */ jsx31("b", { children: t("futureDatedAgreementFda") }),
          " - ",
          /* @__PURE__ */ jsx31("i", { children: t("optional") })
        ] }),
        description: t("futureDatedAgreementFdaDescription"),
        children: /* @__PURE__ */ jsx31(Checkbox, { "data-testid": "fda-checkbox", checked: fdaEnabled, onChange: ({ detail }) => handleFdaEnabledChange(detail.checked), children: t("enableFdaForCustomers") })
      }
    ),
    fdaEnabled && /* @__PURE__ */ jsx31(
      FormField9,
      {
        label: t("fdaValidityRangeInDays"),
        description: t("fdaValidityRangeDescription"),
        constraintText: t("fdaValidityRangeConstraint"),
        errorText: errors.maxFutureStartDurationError,
        children: /* @__PURE__ */ jsx31(
          Input5,
          {
            "data-testid": "fda-validity-range-input",
            value: maxFutureStartDuration,
            ariaRequired: true,
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "offer-settings",
                  ClickAct: "max-future-start-duration"
                },
                value: 1,
                unit: "Count"
              });
            },
            onChange: ({ detail }) => handleMaxFutureStartDurationChange(detail.value),
            type: "number",
            placeholder: t("enterNumberOfDays"),
            invalid: !!errors.maxFutureStartDurationError
          }
        )
      }
    ),
    /* @__PURE__ */ jsx31(FormField9, { label: t("endUserLicenseAgreement"), description: t("eulaDescription"), errorText: errors.eulaTypeError, children: /* @__PURE__ */ jsx31(
      Select5,
      {
        "data-testid": "eula-type-select",
        selectedOption: eulaType === "PUBLIC_OFFER_EULA" ? { label: t("publicOfferEula"), value: "PUBLIC_OFFER_EULA" } : eulaType === "STANDARD_CONTRACT_MARKETPLACE" ? { label: t("standardContractForMarketplace"), value: "STANDARD_CONTRACT_MARKETPLACE" } : null,
        onChange: ({ detail }) => {
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "offer-settings",
              ClickAct: "eula-type-dropdown"
            },
            value: 1,
            unit: "Count"
          });
          handleEulaTypeChange(detail.selectedOption);
        },
        options: eulaOptions,
        placeholder: t("selectEula"),
        invalid: !!errors.eulaTypeError
      }
    ) })
  ] });
  return /* @__PURE__ */ jsxs27(SpaceBetween24, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsx31(
      Container16,
      {
        header: /* @__PURE__ */ jsx31(Header20, { variant: "h2", children: /* @__PURE__ */ jsx31("span", { "data-testid": "offer-settings-heading", children: t("contractDetailsAndEulaHeader") }) }),
        children: offerSettingsBody
      }
    ),
    /* @__PURE__ */ jsx31(
      BuyerInstallmentPlanCard,
      {
        t,
        logger,
        writeableArtifact,
        paymentScheduleAllowedError: errors.paymentScheduleAllowedError,
        allowedFrequenciesError: errors.allowedFrequenciesError,
        initialPaymentAllowedError: errors.initialPaymentAllowedError,
        clearFieldError,
        openHelpPanel
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.tsx
import * as React16 from "react";
import Container21 from "@amzn/awsui-components-react/polaris/container";
import Header24 from "@amzn/awsui-components-react/polaris/header";
import ColumnLayout3 from "@amzn/awsui-components-react/polaris/column-layout";
import FormField12 from "@amzn/awsui-components-react/polaris/form-field";
import Input8 from "@amzn/awsui-components-react/polaris/input";
import Alert10 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween29 from "@amzn/awsui-components-react/polaris/space-between";
import Icon4 from "@amzn/awsui-components-react/polaris/icon";
import KeyValuePairs6 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link13 from "@amzn/awsui-components-react/polaris/link";
import {
  HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG11
} from "@amzn/awsmp-max-agentic-renderer-interface";
import TextContent12 from "@cloudscape-design/components/text-content";

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.module.css
var DiscountStrategyStep_default = {
  buyerProfileLabel: "DiscountStrategyStep_buyerProfileLabel",
  aiIcon: "DiscountStrategyStep_aiIcon",
  aiAssisted: "DiscountStrategyStep_aiAssisted",
  generatedByAi: "DiscountStrategyStep_generatedByAi",
  dimensionSeparator: "DiscountStrategyStep_dimensionSeparator",
  innerQuestionnaireContainer: "DiscountStrategyStep_innerQuestionnaireContainer",
  askQuestionButtonContainer: "DiscountStrategyStep_askQuestionButtonContainer"
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/tierUtils.ts
function createEmptyTier() {
  return { minValue: null, maxValue: null, discountPercentage: null };
}
function mapDimensionRates(dimensionRates, productDimensions) {
  return dimensionRates?.map((rate) => {
    const realDimension = productDimensions.get(rate.dimensionKey);
    return {
      key: rate.dimensionKey,
      name: realDimension?.dimension || rate.dimensionKey
    };
  }) || [];
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/PerDimensionDiscountEditor.tsx
import * as React12 from "react";
import Container17 from "@amzn/awsui-components-react/polaris/container";
import Header21 from "@amzn/awsui-components-react/polaris/header";
import Input6 from "@amzn/awsui-components-react/polaris/input";
import Alert7 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween25 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent8 from "@cloudscape-design/components/text-content";
import AttributeEditor from "@cloudscape-design/components/attribute-editor";

// src/aipo/CreateConfig/components/DiscountStrategyStep/strategyTypeGuards.ts
function isPerDimensionStrategy(strategy) {
  return strategy?.strategy === "PER_DIMENSION_TCV" || strategy?.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
}
function isTcvStrategy(strategy) {
  return strategy?.strategy === "TOTAL_TCV" || strategy?.strategy === "TOTAL_TCV_WITH_QUALIFICATION";
}
function isQualificationStrategy(strategy) {
  return strategy?.strategy === "QUALIFICATION" || strategy?.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || strategy?.strategy === "TOTAL_TCV_WITH_QUALIFICATION";
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/PerDimensionDiscountEditor.tsx
import { jsx as jsx32, jsxs as jsxs28 } from "react/jsx-runtime";
var MAX_TIERS_PER_DIMENSION = 5;
var PerDimensionDiscountEditor = ({
  writeableArtifact,
  productDimensions,
  clearFieldError,
  showFieldErrors,
  logger,
  t
  // openHelpPanel,
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const allowBoundaryTouch = false;
  const availableDimensions = React12.useMemo(() => {
    return mapDimensionRates(artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates, productDimensions);
  }, [artifact.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const dimensionTiers = React12.useMemo(() => {
    if (!isPerDimensionStrategy(discountStrategy)) {
      return {};
    }
    const tiers = discountStrategy.perDimensionTcvTiers || {};
    const result = {};
    Object.entries(tiers).forEach(([dimensionKey, tierArray]) => {
      result[dimensionKey] = tierArray.map((tier, index) => ({
        id: `${dimensionKey}-${index}`,
        minValue: tier.minValue,
        maxValue: tier.maxValue,
        discountPercentage: tier.discountPercentage
      }));
    });
    return result;
  }, [discountStrategy]);
  const perDimensionValidationCache = React12.useMemo(() => {
    const cache = {};
    Object.entries(dimensionTiers).forEach(([dimensionKey, tiers]) => {
      const tierData = tiers.map((tier) => ({
        minValue: tier.minValue,
        maxValue: tier.maxValue,
        discountPercentage: tier.discountPercentage
      }));
      cache[dimensionKey] = detectRangeErrors(dimensionKey, tierData, t, allowBoundaryTouch);
    });
    return cache;
  }, [dimensionTiers, allowBoundaryTouch, t]);
  const perDimensionGapCache = Object.fromEntries(
    Object.entries(dimensionTiers).map(([dimensionKey, tiers]) => [
      dimensionKey,
      detectGaps(
        tiers.map((tier) => ({ minValue: tier.minValue, maxValue: tier.maxValue, discountPercentage: tier.discountPercentage })),
        allowBoundaryTouch
      )
    ])
  );
  const getTotalPerDimensionTierCount = React12.useMemo(() => {
    let totalTiers = 0;
    Object.values(dimensionTiers).forEach((tiers) => {
      totalTiers += tiers.length;
    });
    return totalTiers;
  }, [dimensionTiers]);
  const isPerDimensionTierLimitExceeded = getTotalPerDimensionTierCount >= MAX_TOTAL_TIERS;
  const handleUpdatePerDimensionTier = (dimensionKey, tierIndex, field, value) => {
    clearFieldError("perDimensionError");
    setArtifact((prev) => {
      if (!isPerDimensionStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (!updatedTiers[dimensionKey]) {
        updatedTiers[dimensionKey] = [];
      }
      const tiersCopy = [...updatedTiers[dimensionKey]];
      if (tiersCopy[tierIndex]) {
        tiersCopy[tierIndex] = {
          minValue: tiersCopy[tierIndex].minValue,
          maxValue: tiersCopy[tierIndex].maxValue,
          discountPercentage: tiersCopy[tierIndex].discountPercentage,
          // min/max are dollar amounts (thousands separators); discount is a plain integer percent.
          [field]: value === "" ? null : field === "discountPercentage" ? parseIntegerValue(value) : parseThousandsSeparated(value)
        };
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  const handleAddPerDimensionTier = (dimensionKey, dimensionName) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "per-dimension-config",
        ClickObj: "add-new-range",
        ClickAct: dimensionName
      },
      value: 1,
      unit: "Count"
    });
    clearFieldError("perDimensionError");
    setArtifact((prev) => {
      if (!isPerDimensionStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (!updatedTiers[dimensionKey]) {
        updatedTiers[dimensionKey] = [];
      }
      const tiersCopy = [...updatedTiers[dimensionKey]];
      if (tiersCopy.length < MAX_TIERS_PER_DIMENSION) {
        tiersCopy.push(createEmptyTier());
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  const handleRemovePerDimensionTier = (dimensionKey, tierIndex, dimensionName) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "per-dimension-config",
        ClickObj: "remove",
        ClickAct: dimensionName
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => {
      if (!isPerDimensionStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (updatedTiers[dimensionKey]) {
        const tiersCopy = [...updatedTiers[dimensionKey]];
        tiersCopy.splice(tierIndex, 1);
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  return /* @__PURE__ */ jsx32(
    Container17,
    {
      header: /* @__PURE__ */ jsx32(
        Header21,
        {
          variant: "h2",
          description: t("perDimensionDiscountsEditorDescription"),
          children: t("perDimensionDiscountsHeader")
        }
      ),
      children: /* @__PURE__ */ jsxs28(SpaceBetween25, { direction: "vertical", size: "l", children: [
        /* @__PURE__ */ jsx32(Alert7, { type: "info", children: t("perDimensionDefaultDiscountInfo") }),
        availableDimensions.map((dimension, dimensionIndex) => {
          const dimensionHasGaps = perDimensionGapCache[dimension.key] ?? false;
          const dimensionHasOverlapErrors = Object.keys(perDimensionValidationCache[dimension.key]?.errorFlags ?? {}).length > 0;
          return /* @__PURE__ */ jsxs28("div", { children: [
            /* @__PURE__ */ jsxs28(SpaceBetween25, { size: "l", children: [
              /* @__PURE__ */ jsxs28(TextContent8, { children: [
                /* @__PURE__ */ jsx32("strong", { children: t("dimensionName") }),
                /* @__PURE__ */ jsx32("p", { children: dimension.name })
              ] }),
              dimensionHasGaps && !dimensionHasOverlapErrors && /* @__PURE__ */ jsx32(Alert7, { type: "warning", children: t("perDimensionTierGapWarning") }),
              /* @__PURE__ */ jsx32(
                AttributeEditor,
                {
                  items: dimensionTiers[dimension.key] || [],
                  onAddButtonClick: () => handleAddPerDimensionTier(dimension.key, dimension.name),
                  onRemoveButtonClick: ({ detail }) => handleRemovePerDimensionTier(dimension.key, detail.itemIndex, dimension.name),
                  isItemRemovable: () => getTotalPerDimensionTierCount > 1,
                  definition: [
                    {
                      label: t("minimumUnitQuantity"),
                      errorText: (item, itemIndex) => {
                        const cache = perDimensionValidationCache[dimension.key];
                        const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue`) : void 0;
                        const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue-range`) : void 0;
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                        return overlapError || rangeError || incompleteError;
                      },
                      control: (item, itemIndex) => {
                        const cache = perDimensionValidationCache[dimension.key];
                        const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue`) : void 0;
                        const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue-range`) : void 0;
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                        const hasError = !!(overlapError || rangeError || incompleteError);
                        return /* @__PURE__ */ jsx32(
                          Input6,
                          {
                            "data-testid": `tier-${itemIndex}-min`,
                            ariaRequired: true,
                            value: item.minValue?.toString() || "",
                            onFocus: () => {
                              logger.biMetric({
                                metricName: "Click",
                                dimensions: {
                                  ClickFeat: "per-dimension-config",
                                  ClickObj: "from-unit-input",
                                  ClickAct: dimension.name
                                },
                                value: 1,
                                unit: "Count"
                              });
                            },
                            onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "minValue", detail.value),
                            type: "text",
                            inputMode: "numeric",
                            placeholder: t("enterAmount"),
                            invalid: hasError,
                            disabled: isArtifactLocked
                          }
                        );
                      }
                    },
                    {
                      label: t("maximumUnitQuantity"),
                      errorText: (item, itemIndex) => {
                        const cache = perDimensionValidationCache[dimension.key];
                        const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue`) : void 0;
                        const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue-range`) : void 0;
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                        return overlapError || rangeError || incompleteError;
                      },
                      control: (item, itemIndex) => {
                        const cache = perDimensionValidationCache[dimension.key];
                        const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue`) : void 0;
                        const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue-range`) : void 0;
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                        const hasError = !!(overlapError || rangeError || incompleteError);
                        return /* @__PURE__ */ jsx32(
                          Input6,
                          {
                            "data-testid": `tier-${itemIndex}-max`,
                            ariaRequired: true,
                            value: item.maxValue?.toString() || "",
                            onFocus: () => {
                              logger.biMetric({
                                metricName: "Click",
                                dimensions: {
                                  ClickFeat: "per-dimension-config",
                                  ClickObj: "to-unit-input",
                                  ClickAct: dimension.name
                                },
                                value: 1,
                                unit: "Count"
                              });
                            },
                            onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "maxValue", detail.value),
                            type: "text",
                            inputMode: "numeric",
                            placeholder: t("enterAmount"),
                            invalid: hasError,
                            disabled: isArtifactLocked
                          }
                        );
                      }
                    },
                    {
                      label: t("discountPercentage"),
                      errorText: (item) => {
                        const invalidDiscountError = item.discountPercentage !== null && item.discountPercentage >= MAX_DISCOUNT_PERCENTAGE ? t("discountPercentageMustBeBelowHundred") : item.discountPercentage !== null && item.discountPercentage <= MIN_DISCOUNT_PERCENTAGE ? t("discountPercentageMustBeGreaterThanZero") : void 0;
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                        return invalidDiscountError || incompleteError;
                      },
                      control: (item, itemIndex) => {
                        const invalidDiscountError = item.discountPercentage !== null && (item.discountPercentage >= MAX_DISCOUNT_PERCENTAGE || item.discountPercentage <= MIN_DISCOUNT_PERCENTAGE);
                        const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                        return /* @__PURE__ */ jsx32(
                          Input6,
                          {
                            "data-testid": `tier-${itemIndex}-discount`,
                            ariaRequired: true,
                            value: item.discountPercentage?.toString() || "",
                            onFocus: () => {
                              logger.biMetric({
                                metricName: "Click",
                                dimensions: {
                                  ClickFeat: "per-dimension-config",
                                  ClickObj: "discount-input",
                                  ClickAct: dimension.name
                                },
                                value: 1,
                                unit: "Count"
                              });
                            },
                            onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "discountPercentage", detail.value),
                            type: "number",
                            placeholder: t("enterDiscount"),
                            invalid: !!(invalidDiscountError || incompleteError),
                            disabled: isArtifactLocked
                          }
                        );
                      }
                    }
                  ],
                  addButtonText: t("addNewTier"),
                  removeButtonText: t("remove"),
                  empty: t("noDiscountTierForDimension"),
                  disableAddButton: isPerDimensionTierLimitExceeded || (dimensionTiers[dimension.key] || []).length >= MAX_TIERS_PER_DIMENSION || isArtifactLocked,
                  gridLayout: [
                    {
                      rows: [[2, 2, 2]],
                      breakpoint: "s"
                    },
                    {
                      rows: [[1], [1], [1]],
                      removeButton: { ownRow: true }
                    }
                  ],
                  additionalInfo: /* @__PURE__ */ jsx32(TextContent8, { children: /* @__PURE__ */ jsx32("small", { children: isPerDimensionTierLimitExceeded ? t("perDimensionTierLimitExceeded") : (dimensionTiers[dimension.key] || []).length >= MAX_TIERS_PER_DIMENSION ? t("perDimensionTierLimitReached", { count: getTotalPerDimensionTierCount }) : t("perDimensionTiersAvailable", {
                    available: MAX_TIERS_PER_DIMENSION - (dimensionTiers[dimension.key] || []).length,
                    count: getTotalPerDimensionTierCount
                  }) }) })
                }
              )
            ] }),
            dimensionIndex < availableDimensions.length - 1 && /* @__PURE__ */ jsx32("hr", { className: DiscountStrategyStep_default.dimensionSeparator })
          ] }, dimension.key);
        })
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/TcvDiscountEditor.tsx
import * as React13 from "react";
import Container18 from "@amzn/awsui-components-react/polaris/container";
import Header22 from "@amzn/awsui-components-react/polaris/header";
import Input7 from "@amzn/awsui-components-react/polaris/input";
import Alert8 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween26 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent9 from "@cloudscape-design/components/text-content";
import AttributeEditor2 from "@cloudscape-design/components/attribute-editor";
import { jsx as jsx33, jsxs as jsxs29 } from "react/jsx-runtime";
var TcvDiscountEditor = ({
  writeableArtifact,
  clearFieldError,
  showFieldErrors,
  logger,
  t
  // openHelpPanel,
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const tcvTiers = React13.useMemo(() => {
    if (!isTcvStrategy(discountStrategy)) {
      return [];
    }
    return discountStrategy.totalTcvTiers?.map((tier, index) => ({
      id: `tcv-${index}`,
      minValue: tier.minValue,
      maxValue: tier.maxValue,
      discountPercentage: tier.discountPercentage
    })) || [];
  }, [discountStrategy]);
  const tcvValidationCache = React13.useMemo(() => {
    const tierData = tcvTiers.map((tier) => ({
      minValue: tier.minValue,
      maxValue: tier.maxValue,
      discountPercentage: tier.discountPercentage
    }));
    return detectRangeErrors("tcv", tierData, t, true);
  }, [tcvTiers, t]);
  const [displayTierValues, setDisplayTierValues] = React13.useState({});
  const hasGaps = detectGaps(
    tcvTiers.map((tier) => ({ minValue: tier.minValue, maxValue: tier.maxValue, discountPercentage: tier.discountPercentage })),
    true
  );
  const hasOverlapErrors = Object.keys(tcvValidationCache.errorFlags).length > 0;
  const handleUpdateTcvTier = (tierIndex, field, value) => {
    clearFieldError("tcvDiscountsError");
    setArtifact((prev) => {
      if (!isTcvStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      if (tiersCopy[tierIndex]) {
        const parsed = field === "discountPercentage" ? parseIntegerValue(value) : parseCurrencyValue(value);
        tiersCopy[tierIndex] = {
          ...tiersCopy[tierIndex],
          [field]: value === "" ? null : parsed
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  const handleAddTcvTier = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "tcv-config",
        ClickObj: "add-new-range",
        ClickAct: "tcv"
      },
      value: 1,
      unit: "Count"
    });
    clearFieldError("tcvDiscountsError");
    setArtifact((prev) => {
      if (!isTcvStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      if (tiersCopy.length < MAX_TCV_TIERS) {
        tiersCopy.push(createEmptyTier());
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  const handleRemoveTcvTier = (tierIndex) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "tcv-config",
        ClickObj: "remove",
        ClickAct: "tcv"
      },
      value: 1,
      unit: "Count"
    });
    setDisplayTierValues({});
    setArtifact((prev) => {
      if (!isTcvStrategy(prev.configurationRequest.discountStrategy)) {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      tiersCopy.splice(tierIndex, 1);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  return /* @__PURE__ */ jsx33(
    Container18,
    {
      header: /* @__PURE__ */ jsx33(
        Header22,
        {
          variant: "h2",
          description: t("tcvDiscountStrategyDescription"),
          children: t("tcvDiscountStrategyHeader")
        }
      ),
      children: /* @__PURE__ */ jsxs29(SpaceBetween26, { direction: "vertical", size: "l", children: [
        /* @__PURE__ */ jsx33(Alert8, { type: "info", children: t("tcvDefaultDiscountInfo") }),
        hasGaps && !hasOverlapErrors && /* @__PURE__ */ jsx33(Alert8, { type: "warning", children: t("tcvTierGapWarning") }),
        /* @__PURE__ */ jsx33(
          AttributeEditor2,
          {
            items: tcvTiers,
            onAddButtonClick: handleAddTcvTier,
            onRemoveButtonClick: ({ detail }) => handleRemoveTcvTier(detail.itemIndex),
            isItemRemovable: () => tcvTiers.length > 1,
            definition: [
              {
                label: t("minimumValueUsd"),
                errorText: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                  return overlapError || rangeError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                  const hasError = !!(overlapError || rangeError || incompleteError);
                  const displayKey = `${itemIndex}-min`;
                  return /* @__PURE__ */ jsx33(
                    Input7,
                    {
                      "data-testid": `tier-${itemIndex}-min`,
                      ariaRequired: true,
                      value: displayTierValues[displayKey] ?? item.minValue?.toString() ?? "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-from-range"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => {
                        const restricted = restrictDecimalInput(
                          detail.value,
                          displayTierValues[displayKey] ?? item.minValue?.toString() ?? "",
                          CENTS_PRECISION
                        );
                        setDisplayTierValues((prev) => ({ ...prev, [displayKey]: restricted }));
                      },
                      onBlur: () => {
                        const current = displayTierValues[displayKey];
                        if (current !== void 0) {
                          handleUpdateTcvTier(itemIndex, "minValue", current);
                          setDisplayTierValues((prev) => {
                            const next = { ...prev };
                            delete next[displayKey];
                            return next;
                          });
                        }
                      },
                      type: "text",
                      inputMode: "decimal",
                      placeholder: t("enterAmount"),
                      invalid: hasError,
                      disabled: isArtifactLocked
                    }
                  );
                }
              },
              {
                label: t("maximumValueUsd"),
                errorText: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                  return overlapError || rangeError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                  const hasError = !!(overlapError || rangeError || incompleteError);
                  const displayKey = `${itemIndex}-max`;
                  return /* @__PURE__ */ jsx33(
                    Input7,
                    {
                      "data-testid": `tier-${itemIndex}-max`,
                      ariaRequired: true,
                      value: displayTierValues[displayKey] ?? item.maxValue?.toString() ?? "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-to-range"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => {
                        const restricted = restrictDecimalInput(
                          detail.value,
                          displayTierValues[displayKey] ?? item.maxValue?.toString() ?? "",
                          CENTS_PRECISION
                        );
                        setDisplayTierValues((prev) => ({ ...prev, [displayKey]: restricted }));
                      },
                      onBlur: () => {
                        const current = displayTierValues[displayKey];
                        if (current !== void 0) {
                          handleUpdateTcvTier(itemIndex, "maxValue", current);
                          setDisplayTierValues((prev) => {
                            const next = { ...prev };
                            delete next[displayKey];
                            return next;
                          });
                        }
                      },
                      type: "text",
                      inputMode: "decimal",
                      placeholder: t("enterAmount"),
                      invalid: hasError,
                      disabled: isArtifactLocked
                    }
                  );
                }
              },
              {
                label: t("discountPercentage"),
                errorText: (item) => {
                  const invalidDiscountError = item.discountPercentage !== null && item.discountPercentage >= MAX_DISCOUNT_PERCENTAGE ? t("discountPercentageMustBeBelowHundred") : item.discountPercentage !== null && item.discountPercentage <= MIN_DISCOUNT_PERCENTAGE ? t("discountPercentageMustBeGreaterThanZero") : void 0;
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                  return invalidDiscountError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const invalidDiscountError = item.discountPercentage !== null && (item.discountPercentage >= MAX_DISCOUNT_PERCENTAGE || item.discountPercentage <= MIN_DISCOUNT_PERCENTAGE);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                  return /* @__PURE__ */ jsx33(
                    Input7,
                    {
                      "data-testid": `tier-${itemIndex}-discount`,
                      ariaRequired: true,
                      value: item.discountPercentage?.toString() || "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-discount-percentage"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => handleUpdateTcvTier(itemIndex, "discountPercentage", detail.value),
                      type: "number",
                      placeholder: t("enterDiscount"),
                      invalid: !!(invalidDiscountError || incompleteError),
                      disabled: isArtifactLocked
                    }
                  );
                }
              }
            ],
            addButtonText: t("addNewTier"),
            removeButtonText: t("remove"),
            empty: t("noDiscountTiersConfigured"),
            disableAddButton: tcvTiers.length >= MAX_TCV_TIERS || isArtifactLocked,
            gridLayout: [
              {
                rows: [[2, 2, 2]],
                breakpoint: "s"
              },
              {
                rows: [[1], [1], [1]],
                removeButton: { ownRow: true }
              }
            ],
            additionalInfo: /* @__PURE__ */ jsx33(TextContent9, { children: /* @__PURE__ */ jsx33("small", { children: tcvTiers.length >= MAX_TCV_TIERS ? t("tcvTierLimitReached") : t("tcvTiersAvailable", { available: MAX_TCV_TIERS - tcvTiers.length }) }) })
          }
        )
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/BuyerProfileEditor.tsx
import * as React15 from "react";
import Container20 from "@amzn/awsui-components-react/polaris/container";
import Header23 from "@amzn/awsui-components-react/polaris/header";
import Button12 from "@amzn/awsui-components-react/polaris/button";
import Select6 from "@amzn/awsui-components-react/polaris/select";
import Textarea3 from "@amzn/awsui-components-react/polaris/textarea";
import FormField11 from "@amzn/awsui-components-react/polaris/form-field";
import Alert9 from "@amzn/awsui-components-react/polaris/alert";
import Icon3 from "@amzn/awsui-components-react/polaris/icon";
import SpaceBetween28 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent11 from "@cloudscape-design/components/text-content";
import Grid2 from "@cloudscape-design/components/grid";

// src/aipo/CreateConfig/components/DiscountStrategyStep/QuestionnairePreviewModal.tsx
import Modal from "@amzn/awsui-components-react/polaris/modal";
import Box16 from "@amzn/awsui-components-react/polaris/box";
import Button11 from "@amzn/awsui-components-react/polaris/button";
import SpaceBetween27 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent10 from "@cloudscape-design/components/text-content";
import Icon2 from "@amzn/awsui-components-react/polaris/icon";
import Container19 from "@amzn/awsui-components-react/polaris/container";
import FormField10 from "@amzn/awsui-components-react/polaris/form-field";
import Textarea2 from "@amzn/awsui-components-react/polaris/textarea";
import { Fragment as Fragment5, jsx as jsx34, jsxs as jsxs30 } from "react/jsx-runtime";
var QuestionnairePreviewModal = ({ visible, onDismiss, questions, logger, t }) => {
  return /* @__PURE__ */ jsx34(
    Modal,
    {
      "data-testid": "questionnaire-preview-modal",
      className: "awsui-visual-refresh",
      visible,
      onDismiss,
      size: "max",
      header: /* @__PURE__ */ jsxs30(Fragment5, { children: [
        /* @__PURE__ */ jsxs30(SpaceBetween27, { direction: "horizontal", size: "s", alignItems: "center", children: [
          /* @__PURE__ */ jsx34(TextContent10, { children: /* @__PURE__ */ jsx34("h2", { children: t("customerPreview") }) }),
          /* @__PURE__ */ jsx34(TextContent10, { children: /* @__PURE__ */ jsxs30("div", { className: DiscountStrategyStep_default.aiIcon, children: [
            /* @__PURE__ */ jsx34(Icon2, { name: "gen-ai", size: "small" }),
            /* @__PURE__ */ jsx34("span", { className: DiscountStrategyStep_default.generatedByAi, children: t("generatedByAi") })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx34(TextContent10, { children: /* @__PURE__ */ jsx34("p", { children: t("reviewGeneratedQuestionnaire") }) })
      ] }),
      footer: /* @__PURE__ */ jsx34(Box16, { className: "awsui-visual-refresh", float: "right", children: /* @__PURE__ */ jsx34(
        Button11,
        {
          variant: "primary",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "modal",
                ClickObj: "close-questionnaire-preview",
                ClickAct: "close-modal"
              },
              value: 1,
              unit: "Count"
            });
            onDismiss();
          },
          children: t("closePreview")
        }
      ) }),
      children: /* @__PURE__ */ jsx34(SpaceBetween27, { direction: "vertical", size: "l", children: /* @__PURE__ */ jsxs30(SpaceBetween27, { size: "xs", children: [
        /* @__PURE__ */ jsx34(TextContent10, { children: /* @__PURE__ */ jsx34("strong", { children: t("customerView") }) }),
        /* @__PURE__ */ jsx34(Container19, { className: `awsui-visual-refresh ${DiscountStrategyStep_default.innerQuestionnaireContainer}`, children: /* @__PURE__ */ jsxs30(SpaceBetween27, { size: "s", children: [
          /* @__PURE__ */ jsxs30(TextContent10, { children: [
            /* @__PURE__ */ jsx34("h2", { children: t("questionnaire") }),
            /* @__PURE__ */ jsx34("p", { children: t("answerAdditionalQuestions") })
          ] }),
          /* @__PURE__ */ jsx34(Container19, { className: "awsui-visual-refresh", children: /* @__PURE__ */ jsx34(SpaceBetween27, { direction: "vertical", size: "l", children: questions.map((q, index) => /* @__PURE__ */ jsxs30(SpaceBetween27, { size: "xxs", children: [
            /* @__PURE__ */ jsx34(TextContent10, { children: /* @__PURE__ */ jsx34("strong", { children: q.question }) }),
            /* @__PURE__ */ jsx34(FormField10, { constraintText: t("characterCountZero"), children: /* @__PURE__ */ jsx34(Textarea2, { value: "", placeholder: q.exampleResponse || t("enterYourAnswer"), rows: 3, onChange: () => {
            } }) })
          ] }, index)) }) })
        ] }) })
      ] }) })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/qualificationUtils.ts
function getQualifications(strategy) {
  if (!strategy)
    return [];
  switch (strategy.strategy) {
    case "QUALIFICATION":
    case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
    case "TOTAL_TCV_WITH_QUALIFICATION":
      return strategy.qualifications || [];
    default:
      return [];
  }
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/hooks/usePreviewQuestionnaire.ts
import * as React14 from "react";

// ../../node_modules/serialize-error/error-constructors.js
var list = [
  // Native ES errors https://262.ecma-international.org/12.0/#sec-well-known-intrinsic-objects
  EvalError,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  // Built-in errors
  globalThis.DOMException,
  // Node-specific errors
  // https://nodejs.org/api/errors.html
  globalThis.AssertionError,
  globalThis.SystemError
].filter(Boolean).map(
  (constructor) => [constructor.name, constructor]
);
var errorConstructors = new Map(list);
var error_constructors_default = errorConstructors;

// ../../node_modules/serialize-error/index.js
var commonProperties = [
  {
    property: "name",
    enumerable: false
  },
  {
    property: "message",
    enumerable: false
  },
  {
    property: "stack",
    enumerable: false
  },
  {
    property: "code",
    enumerable: true
  },
  {
    property: "cause",
    enumerable: false
  }
];
var toJsonWasCalled = /* @__PURE__ */ new WeakSet();
var toJSON = (from) => {
  toJsonWasCalled.add(from);
  const json = from.toJSON();
  toJsonWasCalled.delete(from);
  return json;
};
var getErrorConstructor = (name) => error_constructors_default.get(name) ?? Error;
var destroyCircular = ({
  from,
  seen,
  to,
  forceEnumerable,
  maxDepth,
  depth,
  useToJSON,
  serialize
}) => {
  if (!to) {
    if (Array.isArray(from)) {
      to = [];
    } else if (!serialize && isErrorLike(from)) {
      const Error2 = getErrorConstructor(from.name);
      to = new Error2();
    } else {
      to = {};
    }
  }
  seen.push(from);
  if (depth >= maxDepth) {
    return to;
  }
  if (useToJSON && typeof from.toJSON === "function" && !toJsonWasCalled.has(from)) {
    return toJSON(from);
  }
  const continueDestroyCircular = (value) => destroyCircular({
    from: value,
    seen: [...seen],
    forceEnumerable,
    maxDepth,
    depth,
    useToJSON,
    serialize
  });
  for (const [key, value] of Object.entries(from)) {
    if (value && value instanceof Uint8Array && value.constructor.name === "Buffer") {
      to[key] = "[object Buffer]";
      continue;
    }
    if (value !== null && typeof value === "object" && typeof value.pipe === "function") {
      to[key] = "[object Stream]";
      continue;
    }
    if (typeof value === "function") {
      continue;
    }
    if (!value || typeof value !== "object") {
      try {
        to[key] = value;
      } catch {
      }
      continue;
    }
    if (!seen.includes(from[key])) {
      depth++;
      to[key] = continueDestroyCircular(from[key]);
      continue;
    }
    to[key] = "[Circular]";
  }
  for (const { property, enumerable } of commonProperties) {
    if (typeof from[property] !== "undefined" && from[property] !== null) {
      Object.defineProperty(to, property, {
        value: isErrorLike(from[property]) ? continueDestroyCircular(from[property]) : from[property],
        enumerable: forceEnumerable ? true : enumerable,
        configurable: true,
        writable: true
      });
    }
  }
  return to;
};
function serializeError(value, options = {}) {
  const {
    maxDepth = Number.POSITIVE_INFINITY,
    useToJSON = true
  } = options;
  if (typeof value === "object" && value !== null) {
    return destroyCircular({
      from: value,
      seen: [],
      forceEnumerable: true,
      maxDepth,
      depth: 0,
      useToJSON,
      serialize: true
    });
  }
  if (typeof value === "function") {
    return `[Function: ${value.name || "anonymous"}]`;
  }
  return value;
}
function isErrorLike(value) {
  return Boolean(value) && typeof value === "object" && "name" in value && "message" in value && "stack" in value;
}

// src/aipo/CreateConfig/services/buyerProfileQuestionsService.ts
async function generateAndUpdateBuyerProfileQuestions(writeableArtifact) {
  const result = await writeableArtifact.callMcpTool("generateExpressPrivateOfferSellerQualificationQuestions", {});
  const validationErrors = {};
  let hasValidationErrors = false;
  if (result && Array.isArray(result.qualifications)) {
    result.qualifications.forEach((qual, index) => {
      if (qual._validationError) {
        validationErrors[index] = qual._validationError;
        hasValidationErrors = true;
      }
    });
  }
  const currentArtifact = writeableArtifact.artifact;
  if (!currentArtifact?.configurationRequest.discountStrategy || !("qualifications" in currentArtifact.configurationRequest.discountStrategy)) {
    return {
      hasValidationErrors,
      validationErrors,
      result
    };
  }
  const updatedQualifications = [...currentArtifact.configurationRequest.discountStrategy.qualifications || []];
  if (result && Array.isArray(result.qualifications)) {
    result.qualifications.forEach((resultQual, index) => {
      if (updatedQualifications[index]) {
        updatedQualifications[index] = {
          ...updatedQualifications[index],
          buyerQuestions: resultQual.buyerQuestions || []
        };
        if (resultQual._validationError) {
          updatedQualifications[index]._validationError = resultQual._validationError;
        } else {
          const { _validationError, ...rest } = updatedQualifications[index];
          updatedQualifications[index] = rest;
        }
      }
    });
  }
  const updatedArtifact = {
    ...currentArtifact,
    configurationRequest: {
      ...currentArtifact.configurationRequest,
      discountStrategy: {
        ...currentArtifact.configurationRequest.discountStrategy,
        qualifications: updatedQualifications
      }
    }
  };
  writeableArtifact.setArtifact(updatedArtifact);
  return {
    hasValidationErrors,
    validationErrors,
    result,
    updatedArtifact
  };
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/hooks/usePreviewQuestionnaire.ts
function mapToBuyerQuestions(qualifications, questionKey = "buyerQuestions") {
  const questions = [];
  for (const qual of qualifications) {
    const items = qual[questionKey];
    if (items && Array.isArray(items)) {
      for (const q of items) {
        questions.push({
          question: q.question,
          qualifyingTheme: qual.qualifyingTheme || "",
          exampleResponse: q.exampleResponse
        });
      }
    }
  }
  return questions;
}
function usePreviewQuestionnaire({
  writeableArtifact,
  artifact,
  projectId,
  qualificationItems,
  setFieldError,
  clearFieldError,
  logger,
  t
}) {
  const [isGenerating, setIsGenerating] = React14.useState(false);
  const [isModalVisible, setIsModalVisible] = React14.useState(false);
  const [generatedQuestions, setGeneratedQuestions] = React14.useState([]);
  const [validationErrors, setValidationErrors] = React14.useState({});
  const handlePreview = async () => {
    setValidationErrors({});
    const validation = validateDiscountStrategyStep(artifact, t);
    const hasValidationErrors = !validation.isValid;
    const hasFieldErrors = Object.entries(validation.errorProps).some(([_key, value]) => {
      return value !== void 0 && value !== null && value !== "";
    });
    if (hasValidationErrors || hasFieldErrors) {
      Object.entries(validation.errorProps).forEach(([key, value]) => {
        if (value !== void 0 && value !== null && value !== "") {
          setFieldError(key, value);
        }
      });
      return;
    }
    clearFieldError("buyerProfileError");
    const allHaveQuestions = qualificationItems.every((qual) => qual.generatedQuestions && qual.generatedQuestions.length > 0);
    if (allHaveQuestions) {
      setGeneratedQuestions(mapToBuyerQuestions(qualificationItems, "generatedQuestions"));
      setIsModalVisible(true);
      return;
    }
    setIsGenerating(true);
    try {
      const { hasValidationErrors: hasValErrors, validationErrors: errors, result } = await generateAndUpdateBuyerProfileQuestions(writeableArtifact);
      if (hasValErrors) {
        setValidationErrors(errors);
        setIsGenerating(false);
        setFieldError("buyerProfileAIValidationError", "AI validation errors present");
      } else {
        setValidationErrors({});
        clearFieldError("buyerProfileAIValidationError");
        setGeneratedQuestions(result && Array.isArray(result.qualifications) ? mapToBuyerQuestions(result.qualifications) : []);
        setIsGenerating(false);
        setIsModalVisible(true);
      }
    } catch (error) {
      logger.error("Error in handlePreviewQuestionnaire", void 0, {
        productId: artifact.configurationRequest.productId,
        projectId,
        ...serializeError(error)
      });
      setIsGenerating(false);
    }
  };
  const dismissModal = () => setIsModalVisible(false);
  return {
    handlePreview,
    isGenerating,
    generatedQuestions,
    validationErrors,
    setValidationErrors,
    isModalVisible,
    dismissModal
  };
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/BuyerProfileEditor.tsx
import { jsx as jsx35, jsxs as jsxs31 } from "react/jsx-runtime";
var MAX_QUALIFICATION_DETAIL_LENGTH = 1e3;
var MAX_QUALIFICATIONS = 5;
var BuyerProfileEditor = ({
  writeableArtifact,
  clearFieldError,
  setFieldError,
  showFieldErrors,
  projectId,
  logger,
  t
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const qualificationItems = React15.useMemo(() => {
    const qualifications = getQualifications(discountStrategy);
    return qualifications.map((qual, index) => ({
      id: `qual-${index}`,
      qualifyingTheme: qual.qualifyingTheme,
      detail: qual.detail,
      generatedQuestions: qual.buyerQuestions
    }));
  }, [discountStrategy]);
  const { handlePreview, isGenerating, generatedQuestions, validationErrors, setValidationErrors, isModalVisible, dismissModal } = usePreviewQuestionnaire({
    writeableArtifact,
    artifact,
    projectId,
    qualificationItems,
    setFieldError,
    clearFieldError,
    logger,
    t
  });
  React15.useEffect(() => {
    const hasEmptyThemes = qualificationItems.some((qual) => !qual.qualifyingTheme || qual.qualifyingTheme.trim() === "");
    const hasEmptyDetails = qualificationItems.some((qual) => !qual.detail || qual.detail.trim() === "");
    const hasCharacterLimitErrors = qualificationItems.some((qual) => qual.detail.length > MAX_QUALIFICATION_DETAIL_LENGTH);
    if (!hasEmptyThemes && !hasEmptyDetails && !hasCharacterLimitErrors && qualificationItems.length > 0) {
      clearFieldError("buyerProfileError");
    }
  }, [qualificationItems]);
  const clearValidationErrorAtIndex = (qualificationIndex) => {
    setValidationErrors((prev) => {
      const updated = { ...prev };
      delete updated[qualificationIndex];
      if (Object.keys(updated).length === 0) {
        clearFieldError("buyerProfileAIValidationError");
      }
      return updated;
    });
  };
  const handleUpdateQualificationTheme = (qualificationIndex, theme) => {
    if (!theme)
      return;
    clearValidationErrorAtIndex(qualificationIndex);
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy)
        return prev;
      const qualifications = [...getQualifications(prev.configurationRequest.discountStrategy)];
      if (qualifications[qualificationIndex]) {
        const { _validationError, ...rest } = qualifications[qualificationIndex];
        qualifications[qualificationIndex] = {
          ...rest,
          qualifyingTheme: theme,
          buyerQuestions: []
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleUpdateQualificationDetail = (qualificationIndex, detail) => {
    if (detail.length > MAX_QUALIFICATION_DETAIL_LENGTH) {
      setFieldError("buyerProfileCharacterLimitError", "Buyer profile details exceed character limit");
    } else {
      setFieldError("buyerProfileCharacterLimitError", void 0);
    }
    clearValidationErrorAtIndex(qualificationIndex);
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy)
        return prev;
      const qualifications = [...getQualifications(prev.configurationRequest.discountStrategy)];
      if (qualifications[qualificationIndex]) {
        const { _validationError, ...rest } = qualifications[qualificationIndex];
        qualifications[qualificationIndex] = {
          ...rest,
          detail,
          buyerQuestions: []
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleAddQualification = () => {
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy)
        return prev;
      const qualifications = [...getQualifications(prev.configurationRequest.discountStrategy)];
      if (qualifications.length < MAX_QUALIFICATIONS) {
        qualifications.push({
          qualifyingTheme: "",
          detail: "",
          buyerQuestions: []
        });
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleRemoveQualification = (qualificationIndex) => {
    setValidationErrors((prev) => {
      const updated = {};
      Object.entries(prev).forEach(([indexStr, error]) => {
        const index = parseInt(indexStr, 10);
        if (index < qualificationIndex) {
          updated[index] = error;
        } else if (index > qualificationIndex) {
          updated[index - 1] = error;
        }
      });
      if (Object.keys(updated).length === 0) {
        clearFieldError("buyerProfileAIValidationError");
      }
      return updated;
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy)
        return prev;
      const qualifications = [...getQualifications(prev.configurationRequest.discountStrategy)];
      qualifications.splice(qualificationIndex, 1);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  return /* @__PURE__ */ jsxs31(
    Container20,
    {
      header: /* @__PURE__ */ jsx35(
        Header23,
        {
          variant: "h2",
          actions: /* @__PURE__ */ jsx35(
            Button12,
            {
              "data-testid": "preview-questionnaire-button",
              iconName: "gen-ai",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "buyer-profile-config",
                    ClickAct: "preview-questionnaire"
                  },
                  value: 1,
                  unit: "Count"
                });
                handlePreview();
              },
              loading: isGenerating,
              disabled: isArtifactLocked,
              children: t("previewQuestionnaire")
            }
          ),
          description: t("buyerProfileDiscountStrategyDescription"),
          children: /* @__PURE__ */ jsxs31("span", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
            t("buyerProfileBasedDiscountStrategy"),
            /* @__PURE__ */ jsx35(TextContent11, { children: /* @__PURE__ */ jsxs31("i", { style: { color: "#8456ce", display: "flex", alignItems: "center", gap: "4px" }, children: [
              /* @__PURE__ */ jsx35(Icon3, { name: "gen-ai", size: "small" }),
              /* @__PURE__ */ jsx35("span", { children: t("aiAssisted") })
            ] }) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ jsx35(SpaceBetween28, { direction: "vertical", size: "l", children: /* @__PURE__ */ jsxs31(SpaceBetween28, { size: "xl", children: [
          qualificationItems.map((qualification, qualificationIndex) => /* @__PURE__ */ jsxs31("div", { children: [
            qualificationIndex > 0 && /* @__PURE__ */ jsx35("hr", { style: { margin: "16px 0", border: "none", borderTop: "1px solid #e9ebed" } }),
            /* @__PURE__ */ jsxs31(SpaceBetween28, { direction: "vertical", size: "l", children: [
              /* @__PURE__ */ jsxs31(SpaceBetween28, { size: "xs", children: [
                /* @__PURE__ */ jsx35(
                  Header23,
                  {
                    variant: "h3",
                    actions: /* @__PURE__ */ jsx35(
                      Button12,
                      {
                        variant: "normal",
                        "data-testid": `remove-qualifier-${qualificationIndex}`,
                        disabled: qualificationItems.length <= 1 || isArtifactLocked,
                        onClick: () => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickAct: "remove"
                            },
                            value: 1,
                            unit: "Count"
                          });
                          handleRemoveQualification(qualificationIndex);
                        },
                        children: t("remove")
                      }
                    ),
                    children: t("discountQualifier")
                  }
                ),
                /* @__PURE__ */ jsx35(Grid2, { gridDefinition: [{ colspan: { default: 12, s: 10 } }], children: /* @__PURE__ */ jsx35(
                  FormField11,
                  {
                    label: t("qualifyingThemeLabel"),
                    description: t("qualifyingThemeDescription"),
                    stretch: true,
                    errorText: showFieldErrors && (!qualification.qualifyingTheme || qualification.qualifyingTheme.trim() === "") ? t("validationFieldRequired") : void 0,
                    children: /* @__PURE__ */ jsx35(
                      Select6,
                      {
                        "data-testid": qualificationIndex === 0 ? "qualifying-theme-select" : `qualifying-theme-select-${qualificationIndex}`,
                        selectedOption: qualification.qualifyingTheme ? { label: qualification.qualifyingTheme, value: qualification.qualifyingTheme } : null,
                        onChange: ({ detail }) => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickObj: "qualifying-theme-dropdown",
                              ClickAct: detail.selectedOption.value || ""
                            },
                            value: 1,
                            unit: "Count"
                          });
                          handleUpdateQualificationTheme(qualificationIndex, detail.selectedOption.value);
                        },
                        options: QUALIFYING_THEME_OPTIONS.map((opt) => ({
                          label: t(opt.translationKey),
                          value: opt.value
                        })),
                        placeholder: t("chooseAnOption"),
                        invalid: showFieldErrors && (!qualification.qualifyingTheme || qualification.qualifyingTheme.trim() === ""),
                        disabled: isArtifactLocked
                      }
                    )
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs31("div", { children: [
                /* @__PURE__ */ jsx35(TextContent11, { children: /* @__PURE__ */ jsx35("strong", { children: t("detailsLabel") }) }),
                /* @__PURE__ */ jsx35(Grid2, { gridDefinition: [{ colspan: { default: 12, s: 10 } }], children: /* @__PURE__ */ jsx35(
                  FormField11,
                  {
                    stretch: true,
                    constraintText: t("qualificationDescriptionConstraint", { count: qualification.detail.length.toLocaleString() }),
                    errorText: qualification.detail.length > MAX_QUALIFICATION_DETAIL_LENGTH ? t("qualificationDetailsTooManyCharacters", { count: qualification.detail.length.toLocaleString() }) : showFieldErrors && (!qualification.detail || qualification.detail.trim() === "") ? t("validationFieldRequired") : void 0,
                    children: /* @__PURE__ */ jsx35(
                      Textarea3,
                      {
                        "data-testid": qualificationIndex === 0 ? "qualification-details-textarea" : `qualification-details-textarea-${qualificationIndex}`,
                        value: qualification.detail,
                        onFocus: () => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickAct: "qualification-details"
                            },
                            value: 1,
                            unit: "Count"
                          });
                        },
                        onChange: ({ detail }) => {
                          handleUpdateQualificationDetail(qualificationIndex, detail.value);
                        },
                        placeholder: t("qualificationDetailsPlaceholder"),
                        rows: 4,
                        invalid: qualification.detail.length > MAX_QUALIFICATION_DETAIL_LENGTH || showFieldErrors && (!qualification.detail || qualification.detail.trim() === ""),
                        disabled: isArtifactLocked
                      }
                    )
                  }
                ) })
              ] }),
              validationErrors[qualificationIndex] && /* @__PURE__ */ jsx35(
                Alert9,
                {
                  "data-testid": `qualification-validation-error-${qualificationIndex}`,
                  type: "error",
                  dismissible: true,
                  onDismiss: () => clearValidationErrorAtIndex(qualificationIndex),
                  children: validationErrors[qualificationIndex]
                }
              )
            ] })
          ] }, qualification.id)),
          /* @__PURE__ */ jsxs31("div", { children: [
            /* @__PURE__ */ jsx35(
              Button12,
              {
                variant: "normal",
                "data-testid": "add-new-qualifier",
                disabled: qualificationItems.length >= MAX_QUALIFICATIONS || isArtifactLocked,
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "buyer-profile-config",
                      ClickAct: "add-new-qualifier"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  handleAddQualification();
                },
                children: t("addNewQualifier")
              }
            ),
            /* @__PURE__ */ jsx35(TextContent11, { children: /* @__PURE__ */ jsx35("small", { children: qualificationItems.length >= MAX_QUALIFICATIONS ? t("qualifiersLimitReached") : t("qualifiersAvailable", { count: MAX_QUALIFICATIONS - qualificationItems.length }) }) })
          ] })
        ] }) }),
        /* @__PURE__ */ jsx35(QuestionnairePreviewModal, { visible: isModalVisible, onDismiss: dismissModal, questions: generatedQuestions, logger, t })
      ]
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/strategyCompositionUtils.ts
function composeDiscountStrategy(current, change, availableDimensions) {
  const { strategyType, checked } = change;
  const existingQualifications = getQualifications(current);
  const hasQualifications = existingQualifications.length > 0 || isQualificationStrategy(current);
  if (checked) {
    return handleChecked(strategyType, current, existingQualifications, hasQualifications, availableDimensions);
  }
  return handleUnchecked(strategyType, current, existingQualifications, hasQualifications);
}
function handleChecked(strategyType, current, existingQualifications, hasQualifications, availableDimensions) {
  if (strategyType === "perDimension") {
    const initialTiers = buildInitialPerDimensionTiers(availableDimensions);
    if (hasQualifications) {
      return {
        strategy: "PER_DIMENSION_TCV_WITH_QUALIFICATION",
        perDimensionTcvTiers: initialTiers,
        qualifications: existingQualifications
      };
    }
    return {
      strategy: "PER_DIMENSION_TCV",
      perDimensionTcvTiers: initialTiers
    };
  }
  if (strategyType === "tcv") {
    if (hasQualifications) {
      return {
        strategy: "TOTAL_TCV_WITH_QUALIFICATION",
        totalTcvTiers: [createEmptyTier()],
        qualifications: existingQualifications
      };
    }
    return {
      strategy: "TOTAL_TCV",
      totalTcvTiers: [createEmptyTier()]
    };
  }
  const emptyQualification = { qualifyingTheme: "", detail: "", buyerQuestions: [] };
  if (isPerDimensionStrategy(current)) {
    return {
      strategy: "PER_DIMENSION_TCV_WITH_QUALIFICATION",
      perDimensionTcvTiers: getExistingPerDimensionTiers(current),
      qualifications: [emptyQualification]
    };
  }
  if (isTcvStrategy(current)) {
    return {
      strategy: "TOTAL_TCV_WITH_QUALIFICATION",
      totalTcvTiers: getExistingTcvTiers(current),
      qualifications: [emptyQualification]
    };
  }
  return {
    strategy: "QUALIFICATION",
    qualifications: [emptyQualification]
  };
}
function handleUnchecked(strategyType, current, existingQualifications, hasQualifications) {
  if (strategyType === "perDimension") {
    if (hasQualifications) {
      return {
        strategy: "QUALIFICATION",
        qualifications: existingQualifications
      };
    }
    return void 0;
  }
  if (strategyType === "tcv") {
    if (hasQualifications) {
      return {
        strategy: "QUALIFICATION",
        qualifications: existingQualifications
      };
    }
    return void 0;
  }
  if (isPerDimensionStrategy(current)) {
    return {
      strategy: "PER_DIMENSION_TCV",
      perDimensionTcvTiers: getExistingPerDimensionTiers(current)
    };
  }
  if (isTcvStrategy(current)) {
    return {
      strategy: "TOTAL_TCV",
      totalTcvTiers: getExistingTcvTiers(current)
    };
  }
  return void 0;
}
function buildInitialPerDimensionTiers(availableDimensions) {
  const tiers = {};
  availableDimensions.forEach((dimension, index) => {
    if (index === 0) {
      tiers[dimension.key] = [createEmptyTier()];
    } else {
      tiers[dimension.key] = [];
    }
  });
  return tiers;
}
function getExistingPerDimensionTiers(strategy) {
  if (isPerDimensionStrategy(strategy)) {
    return strategy.perDimensionTcvTiers || {};
  }
  return {};
}
function getExistingTcvTiers(strategy) {
  if (isTcvStrategy(strategy)) {
    return strategy.totalTcvTiers || [];
  }
  return [];
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/checkboxStateUtils.ts
function getCheckboxDisabledStates(isMaxDiscountZero, hasAnyStrategy, perDimensionSelected, tcvSelected) {
  if (isMaxDiscountZero && !hasAnyStrategy) {
    return {
      perDimensionDisabled: true,
      tcvDisabled: true,
      buyerProfileDisabled: true
    };
  }
  return {
    perDimensionDisabled: tcvSelected,
    tcvDisabled: perDimensionSelected,
    buyerProfileDisabled: false
  };
}
function getPopoverMessages(isMaxDiscountZero, hasAnyStrategy, t) {
  const allDisabledDueToMaxDiscount = isMaxDiscountZero && !hasAnyStrategy;
  return {
    perDimensionPopoverText: allDisabledDueToMaxDiscount ? t("popoverPerDimensionMaxDiscount") : t("popoverPerDimensionMutuallyExclusive"),
    tcvPopoverText: allDisabledDueToMaxDiscount ? t("popoverTcvMaxDiscount") : t("popoverTcvMutuallyExclusive"),
    buyerProfilePopoverText: t("popoverBuyerProfileMaxDiscount")
  };
}

// src/aipo/CreateConfig/components/DiscountStrategyStep/StrategyCheckbox.tsx
import Checkbox2 from "@amzn/awsui-components-react/polaris/checkbox";
import Popover2 from "@amzn/awsui-components-react/polaris/popover";
import { jsx as jsx36, jsxs as jsxs32 } from "react/jsx-runtime";
var StrategyCheckbox = ({
  checked,
  disabled,
  isArtifactLocked,
  onChange,
  label,
  description,
  popoverText,
  testId,
  badge,
  logger,
  metricAction
}) => {
  const checkbox = /* @__PURE__ */ jsx36(
    Checkbox2,
    {
      "data-testid": testId,
      checked,
      onChange: ({ detail }) => {
        logger.biMetric({
          metricName: "Click",
          dimensions: {
            ClickFeat: "strategy-selection",
            ClickAct: metricAction
          },
          value: 1,
          unit: "Count"
        });
        onChange(detail.checked);
      },
      disabled: disabled || isArtifactLocked,
      description,
      children: badge ? /* @__PURE__ */ jsxs32("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
        /* @__PURE__ */ jsx36("span", { children: label }),
        badge
      ] }) : label
    }
  );
  if (disabled && !isArtifactLocked) {
    return /* @__PURE__ */ jsx36(Popover2, { dismissButton: true, position: "left", size: "small", triggerType: "custom", content: popoverText, children: checkbox });
  }
  return checkbox;
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.tsx
import { Fragment as Fragment6, jsx as jsx37, jsxs as jsxs33 } from "react/jsx-runtime";
var DiscountStrategyStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  setFieldError,
  productDimensions = /* @__PURE__ */ new Map(),
  layoutComponents,
  isArtifactLocked = false,
  sendMessage,
  renderMessages,
  projectId,
  logger,
  t,
  openHelpPanel
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const [showAssistant, setShowAssistant] = React16.useState(false);
  const [panelSize, setPanelSize] = React16.useState(500);
  const { LayoutSplitPanel } = layoutComponents;
  const [maxTcvEdit, setMaxTcvEdit] = React16.useState(void 0);
  const [minTcvEdit, setMinTcvEdit] = React16.useState(void 0);
  const displayMaxTcv = maxTcvEdit ?? artifact.configurationRequest.maxTotalContractValue?.toString() ?? "";
  const displayMinTcv = minTcvEdit ?? artifact.configurationRequest.minTotalContractValue?.toString() ?? "";
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.CONFIGURE_DISCOUNT_STRATEGY);
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const maxDiscountPercentage = artifact.configurationRequest.maxDiscountPercentage?.toString() || "";
  const currentStrategy = discountStrategy?.strategy || null;
  const [perDimensionDiscounts, setPerDimensionDiscounts] = React16.useState(() => {
    return currentStrategy === "PER_DIMENSION_TCV" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
  });
  const [tcvDiscounts, setTcvDiscounts] = React16.useState(() => {
    return currentStrategy === "TOTAL_TCV" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  });
  const [buyerProfileDiscounts, setBuyerProfileDiscounts] = React16.useState(() => {
    return currentStrategy === "QUALIFICATION" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  });
  const availableDimensions = React16.useMemo(() => {
    return mapDimensionRates(artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates, productDimensions);
  }, [artifact.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handleDiscountStrategyChange = (strategyType, checked) => {
    if (strategyType === "perDimension") {
      setPerDimensionDiscounts(checked);
    } else if (strategyType === "tcv") {
      setTcvDiscounts(checked);
    } else if (strategyType === "buyerProfile") {
      setBuyerProfileDiscounts(checked);
    }
    if (checked && errors.discountStrategyError) {
      clearFieldError("discountStrategyError");
    }
    if (!checked) {
      if (strategyType === "perDimension") {
        clearFieldError("perDimensionError");
      } else if (strategyType === "tcv") {
        clearFieldError("tcvDiscountsError");
      } else if (strategyType === "buyerProfile") {
        clearFieldError("buyerProfileError");
        clearFieldError("buyerProfileCharacterLimitError");
        clearFieldError("buyerProfileAIValidationError");
      }
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        discountStrategy: composeDiscountStrategy(prev.configurationRequest.discountStrategy, { strategyType, checked }, availableDimensions)
      }
    }));
  };
  const handleMaxDiscountChange = (value) => {
    if (errors.maxDiscountError) {
      clearFieldError("maxDiscountError");
    }
    if (errors.discountThresholdsError) {
      clearFieldError("discountThresholdsError");
    }
    const integerValue = parseIntegerValue(value);
    if (integerValue !== void 0 && (integerValue < 0 || integerValue >= MAX_DISCOUNT_PERCENTAGE)) {
      setFieldError("maxDiscountError", t("validationDiscountPercentageRange"));
    } else {
      setFieldError("maxDiscountError", void 0);
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxDiscountPercentage: integerValue
      }
    }));
  };
  const validateMaxTcv = (value) => {
    if (errors.maxTcvError) {
      clearFieldError("maxTcvError");
    }
    if (errors.discountThresholdsError) {
      clearFieldError("discountThresholdsError");
    }
    const numericValue = parseCurrencyValue(value);
    const minTotalContractValue = artifact.configurationRequest.minTotalContractValue;
    const maxIsBelowMin = numericValue !== void 0 && minTotalContractValue !== void 0 && minTotalContractValue !== null && numericValue < minTotalContractValue;
    if (numericValue !== void 0 && numericValue <= 0) {
      setFieldError("maxTcvError", t("validationMaxTcvGreaterThanZero"));
    } else if (numericValue !== void 0 && numericValue >= MAX_TCV_VALUE) {
      setFieldError("maxTcvError", t("validationMaxTcvBelowLimit"));
    } else if (maxIsBelowMin) {
      setFieldError("maxTcvError", t(MAX_TCV_BELOW_MIN_MESSAGE_KEY));
    } else {
      setFieldError("maxTcvError", void 0);
    }
    const minIsNonNegative = minTotalContractValue !== void 0 && minTotalContractValue !== null && minTotalContractValue >= 0;
    if (errors.minTcvError && minIsNonNegative && !maxIsBelowMin) {
      clearFieldError("minTcvError");
    }
  };
  const commitMaxTcv = (value) => {
    const numericValue = parseCurrencyValue(value);
    setMaxTcvEdit(void 0);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxTotalContractValue: numericValue
      }
    }));
  };
  const validateMinTcv = (value) => {
    if (errors.minTcvError) {
      clearFieldError("minTcvError");
    }
    const numericValue = parseCurrencyValue(value);
    const maxTotalContractValue = artifact.configurationRequest.maxTotalContractValue;
    const hasMaxTcv = maxTotalContractValue !== void 0 && maxTotalContractValue !== null;
    const minExceedsMax = hasMaxTcv && numericValue !== void 0 && numericValue > maxTotalContractValue;
    if (numericValue !== void 0 && minExceedsMax) {
      setFieldError("minTcvError", t(MIN_TCV_EXCEEDS_MAX_MESSAGE_KEY));
    }
    const maxWithinOwnBounds = hasMaxTcv && maxTotalContractValue > 0 && maxTotalContractValue < MAX_TCV_VALUE;
    if (errors.maxTcvError && maxWithinOwnBounds && !minExceedsMax) {
      clearFieldError("maxTcvError");
    }
  };
  const commitMinTcv = (value) => {
    const numericValue = parseCurrencyValue(value);
    setMinTcvEdit(void 0);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        minTotalContractValue: numericValue
      }
    }));
  };
  const showPerDimensionFieldErrors = errors.perDimensionError?.showFieldLevelErrors ?? false;
  const showTcvFieldErrors = errors.tcvDiscountsError?.showFieldLevelErrors ?? false;
  const showBuyerProfileFieldError = errors.buyerProfileError?.showFieldLevelErrors ?? false;
  const hasAnyStrategySelected = React16.useMemo(() => {
    return perDimensionDiscounts || tcvDiscounts || buyerProfileDiscounts;
  }, [perDimensionDiscounts, tcvDiscounts, buyerProfileDiscounts]);
  const isMaxDiscountZero = React16.useMemo(() => {
    const numValue = parseFloat(maxDiscountPercentage);
    return numValue === 0;
  }, [maxDiscountPercentage]);
  const { perDimensionDisabled, tcvDisabled, buyerProfileDisabled } = getCheckboxDisabledStates(
    isMaxDiscountZero,
    hasAnyStrategySelected,
    perDimensionDiscounts,
    tcvDiscounts
  );
  const { perDimensionPopoverText, tcvPopoverText, buyerProfilePopoverText } = getPopoverMessages(isMaxDiscountZero, hasAnyStrategySelected, t);
  const specialMaxDiscountError = React16.useMemo(() => {
    if (isMaxDiscountZero && hasAnyStrategySelected) {
      return {
        body: t("errorDiscountMustBeGreaterThanZero"),
        header: void 0
      };
    }
    return null;
  }, [isMaxDiscountZero, hasAnyStrategySelected, t]);
  const buyerProfileBadge = /* @__PURE__ */ jsx37(TextContent12, { children: /* @__PURE__ */ jsxs33("i", { className: DiscountStrategyStep_default.aiIcon, style: { opacity: buyerProfileDisabled || isArtifactLocked ? 0.5 : 1 }, children: [
    /* @__PURE__ */ jsx37(Icon4, { name: "gen-ai", size: "small" }),
    /* @__PURE__ */ jsx37("span", { className: DiscountStrategyStep_default.aiAssisted, children: /* @__PURE__ */ jsx37("i", { children: t("aiAssisted") }) })
  ] }) });
  return /* @__PURE__ */ jsxs33(SpaceBetween29, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsx37(
      Container21,
      {
        header: /* @__PURE__ */ jsx37(
          Header24,
          {
            variant: "h2",
            description: t("discountThresholdsDescription"),
            info: openHelpPanel ? /* @__PURE__ */ jsx37(
              Link13,
              {
                variant: "info",
                ariaLabel: t("infoAriaLabel", { section: t("discountThresholds") }),
                onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG11.CONFIG_DISCOUNT_THRESHOLDS),
                children: t("info")
              }
            ) : void 0,
            children: t("discountThresholds")
          }
        ),
        children: /* @__PURE__ */ jsxs33(SpaceBetween29, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx37(
            KeyValuePairs6,
            {
              items: [
                {
                  label: t("currency"),
                  value: t("currencyUsd")
                }
              ]
            }
          ),
          /* @__PURE__ */ jsx37(
            FormField12,
            {
              label: t("maximumDiscountPercentage"),
              description: t("maximumDiscountPercentageDescription"),
              errorText: specialMaxDiscountError?.body || errors.maxDiscountError,
              children: /* @__PURE__ */ jsx37(
                Input8,
                {
                  "data-testid": "max-discount-percentage-input",
                  value: maxDiscountPercentage,
                  onFocus: () => {
                    logger.biMetric({
                      metricName: "Click",
                      dimensions: {
                        ClickFeat: "discount-thresholds",
                        ClickAct: "maximum-discount-percentage"
                      },
                      value: 1,
                      unit: "Count"
                    });
                  },
                  onChange: ({ detail }) => handleMaxDiscountChange(detail.value),
                  type: "number",
                  placeholder: t("enterANumber"),
                  invalid: !!(specialMaxDiscountError || errors.maxDiscountError),
                  disabled: isArtifactLocked
                }
              )
            }
          ),
          (() => {
            const maxTcvField = /* @__PURE__ */ jsx37(
              FormField12,
              {
                label: t("maximumTcvForEpoFps"),
                constraintText: t("maximumTcvConstraint"),
                description: t("maximumTcvDescription"),
                errorText: errors.maxTcvError,
                children: /* @__PURE__ */ jsx37(
                  Input8,
                  {
                    "data-testid": "max-tcv-input",
                    ariaRequired: true,
                    type: "text",
                    inputMode: "decimal",
                    value: displayMaxTcv,
                    onFocus: () => {
                      logger.biMetric({
                        metricName: "Click",
                        dimensions: {
                          ClickFeat: "discount-thresholds",
                          ClickAct: "maximum-total-contract-value"
                        },
                        value: 1,
                        unit: "Count"
                      });
                    },
                    onChange: ({ detail }) => {
                      const restricted = restrictDecimalInput(detail.value, displayMaxTcv, CENTS_PRECISION);
                      setMaxTcvEdit(restricted);
                      validateMaxTcv(restricted);
                    },
                    onBlur: () => {
                      if (maxTcvEdit !== void 0)
                        commitMaxTcv(maxTcvEdit);
                    },
                    invalid: !!errors.maxTcvError,
                    disabled: isArtifactLocked
                  }
                )
              }
            );
            return /* @__PURE__ */ jsxs33(ColumnLayout3, { columns: 2, children: [
              /* @__PURE__ */ jsx37(
                FormField12,
                {
                  "data-testid": "minimum-tcv-form-field",
                  label: /* @__PURE__ */ jsxs33(Fragment6, { children: [
                    t("minimumTcvForExpressPrivateOffers"),
                    " - ",
                    /* @__PURE__ */ jsx37("i", { children: t("optional") })
                  ] }),
                  constraintText: t("minimumTcvConstraint"),
                  description: t("minimumTcvForExpressPrivateOffersDescription"),
                  errorText: errors.minTcvError ? /* @__PURE__ */ jsx37("span", { "data-testid": "minimum-tcv-error", children: errors.minTcvError }) : void 0,
                  children: /* @__PURE__ */ jsx37(
                    Input8,
                    {
                      "data-testid": "minimum-tcv-input",
                      type: "text",
                      inputMode: "decimal",
                      value: displayMinTcv,
                      invalid: !!errors.minTcvError,
                      disabled: isArtifactLocked,
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "discount-thresholds",
                            ClickAct: "minimum-total-contract-value"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => {
                        const restricted = restrictDecimalInput(detail.value, displayMinTcv, CENTS_PRECISION);
                        setMinTcvEdit(restricted);
                        validateMinTcv(restricted);
                      },
                      onBlur: () => {
                        if (minTcvEdit !== void 0)
                          commitMinTcv(minTcvEdit);
                      }
                    }
                  )
                }
              ),
              maxTcvField
            ] });
          })()
        ] })
      }
    ),
    /* @__PURE__ */ jsx37(
      Container21,
      {
        header: /* @__PURE__ */ jsx37(
          Header24,
          {
            variant: "h2",
            description: t("discountStrategiesDescription"),
            info: openHelpPanel ? /* @__PURE__ */ jsx37(
              Link13,
              {
                variant: "info",
                ariaLabel: t("infoAriaLabel", { section: t("discountStrategies") }),
                onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG11.CONFIG_DISCOUNT_STRATEGIES),
                children: t("info")
              }
            ) : void 0,
            children: t("discountStrategies")
          }
        ),
        children: /* @__PURE__ */ jsxs33(SpaceBetween29, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx37(Alert10, { type: "info", children: t("discountStrategiesCombinationAlert") }),
          /* @__PURE__ */ jsxs33(SpaceBetween29, { size: "xxs", children: [
            /* @__PURE__ */ jsx37(TextContent12, { children: /* @__PURE__ */ jsx37("strong", { children: t("discountStrategyOptions") }) }),
            /* @__PURE__ */ jsxs33(SpaceBetween29, { size: "xxxs", children: [
              /* @__PURE__ */ jsx37(
                StrategyCheckbox,
                {
                  checked: perDimensionDiscounts,
                  disabled: perDimensionDisabled,
                  isArtifactLocked,
                  onChange: (checked) => handleDiscountStrategyChange("perDimension", checked),
                  label: t("perDimensionDiscounts"),
                  description: t("perDimensionDiscountsDescription"),
                  popoverText: perDimensionPopoverText,
                  testId: "per-dimension-checkbox",
                  logger,
                  metricAction: "per-dimension-discounts"
                }
              ),
              /* @__PURE__ */ jsx37(
                StrategyCheckbox,
                {
                  checked: tcvDiscounts,
                  disabled: tcvDisabled,
                  isArtifactLocked,
                  onChange: (checked) => handleDiscountStrategyChange("tcv", checked),
                  label: t("tcvBasedDiscounts"),
                  description: t("tcvBasedDiscountsDescription"),
                  popoverText: tcvPopoverText,
                  testId: "tcv-checkbox",
                  logger,
                  metricAction: "tcv-discounts"
                }
              ),
              /* @__PURE__ */ jsx37(
                StrategyCheckbox,
                {
                  checked: buyerProfileDiscounts,
                  disabled: buyerProfileDisabled,
                  isArtifactLocked,
                  onChange: (checked) => handleDiscountStrategyChange("buyerProfile", checked),
                  label: t("buyerProfileBasedDiscounts"),
                  description: t("buyerProfileBasedDiscountsDescription"),
                  popoverText: buyerProfilePopoverText,
                  testId: "buyer-profile-checkbox",
                  badge: buyerProfileBadge,
                  logger,
                  metricAction: "buyer-profile-discounts"
                }
              )
            ] })
          ] })
        ] })
      }
    ),
    perDimensionDiscounts && /* @__PURE__ */ jsx37(
      PerDimensionDiscountEditor,
      {
        writeableArtifact,
        productDimensions,
        clearFieldError,
        showFieldErrors: showPerDimensionFieldErrors,
        logger,
        t
      }
    ),
    tcvDiscounts && /* @__PURE__ */ jsx37(
      TcvDiscountEditor,
      {
        writeableArtifact,
        clearFieldError,
        showFieldErrors: showTcvFieldErrors,
        logger,
        t
      }
    ),
    buyerProfileDiscounts && /* @__PURE__ */ jsx37(
      BuyerProfileEditor,
      {
        writeableArtifact,
        clearFieldError,
        setFieldError,
        showFieldErrors: showBuyerProfileFieldError,
        projectId,
        logger,
        t
      }
    ),
    errors.discountStrategyError && /* @__PURE__ */ jsx37(
      Alert10,
      {
        dismissible: true,
        type: "error",
        onDismiss: () => clearFieldError("discountStrategyError"),
        header: errors.discountStrategyError.header,
        children: errors.discountStrategyError.body
      }
    ),
    errors.perDimensionError && !showPerDimensionFieldErrors && /* @__PURE__ */ jsx37(Alert10, { dismissible: true, type: "error", onDismiss: () => clearFieldError("perDimensionError"), header: errors.perDimensionError.header, children: errors.perDimensionError.body }),
    errors.tcvDiscountsError && !showTcvFieldErrors && /* @__PURE__ */ jsx37(Alert10, { dismissible: true, type: "error", onDismiss: () => clearFieldError("tcvDiscountsError"), header: errors.tcvDiscountsError.header, children: errors.tcvDiscountsError.body }),
    errors.buyerProfileError && !showBuyerProfileFieldError && /* @__PURE__ */ jsx37(Alert10, { dismissible: true, type: "error", onDismiss: () => clearFieldError("buyerProfileError"), header: errors.buyerProfileError.header, children: errors.buyerProfileError.body }),
    sendMessage && renderMessages && /* @__PURE__ */ jsx37(
      LayoutSplitPanel,
      {
        open: showAssistant,
        onToggle: (open) => setShowAssistant(open),
        onDismiss: () => setShowAssistant(false),
        onResize: (size) => setPanelSize(size),
        closeBehavior: "hide" /* Hide */,
        header: t("advancedSettings"),
        size: panelSize,
        children: /* @__PURE__ */ jsx37(SpaceBetween29, { size: "l", children: /* @__PURE__ */ jsx37("div", { style: { maxHeight: "400px", overflowY: "auto" }, children: renderMessages() }) })
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/GuidanceStep/GuidanceStep.tsx
import * as React22 from "react";
import Alert12 from "@amzn/awsui-components-react/polaris/alert";
import Box23 from "@amzn/awsui-components-react/polaris/box";
import Button17 from "@amzn/awsui-components-react/polaris/button";
import Container22 from "@amzn/awsui-components-react/polaris/container";
import ExpandableSection2 from "@amzn/awsui-components-react/polaris/expandable-section";
import Header25 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween36 from "@amzn/awsui-components-react/polaris/space-between";
import { GuidanceStatus as GuidanceStatus7, ProjectStatus } from "@amzn/awsmp-max-model";

// src/aipo/CreateConfig/services/dimensionUtils.ts
function splitDimensionsByVisibility(dimensions, publicOfferDimensionKeys) {
  if (!publicOfferDimensionKeys) {
    return { publicDimensions: [], epoExclusiveDimensions: dimensions };
  }
  return {
    publicDimensions: dimensions.filter((d) => publicOfferDimensionKeys.has(d.apiIdentifier)),
    epoExclusiveDimensions: dimensions.filter((d) => !publicOfferDimensionKeys.has(d.apiIdentifier))
  };
}

// src/aipo/CreateConfig/components/GuidanceStep/useGuidanceActions.ts
import {
  createMaxWrappedError as createMaxWrappedError3
} from "@amzn/awsmp-max-agentic-renderer-interface";
import { AgentId as AgentId4, GuidanceStatus as GuidanceStatus3 } from "@amzn/awsmp-max-model";

// src/aipo/CreateConfig/services/artifactUpdateUtils.ts
import { GuidanceStatus as GuidanceStatus2 } from "@amzn/awsmp-max-model";
function setProposedGuidanceEnhancing(artifact, dimensionKeys) {
  const currentGuidance = artifact.proposedGuidance ?? {};
  const updatedGuidance = { ...currentGuidance };
  for (const key of dimensionKeys) {
    updatedGuidance[key] = {
      content: "",
      status: GuidanceStatus2.Enhancing,
      insights: {},
      sources: {}
    };
  }
  return { ...artifact, proposedGuidance: updatedGuidance };
}
function restorePreEnhanceSnapshot(artifact, snapshot) {
  const currentGuidance = artifact.proposedGuidance ?? {};
  const staleKeys = Object.keys(currentGuidance).filter((key) => currentGuidance[key].status === GuidanceStatus2.Enhancing);
  if (staleKeys.length === 0)
    return null;
  const updatedGuidance = { ...currentGuidance };
  for (const key of staleKeys) {
    const previous = snapshot?.[key];
    if (previous) {
      updatedGuidance[key] = previous;
    } else {
      delete updatedGuidance[key];
    }
  }
  return { ...artifact, proposedGuidance: updatedGuidance };
}
function removeProposedGuidance(artifact, dimensionKeys) {
  const currentGuidance = artifact.proposedGuidance ?? {};
  const updatedGuidance = { ...currentGuidance };
  for (const key of dimensionKeys) {
    delete updatedGuidance[key];
  }
  return { ...artifact, proposedGuidance: updatedGuidance };
}
function updateProposedGuidanceContent(artifact, dimensionKey, content, targetStatus) {
  const currentGuidance = artifact.proposedGuidance ?? {};
  const existingEntry = currentGuidance[dimensionKey] ?? { content: "", status: targetStatus, insights: {}, sources: {} };
  const result = {
    ...artifact,
    proposedGuidance: {
      ...currentGuidance,
      [dimensionKey]: {
        ...existingEntry,
        content,
        status: targetStatus,
        insights: {}
      }
    }
  };
  return result;
}

// src/aipo/CreateConfig/components/GuidanceStep/constants.ts
import { InsightType } from "@amzn/awsmp-max-model";
var EDIT_PANEL_SIZE = 500;
var TEXTAREA_ROWS = 8;
var INSIGHT_TYPE_KEYS = {
  [InsightType.HallucinationRisk]: "guidanceInsightHallucinationRisk",
  [InsightType.LowConfidence]: "guidanceInsightLowConfidence",
  [InsightType.ConflictingInformation]: "guidanceInsightConflictingInformation",
  [InsightType.InsufficientData]: "guidanceInsightInsufficientData",
  [InsightType.ValidationFailure]: "guidanceInsightValidationFailure"
};
function isKnownInsightType(type) {
  return type in INSIGHT_TYPE_KEYS;
}
var METRIC_CLICK_FEAT = "descriptions-table";
var METRIC_ENHANCE_DESCRIPTION = "enhance-description";
var METRIC_ENHANCE_ALL = "enhance-all-descriptions";
var METRIC_REVERT_DESCRIPTION = "revert-description";
var METRIC_REVERT_ALL = "revert-all-descriptions";
var METRIC_EDIT_DESCRIPTION = "edit-description";
var METRIC_EDIT_PANEL_FEAT = "edit-dimension-description-panel";
var METRIC_EDIT_PANEL_TEXTAREA = "dimension-description-text-area";
var METRIC_EDIT_PANEL_CANCEL = "cancel";
var METRIC_EDIT_PANEL_SAVE = "save";
var TRUST_LEVEL_KEYS = {
  seller: "guidanceSourceTrustSeller",
  official: "guidanceSourceTrustOfficial",
  reputable: "guidanceSourceTrustReputable",
  external: "guidanceSourceTrustExternal"
};

// src/aipo/CreateConfig/components/GuidanceStep/useGuidanceActions.ts
var EPO_GUIDANCE_AGENT = { agentId: AgentId4.EpoSellerGuidance };
function useGuidanceActions(writeableArtifact, logger, withAsyncErrors, setPreEnhanceSnapshot, flashbarManager, t) {
  const { artifact } = writeableArtifact;
  const guidance = artifact.proposedGuidance ?? {};
  const handleEnhanceDimension = async (dimensionKey) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: { ClickFeat: METRIC_CLICK_FEAT, ClickObj: METRIC_ENHANCE_DESCRIPTION, ClickAct: dimensionKey },
      value: 1,
      unit: "Count"
    });
    setPreEnhanceSnapshot(artifact.proposedGuidance ? { ...artifact.proposedGuidance } : {});
    const updatedArtifact = setProposedGuidanceEnhancing(artifact, [dimensionKey]);
    writeableArtifact.setArtifact(updatedArtifact);
    const onStreamError = () => {
      writeableArtifact.setArtifact(artifact);
      writeableArtifact.commitArtifactUpdate(artifact).catch(() => void 0);
      flashbarManager.addItem({
        type: "error",
        content: t("guidanceEnhanceError"),
        dismissible: true
      });
    };
    await withAsyncErrors(
      (async () => {
        try {
          await writeableArtifact.sendMessage(
            `Enhance descriptions for dimensions: ${dimensionKey}`,
            EPO_GUIDANCE_AGENT,
            updatedArtifact,
            onStreamError
          );
        } catch (error) {
          writeableArtifact.setArtifact(artifact);
          throw createMaxWrappedError3(error, { isFatal: false });
        }
      })()
    );
  };
  const handleEnhanceAll = async () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: { ClickFeat: METRIC_CLICK_FEAT, ClickAct: METRIC_ENHANCE_ALL },
      value: 1,
      unit: "Count"
    });
    const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates ?? [];
    const eligibleKeys = dimensionRates.map((r2) => r2.dimensionKey).filter((key) => !guidance[key] || guidance[key].status === GuidanceStatus3.UserEdited);
    if (eligibleKeys.length === 0)
      return;
    setPreEnhanceSnapshot(artifact.proposedGuidance ? { ...artifact.proposedGuidance } : {});
    const updatedArtifact = setProposedGuidanceEnhancing(artifact, eligibleKeys);
    writeableArtifact.setArtifact(updatedArtifact);
    const onStreamError = () => {
      writeableArtifact.setArtifact(artifact);
      writeableArtifact.commitArtifactUpdate(artifact).catch(() => void 0);
      flashbarManager.addItem({
        type: "error",
        content: t("guidanceEnhanceError"),
        dismissible: true
      });
    };
    await withAsyncErrors(
      (async () => {
        try {
          await writeableArtifact.sendMessage(
            `Enhance descriptions for dimensions: ${eligibleKeys.join(", ")}`,
            EPO_GUIDANCE_AGENT,
            updatedArtifact,
            onStreamError
          );
        } catch (error) {
          writeableArtifact.setArtifact(artifact);
          throw createMaxWrappedError3(error, { isFatal: false });
        }
      })()
    );
  };
  const handleRevert = async (dimensionKey) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: { ClickFeat: METRIC_CLICK_FEAT, ClickObj: METRIC_REVERT_DESCRIPTION, ClickAct: dimensionKey },
      value: 1,
      unit: "Count"
    });
    const previousArtifact = artifact;
    const updatedArtifact = removeProposedGuidance(artifact, [dimensionKey]);
    writeableArtifact.setArtifact(updatedArtifact);
    try {
      await writeableArtifact.commitArtifactUpdate(updatedArtifact);
    } catch (_error) {
      writeableArtifact.setArtifact(previousArtifact);
      flashbarManager.addItem({
        type: "error",
        content: t("guidanceRevertError"),
        dismissible: true
      });
    }
  };
  const handleRevertAll = async () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: { ClickFeat: METRIC_CLICK_FEAT, ClickAct: METRIC_REVERT_ALL },
      value: 1,
      unit: "Count"
    });
    const keysToRevert = Object.entries(guidance).filter(
      ([_, entry]) => entry.status === GuidanceStatus3.Enhanced || entry.status === GuidanceStatus3.EnhancedEdited || entry.status === GuidanceStatus3.UserEdited
    ).map(([key]) => key);
    if (keysToRevert.length === 0)
      return;
    const previousArtifact = artifact;
    const updatedArtifact = removeProposedGuidance(artifact, keysToRevert);
    writeableArtifact.setArtifact(updatedArtifact);
    try {
      await writeableArtifact.commitArtifactUpdate(updatedArtifact);
    } catch (_error) {
      writeableArtifact.setArtifact(previousArtifact);
      flashbarManager.addItem({
        type: "error",
        content: t("guidanceRevertError"),
        dismissible: true
      });
    }
  };
  return { handleEnhanceDimension, handleEnhanceAll, handleRevert, handleRevertAll };
}

// src/aipo/CreateConfig/components/GuidanceStep/useGuidanceEditPanel.ts
import * as React17 from "react";
import { GuidanceStatus as GuidanceStatus4 } from "@amzn/awsmp-max-model";
var emitEditPanelMetric = (logger, clickFeat, clickAct) => {
  logger.biMetric({
    metricName: "Click",
    value: 1,
    unit: "Count",
    dimensions: {
      ClickFeat: clickFeat,
      ClickAct: clickAct
    }
  });
};
var useGuidanceEditPanel = ({
  writeableArtifact,
  isBusy,
  flashbarManager,
  t,
  logger
}) => {
  const { artifact } = writeableArtifact;
  const [editingDimensionKey, setEditingDimensionKey] = React17.useState();
  const [isSaving, setIsSaving] = React17.useState(false);
  const showEditPanel = editingDimensionKey !== void 0;
  const handleOpenEdit = (key) => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: METRIC_CLICK_FEAT,
        ClickObj: METRIC_EDIT_DESCRIPTION,
        ClickAct: key
      }
    });
    setEditingDimensionKey(key);
  };
  const handleCancelEdit = () => {
    if (editingDimensionKey)
      emitEditPanelMetric(logger, METRIC_EDIT_PANEL_FEAT, METRIC_EDIT_PANEL_CANCEL);
    setEditingDimensionKey(void 0);
  };
  const closeEditPanel = () => {
    setEditingDimensionKey(void 0);
  };
  const handleSaveEdit = async (description) => {
    if (!editingDimensionKey || isBusy)
      return;
    emitEditPanelMetric(logger, METRIC_EDIT_PANEL_FEAT, METRIC_EDIT_PANEL_SAVE);
    const currentStatus = artifact.proposedGuidance?.[editingDimensionKey]?.status;
    const targetStatus = !currentStatus || currentStatus === GuidanceStatus4.UserEdited || currentStatus === GuidanceStatus4.Failed ? GuidanceStatus4.UserEdited : GuidanceStatus4.EnhancedEdited;
    const updatedArtifact = updateProposedGuidanceContent(artifact, editingDimensionKey, description, targetStatus);
    const previousArtifact = artifact;
    writeableArtifact.setArtifact(updatedArtifact);
    setIsSaving(true);
    try {
      await writeableArtifact.commitArtifactUpdate(updatedArtifact);
      setEditingDimensionKey(void 0);
    } catch (_error) {
      writeableArtifact.setArtifact(previousArtifact);
      flashbarManager.addItem({
        type: "error",
        content: t("editDescriptionSaveError"),
        dismissible: true
      });
    } finally {
      setIsSaving(false);
    }
  };
  return {
    editingDimensionKey,
    showEditPanel,
    isSaving,
    handleOpenEdit,
    handleCancelEdit,
    handleSaveEdit,
    closeEditPanel
  };
};

// src/aipo/CreateConfig/components/GuidanceStep/useGuidanceStepState.ts
import * as React18 from "react";
import { GuidanceStatus as GuidanceStatus5 } from "@amzn/awsmp-max-model";
var useGuidanceStepState = ({ writeableArtifact, productDimensions }) => {
  const { artifact } = writeableArtifact;
  const proposedGuidance = artifact.proposedGuidance;
  const guidance = React18.useMemo(() => proposedGuidance ?? {}, [proposedGuidance]);
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates;
  const statuses = Object.values(guidance).map((g) => g.status);
  const isEnhancing = statuses.some((s2) => s2 === GuidanceStatus5.Enhancing);
  const isBusy = isEnhancing || writeableArtifact.isArtifactLocked;
  const hasEligibleDimensions = (dimensionRates ?? []).some(
    (r2) => !guidance[r2.dimensionKey] || guidance[r2.dimensionKey].status === GuidanceStatus5.UserEdited
  );
  const hasRevertibleDimensions = statuses.some(
    (s2) => s2 === GuidanceStatus5.Enhanced || s2 === GuidanceStatus5.EnhancedEdited || s2 === GuidanceStatus5.UserEdited
  );
  const enhanceAllDisabled = !hasEligibleDimensions || isBusy;
  const revertAllDisabled = !hasRevertibleDimensions || isBusy;
  const [dismissedFailedAlert, setDismissedFailedAlert] = React18.useState(false);
  const [prevGuidance, setPrevGuidance] = React18.useState(guidance);
  if (prevGuidance !== guidance) {
    setDismissedFailedAlert(false);
    setPrevGuidance(guidance);
  }
  const failedAlertDimensions = React18.useMemo(() => {
    if (dismissedFailedAlert)
      return [];
    return Object.entries(guidance).filter(([_key, entry]) => entry.status === GuidanceStatus5.Failed).map(([key]) => productDimensions.get(key)?.dimension ?? key);
  }, [guidance, dismissedFailedAlert, productDimensions]);
  return {
    isBusy,
    enhanceAllDisabled,
    revertAllDisabled,
    dismissedFailedAlert,
    setDismissedFailedAlert,
    failedAlertDimensions
  };
};

// src/aipo/CreateConfig/components/GuidanceStep/DimensionItem.tsx
import Box21 from "@amzn/awsui-components-react/polaris/box";
import Button15 from "@amzn/awsui-components-react/polaris/button";
import ColumnLayout4 from "@amzn/awsui-components-react/polaris/column-layout";
import Icon8 from "@amzn/awsui-components-react/polaris/icon";
import SpaceBetween34 from "@amzn/awsui-components-react/polaris/space-between";

// ../../node_modules/@cloudscape-design/chat-components/loading-bar/index.js
import { jsx as _jsx2 } from "react/jsx-runtime";

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metadata.js
import { useEffect as useEffect12, useRef as useRef11 } from "react";
var COMPONENT_METADATA_KEY = "__awsuiMetadata__";
function useComponentMetadata(componentName, packageMetadata, analyticsMetadata) {
  const elementRef = useRef11(null);
  useEffect12(() => {
    if (elementRef.current) {
      const pkgMetadata = typeof packageMetadata === "string" ? { version: packageMetadata } : packageMetadata;
      const node = elementRef.current;
      const metadata = {
        ...pkgMetadata,
        name: componentName
      };
      if (analyticsMetadata && Object.keys(analyticsMetadata).length > 0) {
        metadata.analytics = analyticsMetadata;
      }
      Object.freeze(metadata);
      Object.defineProperty(node, COMPONENT_METADATA_KEY, { value: metadata, writable: false, configurable: true });
    }
  });
  return elementRef;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metrics.js
import { useEffect as useEffect13 } from "react";

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/log-clients.js
var AWSUI_EVENT = "awsui";
function validateLength(value, maxLength) {
  return !value || value.length <= maxLength;
}
var CLogClient = class {
  /**
   * Sends metric but only if Console Platform client logging JS API is present in the page.
   */
  sendMetric(metricName, value, detail) {
    if (!metricName || !/^[a-zA-Z0-9_-]+$/.test(metricName)) {
      console.error(`Invalid metric name: ${metricName}`);
      return;
    }
    if (!validateLength(metricName, 1e3)) {
      console.error(`Metric name ${metricName} is too long`);
      return;
    }
    if (!validateLength(detail, 4e3)) {
      console.error(`Detail for metric ${metricName} is too long: ${detail}`);
      return;
    }
    const wasSent = new PanoramaClient().sendMetric({
      eventContext: metricName,
      eventDetail: detail,
      eventValue: `${value}`,
      timestamp: Date.now()
    });
    if (wasSent) {
      return;
    }
    const AWSC = this.findAWSC(window);
    if (typeof AWSC === "object" && typeof AWSC.Clog === "object" && typeof AWSC.Clog.log === "function") {
      AWSC.Clog.log(metricName, value, detail);
    }
  }
  findAWSC(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === "object") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findAWSC(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};
var PanoramaClient = class {
  /**
   * Sends metric but only if Console Platform client v2 logging JS API is present in the page.
   */
  sendMetric(metric) {
    const panorama = this.findPanorama(window);
    if (!panorama) {
      return false;
    }
    const payload = {
      eventType: AWSUI_EVENT,
      timestamp: Date.now(),
      ...metric,
      eventDetail: typeof metric.eventDetail === "object" ? JSON.stringify(metric.eventDetail) : metric.eventDetail,
      eventValue: typeof metric.eventValue === "object" ? JSON.stringify(metric.eventValue) : metric.eventValue
    };
    if (!validateLength(payload.eventDetail, 4e3)) {
      this.onMetricError(`Event detail for metric is too long: ${payload.eventDetail}`);
      return true;
    }
    if (!validateLength(payload.eventValue, 4e3)) {
      this.onMetricError(`Event value for metric is too long: ${payload.eventValue}`);
      return true;
    }
    if (!validateLength(payload.eventContext, 4e3)) {
      this.onMetricError(`Event context for metric is too long: ${payload.eventContext}`);
      return true;
    }
    panorama("trackCustomEvent", payload);
    return true;
  }
  onMetricError(message) {
    console.error(message);
    const panorama = this.findPanorama(window);
    if (panorama) {
      panorama("trackCustomEvent", {
        eventType: AWSUI_EVENT,
        eventContext: "awsui-metric-error",
        eventDetail: message.slice(0, 4e3),
        timestamp: Date.now()
      });
    }
  }
  findPanorama(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === "function") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
      }
      const panoramaSymbol = Symbol.for("panorama");
      const symbolProperty = currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[panoramaSymbol];
      if (typeof symbolProperty === "function") {
        return symbolProperty;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findPanorama(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/formatters.js
function buildMetricDetail(detail, context) {
  const metricOrigin = typeof AWSUI_METRIC_ORIGIN !== "undefined" ? AWSUI_METRIC_ORIGIN : "main";
  const detailObject = {
    o: metricOrigin,
    t: context.theme,
    // React is the only framework we're using.
    f: "react",
    // Remove spaces from the version string for compactness
    v: context.packageVersion.replace(/\s/g, ""),
    ...detail
  };
  return jsonStringify(detailObject);
}
function buildComponentMetricDetail({ componentName, action, configuration, packageSource }, context) {
  return buildMetricDetail({
    a: action,
    s: componentName,
    p: packageSource,
    c: configuration
  }, context);
}
function jsonStringify(detailObject) {
  return JSON.stringify(detailObject, detailSerializer);
}
function detailSerializer(key, value) {
  if (typeof value === "number" && !Number.isFinite(value)) {
    return `${value}`;
  }
  return value;
}
function getMajorVersion(versionString) {
  const majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
  return majorVersionMatch ? majorVersionMatch[1].replace(".", "") : "";
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/metrics.js
var oneTimeMetrics = /* @__PURE__ */ new Set();
var Metrics = class {
  constructor(...args) {
    this.clog = new CLogClient();
    this.panorama = new PanoramaClient();
    if (args.length === 1) {
      this.context = args[0];
    } else {
      const [packageSource, packageVersion] = args;
      this.context = { packageSource, packageVersion, theme: "unknown" };
    }
  }
  sendComponentMetric(metric) {
    this.sendMetricOnce(`awsui_${metric.componentName}_${this.context.theme.charAt(0)}${getMajorVersion(this.context.packageVersion)}`, 1, buildComponentMetricDetail(metric, this.context));
  }
  /*
   * Calls Console Platform's client logging only the first time the provided metricName is used.
   * Subsequent calls with the same metricName are ignored.
   */
  sendMetricOnce(metricName, value, detail) {
    const key = [metricName + value + detail].join("|");
    if (!oneTimeMetrics.has(key)) {
      this.clog.sendMetric(metricName, value, detail);
      oneTimeMetrics.add(key);
    }
  }
  /**
   * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
   * Does nothing if Console Platform client logging JS is not present in page.
   */
  sendPanoramaMetric(metric) {
    this.panorama.sendMetric(metric);
  }
  sendOpsMetricObject(metricName, detail) {
    this.sendMetricOnce(metricName, 1, buildMetricDetail(detail, this.context));
  }
  sendOpsMetricValue(metricName, value) {
    this.sendMetricOnce(metricName, value);
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was loaded. The component load event will only be reported as used to client logging
   * service once per page view.
   */
  logComponentsLoaded() {
    this.sendComponentMetric({ componentName: this.context.packageSource, action: "loaded" });
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was used in the page.  A component will only be reported as used to client logging
   * service once per page view.
   */
  logComponentUsed(componentName, configuration) {
    this.sendComponentMetric({
      action: "used",
      componentName,
      configuration,
      packageSource: this.context.packageSource
    });
  }
};

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metrics.js
function useComponentMetrics(componentName, settings, configuration = { props: {} }) {
  useEffect13(() => {
    const metrics = new Metrics(settings);
    if (typeof window !== "undefined") {
      metrics.sendOpsMetricValue("awsui-viewport-width", window.innerWidth || 0);
      metrics.sendOpsMetricValue("awsui-viewport-height", window.innerHeight || 0);
    }
    metrics.logComponentsLoaded();
    metrics.logComponentUsed(componentName.toLowerCase(), configuration);
  }, []);
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/init-awsui-versions.js
function initAwsUiVersions(source, packageVersion) {
  if (typeof window !== "undefined") {
    if (!window.awsuiVersions) {
      window.awsuiVersions = {};
    }
    if (!window.awsuiVersions[source]) {
      window.awsuiVersions[source] = [];
    }
    window.awsuiVersions[source].push(packageVersion);
  }
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/singleton-handler/index.js
import { useEffect as useEffect14, useState as useState21 } from "react";
import { unstable_batchedUpdates } from "react-dom";
function createSingletonHandler(factory) {
  const listeners = [];
  const callback = (value) => {
    unstable_batchedUpdates(() => {
      for (const listener of listeners) {
        listener(value);
      }
    });
  };
  let cleanup;
  return function useSingleton(listener) {
    useEffect14(() => {
      if (listeners.length === 0) {
        cleanup = factory(callback);
      }
      listeners.push(listener);
      return () => {
        listeners.splice(listeners.indexOf(listener), 1);
        if (listeners.length === 0) {
          cleanup();
          cleanup = void 0;
        }
      };
    }, []);
  };
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/visual-mode/index.js
import { useEffect as useEffect15, useState as useState22 } from "react";

// ../../node_modules/@cloudscape-design/component-toolkit/internal/is-development.js
var isDevelopment = true;

// ../../node_modules/@cloudscape-design/component-toolkit/internal/logging.js
var messageCache = /* @__PURE__ */ new Set();
function warnOnce(component, message) {
  if (isDevelopment) {
    const warning = `[AwsUi] [${component}] ${message}`;
    if (!messageCache.has(warning)) {
      messageCache.add(warning);
      console.warn(warning);
    }
  }
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/global-flags/index.js
var awsuiVisualRefreshFlag = Symbol.for("awsui-visual-refresh-flag");
var awsuiGlobalFlagsSymbol = Symbol.for("awsui-global-flags");
function getGlobal() {
  return typeof window !== "undefined" ? window : globalThis;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/visual-mode/index.js
var useMutationSingleton = createSingletonHandler((handler) => {
  const observer = new MutationObserver(() => handler());
  observer.observe(document.body, { attributes: true, subtree: true });
  return () => observer.disconnect();
});
var visualRefreshState = void 0;
function detectVisualRefreshClassName() {
  return typeof document !== "undefined" && !!document.querySelector(".awsui-visual-refresh");
}
function detectVisualRefreshFlag() {
  var _a, _b;
  const global = getGlobal();
  return (_b = (_a = global === null || global === void 0 ? void 0 : global[awsuiVisualRefreshFlag]) === null || _a === void 0 ? void 0 : _a.call(global)) !== null && _b !== void 0 ? _b : false;
}
function useRuntimeVisualRefresh() {
  if (visualRefreshState === void 0) {
    visualRefreshState = detectVisualRefreshClassName();
    if (!visualRefreshState) {
      if (detectVisualRefreshFlag()) {
        visualRefreshState = true;
        if (typeof document !== "undefined") {
          document.body.classList.add("awsui-visual-refresh");
        }
      }
    }
  }
  if (isDevelopment) {
    const newVisualRefreshState = detectVisualRefreshClassName() || detectVisualRefreshFlag();
    if (newVisualRefreshState !== visualRefreshState) {
      warnOnce("Visual Refresh", "Dynamic visual refresh change detected. This is not supported. Make sure `awsui-visual-refresh` is attached to the `<body>` element before initial React render");
    }
  }
  return visualRefreshState;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/focus-visible/index.js
import { useEffect as useEffect16 } from "react";

// ../../node_modules/@cloudscape-design/component-toolkit/internal/keycode.js
var KeyCode;
(function(KeyCode2) {
  KeyCode2[KeyCode2["pageUp"] = 33] = "pageUp";
  KeyCode2[KeyCode2["pageDown"] = 34] = "pageDown";
  KeyCode2[KeyCode2["end"] = 35] = "end";
  KeyCode2[KeyCode2["home"] = 36] = "home";
  KeyCode2[KeyCode2["backspace"] = 8] = "backspace";
  KeyCode2[KeyCode2["space"] = 32] = "space";
  KeyCode2[KeyCode2["down"] = 40] = "down";
  KeyCode2[KeyCode2["left"] = 37] = "left";
  KeyCode2[KeyCode2["right"] = 39] = "right";
  KeyCode2[KeyCode2["up"] = 38] = "up";
  KeyCode2[KeyCode2["escape"] = 27] = "escape";
  KeyCode2[KeyCode2["enter"] = 13] = "enter";
  KeyCode2[KeyCode2["tab"] = 9] = "tab";
  KeyCode2[KeyCode2["shift"] = 16] = "shift";
  KeyCode2[KeyCode2["control"] = 17] = "control";
  KeyCode2[KeyCode2["alt"] = 18] = "alt";
  KeyCode2[KeyCode2["meta"] = 91] = "meta";
})(KeyCode || (KeyCode = {}));
function isModifierKey(event) {
  return [KeyCode.shift, KeyCode.alt, KeyCode.control, KeyCode.meta].includes(event.keyCode);
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/focus-visible/index.js
var frames = /* @__PURE__ */ new Map();
function setIsKeyboard(active) {
  if (active) {
    for (const currentDocument of frames.keys()) {
      currentDocument.body.setAttribute("data-awsui-focus-visible", "true");
    }
  } else {
    for (const currentDocument of frames.keys()) {
      currentDocument.body.removeAttribute("data-awsui-focus-visible");
    }
  }
}
function handleMousedown() {
  setIsKeyboard(false);
}
function handleKeydown(event) {
  if (!isModifierKey(event)) {
    setIsKeyboard(true);
  }
}
function addListeners(currentDocument) {
  const abortController = new AbortController();
  currentDocument.addEventListener("mousedown", handleMousedown, { signal: abortController.signal });
  currentDocument.addEventListener("keydown", handleKeydown, { signal: abortController.signal });
  return abortController;
}
function useFocusVisible(componentRef) {
  useEffect16(() => {
    var _a, _b;
    const currentDocument = (_b = (_a = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
    let frame = frames.get(currentDocument);
    if (frame) {
      frame.componentsCount++;
    } else {
      const abortController = addListeners(currentDocument);
      frame = { componentsCount: 1, abortController };
      frames.set(currentDocument, frame);
    }
    return () => {
      frame.componentsCount--;
      if (frame.componentsCount === 0) {
        frame.abortController.abort();
        frames.delete(currentDocument);
      }
    };
  }, [componentRef]);
}

// ../../node_modules/@cloudscape-design/chat-components/internal/environment.js
var PACKAGE_SOURCE = "chat-components";
var PACKAGE_VERSION = "1.0.0 (973328c3)";
var THEME = "open-source-visual-refresh";
var ALWAYS_VISUAL_REFRESH = true;

// ../../node_modules/@cloudscape-design/chat-components/internal/utils/get-visual-theme.js
var getVisualTheme = (theme, isVR) => {
  if (theme === "polaris" && isVR) {
    return "vr";
  }
  return theme;
};

// ../../node_modules/@cloudscape-design/chat-components/internal/base-component/use-visual-refresh.js
var useVisualRefresh = ALWAYS_VISUAL_REFRESH ? () => true : useRuntimeVisualRefresh;

// ../../node_modules/@cloudscape-design/chat-components/internal/base-component/use-base-component.js
initAwsUiVersions(PACKAGE_SOURCE, PACKAGE_VERSION);
function useBaseComponent(componentName, config) {
  const isVisualRefresh = useVisualRefresh();
  const theme = getVisualTheme(THEME, isVisualRefresh);
  useComponentMetrics(componentName, { packageSource: PACKAGE_SOURCE, packageVersion: PACKAGE_VERSION, theme }, config);
  useFocusVisible();
  const elementRef = useComponentMetadata(componentName, {
    packageName: PACKAGE_SOURCE,
    version: PACKAGE_VERSION,
    theme
  });
  return { __internalRootRef: elementRef };
}

// ../../node_modules/@cloudscape-design/chat-components/internal/utils/apply-display-name.js
function applyDisplayName(component, displayName) {
  component.displayName = displayName;
}

// ../../node_modules/@cloudscape-design/chat-components/loading-bar/internal.js
import { jsx as _jsx } from "react/jsx-runtime";

// ../../node_modules/clsx/dist/clsx.m.js
function r(e) {
  var t, f, n2 = "";
  if ("string" == typeof e || "number" == typeof e)
    n2 += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n2 && (n2 += " "), n2 += f);
    else
      for (t in e)
        e[t] && (n2 && (n2 += " "), n2 += t);
  return n2;
}
function clsx() {
  for (var e, t, f = 0, n2 = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n2 && (n2 += " "), n2 += t);
  return n2;
}
var clsx_m_default = clsx;

// ../../node_modules/@cloudscape-design/chat-components/internal/base-component/get-data-attributes.js
function getDataAttributes(props) {
  const result = {};
  Object.keys(props).forEach((prop) => {
    if (prop.startsWith("data-")) {
      result[prop] = props[prop];
    }
  });
  return result;
}

// ../../node_modules/@cloudscape-design/chat-components/loading-bar/styles.css.js
var styles_css_default = {
  "root": "awsui_root_pac4k_foszn_11",
  "variant-gen-ai": "awsui_variant-gen-ai_pac4k_foszn_55",
  "variant-gen-ai-masked": "awsui_variant-gen-ai-masked_pac4k_foszn_56",
  "searchbar": "awsui_searchbar_pac4k_foszn_1",
  "searchbar-rtl": "awsui_searchbar-rtl_pac4k_foszn_1"
};

// ../../node_modules/@cloudscape-design/chat-components/loading-bar/internal.js
function InternalLoadingBar({ variant, __internalRootRef, ...rest }) {
  return _jsx("div", { ref: __internalRootRef, ...getDataAttributes(rest), className: clsx_m_default([styles_css_default.root, styles_css_default[`variant-${variant}`]]) });
}

// ../../node_modules/@cloudscape-design/chat-components/loading-bar/index.js
function LoadingBar(props) {
  const baseComponentProps = useBaseComponent("LoadingBar", { props: { variant: props.variant } });
  return _jsx2(InternalLoadingBar, { ...props, ...baseComponentProps });
}
applyDisplayName(LoadingBar, "LoadingBar");

// src/aipo/CreateConfig/components/GuidanceStep/DimensionItem.tsx
import { GuidanceStatus as GuidanceStatus6 } from "@amzn/awsmp-max-model";

// src/aipo/CreateConfig/components/GuidanceStep/SourceAnnotationPopover.tsx
import * as React19 from "react";
import Box17 from "@amzn/awsui-components-react/polaris/box";
import Button13 from "@amzn/awsui-components-react/polaris/button";
import Icon5 from "@amzn/awsui-components-react/polaris/icon";
import Link14 from "@amzn/awsui-components-react/polaris/link";
import Popover3 from "@amzn/awsui-components-react/polaris/popover";
import SpaceBetween30 from "@amzn/awsui-components-react/polaris/space-between";

// src/aipo/CreateConfig/components/GuidanceStep/GuidanceStep.module.scss
var GuidanceStep_module_default = {
  dimensionDivider: "GuidanceStep_module_dimensionDivider",
  sourceBadge: "GuidanceStep_module_sourceBadge",
  insightBadge: "GuidanceStep_module_insightBadge",
  popoverDivider: "GuidanceStep_module_popoverDivider",
  paginationRow: "GuidanceStep_module_paginationRow",
  paginationButtons: "GuidanceStep_module_paginationButtons",
  insightsContainer: "GuidanceStep_module_insightsContainer",
  insightDivider: "GuidanceStep_module_insightDivider"
};

// src/aipo/CreateConfig/components/GuidanceStep/SourceAnnotationPopover.tsx
import { Fragment as Fragment7, jsx as jsx38, jsxs as jsxs34 } from "react/jsx-runtime";
function isValidHttpUrl(url) {
  return url.startsWith("https://") || url.startsWith("http://");
}
function isKnownTrustLevel(trustLevel) {
  return trustLevel in TRUST_LEVEL_KEYS;
}
function getTrustLevelLabel(trustLevel, t) {
  return t(TRUST_LEVEL_KEYS[trustLevel]);
}
function getAggregatedTrustLabel(trustLevels, t) {
  if (trustLevels.length === 0)
    return "";
  const unique = new Set(trustLevels);
  if (unique.size === 1) {
    const singleLevel = [...unique][0];
    return singleLevel ? getTrustLevelLabel(singleLevel, t) : "";
  }
  return t("guidanceSourceTrustMixed");
}
var SourceAnnotationPopover = ({ sources, t }) => {
  const sourceList = Object.values(sources).filter(
    (s2) => s2.trustLevel !== void 0 && isKnownTrustLevel(s2.trustLevel)
  );
  const [currentIndex, setCurrentIndex] = React19.useState(0);
  React19.useEffect(() => {
    setCurrentIndex(0);
  }, [sources]);
  if (sourceList.length === 0) {
    return /* @__PURE__ */ jsx38("span", { className: GuidanceStep_module_default.sourceBadge, "data-testid": "guidance-source-none", children: t("guidanceSourceNone") });
  }
  const safeIndex = Math.min(currentIndex, sourceList.length - 1);
  const source = sourceList[safeIndex];
  if (!source)
    return /* @__PURE__ */ jsx38("span", { className: GuidanceStep_module_default.sourceBadge, children: t("guidanceSourceNone") });
  const aggregatedLabel = getAggregatedTrustLabel(
    sourceList.map((s2) => s2.trustLevel),
    t
  );
  return /* @__PURE__ */ jsx38(
    Popover3,
    {
      dismissButton: true,
      position: "bottom",
      size: "medium",
      fixedWidth: true,
      triggerType: "custom",
      content: /* @__PURE__ */ jsxs34(SpaceBetween30, { size: "s", children: [
        /* @__PURE__ */ jsx38(Box17, { fontSize: "body-s", children: t("guidanceSourceHeader") }),
        /* @__PURE__ */ jsx38("span", { className: GuidanceStep_module_default.sourceBadge, children: getTrustLevelLabel(source.trustLevel, t) }),
        /* @__PURE__ */ jsx38(Box17, { variant: "strong", fontSize: "body-s", children: source.title }),
        source.url && isValidHttpUrl(source.url) ? /* @__PURE__ */ jsx38(Link14, { variant: "primary", external: true, href: source.url, fontSize: "body-s", children: source.url }) : /* @__PURE__ */ jsx38(Box17, { fontSize: "body-s", color: "text-body-secondary", children: source.url }),
        sourceList.length > 1 && /* @__PURE__ */ jsxs34(Fragment7, { children: [
          /* @__PURE__ */ jsx38("hr", { className: GuidanceStep_module_default.popoverDivider }),
          /* @__PURE__ */ jsxs34("div", { className: GuidanceStep_module_default.paginationRow, children: [
            /* @__PURE__ */ jsx38(Box17, { fontSize: "body-s", color: "text-body-secondary", children: t("guidanceSourcePagination", { current: String(safeIndex + 1), total: String(sourceList.length) }) }),
            /* @__PURE__ */ jsxs34("div", { className: GuidanceStep_module_default.paginationButtons, children: [
              /* @__PURE__ */ jsx38(
                Button13,
                {
                  "data-testid": "guidance-source-popover-prev",
                  variant: "link",
                  disabled: safeIndex === 0,
                  onClick: () => setCurrentIndex((i) => i - 1),
                  children: t("guidanceSourcePrevious")
                }
              ),
              /* @__PURE__ */ jsx38(
                Button13,
                {
                  "data-testid": "guidance-source-popover-next",
                  variant: "normal",
                  disabled: safeIndex === sourceList.length - 1,
                  onClick: () => setCurrentIndex((i) => i + 1),
                  children: t("guidanceSourceNext")
                }
              )
            ] })
          ] })
        ] })
      ] }),
      children: /* @__PURE__ */ jsxs34("span", { className: GuidanceStep_module_default.sourceBadge, "data-testid": "guidance-source-badge", children: [
        /* @__PURE__ */ jsx38(Icon5, { name: "anchor-link", size: "small" }),
        " ",
        t("guidanceSourceBadgeLabel", { count: String(sourceList.length), trustLevel: aggregatedLabel })
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/GuidanceStep/AgentInsightBadge.tsx
import * as React20 from "react";
import Box18 from "@amzn/awsui-components-react/polaris/box";
import Icon6 from "@amzn/awsui-components-react/polaris/icon";
import Link15 from "@amzn/awsui-components-react/polaris/link";
import Popover4 from "@amzn/awsui-components-react/polaris/popover";
import SpaceBetween31 from "@amzn/awsui-components-react/polaris/space-between";
import { jsx as jsx39, jsxs as jsxs35 } from "react/jsx-runtime";
var AgentInsightBadge = ({ insights, onEdit, t }) => {
  const entries = Object.entries(insights).filter(
    (entry) => isKnownInsightType(entry[0]) && entry[1] !== void 0 && entry[1].value === true
  );
  if (entries.length === 0) {
    return /* @__PURE__ */ jsx39("span", { className: GuidanceStep_module_default.sourceBadge, "data-testid": "guidance-insight-none", children: t("guidanceInsightNone") });
  }
  return /* @__PURE__ */ jsx39(
    Popover4,
    {
      dismissButton: false,
      position: "top",
      size: "medium",
      triggerType: "custom",
      content: /* @__PURE__ */ jsx39(SpaceBetween31, { size: "s", "data-testid": "guidance-insight-popover-content", children: entries.map(([type, insight], index) => /* @__PURE__ */ jsxs35(React20.Fragment, { children: [
        index > 0 && /* @__PURE__ */ jsx39("hr", { className: GuidanceStep_module_default.insightDivider }),
        /* @__PURE__ */ jsxs35(SpaceBetween31, { size: "xxs", children: [
          /* @__PURE__ */ jsx39(Box18, { variant: "strong", fontSize: "body-s", children: t(INSIGHT_TYPE_KEYS[type]) }),
          /* @__PURE__ */ jsxs35(Box18, { fontSize: "body-s", children: [
            insight.reason,
            " ",
            onEdit && /* @__PURE__ */ jsx39(
              Link15,
              {
                variant: "primary",
                fontSize: "body-s",
                href: "#",
                onFollow: (e) => {
                  e.preventDefault();
                  onEdit();
                },
                children: t("guidanceInsightEditToResolve")
              }
            )
          ] })
        ] })
      ] }, type)) }),
      children: /* @__PURE__ */ jsxs35("span", { className: GuidanceStep_module_default.insightBadge, "data-testid": "guidance-insight-badge", children: [
        /* @__PURE__ */ jsx39(Icon6, { name: "gen-ai", size: "small" }),
        " ",
        t("guidanceInsightReview", { count: String(entries.length) })
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/GuidanceStep/EnhancedDescriptionBlock.tsx
import Box20 from "@amzn/awsui-components-react/polaris/box";
import Button14 from "@amzn/awsui-components-react/polaris/button";
import Icon7 from "@amzn/awsui-components-react/polaris/icon";
import SpaceBetween33 from "@amzn/awsui-components-react/polaris/space-between";

// src/aipo/CreateConfig/components/GuidanceStep/OriginalDescriptionPopover.tsx
import Box19 from "@amzn/awsui-components-react/polaris/box";
import Popover5 from "@amzn/awsui-components-react/polaris/popover";
import SpaceBetween32 from "@amzn/awsui-components-react/polaris/space-between";
import { jsx as jsx40, jsxs as jsxs36 } from "react/jsx-runtime";
var OriginalDescriptionPopover = ({ originalDescription, t }) => /* @__PURE__ */ jsx40(Box19, { color: "text-status-info", fontSize: "body-s", children: /* @__PURE__ */ jsx40(
  Popover5,
  {
    dismissButton: true,
    position: "bottom",
    size: "large",
    triggerType: "text",
    content: /* @__PURE__ */ jsxs36(SpaceBetween32, { size: "xs", "data-testid": "guidance-original-description-content", children: [
      /* @__PURE__ */ jsx40(Box19, { variant: "awsui-key-label", children: t("guidanceOriginalDescription") }),
      /* @__PURE__ */ jsx40(Box19, { variant: "p", color: "text-body-secondary", children: originalDescription || t("noDescriptionProvided") })
    ] }),
    children: /* @__PURE__ */ jsx40("span", { "data-testid": "guidance-view-original", children: t("guidanceViewOriginal") })
  }
) });

// src/aipo/CreateConfig/components/GuidanceStep/EnhancedDescriptionBlock.tsx
import { jsx as jsx41, jsxs as jsxs37 } from "react/jsx-runtime";
var EnhancedDescriptionBlock = ({
  dimensionKey,
  index,
  proposedContent,
  originalDescription,
  actionsDisabled,
  actions,
  t
}) => /* @__PURE__ */ jsxs37(SpaceBetween33, { size: "xs", children: [
  /* @__PURE__ */ jsx41(Box20, { "data-testid": `dimension-description-${dimensionKey}-${index}`, variant: "span", children: proposedContent || t("noDescriptionProvided") }),
  /* @__PURE__ */ jsxs37(Box20, { children: [
    /* @__PURE__ */ jsx41(Box20, { float: "right", children: /* @__PURE__ */ jsx41(SpaceBetween33, { direction: "horizontal", size: "l", children: actions.map((action) => /* @__PURE__ */ jsx41(
      Button14,
      {
        "data-testid": `${action.key}-${dimensionKey}-${index}`,
        variant: "inline-link",
        disabled: action.key !== "edit" /* Edit */ && actionsDisabled,
        onClick: action.onClick,
        children: action.iconName ? /* @__PURE__ */ jsxs37(SpaceBetween33, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
          /* @__PURE__ */ jsx41(Icon7, { name: action.iconName, size: "normal" }),
          /* @__PURE__ */ jsx41("span", { children: action.label })
        ] }) : action.label
      },
      action.key
    )) }) }),
    /* @__PURE__ */ jsx41(OriginalDescriptionPopover, { originalDescription, t })
  ] })
] });

// src/aipo/CreateConfig/components/GuidanceStep/DimensionItem.tsx
import { Fragment as Fragment9, jsx as jsx42, jsxs as jsxs38 } from "react/jsx-runtime";
var EMPTY_SOURCES = {};
var EMPTY_INSIGHTS = {};
var DimensionItem = ({
  dimension,
  status,
  proposedContent,
  originalDescription,
  onEnhance,
  onRevert,
  onEdit,
  sources,
  insights,
  index,
  isLast,
  actionsDisabled,
  t
}) => {
  const dimensionKey = dimension.apiIdentifier;
  const showSources = status === GuidanceStatus6.Enhanced || status === GuidanceStatus6.EnhancedEdited;
  const showInsights = status === GuidanceStatus6.Enhanced;
  const metadataColumns = showInsights ? 3 : showSources ? 2 : 1;
  const enhancedActions = [
    { key: "revert" /* Revert */, label: t("guidanceRevert"), iconName: "undo", onClick: () => onRevert(dimensionKey) },
    { key: "edit" /* Edit */, label: t("guidanceEdit"), onClick: () => onEdit?.(dimensionKey) }
  ];
  const enhancedEditedActions = [
    { key: "revert" /* Revert */, label: t("guidanceRevert"), iconName: "undo", onClick: () => onRevert(dimensionKey) },
    { key: "enhance" /* Enhance */, label: t("guidanceEnhance"), iconName: "gen-ai", onClick: () => onEnhance(dimensionKey) },
    { key: "edit" /* Edit */, label: t("guidanceEdit"), onClick: () => onEdit?.(dimensionKey) }
  ];
  const userEditedActions = [
    { key: "revert" /* Revert */, label: t("guidanceRevert"), iconName: "undo", onClick: () => onRevert(dimensionKey) },
    { key: "enhance" /* Enhance */, label: t("guidanceEnhance"), iconName: "gen-ai", onClick: () => onEnhance(dimensionKey) },
    { key: "edit" /* Edit */, label: t("guidanceEdit"), onClick: () => onEdit?.(dimensionKey) }
  ];
  return /* @__PURE__ */ jsxs38(Fragment9, { children: [
    /* @__PURE__ */ jsx42(Box21, { padding: { vertical: "l" }, children: /* @__PURE__ */ jsxs38(SpaceBetween34, { size: "m", children: [
      /* @__PURE__ */ jsxs38(ColumnLayout4, { columns: metadataColumns, variant: "text-grid", children: [
        /* @__PURE__ */ jsxs38(Box21, { children: [
          /* @__PURE__ */ jsx42(Box21, { variant: "awsui-key-label", children: t("dimensionName") }),
          /* @__PURE__ */ jsx42(Box21, { "data-testid": `dimension-name-${dimensionKey}-${index}`, children: dimension.dimension })
        ] }),
        showSources && /* @__PURE__ */ jsxs38(Box21, { children: [
          /* @__PURE__ */ jsx42(Box21, { variant: "awsui-key-label", children: t("guidanceSourcesLabel") }),
          /* @__PURE__ */ jsx42(Box21, { margin: { top: "xxs" }, children: /* @__PURE__ */ jsx42(SourceAnnotationPopover, { sources: sources ?? EMPTY_SOURCES, t }) })
        ] }),
        showInsights && /* @__PURE__ */ jsxs38(Box21, { children: [
          /* @__PURE__ */ jsx42(Box21, { variant: "awsui-key-label", children: t("guidanceInsightsLabel") }),
          /* @__PURE__ */ jsx42(Box21, { margin: { top: "xxs" }, children: /* @__PURE__ */ jsx42(AgentInsightBadge, { insights: insights ?? EMPTY_INSIGHTS, onEdit: onEdit ? () => onEdit(dimensionKey) : void 0, t }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs38(Box21, { children: [
        (!status || status === GuidanceStatus6.Failed) && /* @__PURE__ */ jsx42(Box21, { float: "right", children: /* @__PURE__ */ jsxs38(SpaceBetween34, { direction: "horizontal", size: "l", children: [
          /* @__PURE__ */ jsx42(Button15, { "data-testid": `edit-${dimensionKey}-${index}`, variant: "inline-link", onClick: () => onEdit?.(dimensionKey), children: t("guidanceEdit") }),
          !status && /* @__PURE__ */ jsx42(
            Button15,
            {
              "data-testid": `enhance-${dimensionKey}-${index}`,
              variant: "inline-link",
              disabled: actionsDisabled,
              onClick: () => onEnhance(dimensionKey),
              children: /* @__PURE__ */ jsxs38(SpaceBetween34, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
                /* @__PURE__ */ jsx42(Icon8, { name: "gen-ai", size: "normal" }),
                /* @__PURE__ */ jsx42("span", { children: t("guidanceEnhanceDescription") })
              ] })
            }
          )
        ] }) }),
        /* @__PURE__ */ jsxs38(SpaceBetween34, { direction: "horizontal", size: "xs", alignItems: "center", children: [
          /* @__PURE__ */ jsx42(Box21, { variant: "awsui-key-label", children: t("description") }),
          status === GuidanceStatus6.Enhanced && /* @__PURE__ */ jsx42(Box21, { "data-testid": `ai-label-${dimensionKey}-${index}`, variant: "awsui-gen-ai-label", display: "inline", fontSize: "body-s", children: /* @__PURE__ */ jsxs38(SpaceBetween34, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
            /* @__PURE__ */ jsx42(Icon8, { name: "gen-ai", size: "small" }),
            t("guidanceGeneratedByAI")
          ] }) }),
          status === GuidanceStatus6.EnhancedEdited && /* @__PURE__ */ jsx42(
            Box21,
            {
              "data-testid": `ai-assisted-label-${dimensionKey}-${index}`,
              variant: "span",
              display: "inline",
              color: "text-body-secondary",
              fontSize: "body-s",
              children: /* @__PURE__ */ jsxs38(SpaceBetween34, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
                /* @__PURE__ */ jsx42(Icon8, { name: "edit-gen-ai", size: "small" }),
                t("guidanceAssistedByAI")
              ] })
            }
          )
        ] }),
        status === GuidanceStatus6.Enhancing ? /* @__PURE__ */ jsxs38(SpaceBetween34, { size: "xs", children: [
          /* @__PURE__ */ jsx42(LoadingBar, { variant: "gen-ai" }),
          /* @__PURE__ */ jsx42(Box21, { color: "text-body-secondary", fontSize: "body-s", children: t("guidanceGeneratingDescription") })
        ] }) : status === GuidanceStatus6.Enhanced ? /* @__PURE__ */ jsx42(
          EnhancedDescriptionBlock,
          {
            dimensionKey,
            index,
            proposedContent,
            originalDescription,
            actionsDisabled,
            actions: enhancedActions,
            t
          }
        ) : status === GuidanceStatus6.EnhancedEdited ? /* @__PURE__ */ jsx42(
          EnhancedDescriptionBlock,
          {
            dimensionKey,
            index,
            proposedContent,
            originalDescription,
            actionsDisabled,
            actions: enhancedEditedActions,
            t
          }
        ) : status === GuidanceStatus6.UserEdited ? /* @__PURE__ */ jsx42(
          EnhancedDescriptionBlock,
          {
            dimensionKey,
            index,
            proposedContent,
            originalDescription,
            actionsDisabled,
            actions: userEditedActions,
            t
          }
        ) : status === GuidanceStatus6.Failed ? /* @__PURE__ */ jsxs38(SpaceBetween34, { size: "xs", children: [
          /* @__PURE__ */ jsx42(Box21, { color: "text-status-inactive", fontSize: "body-s", children: t("guidanceEnhancementFailedDetail") }),
          /* @__PURE__ */ jsx42(Box21, { children: originalDescription || t("noDescriptionProvided") })
        ] }) : /* @__PURE__ */ jsx42(Box21, { "data-testid": `dimension-description-${dimensionKey}-${index}`, children: originalDescription || t("noDescriptionProvided") })
      ] })
    ] }) }),
    !isLast && /* @__PURE__ */ jsx42("hr", { className: GuidanceStep_module_default.dimensionDivider })
  ] });
};

// src/aipo/CreateConfig/components/GuidanceStep/DimensionDescriptionEditPanel.tsx
import * as React21 from "react";
import Alert11 from "@amzn/awsui-components-react/polaris/alert";
import Box22 from "@amzn/awsui-components-react/polaris/box";
import Button16 from "@amzn/awsui-components-react/polaris/button";
import FormField13 from "@amzn/awsui-components-react/polaris/form-field";
import Icon9 from "@amzn/awsui-components-react/polaris/icon";
import SpaceBetween35 from "@amzn/awsui-components-react/polaris/space-between";
import Textarea4 from "@amzn/awsui-components-react/polaris/textarea";
import { Fragment as Fragment10, jsx as jsx43, jsxs as jsxs39 } from "react/jsx-runtime";
var DimensionDescriptionEditPanel = ({
  dimensionName,
  initialDescription,
  insights,
  onSave,
  onCancel,
  saveDisabled,
  saveLoading,
  showAiWarning = true,
  logger,
  t
}) => {
  const [editValue, setEditValue] = React21.useState(initialDescription ?? "");
  const [touched, setTouched] = React21.useState(false);
  React21.useEffect(() => {
    setEditValue(initialDescription ?? "");
    setTouched(false);
  }, [dimensionName, initialDescription]);
  const characterCount = editValue.length;
  const { isOverLimit, unsupportedChars, hasSpaceBeforeTrademark, hasError } = validateDescriptionContent(editValue);
  const hasUnsupportedChars = unsupportedChars !== null && unsupportedChars.length > 0;
  const showError = touched && hasError;
  React21.useEffect(() => {
    if (touched && !hasError)
      setTouched(false);
  }, [touched, hasError]);
  const insightEntries = insights ? Object.entries(insights).filter(
    (entry) => isKnownInsightType(entry[0]) && entry[1] !== void 0 && entry[1].value === true
  ) : [];
  return /* @__PURE__ */ jsx43("div", { "data-testid": "guidance-edit-panel", children: /* @__PURE__ */ jsxs39(SpaceBetween35, { size: "l", children: [
    /* @__PURE__ */ jsxs39("div", { children: [
      /* @__PURE__ */ jsx43(Box22, { variant: "awsui-key-label", margin: { bottom: "xxxs" }, children: t("dimensionName") }),
      /* @__PURE__ */ jsx43("div", { children: dimensionName })
    ] }),
    insightEntries.length > 0 && /* @__PURE__ */ jsx43("div", { className: GuidanceStep_module_default.insightsContainer, children: /* @__PURE__ */ jsxs39(SpaceBetween35, { size: "xxxs", children: [
      /* @__PURE__ */ jsxs39(Box22, { variant: "h3", fontSize: "heading-s", children: [
        /* @__PURE__ */ jsx43(Box22, { variant: "awsui-gen-ai-label", display: "inline", children: /* @__PURE__ */ jsx43(Icon9, { name: "gen-ai", size: "normal" }) }),
        " ",
        t("guidanceInsightsLabel")
      ] }),
      insightEntries.map(([type, insight]) => /* @__PURE__ */ jsxs39("div", { children: [
        /* @__PURE__ */ jsx43(Box22, { variant: "strong", fontSize: "body-s", children: t(INSIGHT_TYPE_KEYS[type]) }),
        /* @__PURE__ */ jsx43(Box22, { fontSize: "body-s", children: insight.reason })
      ] }, type))
    ] }) }),
    /* @__PURE__ */ jsx43(
      FormField13,
      {
        label: /* @__PURE__ */ jsxs39(Fragment10, { children: [
          t("editDescriptionLabel"),
          " -",
          " ",
          /* @__PURE__ */ jsx43(Box22, { variant: "span", tagOverride: "i", children: t("editDescriptionOptional") })
        ] }),
        description: t("editDescriptionHint"),
        characterCountText: t("editDescriptionCharacterCount", { current: String(characterCount), max: String(MAX_DESCRIPTION_LENGTH) }),
        errorText: showError ? /* @__PURE__ */ jsxs39(Fragment10, { children: [
          isOverLimit && /* @__PURE__ */ jsx43("div", { children: t("editDescriptionCharLimitError", { current: String(characterCount), max: String(MAX_DESCRIPTION_LENGTH) }) }),
          hasUnsupportedChars && /* @__PURE__ */ jsx43("div", { children: t("editDescriptionUnsupportedCharsError", { chars: [...new Set(unsupportedChars)].join(" ") }) }),
          hasSpaceBeforeTrademark && /* @__PURE__ */ jsx43("div", { children: t("editDescriptionSpaceBeforeTrademarkError") })
        ] }) : void 0,
        children: /* @__PURE__ */ jsx43(
          Textarea4,
          {
            value: editValue,
            onChange: ({ detail }) => setEditValue(detail.value),
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: METRIC_EDIT_PANEL_FEAT,
                  ClickAct: METRIC_EDIT_PANEL_TEXTAREA
                }
              });
            },
            onBlur: () => setTouched(true),
            rows: TEXTAREA_ROWS,
            invalid: showError
          }
        )
      }
    ),
    showAiWarning && /* @__PURE__ */ jsx43(Alert11, { children: t("editDescriptionWarning") }),
    /* @__PURE__ */ jsx43(Box22, { float: "right", children: /* @__PURE__ */ jsxs39(SpaceBetween35, { direction: "horizontal", size: "xs", children: [
      /* @__PURE__ */ jsx43(Button16, { "data-testid": "guidance-edit-panel-cancel", onClick: onCancel, children: t("cancel") }),
      /* @__PURE__ */ jsx43(
        Button16,
        {
          "data-testid": "guidance-edit-panel-save",
          variant: "primary",
          onClick: () => {
            setTouched(true);
            if (!hasError)
              onSave(editValue);
          },
          disabled: saveDisabled,
          loading: saveLoading,
          children: t("save")
        }
      )
    ] }) })
  ] }) });
};

// src/aipo/CreateConfig/components/GuidanceStep/GuidanceStep.tsx
import { jsx as jsx44, jsxs as jsxs40 } from "react/jsx-runtime";
var GuidanceStep = ({
  writeableArtifact,
  productDimensions = /* @__PURE__ */ new Map(),
  publicOfferDimensionKeys,
  layoutComponents,
  flashbarManager,
  logger,
  t,
  withAsyncErrors,
  turnState,
  errors,
  clearFieldError
}) => {
  const { artifact } = writeableArtifact;
  const LayoutSplitPanel = layoutComponents?.LayoutSplitPanel;
  const [panelSize, setPanelSize] = React22.useState(EDIT_PANEL_SIZE);
  const [preEnhanceSnapshot, setPreEnhanceSnapshot] = React22.useState();
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.ENHANCE_DIMENSIONS);
  React22.useEffect(() => {
    if (turnState !== ProjectStatus.Error)
      return;
    const restored = restorePreEnhanceSnapshot(artifact, preEnhanceSnapshot);
    if (restored) {
      writeableArtifact.setArtifact(restored);
      setPreEnhanceSnapshot(void 0);
      flashbarManager.addItem({
        type: "error",
        content: t("guidanceEnhanceError"),
        dismissible: true
      });
    }
  }, [turnState]);
  React22.useEffect(() => {
    if (errors.guidanceOverLimitError)
      clearFieldError("guidanceOverLimitError");
    if (errors.guidanceUnsupportedCharsError)
      clearFieldError("guidanceUnsupportedCharsError");
    if (errors.guidanceSpaceBeforeTrademarkError)
      clearFieldError("guidanceSpaceBeforeTrademarkError");
  }, [artifact.proposedGuidance]);
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates;
  const proposedGuidance = artifact.proposedGuidance;
  const selectedDimensions = React22.useMemo(() => {
    if (!dimensionRates)
      return [];
    return dimensionRates.reduce((acc, dimRate) => {
      const matchingDimension = productDimensions.get(dimRate.dimensionKey);
      if (matchingDimension) {
        acc.push({ ...matchingDimension, pricePerUnit: dimRate.price });
      }
      return acc;
    }, []);
  }, [dimensionRates, productDimensions]);
  const { publicDimensions, epoExclusiveDimensions } = React22.useMemo(
    () => splitDimensionsByVisibility(selectedDimensions, publicOfferDimensionKeys),
    [selectedDimensions, publicOfferDimensionKeys]
  );
  const { handleEnhanceDimension, handleEnhanceAll, handleRevert, handleRevertAll } = useGuidanceActions(
    writeableArtifact,
    logger,
    withAsyncErrors,
    setPreEnhanceSnapshot,
    flashbarManager,
    t
  );
  const { isBusy, enhanceAllDisabled, revertAllDisabled, setDismissedFailedAlert, failedAlertDimensions } = useGuidanceStepState({
    writeableArtifact,
    productDimensions
  });
  const { editingDimensionKey, showEditPanel, isSaving, handleOpenEdit, handleCancelEdit, handleSaveEdit, closeEditPanel } = useGuidanceEditPanel({
    writeableArtifact,
    isBusy,
    flashbarManager,
    t,
    logger
  });
  const renderDimension = (dimension, index, totalCount) => {
    const dimKey = dimension.apiIdentifier;
    const originalDesc = productDimensions.get(dimKey)?.description;
    const proposedContent = proposedGuidance?.[dimKey]?.content;
    const dimGuidance = proposedGuidance?.[dimKey];
    return /* @__PURE__ */ jsx44(
      DimensionItem,
      {
        dimension,
        status: proposedGuidance?.[dimKey]?.status,
        proposedContent,
        originalDescription: originalDesc,
        onEnhance: (key) => {
          handleEnhanceDimension(key);
          if (key === editingDimensionKey) {
            closeEditPanel();
          }
        },
        onRevert: (key) => {
          handleRevert(key);
          if (key === editingDimensionKey) {
            closeEditPanel();
          }
        },
        onEdit: handleOpenEdit,
        sources: dimGuidance?.sources,
        insights: dimGuidance?.insights,
        index,
        isLast: index === totalCount - 1,
        actionsDisabled: isBusy,
        t
      },
      dimKey
    );
  };
  return /* @__PURE__ */ jsxs40(SpaceBetween36, { size: "l", children: [
    /* @__PURE__ */ jsx44(Alert12, { type: "info", "data-testid": "guidance-info-alert", header: t("guidanceAlertHeader"), children: t("guidanceAlertBody") }),
    /* @__PURE__ */ jsxs40(
      Container22,
      {
        header: /* @__PURE__ */ jsx44(
          Header25,
          {
            "data-testid": "guidance-descriptions-header",
            variant: "h2",
            actions: /* @__PURE__ */ jsxs40(SpaceBetween36, { direction: "horizontal", size: "xs", children: [
              /* @__PURE__ */ jsx44(
                Button17,
                {
                  "data-testid": "guidance-step-revert-all",
                  disabled: revertAllDisabled,
                  onClick: () => {
                    handleRevertAll();
                    closeEditPanel();
                  },
                  children: t("guidanceRevertAll")
                }
              ),
              /* @__PURE__ */ jsx44(Button17, { "data-testid": "guidance-step-enhance-all", iconName: "gen-ai", disabled: enhanceAllDisabled, onClick: handleEnhanceAll, children: t("guidanceEnhanceAll") })
            ] }),
            description: t("guidanceDescriptionsBodyText"),
            children: t("guidanceDescriptionsHeader")
          }
        ),
        children: [
          /* @__PURE__ */ jsx44(
            ExpandableSection2,
            {
              "data-testid": "public-dimensions-section",
              defaultExpanded: true,
              headerText: t("guidancePublicDimensionsHeader", { count: publicDimensions.length }),
              children: publicDimensions.length === 0 ? /* @__PURE__ */ jsx44(Box23, { padding: { vertical: "l" }, color: "text-body-secondary", children: t("guidanceNoPublicDimensions") }) : publicDimensions.map((dim, i) => renderDimension(dim, i, publicDimensions.length))
            }
          ),
          /* @__PURE__ */ jsx44(
            ExpandableSection2,
            {
              "data-testid": "epo-exclusive-dimensions-section",
              defaultExpanded: true,
              headerText: t("guidanceEpoExclusiveDimensionsHeader", { count: epoExclusiveDimensions.length }),
              children: epoExclusiveDimensions.length === 0 ? /* @__PURE__ */ jsx44(Box23, { "data-testid": "no-epo-exclusive-dimensions", padding: { vertical: "l" }, color: "text-body-secondary", children: t("guidanceNoEpoExclusiveDimensions") }) : epoExclusiveDimensions.map((dim, i) => renderDimension(dim, i, epoExclusiveDimensions.length))
            }
          )
        ]
      }
    ),
    failedAlertDimensions.length > 0 && /* @__PURE__ */ jsxs40(
      Alert12,
      {
        "data-testid": "guidance-failed-alert",
        type: "warning",
        dismissible: true,
        onDismiss: () => setDismissedFailedAlert(true),
        header: t("guidanceEnhanceAllFailureAlertHeader"),
        children: [
          /* @__PURE__ */ jsx44(Box23, { variant: "strong", display: "inline", children: failedAlertDimensions.join(", ") }),
          " ",
          t("guidanceEnhanceAllFailureAlertBodySuffix")
        ]
      }
    ),
    errors.guidanceOverLimitError && /* @__PURE__ */ jsxs40(Alert12, { type: "error", "data-testid": "guidance-over-limit-alert", header: t("guidanceOverLimitAlertHeader"), children: [
      /* @__PURE__ */ jsx44(Box23, { variant: "strong", display: "inline", children: errors.guidanceOverLimitError }),
      " ",
      t("guidanceOverLimitAlertBody")
    ] }),
    errors.guidanceUnsupportedCharsError && /* @__PURE__ */ jsxs40(Alert12, { type: "error", "data-testid": "guidance-unsupported-chars-alert", header: t("guidanceUnsupportedCharsAlertHeader"), children: [
      /* @__PURE__ */ jsx44(Box23, { variant: "strong", display: "inline", children: errors.guidanceUnsupportedCharsError }),
      " ",
      t("guidanceUnsupportedCharsAlertBody")
    ] }),
    errors.guidanceSpaceBeforeTrademarkError && /* @__PURE__ */ jsxs40(Alert12, { type: "error", "data-testid": "guidance-space-before-trademark-alert", header: t("guidanceSpaceBeforeTrademarkAlertHeader"), children: [
      /* @__PURE__ */ jsx44(Box23, { variant: "strong", display: "inline", children: errors.guidanceSpaceBeforeTrademarkError }),
      " ",
      t("guidanceSpaceBeforeTrademarkAlertBody")
    ] }),
    LayoutSplitPanel && editingDimensionKey && /* @__PURE__ */ jsx44(
      LayoutSplitPanel,
      {
        open: showEditPanel,
        onToggle: (open) => {
          if (!open)
            handleCancelEdit();
        },
        onDismiss: handleCancelEdit,
        onResize: (size) => setPanelSize(size),
        closeBehavior: "hide" /* Hide */,
        header: t("editDescriptionPanelHeader"),
        size: panelSize,
        children: /* @__PURE__ */ jsx44(
          DimensionDescriptionEditPanel,
          {
            dimensionName: productDimensions.get(editingDimensionKey)?.dimension ?? editingDimensionKey,
            initialDescription: proposedGuidance?.[editingDimensionKey]?.content || productDimensions.get(editingDimensionKey)?.description,
            insights: proposedGuidance?.[editingDimensionKey]?.status === GuidanceStatus7.Failed ? void 0 : proposedGuidance?.[editingDimensionKey]?.insights,
            onSave: handleSaveEdit,
            onCancel: handleCancelEdit,
            saveDisabled: isBusy,
            saveLoading: isSaving,
            showAiWarning: proposedGuidance?.[editingDimensionKey]?.status === GuidanceStatus7.Enhanced || proposedGuidance?.[editingDimensionKey]?.status === GuidanceStatus7.EnhancedEdited,
            logger,
            t
          }
        )
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/RenewalTermsStep/RenewalTermsStep.tsx
import Box24 from "@amzn/awsui-components-react/polaris/box";
import Container23 from "@amzn/awsui-components-react/polaris/container";
import FormField14 from "@amzn/awsui-components-react/polaris/form-field";
import Header26 from "@amzn/awsui-components-react/polaris/header";
import Link16 from "@amzn/awsui-components-react/polaris/link";
import RadioGroup3 from "@amzn/awsui-components-react/polaris/radio-group";
import SpaceBetween37 from "@amzn/awsui-components-react/polaris/space-between";
import Tiles2 from "@amzn/awsui-components-react/polaris/tiles";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG12 } from "@amzn/awsmp-max-agentic-renderer-interface";

// src/aipo/shared/components/PrecisionNumberInput.tsx
import * as React23 from "react";
import Input9 from "@amzn/awsui-components-react/polaris/input";
import { jsx as jsx45 } from "react/jsx-runtime";
var ENTER_KEY_CODE = 13;
var normalizePrecision = (value, precision) => {
  const [integral, fraction = ""] = value.split(".");
  if (precision === 0 || fraction === "")
    return integral;
  if (precision === void 0)
    return value;
  return [integral.length ? integral : "0", fraction.slice(0, precision)].join(".");
};
var boundToString = (bound) => bound.toLocaleString("en-US", { maximumFractionDigits: 20, useGrouping: false });
var normalizeMin = (value, min) => min !== void 0 && Number(value) < min ? boundToString(min) : value;
var normalizeMax = (value, max) => max !== void 0 && Number(value) > max ? boundToString(max) : value;
var isBlockedKey = (key, constraints = {}) => {
  const { precision, min } = constraints;
  if (key === "e" || key === "E" || key === "+")
    return true;
  if (key === "-" && min !== void 0 && min >= 0)
    return true;
  if ((key === "." || key === ",") && precision === 0)
    return true;
  return false;
};
var normalizeNumberInputValue = (value, constraints = {}) => {
  const { precision, min, max } = constraints;
  let n2 = value;
  n2 = normalizePrecision(n2, precision);
  n2 = normalizeMax(n2, max);
  n2 = normalizeMin(n2, min);
  return n2;
};
var valueToText = (value, precision) => {
  if (value === void 0)
    return "";
  return normalizeNumberInputValue(boundToString(value), { precision });
};
var parseBuffer = (text) => {
  if (text.trim() === "")
    return { emit: true, value: void 0 };
  const parsed = Number(text);
  if (Number.isNaN(parsed))
    return { emit: false, value: void 0 };
  return { emit: true, value: parsed };
};
var PrecisionNumberInput = ({
  value,
  onChange,
  precision,
  min,
  max,
  commitOnBlurOrEnter,
  invalid,
  ariaRequired,
  ariaLabel,
  onFocus,
  dataTestId
}) => {
  const [text, setText] = React23.useState(() => valueToText(value, precision));
  const editedRef = React23.useRef(false);
  React23.useEffect(() => {
    setText(valueToText(value, precision));
  }, [value, precision]);
  const handleChange = (rawValue) => {
    editedRef.current = true;
    const normalized = normalizeNumberInputValue(rawValue, { precision, max });
    setText(normalized);
    if (commitOnBlurOrEnter)
      return;
    const { emit, value: parsed } = parseBuffer(normalized);
    if (emit)
      onChange(parsed);
  };
  const commitValue = () => {
    if (!editedRef.current)
      return;
    if (text.trim() === "") {
      setText("");
      onChange(void 0);
      return;
    }
    const normalized = normalizeNumberInputValue(text, { min });
    setText(normalized);
    const { emit, value: parsed } = parseBuffer(normalized);
    if (emit)
      onChange(parsed);
  };
  const handleFocus = () => {
    editedRef.current = false;
    onFocus?.();
  };
  const handleKeyDown = (event) => {
    if (isBlockedKey(event.detail.key, { precision, min })) {
      event.preventDefault();
      return;
    }
    if (commitOnBlurOrEnter && event.detail.keyCode === ENTER_KEY_CODE) {
      commitValue();
    }
  };
  return /* @__PURE__ */ jsx45(
    Input9,
    {
      "data-testid": dataTestId,
      type: "number",
      value: text,
      invalid,
      ariaLabel,
      ariaRequired: ariaRequired ?? false,
      onChange: ({ detail }) => handleChange(detail.value),
      onBlur: commitValue,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown
    }
  );
};

// src/aipo/CreateConfig/components/RenewalTermsStep/RenewalTermsStep.tsx
import { Fragment as Fragment11, jsx as jsx46, jsxs as jsxs41 } from "react/jsx-runtime";
var isRenewalPricing = (value) => value === "identical" || value === "evolving" || value === "none";
var isRenewalMaximumMode = (value) => value === "definite" || value === "indefinite";
var isRenewalUpliftType = (value) => value === "fixed" || value === "range";
var percentToNumber = (value) => value === void 0 || value === "" ? void 0 : Number(value);
var percentFromNumber = (value) => value === void 0 ? void 0 : String(value);
var RenewalTermsStep = ({ writeableArtifact, errors, clearFieldError, logger, t, openHelpPanel }) => {
  const { artifact, setArtifact } = writeableArtifact;
  const req = artifact.configurationRequest;
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.CONFIGURE_RENEWAL_TERMS);
  const biClick = (clickAct, clickObj) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: { ClickFeat: "renewal-terms", ClickAct: clickAct, ...clickObj !== void 0 ? { ClickObj: clickObj } : {} },
      value: 1,
      unit: "Count"
    });
  };
  const patch = (fields) => {
    setArtifact((prev) => ({ ...prev, configurationRequest: { ...prev.configurationRequest, ...fields } }));
  };
  const clearUpliftErrors = () => {
    clearFieldError("renewalUpliftTypeError");
    clearFieldError("renewalFixedPercentageError");
    clearFieldError("renewalRangeError");
    clearFieldError("renewalDefaultError");
    clearFieldError("renewalAdjustmentDeadlineError");
  };
  const clearEvolvingErrors = () => {
    clearFieldError("renewalMaximumError");
    clearFieldError("renewalMaxRenewalsError");
    clearFieldError("renewalLockoutError");
    clearUpliftErrors();
  };
  const onPricingChange = (value) => {
    if (!isRenewalPricing(value))
      return;
    biClick("renewal-pricing", value);
    if (value === "evolving") {
      patch({ renewalPricing: value });
    } else if (value === "identical") {
      patch({
        renewalPricing: value,
        renewalUpliftType: void 0,
        renewalFixedPercentage: void 0,
        renewalRangeMin: void 0,
        renewalRangeMax: void 0,
        renewalRangeDefault: void 0,
        renewalAdjustmentDeadlineDays: void 0
      });
      clearUpliftErrors();
    } else {
      patch({
        renewalPricing: value,
        renewalMaximumMode: void 0,
        renewalMaxRenewals: void 0,
        renewalLockoutDays: void 0,
        renewalUpliftType: void 0,
        renewalFixedPercentage: void 0,
        renewalRangeMin: void 0,
        renewalRangeMax: void 0,
        renewalRangeDefault: void 0,
        renewalAdjustmentDeadlineDays: void 0
      });
      clearEvolvingErrors();
    }
    clearFieldError("renewalPricingError");
  };
  const onMaximumModeChange = ({ detail }) => {
    if (!isRenewalMaximumMode(detail.value))
      return;
    biClick("renewal-maximum", detail.value);
    if (detail.value === "indefinite") {
      patch({ renewalMaximumMode: detail.value, renewalMaxRenewals: void 0 });
      clearFieldError("renewalMaxRenewalsError");
    } else {
      patch({ renewalMaximumMode: detail.value });
    }
    clearFieldError("renewalMaximumError");
  };
  const onCountChange = (value) => {
    patch({ renewalMaxRenewals: value });
    clearFieldError("renewalMaxRenewalsError");
  };
  const onLockoutChange = (value) => {
    patch({ renewalLockoutDays: value });
    clearFieldError("renewalLockoutError");
  };
  const onUpliftTypeChange = ({ detail }) => {
    if (!isRenewalUpliftType(detail.value))
      return;
    biClick("price-uplift-type", detail.value);
    if (detail.value === "fixed") {
      patch({
        renewalUpliftType: detail.value,
        renewalRangeMin: void 0,
        renewalRangeMax: void 0,
        renewalRangeDefault: void 0,
        renewalAdjustmentDeadlineDays: void 0
      });
      clearFieldError("renewalRangeError");
      clearFieldError("renewalDefaultError");
      clearFieldError("renewalAdjustmentDeadlineError");
    } else {
      patch({ renewalUpliftType: detail.value, renewalFixedPercentage: void 0 });
      clearFieldError("renewalFixedPercentageError");
    }
    clearFieldError("renewalUpliftTypeError");
  };
  const onFixedChange = (value) => {
    patch({ renewalFixedPercentage: percentFromNumber(value) });
    clearFieldError("renewalFixedPercentageError");
  };
  const onRangeMinChange = (value) => {
    patch({ renewalRangeMin: percentFromNumber(value) });
    clearFieldError("renewalRangeError");
  };
  const onRangeMaxChange = (value) => {
    patch({ renewalRangeMax: percentFromNumber(value) });
    clearFieldError("renewalRangeError");
  };
  const onDefaultChange = (value) => {
    patch({ renewalRangeDefault: percentFromNumber(value) });
    clearFieldError("renewalDefaultError");
  };
  const onAdjustmentDeadlineChange = (value) => {
    patch({ renewalAdjustmentDeadlineDays: value });
    clearFieldError("renewalAdjustmentDeadlineError");
  };
  return /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsx46(
      Container23,
      {
        header: /* @__PURE__ */ jsx46(
          Header26,
          {
            description: t("renewalTermsContainerDescription"),
            info: openHelpPanel ? /* @__PURE__ */ jsx46(
              Link16,
              {
                variant: "info",
                ariaLabel: t("infoAriaLabel", { section: t("renewalTermsHeader") }),
                onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG12.CONFIG_RENEWAL_TERMS),
                children: t("info")
              }
            ) : void 0,
            children: t("renewalTermsHeader")
          }
        ),
        children: /* @__PURE__ */ jsx46(
          FormField14,
          {
            stretch: true,
            label: t("renewalPricingLabel"),
            description: t("renewalPricingDescription"),
            errorText: errors.renewalPricingError,
            children: /* @__PURE__ */ jsx46("div", { "data-testid": "renewal-pricing-tiles", children: /* @__PURE__ */ jsx46(
              Tiles2,
              {
                columns: 3,
                value: req.renewalPricing ?? null,
                onChange: ({ detail }) => onPricingChange(detail.value),
                items: [
                  { value: "identical", label: t("renewalPricingNoUpliftLabel"), description: t("renewalPricingNoUpliftDescription") },
                  { value: "evolving", label: t("renewalPricingUpliftLabel"), description: t("renewalPricingUpliftDescription") },
                  { value: "none", label: t("renewalPricingNoRenewalLabel"), description: t("renewalPricingNoRenewalDescription") }
                ]
              }
            ) })
          }
        )
      }
    ),
    (req.renewalPricing === "identical" || req.renewalPricing === "evolving") && /* @__PURE__ */ jsx46(
      Container23,
      {
        header: /* @__PURE__ */ jsx46(
          Header26,
          {
            variant: "h2",
            info: openHelpPanel ? /* @__PURE__ */ jsx46(
              Link16,
              {
                variant: "info",
                ariaLabel: t("infoAriaLabel", { section: t("renewalConfigurationHeader") }),
                onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG12.CONFIG_RENEWAL_CONFIGURATION),
                children: t("info")
              }
            ) : void 0,
            children: t("renewalConfigurationHeader")
          }
        ),
        children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx46(
            FormField14,
            {
              stretch: true,
              label: t("renewalMaximumLabel"),
              description: t("renewalMaximumDescription"),
              errorText: errors.renewalMaximumError,
              children: /* @__PURE__ */ jsx46(
                RadioGroup3,
                {
                  ariaRequired: true,
                  "data-testid": "renewal-maximum-radiogroup",
                  value: req.renewalMaximumMode ?? null,
                  onChange: onMaximumModeChange,
                  items: [
                    { value: "definite", label: t("renewalMaximumDefiniteLabel"), description: t("renewalMaximumDefiniteDescription") },
                    { value: "indefinite", label: t("renewalMaximumUnlimitedLabel"), description: t("renewalMaximumUnlimitedDescription") }
                  ]
                }
              )
            }
          ),
          req.renewalMaximumMode === "definite" && /* @__PURE__ */ jsx46(FormField14, { label: t("renewalCountLabel"), description: t("renewalCountDescription"), errorText: errors.renewalMaxRenewalsError, children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "s", alignItems: "center", children: [
            /* @__PURE__ */ jsx46(
              PrecisionNumberInput,
              {
                dataTestId: "renewal-count-input",
                precision: 0,
                min: 1,
                ariaRequired: true,
                value: req.renewalMaxRenewals,
                onFocus: () => biClick("number-of-renewals"),
                onChange: onCountChange,
                invalid: !!errors.renewalMaxRenewalsError
              }
            ),
            /* @__PURE__ */ jsx46(Box24, { children: t("renewalCountSuffix", { count: req.renewalMaxRenewals ?? 0 }) })
          ] }) }),
          /* @__PURE__ */ jsx46(
            FormField14,
            {
              label: /* @__PURE__ */ jsxs41(Fragment11, { children: [
                t("renewalLockoutLabel"),
                " -",
                " ",
                /* @__PURE__ */ jsx46(Box24, { variant: "span", tagOverride: "i", display: "inline", children: t("optional") })
              ] }),
              description: t("renewalLockoutDescription"),
              constraintText: t("renewalLockoutConstraint"),
              errorText: errors.renewalLockoutError,
              children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "s", alignItems: "center", children: [
                /* @__PURE__ */ jsx46(
                  PrecisionNumberInput,
                  {
                    dataTestId: "renewal-lockout-input",
                    precision: 0,
                    min: 1,
                    ariaRequired: false,
                    value: req.renewalLockoutDays,
                    onFocus: () => biClick("lockout-date"),
                    onChange: onLockoutChange,
                    invalid: !!errors.renewalLockoutError
                  }
                ),
                /* @__PURE__ */ jsx46(Box24, { children: t("renewalLockoutSuffix", { count: req.renewalLockoutDays ?? 0 }) })
              ] })
            }
          ),
          req.renewalPricing === "evolving" && /* @__PURE__ */ jsx46(
            FormField14,
            {
              stretch: true,
              label: t("renewalUpliftTypeLabel"),
              description: t("renewalUpliftTypeDescription"),
              errorText: errors.renewalUpliftTypeError,
              children: /* @__PURE__ */ jsx46(
                RadioGroup3,
                {
                  ariaRequired: true,
                  "data-testid": "renewal-uplift-type-radiogroup",
                  value: req.renewalUpliftType ?? null,
                  onChange: onUpliftTypeChange,
                  items: [
                    { value: "fixed", label: t("renewalUpliftTypeFixedLabel"), description: t("renewalUpliftTypeFixedDescription") },
                    { value: "range", label: t("renewalUpliftTypeRangeLabel"), description: t("renewalUpliftTypeRangeDescription") }
                  ]
                }
              )
            }
          ),
          req.renewalUpliftType === "fixed" && /* @__PURE__ */ jsx46(
            FormField14,
            {
              label: t("renewalFixedPercentageLabel"),
              description: t("renewalFixedPercentageDescription"),
              constraintText: t("renewalFixedPercentageConstraint"),
              errorText: errors.renewalFixedPercentageError,
              children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "s", alignItems: "center", children: [
                /* @__PURE__ */ jsx46(
                  PrecisionNumberInput,
                  {
                    dataTestId: "renewal-fixed-percentage-input",
                    precision: 2,
                    min: 0,
                    max: 100,
                    commitOnBlurOrEnter: true,
                    value: percentToNumber(req.renewalFixedPercentage),
                    onFocus: () => biClick("price-uplift-percentage"),
                    onChange: onFixedChange,
                    invalid: !!errors.renewalFixedPercentageError
                  }
                ),
                /* @__PURE__ */ jsx46(Box24, { children: t("renewalPercentageSuffix") })
              ] })
            }
          ),
          req.renewalUpliftType === "range" && /* @__PURE__ */ jsxs41(Fragment11, { children: [
            /* @__PURE__ */ jsx46(
              FormField14,
              {
                label: t("renewalRangeLabel"),
                description: t("renewalRangeDescription"),
                constraintText: t("renewalRangeConstraint"),
                errorText: errors.renewalRangeError,
                children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "m", alignItems: "end", children: [
                  /* @__PURE__ */ jsxs41(SpaceBetween37, { size: "xxs", children: [
                    /* @__PURE__ */ jsx46(Box24, { variant: "awsui-key-label", children: t("renewalRangeMinLabel") }),
                    /* @__PURE__ */ jsx46(
                      PrecisionNumberInput,
                      {
                        dataTestId: "renewal-range-min-input",
                        ariaLabel: t("renewalRangeMinLabel"),
                        precision: 2,
                        min: 0,
                        max: 100,
                        commitOnBlurOrEnter: true,
                        ariaRequired: true,
                        value: percentToNumber(req.renewalRangeMin),
                        onFocus: () => biClick("uplift-range-min"),
                        onChange: onRangeMinChange,
                        invalid: !!errors.renewalRangeError
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx46(Box24, { padding: { bottom: "xxs" }, children: t("renewalRangeToLabel") }),
                  /* @__PURE__ */ jsxs41(SpaceBetween37, { size: "xxs", children: [
                    /* @__PURE__ */ jsx46(Box24, { variant: "awsui-key-label", children: t("renewalRangeMaxLabel") }),
                    /* @__PURE__ */ jsx46(
                      PrecisionNumberInput,
                      {
                        dataTestId: "renewal-range-max-input",
                        ariaLabel: t("renewalRangeMaxLabel"),
                        precision: 2,
                        min: 0,
                        max: 100,
                        commitOnBlurOrEnter: true,
                        ariaRequired: true,
                        value: percentToNumber(req.renewalRangeMax),
                        onFocus: () => biClick("uplift-range-max"),
                        onChange: onRangeMaxChange,
                        invalid: !!errors.renewalRangeError
                      }
                    )
                  ] })
                ] })
              }
            ),
            /* @__PURE__ */ jsx46(
              FormField14,
              {
                label: t("renewalAdjustmentDeadlineLabel"),
                description: t("renewalAdjustmentDeadlineDescription"),
                constraintText: t("renewalAdjustmentDeadlineConstraint"),
                errorText: errors.renewalAdjustmentDeadlineError,
                children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "s", alignItems: "center", children: [
                  /* @__PURE__ */ jsx46(
                    PrecisionNumberInput,
                    {
                      dataTestId: "renewal-adjustment-deadline-input",
                      precision: 0,
                      min: 1,
                      ariaRequired: true,
                      value: req.renewalAdjustmentDeadlineDays,
                      onFocus: () => biClick("adjustment-deadline"),
                      onChange: onAdjustmentDeadlineChange,
                      invalid: !!errors.renewalAdjustmentDeadlineError
                    }
                  ),
                  /* @__PURE__ */ jsx46(Box24, { children: t("renewalAdjustmentDeadlineSuffix", { count: req.renewalAdjustmentDeadlineDays ?? 0 }) })
                ] })
              }
            ),
            /* @__PURE__ */ jsx46(
              FormField14,
              {
                label: t("renewalDefaultLabel"),
                description: t("renewalDefaultDescription"),
                constraintText: t("renewalDefaultConstraint"),
                errorText: errors.renewalDefaultError,
                children: /* @__PURE__ */ jsxs41(SpaceBetween37, { direction: "horizontal", size: "s", alignItems: "center", children: [
                  /* @__PURE__ */ jsx46(
                    PrecisionNumberInput,
                    {
                      dataTestId: "renewal-default-input",
                      precision: 2,
                      min: 0,
                      max: 100,
                      commitOnBlurOrEnter: true,
                      value: percentToNumber(req.renewalRangeDefault),
                      onFocus: () => biClick("default-uplift-percentage"),
                      onChange: onDefaultChange,
                      invalid: !!errors.renewalDefaultError
                    }
                  ),
                  /* @__PURE__ */ jsx46(Box24, { children: t("renewalPercentageSuffix") })
                ] })
              }
            )
          ] })
        ] })
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/ReviewAndCreate/ReviewAndCreateStep.tsx
import * as React24 from "react";
import Container24 from "@amzn/awsui-components-react/polaris/container";
import Header28 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween40 from "@amzn/awsui-components-react/polaris/space-between";
import Box26 from "@amzn/awsui-components-react/polaris/box";
import KeyValuePairs7 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Alert13 from "@amzn/awsui-components-react/polaris/alert";
import Table5 from "@amzn/awsui-components-react/polaris/table";
import { ManagedTable as ManagedTable8 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";

// src/aipo/CreateConfig/components/ReviewAndCreate/DescriptionCellWithBadge.tsx
import SpaceBetween38 from "@amzn/awsui-components-react/polaris/space-between";
import Box25 from "@amzn/awsui-components-react/polaris/box";
import Icon10 from "@amzn/awsui-components-react/polaris/icon";
import { GuidanceStatus as GuidanceStatus8 } from "@amzn/awsmp-max-model";
import { jsx as jsx47, jsxs as jsxs42 } from "react/jsx-runtime";
var DescriptionCellWithBadge = ({ status, description, t }) => /* @__PURE__ */ jsxs42(SpaceBetween38, { size: "xxs", direction: "vertical", children: [
  status === GuidanceStatus8.Enhanced && /* @__PURE__ */ jsx47(Box25, { variant: "awsui-gen-ai-label", display: "inline", fontSize: "body-s", children: /* @__PURE__ */ jsxs42(SpaceBetween38, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
    /* @__PURE__ */ jsx47(Icon10, { name: "gen-ai", size: "small" }),
    t("guidanceGeneratedByAI")
  ] }) }),
  status === GuidanceStatus8.EnhancedEdited && /* @__PURE__ */ jsx47(Box25, { variant: "span", display: "inline", color: "text-body-secondary", fontSize: "body-s", children: /* @__PURE__ */ jsxs42(SpaceBetween38, { direction: "horizontal", size: "xxs", alignItems: "center", children: [
    /* @__PURE__ */ jsx47(Icon10, { name: "edit-gen-ai", size: "small" }),
    t("guidanceAssistedByAI")
  ] }) }),
  /* @__PURE__ */ jsx47("span", { children: description })
] });

// src/aipo/CreateConfig/components/ReviewAndCreate/reviewUtils.ts
import { GuidanceStatus as GuidanceStatus9 } from "@amzn/awsmp-max-model";
function getDiscountStrategyInfo(strategy) {
  return {
    perDimensionDiscounts: isPerDimensionStrategy(strategy),
    tcvDiscounts: isTcvStrategy(strategy),
    hasQualifications: isQualificationStrategy(strategy),
    perDimensionTiers: getExistingPerDimensionTiers(strategy),
    tcvDiscountRanges: getExistingTcvTiers(strategy),
    buyerProfileQualifiers: getQualifications(strategy)
  };
}
function getGuidanceEnhancementState(dimensions, proposedGuidance) {
  const totalCount = dimensions.length;
  const enhancedCount = dimensions.filter((dim) => {
    const status = proposedGuidance?.[dim.apiIdentifier]?.status;
    return status === GuidanceStatus9.Enhanced || status === GuidanceStatus9.EnhancedEdited;
  }).length;
  const notEnhancedCount = totalCount - enhancedCount;
  return {
    enhancedCount,
    totalCount,
    notEnhancedCount,
    allOriginal: enhancedCount === 0 && totalCount > 0,
    allEnhanced: enhancedCount === totalCount && totalCount > 0
  };
}

// src/aipo/CreateConfig/components/ReviewAndCreate/ReviewSection.tsx
import Header27 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween39 from "@amzn/awsui-components-react/polaris/space-between";
import Button18 from "@amzn/awsui-components-react/polaris/button";
import { jsx as jsx48, jsxs as jsxs43 } from "react/jsx-runtime";
var ReviewSection = ({
  title,
  editStepIndex,
  onEditStep,
  isDisabled,
  metricObject,
  logger,
  t,
  children,
  "data-testid": dataTestId
}) => /* @__PURE__ */ jsxs43(SpaceBetween39, { size: "l", children: [
  /* @__PURE__ */ jsx48(
    Header27,
    {
      variant: "h3",
      actions: /* @__PURE__ */ jsx48("span", { "data-testid": dataTestId ? `${dataTestId}-edit-button` : void 0, children: /* @__PURE__ */ jsx48(
        Button18,
        {
          variant: "normal",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "review-actions",
                ClickObj: metricObject,
                ClickAct: "edit"
              },
              value: 1,
              unit: "Count"
            });
            onEditStep(editStepIndex);
          },
          disabled: isDisabled,
          children: t("edit")
        }
      ) }),
      children: title
    }
  ),
  children
] });

// src/aipo/CreateConfig/components/ReviewAndCreate/ReviewAndCreateStep.tsx
import { jsx as jsx49, jsxs as jsxs44 } from "react/jsx-runtime";
var RENEWAL_EDIT_STEP_INDEX = 5;
var REVIEW_DASH = "\u2014";
var ReviewAndCreateStep = ({
  writeableArtifact,
  onEditStep,
  productDimensions = /* @__PURE__ */ new Map(),
  publicOfferDimensionKeys,
  productName,
  logger,
  t,
  renewalEnabled = false
}) => {
  const { artifact, isArtifactLocked } = writeableArtifact;
  useSubPageHit(logger, PAGE_CONTEXT3.SUB_PAGE_TYPES.REVIEW_AND_CREATE);
  const req = artifact.configurationRequest;
  const renewalPricingText = req.renewalPricing === "identical" ? t("renewalPricingNoUpliftLabel") : req.renewalPricing === "evolving" ? t("renewalPricingUpliftLabel") : req.renewalPricing === "none" ? t("renewalPricingNoRenewalLabel") : REVIEW_DASH;
  const renewalMaximumText = req.renewalMaximumMode === "indefinite" ? t("renewalMaximumUnlimitedLabel") : req.renewalMaximumMode === "definite" && req.renewalMaxRenewals !== void 0 ? String(req.renewalMaxRenewals) : REVIEW_DASH;
  const renewalUpliftTypeText = req.renewalUpliftType === "fixed" ? t("renewalUpliftTypeFixedLabel") : req.renewalUpliftType === "range" ? t("renewalUpliftTypeRangeLabel") : REVIEW_DASH;
  const renewalFixedText = req.renewalFixedPercentage ? `${req.renewalFixedPercentage}%` : REVIEW_DASH;
  const renewalRangeText = req.renewalRangeMin && req.renewalRangeMax ? `${req.renewalRangeMin}% \u2013 ${req.renewalRangeMax}%` : REVIEW_DASH;
  const renewalDefaultText = req.renewalRangeDefault ? `${req.renewalRangeDefault}%` : REVIEW_DASH;
  const renewalLockoutText = req.renewalLockoutDays !== void 0 ? t("renewalDaysValue", { count: req.renewalLockoutDays }) : REVIEW_DASH;
  const renewalAdjustmentDeadlineText = req.renewalAdjustmentDeadlineDays !== void 0 ? t("renewalDaysValue", { count: req.renewalAdjustmentDeadlineDays }) : REVIEW_DASH;
  const selectedDimensions = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
  const { perDimensionDiscounts, tcvDiscounts, perDimensionTiers, tcvDiscountRanges, buyerProfileQualifiers } = getDiscountStrategyInfo(
    artifact.configurationRequest.discountStrategy
  );
  const paymentScheduleAllowed = artifact.configurationRequest.paymentScheduleAllowed;
  const dimensionColumns = createDimensionColumns(t, productDimensions);
  const priceColumns = createPriceColumns(t, productDimensions);
  const perDimensionDiscountColumns = createPerDimensionDiscountColumns(t);
  const tcvDiscountColumns = createTcvDiscountColumns(t);
  const selectedProductDimensions = React24.useMemo(
    () => selectedDimensions.reduce((acc, dimRate) => {
      const dim = productDimensions.get(dimRate.dimensionKey);
      if (dim)
        acc.push(dim);
      return acc;
    }, []),
    [selectedDimensions, productDimensions]
  );
  const { publicDimensions, epoExclusiveDimensions } = React24.useMemo(
    () => splitDimensionsByVisibility(selectedProductDimensions, publicOfferDimensionKeys),
    [selectedProductDimensions, publicOfferDimensionKeys]
  );
  const proposedGuidance = artifact.proposedGuidance;
  const { allOriginal, allEnhanced, notEnhancedCount, totalCount } = getGuidanceEnhancementState(selectedProductDimensions, proposedGuidance);
  const baseDescriptionColumns = createDescriptionReviewColumns(t, proposedGuidance);
  const descriptionColumns = baseDescriptionColumns.map(
    (col) => col.id === "description" ? {
      ...col,
      cell: (item) => /* @__PURE__ */ jsx49(DescriptionCellWithBadge, { status: proposedGuidance?.[item.apiIdentifier]?.status, description: col.cell(item), t })
    } : col
  );
  return /* @__PURE__ */ jsxs44(SpaceBetween40, { direction: "vertical", size: "xl", children: [
    /* @__PURE__ */ jsxs44(
      ReviewSection,
      {
        title: t("reviewStepProductDimensions"),
        editStepIndex: 0,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "product-dimensions",
        logger,
        t,
        "data-testid": "review-product-dimensions",
        children: [
          /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("selectedProduct") }), "data-testid": "review-product-container", children: /* @__PURE__ */ jsx49(
            KeyValuePairs7,
            {
              columns: 1,
              items: [
                {
                  label: t("product"),
                  value: productName && artifact.configurationRequest.productId ? `${productName} (${artifact.configurationRequest.productId})` : artifact.configurationRequest.productId || t("noProductSelected")
                }
              ]
            }
          ) }),
          /* @__PURE__ */ jsx49(
            ManagedTable8,
            {
              preferenceKey: "review-dimensions-table",
              hidePreferences: true,
              columnDefinitions: dimensionColumns,
              items: selectedDimensions,
              selectionType: void 0,
              ariaLabels: {
                allItemsSelectionLabel: () => t("allDimensions"),
                itemSelectionLabel: (_, item) => item.dimensionKey
              },
              trackBy: "dimensionKey",
              empty: /* @__PURE__ */ jsxs44(Box26, { textAlign: "center", color: "inherit", children: [
                /* @__PURE__ */ jsx49("b", { children: t("noDimensionsSelected") }),
                /* @__PURE__ */ jsx49(Box26, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionsSelectedDescription") })
              ] }),
              header: /* @__PURE__ */ jsx49(Header28, { counter: `(${selectedDimensions.length})`, children: t("includedDimensions") })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs44(
      ReviewSection,
      {
        title: t("reviewStepDimensionDescriptions"),
        editStepIndex: 1,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "enhance-dimension-descriptions",
        logger,
        t,
        "data-testid": "review-dimension-descriptions",
        children: [
          allOriginal && /* @__PURE__ */ jsx49(Alert13, { type: "info", header: t("reviewNoDescriptionsEnhanced"), children: t("reviewNoDescriptionsEnhancedBody") }),
          !allOriginal && !allEnhanced && totalCount > 0 && /* @__PURE__ */ jsx49(Alert13, { type: "info", header: t("reviewSomeDescriptionsNotEnhanced"), children: t("reviewSomeDescriptionsNotEnhancedBody", { notEnhancedCount, totalCount }) }),
          /* @__PURE__ */ jsx49(Container24, { children: /* @__PURE__ */ jsxs44(SpaceBetween40, { size: "l", children: [
            /* @__PURE__ */ jsx49(
              Table5,
              {
                variant: "embedded",
                wrapLines: true,
                columnDefinitions: descriptionColumns,
                items: publicDimensions,
                header: /* @__PURE__ */ jsx49(Header28, { variant: "h2", counter: `(${publicDimensions.length})`, children: t("reviewPublicDimensionsHeader") }),
                empty: /* @__PURE__ */ jsx49(Box26, { textAlign: "center", color: "inherit", children: t("reviewNoPublicDimensions") })
              }
            ),
            /* @__PURE__ */ jsx49(
              Table5,
              {
                variant: "embedded",
                wrapLines: true,
                columnDefinitions: descriptionColumns,
                items: epoExclusiveDimensions,
                header: /* @__PURE__ */ jsx49(Header28, { variant: "h2", counter: `(${epoExclusiveDimensions.length})`, children: t("reviewEpoExclusiveDimensionsHeader") }),
                empty: /* @__PURE__ */ jsx49(Box26, { textAlign: "center", color: "inherit", children: t("guidanceNoEpoExclusiveDimensions") })
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx49(
      ReviewSection,
      {
        title: t("reviewStepPricingDetailsGated"),
        editStepIndex: 2,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "pricing",
        logger,
        t,
        "data-testid": "review-pricing-details",
        children: /* @__PURE__ */ jsx49(
          ManagedTable8,
          {
            "data-testid": "review-prices-table",
            preferenceKey: "review-prices-table",
            hidePreferences: true,
            columnDefinitions: priceColumns,
            items: selectedDimensions,
            selectionType: void 0,
            ariaLabels: {
              allItemsSelectionLabel: () => t("allDimensionPrices"),
              itemSelectionLabel: (_, item) => item.dimensionKey
            },
            trackBy: "dimensionKey",
            empty: /* @__PURE__ */ jsxs44(Box26, { textAlign: "center", color: "inherit", children: [
              /* @__PURE__ */ jsx49("b", { children: t("noDimensionPricesConfigured") }),
              /* @__PURE__ */ jsx49(Box26, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionPricesConfiguredDescription") })
            ] }),
            header: /* @__PURE__ */ jsx49(Header28, { counter: `(${selectedDimensions.length})`, children: t("specifiedDimensions") })
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs44(
      ReviewSection,
      {
        title: t("reviewStepOfferSettingsGated"),
        editStepIndex: 3,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "offer-settings",
        logger,
        t,
        "data-testid": "review-offer-settings",
        children: [
          /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("contractDetailsAndEulaHeader") }), "data-testid": "review-offer-settings-container", children: /* @__PURE__ */ jsx49(
            KeyValuePairs7,
            {
              columns: 2,
              items: [
                {
                  label: t("minimumOfferDurationInMonths"),
                  value: iso8601ToMonths(artifact.configurationRequest.minOfferDuration || "") || t("notSet")
                },
                {
                  label: t("maximumOfferDurationInMonths"),
                  value: iso8601ToMonths(artifact.configurationRequest.maxOfferDuration || "") || t("notSet")
                },
                {
                  label: t("endUserLicenseAgreement"),
                  value: artifact.configurationRequest.eulaType === "PUBLIC_OFFER_EULA" ? t("publicOfferEula") : t("standardContractForMarketplace")
                },
                {
                  label: t("offerExpirationDurationInDays"),
                  value: iso8601ToDays(artifact.configurationRequest.expiration || "") || t("notSet")
                },
                ...isFdaEnabled(artifact.configurationRequest.maxFutureStartDuration) ? [
                  {
                    label: t("fdaValidityRangeInDays"),
                    value: iso8601ToDays(artifact.configurationRequest.maxFutureStartDuration || "") || t("notSet")
                  }
                ] : []
              ]
            }
          ) }),
          /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("buyerPaymentSchedule") }), "data-testid": "review-buyer-installment-plan-container", children: /* @__PURE__ */ jsx49(
            KeyValuePairs7,
            {
              columns: 2,
              items: [
                {
                  label: t("paymentScheduleGateLabel"),
                  value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-payment-schedule-gate-value", children: paymentScheduleAllowed === true ? t("paymentScheduleAllowedLabel") : paymentScheduleAllowed === false ? t("paymentScheduleNotAllowedLabel") : t("notSet") })
                },
                ...paymentScheduleAllowed === true ? [
                  {
                    label: t("allowedPaymentFrequencies"),
                    value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-allowed-frequencies-value", children: (artifact.configurationRequest.allowedFrequencies?.length ?? 0) > 0 ? artifact.configurationRequest.allowedFrequencies.map((f) => frequencyLabel(f, t)).join(", ") : t("notSet") })
                  },
                  {
                    label: t("initialCustomPayment"),
                    value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-initial-custom-payment-value", children: artifact.configurationRequest.initialPaymentAllowed === true ? t("initialCustomPaymentAllowedLabel") : artifact.configurationRequest.initialPaymentAllowed === false ? t("initialCustomPaymentNotAllowedLabel") : t("notSet") })
                  }
                ] : []
              ]
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs44(
      ReviewSection,
      {
        title: t("reviewStepDiscountStrategyGated"),
        editStepIndex: 4,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "discount-strategy",
        logger,
        t,
        "data-testid": "review-discount-strategy",
        children: [
          /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("discountThresholds") }), "data-testid": "review-discount-thresholds-container", children: /* @__PURE__ */ jsxs44(SpaceBetween40, { direction: "vertical", size: "m", children: [
            /* @__PURE__ */ jsx49(
              KeyValuePairs7,
              {
                columns: 2,
                items: [
                  {
                    label: t("currency"),
                    value: t("currencyUsd")
                  },
                  {
                    label: t("maximumDiscountPercentage"),
                    value: artifact.configurationRequest.maxDiscountPercentage?.toString() || t("notSet")
                  }
                ]
              }
            ),
            /* @__PURE__ */ jsx49(
              KeyValuePairs7,
              {
                "data-testid": "review-tcv-keyvaluepairs",
                columns: 2,
                items: [
                  {
                    label: t("minimumTcvForExpressPrivateOffers"),
                    value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-min-tcv-value", children: artifact.configurationRequest.minTotalContractValue?.toString() || "0" })
                  },
                  {
                    label: t("maximumTcvForEpoFps"),
                    value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-max-tcv-value", children: artifact.configurationRequest.maxTotalContractValue !== void 0 && artifact.configurationRequest.maxTotalContractValue !== null ? artifact.configurationRequest.maxTotalContractValue.toString() : t("notSet") })
                  }
                ]
              }
            )
          ] }) }),
          perDimensionDiscounts && Object.keys(perDimensionTiers).length > 0 && /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("perDimensionDiscountStrategyHeader") }), children: /* @__PURE__ */ jsxs44(SpaceBetween40, { direction: "vertical", size: "xs", children: [
            /* @__PURE__ */ jsx49(Alert13, { type: "info", children: t("dimensionsWithoutRangesInfo") }),
            /* @__PURE__ */ jsx49(SpaceBetween40, { direction: "vertical", size: "l", children: Object.entries(perDimensionTiers).filter(([_dimensionKey, tiers]) => tiers && tiers.length > 0).map(([dimensionKey, tiers]) => {
              const matchingDimension = productDimensions.get(dimensionKey);
              const dimensionName = matchingDimension?.dimension || dimensionKey;
              return /* @__PURE__ */ jsx49(
                ManagedTable8,
                {
                  variant: "embedded",
                  preferenceKey: `review-per-dimension-${dimensionKey}-table`,
                  hidePreferences: true,
                  columnDefinitions: perDimensionDiscountColumns,
                  items: tiers,
                  selectionType: void 0,
                  ariaLabels: {
                    allItemsSelectionLabel: () => t("allDimensionDiscountRanges", { dimensionName }),
                    itemSelectionLabel: (_, item) => t("rangeMinToMax", { minValue: item.minValue, maxValue: item.maxValue })
                  },
                  trackBy: "minValue",
                  empty: /* @__PURE__ */ jsxs44(Box26, { textAlign: "center", color: "inherit", children: [
                    /* @__PURE__ */ jsx49("b", { children: t("noDiscountRangesConfigured") }),
                    /* @__PURE__ */ jsx49(Box26, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDiscountRangesForDimension") })
                  ] }),
                  header: /* @__PURE__ */ jsx49(Header28, { counter: `(${tiers.length})`, children: dimensionName })
                },
                dimensionKey
              );
            }) })
          ] }) }),
          tcvDiscounts && /* @__PURE__ */ jsx49(
            ManagedTable8,
            {
              preferenceKey: "review-tcv-discounts-table",
              hidePreferences: true,
              columnDefinitions: tcvDiscountColumns,
              items: tcvDiscountRanges,
              selectionType: void 0,
              ariaLabels: {
                allItemsSelectionLabel: () => t("allTcvDiscountRanges"),
                itemSelectionLabel: (_, item) => t("rangeMinToMax", { minValue: item.minValue, maxValue: item.maxValue })
              },
              trackBy: "minValue",
              empty: /* @__PURE__ */ jsxs44(Box26, { textAlign: "center", color: "inherit", children: [
                /* @__PURE__ */ jsx49("b", { children: t("noTcvDiscountRangesConfigured") }),
                /* @__PURE__ */ jsx49(Box26, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noTcvDiscountRangesDescription") })
              ] }),
              header: /* @__PURE__ */ jsx49(Header28, { counter: `(${tcvDiscountRanges.length})`, children: t("totalContractValueDiscountStrategyHeader") })
            }
          ),
          buyerProfileQualifiers && buyerProfileQualifiers.length > 0 && /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("buyerProfileDiscountStrategyHeader") }), "data-testid": "review-buyer-profile-container", children: /* @__PURE__ */ jsx49(SpaceBetween40, { direction: "vertical", size: "m", children: buyerProfileQualifiers.map((qualifier, index) => /* @__PURE__ */ jsxs44("div", { "data-testid": `review-buyer-profile-qualifier-${index}`, children: [
            /* @__PURE__ */ jsxs44(SpaceBetween40, { direction: "vertical", size: "s", children: [
              /* @__PURE__ */ jsxs44(Box26, { children: [
                /* @__PURE__ */ jsx49(Box26, { fontWeight: "bold", display: "inline", children: t("qualifyingTheme") }),
                /* @__PURE__ */ jsx49(Box26, { margin: { top: "xs" }, children: qualifier.qualifyingTheme })
              ] }),
              /* @__PURE__ */ jsxs44(Box26, { children: [
                /* @__PURE__ */ jsx49(Box26, { fontWeight: "bold", display: "inline", children: t("details") }),
                /* @__PURE__ */ jsx49(Box26, { margin: { top: "xs" }, children: qualifier.detail })
              ] }),
              qualifier._validationError && /* @__PURE__ */ jsx49(Alert13, { type: "error", children: qualifier._validationError })
            ] }),
            index < buyerProfileQualifiers.length - 1 && /* @__PURE__ */ jsx49(Box26, { margin: { top: "m", bottom: "m" }, children: /* @__PURE__ */ jsx49("hr", { style: { border: "none", borderTop: "1px solid #e9ebed", margin: 0 } }) })
          ] }, index)) }) })
        ]
      }
    ),
    renewalEnabled && /* @__PURE__ */ jsx49(
      ReviewSection,
      {
        title: t("renewalReviewSectionHeader"),
        editStepIndex: RENEWAL_EDIT_STEP_INDEX,
        onEditStep,
        isDisabled: isArtifactLocked,
        metricObject: "renewal-terms",
        logger,
        t,
        "data-testid": "review-renewal-terms",
        children: /* @__PURE__ */ jsx49(Container24, { header: /* @__PURE__ */ jsx49(Header28, { variant: "h3", children: t("renewalTermsHeader") }), "data-testid": "review-renewal-terms-container", children: /* @__PURE__ */ jsx49(
          KeyValuePairs7,
          {
            columns: 2,
            items: [
              // The primary "Renewal pricing" row ALWAYS renders — it is the
              // section anchor, so it is deliberately kept OUT of the empty-dash
              // filter below. If it were filtered and every optional row was also
              // absent, KeyValuePairs would render an empty container.
              { label: t("renewalPricingLabel"), value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-renewal-pricing-value", children: renewalPricingText }) },
              // Renewal maximum ALSO always renders when a renewal is configured —
              // like the View read-back, the most consequential renewal term must
              // never be silent, so it is kept OUT of the empty-dash filter (an
              // incomplete "definite" config must not read as if the field were unset).
              ...req.renewalPricing !== "none" ? [{ label: t("renewalMaximumLabel"), value: /* @__PURE__ */ jsx49("span", { "data-testid": "review-renewal-maximum-value", children: renewalMaximumText }) }] : [],
              ...[
                // Lockout (the renewal decision deadline) is optional, so it is
                // dash-filtered below; shown for both "No price uplift" (identical)
                // and "Price uplift" (evolving), omitted for "No renewal" (none).
                ...req.renewalPricing !== "none" ? [{ label: t("renewalLockoutReviewLabel"), text: renewalLockoutText, testid: "review-renewal-lockout-value" }] : [],
                // Price-uplift rows are exclusive to "Price uplift" (evolving).
                // Within it, the "fixed" mode shows a single percentage and the
                // "range" mode shows min/max, default, and adjustment deadline;
                // RenewalTermsStep clears the other mode's fields on switch.
                ...req.renewalPricing === "evolving" ? [
                  { label: t("renewalUpliftTypeLabel"), text: renewalUpliftTypeText, testid: "review-renewal-uplift-type-value" },
                  ...req.renewalUpliftType === "fixed" ? [{ label: t("renewalFixedPercentageLabel"), text: renewalFixedText, testid: "review-renewal-fixed-value" }] : req.renewalUpliftType === "range" ? [
                    { label: t("renewalRangeLabel"), text: renewalRangeText, testid: "review-renewal-range-value" },
                    { label: t("renewalDefaultLabel"), text: renewalDefaultText, testid: "review-renewal-default-value" },
                    {
                      label: t("renewalAdjustmentDeadlineLabel"),
                      text: renewalAdjustmentDeadlineText,
                      testid: "review-renewal-adjustment-deadline-value"
                    }
                  ] : []
                ] : []
              ].filter((item) => item.text !== REVIEW_DASH).map((item) => ({
                label: item.label,
                value: /* @__PURE__ */ jsx49("span", { "data-testid": item.testid, children: item.text })
              }))
            ]
          }
        ) })
      }
    )
  ] });
};

// src/aipo/CreateConfig/wizardSteps.tsx
import { Fragment as Fragment12, jsx as jsx50, jsxs as jsxs45 } from "react/jsx-runtime";
var WIZARD_STEP_IDS = {
  product: "product",
  guidance: "guidance",
  additionalInformation: "additional-information",
  offerSettings: "offer-settings",
  discount: "discount-strategy",
  renewal: "renewal-terms",
  review: "review"
};
var buildWizardSteps = ({
  writeableArtifact,
  availableProducts,
  configuredProductIds,
  productDimensions,
  publicOfferDimensionKeys,
  isLoadingProducts,
  isLoadingDimensions,
  hasPublicOffer,
  eulaDocumentType,
  isArtifactLocked,
  t,
  stepErrors,
  clearFieldError,
  setFieldError,
  setActiveStepIndex,
  layoutComponents,
  flashbarManager,
  logger,
  withAsyncErrors,
  turnState,
  sendMessage,
  renderMessages,
  projectId,
  renewalEnabled,
  isEditMode,
  didSeedEditNav,
  helpPanelsEnabled,
  openHelpPanel,
  wizardHeaderInfo
}) => {
  const { artifact } = writeableArtifact;
  return [
    {
      id: WIZARD_STEP_IDS.product,
      title: t("wizardStepSelectProduct"),
      description: t("wizardStepSelectProductDesc"),
      info: wizardHeaderInfo,
      content: /* @__PURE__ */ jsx50(
        SelectProductDimensionsStep,
        {
          availableProducts: availableProducts.filter((product) => !configuredProductIds.has(product.id)),
          writeableArtifact,
          errors: stepErrors,
          clearFieldError,
          productDimensions,
          isLoadingDimensions,
          isLoadingProducts,
          logger,
          t,
          isEditMode
        }
      )
    },
    {
      id: WIZARD_STEP_IDS.guidance,
      title: t("wizardStepEnhanceDescriptions"),
      description: t("wizardStepEnhanceDescriptionsDesc"),
      isOptional: true,
      content: /* @__PURE__ */ jsx50(
        GuidanceStep,
        {
          writeableArtifact,
          productDimensions,
          publicOfferDimensionKeys,
          layoutComponents,
          flashbarManager,
          logger,
          t,
          withAsyncErrors,
          turnState,
          errors: stepErrors,
          clearFieldError
        }
      )
    },
    {
      id: WIZARD_STEP_IDS.additionalInformation,
      title: t("wizardStepSetBasePrice"),
      description: t("wizardStepSetBasePriceDesc"),
      content: /* @__PURE__ */ jsx50(
        AdditionalInformationStep,
        {
          writeableArtifact,
          errors: stepErrors,
          clearFieldError,
          layoutComponents,
          productDimensions,
          logger,
          t
        }
      )
    },
    {
      id: WIZARD_STEP_IDS.offerSettings,
      title: t("wizardStepOfferSettings"),
      content: /* @__PURE__ */ jsx50(
        OfferSettingsStep,
        {
          writeableArtifact,
          errors: stepErrors,
          clearFieldError,
          setFieldError,
          hasPublicOffer,
          eulaDocumentType,
          logger,
          t,
          openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
        }
      )
    },
    {
      id: WIZARD_STEP_IDS.discount,
      title: t("wizardStepDiscountStrategy"),
      description: /* @__PURE__ */ jsxs45(Fragment12, { children: [
        t("wizardStepDiscountStrategyDesc"),
        " ",
        /* @__PURE__ */ jsx50(
          Link17,
          {
            external: true,
            href: "https://docs.aws.amazon.com/marketplace/latest/userguide/express-private-offers-configuration.html#express-private-offers-configuration-rate-cards",
            variant: "primary",
            children: t("learnMore")
          }
        )
      ] }),
      content: /* @__PURE__ */ jsx50(
        DiscountStrategyStep,
        {
          writeableArtifact,
          errors: stepErrors,
          clearFieldError,
          setFieldError,
          productDimensions,
          layoutComponents,
          sendMessage,
          renderMessages,
          isArtifactLocked,
          projectId,
          logger,
          t,
          openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
        }
      )
    },
    // Renewal terms is the last gated step before Review. When renewalEnabled is
    // false this spread is empty, so the steps array is byte-identical to today.
    ...renewalEnabled ? [
      {
        id: WIZARD_STEP_IDS.renewal,
        title: t("renewalStepTitle"),
        description: t("renewalStepDescription"),
        content: /* @__PURE__ */ jsx50(
          RenewalTermsStep,
          {
            writeableArtifact,
            errors: stepErrors,
            clearFieldError,
            setFieldError,
            logger,
            t,
            openHelpPanel: helpPanelsEnabled ? openHelpPanel : void 0
          }
        )
      }
    ] : [],
    {
      id: WIZARD_STEP_IDS.review,
      title: isEditMode ? t("wizardStepReviewSave") : t("wizardStepReviewCreate"),
      content: didSeedEditNav ? /* @__PURE__ */ jsx50(
        ReviewAndCreateStep,
        {
          writeableArtifact,
          onEditStep: setActiveStepIndex,
          productDimensions,
          publicOfferDimensionKeys,
          productName: availableProducts.find((p) => p.id === artifact.configurationRequest.productId)?.name,
          logger,
          t,
          renewalEnabled
        }
      ) : /* @__PURE__ */ jsx50("div", { "data-testid": "review-step-seed-placeholder" })
    }
  ];
};

// src/aipo/CreateConfig/hooks/useMarketplaceProducts.ts
import * as React25 from "react";
import { createMaxWrappedError as createMaxWrappedError4, NotFoundError } from "@amzn/awsmp-max-agentic-renderer-interface";
import { EpoCapiData as EpoCapiData3, EpoEntityState as EpoEntityState2, CapiProductData as CapiProductData2 } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/hooks/useMarketplaceProducts.utils.ts
function isThrottlingError(error) {
  if (typeof error !== "object" || error === null)
    return false;
  const name = error.name ?? "";
  if (name === "ThrottlingException" || name === "TooManyRequestsException")
    return true;
  const httpStatus = error.$metadata?.httpStatusCode;
  if (httpStatus === 429)
    return true;
  const message = error.message ?? "";
  return message.includes("Rate exceeded") || message.includes("Throttling");
}

// src/aipo/CreateConfig/hooks/useMarketplaceProducts.ts
var useMarketplaceProducts = ({
  productId,
  includeLimited,
  logger,
  withAsyncErrors
}) => {
  const [availableProducts, setAvailableProducts] = React25.useState([]);
  const [isLoadingMarketplaceProducts, setIsLoadingMarketplaceProducts] = React25.useState(true);
  const [isLoadingConfigurations, setIsLoadingConfigurations] = React25.useState(true);
  const isLoadingProducts = isLoadingMarketplaceProducts || isLoadingConfigurations;
  const [configuredProductIds, setConfiguredProductIds] = React25.useState(/* @__PURE__ */ new Set());
  const [batchEntityDetails, setBatchEntityDetails] = React25.useState({});
  const capiProductData = React25.useMemo(() => CapiProductData2.getInstance(logger), [logger]);
  React25.useEffect(() => {
    const fetchMarketplaceProducts = async () => {
      setIsLoadingMarketplaceProducts(true);
      const maxAttempts = 2;
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
          const { products, detailsByProductId } = await capiProductData.fetchEpoEligibleProducts(includeLimited);
          setBatchEntityDetails(detailsByProductId);
          setAvailableProducts([...products]);
          setIsLoadingMarketplaceProducts(false);
          return;
        } catch (error) {
          if (isAuthenticationError(error)) {
            setIsLoadingMarketplaceProducts(false);
            await epoSellerSignIn();
            return;
          }
          if (isThrottlingError(error) && attempt < maxAttempts) {
            await new Promise((r2) => setTimeout(r2, 2e3 * attempt));
            continue;
          }
          setIsLoadingMarketplaceProducts(false);
          throw isThrottlingError(error) ? createMaxWrappedError4(error, { isFatal: false }) : createMaxWrappedError4(error, { isNotFound: true, showFlashbar: true });
        }
      }
    };
    withAsyncErrors(fetchMarketplaceProducts());
  }, [withAsyncErrors, capiProductData, includeLimited]);
  React25.useEffect(() => {
    const fetchEpoConfigurations = async () => {
      const maxAttempts = 2;
      try {
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            const epoData = EpoCapiData3.getInstance(logger);
            const listResult = await epoData.listConfigs({ state: EpoEntityState2.Active });
            const entityIds = (listResult.EntitySummaryList ?? []).map((e) => e.EntityId).filter((id) => id != null);
            const detailsMap = entityIds.length > 0 ? await epoData.batchDescribeConfigs(entityIds) : {};
            const configuredIds = new Set(Object.values(detailsMap).map((doc) => doc.ProductId));
            setConfiguredProductIds(configuredIds);
            return;
          } catch (error) {
            if (isAuthenticationError(error)) {
              await epoSellerSignIn();
              return;
            }
            if (isThrottlingError(error) && attempt < maxAttempts) {
              await new Promise((r2) => setTimeout(r2, 2e3 * attempt));
              continue;
            }
            throw isThrottlingError(error) ? createMaxWrappedError4(error, { isFatal: false }) : createMaxWrappedError4(error, { isNotFound: true, showFlashbar: true });
          }
        }
      } finally {
        setIsLoadingConfigurations(false);
      }
    };
    withAsyncErrors(fetchEpoConfigurations());
  }, [withAsyncErrors, logger]);
  React25.useEffect(() => {
    if (!productId)
      return;
    if (isLoadingProducts)
      return;
    const availableProductIds = availableProducts.filter((product) => !configuredProductIds.has(product.id)).map((product) => product.id);
    if (!availableProductIds.includes(productId)) {
      throw new NotFoundError(`Product ${productId} not found in available products`);
    }
  }, [productId, availableProducts, configuredProductIds, isLoadingProducts]);
  return {
    availableProducts,
    isLoadingProducts,
    configuredProductIds,
    batchEntityDetails
  };
};

// src/aipo/CreateConfig/hooks/useProductDimensions.ts
import * as React26 from "react";
import { NotFoundError as NotFoundError2 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { CapiProductData as CapiProductData3 } from "@amzn/awsmp-max-data";
var useProductDimensions = ({ selectedProductId, batchEntityDetails }) => {
  const [productDimensions, setProductDimensions] = React26.useState(/* @__PURE__ */ new Map());
  const [isLoadingDimensions, setIsLoadingDimensions] = React26.useState(false);
  React26.useEffect(() => {
    if (!selectedProductId || selectedProductId.length === 0)
      return;
    if (Object.keys(batchEntityDetails).length === 0)
      return;
    try {
      setIsLoadingDimensions(true);
      const doc = batchEntityDetails[selectedProductId];
      if (!doc) {
        throw new Error(`No CAPI details document for selected productId: ${selectedProductId}`);
      }
      const dimensions = CapiProductData3.extractEntitledDimensions(doc);
      setProductDimensions(dimensions);
    } catch (error) {
      setProductDimensions(/* @__PURE__ */ new Map());
      throw new NotFoundError2(error);
    } finally {
      setIsLoadingDimensions(false);
    }
  }, [selectedProductId, batchEntityDetails]);
  return { productDimensions, isLoadingDimensions };
};

// src/aipo/CreateConfig/hooks/useWizardNavigation.ts
import * as React27 from "react";

// src/aipo/CreateConfig/services/capiPathToWizardField.ts
var productField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.product,
  fieldKey,
  valueShape: "string"
});
var additionalInformationField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.additionalInformation,
  fieldKey,
  valueShape: "string"
});
var offerSettingsField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.offerSettings,
  fieldKey,
  valueShape: "string"
});
var discountStringField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.discount,
  fieldKey,
  valueShape: "string"
});
var discountValidationErrorField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.discount,
  fieldKey,
  valueShape: "validationError"
});
var renewalField = (fieldKey) => ({
  kind: "field",
  stepId: WIZARD_STEP_IDS.renewal,
  fieldKey,
  valueShape: "string"
});
var CAPI_PATH_RULES = [
  {
    capiPathPrefix: "OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates[",
    ref: additionalInformationField("missingPricesError")
  },
  {
    capiPathPrefix: "OfferRates.ConfigurableUpfrontDimensionRates.DimensionRates",
    ref: productField("dimensionsError")
  },
  // Configurable-upfront `Duration` is a fixed backend value (P1M) the seller
  // cannot edit, so no field owns it — route to the dimension step.
  {
    capiPathPrefix: "OfferRates.ConfigurableUpfrontDimensionRates.Duration",
    ref: { kind: "step", stepId: WIZARD_STEP_IDS.product }
  },
  { capiPathPrefix: "OfferSettings.MinOfferDuration", ref: offerSettingsField("minOfferDurationError") },
  { capiPathPrefix: "OfferSettings.MaxOfferDuration", ref: offerSettingsField("maxOfferDurationError") },
  { capiPathPrefix: "OfferSettings.Expiration", ref: offerSettingsField("expirationError") },
  { capiPathPrefix: "OfferSettings.MaxFutureStartDuration", ref: offerSettingsField("maxFutureStartDurationError") },
  { capiPathPrefix: "Guardrails.MaxTotalContractValue", ref: discountStringField("maxTcvError") },
  { capiPathPrefix: "Guardrails.MaxDiscountPercentage", ref: discountStringField("maxDiscountError") },
  // DiscountStrategyStep renders `discountStrategyError` as a `ValidationError`
  // object (`.header`/`.body`), so it MUST use the validation-error helper — a
  // plain string here renders an empty alert. `tsc` enforces the pairing:
  // `discountValidationErrorField` accepts only object-valued keys.
  { capiPathPrefix: "DiscountRules", ref: discountValidationErrorField("discountStrategyError") },
  { capiPathPrefix: "RenewalTerm.LockoutPeriod", ref: renewalField("renewalLockoutError") },
  { capiPathPrefix: "RenewalTerm.AdjustmentDeadline", ref: renewalField("renewalAdjustmentDeadlineError") }
];
var capiPathToWizardField = (capiPath) => {
  const rule = CAPI_PATH_RULES.find((candidate) => capiPath.startsWith(candidate.capiPathPrefix));
  return rule?.ref ?? { kind: "unmapped" };
};
var FIELD_KEY_STEP_IDS = new Map(
  CAPI_PATH_RULES.flatMap((rule) => rule.ref.kind === "field" ? [[rule.ref.fieldKey, rule.ref.stepId]] : [])
);
var fieldKeyToStepId = (fieldKey) => FIELD_KEY_STEP_IDS.get(fieldKey);
var GATE_OWNED_FIELD_KEYS = Array.from(
  new Set(CAPI_PATH_RULES.flatMap((rule) => rule.ref.kind === "field" ? [rule.ref.fieldKey] : []))
);

// src/aipo/CreateConfig/hooks/useWizardNavigation.ts
var useWizardNavigation = ({ stepValidations, initialStepIndex = 0 }) => {
  const [activeStepIndex, setActiveStepIndex] = React27.useState(initialStepIndex);
  const [stepErrors, setStepErrors] = React27.useState({});
  const clearStepErrors = React27.useCallback(() => {
    setStepErrors({});
  }, []);
  const clearFieldError = React27.useCallback((errorKey) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[errorKey];
      return newErrors;
    });
  }, []);
  const clearFieldErrorKeys = React27.useCallback((errorKeys) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      for (const errorKey of errorKeys) {
        delete newErrors[errorKey];
      }
      return newErrors;
    });
  }, []);
  const setFieldError = React27.useCallback((field, error) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  }, []);
  const setFieldErrors = React27.useCallback((fieldErrors) => {
    setStepErrors((prev) => ({ ...prev, ...fieldErrors }));
  }, []);
  const onNavigate = React27.useCallback(
    (detail) => {
      const { requestedStepIndex, reason } = detail;
      if (reason === "next" || reason === "step" && requestedStepIndex > activeStepIndex) {
        const startStep = activeStepIndex;
        const endStep = Math.min(requestedStepIndex - 1, stepValidations.length - 1);
        for (let stepIndex = startStep; stepIndex <= endStep; stepIndex++) {
          const validation = stepValidations[stepIndex]?.();
          if (stepIndex === activeStepIndex) {
            const constraintErrors = Object.entries(stepErrors).filter(([key, value]) => {
              if (value === void 0 || value === null || value === "") {
                return false;
              }
              return fieldKeyToStepId(key) === void 0;
            });
            if (constraintErrors.length > 0) {
              return;
            }
          }
          if (validation && !validation.isValid) {
            setStepErrors(validation.errorProps);
            setActiveStepIndex(stepIndex);
            return;
          }
        }
        clearStepErrors();
      } else {
        clearStepErrors();
      }
      setActiveStepIndex(requestedStepIndex);
    },
    [activeStepIndex, stepValidations, stepErrors, clearStepErrors]
  );
  return {
    activeStepIndex,
    setActiveStepIndex,
    stepErrors,
    onNavigate,
    clearStepErrors,
    clearFieldError,
    clearFieldErrorKeys,
    setFieldError,
    setFieldErrors
  };
};

// src/aipo/CreateConfig/hooks/useCreateConfiguration.ts
import * as React28 from "react";
import { useNavigate as useNavigate3 } from "react-router-dom";
import { createMaxWrappedError as createMaxWrappedError5 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { MaxTokenData as MaxTokenData2, GrantAction as GrantAction2, EpoCapiData as EpoCapiData4 } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/services/createConfigTransformers.ts
import { CreateEpoConfigInputRuntype, QualifyingTheme as QualifyingTheme2 } from "@amzn/awsmp-max-data";
var toCapiCreateInput = (artifact, publicOfferId, hasUsageBasedPricing, logger, renewalEnabled = false) => {
  const req = artifact.configurationRequest;
  if (hasUsageBasedPricing && !publicOfferId) {
    throw new Error(
      `Cannot build create-config input for ${req.productId}: usage-based pricing requires a resolved public OfferId, but none was available (public-offer resolution incomplete).`
    );
  }
  const renewalTerm = renewalEnabled ? buildRenewalTerm(req) : void 0;
  const input = {
    Name: req.productId,
    ProductId: req.productId,
    CurrencyCode: req.currencyCode,
    OfferRates: {
      ConfigurableUpfrontDimensionRates: {
        Duration: "P1M",
        DimensionRates: (req.configurableUpfrontDimensionRates?.dimensionRates ?? []).map((dr) => ({
          DimensionKey: dr.dimensionKey,
          Price: dr.price
        }))
      },
      ...hasUsageBasedPricing && publicOfferId ? { UsageBasedDimensionRates: { OfferId: publicOfferId } } : {}
    },
    Guardrails: {
      MaxDiscountPercentage: req.maxDiscountPercentage,
      MaxTotalContractValue: req.maxTotalContractValue,
      MinTotalContractValue: req.minTotalContractValue ?? 0
    },
    OfferSettings: {
      Eula: buildEula(req.eulaType, publicOfferId),
      MinOfferDuration: req.minOfferDuration,
      MaxOfferDuration: req.maxOfferDuration,
      MaxFutureStartDuration: req.maxFutureStartDuration,
      Expiration: req.expiration
    },
    ...req.allowedFrequencies !== void 0 && req.initialPaymentAllowed !== void 0 ? {
      PaymentSchedule: {
        AllowedFrequencies: req.allowedFrequencies,
        InitialPaymentAllowed: req.initialPaymentAllowed
      }
    } : {},
    ...renewalTerm ? { RenewalTerm: renewalTerm } : {},
    ...req.discountStrategy ? {
      DiscountRules: buildDiscountRules(req.discountStrategy, logger)
    } : {}
  };
  return CreateEpoConfigInputRuntype.check(input);
};
var buildEula = (eulaType, resolvedOfferId) => {
  if (eulaType === "PUBLIC_OFFER_EULA" && resolvedOfferId) {
    return { Type: "OFFER_EULA", OfferId: resolvedOfferId };
  }
  return { Type: "STANDARD_CONTRACT_MARKETPLACE" };
};
var toCapiQualifyingTheme = (theme, logger) => {
  const mapped = QUALIFYING_THEME_TO_CAPI[theme];
  if (!mapped) {
    logger?.warn(`Unknown qualifying theme: "${theme}", falling back to OTHER`);
    return QualifyingTheme2.Other;
  }
  return mapped;
};
var buildDiscountRules = (strategy, logger) => {
  const rules = {};
  if (isQualificationStrategy(strategy)) {
    rules.Qualification = {
      Questions: strategy.qualifications.map((qual) => ({
        QualifyingTheme: toCapiQualifyingTheme(qual.qualifyingTheme, logger),
        Instructions: qual.detail,
        BuyerQuestions: (qual.buyerQuestions ?? []).map((bq) => ({
          Question: bq.question,
          ExampleResponse: bq.exampleResponse,
          ResponseType: "FREE_TEXT"
        }))
      }))
    };
  }
  if (isPerDimensionStrategy(strategy)) {
    const nonEmptyEntries = Object.entries(strategy.perDimensionTcvTiers).filter(([_, tiers]) => tiers.length > 0);
    if (nonEmptyEntries.length > 0) {
      rules.DimensionQuantity = {
        PerDimensionTiers: Object.fromEntries(nonEmptyEntries.map(([dimensionKey, tiers]) => [dimensionKey, mapTiersToCapiFormat(tiers)]))
      };
    }
  }
  if (isTcvStrategy(strategy)) {
    rules.TotalContractValue = {
      Tiers: mapTiersToCapiFormat(strategy.totalTcvTiers)
    };
  }
  return rules;
};

// src/aipo/CreateConfig/services/validatePreSubmit.ts
var import_validation11 = __toESM(require_validation2(), 1);
var import_schemas = __toESM(require_schemas3(), 1);

// src/aipo/CreateConfig/services/toValidatorInput.ts
var CONFIGURABLE_UPFRONT_DURATION = "P1M";
var narrowConfigurableUpfrontDuration = (duration) => {
  if (duration !== CONFIGURABLE_UPFRONT_DURATION) {
    throw new Error(`ConfigurableUpfront Duration must be ${CONFIGURABLE_UPFRONT_DURATION}, received: ${duration}`);
  }
  return CONFIGURABLE_UPFRONT_DURATION;
};
var toValidatorInput = (input) => ({
  ...input,
  OfferRates: {
    ...input.OfferRates,
    ConfigurableUpfrontDimensionRates: {
      ...input.OfferRates.ConfigurableUpfrontDimensionRates,
      Duration: narrowConfigurableUpfrontDuration(input.OfferRates.ConfigurableUpfrontDimensionRates.Duration)
    }
  }
});

// src/aipo/CreateConfig/services/validatePreSubmit.ts
var RENEWAL_TERM_PATH_PREFIX = "RenewalTerm";
var renewalCrossFacetField = (name, value) => ({
  name,
  value,
  capiPath: `${RENEWAL_TERM_PATH_PREFIX}.${name}`
});
var renewalCrossFacetFields = (renewal) => [
  renewalCrossFacetField("LockoutPeriod", renewal.LockoutPeriod),
  renewalCrossFacetField("AdjustmentDeadline", renewal.AdjustmentDeadline)
];
var renewalCrossFacetErrors = (input) => {
  const renewal = input.RenewalTerm;
  if (renewal === void 0) {
    return [];
  }
  const maxOfferDuration = input.OfferSettings.MaxOfferDuration;
  if (!import_validation11.DurationValidator.isSupported(maxOfferDuration)) {
    return [];
  }
  const maxOfferDurationMinDays = import_validation11.DurationValidator.minPossibleCalendarDays(maxOfferDuration);
  return renewalCrossFacetFields(renewal).flatMap(({ name, value, capiPath }) => {
    const message = (0, import_validation11.checkRenewalDurationShorterThanMaxOffer)(value, name, maxOfferDuration, maxOfferDurationMinDays);
    return message === void 0 ? [] : [{ capiPath, message }];
  });
};
var renewalAdjustmentDeadlineFloorErrors = (input) => {
  const renewal = input.RenewalTerm;
  if (renewal === void 0 || renewal.AdjustmentDeadline === void 0) {
    return [];
  }
  const adjustmentDeadlineDays = isoDurationToDays(renewal.AdjustmentDeadline);
  if (adjustmentDeadlineDays === null) {
    return [];
  }
  const lockoutDays = renewal.LockoutPeriod === void 0 ? 0 : isoDurationToDays(renewal.LockoutPeriod) ?? 0;
  if (adjustmentDeadlineDays >= lockoutDays + import_schemas.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT) {
    return [];
  }
  return [
    {
      capiPath: `${RENEWAL_TERM_PATH_PREFIX}.AdjustmentDeadline`,
      message: `AdjustmentDeadline (${renewal.AdjustmentDeadline}) must be at least ${import_schemas.ADJUSTMENT_DEADLINE_MIN_DAYS_AFTER_LOCKOUT} day(s) after LockoutPeriod`
    }
  ];
};
var validatePreSubmit = (input) => [
  ...(0, import_validation11.validateCreateEpoConfigInput)(toValidatorInput(input)).map(({ field, message }) => ({ capiPath: field, message })),
  ...renewalCrossFacetErrors(input),
  ...renewalAdjustmentDeadlineFloorErrors(input)
];

// src/aipo/CreateConfig/services/planPreSubmitErrors.ts
var FIELD_MESSAGE_SEPARATOR = "\n";
var planPreSubmitErrors = (errors, steps) => {
  if (errors.length === 0) {
    return { ok: true };
  }
  const fieldMessages = /* @__PURE__ */ new Map();
  const unmapped = [];
  const failingStepIds = /* @__PURE__ */ new Set();
  for (const error of errors) {
    const ref = capiPathToWizardField(error.capiPath);
    switch (ref.kind) {
      case "field": {
        const existing = fieldMessages.get(ref.fieldKey);
        if (existing) {
          existing.messages.push(error.message);
        } else {
          fieldMessages.set(ref.fieldKey, { valueShape: ref.valueShape, messages: [error.message] });
        }
        failingStepIds.add(ref.stepId);
        break;
      }
      case "step":
        failingStepIds.add(ref.stepId);
        unmapped.push(error);
        break;
      case "unmapped":
        unmapped.push(error);
        break;
      default: {
        const _exhaustive = ref;
        throw new Error(`unhandled wizard field ref: ${JSON.stringify(_exhaustive)}`);
      }
    }
  }
  const fieldErrors = {};
  for (const [fieldKey, { valueShape, messages }] of fieldMessages) {
    const joined = messages.join(FIELD_MESSAGE_SEPARATOR);
    fieldErrors[fieldKey] = valueShape === "validationError" ? { body: joined } : joined;
  }
  const earliestFailingIndex = steps.findIndex((step) => failingStepIds.has(step.id));
  const firstFailingStepIndex = earliestFailingIndex === -1 ? null : earliestFailingIndex;
  return { ok: false, firstFailingStepIndex, fieldErrors, unmapped };
};

// src/aipo/CreateConfig/services/runPreSubmitGate.ts
var UNMAPPED_FLASH_ID_PREFIX = "EPO_PRESUBMIT_UNMAPPED_";
var GATE_BLOCKED_METRIC_NAME = "EpoPreSubmitGateBlocked";
var surfaceUnmapped = (error, flashbarManager, t) => {
  const id = `${UNMAPPED_FLASH_ID_PREFIX}${error.capiPath}`;
  flashbarManager.removeItem(id);
  flashbarManager.addItem({
    id,
    type: "error",
    header: t("errorValidationOccurred"),
    content: error.message,
    dismissible: true
  });
  return id;
};
var runPreSubmitGate = (input, gate) => {
  const errors = validatePreSubmit(input);
  const outcome = planPreSubmitErrors(errors, gate.steps);
  gate.clearFieldErrorKeys(GATE_OWNED_FIELD_KEYS);
  for (const staleId of gate.unmappedFlashIdsRef.current) {
    gate.flashbarManager.removeItem(staleId);
  }
  gate.unmappedFlashIdsRef.current = [];
  if (outcome.ok) {
    return false;
  }
  gate.setFieldErrors(outcome.fieldErrors);
  gate.unmappedFlashIdsRef.current = outcome.unmapped.map((error) => surfaceUnmapped(error, gate.flashbarManager, gate.t));
  gate.setActiveStepIndex(outcome.firstFailingStepIndex ?? gate.activeStepIndex);
  gate.logger.warn("EPO pre-submit gate blocked submit", {
    capiPaths: errors.map((error) => error.capiPath),
    unmappedCount: outcome.unmapped.length,
    firstFailingStepIndex: outcome.firstFailingStepIndex
  });
  gate.logger.biMetric({ metricName: GATE_BLOCKED_METRIC_NAME, value: 1, unit: "Count" });
  return true;
};

// src/aipo/CreateConfig/services/proposedGuidanceUpdateDimensions.ts
import { GuidanceStatus as GuidanceStatus10 } from "@amzn/awsmp-max-model";
var QUALIFYING_STATUSES = /* @__PURE__ */ new Set([GuidanceStatus10.Enhanced, GuidanceStatus10.EnhancedEdited, GuidanceStatus10.UserEdited]);
var buildUpdateDimensionsEntries = (proposedGuidance, productDimensions) => Object.entries(proposedGuidance).flatMap(([dimensionKey, guidance]) => {
  if (guidance.status === void 0 || !QUALIFYING_STATUSES.has(guidance.status))
    return [];
  if (guidance.content.trim().length === 0)
    return [];
  const dim = productDimensions.get(dimensionKey);
  if (!dim) {
    throw new Error(`proposedGuidance key "${dimensionKey}" has no matching product dimension`);
  }
  return [
    {
      Key: dimensionKey,
      Types: [...dim.types],
      Description: guidance.content
    }
  ];
});

// src/aipo/CreateConfig/hooks/useCreateConfiguration.ts
var buildSuccessRedirectUrl = (productId, productName) => `${EPO_ROUTES.LIST}?${QUERY_PARAMS.CREATED}=true&${QUERY_PARAMS.PRODUCT_ID}=${encodeURIComponent(productId)}&${QUERY_PARAMS.PRODUCT_NAME}=${encodeURIComponent(productName)}`;
var navigateToSuccess = (navigate, availableProducts, productId) => {
  const selectedProduct = availableProducts.find((p) => p.id === productId);
  navigate(buildSuccessRedirectUrl(productId, selectedProduct?.name || productId));
};
var handleQualificationQuestionGeneration = async (artifact, writeableArtifact) => {
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  if (!discountStrategy || !isQualificationStrategy(discountStrategy)) {
    return { shouldReturn: false };
  }
  const qualifications = discountStrategy.qualifications || [];
  if (qualifications.some((qual) => qual._validationError)) {
    return { shouldReturn: true };
  }
  const needsQuestionGeneration = qualifications.some((qual) => !qual.buyerQuestions || qual.buyerQuestions.length === 0);
  if (!needsQuestionGeneration) {
    return { shouldReturn: false };
  }
  const { hasValidationErrors, updatedArtifact } = await generateAndUpdateBuyerProfileQuestions(writeableArtifact);
  if (hasValidationErrors) {
    return { shouldReturn: true };
  }
  return { shouldReturn: false, updatedArtifact };
};
var submitViaCapi = async (artifact, writeableArtifact, availableProducts, logger, navigate, productDimensions, preSubmitGate, resolvedOfferId, hasUsageBasedPricing, projectId, renewalEnabled) => {
  if (runPreSubmitGate(toCapiCreateInput(artifact, resolvedOfferId, hasUsageBasedPricing, logger, renewalEnabled), preSubmitGate))
    return;
  if (projectId) {
    const tokens = await MaxTokenData2.getInstance(logger).generateTokens([{ action: GrantAction2.CreateExpressPrivateOfferConfiguration }]);
    await writeableArtifact.shareProject(projectId, tokens[0]);
  }
  const { shouldReturn, updatedArtifact } = await handleQualificationQuestionGeneration(artifact, writeableArtifact);
  if (shouldReturn)
    return;
  const submitArtifact = updatedArtifact ?? artifact;
  const productId = submitArtifact.configurationRequest.productId;
  if (!productId)
    throw new Error("Cannot submit EPO config without a productId");
  const capiInput = toCapiCreateInput(submitArtifact, resolvedOfferId, hasUsageBasedPricing, logger, renewalEnabled);
  const epoData = EpoCapiData4.getInstance(logger);
  const entries = buildUpdateDimensionsEntries(submitArtifact.proposedGuidance ?? {}, productDimensions);
  const changeSetId = await (entries.length > 0 ? epoData.createConfigWithDimensionUpdates(productId, entries, capiInput) : epoData.createConfig(capiInput));
  try {
    await epoData.waitForPendingChangeSet(changeSetId);
  } catch (error) {
    logger.warn("Failed to poll for pending changeset, redirecting anyway", { productId, projectId, changeSetId, error: String(error) });
  }
  navigateToSuccess(navigate, availableProducts, productId);
};
var useCreateConfiguration = ({
  writeableArtifact,
  availableProducts,
  logger,
  withAsyncErrors,
  resolvedOfferId,
  hasUsageBasedPricing,
  projectId,
  productDimensions,
  renewalEnabled,
  preSubmitGate
}) => {
  const navigate = useNavigate3();
  const [isSubmitting, setIsSubmitting] = React28.useState(false);
  const { artifact } = writeableArtifact;
  const handleSubmit = React28.useCallback(() => {
    if (isSubmitting)
      return;
    withAsyncErrors(
      (async () => {
        setIsSubmitting(true);
        try {
          await submitViaCapi(
            artifact,
            writeableArtifact,
            availableProducts,
            logger,
            navigate,
            productDimensions,
            preSubmitGate,
            resolvedOfferId,
            hasUsageBasedPricing,
            projectId,
            renewalEnabled
          );
        } catch (error) {
          if (isAuthenticationError(error)) {
            await epoSellerSignIn();
            return;
          }
          throw createMaxWrappedError5(error, { isFatal: false });
        } finally {
          setIsSubmitting(false);
        }
      })()
    );
  }, [
    isSubmitting,
    artifact,
    writeableArtifact,
    availableProducts,
    logger,
    withAsyncErrors,
    navigate,
    resolvedOfferId,
    hasUsageBasedPricing,
    projectId,
    productDimensions,
    renewalEnabled,
    preSubmitGate
  ]);
  return { handleSubmit, isSubmitting };
};

// src/aipo/CreateConfig/hooks/useEditConfiguration.ts
import * as React29 from "react";
import { useNavigate as useNavigate4 } from "react-router-dom";
import {
  createMaxWrappedError as createMaxWrappedError6
} from "@amzn/awsmp-max-agentic-renderer-interface";
import { EpoCapiData as EpoCapiData5 } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/services/editConfigTransformers.ts
import { EulaType as CapiEulaType } from "@amzn/awsmp-max-data";
import { EpocEulaType as EpocEulaType2 } from "@amzn/awsmp-max-model";
var canonical = (value) => {
  const normalize = (v) => {
    if (v === null || typeof v !== "object")
      return v;
    if (Array.isArray(v))
      return v.map(normalize);
    return Object.keys(v).filter((k) => v[k] !== void 0).sort().reduce((acc, k) => {
      acc[k] = normalize(v[k]);
      return acc;
    }, {});
  };
  return JSON.stringify(normalize(value));
};
var isEqual = (a, b) => canonical(a) === canonical(b);
var sortOfferRatesForCompare = (offerRates) => ({
  ...offerRates,
  ConfigurableUpfrontDimensionRates: {
    ...offerRates.ConfigurableUpfrontDimensionRates,
    DimensionRates: [...offerRates.ConfigurableUpfrontDimensionRates.DimensionRates].sort((a, b) => a.DimensionKey.localeCompare(b.DimensionKey))
  }
});
var normalizeDiscountRules = (rules) => rules && Object.keys(rules).length === 0 ? void 0 : rules;
var OFFER_EULA = CapiEulaType.OfferEula;
var PUBLIC_OFFER_EULA = EpocEulaType2.PUBLIC_OFFER_EULA;
var reconcileOfferDerivedFields = (built, intentEulaType, original) => {
  let result = built;
  if (intentEulaType === PUBLIC_OFFER_EULA && original.OfferSettings.Eula.Type === OFFER_EULA) {
    result = { ...result, OfferSettings: { ...result.OfferSettings, Eula: original.OfferSettings.Eula } };
  }
  if (!result.OfferRates.UsageBasedDimensionRates && original.OfferRates.UsageBasedDimensionRates) {
    result = {
      ...result,
      OfferRates: { ...result.OfferRates, UsageBasedDimensionRates: original.OfferRates.UsageBasedDimensionRates }
    };
  }
  return result;
};
var reconcilePaymentSchedule = (built, intent, original) => {
  const sellerRemovedFps = intent.allowedFrequencies !== void 0 || intent.paymentScheduleAllowed === false;
  if (!built.PaymentSchedule && original.PaymentSchedule && !sellerRemovedFps) {
    return { ...built, PaymentSchedule: original.PaymentSchedule };
  }
  return built;
};
var toEpoUpdateChanges = (artifact, original, options = {}) => {
  const { publicOfferId, hasUsageBasedPricing, logger, renewalEnabled } = options;
  const originalArtifact = {
    configurationRequest: {
      ...DEFAULT_CONFIGURATION_REQUEST,
      ...fromCapiDoc(original),
      ...renewalEnabled ? renewalTermToInput(original.RenewalTerm) : {}
    }
  };
  const next = reconcilePaymentSchedule(
    reconcileOfferDerivedFields(
      toCapiCreateInput(artifact, publicOfferId, hasUsageBasedPricing, logger, renewalEnabled),
      artifact.configurationRequest.eulaType,
      original
    ),
    artifact.configurationRequest,
    original
  );
  const baseline = reconcilePaymentSchedule(
    reconcileOfferDerivedFields(
      toCapiCreateInput(originalArtifact, publicOfferId, hasUsageBasedPricing, logger, renewalEnabled),
      originalArtifact.configurationRequest.eulaType,
      original
    ),
    originalArtifact.configurationRequest,
    original
  );
  const changes = {};
  const offerRatesChanged = !isEqual(sortOfferRatesForCompare(next.OfferRates), sortOfferRatesForCompare(baseline.OfferRates));
  const guardrailsChanged = !isEqual(next.Guardrails, baseline.Guardrails);
  const nextDiscountRules = normalizeDiscountRules(next.DiscountRules);
  const discountRulesChanged = !isEqual(nextDiscountRules, normalizeDiscountRules(baseline.DiscountRules));
  if (offerRatesChanged || guardrailsChanged || discountRulesChanged) {
    changes.pricing = {
      ...offerRatesChanged ? { OfferRates: next.OfferRates } : {},
      ...guardrailsChanged ? { Guardrails: next.Guardrails } : {},
      // `null` removes existing rules; omit when unchanged.
      ...discountRulesChanged ? { DiscountRules: nextDiscountRules ?? null } : {}
    };
  }
  if (!isEqual(next.OfferSettings, baseline.OfferSettings)) {
    changes.offerSettings = { OfferSettings: next.OfferSettings };
  }
  if (!isEqual(next.PaymentSchedule, baseline.PaymentSchedule)) {
    changes.paymentSchedule = { PaymentSchedule: next.PaymentSchedule ?? null };
  }
  if (!isEqual(next.RenewalTerm, baseline.RenewalTerm)) {
    changes.renewalTerm = { RenewalTerm: next.RenewalTerm ?? null };
  }
  return changes;
};

// src/aipo/CreateConfig/hooks/useEditConfiguration.ts
var useEditConfiguration = ({
  writeableArtifact,
  entityId,
  logger,
  withAsyncErrors,
  flashbarManager,
  t,
  resolvedOfferId,
  hasUsageBasedPricing,
  isResolving,
  productDimensions,
  renewalEnabled,
  preSubmitGate
}) => {
  const navigate = useNavigate4();
  const [isSubmitting, setIsSubmitting] = React29.useState(false);
  const { artifact } = writeableArtifact;
  const handleSubmit = React29.useCallback(() => {
    if (isSubmitting)
      return;
    if (!entityId) {
      throw new Error("useEditConfiguration.handleSubmit invoked without an entityId");
    }
    if (isResolving) {
      logger.log("EPO edit submit blocked: public offer resolution in progress", { entityId });
      return;
    }
    withAsyncErrors(
      (async () => {
        setIsSubmitting(true);
        try {
          const next = toCapiCreateInput(artifact, resolvedOfferId, hasUsageBasedPricing, logger, renewalEnabled);
          if (runPreSubmitGate(next, preSubmitGate))
            return;
          const epoData = EpoCapiData5.getInstance(logger);
          const original = await epoData.getConfig(entityId);
          const changes = toEpoUpdateChanges(artifact, original, {
            publicOfferId: resolvedOfferId,
            hasUsageBasedPricing,
            logger,
            renewalEnabled
          });
          const dimensionEntries = buildUpdateDimensionsEntries(artifact.proposedGuidance ?? {}, productDimensions);
          const dimensionUpdate = dimensionEntries.length > 0 ? { productId: original.ProductId, entries: dimensionEntries } : void 0;
          const changeSetId = await epoData.updateConfig(entityId, changes, dimensionUpdate);
          if (changeSetId) {
            await epoData.waitForChangeCompletion(changeSetId);
            flashbarManager.addItem({
              id: `CONFIG_UPDATED_${entityId}_${crypto.randomUUID()}`,
              type: "success",
              content: t("editConfigSuccessFlash"),
              dismissible: true
            });
          } else {
            logger.log("EPO edit configuration submit: no changes to persist", { entityId });
            flashbarManager.addItem({
              id: `CONFIG_NO_CHANGES_${entityId}_${crypto.randomUUID()}`,
              type: "info",
              content: t("editConfigNoChangesFlash"),
              dismissible: true,
              ariaRole: "status"
            });
          }
          navigate(EPO_ROUTES.VIEW(entityId));
        } catch (error) {
          logger.warn("EPO edit configuration submit failed", { entityId, error: String(error) });
          if (isAuthenticationError(error)) {
            await epoSellerSignIn();
            return;
          }
          throw createMaxWrappedError6(error, { isFatal: false });
        } finally {
          setIsSubmitting(false);
        }
      })()
    );
  }, [
    isSubmitting,
    artifact,
    entityId,
    logger,
    withAsyncErrors,
    flashbarManager,
    t,
    navigate,
    resolvedOfferId,
    hasUsageBasedPricing,
    isResolving,
    productDimensions,
    renewalEnabled,
    preSubmitGate
  ]);
  return { handleSubmit, isSubmitting };
};

// src/aipo/CreateConfig/hooks/usePublicOfferResolution.ts
import * as React30 from "react";
import { createMaxWrappedError as createMaxWrappedError7 } from "@amzn/awsmp-max-agentic-renderer-interface";
import {
  OfferCapiData,
  OFFER_TERM_TYPE,
  EULA_DOCUMENT_TYPE as EULA_DOCUMENT_TYPE2,
  getPublicOfferDimensionKeys,
  isPublicOffer
} from "@amzn/awsmp-max-data";
var NO_PUBLIC_OFFER = { isResolving: false, hasPublicOffer: false };
var RESOLVING = { isResolving: true, hasPublicOffer: false };
var usePublicOfferResolution = ({
  productId,
  ownerAccountId,
  projectId,
  logger,
  withAsyncErrors
}) => {
  const [result, setResult] = React30.useState(NO_PUBLIC_OFFER);
  React30.useEffect(() => {
    if (!productId) {
      setResult(NO_PUBLIC_OFFER);
      return;
    }
    let cancelled = false;
    const resolve = async () => {
      setResult(RESOLVING);
      try {
        const offerData = OfferCapiData.getInstance(logger);
        const listResult = await offerData.listPublicOfferEntities(productId, ownerAccountId);
        const offerSummaries = listResult.EntitySummaryList ?? [];
        if (cancelled)
          return;
        if (offerSummaries.length === 0) {
          setResult(NO_PUBLIC_OFFER);
          return;
        }
        const offerIds = offerSummaries.map((s2) => s2.EntityId).filter((id) => id !== void 0);
        if (offerIds.length < offerSummaries.length) {
          logger.warn(`${offerSummaries.length - offerIds.length} offer(s) returned without EntityId for ${productId}`, { productId, projectId });
        }
        let describedOffers;
        try {
          describedOffers = await offerData.batchDescribeOffers(offerIds);
        } catch (error) {
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerBatchDescribeFailure, unit: "Count", value: 1 });
          throw error;
        }
        if (cancelled)
          return;
        const describedCount = Object.keys(describedOffers).length;
        if (describedCount === 0) {
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerBatchDescribeFailure, unit: "Count", value: 1 });
          setResult(NO_PUBLIC_OFFER);
          return;
        }
        if (describedCount < offerIds.length) {
          const failedIds = offerIds.filter((id) => !(id in describedOffers));
          logger.warn(`Failed to describe ${failedIds.length} of ${offerIds.length} offers: ${failedIds.join(", ")}`, {
            productId,
            projectId,
            failedOfferIds: failedIds
          });
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerBatchDescribePartialFailure, unit: "Count", value: 1 });
        }
        const publicOffers = Object.entries(describedOffers).filter(([_, doc]) => isPublicOffer(doc));
        if (publicOffers.length === 0) {
          logger.warn("EPO Create Config: no public offer found after isPublic filtering", {
            productId,
            projectId,
            candidateOfferIds: Object.keys(describedOffers)
          });
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerNoPublicOfferFound, unit: "Count", value: 1 });
          setResult(NO_PUBLIC_OFFER);
          return;
        }
        if (publicOffers.length > 1) {
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerMultiplePublicOffers, unit: "Count", value: 1 });
          logger.warn(`Expected 1 public offer for ${productId}, found ${publicOffers.length}`, {
            productId,
            projectId,
            publicOfferIds: publicOffers.map(([id]) => id)
          });
        }
        const [offerId, offerDoc] = publicOffers[0];
        const hasUsageBasedPricing = offerDoc.Terms.some((t) => t.Type === OFFER_TERM_TYPE.UsageBasedPricing);
        const legalTerm = offerDoc.Terms.find((t) => t.Type === OFFER_TERM_TYPE.LegalTerm);
        const rawEulaType = legalTerm?.Documents?.[0]?.Type;
        if (rawEulaType !== EULA_DOCUMENT_TYPE2.StandardEula && rawEulaType !== EULA_DOCUMENT_TYPE2.CustomEula) {
          logger.warn(`Unexpected EULA document type "${rawEulaType}" for offer ${offerId}`, {
            productId,
            projectId,
            offerId,
            eulaType: rawEulaType
          });
          logger.opsMetric({ metricName: CustomOpsMetricName.EPOSellerUnexpectedEulaType, unit: "Count", value: 1 });
          setResult(NO_PUBLIC_OFFER);
          return;
        }
        const publicOfferDimensionKeys = getPublicOfferDimensionKeys(offerDoc);
        setResult({
          isResolving: false,
          hasPublicOffer: true,
          resolvedOfferId: offerId,
          hasUsageBasedPricing,
          eulaDocumentType: rawEulaType,
          publicOfferDimensionKeys
        });
      } catch (error) {
        if (cancelled)
          return;
        if (isAuthenticationError(error)) {
          await epoSellerSignIn();
          return;
        }
        setResult(NO_PUBLIC_OFFER);
        throw createMaxWrappedError7(error, { isNotFound: true, showFlashbar: true });
      }
    };
    withAsyncErrors(resolve());
    return () => {
      cancelled = true;
    };
  }, [productId, ownerAccountId, projectId, logger, withAsyncErrors]);
  return result;
};

// src/aipo/CreateConfig/CreateConfig.tsx
import { marketplaceLinks as marketplaceLinks8 } from "@amzn/awsmp-max-link-catalog/browser";
import { HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG13 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { jsx as jsx51, jsxs as jsxs46 } from "react/jsx-runtime";
var CreateConfig = ({
  projectId,
  productId,
  writeableArtifact,
  t,
  layoutComponents,
  sendMessage,
  renderMessages,
  setBreadcrumbs,
  flashbarManager,
  logger,
  withAsyncErrors,
  turnState,
  renewalEnabled = false,
  helpPanelsEnabled = false,
  isEditMode = false,
  entityId
}) => {
  const navigate = useNavigate5();
  const [searchParams] = useSearchParams();
  const includeLimited = searchParams.get(SEARCH_PARAMS.INCLUDE_LIMITED) === "true";
  const { artifact, isArtifactLocked } = writeableArtifact;
  usePageHit(logger, isEditMode ? PAGE_CONTEXT3.EDIT_PAGE_TYPE : PAGE_CONTEXT3.PAGE_TYPE);
  const { availableProducts, isLoadingProducts, configuredProductIds, batchEntityDetails } = useMarketplaceProducts({
    productId,
    includeLimited,
    logger,
    withAsyncErrors
  });
  const selectedProductId = artifact.configurationRequest.productId || "";
  const selectedProductOwnerAccountId = availableProducts.find((p) => p.id === selectedProductId)?.ownerAccountId;
  const publicOfferResolution = usePublicOfferResolution({
    productId: selectedProductId,
    ownerAccountId: selectedProductOwnerAccountId,
    projectId,
    logger,
    withAsyncErrors
  });
  const { isResolving, resolvedOfferId, hasPublicOffer, hasUsageBasedPricing, eulaDocumentType } = publicOfferResolution;
  const publicOfferDimensionKeys = publicOfferResolution.hasPublicOffer ? publicOfferResolution.publicOfferDimensionKeys : void 0;
  const { productDimensions, isLoadingDimensions } = useProductDimensions({
    selectedProductId,
    batchEntityDetails
  });
  const stepValidations = [
    () => validateSelectProductDimensionsStep(artifact, t),
    () => validateGuidanceStep(artifact, productDimensions),
    () => validateAdditionalInformationStep(artifact, t),
    () => validateOfferSettingsStep(artifact, t, isFdaEnabled(artifact.configurationRequest.maxFutureStartDuration)),
    () => validateDiscountStrategyStep(artifact, t),
    // Renewal terms is the last gated step before Review. When renewalEnabled is
    // false this spread is empty, so stepValidations is byte-identical to today.
    ...renewalEnabled ? [() => validateRenewalTermsStep(artifact, t, renewalEnabled)] : []
  ];
  const lastStepIndex = stepValidations.length;
  const { activeStepIndex, setActiveStepIndex, stepErrors, onNavigate, clearFieldError, clearFieldErrorKeys, setFieldError, setFieldErrors } = useWizardNavigation({
    stepValidations,
    initialStepIndex: isEditMode ? lastStepIndex : 0
  });
  const [didSeedEditNav, setDidSeedEditNav] = React31.useState(!isEditMode);
  const { LayoutHelpPanel } = layoutComponents;
  const [helpPanelOpen, setHelpPanelOpen] = React31.useState(false);
  const [helpPanelPathslug, setHelpPanelPathslug] = React31.useState(HELP_PANEL_PATHSLUG13.CONFIG_RENEWAL_TERMS);
  const openHelpPanel = React31.useCallback((pathslug) => {
    setHelpPanelPathslug(pathslug);
    setHelpPanelOpen(true);
  }, []);
  const wizardHeaderInfo = helpPanelsEnabled ? /* @__PURE__ */ jsx51(
    Link18,
    {
      variant: "info",
      ariaLabel: t("infoAriaLabel", { section: t("breadcrumbCreateConfiguration") }),
      onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG13.SELLER_CREATE_CONFIGURATION),
      children: t("info")
    }
  ) : void 0;
  React31.useLayoutEffect(() => {
    if (isEditMode && !didSeedEditNav) {
      setDidSeedEditNav(true);
      setActiveStepIndex(0);
    }
  }, [isEditMode, didSeedEditNav, setActiveStepIndex]);
  const wizardSteps = buildWizardSteps({
    writeableArtifact,
    availableProducts,
    configuredProductIds,
    productDimensions,
    publicOfferDimensionKeys,
    isLoadingProducts,
    isLoadingDimensions,
    hasPublicOffer,
    eulaDocumentType,
    isArtifactLocked,
    t,
    stepErrors,
    clearFieldError,
    setFieldError,
    setActiveStepIndex,
    layoutComponents,
    flashbarManager,
    logger,
    withAsyncErrors,
    turnState,
    sendMessage,
    renderMessages,
    projectId,
    renewalEnabled,
    isEditMode,
    didSeedEditNav,
    helpPanelsEnabled,
    openHelpPanel,
    wizardHeaderInfo
  });
  const unmappedFlashIdsRef = React31.useRef([]);
  const preSubmitGate = {
    steps: wizardSteps,
    activeStepIndex,
    setFieldErrors,
    clearFieldErrorKeys,
    setActiveStepIndex,
    flashbarManager,
    unmappedFlashIdsRef,
    logger,
    t
  };
  const createConfiguration = useCreateConfiguration({
    writeableArtifact,
    availableProducts,
    logger,
    withAsyncErrors,
    resolvedOfferId,
    hasUsageBasedPricing,
    projectId,
    productDimensions,
    renewalEnabled,
    preSubmitGate
  });
  const editConfiguration = useEditConfiguration({
    writeableArtifact,
    entityId,
    logger,
    withAsyncErrors,
    flashbarManager,
    t,
    resolvedOfferId,
    hasUsageBasedPricing,
    isResolving,
    productDimensions,
    renewalEnabled,
    preSubmitGate
  });
  const { handleSubmit, isSubmitting } = isEditMode ? editConfiguration : createConfiguration;
  const exitRoute = isEditMode && entityId ? EPO_ROUTES.VIEW(entityId) : EPO_ROUTES.LIST;
  React31.useEffect(() => {
    const finalCrumb = isEditMode && entityId ? { text: t("breadcrumbEditConfiguration"), href: EPO_ROUTES.EDIT(entityId) } : { text: t("breadcrumbCreateConfiguration"), href: EPO_ROUTES.CREATE };
    setBreadcrumbs([
      { text: t("breadcrumbAwsMarketplace"), href: marketplaceLinks8.get("Home"), isAbsoluteUrl: true },
      { text: t("breadcrumbEpoConfigurations"), href: EPO_ROUTES.LIST },
      finalCrumb
    ]);
  }, [setBreadcrumbs]);
  React31.useEffect(() => {
    const unloadEvent = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return t("unsavedChangesWarning");
    };
    window.addEventListener("beforeunload", unloadEvent);
    return () => window.removeEventListener("beforeunload", unloadEvent);
  }, []);
  return /* @__PURE__ */ jsxs46("div", { "data-testid": "create-config-page", children: [
    /* @__PURE__ */ jsx51(
      Wizard2,
      {
        activeStepIndex,
        submitButtonText: isEditMode ? isSubmitting ? t("wizardSubmitButtonEditing") : t("wizardSubmitButtonEdit") : isSubmitting ? t("wizardSubmitButtonCreating") : t("wizardSubmitButton"),
        isLoadingNextStep: isSubmitting || isArtifactLocked || isResolving,
        ...!isSubmitting && {
          onCancel: () => navigate(exitRoute)
        },
        onNavigate: ({ detail }) => onNavigate(detail),
        onSubmit: handleSubmit,
        steps: wizardSteps
      }
    ),
    helpPanelsEnabled && /* @__PURE__ */ jsx51(LayoutHelpPanel, { pathslug: helpPanelPathslug, open: helpPanelOpen, onToggle: setHelpPanelOpen })
  ] });
};

// src/aipo/ViewConfig/ViewConfig.tsx
import * as React32 from "react";
import Button19 from "@cloudscape-design/components/button";
import Header32 from "@cloudscape-design/components/header";
import Link19 from "@cloudscape-design/components/link";
import Tabs from "@cloudscape-design/components/tabs";
import Table6 from "@cloudscape-design/components/table";
import SpaceBetween42 from "@cloudscape-design/components/space-between";
import KeyValuePairs11 from "@cloudscape-design/components/key-value-pairs";
import Container28 from "@cloudscape-design/components/container";
import { EpoCapiData as EpoCapiData6, EpoEntityState as EpoEntityState3, CapiProductData as CapiProductData4 } from "@amzn/awsmp-max-data";

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/models/MarketplaceCatalogServiceException.js
var MarketplaceCatalogServiceException = class _MarketplaceCatalogServiceException extends ServiceException {
  constructor(options) {
    super(options);
    Object.setPrototypeOf(this, _MarketplaceCatalogServiceException.prototype);
  }
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/models/models_0.js
var ResourceNotFoundException = class _ResourceNotFoundException extends MarketplaceCatalogServiceException {
  name = "ResourceNotFoundException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ResourceNotFoundException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ResourceNotFoundException.prototype);
    this.Message = opts.Message;
  }
};

// src/aipo/ViewConfig/ViewConfig.tsx
import { LoadingSpinner as LoadingSpinner2 } from "@amzn/awsmp-max-ux-patterns/LoadingSpinner";
import { marketplaceLinks as marketplaceLinks9 } from "@amzn/awsmp-max-link-catalog/browser";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { createMaxWrappedError as createMaxWrappedError8, NotFoundError as NotFoundError3, HELP_PANEL_PATHSLUG as HELP_PANEL_PATHSLUG14 } from "@amzn/awsmp-max-agentic-renderer-interface";

// src/aipo/ViewConfig/config/constants.ts
var PAGE_CONTEXT4 = {
  // Bound to the canonical EPO page-type set (@amzn/awsmp-max-model); see CreateConfig constants.
  PAGE_TYPE: "AWSMP-EPO-View-Config",
  SUB_PAGE_TYPES: {
    CONFIGURATION_DETAILS: "AWSMP-Configuration-Details"
  }
};

// src/aipo/ViewConfig/BuyerPaymentScheduleContainer.tsx
import Container25 from "@cloudscape-design/components/container";
import Header29 from "@cloudscape-design/components/header";
import KeyValuePairs8 from "@cloudscape-design/components/key-value-pairs";
import { jsx as jsx52 } from "react/jsx-runtime";
var BuyerPaymentScheduleContainer = ({ t, allowedFrequencies, initialPaymentAllowed }) => {
  const scheduleAllowed = allowedFrequencies !== void 0;
  const frequencyValue = allowedFrequencies && allowedFrequencies.length > 0 ? allowedFrequencies.map((f) => frequencyLabel(f, t)).join(", ") : t("notSet");
  const initialPaymentValue = initialPaymentAllowed === void 0 ? t("notSet") : initialPaymentAllowed ? t("initialCustomPaymentAllowedLabel") : t("initialCustomPaymentNotAllowedLabel");
  return /* @__PURE__ */ jsx52(
    Container25,
    {
      "data-testid": "view-buyer-payment-schedule-container",
      header: /* @__PURE__ */ jsx52(Header29, { variant: "h3", description: t("buyerPaymentScheduleDescription"), children: t("buyerPaymentSchedule") }),
      children: /* @__PURE__ */ jsx52(
        KeyValuePairs8,
        {
          "data-testid": "view-buyer-payment-schedule-keyvaluepairs",
          columns: 2,
          items: [
            {
              label: t("paymentScheduleGateLabel"),
              value: /* @__PURE__ */ jsx52("span", { "data-testid": "view-payment-schedule-gate-value", children: scheduleAllowed ? t("paymentScheduleAllowedLabel") : t("paymentScheduleNotAllowedLabel") })
            },
            // Disclosed rows render only when an installment plan is allowed, matching
            // the seller create/review card's progressive disclosure.
            ...scheduleAllowed ? [
              { label: t("allowedPaymentFrequencies"), value: frequencyValue },
              { label: t("initialCustomPayment"), value: initialPaymentValue }
            ] : []
          ]
        }
      )
    }
  );
};

// src/aipo/ViewConfig/OfferSettingsContainer.tsx
import Container26 from "@cloudscape-design/components/container";
import Header30 from "@cloudscape-design/components/header";
import KeyValuePairs9 from "@cloudscape-design/components/key-value-pairs";
import { jsx as jsx53 } from "react/jsx-runtime";
var OfferSettingsContainer = ({ t, configuration, formatDuration, formatEulaType }) => /* @__PURE__ */ jsx53(Container26, { "data-testid": "view-offer-settings-container", header: /* @__PURE__ */ jsx53(Header30, { variant: "h3", children: t("contractDetailsAndEula") }), children: /* @__PURE__ */ jsx53(
  KeyValuePairs9,
  {
    "data-testid": "view-offer-settings-keyvaluepairs",
    columns: 2,
    items: [
      {
        label: t("minimumOfferDuration"),
        value: configuration.minOfferDuration ? formatDuration(configuration.minOfferDuration) : t("notSet")
      },
      {
        label: t("maximumOfferDuration"),
        value: configuration.maxOfferDuration ? formatDuration(configuration.maxOfferDuration) : t("notSet")
      },
      {
        label: t("endUserLicenseAgreement"),
        value: configuration.eulaType ? formatEulaType(configuration.eulaType) : t("notSet")
      },
      {
        label: t("offerExpirationDuration"),
        value: configuration.expiration ? formatDuration(configuration.expiration) : t("notSet")
      },
      ...isFdaEnabled(configuration.maxFutureStartDuration) ? [
        {
          label: t("fdaValidityRange"),
          value: formatDuration(configuration.maxFutureStartDuration || "") || t("notSet")
        }
      ] : []
    ]
  }
) });

// src/aipo/ViewConfig/RenewalDetailsContainer.tsx
import Container27 from "@cloudscape-design/components/container";
import Header31 from "@cloudscape-design/components/header";
import KeyValuePairs10 from "@cloudscape-design/components/key-value-pairs";
import SpaceBetween41 from "@cloudscape-design/components/space-between";
import { jsx as jsx54, jsxs as jsxs47 } from "react/jsx-runtime";
var MAX_RENEWAL_VIEW_COLUMNS = 4;
var buildDurationRow = (iso, label, phrase) => {
  if (iso === void 0)
    return null;
  const days = isoDurationToDays(iso);
  return days === null ? null : { label, value: phrase(days) };
};
var RenewalDetailsContainer = ({ t, renewal, allowedFrequencies }) => {
  const priceIncrease = renewal.PriceIncrease;
  const isNoUplift2 = priceIncrease.Type === "FixedPercentage" && isNoUpliftFixedPercentage(priceIncrease.Value);
  const pricingRow = {
    label: t("renewalPricingLabel"),
    value: isNoUplift2 ? t("renewalPricingNoUplift") : t("renewalPricingUplift")
  };
  const maximumRow = {
    label: t("renewalMaximumLabel"),
    value: renewal.MaxRenewals !== void 0 ? String(renewal.MaxRenewals) : t("renewalMaximumUnlimited")
  };
  const lockoutRow = buildDurationRow(renewal.LockoutPeriod, t("renewalLockoutReviewLabel"), (days) => t("renewalLockoutPhrase", { days }));
  const fields = (() => {
    switch (priceIncrease.Type) {
      case "FixedPercentage":
        return isNoUplift2 ? [pricingRow, maximumRow, lockoutRow] : [
          pricingRow,
          { label: t("renewalUpliftTypeLabel"), value: t("renewalUpliftTypeFixedLabel") },
          { label: t("renewalFixedPercentageLabel"), value: t("renewalPercentageValue", { percent: priceIncrease.Value }) },
          maximumRow,
          lockoutRow
        ];
      case "PercentageRange":
        return [
          pricingRow,
          { label: t("renewalUpliftTypeLabel"), value: t("renewalUpliftTypeRangeLabel") },
          {
            label: t("renewalRangeLabel"),
            value: t("renewalUpliftRangeValue", { min: priceIncrease.Range.MinValue, max: priceIncrease.Range.MaxValue })
          },
          maximumRow,
          lockoutRow,
          { label: t("renewalDefaultLabel"), value: t("renewalPercentageValue", { percent: priceIncrease.Range.DefaultValue }) },
          // Raw read-back: the wire carries the gap (days before the renewal decision
          // deadline) directly, so render it via the plain days-only duration row.
          buildDurationRow(renewal.AdjustmentDeadline, t("renewalAdjustmentDeadlineLabel"), (days) => t("renewalAdjustmentDeadlinePhrase", { days }))
        ];
      default: {
        const _exhaustive = priceIncrease;
        return [pricingRow, maximumRow, lockoutRow];
      }
    }
  })();
  const items = fields.filter((f) => f !== null);
  return /* @__PURE__ */ jsxs47(SpaceBetween41, { size: "l", children: [
    /* @__PURE__ */ jsx54(Container27, { "data-testid": "view-renewal-terms-container", header: /* @__PURE__ */ jsx54(Header31, { variant: "h3", children: t("renewalTermsHeader") }), children: /* @__PURE__ */ jsx54(KeyValuePairs10, { "data-testid": "view-renewal-terms-keyvaluepairs", columns: Math.min(items.length, MAX_RENEWAL_VIEW_COLUMNS), items }) }),
    allowedFrequencies !== void 0 && allowedFrequencies.length > 0 && /* @__PURE__ */ jsx54(
      Container27,
      {
        "data-testid": "view-renewal-installment-plan-container",
        header: /* @__PURE__ */ jsx54(Header31, { variant: "h3", description: t("renewalInstallmentPlanDescription"), children: t("renewalInstallmentPlan") }),
        children: /* @__PURE__ */ jsx54(
          KeyValuePairs10,
          {
            "data-testid": "view-renewal-installment-plan-keyvaluepairs",
            columns: 1,
            items: [{ label: t("renewalAllowedPaymentFrequencies"), value: allowedFrequencies.map((f) => frequencyLabel(f, t)).join(", ") }]
          }
        )
      }
    )
  ] });
};

// src/aipo/ViewConfig/ViewConfig.tsx
import { jsx as jsx55, jsxs as jsxs48 } from "react/jsx-runtime";
var buildDeleteRedirectUrl = (productId, productName) => `${EPO_ROUTES.LIST}?${QUERY_PARAMS.DELETED}=true&${QUERY_PARAMS.PRODUCT_ID}=${encodeURIComponent(productId)}&${QUERY_PARAMS.PRODUCT_NAME}=${encodeURIComponent(productName)}`;
var ViewConfig = ({
  entityId,
  t,
  setBreadcrumbs,
  logger,
  withAsyncErrors,
  epoRenewalEnabledSeller,
  helpPanelsEnabled = false,
  layoutComponents
}) => {
  const navigate = useNavigate6();
  const LayoutHelpPanel = layoutComponents?.LayoutHelpPanel;
  const [helpPanelOpen, setHelpPanelOpen] = React32.useState(false);
  const [helpPanelPathslug, setHelpPanelPathslug] = React32.useState(HELP_PANEL_PATHSLUG14.CONFIGURATION_DETAILS);
  const openHelpPanel = React32.useCallback((pathslug) => {
    setHelpPanelPathslug(pathslug);
    setHelpPanelOpen(true);
  }, []);
  const [activeTabId, setActiveTabId] = React32.useState("dimensions");
  const [configuration, setConfiguration] = React32.useState(null);
  const [renewal, setRenewal] = React32.useState(void 0);
  const [productName, setProductName] = React32.useState("");
  const [productCode, setProductCode] = React32.useState(void 0);
  const [dimensionNames, setDimensionNames] = React32.useState(/* @__PURE__ */ new Map());
  const [loading, setLoading] = React32.useState(true);
  const [productIdFromConfig, setProductIdFromConfig] = React32.useState(null);
  const { handleDelete, isDeleting } = useDeleteConfiguration({
    logger,
    onSuccess: async (_item) => {
      navigate(buildDeleteRedirectUrl(productIdFromConfig ?? "", productName));
    }
  });
  React32.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (!EPO_CONFIG_ENTITY_ID_PATTERN.test(entityId)) {
          throw new NotFoundError3(`Invalid EPO config entity ID: ${entityId}`);
        }
        const epoData = EpoCapiData6.getInstance(logger);
        const doc = await epoData.getConfig(entityId);
        if (doc.State === EpoEntityState3.Inactive) {
          throw new NotFoundError3(`Entity ${entityId} is inactive`);
        }
        setConfiguration(fromCapiDoc(doc));
        setRenewal(renewalFromCapiDoc(doc));
        setProductIdFromConfig(doc.ProductId);
        try {
          const detailsMap = await CapiProductData4.getInstance(logger).fetchProductDetails([doc.ProductId]);
          const details = detailsMap.get(doc.ProductId);
          setProductName(details.name);
          setProductCode(details.productCode);
          setDimensionNames(new Map(details.dimensions));
        } catch (_nameError) {
          setProductName(doc.ProductId);
          setProductCode(void 0);
          setDimensionNames(/* @__PURE__ */ new Map());
        }
      } catch (error) {
        if (isAuthenticationError(error)) {
          await epoSellerSignIn();
          return;
        }
        if (error instanceof ResourceNotFoundException) {
          throw createMaxWrappedError8(error, { isNotFound: true });
        }
        throw createMaxWrappedError8(error, { isNotFound: true, showFlashbar: true });
      } finally {
        setLoading(false);
      }
    };
    withAsyncErrors(fetchData());
  }, [entityId, withAsyncErrors]);
  React32.useEffect(() => {
    setBreadcrumbs([
      { text: t("awsMarketplace"), href: marketplaceLinks9.get("Home"), isAbsoluteUrl: true },
      { text: t("expressPrivateOfferConfigurations"), href: EPO_ROUTES.LIST },
      { text: productName, href: EPO_ROUTES.VIEW(entityId) }
    ]);
  }, [productName, setBreadcrumbs]);
  usePageHit(logger, PAGE_CONTEXT4.PAGE_TYPE);
  useSubPageHit(logger, PAGE_CONTEXT4.SUB_PAGE_TYPES.CONFIGURATION_DETAILS);
  if (loading || !configuration) {
    return /* @__PURE__ */ jsx55(LoadingSpinner2, {});
  }
  const configItem = {
    id: productIdFromConfig || entityId,
    entityId,
    product: productName,
    status: "ACTIVE",
    dateCreated: null
  };
  const discountStrategy = configuration.discountStrategy;
  const perDimensionTcvTiers = isPerDimensionStrategy(discountStrategy) ? discountStrategy.perDimensionTcvTiers : void 0;
  const totalTcvTiers = isTcvStrategy(discountStrategy) ? discountStrategy.totalTcvTiers : void 0;
  const qualifications = isQualificationStrategy(discountStrategy) ? discountStrategy.qualifications : [];
  const showRenewal = epoRenewalEnabledSeller && renewal !== void 0;
  const effectiveActiveTabId = activeTabId === "renewal-details" && !showRenewal ? "dimensions" : activeTabId;
  const formatDuration = (duration) => {
    const match2 = duration.match(/P(\d+)([YMD])/);
    if (!match2)
      return duration;
    const value = match2[1];
    const unit = match2[2];
    const unitMap = {
      Y: value === "1" ? t("year") : t("yearsLowercase"),
      M: value === "1" ? t("month") : t("monthsLowercase"),
      D: value === "1" ? t("day") : t("daysLowercase")
    };
    return `${value} ${unitMap[unit]}`;
  };
  const formatEulaType = (eulaType) => {
    if (eulaType === "PUBLIC_OFFER_EULA") {
      return t("publicOfferEula");
    } else if (eulaType === "STANDARD_CONTRACT_MARKETPLACE") {
      return t("standardContractForMarketplace");
    }
    return eulaType;
  };
  const dimensionsData = configuration.configurableUpfrontDimensionRates?.dimensionRates?.map((rate) => ({
    apiIdentifier: rate.dimensionKey,
    dimension: rate.dimensionKey,
    pricePerMonth: `$${rate.price}`,
    expressPrivateOfferDescription: rate.supplementaryDescription ?? "-"
  })) || [];
  const columnDefinitions = [
    {
      id: "apiIdentifier",
      header: t("apiIdentifier"),
      cell: (item) => item.apiIdentifier
    },
    {
      id: "dimension",
      header: t("dimension"),
      cell: (item) => dimensionNames.get(item.apiIdentifier) || item.dimension
    },
    {
      id: "pricePerMonth",
      header: t("pricePerMonth"),
      cell: (item) => item.pricePerMonth
    },
    {
      id: "expressPrivateOfferDescription",
      header: t("guidance"),
      cell: (item) => item.expressPrivateOfferDescription
    }
  ];
  const perDimensionTcvData = {};
  if (perDimensionTcvTiers) {
    Object.entries(perDimensionTcvTiers).forEach(([dimensionKey, tiers]) => {
      perDimensionTcvData[dimensionKey] = tiers.map((tier) => ({
        fromValue: `${tier.minValue.toLocaleString()}`,
        toValue: `${tier.maxValue.toLocaleString()}`,
        discountPercent: `${tier.discountPercentage}%`
      }));
    });
  }
  const totalTcvDiscountData = [];
  if (totalTcvTiers) {
    totalTcvTiers.forEach((tier) => {
      totalTcvDiscountData.push({
        fromValue: `$${tier.minValue.toLocaleString()}`,
        toValue: `$${tier.maxValue.toLocaleString()}`,
        discountPercent: `${tier.discountPercentage}%`
      });
    });
  }
  const tcvColumnDefinitions = [
    {
      id: "fromValue",
      header: t("minimumValue"),
      cell: (item) => item.fromValue
    },
    {
      id: "toValue",
      header: t("maximumValue"),
      cell: (item) => item.toValue
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => item.discountPercent
    }
  ];
  const perDimensionColumnDefinitions = [
    {
      id: "fromValue",
      header: t("minimumUnitQuantity"),
      cell: (item) => item.fromValue
    },
    {
      id: "toValue",
      header: t("maximumUnitQuantity"),
      cell: (item) => item.toValue
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => item.discountPercent
    }
  ];
  return /* @__PURE__ */ jsxs48("div", { "data-testid": "view-config-page", style: { marginTop: "12px" }, children: [
    /* @__PURE__ */ jsxs48(SpaceBetween42, { size: "l", children: [
      /* @__PURE__ */ jsxs48(
        Header32,
        {
          variant: "h1",
          info: helpPanelsEnabled ? /* @__PURE__ */ jsx55(
            Link19,
            {
              variant: "info",
              ariaLabel: t("infoAriaLabel", { section: t("viewConfiguration") }),
              onFollow: () => openHelpPanel(HELP_PANEL_PATHSLUG14.CONFIGURATION_DETAILS),
              children: t("info")
            }
          ) : void 0,
          actions: /* @__PURE__ */ jsxs48(SpaceBetween42, { direction: "horizontal", size: "xs", children: [
            /* @__PURE__ */ jsx55(
              Button19,
              {
                "data-testid": "remove-config-button",
                variant: "normal",
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "header-actions",
                      ClickAct: "remove-config"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  withAsyncErrors(handleDelete(configItem));
                },
                loading: isDeleting,
                disabled: isDeleting,
                children: t("remove")
              }
            ),
            /* @__PURE__ */ jsx55(Button19, { "data-testid": "edit-config-button", variant: "normal", onClick: () => navigate(EPO_ROUTES.EDIT(entityId)), children: t("editConfigurationButton") }),
            /* @__PURE__ */ jsx55(
              Button19,
              {
                variant: "normal",
                href: productCode ? marketplaceLinks9.get("ListingDetailsBySku", { sku: productCode }) : (
                  // No SKU: fall back to the seller management console, which is excluded from the
                  // TLD migration and pinned to aws.amazon.com inside the directory entry itself.
                  marketplaceLinks9.get("ProductManagementConsole", { productId: productIdFromConfig ?? "" })
                ),
                iconAlign: "right",
                iconName: "external",
                target: "_blank",
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "header-actions",
                      ClickAct: "view-external-product"
                    },
                    value: 1,
                    unit: "Count"
                  });
                },
                children: t("viewProductListing")
              }
            )
          ] }),
          children: [
            productName,
            " (",
            productIdFromConfig,
            ")"
          ]
        }
      ),
      /* @__PURE__ */ jsx55(
        Tabs,
        {
          "data-testid": "view-config-tabs",
          activeTabId: effectiveActiveTabId,
          onChange: ({ detail }) => {
            const tabClickActions = {
              dimensions: "dimensions-tab",
              "discount-strategy": "discount-strategy-tab",
              "offer-settings": "offer-description-tab",
              "renewal-details": "renewal-details-tab"
            };
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "tab-navigation",
                ClickAct: tabClickActions[detail.activeTabId] || detail.activeTabId
              },
              value: 1,
              unit: "Count"
            });
            setActiveTabId(detail.activeTabId);
          },
          tabs: [
            {
              id: "dimensions",
              label: t("dimensions"),
              content: /* @__PURE__ */ jsx55(
                Table6,
                {
                  "data-testid": "view-dimensions-table",
                  columnDefinitions,
                  items: dimensionsData,
                  header: /* @__PURE__ */ jsx55(Header32, { variant: "h3", children: t("specifiedDimensions") }),
                  empty: t("noDimensionsFound")
                }
              )
            },
            {
              id: "discount-strategy",
              label: t("discountStrategy"),
              content: /* @__PURE__ */ jsxs48(SpaceBetween42, { size: "l", children: [
                Object.keys(perDimensionTcvData).length > 0 && /* @__PURE__ */ jsx55(Container28, { header: /* @__PURE__ */ jsx55(Header32, { variant: "h3", children: t("perDimensionDiscountStrategy") }), children: /* @__PURE__ */ jsx55(SpaceBetween42, { size: "l", children: Object.entries(perDimensionTcvData).map(([dimensionKey, tiers]) => /* @__PURE__ */ jsx55(
                  Table6,
                  {
                    variant: "embedded",
                    columnDefinitions: perDimensionColumnDefinitions,
                    items: tiers,
                    header: /* @__PURE__ */ jsx55(Header32, { counter: `(${tiers.length})`, children: dimensionNames.get(dimensionKey) || dimensionKey }),
                    empty: t("noDiscountTiersFound")
                  },
                  dimensionKey
                )) }) }),
                totalTcvDiscountData.length > 0 && /* @__PURE__ */ jsx55(Container28, { header: /* @__PURE__ */ jsx55(Header32, { variant: "h3", children: t("totalContractValueDiscountStrategy") }), children: /* @__PURE__ */ jsx55(
                  Table6,
                  {
                    variant: "embedded",
                    columnDefinitions: tcvColumnDefinitions,
                    items: totalTcvDiscountData,
                    empty: t("noDiscountTiersFound")
                  }
                ) }),
                qualifications.length > 0 && /* @__PURE__ */ jsx55(Container28, { "data-testid": "view-buyer-profile-container", header: /* @__PURE__ */ jsx55(Header32, { variant: "h3", children: t("buyerProfileDiscountStrategy") }), children: /* @__PURE__ */ jsx55("div", { children: qualifications.map((qual, index) => /* @__PURE__ */ jsxs48(React32.Fragment, { children: [
                  /* @__PURE__ */ jsx55(
                    KeyValuePairs11,
                    {
                      columns: 1,
                      items: [
                        {
                          label: t("qualifyingTheme"),
                          value: qual.qualifyingTheme || "-"
                        },
                        {
                          label: t("details"),
                          value: qual.detail || "-"
                        },
                        {
                          label: t("customerFacingQuestion"),
                          value: (qual.buyerQuestions || []).map((q) => q.question).join(" ") || "-"
                        }
                      ]
                    }
                  ),
                  index < qualifications.length - 1 && /* @__PURE__ */ jsx55("hr", { style: { margin: "16px 0", border: "none", borderTop: "1px solid #e9ebed" } })
                ] }, index)) }) }),
                /* @__PURE__ */ jsx55(Container28, { "data-testid": "view-discount-thresholds-container", header: /* @__PURE__ */ jsx55(Header32, { variant: "h3", children: t("discountThresholds") }), children: /* @__PURE__ */ jsx55(
                  KeyValuePairs11,
                  {
                    "data-testid": "view-discount-thresholds-keyvaluepairs",
                    columns: 2,
                    items: [
                      {
                        label: t("currency"),
                        // Only USD is supported currently
                        value: t("usd")
                      },
                      {
                        label: t("maximumDiscountPercentage"),
                        value: `${String(configuration.maxDiscountPercentage || 0)}%`
                      },
                      // Show Minimum TCV first (left) with Maximum TCV to its right.
                      {
                        label: t("minimumTcvForExpressPrivateOffers"),
                        value: `$${(configuration.minTotalContractValue ?? 0).toLocaleString()}`
                      },
                      {
                        label: t("maximumTotalContractValue"),
                        value: `$${(configuration.maxTotalContractValue || 0).toLocaleString()}`
                      }
                    ]
                  }
                ) })
              ] })
            },
            {
              id: "offer-settings",
              label: t("offerSettings"),
              content: /* @__PURE__ */ jsxs48(SpaceBetween42, { size: "l", children: [
                /* @__PURE__ */ jsx55(OfferSettingsContainer, { t, configuration, formatDuration, formatEulaType }),
                /* @__PURE__ */ jsx55(
                  BuyerPaymentScheduleContainer,
                  {
                    t,
                    allowedFrequencies: configuration.allowedFrequencies,
                    initialPaymentAllowed: configuration.initialPaymentAllowed
                  }
                )
              ] })
            },
            // Keep the optional "Renewal details" tab appended last so changes to this shared `tabs` array stay rebase-friendly.
            ...showRenewal && renewal !== void 0 ? [
              {
                id: "renewal-details",
                label: t("renewalDetails"),
                content: /* @__PURE__ */ jsx55(RenewalDetailsContainer, { t, renewal, allowedFrequencies: configuration.allowedFrequencies })
              }
            ] : []
          ]
        }
      )
    ] }),
    helpPanelsEnabled && LayoutHelpPanel && /* @__PURE__ */ jsx55(LayoutHelpPanel, { pathslug: helpPanelPathslug, open: helpPanelOpen, onToggle: setHelpPanelOpen })
  ] });
};

// src/aipo/Offer/Offer.tsx
import { jsx as jsx56, jsxs as jsxs49 } from "react/jsx-runtime";
var Offer = ({ onNavigateToProjects, onCreateProject }) => {
  return /* @__PURE__ */ jsxs49("div", { style: { padding: "20px" }, children: [
    /* @__PURE__ */ jsx56("h1", { children: "AIPO Buyer Flow" }),
    /* @__PURE__ */ jsx56("p", { children: "AI-Powered Offers entry point for buyers" }),
    /* @__PURE__ */ jsxs49("div", { style: { marginTop: "20px", padding: "15px", border: "1px solid #ccc", borderRadius: "5px" }, children: [
      /* @__PURE__ */ jsx56("h3", { children: "Coming Soon" }),
      /* @__PURE__ */ jsx56("p", { children: "This page will provide:" }),
      /* @__PURE__ */ jsxs49("ul", { children: [
        /* @__PURE__ */ jsx56("li", { children: "Browse available AI-powered offers" }),
        /* @__PURE__ */ jsx56("li", { children: "Filter and search functionality" }),
        /* @__PURE__ */ jsx56("li", { children: "View offer details and pricing" }),
        /* @__PURE__ */ jsx56("li", { children: "Request offers from sellers" })
      ] }),
      /* @__PURE__ */ jsxs49("p", { children: [
        /* @__PURE__ */ jsx56("strong", { children: "Note:" }),
        " Entry point for buyers to discover and request AIPO offers"
      ] })
    ] }),
    /* @__PURE__ */ jsxs49("div", { style: { marginTop: "20px", display: "flex", gap: "10px" }, children: [
      /* @__PURE__ */ jsx56(
        "button",
        {
          onClick: onNavigateToProjects,
          style: {
            padding: "10px 20px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          },
          children: "View Projects"
        }
      ),
      /* @__PURE__ */ jsx56(
        "button",
        {
          onClick: onCreateProject,
          style: {
            padding: "10px 20px",
            backgroundColor: "#0073bb",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          },
          children: "Create New Project"
        }
      )
    ] }),
    /* @__PURE__ */ jsx56("div", { style: { marginTop: "20px", fontSize: "14px", color: "#666" }, children: /* @__PURE__ */ jsxs49("p", { children: [
      /* @__PURE__ */ jsx56("strong", { children: "Buyer Experience:" }),
      " Discover AI-powered offers from sellers, compare options, and initiate purchase requests through the marketplace."
    ] }) })
  ] });
};
export {
  CreateConfig,
  DEFAULT_CONFIGURATION_REQUEST,
  EPO_CONFIG_ENTITY_ID_PATTERN,
  GetOffer,
  ListConfig,
  Offer,
  QUALIFYING_THEME_TO_CAPI,
  ViewConfig,
  epoSellerSignIn,
  fromCapiDoc,
  isAuthenticationError,
  mockQualificationResponses,
  readAttributionId,
  renewalTermToInput,
  useAttributionIdCapture
};
//# sourceMappingURL=index.js.map
